var baseconfig = {
	"version": "4.21.0",
	"system_instance": "https://app.formunauts.com/",
	"callback_url": "admin/bureau/callbackdonation/",
	"debugInfoEnabled": false,
	"next": {
		"nextLogin": "true"
	},
	"raven": {
		"public_dsn": "https://634d07c25a12448395bdf027b96010de@sentry.io/1242713",
		"environment": "production",
		"release": "4.21.0"
	},
	"browserSupportWhitelist": {
		"Chrome": 90,
		"Safari": 13
	},
	"signatureValidation": {
		"minLines": 1,
		"minPoints": 5
	},
	"raisenow": {
		"endpoint": "https://api.raisenow.com",
		"errorUrl": "https://app.formunauts.com/app/iframe.view.html",
		"successUrl": "https://app.formunauts.com/app/iframe.view.html",
		"cancelUrl": "https://app.formunauts.com/app/iframe.view.html",
		"testMode": "false",
		"useStripe": "true",
		"paymentMethods": [
			"cym",
			"sms",
			"cc_raisenow",
			"cc_mpos",
			"cc_mpos_new",
			"amx",
			"din",
			"dis",
			"eca",
			"pfc",
			"vis",
			"stp"
		]
	},
	"google": {
		"key": "AIzaSyAGK7Qg9qPEZEpFTkbQku5fYOtDut8078Y"
	}
};
CheckboxesWithContent.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function CheckboxesWithContent(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var checkboxesWithContent = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'checkboxesWithContent';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(checkboxesWithContent);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'checkboxesWithContent',
    'app/commons/form/checkboxes-with-content/checkboxes-with-content.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'checkboxesWithContent',
    'app/commons/form/checkboxes-with-content/checkboxes-with-content.html'
  );
}

angular.module('form.checkboxesWithContent', []).config(CheckboxesWithContent);

customDateFieldComponentDir.$inject = [];
function customDateFieldComponentDir() {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controllers) {
      var that = this;
      //config section
      var dirNameAttr = 'customDateFieldComponentDir';
      var currentDateComponentNameAttr = 'customDateFieldComponentName';
      var dateFieldNameAttr = 'customDateFieldName';

      var componentName = attrs[currentDateComponentNameAttr];

      var realDateFieldName = attrs[dateFieldNameAttr];
      var dayComponentFieldName = attrs[dateFieldNameAttr] + '_date_day';
      var monthComponentFieldName = attrs[dateFieldNameAttr] + '_date_month';
      var yearComponentFieldName = attrs[dateFieldNameAttr] + '_date_year';

      var watchers = [];

      var form = controllers[0];
      var ngModel = controllers[1];

      var isActive = false;
      var dirActiveWatch;

      dirActiveWatch = scope.$watch(
        function() {
          return !!parseInt(attrs[dirNameAttr]);
        },
        function(value) {
          isActive = value;
        }
      );

      // parses from the DOM value into the model value
      ngModel.$parsers.unshift(function(value) {
        // if an empty string is given, return the untouched value
        if (!value) {
          return value;
          // TODO: maybe in case this is an empty string, set all model fields to empty?
        } else {
          value = formatInputByDateSegment(value, componentName);
          setDateFromViewToModel();
          focusNextInput();
        }
        return value;
      });

      // formats how a model value will be rendered in the DOM
      ngModel.$formatters.unshift(function(value) {
        return value;
      });

      element.bind('blur', function(e) {
        var formattedValue = e.target.value;
        // if day or month and length < 2
        if (
          formattedValue &&
          formattedValue.length < 2 &&
          ['day', 'month'].indexOf(componentName) !== -1
        ) {
          formattedValue = '0' + formattedValue;
          ngModel.$setViewValue(formattedValue);
          ngModel.$render();
        }
      });

      ////////////////////////////////////////////

      function formatInputByDateSegment(value, dateSegment) {
        var formattedValue = value;

        switch (dateSegment) {
          case 'day':
            /*if(value.length < 2 && parseInt(value) === 0) {
              formattedValue = ''
            }
            else */
            if (value.length < 2 && parseInt(value) > 3) {
              formattedValue = '0' + value;
            } else if (value.length > 2) {
              formattedValue =
                value[value.length - 3] + value[value.length - 2];
            }
            break;
          case 'month':
            /*
            if(value.length < 2 && parseInt(value) === 0) {
              formattedValue = ''
            } else
            */
            if (value.length < 2 && parseInt(value) > 1) {
              formattedValue = '0' + value;
            } else if (value.length > 2) {
              formattedValue =
                value[value.length - 3] + value[value.length - 2];
            }
            break;
          case 'year':
            if (value.length < 3 && parseInt(value) === 0) {
              formattedValue = '';
            } else if (value.length > 4) {
              formattedValue =
                value[value.length - 3] + value[value.length - 2];
            }
            break;
        }

        ngModel.$setViewValue(formattedValue);
        ngModel.$render();

        return formattedValue;
      }

      function setDateFromViewToModel() {
        var day = getFormField(dayComponentFieldName)
          ? getFormField(dayComponentFieldName).$viewValue
          : '';
        var month = getFormField(monthComponentFieldName)
          ? getFormField(monthComponentFieldName).$viewValue
          : '';
        var year = getFormField(yearComponentFieldName)
          ? getFormField(yearComponentFieldName).$viewValue
          : '';

        var realDateField = getFormField(realDateFieldName);

        //concat date
        if (
          parseInt(day) &&
          day.toString().length > 0 &&
          parseInt(month) &&
          month.toString().length > 0 &&
          parseInt(year) &&
          year.toString().length > 3 &&
          realDateField
        ) {
          try {
            //day = parseInt(day) === 0 ? 0 : parseInt(day) < 10 ? '0'+(parseInt(day)+1):(parseInt(day)+1);
            var newDate = year + '-' + month + '-' + day;
            //write value
            realDateField.$setViewValue(newDate);
            realDateField.$render();
          } catch (e) {
            console.error(e);
          }
        } else {
          realDateField.$setViewValue('');
          realDateField.$render();
        }
      }

      // determine if input focus can change based on current input
      function focusNextInput() {
        var currentValue = ngModel.$viewValue;
        // Do nothing until the input values have the right length
        if (
          (componentName === 'day' || componentName === 'month') &&
          currentValue.length < 2
        ) {
          return;
        }
        if (componentName === 'year' && currentValue.length < 4) {
          return;
        }

        // determine next input to focus
        var baseId = attrs['id'].split('_date_')[0] + '_date_';

        var day =
          form[dayComponentFieldName] && form[dayComponentFieldName].$viewValue
            ? form[dayComponentFieldName].$viewValue
            : '';
        var month =
          form[monthComponentFieldName] &&
          form[monthComponentFieldName].$viewValue
            ? form[monthComponentFieldName].$viewValue
            : '';
        var year =
          form[yearComponentFieldName] &&
          form[yearComponentFieldName].$viewValue
            ? form[yearComponentFieldName].$viewValue
            : '';

        var inputToFocus;

        if (day.length < 2) {
          inputToFocus = angular.element(
            document.getElementById(baseId + 'day')
          );
        } else if (month.length < 2) {
          inputToFocus = angular.element(
            document.getElementById(baseId + 'month')
          );
        } else if (year.length < 4) {
          inputToFocus = angular.element(
            document.getElementById(baseId + 'year')
          );
        }

        // focus next input
        if (inputToFocus) {
          inputToFocus[0].focus();
        }
      }

      function getFormField(fieldName) {
        var field = false;
        if (fieldName && form[fieldName]) {
          field = form[fieldName];
        }

        return field;
      }
    }
  };
}

function customDateFieldExploderDir() {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controllers) {
      //config section
      var dirNameAttr = 'customDateFieldExploderDir';
      var watchers = [];

      //
      var form = controllers[0];
      var ngModel = controllers[1];

      //
      var isActive = false;
      var dirActiveWatch;

      dirActiveWatch = scope.$watch(
        function() {
          return !!parseInt(attrs[dirNameAttr]);
        },
        function(value) {
          isActive = value;
        }
      );

      // parses from the DOM value into the model value
      ngModel.$parsers.unshift(function(value) {
        if (value === '') {
          return '';
        }
        // use new Date to detect undefineds etc., use moment to detect 1999-02-31 is invalid
        if (new Date(value) != 'Invalid Date' && moment(value).isValid())
          return value;
      });

      // formats how a model value will be rendered in the DOM
      ngModel.$formatters.unshift(function(value) {
        explodeIntoComponents(value);
        return value;
      });

      ////////////////////////////////////////////

      function explodeIntoComponents(dateValue) {
        var day;
        var month;
        var year;

        var dayComponentFieldName = attrs['id'] + '_date_day';
        var monthComponentFieldName = attrs['id'] + '_date_month';
        var yearComponentFieldName = attrs['id'] + '_date_year';

        var dayField = form[dayComponentFieldName]
          ? form[dayComponentFieldName]
          : null;
        var monthField = form[monthComponentFieldName]
          ? form[monthComponentFieldName]
          : null;
        var yearField = form[yearComponentFieldName]
          ? form[yearComponentFieldName]
          : null;

        if (dateValue) {
          dateValue = new Date(dateValue);

          day = dateValue.getDate();
          month = dateValue.getMonth() + 1;
          year = dateValue.getFullYear();

          if (day && day.toString().length < 2) {
            day = '0' + day;
          }
          if (month && month.toString().length < 2) {
            month = '0' + month;
          }

          if (dayField) {
            dayField.$setViewValue(day);
            dayField.$modelValue = day;
            dayField.$render();
          }
          if (monthField) {
            monthField.$setViewValue(month);
            monthField.$render();
          }
          if (yearField) {
            yearField.$setViewValue(year);
            yearField.$render();
          }
        } else {
          dayField.$setViewValue('');
          dayField.$render();
          monthField.$setViewValue('');
          monthField.$render();
          yearField.$setViewValue('');
          yearField.$render();
        }
      }
    }
  };
}

CustomDateField.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function CustomDateField(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var customDateField = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'customDateField';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(customDateField);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'customDateField',
    'app/commons/form/custom-date-field/custom-date-field.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'customDateField',
    'app/commons/form/custom-date-field/custom-date-field.html'
  );
}

angular
  .module('form.customDateField', [])
  .directive('customDateFieldComponentDir', customDateFieldComponentDir)
  .directive('customDateFieldExploderDir', customDateFieldExploderDir)
  .config(CustomDateField);

FromDisclaimer.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function FromDisclaimer(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var disclaimer = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'disclaimer';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(disclaimer);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'disclaimer',
    'app/commons/form/disclaimer/disclaimer.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'disclaimer',
    'app/commons/form/disclaimer/disclaimer.html'
  );
}

angular.module('form.disclaimer', []).config(FromDisclaimer);

Typeahead.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function Typeahead(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var typeahead = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'typeahead';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(typeahead);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'typeahead',
    'app/commons/form/typeahead/typeahead.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'typeahead',
    'app/commons/form/typeahead/typeahead.html'
  );
}

angular.module('form.typeahead', []).config(Typeahead);

RadiosWithSentence.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function RadiosWithSentence(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var radiosWithSentence = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'radiosWithSentence';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(radiosWithSentence);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'radiosWithSentence',
    'app/commons/form/radios-with-sentence/radios-with-sentence.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'radiosWithSentence',
    'app/commons/form/radios-with-sentence/radios-with-sentence.html'
  );
}

angular.module('form.radioWithSentence', []).config(RadiosWithSentence);

RadiosWithContent.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function RadiosWithContent(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var radiosWithContent = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'radiosWithContent';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(radiosWithContent);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'radiosWithContent',
    'app/commons/form/radios-with-content/radios-with-content.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'radiosWithContent',
    'app/commons/form/radios-with-content/radios-with-content.html'
  );
}

angular.module('form.radiosWithContent', []).config(RadiosWithContent);

RadiosWithCustomDelete.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function RadiosWithCustomDelete(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var radiosWithCustomDelete = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'radiosWithCustomDelete';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(radiosWithCustomDelete);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'radiosWithCustomDelete',
    'app/commons/form/radios-with-custom-delete/radios-with-custom-delete.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'radiosWithCustomDelete',
    'app/commons/form/radios-with-custom-delete/radios-with-custom-delete.html'
  );
}

/* The super special component that's only used for the oput-out yes/no radio
button for one client */

angular
  .module('form.radiosWithCustomDelete', [])
  .config(RadiosWithCustomDelete);

SchemaFormRangeWithContentSimple.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function SchemaFormRangeWithContentSimple(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var rangesWithContentSimple = function(name, schema, options) {
    if (
      schema.type === 'string' &&
      schema.format === 'rangesWithContentSimple'
    ) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'rangesWithContentSimple';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(rangesWithContentSimple);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'rangesWithContentSimple',
    'app/commons/form/schema-form-range-with-content-simple/schema-form-range-with-content-simple.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'rangesWithContentSimple',
    'app/commons/form/schema-form-range-with-content-simple/schema-form-range-with-content-simple.html'
  );
}

angular
  .module('form.schemaFormRangeWithContentSimple', [])
  .config(SchemaFormRangeWithContentSimple);

smsButtonActions.$inject = ['$q', 'SmsResource', '$timeout'];
function smsButtonActions($q, SmsResource, $timeout) {
  var ACTIONS = {
    Sms: 'sms',
    Hlr: 'hlr'
  };

  /**
   * @param {string} action The action to check
   *
   * @returns
   * `true`, if `action` is valid
   */
  function isValidAction(action) {
    for (var enumKey in ACTIONS) {
      var _action = ACTIONS[enumKey];

      if (action === _action) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {*} action The performed action
   * @param {*} success Wether the action is considered successful
   * @param {*} response The response
   *
   * @returns {string}
   * Status message based on `action` and `success`
   */
  function getStatusMessage(action, success, response) {
    if (ACTIONS.Sms === action) {
      if (success) {
        return 'Sms sent';
      } else {
        return response.status == 400
          ? response.data.detail
          : 'Sending sms failed';
      }
    } else if (ACTIONS.Hlr === action) {
      if (success) {
        return 'Phone number valid';
      } else {
        // Use backend error message or fallback
        return response.status == 400
          ? response.data.detail
          : 'Number could not be validated';
      }
    }
  }

  return {
    restrict: 'A',
    require: ['^form'],
    link: function(scope, element, attrs, controllers) {
      var action = attrs.smsButtonActions;
      // Only operator on known actions
      if (!isValidAction(action)) {
        return;
      }

      var form = controllers[0];

      var requestPending;
      scope.smsButtonActionsOptoins = {};
      scope.smsButtonActionsOptoins.isDisabled = 0;
      scope.smsButtonActionsOptoins.onClick = onClick;
      scope.smsButtonActionsOptoins.isDisabled = isDisabled;
      scope.smsButtonActionsOptoins.error;

      scope.$watch(function() {
        return form[attrs.targetFieldName].$modelValue;
      }, onInputChange);

      function onInputChange(oldVal, newVal) {
        scope.smsButtonActionsOptoins.error = '';
      }

      function onClick() {
        if (isDisabled()) {
          return;
        }
        sendSms(
          form[attrs.targetFieldName].$modelValue,
          attrs.campaignLang
        ).catch(function(errorResponse) {});
      }

      function isDisabled() {
        return !!(
          !form[attrs.targetFieldName].$modelValue ||
          requestPending ||
          scope.smsButtonActionsOptoins.error
        );
      }

      function sendSms(number, lang) {
        if (requestPending) {
          return requestPending;
        }

        var defered = $q.defer();
        var data = {
          to: number,
          lang: lang
        };

        if (attrs.campaignType == 'campaign') {
          data.campaign_id = attrs.campaignId;
        } else if (attrs.campaignType == 'petition') {
          data.petition_campaign_id = attrs.campaignId;
        } else if (attrs.campaignType == 'recruiting') {
          data.recruiting_id = attrs.campaignId;
        }

        if (
          number &&
          (data.petition_campaign_id || data.campaign_id || data.recruiting_id)
        ) {
          scope.smsButtonActionsOptoins.isPending = true;
          SmsResource.sms(data)
            .then(function(response) {
              var msg = getStatusMessage(action, true, response);
              scope.smsButtonActionsOptoins.success = msg;
              $timeout(function() {
                scope.smsButtonActionsOptoins.success = '';
                defered.resolve();
              }, 3000);
            })
            .catch(function(errorResponse) {
              var msg = getStatusMessage(action, false, errorResponse);
              scope.smsButtonActionsOptoins.error = msg;
              defered.reject();
            })
            .finally(function() {
              scope.smsButtonActionsOptoins.isPending = false;
              requestPending = null;
            });
        } else {
          defered.reject();
        }

        requestPending = defered.promise;

        return defered.promise;
      }
    }
  };
}

angular
  .module('form.smsButtonActions', [])
  .directive('smsButtonActions', smsButtonActions);

SignaturePadControl.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function SignaturePadControl(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var signaturePad = function(name, schema, options) {
    if (schema.type === 'string' && schema.enum != undefined) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'signaturePad';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(signaturePad);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'signaturePad',
    'app/commons/form/signature-pad/signature-pad.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'signaturePad',
    'app/commons/form/signature-pad/signature-pad.html'
  );
}

angular.module('form.signaturePad', []).config(SignaturePadControl);

GoogleAddressSearch.$inject = [
  'schemaFormProvider',
  'schemaFormDecoratorsProvider',
  'sfPathProvider'
];
function GoogleAddressSearch(
  schemaFormProvider,
  schemaFormDecoratorsProvider,
  sfPathProvider
) {
  var googleAddressSearch = function(name, schema, options) {
    var f = schemaFormProvider.stdFormObj(name, schema, options);

    if (schema.type === 'string') {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'googleAddressSearch';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(googleAddressSearch);

  schemaFormDecoratorsProvider.addMapping(
    'bootstrapDecorator',
    'googleAddressSearch',
    'app/commons/form/google-address-search/google-address-search.html'
  );

  schemaFormDecoratorsProvider.createDirective(
    'googleAddressSearch',
    'app/commons/form/google-address-search/google-address-search.html'
  );
}

angular
  .module('form.googleAddressSearch', ['ngAutocomplete'])
  .config(GoogleAddressSearch);

function IncognitoCheckService() {
  var incognitoCheckService = {
    //retry : retry,
    //isIE10OrLater : isIE10OrLater,
    detectPrivateMode: detectPrivateMode
  };

  return incognitoCheckService;

  function retry(isDone, next) {
    var current_trial = 0,
      max_retry = 50,
      interval = 10,
      is_timeout = false;
    var id = window.setInterval(function() {
      if (isDone()) {
        window.clearInterval(id);
        next(is_timeout);
      }
      if (current_trial++ > max_retry) {
        window.clearInterval(id);
        is_timeout = true;
        next(is_timeout);
      }
    }, 10);
  }

  function isIE10OrLater(user_agent) {
    var ua = user_agent.toLowerCase();
    if (ua.indexOf('msie') === 0 && ua.indexOf('trident') === 0) {
      return false;
    }
    var match = /(?:msie|rv:)\s?([\d\.]+)/.exec(ua);
    if (match && parseInt(match[1], 10) >= 10) {
      return true;
    }
    return false;
  }

  function detectPrivateMode(callback) {
    var is_private;

    if (window.webkitRequestFileSystem) {
      window.webkitRequestFileSystem(
        window.TEMPORARY,
        1,
        function() {
          is_private = false;
        },
        function(e) {
          is_private = true;
        }
      );
    } else if (window.indexedDB && /Firefox/.test(window.navigator.userAgent)) {
      var db;
      try {
        db = window.indexedDB.open('test');
      } catch (e) {
        is_private = true;
      }

      if (typeof is_private === 'undefined') {
        retry(
          function isDone() {
            return db.readyState === 'done' ? true : false;
          },
          function next(is_timeout) {
            if (!is_timeout) {
              is_private = db.result ? false : true;
            }
          }
        );
      }
    } else if (isIE10OrLater(window.navigator.userAgent)) {
      is_private = false;
      try {
        if (!window.indexedDB) {
          is_private = true;
        }
      } catch (e) {
        is_private = true;
      }
    } else if (
      window.localStorage &&
      /Safari/.test(window.navigator.userAgent)
    ) {
      try {
        window.localStorage.setItem('test', 1);
      } catch (e) {
        is_private = true;
      }

      if (typeof is_private === 'undefined') {
        is_private = false;
        window.localStorage.removeItem('test');
      }
    }

    retry(
      function isDone() {
        return typeof is_private !== 'undefined' ? true : false;
      },
      function next(is_timeout) {
        callback(is_private);
      }
    );
  }
}

angular
  .module('service.incognitocheck', [])
  .service('incognitoCheckService', IncognitoCheckService);

CachingService.$inject = [
  '$rootScope',
  '$templateCache',
  'CacheFactory',
  'AuthenticationChannel'
];
function CachingService(
  $rootScope,
  $templateCache,
  CacheFactory,
  AuthenticationChannel
) {
  var scope = $rootScope.$new();

  init();

  var cachingService = {
    clearAllCaches: clearAllCaches,
    clearTemplateCaches: clearTemplateCaches,
    clearHttpCaches: clearHttpCaches
  };
  return cachingService;

  /////////

  function init() {
    AuthenticationChannel.subAuthenticationLogoutConfirmed(
      scope,
      onLogoutConfirmeHandler
    );
  }

  function onLogoutConfirmeHandler(data) {
    clearHttpCaches();
  }

  function clearAllCaches() {
    //clearTemplateCaches();
    clearHttpCaches();
  }

  function clearTemplateCaches() {
    $templateCache.removeAll();
  }

  function clearHttpCaches() {
    CacheFactory.clearAll();
  }
}

angular
  .module('service.cachingService', [])
  .service('cachingService', CachingService);

SchemeFormTemplateOverrides.$inject = ['$templateCache'];
function SchemeFormTemplateOverrides($templateCache) {
  $templateCache.put(
    'directives/decorators/bootstrap/actions.html',
    '<div class="btn-group schema-form-actions {{form.htmlClass}}"><input ng-repeat-start="item in form.items" type="submit" class="btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}" value="{{item.title}}" ng-if="item.type === \'submit\'"> <button ng-repeat-end="" class="btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}" type="button" ng-disabled="form.readonly" ng-if="item.type !== \'submit\'" ng-click="buttonClick($event,item)"><span ng-if="item.icon" class="{{item.icon}}"></span>{{item.title}}</button></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/array.html',
    '<div sf-array="form" class="schema-form-array {{form.htmlClass}}" ng-model="$$value$$" ng-model-options="form.ngModelOptions"><label class="control-label" ng-show="showTitle()">{{ form.title }}</label><ol class="list-group" ng-model="modelArray" ui-sortable=""><li class="list-group-item {{form.fieldHtmlClass}}" ng-repeat="item in modelArray track by $index"><button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)" style="position: relative; z-index: 20;" type="button" class="close pull-right"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator></li></ol><div class="clearfix" style="padding: 15px;"><button ng-hide="form.readonly || form.add === null" ng-click="appendToArray()" type="button" class="btn {{ form.style.add || \'btn-default\' }} pull-right"><i class="fa fa-plus"></i> {{ form.add || \'Add\'}}</button></div><div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description" ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/checkbox.html',
    '<div class="checkbox schema-form-checkbox {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="{{form.labelHtmlClass}}"><input type="checkbox" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" class="{{form.fieldHtmlClass}}" name="{{form.key.slice(-1)[0]}}"> <span ng-bind-html="form.title"></span></label><div class="help-block" sf-message="form.description"></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/checkboxes.html',
    '<div sf-array="form" ng-model="$$value$$" class="form-group schema-form-checkboxes {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label><div class="checkbox" ng-repeat="val in titleMapValues track by $index"><label><input type="checkbox" ng-disabled="form.readonly" sf-changed="form" class="{{form.fieldHtmlClass}}" ng-model="titleMapValues[$index]" name="{{form.key.slice(-1)[0]}}"> <span ng-bind-html="form.titleMap[$index].name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'
  );
  // default
  $templateCache.put(
    'directives/decorators/bootstrap/fieldset-trcl.html',
    '<fieldset ng-disabled="form.readonly" class="schema-form-fieldset {{form.htmlClass}}"><legend  class="legend" ng-class="{\'sr-only\': !showTitle() }"><p>{{ form.title }}</p></legend><div class="help-block" ng-show="form.description" ng-bind-html="form.description"></div><div ng-transclude=""></div></fieldset>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/help.html',
    '<div class="helpvalue schema-form-helpvalue {{form.htmlClass}}" ng-bind-html="form.helpvalue"></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/radio-buttons.html',
    '<div class="form-group schema-form-radiobuttons {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><div><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label></div><div class="btn-group"><label class="btn {{ (item.value === $$value$$) ? form.style.selected || \'btn-default\' : form.style.unselected || \'btn-default\'; }}" ng-class="{ active: item.value === $$value$$ }" ng-repeat="item in form.titleMap"><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" style="display: none;" ng-disabled="form.readonly" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/radios-inline.html',
    '<div id="{{\'form-group-\'+form.key.slice(-1)[0]}}" class="form-group schema-form-radios-inline {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label><div><label class="radio-inline" ng-repeat="item in form.titleMap"><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/radios.html',
    '<div class="form-group schema-form-radios {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label><div class="radio" ng-repeat="item in form.titleMap"><label><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/section.html',
    '<div class="schema-form-section {{form.htmlClass}}"><sf-decorator ng-repeat="item in form.items" form="item"></sf-decorator></div>'
  );
  // fieldset
  $templateCache.put(
    'directives/decorators/bootstrap/fieldset.html',
    '<fieldset  ' +
      'ng-style="form.styles" ' +
      'ng-if="form.condition === undefined || form.condition()" ' +
      'ng-disabled="form.readonly" ' +
      'class="schema-form-fieldset schema-form-fieldset--{{form.htmlClass}}">' +
      '<legend class="legend" ng-class="{\'sr-only\': !showTitle() }">' +
      '<p>{{ form.title }}</p>' +
      '</legend>' +
      '<div class="help-block" ng-show="form.description" ng-bind-html="form.description"></div>' +
      '<sf-decorator ng-repeat="item in form.items" form="item"></sf-decorator>' +
      '</fieldset>'
  );

  // select
  // submit
  $templateCache.put(
    'directives/decorators/bootstrap/tabarray.html',
    '<div sf-array="form" ng-init="selected = { tab: 0 }" class="clearfix schema-form-tabarray schema-form-tabarray-{{form.tabType || \'left\'}} {{form.htmlClass}}"><div ng-if="!form.tabType || form.tabType !== \'right\'" ng-class="{\'col-xs-3\': !form.tabType || form.tabType === \'left\'}"><ul class="nav nav-tabs" ng-class="{ \'tabs-left\': !form.tabType || form.tabType === \'left\'}"><li ng-repeat="item in modelArray track by $index" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide="form.readonly" ng-click="$event.preventDefault() || (selected.tab = appendToArray().length - 1)"><a href="#"><i class="fa fa-plus"></i> {{ form.add || \'Add\'}}</a></li></ul></div><div ng-class="{\'col-xs-9\': !form.tabType || form.tabType === \'left\' || form.tabType === \'right\'}"><div class="tab-content {{form.fieldHtmlClass}}"><div class="tab-pane clearfix" ng-repeat="item in modelArray track by $index" ng-show="selected.tab === $index" ng-class="{active: selected.tab === $index}"><sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator><button ng-hide="form.readonly" ng-click="selected.tab = deleteFromArray($index).length - 1" type="button" class="btn {{ form.style.remove || \'btn-default\' }} pull-right"><i class="fa fa-trash"></i> {{ form.remove || \'Remove\'}}</button></div></div></div><div ng-if="form.tabType === \'right\'" class="col-xs-3"><ul class="nav nav-tabs tabs-right"><li ng-repeat="item in modelArray track by $index" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide="form.readonly" ng-click="$event.preventDefault() || appendToArray()"><a href="#"><i class="fa fa-plus"></i> {{ form.add || \'Add\'}}</a></li></ul></div></div>'
  );
  $templateCache.put(
    'directives/decorators/bootstrap/tabs.html',
    '<div ng-init="selected = { tab: 0 }" class="schema-form-tabs {{form.htmlClass}}"><ul class="nav nav-tabs"><li ng-repeat="tab in form.tabs" ng-disabled="form.readonly" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{ tab.title }}</a></li></ul><div class="tab-content {{form.fieldHtmlClass}}"><div class="tab-pane" ng-disabled="form.readonly" ng-repeat="tab in form.tabs" ng-show="selected.tab === $index" ng-class="{active: selected.tab === $index}"><bootstrap-decorator ng-repeat="item in tab.items" form="item"></bootstrap-decorator></div></div></div>'
  );

  $templateCache.put(
    'directives/decorators/bootstrap/textarea.html',
    '<div class="form-group has-feedback {{form.htmlClass}} schema-form-textarea" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="{{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.slice(-1)[0]}}">{{form.title}}</label> <textarea ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-changed="form" placeholder="{{form.placeholder}}" ng-disabled="form.readonly" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" name="{{form.key.slice(-1)[0]}}"></textarea><div ng-if="form.fieldAddonLeft || form.fieldAddonRight" ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span> <textarea class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-changed="form" placeholder="{{form.placeholder}}" ng-disabled="form.readonly" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" name="{{form.key.slice(-1)[0]}}"></textarea> <span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span></div><span class="help-block" sf-message="form.description"></span></div>'
  );

  /*autocapitalize=off autocomplete=off autocorrect=off*/
  $templateCache.put(
    'directives/decorators/bootstrap/default.html',
    '<div id="{{\'form-group-\'+form.key.slice(-1)[0]}}" ' +
      'class="form-group schema-form-{{form.type}} {{form.htmlClass}}" ' +
      "ng-class=\"{'has-error': form.disableErrorState !== true && hasError(), 'has-success': form.disableSuccessState !== true && hasSuccess(), 'has-feedback': form.feedback !== false }\">" +
      '<label class="control-label {{form.labelHtmlClass}}" ' +
      'ng-class="{\'sr-only\': !showTitle()}" ' +
      'for="{{form.key.slice(-1)[0]}}">' +
      '{{form.title}}' +
      '</label>' +
      '<input autocapitalize="off" autocomplete="off" autocorrect="off" ' +
      'ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" ' +
      'ng-show="form.key" ' +
      'type="{{form.type}}" ' +
      'step="any" ' +
      'sf-changed="form" ' +
      'placeholder="{{form.placeholder}}" ' +
      'class="form-control {{form.fieldHtmlClass}}" ' +
      'id="{{form.key.slice(-1)[0]}}" ' +
      "is-required-if-country-different-dir='{{form.isRequiredIfCountryDifferentDir}}' is-required-if-country-different-country='{{form.isRequiredIfCountryDifferentCountry}}' is-required-if-country-different-initial-country='{{form.isRequiredIfCountryDifferentInitialCountry}}' " +
      "capitalized-dir='{{form.capitalizedDir}}' " +
      "uppercased-dir='{{form.uppercasedDir}}' " +
      "format-iban-dir='{{form.formatIbanDir}}' " +
      "trimmed-whitespace-dir='{{form.trimmedWhitespaceDir}}' trim-all-whitespace='{{form.trimAllWhitespace}}' " +
      "some-of-valid-dir='{{form.someOfValidDir}}' " +
      "some-of-valid-fields='{{form.someOfValidFields}}' " +
      "some-of-valid-num-of-matches='{{form.someOfValidNumOfMatches}}' " +
      "is-country-of-iban-valid-dir='{{form.isCountryOfIbanValidDir}}' is-country-of-iban-valid-country='{{form.isCountryOfIbanValidCountry}}' " +
      "is-iban-valid-dir='{{form.isIbanValidDir}}' " +
      "is-bic-existing-valid-dir='{{form.isBicExistingValidDir}}' " +
      "is-bic-existing-valid-country='{{form.isBicExistingValidCountry}}' " +
      "gb-post-code-validation-dir='{{form.gbPostCodeValidationDir}}' gb-post-code-validation-country='{{form.gbPostCodeValidationCountry}}' " +
      "is-valid-first-name-dir is-valid-first-name='{{form.isValidFirstName}}' valid-first-name-title='{{form.validFirstNameTitle}}' valid-first-name-warning-message='{{form.validFirstNameWarningMessage}}' " +
      "format-e164-dir is-format-e164='{{form.isFormatE164}}' format-e164-country='{{form.formatE164Country}}' update-on-country-change='{{form.updateOnCountryChange}}' format-e164-warning-message='{{form.formatE164WarningMessage}}' " +
      "get-bank-name-dir='{{form.getBankNameDir}}' " +
      "get-bank-name-bic='{{form.getBankNameBic}}' " +
      "get-bank-name-iban='{{form.getBankNameIban}}' " +
      "get-bank-name-country='{{form.getBankNameCountry}}'  " +
      "get-bank-name-bank-code='{{form.getBankNameBankCode}}' " +
      "get-bank-name-uk-sort-code='{{form.getBankNameUkSortCode}}' " +
      "get-bank-name-postfinance-clearing-number='{{form.getBankNamePostfinanceClearingNumber}}' " +
      "get-bank-name-payment-method='{{form.getBankNamePaymentMethod}}' " +
      "is-uk-account-number-valid-dir='{{form.isUkAccountNumberValidDir}}' is-uk-account-number-valid-sort-code='{{form.isUkAccountNumberValidSortCode}}' " +
      "is-uk-sort-code-existing-valid-dir='{{form.isUkSortCodeExistingValidDir}}' " +
      "format-uk-sort-code-dir='{{form.formatUkSortCodeDir}}' " +
      "format-ch-post-account-number-dir='{{form.formatChPostAccountNumberDir}}' " +
      "is-post-account-number-valid-dir='{{form.isPostAccountNumberValidDir}}' " +
      'ng-model-options="form.ngModelOptions" ' +
      'ng-model="$$value$$" ' +
      'ng-disabled="form.readonly" ' +
      'schema-validate="form" ' +
      'name="{{form.key.slice(-1)[0]}}" ' +
      'aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">' +
      '<div ng-if="form.fieldAddonLeft || form.fieldAddonRight" ' +
      'ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}">' +
      '<span ng-if="form.fieldAddonLeft" ' +
      'class="input-group-addon" ' +
      'ng-bind-html="form.fieldAddonLeft"></span> ' +
      '<input ng-show="form.key" ' +
      'type="{{form.type}}" ' +
      'step="any" ' +
      'sf-changed="form" ' +
      'placeholder="{{form.placeholder}}" ' +
      'class="form-control {{form.fieldHtmlClass}}" ' +
      'id="{{form.key.slice(-1)[0]}}" ' +
      'ng-model-options="form.ngModelOptions" ' +
      'ng-model="$$value$$" ' +
      'ng-disabled="form.readonly" ' +
      'schema-validate="form" ' +
      'name="{{form.key.slice(-1)[0]}}" ' +
      'aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}"> ' +
      '<span ng-if="form.fieldAddonRight" ' +
      'class="input-group-addon" ' +
      'ng-bind-html="form.fieldAddonRight">' +
      '</span>' +
      '</div>' +
      '<span ' +
      'ng-if="form.feedback !== false" ' +
      'class="form-control-feedback" ' +
      "ng-class=\"evalInScope(form.feedback) || {'fa': true, 'fa-check': hasSuccess(), 'fa-remove': hasError() }\" " +
      'aria-hidden="true"></span>' +
      '<span ng-if="hasError() || hasSuccess()" ' +
      'id="{{form.key.slice(-1)[0] + \'Status\'}}" ' +
      "class=\"sr-only\">{{ hasSuccess() ? '(success)' : '(error)' }}</span>" +
      '<div class="help-block" sf-message="form.description"></div>' +
      '<div class="warning-block"></div>' +
      '</div>'
  );

  $templateCache.put(
    'directives/decorators/bootstrap/select.html',
    '<div ' +
      'id="{{\'form-group-\'+form.key.slice(-1)[0]}}" ' +
      'class="form-group {{form.htmlClass}} schema-form-select" ' +
      "ng-class=\"{'has-error': form.disableErrorState !== true && hasError(), 'has-success': form.disableSuccessState !== true && hasSuccess(), 'has-feedback': form.feedback !== false}\">" +
      '<label ' +
      'class="control-label {{form.labelHtmlClass}}" ' +
      'ng-show="showTitle()">{{form.title}}</label>' +
      '<select ' +
      'ng-model="$$value$$" ' +
      'ng-model-options="form.ngModelOptions" ' +
      'ng-disabled="form.readonly" ' +
      'sf-changed="form" ' +
      'id="{{form.key.slice(-1)[0]}}" ' +
      'class="form-control {{form.fieldHtmlClass}}" ' +
      'schema-validate="form" ' +
      'ng-options="item.value as item.name group by item.group for item in form.titleMap" ' +
      'name="{{form.key.slice(-1)[0]}}"' +
      "is-postfinance-country-valid-dir='{{form.isPostfinanceCountryValidDir}}' " +
      "is-postfinance-country-valid-payment-method='{{form.isPostfinanceCountryValidPaymentMethod}}' " +
      "is-sort-code-country-valid-dir='{{form.isSortCodeCountryValidDir}}' " +
      "is-sort-code-country-valid-payment-method='{{form.isSortCodeCountryValidPaymentMethod}}' " +
      "is-payment-interval-valid-dir='{{form.isPaymentIntervalValidDir}}' " +
      "is-payment-interval-valid-amount='{{form.isPaymentIntervalValidAmount}}' " +
      "is-payment-interval-valid-title-map='{{form.isPaymentIntervalValidTitleMap}}' " +
      '>' +
      '<option value=""></option>' +
      '</select>' +
      '<div class="help-block" sf-message="form.description"></div>' +
      '</div>'
  );

  $templateCache.put(
    'directives/decorators/bootstrap/submit.html',
    '<div ' +
      'class="form-group schema-form-submit sms-button {{form.htmlClass}}" ' +
      "sms-button-actions='{{form.isSmsButton}}' " +
      'campaign-id="{{form.campaignId}}" ' +
      'campaign-type="{{form.campaignType}}" ' +
      'target-field-name="{{form.targetFieldName}}"' +
      'campaign-lang="{{form.campaignLang}}">' +
      '<input type="submit" ' +
      'class="btn {{ form.style || \'btn-primary\' }} {{form.fieldHtmlClass}}" ' +
      'value="{{form.title}}" ' +
      'ng-disabled="form.readonly" ' +
      'ng-if="form.type === \'submit\'"> ' +
      '<button class="btn {{ form.style || \'btn-default\' }}" ' +
      'ng-click="smsButtonActionsOptoins.onClick()" ' +
      'ng-class="{\'disabled\':smsButtonActionsOptoins.isDisabled()}" ' +
      'type="button" ' +
      'ng-disabled="form.readonly" ' +
      'ng-if="form.type !== \'submit\'">' +
      '<span ng-if="form.icon" class="{{form.icon}}"></span> {{form.title}}</button>' +
      "<div class='error' ng-if='smsButtonActionsOptoins.error'>{{smsButtonActionsOptoins.error | translate}}</div>" +
      "<div class='success' ng-if='smsButtonActionsOptoins.success'>{{smsButtonActionsOptoins.success | translate}}</div>" +
      '</div>'
  );
}

angular
  .module('form', [
    'schemaForm',
    'form.checkboxesWithContent',
    'form.customDateField',
    'form.disclaimer',
    'form.radiosWithContent',
    'form.radiosWithCustomDelete',
    'form.schemaFormRangeWithContentSimple',
    'form.googleAddressSearch',
    'form.radioWithSentence',
    'form.typeahead',
    'form.smsButtonActions',
    'form.signaturePad'
  ])
  .run(SchemeFormTemplateOverrides);

function BrowserSupportService() {
  return {
    isBrowserSupported: isBrowserSupported,
    detectBrowser: detectBrowser,
    getBrowserSupportFeedback: getBrowserSupportFeedback
  };

  /**
   * isBrowserSupported
   * Checks if the detected browser is supported or not.
   *
   * @param browserCheckResult
   * @param supportedBrowsers
   */
  function isBrowserSupported(browserCheckResult, supportedBrowsers) {
    // normal check of supported browsers
    return (
      browserCheckResult.browserName in supportedBrowsers &&
      browserCheckResult.majorVersion >=
        supportedBrowsers[browserCheckResult.browserName]
    );
  }

  function getBrowserSupportFeedback(browserCheckResult, supportedBrowsers) {
    //var isSupported = isBrowserSupported(browserCheckResult, supportedBrowsers);
    var title =
      'Browser ' +
      browserCheckResult.browserName +
      ' ' +
      browserCheckResult.majorVersion +
      ' is deprecated';
    var text = 'To avoid errors please update your browser.';

    //browser type not supported
    if (!(browserCheckResult.browserName in supportedBrowsers)) {
      title = 'Browser ' + browserCheckResult.browserName + ' is not supported';
      text =
        'Please use ' +
        Object.keys(supportedBrowsers).join(' or ') +
        ' instead.';
    }

    return {
      title: title,
      text: text
    };
  }

  /**
   * detectBrowser
   * This code is copied from http://stackoverflow.com/a/34172944
   * This code checks Browser version on client side. It returns a object including browser name, version usw...
   *
   * @returns {{nVer: string, nAgt: string, browserName: string, fullVersion: string, majorVersion: Number, nameOffset: *, verOffset: *, ix: *}}
   * @constructor
   */
  function detectBrowser() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera 15+, the true version is after "OPR/"
    if ((verOffset = nAgt.indexOf('OPR/')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 4);
    } else if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      // In older Opera, the true version is after "Opera" or after "Version"
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    } else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      // In MSIE, the true version is after "MSIE" in userAgent
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    } else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      // In Chrome, the true version is after "Chrome"
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    } else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      // In Safari, the true version is after "Safari" or after "Version"
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    } else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      // In Firefox, the true version is after "Firefox"
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    } else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      // In most other browsers, "name/version" is at the end of userAgent
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    return {
      nVer: nVer,
      nAgt: nAgt,
      browserName: browserName,
      fullVersion: fullVersion,
      majorVersion: majorVersion,
      nameOffset: nameOffset,
      verOffset: verOffset,
      ix: ix
    };
  }
}

function CommonHelpers() {
  return {
    filterValuesRecursive: filterValuesRecursive
  };

  /**
   * Recursively filter out all values of any object/array.
   * @param {mixed} obj          object/array to filter
   * @param {Function} filter    filter function
   * @returns {Array}
   */
  function filterValuesRecursive(obj, filter) {
    var values = [];

    if (obj instanceof Array) {
      for (var key in obj) {
        values = values.concat(filterValuesRecursive(obj[key], filter));
      }
    } else if (typeof obj === 'object') {
      for (var key in obj) {
        values = values.concat(filterValuesRecursive(obj[key], filter));
      }
    } else {
      if (filter(obj)) {
        values.push(obj);
      }
    }
    return values;
  }
}

angular
  .module('service.commonHelpers', [])
  .service('commonHelpers', CommonHelpers);

ImagePreloader.$inject = ['$q'];
function ImagePreloader($q) {
  var cache = [];

  return {
    load: load
  };

  /**
   * loadUrlPromise
   * loads an url and returns its promise
   *
   * @param string url   the media url
   * @returns {*|promise}
   */
  function loadUrlPromise(url) {
    // this is the preloading part
    var image = new Image();
    image.src = url;

    // keep a reference to the image
    // in order for it to stay in the memory
    cache.push(image);

    var deferred = $q.defer();

    image.onload = function() {
      deferred.resolve(url);
    };

    return deferred.promise;
  }

  /**
   * load
   * Preload an array of urls.
   *
   * @param {array<string>|string} urls    an array of or a single image url
   * @returns {Promise}
   */
  function load(urls) {
    var promises = [];

    if (!(urls instanceof Array)) {
      urls = [urls];
    }

    // count is used to determine whether all images have been loaded
    var count = urls.length;

    for (var key in urls) {
      var url = urls[key];

      promises.push(loadUrlPromise(url));

      if (count == 0) {
        promises.push($q.when(urls));
      }

      count--;
    }

    return $q.all(promises);
  }
}

angular
  .module('service.imagePreloader', [])
  .service('imagePreloader', ImagePreloader);

angular.module('service.bankAccountCheck', [
  'service.geoLocation',
  'bank-account.sepa',
  'bank-account.uk-sort-code',
  'bank-account.ch-post-finance',
  'isRequiredIfCountryDifferent-dir',
  'isPaymentIntervalValid-dir'
]);

FormHelperFactory.$inject = [
  '$translate',
  '$q',
  'CommonNames',
  'SmsResource',
  'AuthenticationService'
];
function FormHelperFactory(
  $translate,
  $q,
  CommonNames,
  SmsResource,
  AuthenticationService
) {
  var calculation_bases = ['monthly', 'yearly'];

  var FormHelperService = {
    applyDateAndFocus: applyDateAndFocus,
    getCalculationBases: getCalculationBases,
    getFieldOfFormObj: getFieldOfFormObj,
    getLocationAutofill: getLocationAutofill,
    getValueOfTitleMap: getValueOfTitleMap,
    calcIntervalDebitAmount: calcIntervalDebitAmount,
    calcMonthlyDebitAmount: calcMonthlyDebitAmount,
    calcYearlyDebitAmount: calcYearlyDebitAmount,
    getPaymentDisclaimer: getPaymentDisclaimer,
    rerenderInput: rerenderInput,
    focusEnd: focusEnd,
    toggleWarning: toggleWarning,
    oneOfRequired: oneOfRequired,
    validateFilledOut: validateFilledOut,
    validateMinDate: validateMinDate,
    validateMaxDate: validateMaxDate,
    configureDateOfBirthValidation: configureDateOfBirthValidation,
    isValidPhoneNumber: isValidPhoneNumber,
    isValidSalutation: isValidSalutation,
    isValidEmail: isValidEmail,
    warnIsValidEmail: warnIsValidEmail,
    isAllowedBankCode: isAllowedBankCode,
    isAllowedIbanCountry: isAllowedIbanCountry,
    isValidSignature: isValidSignature,
    copyValues: copyValues,
    smsButtonClick: smsButtonClick,
    keysToString: keysToString,
    getDonationModel: getDonationModel,
    validateRequired: validateRequired
  };

  return FormHelperService;

  ////////////

  function applyDateAndFocus(currentInput, day, month, year, nextInput) {
    //concat date
    if (day && month && year) {
      return new Date(month + '/' + day + '/' + year);
    }

    //focus next
    nextInput = angular.element(document.getElementsByClassName(nextInput));
    var canGoNext = false;

    if (currentInput == 'custom-date_day' && day > 9) {
      canGoNext = true;
    }
    if (currentInput == 'custom-date_month' && month > 9) {
      canGoNext = true;
    }

    if (nextInput[0] && canGoNext) {
      nextInput[0].focus();
    }
  }

  function getCalculationBases() {
    return angular.copy(calculation_bases);
  }

  function getFirstValueOfTitleMap(name, formConfig) {
    var formObj = getFieldOfFormObj(formConfig, name);
    return formObj.titleMap[0].value;
  }

  function getLocationAutofill(lastLocation, serverDefault) {
    if (lastLocation && 'value' in lastLocation) {
      return lastLocation.value;
    }
    return serverDefault || '';
  }

  /**
   * go through the form object and if there are any keys that are arrays, turn
   * them into strings!
   * @param  {object} formObj the SchemaForm form_config.form object
   */
  function keysToString(formObj) {
    // it's pretty silly that we have to do this manually, but actualDonation that
    // comes from DonationService and is instantiated in src/webapp/app/pages/donations/index.js
    // and is supposed to be some sort of constant changes the keys when navigating
    // between pages. If we figure out what's causing this, happily delete this
    // method.
    angular.forEach(formObj, function(fieldset, k) {
      angular.forEach(fieldset.items, function(item, k) {
        if (item.key && item.key.constructor === Array && item.key.length > 0) {
          item.key = item.key.join('');
        }
      });
    });
  }

  /**
   * get the donation model by merging what's passed by the server and what's
   * stored in local storage
   * @returns donationModel
   *
   * @param serverModel – the form_config.model object from the server with default values
   * @param store – the donation model loaded from local storage
   * @param formConfigSchema – form_config.schema as loaded from the server
   * @param formConfigForm – form_config.form as loaded from the server
   * @param lastLocation – the last location stored in local storage.
   */
  function getDonationModel(
    serverModel,
    store,
    formConfigSchema,
    formConfigForm,
    lastLocation
  ) {
    // the new model is initialized with the default values from the server
    var newDonationModel = angular.merge({}, serverModel || {});
    var offlineStore = angular.copy(store || {});
    // if schema is given iterate over all fields present in the server config for step 1 form
    if (formConfigSchema) {
      // iterate over the form_config because here are all possible fields (some of them could be invisible) referenced with key
      for (var key in formConfigSchema) {
        switch (key) {
          case 'account_post_finance_clearing_number':
            newDonationModel[key] = CH_Postfinance.CLEARING_NUMBER;
            break;
          case 'date_of_birth':
            if (offlineStore[key] && moment(offlineStore[key]).isValid()) {
              newDonationModel[key] = new Date(offlineStore[key]);
            }
            break;
          case 'contract_start_date':
            if (offlineStore[key] && moment(offlineStore[key]).isValid()) {
              newDonationModel[key] = new Date(offlineStore[key]);
            } else {
              newDonationModel[key] = new Date();
            }
            break;
          case 'payment_method':
            // first take offline store value
            if ('payment_method' in offlineStore) {
              newDonationModel[key] = offlineStore[key];
            } else if (key in serverModel) {
              // if not present take value from server model (default value)
              newDonationModel[key] = serverModel[key];
            } else {
              // else take the first value from the titleMap (the possible options in the select bo)
              newDonationModel[key] = getFirstValueOfTitleMap(
                'payment_method',
                formConfigForm
              );
            }
            break;
          case 'direct_debit_interval':
            // first take offline store value
            if ('direct_debit_interval' in offlineStore) {
              newDonationModel[key] = offlineStore[key];
            } else if (key in serverModel) {
              // if not present take value from server model (default value)
              newDonationModel[key] = serverModel[key];
            } else {
              // else take the first value from the titleMap (the possible options in the select bo)
              newDonationModel[key] = getFirstValueOfTitleMap(
                'direct_debit_interval',
                formConfigForm
              );
            }
            // no default in model
            break;
          case 'location':
            newDonationModel[key] = getLocationAutofill(
              lastLocation,
              offlineStore[key]
            );
            break;
          default:
            if (
              formConfigSchema[key] &&
              'type' in formConfigSchema[key] &&
              formConfigSchema[key].type === 'date'
            ) {
              if (offlineStore[key] && moment(offlineStore[key]).isValid()) {
                newDonationModel[key] = new Date(offlineStore[key]);
              }
            } else {
              // first take localstorage values if set
              if (
                offlineStore[key] !== undefined &&
                offlineStore[key] !== null
              ) {
                newDonationModel[key] = offlineStore[key];
              }
            }
        }
      }
      // now iterate over all the store's keys and make sure they are all loaded
      for (var key in offlineStore) {
        if (!(key in formConfigSchema)) {
          // TODO: see if we really want this for all the keys
          newDonationModel[key] = offlineStore[key];
          if (key === 'gift_recipients_map') {
            // birthdays have to be stored as dates in the model
            for (var i = 0; i < newDonationModel[key].length; ++i) {
              var giftRecipient = newDonationModel[key][i];
              if (
                'date_of_birth' in giftRecipient &&
                moment(giftRecipient['date_of_birth']).isValid()
              ) {
                giftRecipient['date_of_birth'] = new Date(
                  giftRecipient['date_of_birth']
                );
              }
            }
          }
        }
      }
    }
    // if contract start date does not exist in any dataset we set it to current day
    if (!('contract_start_date' in newDonationModel)) {
      newDonationModel.contract_start_date = new Date();
    }

    // set our frontend unique ID on the donation
    if (!('fuid' in newDonationModel)) {
      newDonationModel.fuid = generateFUID();
    }
    return newDonationModel;
  }

  //////VALIDATORS

  function isValidSignature(signatureArray) {
    if (!angular.isArray(signatureArray)) {
      return false;
    }

    //all under length 250 should be a dor or other to small signature
    if (signatureArray[1].length < 250) {
      return false;
    }

    return true;
  }

  function validateMinDate(form_config, name, value) {
    if (!value) {
      // if e.g. the birthday is empty, this passes. Use validateFilledOut instead for "required"
      return true;
    }

    // Using local mode for comparing dates without time.
    var min_date = moment(form_config.schema.properties[name].minimum).format(
      'YYYY-MM-DD'
    );
    value = moment(value).format('YYYY-MM-DD');

    return moment(value).isSameOrAfter(min_date);
  }

  function validateFilledOut(form_config, name, value) {
    // make sure that value is truthy, i.e. not null, undefined, 0, false or empty string
    return !!value;
  }

  function validateRequired(field, item, vm) {
    item.$validators = {};
    item.validationMessage = {};

    if ('required' in field && field.required) {
      item.$validators['required'] = function(value) {
        return validateFilledOut(vm.form_config, field.key, value);
      };
      item.validationMessage = function(ctx) {
        return $translate.instant('Required');
      };
    }
  }

  function validateMaxDate(form_config, name, value) {
    if (!value) {
      // if e.g. the birthday is empty, this passes. Use validateFilledOut instead for "required"
      return true;
    }

    // Using local mode for comparing dates without time.
    var max_date = moment(form_config.schema.properties[name].maximum).format(
      'YYYY-MM-DD'
    );
    value = moment(value).format('YYYY-MM-DD');

    return moment(value).isSameOrBefore(max_date);
  }

  function configureDateOfBirthValidation(field, item, vm) {
    item.$validators = {};
    item.validationMessage = {};
    if ('maximum' in field) {
      item.$validators['max'] = function(value) {
        return validateMaxDate(vm.form_config, 'date_of_birth', value);
      };
      item.validationMessage['max'] = function(ctx) {
        var max_date = new Date(
            vm.form_config.schema.properties[item.key].maximum.replace(
              /-/g,
              '/'
            )
          ),
          maximumAgeInYears =
            new Date(new Date() - new Date(max_date)).getFullYear() - 1970;
        return $translate.instant('The minimum age is {{minimum}} years.', {
          minimum: maximumAgeInYears
        });
      };
    }
    if ('minimum' in field) {
      item.$validators['min'] = function(value) {
        return validateMinDate(vm.form_config, 'date_of_birth', value);
      };
      item.validationMessage['min'] = function(ctx) {
        var min_date = new Date(
            vm.form_config.schema.properties[item.key].minimum.replace(
              /-/g,
              '/'
            )
          ),
          minimumAgeInYears =
            new Date(new Date() - new Date(min_date)).getFullYear() - 1970 - 1;
        return $translate.instant('The maximum age is {{maximum}} years.', {
          maximum: minimumAgeInYears
        });
      };
    }
    if ('required' in field && field.required) {
      item.$validators['required'] = function(value) {
        return validateFilledOut(vm.form_config, 'date_of_birth', value);
      };
      item.validationMessage['required'] = function(ctx) {
        return $translate.instant('Required');
      };
    }
  }

  /**
   * oneOfRequired
   *
   * put all fields but the one that is the actual field
   * actual value is a separate value because we dont get the new value from actual if we are in onChange
   *
   * @param arrayOfFieldNames
   * @param actual
   * @returns {boolean}
   */
  function oneOfRequired(model, arrayOfFieldNames, actual) {
    for (var i = 0; i < arrayOfFieldNames.length; i++) {
      if (model[arrayOfFieldNames[i]]) {
        return true;
      }
    }

    if (actual) {
      return true;
    }
    return false;
  }

  /////SOFT VALIDATORS

  /**
   * isValidPhoneNumber
   *
   * This is a soft validator It just adds warnings
   *
   * @param key
   * @param value
   */
  function isValidPhoneNumber(key, value) {
    var newMessage = $translate.instant(
      'Number is not correct for this country choice'
    );

    //isValid is a function from the phone lib
    toggleWarning(key, newMessage, !isValidNumber(value));
  }

  /**
   * isValidGender
   *
   * This is a soft validator It just adds warnings
   *
   * @param key
   * @param first_name
   * @param salutation
   */
  function isValidSalutation(key, first_name, salutation) {
    var newMessage = $translate.instant(
        'Salutation may not be correct for this name'
      ),
      addWarning = true,
      genderResult = CommonNames.getGender(first_name);

    if (salutation == '2' && salutation == '3') {
      addWarning = false;
    }

    if (genderResult.valid) {
      if (
        (salutation == 1 && genderResult.gender == 'f') ||
        (salutation == 0 && genderResult.gender == 'm')
      ) {
        addWarning = false;
      }
    } else {
      addWarning = false;
    }

    toggleWarning(key, newMessage, addWarning);
  }

  function isValidEmail(email) {
    // Based on RFC 2822 section 3.2.4 / RFC 5322 section 3.2.3, these
    // characters are permitted in email addresses (not taking into
    //  account internationalization):
    var ATEXT = "a-zA-Z0-9_!#\\$%&\\'\\*\\+\\-/=\\?\\^`\\{\\|\\}~";
    // A "dot atom text", per RFC 2822 3.2.4:
    var DOT_ATOM_TEXT = '[' + ATEXT + ']+(?:\\.[' + ATEXT + ']+)*';

    // The domain part of the email address, after IDNA (ASCII) encoding,
    // must also satisfy the requirements of RFC 952/RFC 1123 which restrict
    // the allowed characters of hostnames further. The hyphen cannot be at
    // the beginning or end of a *dot-atom component* of a hostname either.

    // it seems we can't match the full range \u0080-\U0010FFFF in a JavaScript regex easily
    // (we would need to use surrogate pairs – https://stackoverflow.com/questions/16346567/strip-u10000-u10ffff-from-javascript-strings)
    // so the local part validation is more restricted than on the backend
    //
    // // RFC 6531 section 3.3 extends the allowed characters in internationalized
    // // addresses to also include three specific ranges of UTF8 defined in
    // // RFC3629 section 4, which appear to be the Unicode code points from
    // // U+0080 to U+10FFFF.
    // var ATEXT_UTF8 = ATEXT + '\u0080-\U0010FFFF'
    // var DOT_ATOM_TEXT_UTF8 = '[' + ATEXT_UTF8 + ']+(?:\\.[' + ATEXT_UTF8 + ']+)*'

    // we are not allowing unicode characters in the domain part to be synced with the backend
    /* var validUnicodeChars = '\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFFu20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF'; */

    // var ATEXT_HOSTNAME = '(?:(?:[' + validUnicodeChars + 'a-zA-Z0-9][' + validUnicodeChars + 'a-zA-Z0-9\\-]*)?[' + validUnicodeChars + 'a-zA-Z0-9])';

    // The domain part of the email address, after IDNA (ASCII) encoding,
    // must also satisfy the requirements of RFC 952/RFC 1123 which restrict
    // the allowed characters of hostnames further. The hyphen cannot be at
    // the beginning or end of a *dot-atom component* of a hostname either.
    var ATEXT_HOSTNAME = '(?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]*)?[a-zA-Z0-9])';

    if (!email) {
      return true;
    }

    var parts = email.split('@');
    if (parts.length != 2) {
      return false;
    }
    try {
      validateEmailLocalPart(parts[0]);
    } catch (ex) {
      return false;
    }

    try {
      validateEmailDomainPart(parts[1]);
    } catch (ex) {
      return false;
    }

    return true;

    ///////////////////////////////////////
    function validateEmailLocalPart(localPart) {
      if (!localPart || localPart.length == 0) {
        throw 'There must be something before the @-sign.';
      }
      // RFC 5321 4.5.3.1.1
      if (localPart.length > 64) {
        throw 'The email address is too long before the @-sign.';
      }
      // Check the local part against the regular expression for the older ASCII requirements.
      var re = new RegExp('^' + DOT_ATOM_TEXT + '$');
      var found = null;
      found = localPart.match(re);
      if (!found) {
        throw 'The email address contains invalid characters before the @-sign: "' +
          badChars +
          '"';
      }
      return localPart;
    }

    function validateEmailDomainPart(domainPart) {
      if (!domainPart || domainPart.length == 0) {
        throw 'There must be something after the @-sign.';
      }
      //endsWith
      if (domainPart.indexOf('.') === domainPart.length - 1) {
        throw 'An email address cannot end with a period.';
      }
      //startsWith
      if (domainPart.indexOf('.') === 0) {
        throw 'An email address cannot have a period immediately after the @-sign.';
      }
      if (domainPart.indexOf('..') != -1) {
        throw 'An email address cannot have two periods in a row.';
      }
      if (domainPart.length > 255) {
        throw 'The email address is too long after the @-sign.';
      }
      // A "dot atom text", per RFC 2822 3.2.4, but using the restricted
      // characters allowed in a hostname (see ATEXT_HOSTNAME above).
      DOT_ATOM_TEXT_2 = ATEXT_HOSTNAME + '(?:\\.' + ATEXT_HOSTNAME + ')*';
      // Check the regular expression. This is probably entirely redundant
      // with idna.decode, which also checks this format.
      var re = new RegExp('^' + DOT_ATOM_TEXT_2 + '$');
      var found = domainPart.match(re);
      if (!found) {
        throw 'The email address contains invalid characters after the @-sign.';
      }
      // All publicly deliverable addresses have domain named with at least
      // one period. We also know that all TLDs end with a letter.
      if (domainPart.indexOf('.') == -1) {
        throw 'The domain name ' +
          domainPart +
          ' is not valid. It should have a period.';
      }
      var re = new RegExp('[A-Za-z]$');
      var found = domainPart.search(re);
      if (found == -1) {
        throw 'The domain name ' +
          domainPart +
          ' is not valid. It is not within a valid top-level domain.';
      }
      return domainPart;
    }
  }

  function warnIsValidEmail(key, value) {
    var newMessage = $translate.instant('This is no valid email');

    if (!isValidEmail(value)) {
      toggleWarning(key, newMessage, true);
    } else {
      toggleWarning(key, value);
    }
  }

  /**
   * check the lists of allowed / banned bank codes provided by the backend
   * @param  {string}  iban
   * @return {Boolean} isValid
   */
  function isAllowedBankCode(iban, allowedBankCodes, disallowedBankCodes) {
    if (!iban) return true;
    var bankCode = Sepa.getBankCodeFromIban(iban);
    // allowedBankCodes = ['04835'];
    // disallowedBankCodes = [];
    if (
      allowedBankCodes &&
      allowedBankCodes.length > 0 &&
      allowedBankCodes.indexOf(bankCode) === -1
    ) {
      return false;
    }
    if (
      disallowedBankCodes &&
      disallowedBankCodes.length > 0 &&
      disallowedBankCodes.indexOf(bankCode) > -1
    ) {
      return false;
    }
    return true;
  }

  /**
   * check the lists of allowed / banned IBAN country codes provided by the backend
   * @param  {string}  ibanCountryCode
   * @return {Boolean} isValid
   */
  function isAllowedIbanCountry(
    ibanCountryCode,
    allowedIbanCountryCodes,
    disallowedIbanCountryCodes
  ) {
    if (
      allowedIbanCountryCodes &&
      allowedIbanCountryCodes.length > 0 &&
      allowedIbanCountryCodes.indexOf(ibanCountryCode) === -1
    ) {
      return false;
    }
    if (
      disallowedIbanCountryCodes &&
      disallowedIbanCountryCodes.length > 0 &&
      disallowedIbanCountryCodes.indexOf(ibanCountryCode) > -1
    ) {
      return false;
    }
    return true;
  }

  //////FORMATTER

  function focusEnd(inputId) {
    /*cursor jump bugfix*/
    var input = document.getElementById(inputId);
    if (input) {
      var ngInput = angular.element(input);
      ngInput.focus();
      var selectionRangStart = ngInput[0].value.length;
      var selectionRangEnd = selectionRangStart;
      setTimeout(function() {
        ngInput.get(0).setSelectionRange(selectionRangStart, selectionRangEnd);
      }, 0);
    }
  }

  /**
   * toggleWarning
   *
   * @param fieldName {String}
   * @param newMessage {String}
   * @param addWarning {Boolean}
   */
  function toggleWarning(fieldName, newMessage, addWarning) {
    var contentsOfFormGroup = angular
        .element(document.getElementById(fieldName))
        .parent()
        .contents(),
      helpBlock = angular.element(
        contentsOfFormGroup[contentsOfFormGroup.length - 1]
      ),
      oldDescription = '';
    if (addWarning) {
      angular
        .element(document.getElementById(fieldName))
        .parent()
        .addClass('has-warning');
      helpBlock.text($translate.instant(newMessage));
    } else {
      angular
        .element(document.getElementById(fieldName))
        .parent()
        .removeClass('has-warning');
      helpBlock.text(oldDescription);
    }
  }

  /**
   * This function chages the value of a giver vield and then revert the changes back to previous values
   * This is kind of a hack to force rerendering also the error message
   *
   * @param name The name of the input to be reseted
   */
  function rerenderInput(
    form,
    name,
    viewString,
    viewStringOptions,
    oldValueOverrideIfNull
  ) {
    viewString = viewString ? viewString + '' : '';

    if (form[name] == undefined) {
      return;
    }

    var oldVal = form[name].$viewValue;
    if (oldVal === null || oldVal === undefined) {
      oldVal =
        oldValueOverrideIfNull !== undefined || oldValueOverrideIfNull !== null
          ? oldValueOverrideIfNull
          : '';
    }
    //@TODO check for better way and also check for better val then 1

    if (viewStringOptions) {
      form[name].$setViewValue(viewString + oldVal);
    } else {
      form[name].$setViewValue(viewString);
    }

    form[name].$setViewValue(oldVal);
  }

  function getFieldOfFormObj(formObj, keyName, byRef) {
    var searchedItem = false;
    angular.forEach(formObj, function(fieldset, key) {
      //iterate fieldset items
      if (!angular.isObject(fieldset) || !('items' in fieldset)) {
        return false;
      }

      angular.forEach(fieldset.items, function(item, k) {
        //After the form is rendered the .key turns into an array
        //therefor is the || item.key[0]
        if (item.key == keyName || item.key[0] == keyName) {
          if (byRef) {
            searchedItem = item;
          } else {
            searchedItem = angular.copy(item);
          }
        }
      });
    });

    return searchedItem;
  }

  function getValueOfTitleMap(formObj, name, value, keyInTitleMap, whole) {
    if (!keyInTitleMap) {
      keyInTitleMap = 'name';
    }

    var field = getFieldOfFormObj(formObj, name);

    if (field.titleMap) {
      for (var i = 0; i < field.titleMap.length; i++) {
        if (field.titleMap[i].value == value) {
          if (whole) {
            return field.titleMap[i];
          } else {
            return field.titleMap[i][keyInTitleMap];
          }
        }
      }
    }
  }

  /**
   * copyValues
   *
   * This is the callback function for our address search field
   *
   * @param addressDetails
   * @param copyKeyToField
   * @param formIdToCopyIn
   * @param formNameToCopyIn
   */
  function copyValues(
    addressDetails,
    copyKeyToField,
    formIdToCopyIn,
    formNameToCopyIn
  ) {
    var fCtrl = angular
      .element(document.querySelector(formIdToCopyIn))
      .controller();
    var formToCopyIn = fCtrl[formNameToCopyIn];

    if (
      angular.isObject(addressDetails) &&
      'address_components' in addressDetails
    ) {
      addressDetails.address_components.forEach(function(component) {
        component.types.forEach(function(componentValue) {
          for (var prop in copyKeyToField) {
            var formField = copyKeyToField[prop];
            if (componentValue == prop) {
              //copy value
              if (prop == 'country') {
                formToCopyIn[formField].$setViewValue(
                  component.short_name.toLowerCase()
                );
              } else {
                formToCopyIn[formField].$setViewValue(component.long_name);
              }
              formToCopyIn[formField].$render();
            }
          }
        });
      });
    }

    //focus fist empty field
    for (var formField in copyKeyToField) {
      if (!formToCopyIn[copyKeyToField[formField]].$modelValue) {
        var emptyField = document.getElementById(copyKeyToField[formField]);
        emptyField.focus();
      }
    }
  }

  function smsButtonClick(item, to, campaign_id, petition_campaign_id) {
    var defered = $q.defer();
    var disabledClass = ' disabled',
      data = {
        to: to
        //petition_campaign_id: petition_campaign_id
      };

    if (campaign_id) {
      data.campaign_id = campaign_id;
    } else if (petition_campaign_id) {
      data.petition_campaign_id = petition_campaign_id;
    }

    item.style += disabledClass;

    if (to && (petition_campaign_id || campaign_id)) {
      SmsResource.sms(data)
        .catch(function() {
          defered.reject();
        })
        .finally(function() {
          item.style = item.style.split(disabledClass).join('');
          defered.resolve();
        });
    } else {
      defered.reject();
    }

    return defered.promise;
  }

  function getPaymentDisclaimer(rawData, rawDonation, fieldName) {
    // fieldName can be disclaimer, print_summary_disclaimer or print_summary_signature_text
    var paymentMethods = getFieldOfFormObj(
      rawDonation.form_config.form,
      'payment_method',
      true
    );
    if (paymentMethods) {
      var chosenPaymentMethod = paymentMethods.titleMap.find(function(element) {
        return (
          rawData.payment_method === element.value &&
          (angular.isObject(element[fieldName]) ||
            angular.isString(element[fieldName]))
        );
      });
      if (
        chosenPaymentMethod &&
        fieldName in chosenPaymentMethod &&
        chosenPaymentMethod[fieldName]
      ) {
        // the disclaimer can be a string or an object with fields text, title (if it's a html field)
        if (angular.isString(chosenPaymentMethod[fieldName])) {
          return { text: chosenPaymentMethod[fieldName], title: null };
        } else {
          return chosenPaymentMethod[fieldName];
        }
      } else {
        return {
          text: null,
          title: null
        };
      }
    }
  }

  function calcYearlyDebitAmount(rawAmount, calculationBase) {
    return calculationBase == 'monthly' ? rawAmount * 12 : rawAmount;
  }

  function calcMonthlyDebitAmount(rawAmount, calculationBase) {
    return calculationBase == 'monthly' ? rawAmount : rawAmount / 12;
  }

  function calcIntervalDebitAmount(amount, interval, calcBase) {
    var monthlyValue;
    var debitIntervalValue;

    if (calcBase == 'yearly') {
      monthlyValue = amount / 12;
    } else if (calcBase == 'monthly') {
      monthlyValue = amount;
    }

    interval = parseInt(interval);

    switch (interval) {
      //monthly
      case 0:
      case 4:
        debitIntervalValue = monthlyValue;
        break;
      //quarterly
      case 1:
        debitIntervalValue = monthlyValue * 3;
        break;
      //biannual
      case 2:
        debitIntervalValue = monthlyValue * 6;
        break;
      //annual
      case 3:
        debitIntervalValue = monthlyValue * 12;
        break;
    }

    return debitIntervalValue;
  }

  /* "Best effort" to make a unique ID
  https://stackoverflow.com/a/2117523/544059
  - shortened to fit in an SMS */
  function uuidShort() {
    return 'xxxx'.replace(/[x]/g, function(c) {
      var r = (Math.random() * 16) | 0;
      return r.toString(16);
    });
  }

  /* generate a frontend / Formunauts unique ID
   - consisting of fundraiser ID, timestamp and a UUID */
  function generateFUID() {
    var userData = AuthenticationService.getCurrentUser();
    var userId = userData.id;
    var key = userId + '_' + Date.now() + '_' + uuidShort(); // e.g. "146_1588781348188_d4e4"
    var encodedKey = Base58.encodeText(key); // e.g. "EMZXDXh75DQSMhXgbnpiQniDHxTu4w"
    return encodedKey;
  }
}

angular
  .module('service.formHelper', [
    'service.bankAccountCheck',
    'service.commonNames'
  ])
  .factory('formHelperFactory', FormHelperFactory);

GeoLocationChannel.$inject = ['BaseChannel', 'GeoLocationChannelConstant'];
function GeoLocationChannel(BaseChannel, GeoLocationChannelConstant) {
  //setup and return service
  var goeLocationChannelService = {
    // positionUpdated
    pubPositionUpdated: pubPositionUpdated,
    subPositionUpdated: subPositionUpdated
  };

  return goeLocationChannelService;

  ////////////

  function pubPositionUpdated(args) {
    var args = args;

    BaseChannel.pubRootEmit(GeoLocationChannelConstant.positionUpdated, args);
  }

  function subPositionUpdated(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      GeoLocationChannelConstant.positionUpdated,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }
}

GeoLocationFactory.$inject = ['geoLocationChannel'];
function GeoLocationFactory(geoLocationChannel) {
  var options = {
      enableHighAccuracy: true
    },
    isImplemented = false,
    actualPosition = false;

  init();

  var cachingService = {
    getPosition: getPosition
  };
  return cachingService;

  /////////

  function init() {
    if (geoPosition.init()) {
      // Geolocation Initialisation
      isImplemented = true;
      geoPosition.getCurrentPosition(success_callback, error_callback, options);
    } else {
      // You cannot use Geolocation in this device
      actualPosition = undefined;
    }
  }

  function success_callback(p) {
    actualPosition = p;
    geoLocationChannel.pubPositionUpdated(p);
  }

  function error_callback(p) {}

  function getPosition() {
    if (isImplemented) {
      return actualPosition;
    }
    return false;
  }
}

angular
  .module('service.geoLocation', [])
  .constant('GeoLocationChannelConstant', {
    positionUpdated: 'positionUpdated'
  })
  .factory('geoLocationChannel', GeoLocationChannel)
  .factory('geoLocationFactory', GeoLocationFactory);

OfflineStoreChannel.$inject = ['BaseChannel', 'offlineStoreChannelConstant'];
function OfflineStoreChannel(BaseChannel, offlineStoreChannelConstant) {
  //setup and return service
  var authenticationChannelService = {
    pubOfflineDataChanged: pubOfflineDataChanged,
    subOfflineDataChanged: subOfflineDataChanged
  };

  return authenticationChannelService;

  ////////////

  function pubOfflineDataChanged(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      offlineStoreChannelConstant.offlineDataChanged,
      args
    );
  }

  function subOfflineDataChanged(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      offlineStoreChannelConstant.offlineDataChanged,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }
}

OfflineStore.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$localStorage',
  '$translate',
  'offlineStoreConstant',
  'offlineStoreChannel',
  'DonationsResource',
  'DonationsService',
  'PetitionsResource',
  'PetitionsService',
  'JobapplicationsResource',
  'RecruitingsService',
  'TimecaptureResource',
  'LocationsResource',
  'AuthenticationService',
  'AuthenticationChannel',
  '$uibModal',
  'IndexedDbService'
];
function OfflineStore(
  $filter,
  $q,
  $rootScope,
  $localStorage,
  $translate,
  offlineStoreConstant,
  offlineStoreChannel,
  DonationsResource,
  DonationsService,
  PetitionsResource,
  PetitionsService,
  JobapplicationsResource,
  RecruitingsService,
  TimecaptureResource,
  LocationsResource,
  AuthenticationService,
  AuthenticationChannel,
  $uibModal,
  IndexedDbService
) {
  var types = offlineStoreConstant.types,
    invalidType = 'invalidType',
    scope = $rootScope.$new();

  var OfflineStoreService = {
    getTypes: getTypes,
    queryOfflineData: queryOfflineData,
    getNumOfOfflineData: getNumOfOfflineData,
    getLastKeyOfUserByType: getLastKeyOfUserByType,
    getEntryByKey: getEntryByKey,
    persistFromDataToOfflineCache: persistFromDataToOfflineCache,
    persistOneFromOfflineCacheToServer: persistOneFromOfflineCacheToServer,
    updateDataInOfflineCache: updateDataInOfflineCache,
    persistAllFromOfflineCacheToServer: persistAllFromOfflineCacheToServer,
    savePersistFormData: savePersistFormData,
    deleteFromOffline: deleteFromOffline,
    savePendingFormData: savePendingFormData,
    deletePendingFormData: deletePendingFormData,
    pendingFormDataPresent: pendingFormDataPresent,
    getPendingFormData: getPendingFormData
  };

  return OfflineStoreService;

  ////////////

  /**
   *
   * getTypes
   *
   * @returns {Array} array of types
   */
  function getTypes() {
    return angular.copy(types);
  }

  /**
   * write data to local storage (overwriting anything under the pendingData key)
   * @param  {object} data filled-out form data
   */
  function savePendingFormData(data) {
    $localStorage[offlineStoreConstant.pendingData] = angular.copy(data);
  }

  function pendingFormDataPresent() {
    if (!angular.isObject($localStorage[offlineStoreConstant.pendingData])) {
      return false;
    }

    for (var prop in $localStorage[offlineStoreConstant.pendingData]) {
      if ($localStorage[offlineStoreConstant.pendingData].hasOwnProperty(prop))
        return true;
    }

    return JSON.stringify($localStorage[offlineStoreConstant.pendingData]) ===
      JSON.stringify({})
      ? false
      : true;
  }
  /**
   * tries to get pending form data stored in local storage
   * @return {object} object containing the pending form data or undefined if there isn't any
   */
  function getPendingFormData() {
    return $localStorage[offlineStoreConstant.pendingData];
  }

  function deletePendingFormData() {
    delete $localStorage[offlineStoreConstant.pendingData];
  }

  function getLastKeyOfUserByType(type) {
    var lastKey = false;

    if ($.inArray(type, types) != -1) {
      if (angular.isObject($localStorage[offlineStoreConstant.formData])) {
        angular.forEach($localStorage[offlineStoreConstant.formData], function(
          formData,
          key
        ) {
          if (key.indexOf(type) != -1) {
            var userData = AuthenticationService.getCurrentUser(),
              currentUserID = userData.id,
              keyArray = key.split('_'),
              fundraiserKey = keyArray[0];

            if (parseInt(fundraiserKey) == parseInt(currentUserID)) {
              lastKey = key;
            }
          }
        });
      }
    }

    return lastKey;
  }

  function getEntryByKey(key) {
    var entry = false;

    if (key in $localStorage[offlineStoreConstant.formData]) {
      entry = $localStorage[offlineStoreConstant.formData][key];
    }

    return entry;
  }

  /**
   * persistAllFromOfflineCacheToServer
   *
   * this function loops over all formdata in local storage and trys to upload one by one to the server
   * If the upload fails it keeps the data in local storage and notifies the user to try again later.
   **/
  function persistAllFromOfflineCacheToServer() {
    angular.forEach($localStorage[offlineStoreConstant.formData], function(
      formData,
      key
    ) {
      //upload onle timeentries that are finished
      if (key.indexOf(types[3]) != -1) {
        var data = getEntryByKey(key);

        if (data.isFinished == true) {
          persistOneFromOfflineCacheToServer(key);
        }
      } else {
        persistOneFromOfflineCacheToServer(key);
      }
    });
  }

  /**
   * savePersistFormData
   *
   * first store data in offline cache then try to upload to server
   *
   * @param preparedFormData
   */
  function savePersistFormData(preparedFormData, type) {
    var userData = AuthenticationService.getCurrentUser();
    var activeUser = AuthenticationService.getActiveUser();
    var uploaderId;

    if (angular.isObject(activeUser) && 'id' in activeUser) {
      uploaderId = activeUser.id;
    } else {
      uploaderId = userData.id;
    }
    //recruiting
    if (types[2] == type) {
      preparedFormData.job_scout = uploaderId;
    } else {
      preparedFormData.fundraiser = uploaderId;
    }

    var persistOfflineResult = persistFromDataToOfflineCache(
      preparedFormData,
      type
    );
    return persistOfflineResult.promise.then(function(key) {
      return persistOneFromOfflineCacheToServer(key);
    });
  }

  /**
   * Queries all offline stored data with the given predicate.
   *
   * @param {(entry: object) => boolean} predicate A predicate function
   * @param {number[]} [typesFilter] The indices of the types from getTypes that should be included
   *
   * @returns {object[]}
   * An array of entries that match the given predicate.
   */
  function queryOfflineData(predicate, typesFilter) {
    if (
      !(offlineStoreConstant.formData in $localStorage) ||
      !angular.isObject($localStorage[offlineStoreConstant.formData])
    ) {
      return [];
    }

    var result = [];

    for (var key in $localStorage[offlineStoreConstant.formData]) {
      // Filter for types, if typesFilter was passed
      if (typesFilter) {
        var found = false;
        for (var i = 0; i < typesFilter.length; ++i) {
          if (key.indexOf(types[typesFilter[i]]) != -1) {
            found = true;
          }
        }

        // This type should not be included in the result
        if (!found) {
          continue;
        }
      }

      // Get the data for the key
      var entry = getEntryByKey(key);

      // Skip timetracking events that aren't finished yet
      if (key.indexOf(types[3]) != -1 && entry.isFinished != true) {
        continue;
      }

      if (predicate(entry)) {
        // Push the entry to the result set, if predicate matches
        result.push(entry);
      }
    }

    return result;
  }

  /**
   * getNumOfOfflineData
   *
   * returns the number of formdata in offline store
   *
   * @returns {number}
   */
  function getNumOfOfflineData(includePending) {
    var num = 0;

    if (offlineStoreConstant.formData in $localStorage) {
      if (angular.isObject($localStorage[offlineStoreConstant.formData])) {
        if (includePending) {
          num = Object.keys($localStorage[offlineStoreConstant.formData])
            .length;
        } else {
          for (var key in $localStorage[offlineStoreConstant.formData]) {
            //treat timetracking entries
            if (key.indexOf(types[3]) != -1) {
              var data = getEntryByKey(key);

              if (data.isFinished == true) {
                num++;
              }
            } else {
              num++;
            }
          }
        }
      }
    } else {
      //@TODO move this into init function. also line in persistFromDataToOfflineCache
      $localStorage[offlineStoreConstant.formData] = {};
    }

    return num;
  }

  /**
   *
   * @param {string} key The key of the offline stored dataset
   *
   * @returns {Promise<object>}
   * A promise that is resolved with the response from the raw API request.
   */
  function deleteFromOffline(key) {
    var fuid = '';
    if (key in $localStorage[offlineStoreConstant.formData]) {
      fuid = $localStorage[offlineStoreConstant.formData][key].fuid;
    }
    var promises = [
      IndexedDbService.add('logs', {
        key: key,
        fuid: fuid,
        type: 'delete_donation',
        timestamp: Date.now()
      })
    ];

    temporarilyStoreDeletedOffline(key);
    promises.push(pushDeletedToRawAPI(key));
    if (key in $localStorage[offlineStoreConstant.formData]) {
      delete $localStorage[offlineStoreConstant.formData][key];
      offlineStoreChannel.pubOfflineDataChanged(true);
    }

    return resolveAllPromises(promises).then(function(results) {
      // Resolve with the result from pushDeletedToRawAPI
      return results[1];
    });
  }

  /**
   * for diagnostics reasons we want to temporarily store items that are to be deleted
   * in a first-in-first-out queue data structure
   */
  function temporarilyStoreDeletedOffline(key) {
    var maxStoredOffline = 20;
    if (!(offlineStoreConstant.deletedFormData in $localStorage)) {
      $localStorage[offlineStoreConstant.deletedFormData] = [];
    }
    $localStorage[offlineStoreConstant.deletedFormData].push(
      $localStorage[offlineStoreConstant.formData][key]
    );
    // delete first element as long as the queue is too long
    while (
      $localStorage[offlineStoreConstant.deletedFormData].length >
      maxStoredOffline
    ) {
      $localStorage[offlineStoreConstant.deletedFormData].shift();
    }
  }

  /**
   * for diagnostics reasons we want to push items that are to be deleted
   * to an API endpoint that doesn't validate the data format
   */
  function pushDeletedToRawAPI(key) {
    var data = $localStorage[offlineStoreConstant.formData][key];

    return DonationsResource.createRaw(data, false)
      .then(function() {
        console.log('successfully uploaded to the raw API');
      })
      .catch(function(error) {
        var status = 'status' in error ? error.status : null;
        console.error('error uploading to raw API. Status: ', status);
      });
  }

  /**
   * @param {*} preparedFormData The prepared data
   * @param {string} type A type from the array returned by `getTypes`
   *
   * @returns {{key: string, promise: Promise<string>}}
   * An object with the key with which the data was stored locally
   * and a promise that resolves with the key once all operations inside are
   * finished.
   */
  function persistFromDataToOfflineCache(preparedFormData, type) {
    var key = undefined;

    var userData = AuthenticationService.getCurrentUser();
    var currentUserID = userData.id;

    if (!(offlineStoreConstant.formData in $localStorage)) {
      $localStorage[offlineStoreConstant.formData] = {};
    }

    preparedFormData = prepareFormDataForUpload(preparedFormData);

    if ($.inArray(type, types) != -1) {
      key = currentUserID + '_' + type + '__' + Date.now();
    } else {
      //@TODO rethink this edge case
      key = currentUserID + '_' + invalidType + '__' + Date.now();
    }

    // Prepare promises that should be resolved
    var promises = [
      IndexedDbService.add('logs', {
        key: key,
        fuid: preparedFormData.fuid || '',
        type: 'stored_offline',
        timestamp: Date.now()
      })
    ];

    preparedFormData.versionNumber = baseconfig.version;

    $localStorage[offlineStoreConstant.formData][key] = preparedFormData;

    offlineStoreChannel.pubOfflineDataChanged(key);

    return {
      key: key,
      promise: resolveAllPromises(promises).then(function() {
        return key;
      })
    };

    ///////

    function prepareFormDataForUpload(formData) {
      var preparedData = angular.copy(formData);

      preparedData.createtime = $filter('date')(
        Date.now(),
        'yyyy-MM-dd HH:mm:ss.sss'
      );

      return preparedData;
    }
  }

  function updateDataInOfflineCache(key, data) {
    IndexedDbService.add('logs', {
      key: key,
      type: 'update_donation',
      timestamp: Date.now()
    });

    if (angular.isObject($localStorage[offlineStoreConstant.formData][key])) {
      $localStorage[offlineStoreConstant.formData][key] = data;
      offlineStoreChannel.pubOfflineDataChanged(key);
      return true;
    }

    return false;
  }

  function getCampaignDataByKey(key) {
    var currentUser = AuthenticationService.getCurrentUser(),
      type = getTypeByKey(key),
      currentFromData = $localStorage[offlineStoreConstant.formData][key],
      campaign = false;

    //'donation'
    if (type == types[0]) {
      campaign = DonationsService.getDonation(
        currentFromData.campaign,
        currentFromData.languageWhileCollection
      );
    } else if (type == types[1]) {
      //'petition'
      campaign = PetitionsService.getPetition(
        currentFromData.campaign,
        currentFromData.languageWhileCollection
      );
    } else if (type == types[2]) {
      //'recruiting'
      campaign = RecruitingsService.getRecruiting(
        currentFromData.campaign,
        currentFromData.languageWhileCollection
      );
    }

    return campaign;
  }

  function getModalResolveData(key, type) {
    var actualCampaign = getCampaignDataByKey(key);

    var modalResolveData = {
      title: function() {
        var title = $translate.instant('Upload successful!');
        if (
          angular.isObject(actualCampaign) &&
          'upload_modal_config' in actualCampaign &&
          'success_title' in actualCampaign.upload_modal_config &&
          actualCampaign.upload_modal_config.success_title !== null
        ) {
          title = actualCampaign.upload_modal_config.success_title;
        }
        return title;
      },
      text: function() {
        var text = $translate.instant('Data uploaded correctly!');
        if (
          angular.isObject(actualCampaign) &&
          'upload_modal_config' in actualCampaign &&
          'success_text' in actualCampaign.upload_modal_config &&
          actualCampaign.upload_modal_config.success_text !== null
        ) {
          text = actualCampaign.upload_modal_config.success_text;
        }
        return text;
      },
      image: function() {
        var imgUrl = false;
        if (
          angular.isObject(actualCampaign) &&
          'upload_modal_config' in actualCampaign &&
          'success_image' in actualCampaign.upload_modal_config &&
          actualCampaign.upload_modal_config.success_image !== null
        ) {
          imgUrl = actualCampaign.upload_modal_config.success_image;
        }
        return imgUrl;
      },
      hint: function() {
        return '';
      }
    };

    return modalResolveData;
  }

  /**
   * Tries uploading an offline stored dataset with the given
   * `key` and shows a modal with the final state of this process.
   *
   * @param {string} key The key of the offline stored dataset
   *
   * @returns {Promise<{ response: any, modal: { closed: Promise, result: Promise } }>}
   * A promise that is resolved with the result of the upload request
   * and with the instance of the modal.
   */
  function persistOneFromOfflineCacheToServer(key) {
    var currentFromData = $localStorage[offlineStoreConstant.formData][key],
      uploadFail = false,
      status = 0,
      type = getTypeByKey(key);

    var currentUser = AuthenticationService.getCurrentUser(),
      modalResolveData = getModalResolveData(key, type);

    return uploadByType(key, currentFromData)
      .then(function(result) {
        /**
         * @type {Promise[]}
         */
        var promises = [
          IndexedDbService.add('logs', {
            key: key,
            fuid: currentFromData.fuid || '',
            type: 'uploaded_donation',
            timestamp: Date.now()
          }),
          deleteFromOffline(key)
        ];

        if (type === types[0]) {
          modalResolveData.hint = function() {
            if (result.data.external_id) {
              return $translate.instant(
                '{{externalId}}, Name: {{firstName}} {{lastName}}',
                {
                  externalId: result.data.external_id,
                  firstName: result.data.first_name,
                  lastName: result.data.last_name
                }
              );
            } else {
              return $translate.instant(
                'Unfinished Donation, Name: {{firstName}} {{lastName}}',
                {
                  firstName: result.data.first_name,
                  lastName: result.data.last_name
                }
              );
            }
          };
        }

        // Wait for all promises being resolved and finally resolve with the original result
        return resolveAllPromises(promises).then(function() {
          return result;
        });
      })
      .catch(function(error) {
        /**
         * @type {Promise[]}
         */
        var promises = [];
        var status = 'status' in error ? error.status : null;

        // Set defaults
        modalResolveData.title = function() {
          return $translate.instant('Upload failed!');
        };
        modalResolveData.text = function() {
          return $translate.instant(
            'Could not establish secure connection! The mandate is stored offline. Please try again later.'
          );
        };
        modalResolveData.hint = function() {
          return '';
        };

        // Handle known status codes
        if (status == 409) {
          // For duplicates, we delete the offline datasets.
          promises.push(deleteFromOffline(key));

          modalResolveData.title = function() {
            return $translate.instant('Duplicated dataset!');
          };
          modalResolveData.text = function() {
            return $translate.instant(
              'The mandate was already uploaded. It was removed from the offline storage.'
            );
          };

          if (types[3] === type) {
            modalResolveData.text = function() {
              return $translate.instant(
                'You already have submitted your time tracking for today'
              );
            };
          }
        } else if (status == 400) {
          modalResolveData.text = function() {
            return $translate.instant(
              'The mandate could not be uploaded. Please contact support.'
            );
          };
        } else if (status >= 500 && status < 600) {
          modalResolveData.title = function() {
            return $translate.instant('Server Error!');
          };
        }

        // Wait for all promises being resolved and finally resolve with the original error
        return resolveAllPromises(promises).then(function() {
          return error;
        });
      })
      .then(function(result) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl:
            'app/commons/modals/uploadSuccess/uploadSuccess.view.html',
          controller: 'UploadSuccessController as uploadModal',
          size: 6,
          backdrop: 'static', // clicking on the dark background doesn't close the modal
          openedClass: 'modal-open modal-upload-message',
          resolve: modalResolveData
        });

        return {
          modal: modalInstance,
          response: result
        };
      });

    ///////////////////////////
    // warning: for some reason the next 3 functions are declared within the
    // persistOneFromOfflineCacheToServer function - it's not an indentation mistake
    ///////////////////////////

    function uploadByType(key, data) {
      var defered = $q.defer(),
        type = getTypeByKey(key);
      switch (type) {
        //donations
        case types[0]:
          // when the donation in localStorage was created in the Next frontend
          // we need to upload it to a Next endpoint in the new data format
          DonationsResource.create(
            data,
            data.versionNumber && data.versionNumber.startsWith('next')
          )
            .then(function(s) {
              defered.resolve(s);
            })
            .catch(function(e) {
              defered.reject(e);
            });
          break;
        //petitions
        case types[1]:
          PetitionsResource.create(data)
            .then(function(s) {
              defered.resolve(s);
            })
            .catch(function(e) {
              defered.reject(e);
            });
          break;
        //jobapplication
        case types[2]:
          JobapplicationsResource.create(data)
            .then(function(s) {
              defered.resolve(s);
            })
            .catch(function(e) {
              defered.reject(e);
            });
          break;
        //timecapture
        case types[3]:
          data.timeData = prepareTimes(data.timeData);

          TimecaptureResource.create(data)
            .then(function(s) {
              defered.resolve(s);
            })
            .catch(function(e) {
              defered.reject(e);
            });
          break;
        case types[4]:
          LocationsResource.create(data)
            .then(function(s) {
              defered.resolve(s);
            })
            .catch(function(e) {
              defered.reject(e);
            });
          break;
        //invalidType
        default:
          defered.reject(new Error('unknown type'));
          break;
      }

      return defered.promise;
      ////
    }

    function prepareTimes(data) {
      var times = angular.copy(data);
      for (var i = 0; i < times.length; i++) {
        times[i].start = formatDateTime(new Date(times[i].start));
        times[i].end = formatDateTime(new Date(times[i].end));
      }
      return times;
    }

    function formatDateTime(date) {
      var result = moment(date).format();
      return result;
    }
  }

  /**
   * Makes sure that all given promises are resolved, even if any of the promises was rejected.
   *
   * @param {Promise[]} promises An array of promises
   *
   * @returns {Promise<any[]>}
   * A promise that is resolved with an array of the inner promise results
   * once all passed promises are resolved.
   */
  function resolveAllPromises(promises) {
    return $q.all(
      promises.map(function(promise) {
        return promise.catch(function(r) {
          return r;
        });
      })
    );
  }

  function getTypeByKey(key) {
    var type = false;

    for (var i = 0; i < types.length; i++) {
      if (key.indexOf(types[i]) != -1) {
        type = types[i];
      }
    }

    return type ? type : invalidType;
  }
}

offlineStoreButton.$inject = ['offlineStore', 'offlineStoreChannel'];
function offlineStoreButton(offlineStore, offlineStoreChannel) {
  var offlineStoreButtonTemplate =
    '<button ng-if="offlineBtn.num > 0" class="logout btn btn-primary" ng-click="offlineBtn.uploadForms()">' +
    '<span ng-if="offlineBtn.num == 1">{{offlineBtn.num}} {{"item saved offline - Tap to upload" | translate}}</span>' +
    '<span ng-if="offlineBtn.num > 1">{{offlineBtn.num}} {{"items saved offline - Tap to upload" | translate}}</span>' +
    '</button>';

  return {
    // restrict to an element type.
    restrict: 'E',
    replace: true,
    template: offlineStoreButtonTemplate,
    link: function(scope, element, attrs) {
      scope.offlineBtn = {};
      scope.offlineBtn.uploadForms = uploadForms;
      scope.offlineBtn.num = 0;

      init();
      ////////////

      function init() {
        updateNumberOfOfflineData();
        offlineStoreChannel.subOfflineDataChanged(
          scope,
          updateNumberOfOfflineData
        );
      }

      function uploadForms() {
        offlineStore.persistAllFromOfflineCacheToServer();
      }

      function updateNumberOfOfflineData() {
        scope.offlineBtn.num = offlineStore.getNumOfOfflineData();
      }
    }
  };
}

angular
  .module('service.offlineStore', [, 'uploadSuccess'])
  .constant('offlineStoreChannelConstant', {
    offlineDataChanged: 'event:offlineStore-offlineDataChanged'
  })
  .constant('offlineStoreConstant', {
    pendingData: 'pendingData',
    formData: 'formData',
    deletedFormData: 'deletedFormData',
    types: [
      'donation',
      'petition',
      'recruiting',
      'timecapture',
      'locationselect'
    ]
  })
  .factory('offlineStoreChannel', OfflineStoreChannel)
  .factory('offlineStore', OfflineStore)
  .directive('offlineStoreButton', offlineStoreButton);

/**
 * @typedef {object} IndexedDbServiceConfig
 * Describes the configuration for an instance of `IndexedDBService`
 *
 * @property {string} name
 * The name of the IndexedDB to open
 *
 * @property {number} version
 * The version of the IndexedDB to open
 *
 * @property {Object<string, ?string>} stores
 * The stores for this IndexedDB, where the property key represents the name of the store
 * and the property value represents the keyPath for the store. If the property value is
 * `null`, the keyPath will default to `'id'` and will autoincrement.
 */

IndexedDbService.$inject = ['$q', 'indexedDBConfig'];

function IndexedDbService(
  $q,
  /**
   * @type {IndexedDbServiceConfig}
   */
  indexedDBConfig
) {
  /**
   * @type {IDBDatabase}
   */
  var _indexedDbConnection;

  var service = {
    add: addEntry,
    list: listEntries,
    query: queryEntries,
    delete: deleteEntry
    // clear: clearEntries
  };

  return service;

  function addEntry(store, object) {
    return _getIndexedDbConnection().then(function(connection) {
      var deferred = $q.defer();
      var request = openStore(connection, store).add(object);

      request.onsuccess = function(event) {
        deferred.resolve(event.target.result);
      };

      return deferred.promise;
    });
  }

  /**
   * @param {string} store The name of the store
   *
   * @returns {Promise<any[]>}
   * A promise that resolves with all entries in the given store.
   */
  function listEntries(store) {
    return queryEntries(store, function() {
      return true;
    });
  }

  /**
   * @param {string} store The name of the store
   * @param {(entry: any) => boolean} predicate
   * Function is a predicate, to test each entry.
   * Return true to keep the entry, false otherwise.
   *
   * @returns {Promise<any[]>}
   * A promise that resolves with the entries matching the given
   * predicate.
   */
  function queryEntries(store, predicate) {
    return _getIndexedDbConnection().then(function(connection) {
      var deferred = $q.defer();
      var objects = [];
      var request = openStore(connection, store).openCursor();

      request.onsuccess = function(event) {
        var result = event.target.result;

        if (result) {
          var value = result.value;
          if (predicate(value)) {
            // Add to result, if predicate is true
            objects.push(value);
          }

          result.continue();
        } else {
          deferred.resolve(objects);
        }
      };

      return deferred.promise;
    });
  }

  /**
   * Deletes the entries with the given `key`(s) from the given `store`.
   *
   * @param {string} store The name of the store to delete from
   * @param {any | any[]} key The key or keys of the entries to delete
   *
   * @returns {Promise}
   * A promise that resolves when the data was successfully delete or
   * if an empty array was passed.
   */
  function deleteEntry(store, key) {
    var keys = Array.isArray(key) ? key : [key];

    // If there was no data passed to delete, return a resolved promise
    if (keys.length === 0) {
      return $q.resolve();
    }

    return _getIndexedDbConnection().then(function(connection) {
      var promises = keys.map(function(k) {
        console.log('Deleting', k);

        var deferred = $q.defer();
        var request = openStore(connection, store).delete(k);
        request.onsuccess = function() {
          deferred.resolve();
        };

        request.onerror = function() {
          deferred.reject();
        };

        return deferred.promise;
      });

      return $q.all(promises);
    });
  }

  /**
   * @param {IDBDatabase} connection The IndexedDB connection
   * @param {string} store The name of the store to open
   *
   * @returns {IDBObjectStore}
   */
  function openStore(connection, store) {
    return connection.transaction([store], 'readwrite').objectStore(store);
  }

  /**
   * @returns {Promise<IDBDatabase>}
   * A promise that resolves with the IndexedDB connection
   */
  function _getIndexedDbConnection() {
    var deferred = $q.defer();

    if (_indexedDbConnection) {
      deferred.resolve(_indexedDbConnection);
      return deferred.promise;
    }

    var db = window.indexedDB.open(
      indexedDBConfig.name,
      indexedDBConfig.version
    );

    db.onupgradeneeded = function(event) {
      var connection = event.target.result;

      Object.keys(indexedDBConfig.stores).forEach(function(store) {
        if (connection.objectStoreNames.contains(store)) {
          connection.deleteObjectStore(store);
        }

        connection.createObjectStore(store, {
          keyPath: indexedDBConfig.stores[store] || 'id',
          autoIncrement: !indexedDBConfig.stores[store]
        });
      });
    };

    db.onsuccess = function(event) {
      _indexedDbConnection = event.target.result;
      deferred.resolve(_indexedDbConnection);
    };

    return deferred.promise;
  }
}

angular
  .module('service.indexeddb', [])
  .factory('IndexedDbService', IndexedDbService);

NotificationsChannel.$inject = ['BaseChannel', 'notificationsChannelConstant'];
function NotificationsChannel(BaseChannel, notificationsChannelConstant) {
  //setup and return service
  var authenticationChannelService = {
    pubToastsChanged: pubToastsChanged,
    subToastsChanged: subToastsChanged
  };

  return authenticationChannelService;

  ////////////

  function pubToastsChanged(args) {
    var args = args;

    BaseChannel.pubRootEmit(notificationsChannelConstant.toastsChanged, args);
  }

  function subToastsChanged(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      notificationsChannelConstant.toastsChanged,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }
}

/**
 * @typedef {object} ToastOptions
 *
 * @property {string} text
 * @property {string} title
 * @property {number} duration
 * @property {boolean} dismissable
 *
 * @property {object} button
 * @property {string} button.action
 * @property {string} button.label
 * @property {boolean} button.close
 *
 * @property {object} events
 * @property {(reason: string) => void} events.close
 */

NotificationsService.$inject = ['notificationsChannel'];
function NotificationsService(notificationsChannel) {
  //setup and return service
  var service = {
    hideToast: hideToast,
    showToast: showToast
  };

  var latestToast = undefined;

  return service;

  /**
   *
   * @param {ToastOptions} options
   */
  function showToast(options) {
    latestToast = options;
    notificationsChannel.pubToastsChanged(options);
  }

  function hideToast() {
    if (latestToast !== undefined) {
      latestToast = undefined;
      notificationsChannel.pubToastsChanged(undefined);
    }
  }
}

angular
  .module('service.notifications', [, 'uploadSuccess'])
  .constant('notificationsChannelConstant', {
    toastsChanged: 'event:notifications-toastsChanged'
  })
  .factory('notificationsChannel', NotificationsChannel)
  .factory('NotificationsService', NotificationsService);

function CommonNames() {
  var firstnames = [
    { id: '1', text: 'Aaliyah Fabienne', gender: 'f' },
    { id: '2', text: 'Aaro Enrico Elias', gender: 'm' },
    { id: '3', text: 'Aaron', gender: 'm' },
    { id: '4', text: 'Aaron Bryan', gender: 'm' },
    { id: '5', text: 'Aaron-Noel', gender: 'm' },
    { id: '6', text: 'Abbas', gender: 'm' },
    { id: '7', text: 'Abby Lee', gender: 'f' },
    { id: '8', text: 'Abdul', gender: 'm' },
    { id: '9', text: 'Abdullah', gender: 'm' },
    { id: '10', text: 'Abigail', gender: 'f' },
    { id: '11', text: 'Abigail Sofie', gender: 'f' },
    { id: '12', text: 'Abraham', gender: 'm' },
    { id: '13', text: 'Abram', gender: 'm' },
    { id: '14', text: 'Aceyla', gender: 'f' },
    { id: '15', text: 'Achim', gender: 'm' },
    { id: '16', text: 'Ada', gender: 'm' },
    { id: '17', text: 'Ada', gender: 'f' },
    { id: '18', text: 'Adalbert', gender: 'm' },
    { id: '19', text: 'Adam', gender: 'm' },
    { id: '20', text: 'Adam', gender: 'm' },
    { id: '21', text: 'Adelbert', gender: 'm' },
    { id: '22', text: 'Adele', gender: 'f' },
    { id: '23', text: 'Adelgunde', gender: 'f' },
    { id: '24', text: 'Adelheid', gender: 'f' },
    { id: '25', text: 'Adelinde', gender: 'f' },
    { id: '26', text: 'Adeline', gender: 'f' },
    { id: '27', text: 'Adem', gender: 'm' },
    { id: '28', text: 'Adina', gender: 'f' },
    { id: '29', text: 'Adina', gender: 'f' },
    { id: '30', text: 'Adolf', gender: 'm' },
    { id: '31', text: 'Adolfine', gender: 'f' },
    { id: '32', text: 'Adrian', gender: 'm' },
    { id: '33', text: 'Adrian Maurice', gender: 'm' },
    { id: '34', text: 'Adrián/ Adrian', gender: 'm' },
    { id: '35', text: 'Adriana', gender: 'f' },
    { id: '36', text: 'Adriana', gender: 'f' },
    { id: '37', text: 'Adriane', gender: 'f' },
    { id: '38', text: 'Adriane', gender: 'f' },
    { id: '39', text: 'Adriano', gender: 'm' },
    { id: '40', text: 'Adrienne', gender: 'f' },
    { id: '41', text: 'Aenne', gender: 'f' },
    { id: '42', text: 'Agata', gender: 'f' },
    { id: '43', text: 'Agatha', gender: 'f' },
    { id: '44', text: 'Agathe', gender: 'f' },
    { id: '45', text: 'Agnes', gender: 'f' },
    { id: '46', text: 'Agnesa', gender: 'f' },
    { id: '47', text: 'Agnieszka', gender: 'f' },
    { id: '48', text: 'Ahley', gender: 'f' },
    { id: '49', text: 'Ahmad', gender: 'm' },
    { id: '50', text: 'Ahmed', gender: 'm' },
    { id: '51', text: 'Ahmet', gender: 'm' },
    { id: '52', text: 'Aidan', gender: 'm' },
    { id: '53', text: 'Aileen Elisabeth', gender: 'f' },
    { id: '54', text: 'Ainoa', gender: 'f' },
    { id: '55', text: 'Aisha Elisabetta', gender: 'f' },
    { id: '56', text: 'Akulina', gender: 'f' },
    { id: '57', text: 'Alain', gender: 'm' },
    { id: '58', text: 'Alan', gender: 'm' },
    { id: '59', text: 'Alba', gender: 'f' },
    { id: '60', text: 'Alban', gender: 'm' },
    { id: '61', text: 'Albert', gender: 'm' },
    { id: '62', text: 'Albertine', gender: 'f' },
    { id: '63', text: 'Alberto', gender: 'm' },
    { id: '64', text: 'Albin', gender: 'm' },
    { id: '65', text: 'Albina', gender: 'f' },
    { id: '66', text: 'Albrecht', gender: 'm' },
    { id: '67', text: 'Aldo', gender: 'm' },
    { id: '68', text: 'Alea', gender: 'f' },
    { id: '69', text: 'Aleksandar', gender: 'm' },
    { id: '70', text: 'Aleksander', gender: 'm' },
    { id: '71', text: 'Aleksandr', gender: 'm' },
    { id: '72', text: 'Aleksandra', gender: 'f' },
    { id: '73', text: 'Aleksej', gender: 'm' },
    { id: '74', text: 'Alen', gender: 'm' },
    { id: '75', text: 'Alena', gender: 'f' },
    { id: '76', text: 'Alessandra Silvia', gender: 'f' },
    { id: '77', text: 'Alessandro', gender: 'm' },
    { id: '78', text: 'Alessandro', gender: 'm' },
    { id: '79', text: 'Alessandro Luis', gender: 'm' },
    { id: '80', text: 'Alessia', gender: 'f' },
    { id: '81', text: 'Alessio', gender: 'm' },
    { id: '82', text: 'Alex', gender: 'm' },
    { id: '83', text: 'Alex', gender: 'f' },
    { id: '84', text: 'Alex', gender: 'm' },
    { id: '85', text: 'Alexa', gender: 'f' },
    { id: '86', text: 'Alexa-lee', gender: 'f' },
    { id: '87', text: 'Alexander', gender: 'm' },
    { id: '88', text: 'Alexander', gender: 'm' },
    { id: '89', text: 'Alexander Ben Luca', gender: 'm' },
    { id: '90', text: 'Alexander Maximilian', gender: 'm' },
    { id: '91', text: 'Alexandra', gender: 'f' },
    { id: '92', text: 'Alexandra', gender: 'f' },
    { id: '93', text: 'Alexandra Lea', gender: 'f' },
    { id: '94', text: 'Alexandra Sophia', gender: 'f' },
    { id: '95', text: 'Alexandre', gender: 'm' },
    { id: '96', text: 'Alexandros', gender: 'm' },
    { id: '97', text: 'Alexei', gender: 'm' },
    { id: '98', text: 'Alexej', gender: 'm' },
    { id: '99', text: 'Alexia', gender: 'f' },
    { id: '100', text: 'Alexis', gender: 'f' },
    { id: '101', text: 'Alexis', gender: 'm' },
    { id: '102', text: 'Alexis-Jossi', gender: 'f' },
    { id: '103', text: 'Alexsia', gender: 'f' },
    { id: '104', text: 'Alf', gender: 'm' },
    { id: '105', text: 'Alfons', gender: 'm' },
    { id: '106', text: 'Alfonso', gender: 'm' },
    { id: '107', text: 'Alfred', gender: 'm' },
    { id: '108', text: 'Alfredo', gender: 'm' },
    { id: '109', text: 'Ali', gender: 'm' },
    { id: '110', text: 'Ali', gender: 'm' },
    { id: '111', text: 'Alia', gender: 'f' },
    { id: '112', text: 'Alica', gender: 'f' },
    { id: '113', text: 'Alica-Kiara', gender: 'f' },
    { id: '114', text: 'Alice', gender: 'f' },
    { id: '115', text: 'Alicia', gender: 'f' },
    { id: '116', text: 'Alicia', gender: 'f' },
    { id: '117', text: 'Alicja', gender: 'f' },
    { id: '118', text: 'Alida', gender: 'f' },
    { id: '119', text: 'Alida Angelina', gender: 'f' },
    { id: '120', text: 'Alima', gender: 'f' },
    { id: '121', text: 'Alina', gender: 'f' },
    { id: '122', text: 'Alina', gender: 'f' },
    { id: '123', text: 'Alina Amalia', gender: 'f' },
    { id: '124', text: 'Aline', gender: 'f' },
    { id: '125', text: 'Aline', gender: 'f' },
    { id: '126', text: 'Alisa', gender: 'f' },
    { id: '127', text: 'Alisha', gender: 'f' },
    { id: '128', text: 'Alison', gender: 'f' },
    { id: '129', text: 'Aljosha', gender: 'm' },
    { id: '130', text: 'Alla', gender: 'f' },
    { id: '131', text: 'Allegra', gender: 'f' },
    { id: '132', text: 'Allegra Luna', gender: 'f' },
    { id: '133', text: 'Allison', gender: 'f' },
    { id: '134', text: 'Alma', gender: 'f' },
    { id: '135', text: 'Alma', gender: 'f' },
    { id: '136', text: 'Almut', gender: 'f' },
    { id: '137', text: 'Almuth', gender: 'f' },
    { id: '138', text: 'Alois', gender: 'm' },
    { id: '139', text: 'Aloisia', gender: 'f' },
    { id: '140', text: 'Aloys', gender: 'm' },
    { id: '141', text: 'Alva', gender: 'f' },
    { id: '142', text: 'Alvaro', gender: 'm' },
    { id: '143', text: 'Alvin', gender: 'm' },
    { id: '144', text: 'Alwin', gender: 'm' },
    { id: '145', text: 'Alwina', gender: 'f' },
    { id: '146', text: 'Alwine', gender: 'f' },
    { id: '147', text: 'Alysa', gender: 'f' },
    { id: '148', text: 'Alyshia Fabienne', gender: 'f' },
    { id: '149', text: 'Alyssa-Chiara', gender: 'f' },
    { id: '150', text: 'Amáli', gender: 'f' },
    { id: '151', text: 'Amalia', gender: 'f' },
    { id: '152', text: 'Amalia', gender: 'f' },
    { id: '153', text: 'Amalie', gender: 'f' },
    { id: '154', text: 'Amanda', gender: 'f' },
    { id: '155', text: 'Amanda', gender: 'f' },
    { id: '156', text: 'Amaro-Elias', gender: 'm' },
    { id: '157', text: 'Amber', gender: 'f' },
    { id: '158', text: 'Amelia Josina', gender: 'f' },
    { id: '159', text: 'Amelie', gender: 'f' },
    { id: '160', text: 'Amelie / Amálie', gender: 'f' },
    { id: '161', text: 'Amelie Claire', gender: 'f' },
    { id: '162', text: 'Amelie Mailin', gender: 'f' },
    { id: '163', text: 'Amely Luyanda', gender: 'f' },
    { id: '164', text: 'Ames', gender: 'm' },
    { id: '165', text: 'Amily', gender: 'f' },
    { id: '166', text: 'Amina Emilia', gender: 'f' },
    { id: '167', text: 'Amir', gender: 'm' },
    { id: '168', text: 'Amir', gender: 'm' },
    { id: '169', text: 'Amira', gender: 'f' },
    { id: '170', text: 'Amma-Grace', gender: 'f' },
    { id: '171', text: 'Ammar', gender: 'm' },
    { id: '172', text: 'Amy', gender: 'f' },
    { id: '173', text: 'Amy Jane', gender: 'f' },
    { id: '174', text: 'Amy Josephin', gender: 'f' },
    { id: '175', text: 'Amy Laurie', gender: 'f' },
    { id: '176', text: 'Amy Lee', gender: 'f' },
    { id: '177', text: 'Amy linn', gender: 'f' },
    { id: '178', text: 'Amy Lynn', gender: 'f' },
    { id: '179', text: 'Amy-Jane', gender: 'f' },
    { id: '180', text: 'Amy-Jane merle', gender: 'f' },
    { id: '181', text: 'Ana', gender: 'f' },
    { id: '182', text: 'Ana-Anouk', gender: 'f' },
    { id: '183', text: 'Anastasia', gender: 'f' },
    { id: '184', text: 'Anastasia', gender: 'f' },
    { id: '185', text: 'Anastasios', gender: 'm' },
    { id: '186', text: 'Anatol', gender: 'm' },
    { id: '187', text: 'Anatoli', gender: 'm' },
    { id: '188', text: 'Anatolij', gender: 'm' },
    { id: '189', text: 'Anders', gender: 'm' },
    { id: '190', text: 'Andre', gender: 'm' },
    { id: '191', text: 'Andre', gender: 'm' },
    { id: '192', text: 'André', gender: 'm' },
    { id: '193', text: 'Andrea', gender: 'f' },
    { id: '194', text: 'Andrea', gender: 'f' },
    { id: '195', text: 'Andreas', gender: 'm' },
    { id: '196', text: 'Andreas', gender: 'm' },
    { id: '197', text: 'Andree', gender: 'm' },
    { id: '198', text: 'Andrei', gender: 'm' },
    { id: '199', text: 'Andrej', gender: 'm' },
    { id: '200', text: 'Andres', gender: 'm' },
    { id: '201', text: 'Andres', gender: 'm' },
    { id: '202', text: 'Andrew', gender: 'm' },
    { id: '203', text: 'Andrey', gender: 'm' },
    { id: '204', text: 'Andrzej', gender: 'm' },
    { id: '205', text: 'Andy', gender: 'm' },
    { id: '206', text: 'Anelle', gender: 'm' },
    { id: '207', text: 'Aneta', gender: 'f' },
    { id: '208', text: 'Anett', gender: 'f' },
    { id: '209', text: 'Anette', gender: 'f' },
    { id: '210', text: 'Angel', gender: 'f' },
    { id: '211', text: 'Angela', gender: 'f' },
    { id: '212', text: 'Angela', gender: 'f' },
    { id: '213', text: 'Angeli', gender: 'f' },
    { id: '214', text: 'Angelica', gender: 'f' },
    { id: '215', text: 'Angelika', gender: 'f' },
    { id: '216', text: 'Angelina', gender: 'f' },
    { id: '217', text: 'Angelina', gender: 'f' },
    { id: '218', text: 'Angelina Michelle', gender: 'f' },
    { id: '219', text: 'Angelique', gender: 'f' },
    { id: '220', text: 'Angelique', gender: 'f' },
    { id: '221', text: 'Angelique Natasha', gender: 'f' },
    { id: '222', text: 'Angelo', gender: 'm' },
    { id: '223', text: 'Angelo', gender: 'm' },
    { id: '224', text: 'Angessa', gender: 'f' },
    { id: '225', text: 'Anica', gender: 'f' },
    { id: '226', text: 'Anika', gender: 'f' },
    { id: '227', text: 'Anique', gender: 'f' },
    { id: '228', text: 'Anita', gender: 'f' },
    { id: '229', text: 'Anita', gender: 'f' },
    { id: '230', text: 'Anja', gender: 'f' },
    { id: '231', text: 'Anja', gender: 'f' },
    { id: '232', text: 'Anja', gender: 'f' },
    { id: '233', text: 'Anjo', gender: 'm' },
    { id: '234', text: 'Anjuli', gender: 'f' },
    { id: '235', text: 'Anka', gender: 'f' },
    { id: '236', text: 'Anke', gender: 'f' },
    { id: '237', text: 'Ann', gender: 'f' },
    { id: '238', text: 'Ann', gender: 'f' },
    { id: '239', text: 'Ann Marie', gender: 'f' },
    { id: '240', text: 'Ann-Kathrin', gender: 'f' },
    { id: '241', text: 'Ann-Katrin', gender: 'f' },
    { id: '242', text: 'Anna', gender: 'f' },
    { id: '243', text: 'Anna', gender: 'f' },
    { id: '244', text: 'Anna - Lena', gender: 'f' },
    { id: '245', text: 'Anna Amalia', gender: 'f' },
    { id: '246', text: 'Anna Katharina', gender: 'f' },
    { id: '247', text: 'Anna Lisa', gender: 'f' },
    { id: '248', text: 'Anna Luisa', gender: 'f' },
    { id: '249', text: 'Anna Maria', gender: 'f' },
    { id: '250', text: 'Anna Paola', gender: 'f' },
    { id: '251', text: 'Anna-Carola', gender: 'f' },
    { id: '252', text: 'Anna-Ernestine', gender: 'f' },
    { id: '253', text: 'Anna-Lena', gender: 'f' },
    { id: '254', text: 'Anna-Lena', gender: 'f' },
    { id: '255', text: 'Anna-Luise', gender: 'f' },
    { id: '256', text: 'Anna-Maria', gender: 'f' },
    { id: '257', text: 'Anna-Marie', gender: 'f' },
    { id: '258', text: 'Anna-Sofie', gender: 'f' },
    { id: '259', text: 'Anna-Sophie', gender: 'f' },
    { id: '260', text: 'Annabell', gender: 'f' },
    { id: '261', text: 'Annabelle', gender: 'f' },
    { id: '262', text: 'Annalena', gender: 'f' },
    { id: '263', text: 'Annalena Tamara', gender: 'f' },
    { id: '264', text: 'Annaliese', gender: 'f' },
    { id: '265', text: 'Annamaria', gender: 'f' },
    { id: '266', text: 'Annamaria', gender: 'f' },
    { id: '267', text: 'Anne', gender: 'f' },
    { id: '268', text: 'Änne', gender: 'f' },
    { id: '269', text: 'Anne-Kathrin', gender: 'f' },
    { id: '270', text: 'Anne-Katrin', gender: 'f' },
    { id: '271', text: 'Anne-Marie', gender: 'f' },
    { id: '272', text: 'Anne-Rose', gender: 'f' },
    { id: '273', text: 'Annedore', gender: 'f' },
    { id: '274', text: 'Annegret', gender: 'f' },
    { id: '275', text: 'Annegrete', gender: 'f' },
    { id: '276', text: 'Annekatrin', gender: 'f' },
    { id: '277', text: 'Anneke', gender: 'f' },
    { id: '278', text: 'Annelene', gender: 'f' },
    { id: '279', text: 'Anneli', gender: 'f' },
    { id: '280', text: 'Annelie', gender: 'f' },
    { id: '281', text: 'Annelie / Anneli', gender: 'f' },
    { id: '282', text: 'Annelies', gender: 'f' },
    { id: '283', text: 'Anneliese', gender: 'f' },
    { id: '284', text: 'Annelise', gender: 'f' },
    { id: '285', text: 'Annelore', gender: 'f' },
    { id: '286', text: 'Annemarie', gender: 'f' },
    { id: '287', text: 'Annemie', gender: 'f' },
    { id: '288', text: 'Annerose', gender: 'f' },
    { id: '289', text: 'Annett', gender: 'f' },
    { id: '290', text: 'Annette', gender: 'f' },
    { id: '291', text: 'Anni', gender: 'f' },
    { id: '292', text: 'Anni', gender: 'f' },
    { id: '293', text: 'Annie', gender: 'f' },
    { id: '294', text: 'Annik', gender: 'f' },
    { id: '295', text: 'Annika', gender: 'f' },
    { id: '296', text: 'Annika', gender: 'f' },
    { id: '297', text: 'Annikan', gender: 'm' },
    { id: '298', text: 'Annissa Yara', gender: 'f' },
    { id: '299', text: 'Annita', gender: 'f' },
    { id: '300', text: 'Anny', gender: 'f' },
    { id: '301', text: 'Anouk', gender: 'f' },
    { id: '302', text: 'Ansa Taifun', gender: 'm' },
    { id: '303', text: 'Anselm', gender: 'm' },
    { id: '304', text: 'Ansgar', gender: 'm' },
    { id: '305', text: 'Ante', gender: 'm' },
    { id: '306', text: 'Anthony', gender: 'm' },
    { id: '307', text: 'Anthony', gender: 'm' },
    { id: '308', text: 'Antje', gender: 'f' },
    { id: '309', text: 'Anto', gender: 'm' },
    { id: '310', text: 'Antoinette', gender: 'f' },
    { id: '311', text: 'Anton', gender: 'm' },
    { id: '312', text: 'Anton', gender: 'm' },
    { id: '313', text: 'Antonia', gender: 'f' },
    { id: '314', text: 'Antonia', gender: 'f' },
    { id: '315', text: 'Antonie', gender: 'f' },
    { id: '316', text: 'Antonietta', gender: 'f' },
    { id: '317', text: 'Antonietta', gender: 'f' },
    { id: '318', text: 'Antonina', gender: 'f' },
    { id: '319', text: 'Antonino', gender: 'm' },
    { id: '320', text: 'Antonio', gender: 'm' },
    { id: '321', text: 'Antonio', gender: 'm' },
    { id: '322', text: 'Antonios', gender: 'm' },
    { id: '323', text: 'Antonius', gender: 'm' },
    { id: '324', text: 'Apollonia', gender: 'f' },
    { id: '325', text: 'Apostolos', gender: 'm' },
    { id: '326', text: 'Aramis', gender: 'm' },
    { id: '327', text: 'Arian', gender: 'm' },
    { id: '328', text: 'Ariana', gender: 'f' },
    { id: '329', text: 'Ariane', gender: 'f' },
    { id: '330', text: 'Aribert', gender: 'm' },
    { id: '331', text: 'Arif', gender: 'm' },
    { id: '332', text: 'Armando', gender: 'm' },
    { id: '333', text: 'Armin', gender: 'm' },
    { id: '334', text: 'Armin', gender: 'm' },
    { id: '335', text: 'Arnd', gender: 'm' },
    { id: '336', text: 'Arndt', gender: 'm' },
    { id: '337', text: 'Arne', gender: 'm' },
    { id: '338', text: 'Arnfried', gender: 'm' },
    { id: '339', text: 'Arnim', gender: 'm' },
    { id: '340', text: 'Arno', gender: 'm' },
    { id: '341', text: 'Arnold', gender: 'm' },
    { id: '342', text: 'Arnold', gender: 'm' },
    { id: '343', text: 'Arnulf', gender: 'm' },
    { id: '344', text: 'Aron Phillip', gender: 'm' },
    { id: '345', text: 'Aron-Daniel', gender: 'm' },
    { id: '346', text: 'Arthur', gender: 'm' },
    { id: '347', text: 'Artur', gender: 'm' },
    { id: '348', text: 'Artur', gender: 'm' },
    { id: '349', text: 'Arwen', gender: 'f' },
    { id: '350', text: 'Arzu', gender: 'f' },
    { id: '351', text: 'Asa', gender: 'f' },
    { id: '352', text: 'Aschley', gender: 'm' },
    { id: '353', text: 'Ashlee', gender: 'f' },
    { id: '354', text: 'Ashley', gender: 'f' },
    { id: '355', text: 'Ashley-Chiara', gender: 'f' },
    { id: '356', text: 'Ashley-Sophie', gender: 'f' },
    { id: '357', text: 'Asta', gender: 'f' },
    { id: '358', text: 'Astrid', gender: 'f' },
    { id: '359', text: 'Athanasios', gender: 'm' },
    { id: '360', text: 'Atlantis Oceana', gender: 'f' },
    { id: '361', text: 'Attila', gender: 'm' },
    { id: '362', text: 'Audrey', gender: 'f' },
    { id: '363', text: 'Audrey Charlize', gender: 'f' },
    { id: '364', text: 'August', gender: 'm' },
    { id: '365', text: 'Augusta', gender: 'f' },
    { id: '366', text: 'Auguste', gender: 'f' },
    { id: '367', text: 'Augustin', gender: 'm' },
    { id: '368', text: 'Aurelia', gender: 'f' },
    { id: '369', text: 'Aurelija', gender: 'f' },
    { id: '370', text: 'Aurelio', gender: 'm' },
    { id: '371', text: 'Aurian', gender: 'm' },
    { id: '372', text: 'Aurika', gender: 'f' },
    { id: '373', text: 'Aurora', gender: 'f' },
    { id: '374', text: 'Ava', gender: 'f' },
    { id: '375', text: 'Ava Eowyn', gender: 'f' },
    { id: '376', text: 'Ava Lianna', gender: 'f' },
    { id: '377', text: 'Ava Sofia', gender: 'f' },
    { id: '378', text: 'Axel', gender: 'm' },
    { id: '379', text: 'Axel', gender: 'm' },
    { id: '380', text: 'Ayleen', gender: 'f' },
    { id: '381', text: 'Aylin', gender: 'f' },
    { id: '382', text: 'Aymee´', gender: 'f' },
    { id: '383', text: 'Aynur', gender: 'f' },
    { id: '384', text: 'Ayse', gender: 'f' },
    { id: '385', text: 'Aysel', gender: 'f' },
    { id: '386', text: 'Ayten', gender: 'f' },
    { id: '387', text: 'Aziz', gender: 'm' },
    { id: '388', text: 'Azzurro', gender: 'm' },
    { id: '389', text: 'Babett', gender: 'f' },
    { id: '390', text: 'Babette', gender: 'f' },
    { id: '391', text: 'Baldur', gender: 'm' },
    { id: '392', text: 'Baldur', gender: 'm' },
    { id: '393', text: 'Balthasar', gender: 'm' },
    { id: '394', text: 'Baptist', gender: 'm' },
    { id: '395', text: 'Barbara', gender: 'f' },
    { id: '396', text: 'Barbara', gender: 'f' },
    { id: '397', text: 'Bärbel', gender: 'f' },
    { id: '398', text: 'Barnabas', gender: 'm' },
    { id: '399', text: 'Bartholomäus', gender: 'm' },
    { id: '400', text: 'Bastian', gender: 'm' },
    { id: '401', text: 'Bastian', gender: 'm' },
    { id: '402', text: 'Bastian Joel', gender: 'm' },
    { id: '403', text: 'Bayram', gender: 'm' },
    { id: '404', text: 'Beata', gender: 'f' },
    { id: '405', text: 'Beate', gender: 'f' },
    { id: '406', text: 'Beatrice', gender: 'f' },
    { id: '407', text: 'Beatrix', gender: 'f' },
    { id: '408', text: 'Beatrix', gender: 'f' },
    { id: '409', text: 'Bekir', gender: 'm' },
    { id: '410', text: 'Bela', gender: 'm' },
    { id: '411', text: 'Bela', gender: 'm' },
    { id: '412', text: 'Bela-David', gender: 'm' },
    { id: '413', text: 'Belinda', gender: 'f' },
    { id: '414', text: 'Belinda', gender: 'f' },
    { id: '415', text: 'Bella', gender: 'f' },
    { id: '416', text: 'Bella Luna', gender: 'f' },
    { id: '417', text: 'Ben', gender: 'm' },
    { id: '418', text: 'Ben', gender: 'm' },
    { id: '419', text: 'Ben Elias', gender: 'm' },
    { id: '420', text: 'Ben Emilio', gender: 'm' },
    { id: '421', text: 'Ben Felix', gender: 'm' },
    { id: '422', text: 'Ben Finley', gender: 'm' },
    { id: '423', text: 'Ben Jasper', gender: 'm' },
    { id: '424', text: 'Ben Joel', gender: 'm' },
    { id: '425', text: 'Ben Jonah', gender: 'm' },
    { id: '426', text: 'Ben Lewis', gender: 'm' },
    { id: '427', text: 'Ben Louis', gender: 'm' },
    { id: '428', text: 'Ben Luca', gender: 'm' },
    { id: '429', text: 'Ben Luka', gender: 'm' },
    { id: '430', text: 'Ben Noah', gender: 'm' },
    { id: '431', text: 'Ben Toni', gender: 'm' },
    { id: '432', text: 'Ben-Eduard', gender: 'm' },
    { id: '433', text: 'Ben-Joris', gender: 'm' },
    { id: '434', text: 'Ben-Lares', gender: 'm' },
    { id: '435', text: 'Ben-Luca', gender: 'm' },
    { id: '436', text: 'Ben-Luca-Philipp', gender: 'm' },
    { id: '437', text: 'Benedikt', gender: 'm' },
    { id: '438', text: 'Benedikt', gender: 'm' },
    { id: '439', text: 'Benita', gender: 'f' },
    { id: '440', text: 'Benjamin', gender: 'm' },
    { id: '441', text: 'Benjamin', gender: 'm' },
    { id: '442', text: 'Benjamin', gender: 'm' },
    { id: '443', text: 'Benjamin Magnus', gender: 'm' },
    { id: '444', text: 'Benji Joel', gender: 'm' },
    { id: '445', text: 'Bennet', gender: 'm' },
    { id: '446', text: 'Bennet Laurin', gender: 'm' },
    { id: '447', text: 'Bennett', gender: 'm' },
    { id: '448', text: 'Benno', gender: 'm' },
    { id: '449', text: 'Benno', gender: 'm' },
    { id: '450', text: 'Berend', gender: 'm' },
    { id: '451', text: 'Berenike', gender: 'f' },
    { id: '452', text: 'Berit', gender: 'f' },
    { id: '453', text: 'Bernadette', gender: 'f' },
    { id: '454', text: 'Bernard', gender: 'm' },
    { id: '455', text: 'Bernd', gender: 'm' },
    { id: '456', text: 'Bernd', gender: 'm' },
    { id: '457', text: 'Bernd', gender: 'm' },
    { id: '458', text: 'Bernd-Dieter', gender: 'm' },
    { id: '459', text: 'Berndt', gender: 'm' },
    { id: '460', text: 'Bernfried', gender: 'm' },
    { id: '461', text: 'Bernhard', gender: 'm' },
    { id: '462', text: 'Bernhardine', gender: 'f' },
    { id: '463', text: 'Bernt', gender: 'm' },
    { id: '464', text: 'Bernward', gender: 'm' },
    { id: '465', text: 'Bert', gender: 'm' },
    { id: '466', text: 'Berta', gender: 'f' },
    { id: '467', text: 'Bertha', gender: 'f' },
    { id: '468', text: 'Berthold', gender: 'm' },
    { id: '469', text: 'Bertold', gender: 'm' },
    { id: '470', text: 'Bertram', gender: 'm' },
    { id: '471', text: 'Bertram', gender: 'm' },
    { id: '472', text: 'Betina', gender: 'f' },
    { id: '473', text: 'Betti', gender: 'f' },
    { id: '474', text: 'Bettina', gender: 'f' },
    { id: '475', text: 'Bettina', gender: 'f' },
    { id: '476', text: 'Betty', gender: 'f' },
    { id: '477', text: 'Bianca', gender: 'f' },
    { id: '478', text: 'Bianka', gender: 'f' },
    { id: '479', text: 'Bill', gender: 'm' },
    { id: '480', text: 'Billy', gender: 'm' },
    { id: '481', text: 'Birger', gender: 'm' },
    { id: '482', text: 'Birgid', gender: 'f' },
    { id: '483', text: 'Birgit', gender: 'f' },
    { id: '484', text: 'Birgitt', gender: 'f' },
    { id: '485', text: 'Birgitta', gender: 'f' },
    { id: '486', text: 'Birte', gender: 'f' },
    { id: '487', text: 'Birthe', gender: 'f' },
    { id: '488', text: 'Bjarne Elia', gender: 'm' },
    { id: '489', text: 'Bjarne innjas', gender: 'm' },
    { id: '490', text: 'Bjarne- Finjas', gender: 'm' },
    { id: '491', text: 'Björn', gender: 'm' },
    { id: '492', text: 'Björn- Oliver', gender: 'm' },
    { id: '493', text: 'Blanka', gender: 'f' },
    { id: '494', text: 'Bodo', gender: 'm' },
    { id: '495', text: 'Bogdan', gender: 'm' },
    { id: '496', text: 'Boris', gender: 'm' },
    { id: '497', text: 'Bozena', gender: 'f' },
    { id: '498', text: 'Brandon Elias', gender: 'm' },
    { id: '499', text: 'Branka', gender: 'f' },
    { id: '500', text: 'Branko', gender: 'm' },
    { id: '501', text: 'Brendon', gender: 'm' },
    { id: '502', text: 'Brian', gender: 'm' },
    { id: '503', text: 'Brian', gender: 'm' },
    { id: '504', text: 'Brian Joel', gender: 'm' },
    { id: '505', text: 'Brianna Joy', gender: 'f' },
    { id: '506', text: 'Brigitta', gender: 'f' },
    { id: '507', text: 'Brigitte', gender: 'f' },
    { id: '508', text: 'Brit', gender: 'f' },
    { id: '509', text: 'Brita', gender: 'f' },
    { id: '510', text: 'Britt', gender: 'f' },
    { id: '511', text: 'Britta', gender: 'f' },
    { id: '512', text: 'Brokleyn', gender: 'm' },
    { id: '513', text: 'Brunhild', gender: 'f' },
    { id: '514', text: 'Brunhilde', gender: 'f' },
    { id: '515', text: 'Bruni', gender: 'f' },
    { id: '516', text: 'Bruno', gender: 'm' },
    { id: '517', text: 'Bruno', gender: 'm' },
    { id: '518', text: 'Bryan', gender: 'm' },
    { id: '519', text: 'Burckhard', gender: 'm' },
    { id: '520', text: 'Burghard', gender: 'm' },
    { id: '521', text: 'Burkard', gender: 'm' },
    { id: '522', text: 'Burkhard', gender: 'm' },
    { id: '523', text: 'Burkhardt', gender: 'm' },
    { id: '524', text: 'Cäcilia', gender: 'f' },
    { id: '525', text: 'Cäcilia', gender: 'f' },
    { id: '526', text: 'Cäcilie', gender: 'f' },
    { id: '527', text: 'Caitlin', gender: 'f' },
    { id: '528', text: 'Callum', gender: 'm' },
    { id: '529', text: 'Calogero', gender: 'm' },
    { id: '530', text: 'Calvin', gender: 'm' },
    { id: '531', text: 'Calypso', gender: 'f' },
    { id: '532', text: 'Cameron', gender: 'm' },
    { id: '533', text: 'Camilla', gender: 'f' },
    { id: '534', text: 'Camilla Lea', gender: 'f' },
    { id: '535', text: 'Camille', gender: 'f' },
    { id: '536', text: 'Can', gender: 'm' },
    { id: '537', text: 'Canan', gender: 'f' },
    { id: '538', text: 'Cannon', gender: 'm' },
    { id: '539', text: 'Cara', gender: 'f' },
    { id: '540', text: 'Caren', gender: 'f' },
    { id: '541', text: 'Carin', gender: 'f' },
    { id: '542', text: 'Carin Ruth', gender: 'f' },
    { id: '543', text: 'Carina', gender: 'f' },
    { id: '544', text: 'Carina', gender: 'f' },
    { id: '545', text: 'Carine', gender: 'f' },
    { id: '546', text: 'Carl', gender: 'm' },
    { id: '547', text: 'Carl', gender: 'm' },
    { id: '548', text: 'Carl-Heinz', gender: 'm' },
    { id: '549', text: 'Carla', gender: 'f' },
    { id: '550', text: 'Carla', gender: 'f' },
    { id: '551', text: 'Carlito', gender: 'm' },
    { id: '552', text: 'Carlo', gender: 'm' },
    { id: '553', text: 'Carlo', gender: 'm' },
    { id: '554', text: 'Carlos', gender: 'm' },
    { id: '555', text: 'Carlos', gender: 'm' },
    { id: '556', text: 'Carlotta', gender: 'f' },
    { id: '557', text: 'Carlotta-Marie', gender: 'f' },
    { id: '558', text: 'Carmela', gender: 'f' },
    { id: '559', text: 'Carmelo', gender: 'm' },
    { id: '560', text: 'Carmen', gender: 'f' },
    { id: '561', text: 'Carmen', gender: 'f' },
    { id: '562', text: 'Carmine', gender: 'f' },
    { id: '563', text: 'Carola', gender: 'f' },
    { id: '564', text: 'Carola', gender: 'f' },
    { id: '565', text: 'Carolin', gender: 'f' },
    { id: '566', text: 'Carolin', gender: 'f' },
    { id: '567', text: 'Carolina', gender: 'f' },
    { id: '568', text: 'Carolina', gender: 'f' },
    { id: '569', text: 'Caroline', gender: 'f' },
    { id: '570', text: 'Carsten', gender: 'm' },
    { id: '571', text: 'Carsten', gender: 'm' },
    { id: '572', text: 'Caspar', gender: 'm' },
    { id: '573', text: 'Casper', gender: 'm' },
    { id: '574', text: 'Cassandra', gender: 'f' },
    { id: '575', text: 'Cassidy-Cheyenne', gender: 'f' },
    { id: '576', text: 'Caterina', gender: 'f' },
    { id: '577', text: 'Catharina', gender: 'f' },
    { id: '578', text: 'Catherine', gender: 'f' },
    { id: '579', text: 'Cathleen', gender: 'f' },
    { id: '580', text: 'Cathleen', gender: 'f' },
    { id: '581', text: 'Cathrin', gender: 'f' },
    { id: '582', text: 'Catrin', gender: 'f' },
    { id: '583', text: 'Caya', gender: 'f' },
    { id: '584', text: 'Cecil Leon', gender: 'm' },
    { id: '585', text: 'Cecile', gender: 'f' },
    { id: '586', text: 'Cecilia', gender: 'f' },
    { id: '587', text: 'Ceciliana', gender: 'f' },
    { id: '588', text: 'Cedric', gender: 'm' },
    { id: '589', text: 'Celal', gender: 'm' },
    { id: '590', text: 'Celia Marie', gender: 'f' },
    { id: '591', text: 'Celia-Marie', gender: 'f' },
    { id: '592', text: 'Celina', gender: 'f' },
    { id: '593', text: 'Celina Luisa', gender: 'f' },
    { id: '594', text: 'Celina-Marie', gender: 'f' },
    { id: '595', text: 'Celine', gender: 'f' },
    { id: '596', text: 'Celine Noemi', gender: 'f' },
    { id: '597', text: 'Cemal', gender: 'm' },
    { id: '598', text: 'Cemil', gender: 'm' },
    { id: '599', text: 'Cengiz', gender: 'm' },
    { id: '600', text: 'Centa', gender: 'f' },
    { id: '601', text: 'Cetin', gender: 'm' },
    { id: '602', text: 'Chanel/Channel', gender: 'f' },
    { id: '603', text: 'Chantal', gender: 'f' },
    { id: '604', text: 'Chantal', gender: 'f' },
    { id: '605', text: 'Charel', gender: 'm' },
    { id: '606', text: 'Charis', gender: 'f' },
    { id: '607', text: 'Charleen', gender: 'f' },
    { id: '608', text: 'charleen zoe', gender: 'f' },
    { id: '609', text: 'Charles', gender: 'm' },
    { id: '610', text: 'Charlin', gender: 'f' },
    { id: '611', text: 'Charlize', gender: 'f' },
    { id: '612', text: 'Charlott', gender: 'f' },
    { id: '613', text: 'Charlotta', gender: 'f' },
    { id: '614', text: 'Charlotte', gender: 'f' },
    { id: '615', text: 'Charlotte', gender: 'f' },
    { id: '616', text: 'Charlotte Marie', gender: 'f' },
    { id: '617', text: 'Charlotte Michelle', gender: 'f' },
    { id: '618', text: 'Charlotte-Elena', gender: 'f' },
    { id: '619', text: 'Charly / Charlie', gender: 'f' },
    { id: '620', text: 'Charlyn', gender: 'f' },
    { id: '621', text: 'Chayenne', gender: 'f' },
    { id: '622', text: 'Chayenne Blue', gender: 'f' },
    { id: '623', text: 'chayenne cejla', gender: 'f' },
    { id: '624', text: 'Chelsea', gender: 'f' },
    { id: '625', text: 'Chenoa', gender: 'f' },
    { id: '626', text: 'Cherié', gender: 'f' },
    { id: '627', text: 'Cheyenne', gender: 'f' },
    { id: '628', text: 'Cheyenne', gender: 'f' },
    { id: '629', text: 'Cheyenne Blue', gender: 'f' },
    { id: '630', text: 'Cheyenne Lauren', gender: 'f' },
    { id: '631', text: 'Chiara', gender: 'f' },
    { id: '632', text: 'Chiara Amalia', gender: 'f' },
    { id: '633', text: 'Chiara Ashley', gender: 'f' },
    { id: '634', text: 'Chiara Jazmin', gender: 'f' },
    { id: '635', text: 'chiara katharina', gender: 'f' },
    { id: '636', text: 'Chiara Zoe`', gender: 'f' },
    { id: '637', text: 'Chiara-Luisa', gender: 'f' },
    { id: '638', text: 'Chloé', gender: 'f' },
    { id: '639', text: 'Chris', gender: 'm' },
    { id: '640', text: 'Chris', gender: 'm' },
    { id: '641', text: 'Christa', gender: 'f' },
    { id: '642', text: 'Christa-Maria', gender: 'f' },
    { id: '643', text: 'Christel', gender: 'f' },
    { id: '644', text: 'Christel', gender: 'f' },
    { id: '645', text: 'Christian', gender: 'm' },
    { id: '646', text: 'Christian', gender: 'm' },
    { id: '647', text: 'Christiana', gender: 'f' },
    { id: '648', text: 'Christiane', gender: 'f' },
    { id: '649', text: 'Christiane', gender: 'f' },
    { id: '650', text: 'Christin', gender: 'f' },
    { id: '651', text: 'Christina', gender: 'f' },
    { id: '652', text: 'Christina', gender: 'f' },
    { id: '653', text: 'Christine', gender: 'f' },
    { id: '654', text: 'Christl', gender: 'f' },
    { id: '655', text: 'Christof', gender: 'm' },
    { id: '656', text: 'Christof', gender: 'm' },
    { id: '657', text: 'Christoph', gender: 'm' },
    { id: '658', text: 'Christoph', gender: 'm' },
    { id: '659', text: 'Christophe', gender: 'm' },
    { id: '660', text: 'Christopher', gender: 'm' },
    { id: '661', text: 'Christopher', gender: 'm' },
    { id: '662', text: 'Christos', gender: 'm' },
    { id: '663', text: 'Cilli', gender: 'f' },
    { id: '664', text: 'Cilly', gender: 'f' },
    { id: '665', text: 'Cindy', gender: 'f' },
    { id: '666', text: 'Cindy', gender: 'f' },
    { id: '667', text: 'Cindy Joy', gender: 'f' },
    { id: '668', text: 'Claas', gender: 'm' },
    { id: '669', text: 'Claire', gender: 'f' },
    { id: '670', text: 'Clara', gender: 'f' },
    { id: '671', text: 'Clara', gender: 'f' },
    { id: '672', text: 'Clara Elisa', gender: 'f' },
    { id: '673', text: 'Cläre', gender: 'f' },
    { id: '674', text: 'Clarissa', gender: 'f' },
    { id: '675', text: 'Clarissa', gender: 'f' },
    { id: '676', text: 'Clarssa Desineria Emily', gender: 'f' },
    { id: '677', text: 'Claudia', gender: 'f' },
    { id: '678', text: 'Claudia', gender: 'f' },
    { id: '679', text: 'Claudio', gender: 'm' },
    { id: '680', text: 'Claudio', gender: 'm' },
    { id: '681', text: 'Claudius', gender: 'm' },
    { id: '682', text: 'Claus', gender: 'm' },
    { id: '683', text: 'Claus-Dieter', gender: 'm' },
    { id: '684', text: 'Claus-Peter', gender: 'm' },
    { id: '685', text: 'Clayton', gender: 'm' },
    { id: '686', text: 'Clemens', gender: 'm' },
    { id: '687', text: 'Clemens', gender: 'm' },
    { id: '688', text: 'Clement', gender: 'm' },
    { id: '689', text: 'Clemenz', gender: 'm' },
    { id: '690', text: 'Cleo', gender: 'f' },
    { id: '691', text: 'Clivia', gender: 'f' },
    { id: '692', text: 'Cloe', gender: 'f' },
    { id: '693', text: 'Clothilda', gender: 'f' },
    { id: '694', text: 'Cody Joel', gender: 'm' },
    { id: '695', text: 'Cole', gender: 'm' },
    { id: '696', text: 'Colin', gender: 'm' },
    { id: '697', text: 'Colin Bennet', gender: 'm' },
    { id: '698', text: 'Colin Fabrice', gender: 'm' },
    { id: '699', text: 'Colin Finley', gender: 'm' },
    { id: '700', text: 'Colin Marius', gender: 'm' },
    { id: '701', text: 'Colin Maxim', gender: 'm' },
    { id: '702', text: 'Colin Nicholas', gender: 'm' },
    { id: '703', text: 'Colin Robin', gender: 'm' },
    { id: '704', text: 'Colin Tamino', gender: 'm' },
    { id: '705', text: 'Collien', gender: 'f' },
    { id: '706', text: 'Collin / Colin', gender: 'm' },
    { id: '707', text: 'Collin Paul', gender: 'm' },
    { id: '708', text: 'Collin-Elias', gender: 'm' },
    { id: '709', text: 'Conan', gender: 'm' },
    { id: '710', text: 'Concetta', gender: 'f' },
    { id: '711', text: 'Conner', gender: 'm' },
    { id: '712', text: 'Connor', gender: 'm' },
    { id: '713', text: 'Connor Aidan', gender: 'm' },
    { id: '714', text: 'Conny', gender: 'f' },
    { id: '715', text: 'Conrad', gender: 'm' },
    { id: '716', text: 'Conrad', gender: 'm' },
    { id: '717', text: 'Constance', gender: 'f' },
    { id: '718', text: 'Constantin', gender: 'm' },
    { id: '719', text: 'Constantin', gender: 'm' },
    { id: '720', text: 'Constanze', gender: 'f' },
    { id: '721', text: 'Cora', gender: 'f' },
    { id: '722', text: 'Cora', gender: 'f' },
    { id: '723', text: 'Cord', gender: 'm' },
    { id: '724', text: 'Cordula', gender: 'f' },
    { id: '725', text: 'Cori', gender: 'f' },
    { id: '726', text: 'Corina', gender: 'f' },
    { id: '727', text: 'Corinna', gender: 'f' },
    { id: '728', text: 'Corinna', gender: 'f' },
    { id: '729', text: 'Corinna Charlotte', gender: 'f' },
    { id: '730', text: 'Corinne', gender: 'f' },
    { id: '731', text: 'Cornelia', gender: 'f' },
    { id: '732', text: 'Cornelius', gender: 'm' },
    { id: '733', text: 'Cornelius', gender: 'm' },
    { id: '734', text: 'Cosima', gender: 'f' },
    { id: '735', text: 'Cosima', gender: 'f' },
    { id: '736', text: 'Cosimo', gender: 'm' },
    { id: '737', text: 'Cosmo', gender: 'm' },
    { id: '738', text: 'Couis Alexander', gender: 'm' },
    { id: '739', text: 'Courtney', gender: 'f' },
    { id: '740', text: 'Crisiano', gender: 'm' },
    { id: '741', text: 'cristiano', gender: 'm' },
    { id: '742', text: 'Cristiano Ronaldo', gender: 'm' },
    { id: '743', text: 'Cristina', gender: 'f' },
    { id: '744', text: 'Curt', gender: 'm' },
    { id: '745', text: 'Curtis Michael', gender: 'm' },
    { id: '746', text: 'Curtis-Cave', gender: 'm' },
    { id: '747', text: 'Cynthia', gender: 'f' },
    { id: '748', text: 'Cynthia', gender: 'f' },
    { id: '749', text: 'Cyprienne', gender: 'f' },
    { id: '750', text: 'Czeslaw', gender: 'm' },
    { id: '751', text: 'Dagmar', gender: 'f' },
    { id: '752', text: 'Dagobert', gender: 'm' },
    { id: '753', text: 'Daily', gender: 'f' },
    { id: '754', text: 'Dajana', gender: 'f' },
    { id: '755', text: 'Daliah', gender: 'f' },
    { id: '756', text: 'Damaris', gender: 'f' },
    { id: '757', text: 'Damian', gender: 'm' },
    { id: '758', text: 'Damian', gender: 'm' },
    { id: '759', text: 'Damien', gender: 'm' },
    { id: '760', text: 'Dan', gender: 'm' },
    { id: '761', text: 'Dana', gender: 'f' },
    { id: '762', text: 'Dana', gender: 'f' },
    { id: '763', text: 'Dana - Mari', gender: 'f' },
    { id: '764', text: 'Dana Sophie', gender: 'f' },
    { id: '765', text: 'Danae', gender: 'f' },
    { id: '766', text: 'Danica', gender: 'f' },
    { id: '767', text: 'Daniel', gender: 'm' },
    { id: '768', text: 'Daniel', gender: 'm' },
    { id: '769', text: 'Daniel Arda', gender: 'm' },
    { id: '770', text: 'Daniela', gender: 'f' },
    { id: '771', text: 'Daniele', gender: 'm' },
    { id: '772', text: 'Danielle', gender: 'f' },
    { id: '773', text: 'Danilo', gender: 'm' },
    { id: '774', text: 'Danilo', gender: 'm' },
    { id: '775', text: 'Danjaan', gender: 'm' },
    { id: '776', text: 'Danny', gender: 'm' },
    { id: '777', text: 'Danny', gender: 'm' },
    { id: '778', text: 'Danuta', gender: 'f' },
    { id: '779', text: 'Daria', gender: 'f' },
    { id: '780', text: 'Dariah', gender: 'f' },
    { id: '781', text: 'Darian', gender: 'm' },
    { id: '782', text: 'Dario', gender: 'm' },
    { id: '783', text: 'Dario Allesio', gender: 'm' },
    { id: '784', text: 'Darius', gender: 'm' },
    { id: '785', text: 'Dariusz', gender: 'm' },
    { id: '786', text: 'Darko', gender: 'm' },
    { id: '787', text: 'Darlene', gender: 'f' },
    { id: '788', text: 'Dave', gender: 'm' },
    { id: '789', text: 'Daven', gender: 'm' },
    { id: '790', text: 'David', gender: 'm' },
    { id: '791', text: 'David', gender: 'm' },
    { id: '792', text: 'David - Leon', gender: 'm' },
    { id: '793', text: 'Davie', gender: 'm' },
    { id: '794', text: 'Davina', gender: 'f' },
    { id: '795', text: 'Davina-Maren-Lourette', gender: 'f' },
    { id: '796', text: 'Dawen', gender: 'm' },
    { id: '797', text: 'Dea', gender: 'm' },
    { id: '798', text: 'Dean Ryan', gender: 'm' },
    { id: '799', text: 'Debora', gender: 'f' },
    { id: '800', text: 'Deborah', gender: 'f' },
    { id: '801', text: 'Dejan', gender: 'm' },
    { id: '802', text: 'Delia', gender: 'f' },
    { id: '803', text: 'Delia', gender: 'f' },
    { id: '804', text: 'Demond', gender: 'm' },
    { id: '805', text: 'Denis', gender: 'm' },
    { id: '806', text: 'Denise', gender: 'f' },
    { id: '807', text: 'Denise', gender: 'f' },
    { id: '808', text: 'Denise Emma', gender: 'f' },
    { id: '809', text: 'Deniz', gender: 'm' },
    { id: '810', text: 'Dennis', gender: 'm' },
    { id: '811', text: 'Dennis', gender: 'm' },
    { id: '812', text: 'Denny', gender: 'm' },
    { id: '813', text: 'Derek', gender: 'm' },
    { id: '814', text: 'Derius', gender: 'm' },
    { id: '815', text: 'Derrinton', gender: 'm' },
    { id: '816', text: 'Deryck Jason', gender: 'm' },
    { id: '817', text: 'Desiree', gender: 'f' },
    { id: '818', text: 'Desiree', gender: 'f' },
    { id: '819', text: 'Destina', gender: 'f' },
    { id: '820', text: 'Detlef', gender: 'm' },
    { id: '821', text: 'Detlev', gender: 'm' },
    { id: '822', text: 'Deven Vincent', gender: 'm' },
    { id: '823', text: 'Devin', gender: 'm' },
    { id: '824', text: 'Devin Noel', gender: 'm' },
    { id: '825', text: 'Diana', gender: 'f' },
    { id: '826', text: 'Diana', gender: 'f' },
    { id: '827', text: 'Diana Beate', gender: 'f' },
    { id: '828', text: 'Diana Nicole Claire', gender: 'f' },
    { id: '829', text: 'Diane', gender: 'f' },
    { id: '830', text: 'Dianne', gender: 'f' },
    { id: '831', text: 'Diedrich', gender: 'm' },
    { id: '832', text: 'Diego', gender: 'm' },
    { id: '833', text: 'Dierk', gender: 'm' },
    { id: '834', text: 'Dieter', gender: 'm' },
    { id: '835', text: 'Diethard', gender: 'm' },
    { id: '836', text: 'Diethelm', gender: 'm' },
    { id: '837', text: 'Diether', gender: 'm' },
    { id: '838', text: 'Dietlind', gender: 'f' },
    { id: '839', text: 'Dietlinde', gender: 'f' },
    { id: '840', text: 'Dietmar', gender: 'm' },
    { id: '841', text: 'Dietrich', gender: 'm' },
    { id: '842', text: 'Dijan', gender: 'm' },
    { id: '843', text: 'Dilan', gender: 'm' },
    { id: '844', text: 'Dilara', gender: 'f' },
    { id: '845', text: 'Dilayla', gender: 'f' },
    { id: '846', text: 'Dima', gender: 'm' },
    { id: '847', text: 'Dimitri', gender: 'm' },
    { id: '848', text: 'Dimitrios', gender: 'm' },
    { id: '849', text: 'Dina', gender: 'f' },
    { id: '850', text: 'Dino', gender: 'm' },
    { id: '851', text: 'Dior', gender: 'f' },
    { id: '852', text: 'Dirk', gender: 'm' },
    { id: '853', text: 'Ditmar', gender: 'm' },
    { id: '854', text: 'Dittmar', gender: 'm' },
    { id: '855', text: 'Divo', gender: 'm' },
    { id: '856', text: 'Djamila', gender: 'f' },
    { id: '857', text: 'Djego', gender: 'm' },
    { id: '858', text: 'Djuna', gender: 'f' },
    { id: '859', text: 'Dogan', gender: 'm' },
    { id: '860', text: 'Dolores', gender: 'f' },
    { id: '861', text: 'Domenico', gender: 'm' },
    { id: '862', text: 'Domenico', gender: 'm' },
    { id: '863', text: 'Dominic', gender: 'm' },
    { id: '864', text: 'Dominic Pascal', gender: 'm' },
    { id: '865', text: 'Dominik', gender: 'm' },
    { id: '866', text: 'Dominik', gender: 'm' },
    { id: '867', text: 'Dominik / Dominique', gender: 'm' },
    { id: '868', text: 'Dominika', gender: 'f' },
    { id: '869', text: 'Donald', gender: 'm' },
    { id: '870', text: 'Donata', gender: 'f' },
    { id: '871', text: 'Dora', gender: 'f' },
    { id: '872', text: 'Doreen', gender: 'f' },
    { id: '873', text: 'Dorian', gender: 'm' },
    { id: '874', text: 'Dorien', gender: 'm' },
    { id: '875', text: 'Dorina', gender: 'f' },
    { id: '876', text: 'Doris', gender: 'f' },
    { id: '877', text: 'Dorit', gender: 'f' },
    { id: '878', text: 'Dorle', gender: 'f' },
    { id: '879', text: 'Dorota', gender: 'f' },
    { id: '880', text: 'Dorothe', gender: 'f' },
    { id: '881', text: 'Dorothea', gender: 'f' },
    { id: '882', text: 'Dorothee', gender: 'f' },
    { id: '883', text: 'Dörte', gender: 'f' },
    { id: '884', text: 'Dörte', gender: 'f' },
    { id: '885', text: 'Dörthe', gender: 'f' },
    { id: '886', text: 'Dougles Lui', gender: 'f' },
    { id: '887', text: 'Dragan', gender: 'm' },
    { id: '888', text: 'Dragica', gender: 'f' },
    { id: '889', text: 'Drago', gender: 'm' },
    { id: '890', text: 'Draven', gender: 'm' },
    { id: '891', text: 'Duena', gender: 'f' },
    { id: '892', text: 'Dunja', gender: 'f' },
    { id: '893', text: 'Dursun', gender: 'm' },
    { id: '894', text: 'Dusan', gender: 'm' },
    { id: '895', text: 'Dustin', gender: 'm' },
    { id: '896', text: 'Dustin-Killian', gender: 'm' },
    { id: '897', text: 'Dwayn', gender: 'm' },
    { id: '898', text: 'Dylan', gender: 'm' },
    { id: '899', text: 'Eberhard', gender: 'm' },
    { id: '900', text: 'Eberhard', gender: 'm' },
    { id: '901', text: 'Eberhardt', gender: 'm' },
    { id: '902', text: 'Eckard', gender: 'm' },
    { id: '903', text: 'Eckart', gender: 'm' },
    { id: '904', text: 'Eckehard', gender: 'm' },
    { id: '905', text: 'Eckhard', gender: 'm' },
    { id: '906', text: 'Eckhardt', gender: 'm' },
    { id: '907', text: 'Eckhart', gender: 'm' },
    { id: '908', text: 'Edda', gender: 'f' },
    { id: '909', text: 'Edelbert', gender: 'm' },
    { id: '910', text: 'Edelgard', gender: 'f' },
    { id: '911', text: 'Edeltraud', gender: 'f' },
    { id: '912', text: 'Edeltraud', gender: 'f' },
    { id: '913', text: 'Edeltraud-Gertrude', gender: 'f' },
    { id: '914', text: 'Edeltraut', gender: 'f' },
    { id: '915', text: 'Edeltrud', gender: 'f' },
    { id: '916', text: 'Eden', gender: 'f' },
    { id: '917', text: 'Edgar', gender: 'm' },
    { id: '918', text: 'Edgar', gender: 'm' },
    { id: '919', text: 'Edis', gender: 'm' },
    { id: '920', text: 'Edit', gender: 'f' },
    { id: '921', text: 'Edith', gender: 'f' },
    { id: '922', text: 'Editha', gender: 'f' },
    { id: '923', text: 'Edmund', gender: 'm' },
    { id: '924', text: 'Eduard', gender: 'm' },
    { id: '925', text: 'Edward', gender: 'm' },
    { id: '926', text: 'Edward', gender: 'm' },
    { id: '927', text: 'Edwin', gender: 'm' },
    { id: '928', text: 'Efrem', gender: 'm' },
    { id: '929', text: 'Egbert', gender: 'm' },
    { id: '930', text: 'Eggert', gender: 'm' },
    { id: '931', text: 'Egon', gender: 'm' },
    { id: '932', text: 'Ehrenfried', gender: 'm' },
    { id: '933', text: 'Ehrentraud', gender: 'f' },
    { id: '934', text: 'Ehrhard', gender: 'm' },
    { id: '935', text: 'Eileen', gender: 'f' },
    { id: '936', text: 'Eileen', gender: 'f' },
    { id: '937', text: 'Eileen Sophie', gender: 'f' },
    { id: '938', text: 'Eitel', gender: 'm' },
    { id: '939', text: 'Ekaterina', gender: 'f' },
    { id: '940', text: 'Ekkehard', gender: 'm' },
    { id: '941', text: 'Ekkehart', gender: 'm' },
    { id: '942', text: 'Ekrem', gender: 'm' },
    { id: '943', text: 'Elaine', gender: 'f' },
    { id: '944', text: 'Elane', gender: 'f' },
    { id: '945', text: 'Elea', gender: 'f' },
    { id: '946', text: 'Elena', gender: 'f' },
    { id: '947', text: 'Elena', gender: 'f' },
    { id: '948', text: 'Elena Sofie', gender: 'f' },
    { id: '949', text: 'Elena Sophie', gender: 'f' },
    { id: '950', text: 'Eleni', gender: 'f' },
    { id: '951', text: 'Eleni', gender: 'f' },
    { id: '952', text: 'Elenore', gender: 'f' },
    { id: '953', text: 'Eleonora', gender: 'f' },
    { id: '954', text: 'Eleonora', gender: 'f' },
    { id: '955', text: 'Eleonore', gender: 'f' },
    { id: '956', text: 'Eleonore', gender: 'f' },
    { id: '957', text: 'Elfi', gender: 'f' },
    { id: '958', text: 'Elfie', gender: 'f' },
    { id: '959', text: 'Elfriede', gender: 'f' },
    { id: '960', text: 'Elia', gender: 'f' },
    { id: '961', text: 'Elian', gender: 'm' },
    { id: '962', text: 'Eliana', gender: 'f' },
    { id: '963', text: 'Elias', gender: 'm' },
    { id: '964', text: 'Elias', gender: 'm' },
    { id: '965', text: 'Elias', gender: 'm' },
    { id: '966', text: 'Elias Antonio', gender: 'm' },
    { id: '967', text: 'Elias Emanuel', gender: 'm' },
    { id: '968', text: 'Elias Jakob', gender: 'm' },
    { id: '969', text: 'Elias Manuel', gender: 'm' },
    { id: '970', text: 'Elias-Pätrick', gender: 'm' },
    { id: '971', text: 'Elif', gender: 'f' },
    { id: '972', text: 'Elin', gender: 'f' },
    { id: '973', text: 'Elina', gender: 'f' },
    { id: '974', text: 'Elisa', gender: 'f' },
    { id: '975', text: 'Elisa', gender: 'f' },
    { id: '976', text: 'Elisa Noél', gender: 'f' },
    { id: '977', text: 'Elisabet', gender: 'f' },
    { id: '978', text: 'Elisabeth', gender: 'f' },
    { id: '979', text: 'Elisabeth', gender: 'f' },
    { id: '980', text: 'Elisabetta', gender: 'f' },
    { id: '981', text: 'Elise', gender: 'f' },
    { id: '982', text: 'Elise', gender: 'f' },
    { id: '983', text: 'Elisso', gender: 'm' },
    { id: '984', text: 'Elizabeth', gender: 'f' },
    { id: '985', text: 'Elja', gender: 'f' },
    { id: '986', text: 'Elke', gender: 'f' },
    { id: '987', text: 'Ella', gender: 'f' },
    { id: '988', text: 'Ella', gender: 'f' },
    { id: '989', text: 'Ellen', gender: 'f' },
    { id: '990', text: 'Ellen', gender: 'f' },
    { id: '991', text: 'Elli', gender: 'f' },
    { id: '992', text: 'Elli Victoria', gender: 'f' },
    { id: '993', text: 'Ellie', gender: 'f' },
    { id: '994', text: 'Ellie Sophie', gender: 'f' },
    { id: '995', text: 'Ellinor', gender: 'f' },
    { id: '996', text: 'Ellinor', gender: 'f' },
    { id: '997', text: 'Elliot', gender: 'm' },
    { id: '998', text: 'Elly', gender: 'f' },
    { id: '999', text: 'Elma', gender: 'f' },
    { id: '1000', text: 'Elma', gender: 'f' },
    { id: '1001', text: 'Elmar', gender: 'm' },
    { id: '1002', text: 'Eloise', gender: 'f' },
    { id: '1003', text: 'Elsa', gender: 'f' },
    { id: '1004', text: 'Elsa', gender: 'f' },
    { id: '1005', text: 'Elsbeth', gender: 'f' },
    { id: '1006', text: 'Else', gender: 'f' },
    { id: '1007', text: 'Elvin', gender: 'm' },
    { id: '1008', text: 'Elvina', gender: 'f' },
    { id: '1009', text: 'Elvira', gender: 'f' },
    { id: '1010', text: 'Elvis', gender: 'm' },
    { id: '1011', text: 'Elwira', gender: 'f' },
    { id: '1012', text: 'Elyon', gender: 'f' },
    { id: '1013', text: 'Elzbieta', gender: 'f' },
    { id: '1014', text: 'Ema', gender: 'f' },
    { id: '1015', text: 'Emanuel', gender: 'm' },
    { id: '1016', text: 'Emanuel', gender: 'm' },
    { id: '1017', text: 'Emely', gender: 'f' },
    { id: '1018', text: 'Emely Jolie', gender: 'f' },
    { id: '1019', text: 'Emil', gender: 'm' },
    { id: '1020', text: 'Emil', gender: 'm' },
    { id: '1021', text: 'Emil Joenna', gender: 'f' },
    { id: '1022', text: 'Emil Linus', gender: 'm' },
    { id: '1023', text: 'Emilia', gender: 'f' },
    { id: '1024', text: 'Emilia', gender: 'f' },
    { id: '1025', text: 'Emilia', gender: 'f' },
    { id: '1026', text: 'Emilia Valeria', gender: 'f' },
    { id: '1027', text: 'Emilia- Luise', gender: 'f' },
    { id: '1028', text: 'Emilian', gender: 'm' },
    { id: '1029', text: 'Emiliana', gender: 'f' },
    { id: '1030', text: 'Emilie', gender: 'f' },
    { id: '1031', text: 'Emilie', gender: 'f' },
    { id: '1032', text: 'Emilio', gender: 'm' },
    { id: '1033', text: 'Emily / Emely / Emelie', gender: 'f' },
    { id: '1034', text: 'Emily Gina Marie', gender: 'f' },
    { id: '1035', text: 'Emily Jolie', gender: 'f' },
    { id: '1036', text: 'Emily-Celin', gender: 'f' },
    { id: '1037', text: 'Emily-Marie', gender: 'f' },
    { id: '1038', text: 'Emily-Melissa', gender: 'f' },
    { id: '1039', text: 'Emily-Sophie', gender: 'f' },
    { id: '1040', text: 'Emilya', gender: 'f' },
    { id: '1041', text: 'Emin', gender: 'm' },
    { id: '1042', text: 'Emine', gender: 'f' },
    { id: '1043', text: 'Emma', gender: 'f' },
    { id: '1044', text: 'Emma', gender: 'f' },
    { id: '1045', text: 'Emma Mae', gender: 'f' },
    { id: '1046', text: 'Emma Malin', gender: 'f' },
    { id: '1047', text: 'Emma Sophie', gender: 'f' },
    { id: '1048', text: 'Emma-Fiona', gender: 'f' },
    { id: '1049', text: 'Emma-May', gender: 'f' },
    { id: '1050', text: 'Emmerich', gender: 'm' },
    { id: '1051', text: 'Emmi', gender: 'f' },
    { id: '1052', text: 'Emmi Marie', gender: 'f' },
    { id: '1053', text: 'Emmy', gender: 'f' },
    { id: '1054', text: 'Emmy', gender: 'f' },
    { id: '1055', text: 'Ena', gender: 'f' },
    { id: '1056', text: 'ENDLEY', gender: 'm' },
    { id: '1057', text: 'Endley-Jade', gender: 'm' },
    { id: '1058', text: 'Engelbert', gender: 'm' },
    { id: '1059', text: 'Engin', gender: 'm' },
    { id: '1060', text: 'Enna', gender: 'f' },
    { id: '1061', text: 'Enno', gender: 'm' },
    { id: '1062', text: 'Enno', gender: 'm' },
    { id: '1063', text: 'Enrico', gender: 'm' },
    { id: '1064', text: 'Enrico', gender: 'm' },
    { id: '1065', text: 'Enriquo', gender: 'm' },
    { id: '1066', text: 'Enver', gender: 'm' },
    { id: '1067', text: 'Ercan', gender: 'm' },
    { id: '1068', text: 'Erdal', gender: 'm' },
    { id: '1069', text: 'Erdmute', gender: 'f' },
    { id: '1070', text: 'Erdogan', gender: 'm' },
    { id: '1071', text: 'Erhard', gender: 'm' },
    { id: '1072', text: 'Erhardt', gender: 'm' },
    { id: '1073', text: 'Eric', gender: 'm' },
    { id: '1074', text: 'Eric Anton', gender: 'm' },
    { id: '1075', text: 'Erica', gender: 'f' },
    { id: '1076', text: 'Erich', gender: 'm' },
    { id: '1077', text: 'Erik', gender: 'm' },
    { id: '1078', text: 'Erik / Eric', gender: 'm' },
    { id: '1079', text: 'Erika', gender: 'f' },
    { id: '1080', text: 'Erkan', gender: 'm' },
    { id: '1081', text: 'Erna', gender: 'f' },
    { id: '1082', text: 'Ernest', gender: 'm' },
    { id: '1083', text: 'Ernestine', gender: 'f' },
    { id: '1084', text: 'Ernesto', gender: 'm' },
    { id: '1085', text: 'Ernst', gender: 'm' },
    { id: '1086', text: 'Ernst-August', gender: 'm' },
    { id: '1087', text: 'Ernst-Dieter', gender: 'm' },
    { id: '1088', text: 'Ernst-Otto', gender: 'm' },
    { id: '1089', text: 'Erol', gender: 'm' },
    { id: '1090', text: 'Erwin', gender: 'm' },
    { id: '1091', text: 'Erwin', gender: 'm' },
    { id: '1092', text: 'Erwina', gender: 'f' },
    { id: '1093', text: 'Esmeralda', gender: 'f' },
    { id: '1094', text: 'Estelle', gender: 'f' },
    { id: '1095', text: 'Ester', gender: 'f' },
    { id: '1096', text: 'Esther', gender: 'f' },
    { id: '1097', text: 'Esther', gender: 'f' },
    { id: '1098', text: 'Etien', gender: 'm' },
    { id: '1099', text: 'Etienne', gender: 'm' },
    { id: '1100', text: 'Etnik', gender: 'm' },
    { id: '1101', text: 'Etta', gender: 'f' },
    { id: '1102', text: 'Eugen', gender: 'm' },
    { id: '1103', text: 'Eugen', gender: 'm' },
    { id: '1104', text: 'Eugenia', gender: 'f' },
    { id: '1105', text: 'Eugenia', gender: 'f' },
    { id: '1106', text: 'Eugenie', gender: 'f' },
    { id: '1107', text: 'Eugenie Victoria', gender: 'f' },
    { id: '1108', text: 'Europa', gender: 'f' },
    { id: '1109', text: 'Eva', gender: 'f' },
    { id: '1110', text: 'Eva', gender: 'f' },
    { id: '1111', text: 'Eva Luisa', gender: 'f' },
    { id: '1112', text: 'Eva-Maria', gender: 'f' },
    { id: '1113', text: 'Eva-Marie', gender: 'f' },
    { id: '1114', text: 'Eva-Marie', gender: 'f' },
    { id: '1115', text: 'Evamaria', gender: 'f' },
    { id: '1116', text: 'Evan', gender: 'm' },
    { id: '1117', text: 'Evangelia', gender: 'f' },
    { id: '1118', text: 'Evangelos', gender: 'm' },
    { id: '1119', text: 'Eve', gender: 'f' },
    { id: '1120', text: 'Evelin', gender: 'f' },
    { id: '1121', text: 'Eveline', gender: 'f' },
    { id: '1122', text: 'Eveline', gender: 'f' },
    { id: '1123', text: 'Evelyn', gender: 'f' },
    { id: '1124', text: 'Evelyn', gender: 'f' },
    { id: '1125', text: 'Evelyne', gender: 'f' },
    { id: '1126', text: 'Evi', gender: 'f' },
    { id: '1127', text: 'Evin', gender: 'm' },
    { id: '1128', text: 'Evlana', gender: 'f' },
    { id: '1129', text: 'Ewa', gender: 'f' },
    { id: '1130', text: 'Ewald', gender: 'm' },
    { id: '1131', text: 'Eyleen', gender: 'f' },
    { id: '1132', text: 'Fabian', gender: 'm' },
    { id: '1133', text: 'Fabian', gender: 'm' },
    { id: '1134', text: 'Fabian Elias', gender: 'm' },
    { id: '1135', text: 'Fabian Jannick', gender: 'm' },
    { id: '1136', text: 'Fabian Pascal', gender: 'm' },
    { id: '1137', text: 'Fabien Luan', gender: 'm' },
    { id: '1138', text: 'Fabienne', gender: 'f' },
    { id: '1139', text: 'Fabienne', gender: 'f' },
    { id: '1140', text: 'Fabienne Danielle', gender: 'f' },
    { id: '1141', text: 'Fabienne-Sophie', gender: 'f' },
    { id: '1142', text: 'Fabio', gender: 'm' },
    { id: '1143', text: 'Fabiola', gender: 'f' },
    { id: '1144', text: 'Fabrice', gender: 'f' },
    { id: '1145', text: 'Fadime', gender: 'f' },
    { id: '1146', text: 'Falk', gender: 'm' },
    { id: '1147', text: 'Falko', gender: 'm' },
    { id: '1148', text: 'Fanny', gender: 'f' },
    { id: '1149', text: 'Farin', gender: 'm' },
    { id: '1150', text: 'Faruk', gender: 'm' },
    { id: '1151', text: 'Fatih', gender: 'm' },
    { id: '1152', text: 'Fatima', gender: 'f' },
    { id: '1153', text: 'Fatima', gender: 'f' },
    { id: '1154', text: 'Fatma', gender: 'f' },
    { id: '1155', text: 'Faye', gender: 'f' },
    { id: '1156', text: 'Federico', gender: 'm' },
    { id: '1157', text: 'Fedor', gender: 'm' },
    { id: '1158', text: 'Fee', gender: 'f' },
    { id: '1159', text: 'Felicia', gender: 'f' },
    { id: '1160', text: 'Felicia', gender: 'f' },
    { id: '1161', text: 'Felicitas', gender: 'f' },
    { id: '1162', text: 'Felicitas', gender: 'f' },
    { id: '1163', text: 'Feline', gender: 'f' },
    { id: '1164', text: 'Felipa', gender: 'f' },
    { id: '1165', text: 'Felix', gender: 'm' },
    { id: '1166', text: 'Felix', gender: 'm' },
    { id: '1167', text: 'Felix Luca', gender: 'm' },
    { id: '1168', text: 'Felizitas', gender: 'f' },
    { id: '1169', text: 'Fenja', gender: 'f' },
    { id: '1170', text: 'Fenna', gender: 'f' },
    { id: '1171', text: 'Ferdi', gender: 'm' },
    { id: '1172', text: 'Ferdinand', gender: 'm' },
    { id: '1173', text: 'Ferenc', gender: 'm' },
    { id: '1174', text: 'Fernanda Lynn', gender: 'f' },
    { id: '1175', text: 'Fernando', gender: 'm' },
    { id: '1176', text: 'Fernando', gender: 'm' },
    { id: '1177', text: 'Fidan', gender: 'f' },
    { id: '1178', text: 'Fiete', gender: 'm' },
    { id: '1179', text: 'Filine', gender: 'f' },
    { id: '1180', text: 'Filipo', gender: 'm' },
    { id: '1181', text: 'Filippo', gender: 'm' },
    { id: '1182', text: 'Filiz', gender: 'f' },
    { id: '1183', text: 'Fina', gender: 'f' },
    { id: '1184', text: 'Finja', gender: 'f' },
    { id: '1185', text: 'Finja Alina', gender: 'f' },
    { id: '1186', text: 'Finja Julie', gender: 'f' },
    { id: '1187', text: 'Finja-Marie', gender: 'f' },
    { id: '1188', text: 'Finja-Marie', gender: 'f' },
    { id: '1189', text: 'Finley', gender: 'm' },
    { id: '1190', text: 'Finn', gender: 'm' },
    { id: '1191', text: 'Finn / Fynn', gender: 'm' },
    { id: '1192', text: 'Finn Andreas', gender: 'm' },
    { id: '1193', text: 'Finn Emanuel', gender: 'm' },
    { id: '1194', text: 'Finn Jakob', gender: 'm' },
    { id: '1195', text: 'Finn Louis', gender: 'm' },
    { id: '1196', text: 'Finn Luca', gender: 'm' },
    { id: '1197', text: 'Finn Manuel Ivan', gender: 'm' },
    { id: '1198', text: 'Finn Niclas', gender: 'm' },
    { id: '1199', text: 'Finn Sören', gender: 'm' },
    { id: '1200', text: 'Finn-Alexander', gender: 'm' },
    { id: '1201', text: 'Finn-Jannig', gender: 'm' },
    { id: '1202', text: 'Finn-Julian', gender: 'm' },
    { id: '1203', text: 'Finn-Luca', gender: 'm' },
    { id: '1204', text: 'Finn-Maximilian', gender: 'm' },
    { id: '1205', text: 'Finnja', gender: 'f' },
    { id: '1206', text: 'Finnley', gender: 'm' },
    { id: '1207', text: 'Fiona', gender: 'f' },
    { id: '1208', text: 'Fiona Linnéa', gender: 'f' },
    { id: '1209', text: 'Fiona Sophie', gender: 'f' },
    { id: '1210', text: 'Flavio', gender: 'm' },
    { id: '1211', text: 'Flora', gender: 'f' },
    { id: '1212', text: 'Florence', gender: 'f' },
    { id: '1213', text: 'Florence estelle salome', gender: 'f' },
    { id: '1214', text: 'Florentin', gender: 'm' },
    { id: '1215', text: 'Florentine', gender: 'f' },
    { id: '1216', text: 'Florentine', gender: 'f' },
    { id: '1217', text: 'Florian', gender: 'm' },
    { id: '1218', text: 'Florian', gender: 'm' },
    { id: '1219', text: 'Florine', gender: 'f' },
    { id: '1220', text: 'Floris', gender: 'm' },
    { id: '1221', text: 'Flynn', gender: 'm' },
    { id: '1222', text: 'Folker', gender: 'm' },
    { id: '1223', text: 'Folkert', gender: 'm' },
    { id: '1224', text: 'Franca', gender: 'f' },
    { id: '1225', text: 'Francesca', gender: 'f' },
    { id: '1226', text: 'Francesco', gender: 'm' },
    { id: '1227', text: 'Francesco', gender: 'm' },
    { id: '1228', text: 'Francis', gender: 'm' },
    { id: '1229', text: 'Francisco', gender: 'm' },
    { id: '1230', text: 'Franco', gender: 'm' },
    { id: '1231', text: 'Francoise', gender: 'f' },
    { id: '1232', text: 'Franjo', gender: 'm' },
    { id: '1233', text: 'Frank', gender: 'm' },
    { id: '1234', text: 'Frank', gender: 'm' },
    { id: '1235', text: 'Frank-Michael', gender: 'm' },
    { id: '1236', text: 'Frank-Peter', gender: 'm' },
    { id: '1237', text: 'Franka', gender: 'f' },
    { id: '1238', text: 'Franscheska', gender: 'f' },
    { id: '1239', text: 'Franz', gender: 'm' },
    { id: '1240', text: 'Franz', gender: 'm' },
    { id: '1241', text: 'Franz Josef', gender: 'm' },
    { id: '1242', text: 'Franz-Josef', gender: 'm' },
    { id: '1243', text: 'Franz-Peter', gender: 'm' },
    { id: '1244', text: 'Franz-Xaver', gender: 'm' },
    { id: '1245', text: 'Franziska', gender: 'f' },
    { id: '1246', text: 'Franziska', gender: 'f' },
    { id: '1247', text: 'Franziska', gender: 'f' },
    { id: '1248', text: 'Frauke', gender: 'f' },
    { id: '1249', text: 'Fred', gender: 'm' },
    { id: '1250', text: 'Freddy', gender: 'm' },
    { id: '1251', text: 'Frederic', gender: 'm' },
    { id: '1252', text: 'Frederic', gender: 'm' },
    { id: '1253', text: 'Fredericke/Frederike', gender: 'f' },
    { id: '1254', text: 'Frederik', gender: 'm' },
    { id: '1255', text: 'Frederike', gender: 'f' },
    { id: '1256', text: 'Fredi', gender: 'm' },
    { id: '1257', text: 'Fredo', gender: 'm' },
    { id: '1258', text: 'Fredy', gender: 'm' },
    { id: '1259', text: 'Freia', gender: 'f' },
    { id: '1260', text: 'Freja', gender: 'f' },
    { id: '1261', text: 'Freya', gender: 'f' },
    { id: '1262', text: 'Freya', gender: 'f' },
    { id: '1263', text: 'Frida', gender: 'f' },
    { id: '1264', text: 'Frida', gender: 'f' },
    { id: '1265', text: 'Fridolin', gender: 'm' },
    { id: '1266', text: 'Frieda', gender: 'f' },
    { id: '1267', text: 'Frieda', gender: 'f' },
    { id: '1268', text: 'Friedbert', gender: 'm' },
    { id: '1269', text: 'Friedemann', gender: 'm' },
    { id: '1270', text: 'Frieder', gender: 'm' },
    { id: '1271', text: 'Friedericke', gender: 'f' },
    { id: '1272', text: 'Friederike', gender: 'f' },
    { id: '1273', text: 'Friederike Sofie', gender: 'f' },
    { id: '1274', text: 'Friedhelm', gender: 'm' },
    { id: '1275', text: 'Friedhelm', gender: 'm' },
    { id: '1276', text: 'Friedhelm-Heinrich', gender: 'm' },
    { id: '1277', text: 'Friedhilde', gender: 'f' },
    { id: '1278', text: 'Friedhold', gender: 'm' },
    { id: '1279', text: 'Friedl', gender: 'f' },
    { id: '1280', text: 'Friedlinde', gender: 'f' },
    { id: '1281', text: 'Friedo', gender: 'm' },
    { id: '1282', text: 'Friedolien', gender: 'm' },
    { id: '1283', text: 'Friedrich', gender: 'm' },
    { id: '1284', text: 'Friedrich-Karl', gender: 'm' },
    { id: '1285', text: 'Friedrich-Wilhelm', gender: 'm' },
    { id: '1286', text: 'Frithjof', gender: 'm' },
    { id: '1287', text: 'Fritz', gender: 'm' },
    { id: '1288', text: 'Fritz', gender: 'm' },
    { id: '1289', text: 'Fritz - Felix', gender: 'm' },
    { id: '1290', text: 'Fynn Lennox', gender: 'm' },
    { id: '1291', text: 'Fynn Louis', gender: 'm' },
    { id: '1292', text: 'Fynn Niclas', gender: 'm' },
    { id: '1293', text: 'Fynn Noel', gender: 'm' },
    { id: '1294', text: 'Fynn-Levin', gender: 'm' },
    { id: '1295', text: 'Fynn-Luca', gender: 'm' },
    { id: '1296', text: 'Gabi', gender: 'f' },
    { id: '1297', text: 'Gabor', gender: 'm' },
    { id: '1298', text: 'Gabriel', gender: 'm' },
    { id: '1299', text: 'Gabriel', gender: 'm' },
    { id: '1300', text: 'Gabriela', gender: 'f' },
    { id: '1301', text: 'Gabriele', gender: 'f' },
    { id: '1302', text: 'Gabriella', gender: 'f' },
    { id: '1303', text: 'Gabriella Victoria Saphira', gender: 'f' },
    { id: '1304', text: 'Gabrielle', gender: 'm' },
    { id: '1305', text: 'Gaby', gender: 'f' },
    { id: '1306', text: 'Gaetano', gender: 'm' },
    { id: '1307', text: 'Galina', gender: 'f' },
    { id: '1308', text: 'Gawin', gender: 'm' },
    { id: '1309', text: 'Gebhard', gender: 'm' },
    { id: '1310', text: 'Geert', gender: 'm' },
    { id: '1311', text: 'Genevi éve', gender: 'f' },
    { id: '1312', text: 'Genoveva', gender: 'f' },
    { id: '1313', text: 'Genta', gender: 'f' },
    { id: '1314', text: 'Georg', gender: 'm' },
    { id: '1315', text: 'George', gender: 'm' },
    { id: '1316', text: 'Georgia', gender: 'f' },
    { id: '1317', text: 'Georgine', gender: 'f' },
    { id: '1318', text: 'Georgios', gender: 'm' },
    { id: '1319', text: 'Gerald', gender: 'm' },
    { id: '1320', text: 'Geraldine', gender: 'f' },
    { id: '1321', text: 'Geraldine', gender: 'f' },
    { id: '1322', text: 'Gerard', gender: 'm' },
    { id: '1323', text: 'Gerd', gender: 'm' },
    { id: '1324', text: 'Gerda', gender: 'f' },
    { id: '1325', text: 'Gerdi', gender: 'f' },
    { id: '1326', text: 'Gereon', gender: 'm' },
    { id: '1327', text: 'Gereon', gender: 'm' },
    { id: '1328', text: 'Gerfried', gender: 'm' },
    { id: '1329', text: 'Gerhard', gender: 'm' },
    { id: '1330', text: 'Gerhard', gender: 'm' },
    { id: '1331', text: 'Gerhardt', gender: 'm' },
    { id: '1332', text: 'Gerhart', gender: 'm' },
    { id: '1333', text: 'Gerhild', gender: 'f' },
    { id: '1334', text: 'Gerlind', gender: 'f' },
    { id: '1335', text: 'Gerlinde', gender: 'f' },
    { id: '1336', text: 'German', gender: 'm' },
    { id: '1337', text: 'Gernot', gender: 'm' },
    { id: '1338', text: 'Gernot', gender: 'm' },
    { id: '1339', text: 'Gero', gender: 'm' },
    { id: '1340', text: 'Gerold', gender: 'm' },
    { id: '1341', text: 'Gerolf', gender: 'm' },
    { id: '1342', text: 'Gerrit', gender: 'm' },
    { id: '1343', text: 'Gerrit Julian', gender: 'm' },
    { id: '1344', text: 'Gert', gender: 'm' },
    { id: '1345', text: 'Gerta', gender: 'f' },
    { id: '1346', text: 'Gerti', gender: 'f' },
    { id: '1347', text: 'Gertraud', gender: 'f' },
    { id: '1348', text: 'Gertraude', gender: 'f' },
    { id: '1349', text: 'Gertraut', gender: 'f' },
    { id: '1350', text: 'Gertrud', gender: 'f' },
    { id: '1351', text: 'Gertrud', gender: 'f' },
    { id: '1352', text: 'Gertrude', gender: 'f' },
    { id: '1353', text: 'Gerwin', gender: 'm' },
    { id: '1354', text: 'Gesa', gender: 'f' },
    { id: '1355', text: 'Gesche', gender: 'f' },
    { id: '1356', text: 'Gesine', gender: 'f' },
    { id: '1357', text: 'Geza', gender: 'f' },
    { id: '1358', text: 'Gherom', gender: 'm' },
    { id: '1359', text: 'Gia-Celine', gender: 'f' },
    { id: '1360', text: 'Giacomo', gender: 'm' },
    { id: '1361', text: 'Gian Luca', gender: 'm' },
    { id: '1362', text: 'Gianna', gender: 'f' },
    { id: '1363', text: 'Gianni', gender: 'm' },
    { id: '1364', text: 'Gideon', gender: 'm' },
    { id: '1365', text: 'Giesela', gender: 'f' },
    { id: '1366', text: 'Gilbert', gender: 'm' },
    { id: '1367', text: 'Gilda', gender: 'f' },
    { id: '1368', text: 'Gina', gender: 'f' },
    { id: '1369', text: 'Gina', gender: 'f' },
    { id: '1370', text: 'Gina Lena', gender: 'f' },
    { id: '1371', text: 'Gina Maria', gender: 'f' },
    { id: '1372', text: 'Gina Marie', gender: 'f' },
    { id: '1373', text: 'Gino', gender: 'm' },
    { id: '1374', text: 'Gino', gender: 'm' },
    { id: '1375', text: 'Giordano', gender: 'm' },
    { id: '1376', text: 'Giorgio', gender: 'm' },
    { id: '1377', text: 'Giovanna', gender: 'f' },
    { id: '1378', text: 'Giovanni', gender: 'm' },
    { id: '1379', text: 'Gisa', gender: 'f' },
    { id: '1380', text: 'Gisbert', gender: 'm' },
    { id: '1381', text: 'Gisela', gender: 'f' },
    { id: '1382', text: 'Giselle', gender: 'f' },
    { id: '1383', text: 'Gislinde', gender: 'f' },
    { id: '1384', text: 'Gitta', gender: 'f' },
    { id: '1385', text: 'Gitte', gender: 'f' },
    { id: '1386', text: 'Giulia', gender: 'f' },
    { id: '1387', text: 'Giuljana', gender: 'f' },
    { id: '1388', text: 'Giuseppe', gender: 'm' },
    { id: '1389', text: 'Giuseppina', gender: 'f' },
    { id: '1390', text: 'Glen', gender: 'm' },
    { id: '1391', text: 'Gloria', gender: 'f' },
    { id: '1392', text: 'Gönül', gender: 'f' },
    { id: '1393', text: 'Goran', gender: 'm' },
    { id: '1394', text: 'Gordana', gender: 'f' },
    { id: '1395', text: 'Gordon', gender: 'm' },
    { id: '1396', text: 'Gordon', gender: 'm' },
    { id: '1397', text: 'Gottfried', gender: 'm' },
    { id: '1398', text: 'Gotthard', gender: 'm' },
    { id: '1399', text: 'Gotthilf', gender: 'm' },
    { id: '1400', text: 'Gotthold', gender: 'm' },
    { id: '1401', text: 'Gottlieb', gender: 'm' },
    { id: '1402', text: 'Gottlob', gender: 'm' },
    { id: '1403', text: 'Götz', gender: 'm' },
    { id: '1404', text: 'Grace', gender: 'f' },
    { id: '1405', text: 'Grazyna', gender: 'f' },
    { id: '1406', text: 'Gregor', gender: 'm' },
    { id: '1407', text: 'Gregorio-Juni', gender: 'm' },
    { id: '1408', text: 'Gregory', gender: 'm' },
    { id: '1409', text: 'Greta', gender: 'f' },
    { id: '1410', text: 'Greta', gender: 'f' },
    { id: '1411', text: 'Gretchen', gender: 'f' },
    { id: '1412', text: 'Gretchen', gender: 'f' },
    { id: '1413', text: 'Grete', gender: 'f' },
    { id: '1414', text: 'Gretel', gender: 'f' },
    { id: '1415', text: 'Gretl', gender: 'f' },
    { id: '1416', text: 'Griffin', gender: 'm' },
    { id: '1417', text: 'Grit', gender: 'f' },
    { id: '1418', text: 'Grizelda', gender: 'f' },
    { id: '1419', text: 'Grzegorz', gender: 'm' },
    { id: '1420', text: 'Guadalupe', gender: 'f' },
    { id: '1421', text: 'Gudrun', gender: 'f' },
    { id: '1422', text: 'Gudula', gender: 'f' },
    { id: '1423', text: 'Guenter', gender: 'm' },
    { id: '1424', text: 'Guenther', gender: 'm' },
    { id: '1425', text: 'Guido', gender: 'm' },
    { id: '1426', text: 'Guiliano', gender: 'm' },
    { id: '1427', text: 'Guiljanna-Josephine', gender: 'f' },
    { id: '1428', text: 'Guinevere', gender: 'f' },
    { id: '1429', text: 'Guiseppe', gender: 'm' },
    { id: '1430', text: 'Gülay', gender: 'f' },
    { id: '1431', text: 'Gülsah', gender: 'f' },
    { id: '1432', text: 'Gülsen', gender: 'f' },
    { id: '1433', text: 'Gülten', gender: 'f' },
    { id: '1434', text: 'Gunar', gender: 'm' },
    { id: '1435', text: 'Gunda', gender: 'f' },
    { id: '1436', text: 'Gunda', gender: 'f' },
    { id: '1437', text: 'Gundel', gender: 'f' },
    { id: '1438', text: 'Gundi', gender: 'f' },
    { id: '1439', text: 'Gundolf', gender: 'm' },
    { id: '1440', text: 'Gundula', gender: 'f' },
    { id: '1441', text: 'Gung', gender: 'm' },
    { id: '1442', text: 'Gunhild', gender: 'f' },
    { id: '1443', text: 'Gunnar', gender: 'm' },
    { id: '1444', text: 'Gunter', gender: 'm' },
    { id: '1445', text: 'Günter', gender: 'm' },
    { id: '1446', text: 'Gunther', gender: 'm' },
    { id: '1447', text: 'Günther', gender: 'm' },
    { id: '1448', text: 'Guntram', gender: 'm' },
    { id: '1449', text: 'Gustav', gender: 'm' },
    { id: '1450', text: 'Gustav', gender: 'm' },
    { id: '1451', text: 'Gusti', gender: 'f' },
    { id: '1452', text: 'Gwendolyn', gender: 'f' },
    { id: '1453', text: 'H.-Dieter', gender: 'm' },
    { id: '1454', text: 'Hadassa', gender: 'f' },
    { id: '1455', text: 'Hadrian', gender: 'm' },
    { id: '1456', text: 'Hagen', gender: 'm' },
    { id: '1457', text: 'Hagen', gender: 'm' },
    { id: '1458', text: 'Hailee-Mai', gender: 'f' },
    { id: '1459', text: 'Hailey', gender: 'f' },
    { id: '1460', text: 'Haily Jane', gender: 'f' },
    { id: '1461', text: 'Hajo', gender: 'm' },
    { id: '1462', text: 'Hakan', gender: 'm' },
    { id: '1463', text: 'Hakan', gender: 'm' },
    { id: '1464', text: 'Hakon', gender: 'm' },
    { id: '1465', text: 'Halil', gender: 'm' },
    { id: '1466', text: 'Halina', gender: 'f' },
    { id: '1467', text: 'Hallina', gender: 'f' },
    { id: '1468', text: 'Hanife', gender: 'f' },
    { id: '1469', text: 'Hanna', gender: 'f' },
    { id: '1470', text: 'Hannah', gender: 'f' },
    { id: '1471', text: 'Hannah / Hanna', gender: 'f' },
    { id: '1472', text: 'Hannah Loreen', gender: 'f' },
    { id: '1473', text: 'Hannah Sophia', gender: 'f' },
    { id: '1474', text: 'Hannah Sophie', gender: 'f' },
    { id: '1475', text: 'Hannchen', gender: 'f' },
    { id: '1476', text: 'Hanne', gender: 'f' },
    { id: '1477', text: 'Hanne-Lore', gender: 'f' },
    { id: '1478', text: 'Hannelore', gender: 'f' },
    { id: '1479', text: 'Hannes', gender: 'm' },
    { id: '1480', text: 'Hannes', gender: 'm' },
    { id: '1481', text: 'Hanni', gender: 'm' },
    { id: '1482', text: 'Hanno', gender: 'm' },
    { id: '1483', text: 'Hanno', gender: 'm' },
    { id: '1484', text: 'Hanns', gender: 'm' },
    { id: '1485', text: 'Hanny', gender: 'f' },
    { id: '1486', text: 'Hans', gender: 'm' },
    { id: '1487', text: 'Hans', gender: 'm' },
    { id: '1488', text: 'Hans D', gender: 'm' },
    { id: '1489', text: 'Hans Dieter', gender: 'm' },
    { id: '1490', text: 'Hans Georg', gender: 'm' },
    { id: '1491', text: 'Hans Jörg', gender: 'm' },
    { id: '1492', text: 'Hans Josef', gender: 'm' },
    { id: '1493', text: 'Hans Jürgen', gender: 'm' },
    { id: '1494', text: 'Hans Peter', gender: 'm' },
    { id: '1495', text: 'Hans Peter', gender: 'm' },
    { id: '1496', text: 'Hans-Adolf', gender: 'm' },
    { id: '1497', text: 'Hans-Albert', gender: 'm' },
    { id: '1498', text: 'Hans-Bernd', gender: 'm' },
    { id: '1499', text: 'Hans-Christian', gender: 'm' },
    { id: '1500', text: 'Hans-Detlef', gender: 'm' },
    { id: '1501', text: 'Hans-Dieter', gender: 'm' },
    { id: '1502', text: 'Hans-Dietrich', gender: 'm' },
    { id: '1503', text: 'Hans-Eberhard', gender: 'm' },
    { id: '1504', text: 'Hans-Erich', gender: 'm' },
    { id: '1505', text: 'Hans-Friedrich', gender: 'm' },
    { id: '1506', text: 'Hans-Georg', gender: 'm' },
    { id: '1507', text: 'Hans-Gerd', gender: 'm' },
    { id: '1508', text: 'Hans-Gerhard', gender: 'm' },
    { id: '1509', text: 'Hans-Günter', gender: 'm' },
    { id: '1510', text: 'Hans-Günther', gender: 'm' },
    { id: '1511', text: 'Hans-H', gender: 'm' },
    { id: '1512', text: 'Hans-Heinrich', gender: 'm' },
    { id: '1513', text: 'Hans-Helmut', gender: 'm' },
    { id: '1514', text: 'Hans-Henning', gender: 'm' },
    { id: '1515', text: 'Hans-Herbert', gender: 'm' },
    { id: '1516', text: 'Hans-Hermann', gender: 'm' },
    { id: '1517', text: 'Hans-Hinrich', gender: 'm' },
    { id: '1518', text: 'Hans-J', gender: 'm' },
    { id: '1519', text: 'Hans-Joachim', gender: 'm' },
    { id: '1520', text: 'Hans-Jochen', gender: 'm' },
    { id: '1521', text: 'Hans-Jörg', gender: 'm' },
    { id: '1522', text: 'Hans-Josef', gender: 'm' },
    { id: '1523', text: 'Hans-Jürgen', gender: 'm' },
    { id: '1524', text: 'Hans-Karl', gender: 'm' },
    { id: '1525', text: 'Hans-Ludwig', gender: 'm' },
    { id: '1526', text: 'Hans-Martin', gender: 'm' },
    { id: '1527', text: 'Hans-Michael', gender: 'm' },
    { id: '1528', text: 'Hans-Otto', gender: 'm' },
    { id: '1529', text: 'Hans-Peter', gender: 'm' },
    { id: '1530', text: 'Hans-Rainer', gender: 'm' },
    { id: '1531', text: 'Hans-Rudolf', gender: 'm' },
    { id: '1532', text: 'Hans-Theo', gender: 'm' },
    { id: '1533', text: 'Hans-Ulrich', gender: 'm' },
    { id: '1534', text: 'Hans-Uwe', gender: 'm' },
    { id: '1535', text: 'Hans-Walter', gender: 'm' },
    { id: '1536', text: 'Hans-Werner', gender: 'm' },
    { id: '1537', text: 'Hans-Wilhelm', gender: 'm' },
    { id: '1538', text: 'Hans-Willi', gender: 'm' },
    { id: '1539', text: 'Hans-Wolfgang', gender: 'm' },
    { id: '1540', text: 'Hansgeorg', gender: 'm' },
    { id: '1541', text: 'Hansi', gender: 'm' },
    { id: '1542', text: 'Hansjoachim', gender: 'm' },
    { id: '1543', text: 'Hansjörg', gender: 'm' },
    { id: '1544', text: 'Hansjürgen', gender: 'm' },
    { id: '1545', text: 'Hanspeter', gender: 'm' },
    { id: '1546', text: 'Harald', gender: 'm' },
    { id: '1547', text: 'Harald', gender: 'm' },
    { id: '1548', text: 'Hardy', gender: 'm' },
    { id: '1549', text: 'Harm', gender: 'm' },
    { id: '1550', text: 'Harold', gender: 'm' },
    { id: '1551', text: 'Harri', gender: 'm' },
    { id: '1552', text: 'Harriet', gender: 'f' },
    { id: '1553', text: 'Harro', gender: 'm' },
    { id: '1554', text: 'Harry', gender: 'm' },
    { id: '1555', text: 'Hartmut', gender: 'm' },
    { id: '1556', text: 'Hartmuth', gender: 'm' },
    { id: '1557', text: 'Hartwig', gender: 'm' },
    { id: '1558', text: 'Hasan', gender: 'm' },
    { id: '1559', text: 'Hassan', gender: 'm' },
    { id: '1560', text: 'Hassan', gender: 'm' },
    { id: '1561', text: 'Hasso', gender: 'm' },
    { id: '1562', text: 'Hatice', gender: 'f' },
    { id: '1563', text: 'Hayat', gender: 'f' },
    { id: '1564', text: 'Hazel', gender: 'f' },
    { id: '1565', text: 'Hedda', gender: 'f' },
    { id: '1566', text: 'Hedi', gender: 'f' },
    { id: '1567', text: 'Hedwig', gender: 'f' },
    { id: '1568', text: 'Hedy', gender: 'f' },
    { id: '1569', text: 'Heide', gender: 'f' },
    { id: '1570', text: 'Heide-Marie', gender: 'f' },
    { id: '1571', text: 'Heidelinde', gender: 'f' },
    { id: '1572', text: 'Heidelore', gender: 'f' },
    { id: '1573', text: 'Heidemarie', gender: 'f' },
    { id: '1574', text: 'Heiderose', gender: 'f' },
    { id: '1575', text: 'Heidi', gender: 'f' },
    { id: '1576', text: 'Heidrun', gender: 'f' },
    { id: '1577', text: 'Heike', gender: 'f' },
    { id: '1578', text: 'Heiko', gender: 'm' },
    { id: '1579', text: 'Heiko', gender: 'm' },
    { id: '1580', text: 'Heily', gender: 'f' },
    { id: '1581', text: 'Heimo', gender: 'm' },
    { id: '1582', text: 'Heiner', gender: 'm' },
    { id: '1583', text: 'Heinfried', gender: 'm' },
    { id: '1584', text: 'Heini', gender: 'm' },
    { id: '1585', text: 'Heino', gender: 'm' },
    { id: '1586', text: 'Heinrich', gender: 'm' },
    { id: '1587', text: 'Heinrich', gender: 'm' },
    { id: '1588', text: 'Heinz', gender: 'm' },
    { id: '1589', text: 'Heinz Dieter', gender: 'm' },
    { id: '1590', text: 'Heinz-Dieter', gender: 'm' },
    { id: '1591', text: 'Heinz-Georg', gender: 'm' },
    { id: '1592', text: 'Heinz-Gerd', gender: 'm' },
    { id: '1593', text: 'Heinz-Günter', gender: 'm' },
    { id: '1594', text: 'Heinz-Günther', gender: 'm' },
    { id: '1595', text: 'Heinz-Joachim', gender: 'm' },
    { id: '1596', text: 'Heinz-Josef', gender: 'm' },
    { id: '1597', text: 'Heinz-Jürgen', gender: 'm' },
    { id: '1598', text: 'Heinz-Otto', gender: 'm' },
    { id: '1599', text: 'Heinz-Peter', gender: 'm' },
    { id: '1600', text: 'Heinz-Walter', gender: 'm' },
    { id: '1601', text: 'Heinz-Werner', gender: 'm' },
    { id: '1602', text: 'Heinz-Wilhelm', gender: 'm' },
    { id: '1603', text: 'Heinz-Willi', gender: 'm' },
    { id: '1604', text: 'Hektor', gender: 'm' },
    { id: '1605', text: 'Helen', gender: 'f' },
    { id: '1606', text: 'Helen', gender: 'f' },
    { id: '1607', text: 'Helen Josephine', gender: 'f' },
    { id: '1608', text: 'Helena', gender: 'f' },
    { id: '1609', text: 'Helena', gender: 'f' },
    { id: '1610', text: 'Helene', gender: 'f' },
    { id: '1611', text: 'Helene', gender: 'f' },
    { id: '1612', text: 'Helene-Antonia', gender: 'f' },
    { id: '1613', text: 'Helenko', gender: 'm' },
    { id: '1614', text: 'Helfried', gender: 'm' },
    { id: '1615', text: 'Helga', gender: 'f' },
    { id: '1616', text: 'Helga', gender: 'f' },
    { id: '1617', text: 'Helge', gender: 'm' },
    { id: '1618', text: 'Hella', gender: 'f' },
    { id: '1619', text: 'Hellen', gender: 'f' },
    { id: '1620', text: 'Hellmut', gender: 'm' },
    { id: '1621', text: 'Hellmuth', gender: 'm' },
    { id: '1622', text: 'Helma', gender: 'f' },
    { id: '1623', text: 'Helmar', gender: 'm' },
    { id: '1624', text: 'Helmtrud', gender: 'f' },
    { id: '1625', text: 'Helmut', gender: 'm' },
    { id: '1626', text: 'Helmuth', gender: 'm' },
    { id: '1627', text: 'Hendrik', gender: 'm' },
    { id: '1628', text: 'Henner', gender: 'm' },
    { id: '1629', text: 'Henni', gender: 'f' },
    { id: '1630', text: 'Henning', gender: 'm' },
    { id: '1631', text: 'Henny', gender: 'f' },
    { id: '1632', text: 'Henri', gender: 'f' },
    { id: '1633', text: 'Henriette', gender: 'f' },
    { id: '1634', text: 'Henrik', gender: 'm' },
    { id: '1635', text: 'Henrik Ryan', gender: 'm' },
    { id: '1636', text: 'Henrike', gender: 'f' },
    { id: '1637', text: 'Henry', gender: 'm' },
    { id: '1638', text: 'Henry', gender: 'm' },
    { id: '1639', text: 'Henry Ben', gender: 'm' },
    { id: '1640', text: 'Henryk', gender: 'm' },
    { id: '1641', text: 'Herbert', gender: 'm' },
    { id: '1642', text: 'Herbert', gender: 'm' },
    { id: '1643', text: 'Heribert', gender: 'm' },
    { id: '1644', text: 'Herkules', gender: 'm' },
    { id: '1645', text: 'Herlinde', gender: 'f' },
    { id: '1646', text: 'Herma', gender: 'f' },
    { id: '1647', text: 'Hermann', gender: 'm' },
    { id: '1648', text: 'Hermann Josef', gender: 'm' },
    { id: '1649', text: 'Hermann-Josef', gender: 'm' },
    { id: '1650', text: 'Hermine', gender: 'f' },
    { id: '1651', text: 'Herrmann', gender: 'm' },
    { id: '1652', text: 'Hert', gender: 'm' },
    { id: '1653', text: 'Herta', gender: 'f' },
    { id: '1654', text: 'Hertha', gender: 'f' },
    { id: '1655', text: 'Herwig', gender: 'm' },
    { id: '1656', text: 'Hien', gender: 'm' },
    { id: '1657', text: 'Hilda', gender: 'f' },
    { id: '1658', text: 'Hildburg', gender: 'f' },
    { id: '1659', text: 'Hilde', gender: 'f' },
    { id: '1660', text: 'Hildegard', gender: 'f' },
    { id: '1661', text: 'Hildegart', gender: 'f' },
    { id: '1662', text: 'Hildegund', gender: 'f' },
    { id: '1663', text: 'Hildegunde', gender: 'f' },
    { id: '1664', text: 'Hilko', gender: 'm' },
    { id: '1665', text: 'Hilma', gender: 'f' },
    { id: '1666', text: 'Hilmar', gender: 'm' },
    { id: '1667', text: 'Hiltraud', gender: 'f' },
    { id: '1668', text: 'Hiltrud', gender: 'f' },
    { id: '1669', text: 'Hiltrud - Josepha', gender: 'f' },
    { id: '1670', text: 'Hinata', gender: 'f' },
    { id: '1671', text: 'Hinrich', gender: 'm' },
    { id: '1672', text: 'Holger', gender: 'm' },
    { id: '1673', text: 'Holly', gender: 'f' },
    { id: '1674', text: 'Holm', gender: 'm' },
    { id: '1675', text: 'Hope', gender: 'f' },
    { id: '1676', text: 'Horst', gender: 'm' },
    { id: '1677', text: 'Horst', gender: 'm' },
    { id: '1678', text: 'Horst-Dieter', gender: 'm' },
    { id: '1679', text: 'Horst-Günter', gender: 'm' },
    { id: '1680', text: 'Horst-Peter', gender: 'm' },
    { id: '1681', text: 'Horst-Sergio', gender: 'm' },
    { id: '1682', text: 'Hubert', gender: 'm' },
    { id: '1683', text: 'Hubert', gender: 'm' },
    { id: '1684', text: 'Hubertine', gender: 'f' },
    { id: '1685', text: 'Hubertus', gender: 'm' },
    { id: '1686', text: 'Hugo', gender: 'm' },
    { id: '1687', text: 'Hugo', gender: 'm' },
    { id: '1688', text: 'Hulda', gender: 'f' },
    { id: '1689', text: 'Hülya', gender: 'f' },
    { id: '1690', text: 'Hüseyin', gender: 'm' },
    { id: '1691', text: 'Ian', gender: 'm' },
    { id: '1692', text: 'Ian', gender: 'm' },
    { id: '1693', text: 'Ian Alexander', gender: 'm' },
    { id: '1694', text: 'Ian Bennet', gender: 'm' },
    { id: '1695', text: 'ian Jawin', gender: 'm' },
    { id: '1696', text: 'Ibo', gender: 'm' },
    { id: '1697', text: 'Ibrahim', gender: 'm' },
    { id: '1698', text: 'Iclal', gender: 'f' },
    { id: '1699', text: 'Ida', gender: 'f' },
    { id: '1700', text: 'Ida', gender: 'f' },
    { id: '1701', text: 'Ieon', gender: 'm' },
    { id: '1702', text: 'Ignatz', gender: 'm' },
    { id: '1703', text: 'Ignaz', gender: 'm' },
    { id: '1704', text: 'Igor', gender: 'm' },
    { id: '1705', text: 'Iker', gender: 'm' },
    { id: '1706', text: 'Ilaj', gender: 'm' },
    { id: '1707', text: 'Ilaria', gender: 'f' },
    { id: '1708', text: 'Ilario', gender: 'm' },
    { id: '1709', text: 'Ildiko', gender: 'f' },
    { id: '1710', text: 'Ilenia', gender: 'f' },
    { id: '1711', text: 'Ilhan', gender: 'm' },
    { id: '1712', text: 'Ilias', gender: 'm' },
    { id: '1713', text: 'ilias', gender: 'm' },
    { id: '1714', text: 'Ilija', gender: 'm' },
    { id: '1715', text: 'Ilirian', gender: 'm' },
    { id: '1716', text: 'Ilja', gender: 'm' },
    { id: '1717', text: 'Iljana', gender: 'f' },
    { id: '1718', text: 'Iljas', gender: 'm' },
    { id: '1719', text: 'Ilka', gender: 'f' },
    { id: '1720', text: 'Ilona', gender: 'f' },
    { id: '1721', text: 'Ilonka', gender: 'f' },
    { id: '1722', text: 'Ilse', gender: 'f' },
    { id: '1723', text: 'Ilvy-Marie', gender: 'f' },
    { id: '1724', text: 'Imelda', gender: 'f' },
    { id: '1725', text: 'Imke', gender: 'f' },
    { id: '1726', text: 'Immo', gender: 'm' },
    { id: '1727', text: 'Imre', gender: 'm' },
    { id: '1728', text: 'Ina', gender: 'f' },
    { id: '1729', text: 'Ina', gender: 'f' },
    { id: '1730', text: 'Inaula Fiona', gender: 'f' },
    { id: '1731', text: 'Indira', gender: 'f' },
    { id: '1732', text: 'Ines', gender: 'f' },
    { id: '1733', text: 'Ines', gender: 'f' },
    { id: '1734', text: 'Inex', gender: 'f' },
    { id: '1735', text: 'Inga', gender: 'f' },
    { id: '1736', text: 'Inga', gender: 'f' },
    { id: '1737', text: 'Ingbert', gender: 'm' },
    { id: '1738', text: 'Inge', gender: 'f' },
    { id: '1739', text: 'Ingeborg', gender: 'f' },
    { id: '1740', text: 'Ingeburg', gender: 'f' },
    { id: '1741', text: 'Ingelore', gender: 'f' },
    { id: '1742', text: 'Ingetraud', gender: 'f' },
    { id: '1743', text: 'Ingetraut', gender: 'f' },
    { id: '1744', text: 'Ingmar', gender: 'm' },
    { id: '1745', text: 'Ingo', gender: 'm' },
    { id: '1746', text: 'Ingolf', gender: 'm' },
    { id: '1747', text: 'Ingrid', gender: 'f' },
    { id: '1748', text: 'Ingried', gender: 'f' },
    { id: '1749', text: 'Inka', gender: 'f' },
    { id: '1750', text: 'Inken', gender: 'f' },
    { id: '1751', text: 'Inken', gender: 'f' },
    { id: '1752', text: 'Inna', gender: 'f' },
    { id: '1753', text: 'Inna', gender: 'f' },
    { id: '1754', text: 'Insa', gender: 'f' },
    { id: '1755', text: 'Ioannis', gender: 'm' },
    { id: '1756', text: 'Ioannis', gender: 'm' },
    { id: '1757', text: 'Ira', gender: 'f' },
    { id: '1758', text: 'Irena', gender: 'f' },
    { id: '1759', text: 'Irene', gender: 'f' },
    { id: '1760', text: 'Irina', gender: 'f' },
    { id: '1761', text: 'Iris', gender: 'f' },
    { id: '1762', text: 'Iris', gender: 'f' },
    { id: '1763', text: 'Irma', gender: 'f' },
    { id: '1764', text: 'Irmela', gender: 'f' },
    { id: '1765', text: 'Irmengard', gender: 'f' },
    { id: '1766', text: 'Irmengart', gender: 'f' },
    { id: '1767', text: 'Irmgard', gender: 'f' },
    { id: '1768', text: 'Irmhild', gender: 'f' },
    { id: '1769', text: 'Irmi', gender: 'f' },
    { id: '1770', text: 'Irmingard', gender: 'f' },
    { id: '1771', text: 'Irmtraud', gender: 'f' },
    { id: '1772', text: 'Irmtraut', gender: 'f' },
    { id: '1773', text: 'Irmtrud', gender: 'f' },
    { id: '1774', text: 'Isa', gender: 'f' },
    { id: '1775', text: 'Isabel', gender: 'f' },
    { id: '1776', text: 'Isabell', gender: 'f' },
    { id: '1777', text: 'Isabella', gender: 'f' },
    { id: '1778', text: 'Isabella', gender: 'f' },
    { id: '1779', text: 'Isabella Marie', gender: 'f' },
    { id: '1780', text: 'Isabelle', gender: 'f' },
    { id: '1781', text: 'Isabelle', gender: 'f' },
    { id: '1782', text: 'Isadora', gender: 'f' },
    { id: '1783', text: 'Isaline', gender: 'f' },
    { id: '1784', text: 'Isidor', gender: 'm' },
    { id: '1785', text: 'Ismail', gender: 'm' },
    { id: '1786', text: 'Ismet', gender: 'm' },
    { id: '1787', text: 'Isolde', gender: 'f' },
    { id: '1788', text: 'Istvan', gender: 'm' },
    { id: '1789', text: 'Italy', gender: 'f' },
    { id: '1790', text: 'Ivan', gender: 'm' },
    { id: '1791', text: 'Ivan', gender: 'm' },
    { id: '1792', text: 'Ivan Simon', gender: 'm' },
    { id: '1793', text: 'Ivana', gender: 'f' },
    { id: '1794', text: 'Ivanka', gender: 'f' },
    { id: '1795', text: 'Ive', gender: 'm' },
    { id: '1796', text: 'Iven', gender: 'm' },
    { id: '1797', text: 'Ivo', gender: 'm' },
    { id: '1798', text: 'Ivo', gender: 'm' },
    { id: '1799', text: 'Ivonne', gender: 'f' },
    { id: '1800', text: 'Iwan', gender: 'm' },
    { id: '1801', text: 'Iwona', gender: 'f' },
    { id: '1802', text: 'Jacek', gender: 'm' },
    { id: '1803', text: 'Jack', gender: 'm' },
    { id: '1804', text: 'Jacob', gender: 'm' },
    { id: '1805', text: 'Jacob', gender: 'm' },
    { id: '1806', text: 'Jacqueline', gender: 'f' },
    { id: '1807', text: 'Jacqueline', gender: 'f' },
    { id: '1808', text: 'Jacumo', gender: 'm' },
    { id: '1809', text: 'Jacy Amon', gender: 'm' },
    { id: '1810', text: 'Jade', gender: 'f' },
    { id: '1811', text: 'Jade Judith', gender: 'f' },
    { id: '1812', text: 'Jaden', gender: 'm' },
    { id: '1813', text: 'Jaden Damian', gender: 'm' },
    { id: '1814', text: 'Jaden kian', gender: 'm' },
    { id: '1815', text: 'Jaden-Romeo', gender: 'm' },
    { id: '1816', text: 'Jadwiga', gender: 'f' },
    { id: '1817', text: 'Jael', gender: 'f' },
    { id: '1818', text: 'Jaël', gender: 'm' },
    { id: '1819', text: 'Jahn', gender: 'm' },
    { id: '1820', text: 'Jakob', gender: 'm' },
    { id: '1821', text: 'Jakob', gender: 'm' },
    { id: '1822', text: 'Jakomo', gender: 'm' },
    { id: '1823', text: 'Jakub', gender: 'm' },
    { id: '1824', text: 'Jamal', gender: 'm' },
    { id: '1825', text: 'Jamal-Noel', gender: 'm' },
    { id: '1826', text: 'James', gender: 'm' },
    { id: '1827', text: 'James', gender: 'm' },
    { id: '1828', text: 'Jamie', gender: 'm' },
    { id: '1829', text: 'Jamie Joel', gender: 'm' },
    { id: '1830', text: 'Jamie Luca', gender: 'm' },
    { id: '1831', text: 'Jamie Lynn', gender: 'f' },
    { id: '1832', text: 'Jamie Ramon', gender: 'm' },
    { id: '1833', text: 'Jamiela-Sophie', gender: 'f' },
    { id: '1834', text: 'Jamil', gender: 'm' },
    { id: '1835', text: 'Jamina', gender: 'f' },
    { id: '1836', text: 'Jamy', gender: 'm' },
    { id: '1837', text: 'Jan', gender: 'm' },
    { id: '1838', text: 'Jan', gender: 'm' },
    { id: '1839', text: 'Jan Aron', gender: 'm' },
    { id: '1840', text: 'Jan Christian', gender: 'm' },
    { id: '1841', text: 'Jan Elias', gender: 'm' },
    { id: '1842', text: 'Jan Erik', gender: 'm' },
    { id: '1843', text: 'Jan Finley', gender: 'm' },
    { id: '1844', text: 'Jan Leon', gender: 'm' },
    { id: '1845', text: 'Jan Luca', gender: 'm' },
    { id: '1846', text: 'Jan Marco', gender: 'm' },
    { id: '1847', text: 'Jan Niklas', gender: 'm' },
    { id: '1848', text: 'Jan Ole', gender: 'm' },
    { id: '1849', text: 'Jan-Paul', gender: 'm' },
    { id: '1850', text: 'Jan-Peter', gender: 'm' },
    { id: '1851', text: 'Jan-Philipp', gender: 'm' },
    { id: '1852', text: 'Jana', gender: 'f' },
    { id: '1853', text: 'Jana', gender: 'f' },
    { id: '1854', text: 'Jana Emilia', gender: 'f' },
    { id: '1855', text: 'Jana-Ina', gender: 'f' },
    { id: '1856', text: 'Jane', gender: 'f' },
    { id: '1857', text: 'Jane', gender: 'f' },
    { id: '1858', text: 'Janeck / Jannek', gender: 'm' },
    { id: '1859', text: 'Janek-Luca', gender: 'm' },
    { id: '1860', text: 'Janelle', gender: 'f' },
    { id: '1861', text: 'Janet', gender: 'f' },
    { id: '1862', text: 'Janett', gender: 'f' },
    { id: '1863', text: 'Janette', gender: 'f' },
    { id: '1864', text: 'Janice', gender: 'f' },
    { id: '1865', text: 'Janick', gender: 'm' },
    { id: '1866', text: 'Janin', gender: 'f' },
    { id: '1867', text: 'Janina', gender: 'f' },
    { id: '1868', text: 'Janina', gender: 'f' },
    { id: '1869', text: 'Janina Justine', gender: 'f' },
    { id: '1870', text: 'Janina Marie', gender: 'f' },
    { id: '1871', text: 'Janine', gender: 'f' },
    { id: '1872', text: 'Janine', gender: 'f' },
    { id: '1873', text: 'Janis / Jannis / Yannis', gender: 'm' },
    { id: '1874', text: 'Janko', gender: 'm' },
    { id: '1875', text: 'Jann', gender: 'm' },
    { id: '1876', text: 'Janna', gender: 'f' },
    { id: '1877', text: 'Janne', gender: 'f' },
    { id: '1878', text: 'Janne Sophie', gender: 'f' },
    { id: '1879', text: 'Jannes', gender: 'm' },
    { id: '1880', text: 'Jannes-Ramon', gender: 'm' },
    {
      id: '1881',
      text: 'Jannick Kornelius Lennox Maximilian Noel',
      gender: 'm'
    },
    { id: '1882', text: 'Jannika-Michelle', gender: 'f' },
    { id: '1883', text: 'Jannis', gender: 'm' },
    { id: '1884', text: 'Jannis Elias', gender: 'm' },
    { id: '1885', text: 'Jannisch', gender: 'm' },
    { id: '1886', text: 'Janos', gender: 'm' },
    { id: '1887', text: 'Janouk', gender: 'f' },
    { id: '1888', text: 'Janus', gender: 'm' },
    { id: '1889', text: 'Janusz', gender: 'm' },
    { id: '1890', text: 'Jaqueline', gender: 'f' },
    { id: '1891', text: 'Jaqueline', gender: 'f' },
    { id: '1892', text: 'Jara', gender: 'f' },
    { id: '1893', text: 'Jari-Noel', gender: 'm' },
    { id: '1894', text: 'Jaromir Anakin', gender: 'm' },
    { id: '1895', text: 'Jaron', gender: 'm' },
    { id: '1896', text: 'Jaron Elia', gender: 'm' },
    { id: '1897', text: 'Jaron Noel', gender: 'm' },
    { id: '1898', text: 'Jaroslav', gender: 'm' },
    { id: '1899', text: 'Jaroslaw', gender: 'm' },
    { id: '1900', text: 'Jaroslaw', gender: 'm' },
    { id: '1901', text: 'Jarvis', gender: 'm' },
    { id: '1902', text: 'Jaser', gender: 'm' },
    { id: '1903', text: 'Jasmin', gender: 'f' },
    { id: '1904', text: 'Jasmin', gender: 'f' },
    { id: '1905', text: 'Jasmin Aurèlie', gender: 'f' },
    { id: '1906', text: 'Jasmin Jolie', gender: 'f' },
    { id: '1907', text: 'Jasmina', gender: 'f' },
    { id: '1908', text: 'Jasmina Joline', gender: 'f' },
    { id: '1909', text: 'jason', gender: 'm' },
    { id: '1910', text: 'Jason', gender: 'm' },
    { id: '1911', text: 'Jason Jeremy', gender: 'm' },
    { id: '1912', text: 'Jason Joel', gender: 'm' },
    { id: '1913', text: 'Jason Leandro', gender: 'm' },
    { id: '1914', text: 'Jason Tylor', gender: 'm' },
    { id: '1915', text: 'Jason-Lennox', gender: 'm' },
    { id: '1916', text: 'Jason-Lorean', gender: 'm' },
    { id: '1917', text: 'Jasper', gender: 'm' },
    { id: '1918', text: 'Jayden', gender: 'm' },
    { id: '1919', text: 'Jayla', gender: 'f' },
    { id: '1920', text: 'Jaz Jade', gender: 'f' },
    { id: '1921', text: 'Jean', gender: 'm' },
    { id: '1922', text: 'Jean Luca', gender: 'm' },
    { id: '1923', text: 'Jean Marc', gender: 'm' },
    { id: '1924', text: 'Jean Pierre', gender: 'm' },
    { id: '1925', text: 'Jean-Paul', gender: 'm' },
    { id: '1926', text: 'Jeanette', gender: 'f' },
    { id: '1927', text: 'Jeanette', gender: 'f' },
    { id: '1928', text: 'Jeanne', gender: 'f' },
    { id: '1929', text: 'Jeanne', gender: 'f' },
    { id: '1930', text: 'Jeannette', gender: 'f' },
    { id: '1931', text: 'Jeannine', gender: 'f' },
    { id: '1932', text: 'Jeannine', gender: 'f' },
    { id: '1933', text: 'Jeffery', gender: 'm' },
    { id: '1934', text: 'Jelena', gender: 'f' },
    { id: '1935', text: 'Jelena', gender: 'f' },
    { id: '1936', text: 'Jelle', gender: 'm' },
    { id: '1937', text: 'Jemma', gender: 'f' },
    { id: '1938', text: 'Jemmy', gender: 'm' },
    { id: '1939', text: 'Jenna', gender: 'f' },
    { id: '1940', text: 'Jennifer', gender: 'f' },
    { id: '1941', text: 'Jennifer', gender: 'f' },
    { id: '1942', text: 'Jennifer andrea', gender: 'f' },
    { id: '1943', text: 'Jennifer Melanie', gender: 'f' },
    { id: '1944', text: 'Jenny', gender: 'f' },
    { id: '1945', text: 'Jenny', gender: 'f' },
    { id: '1946', text: 'Jenny Seline', gender: 'f' },
    { id: '1947', text: 'Jenny-Lea', gender: 'f' },
    { id: '1948', text: 'Jens', gender: 'm' },
    { id: '1949', text: 'Jens-Peter', gender: 'm' },
    { id: '1950', text: 'Jens-Uwe', gender: 'm' },
    { id: '1951', text: 'Jeremias', gender: 'm' },
    { id: '1952', text: 'Jeremy', gender: 'm' },
    { id: '1953', text: 'Jeremy Antonio', gender: 'm' },
    { id: '1954', text: 'Jéremy Joël', gender: 'm' },
    { id: '1955', text: 'Jeremy Sean', gender: 'm' },
    { id: '1956', text: 'Jermain Taylan JT', gender: 'm' },
    { id: '1957', text: 'Jermaine Marvin', gender: 'm' },
    { id: '1958', text: 'Jerome', gender: 'm' },
    { id: '1959', text: 'Jerry', gender: 'm' },
    { id: '1960', text: 'Jerzy', gender: 'm' },
    { id: '1961', text: 'Jessica', gender: 'f' },
    { id: '1962', text: 'Jessica', gender: 'f' },
    { id: '1963', text: 'Jessica-Joana', gender: 'f' },
    { id: '1964', text: 'Jessika', gender: 'f' },
    { id: '1965', text: 'Jessy Elias', gender: 'm' },
    { id: '1966', text: 'Jetta', gender: 'f' },
    { id: '1967', text: 'Jette', gender: 'f' },
    { id: '1968', text: 'Jey Ryan Luca', gender: 'm' },
    { id: '1969', text: 'Jil', gender: 'f' },
    { id: '1970', text: 'Jill', gender: 'f' },
    { id: '1971', text: 'Jill-Julie', gender: 'f' },
    { id: '1972', text: 'Jilliana', gender: 'f' },
    { id: '1973', text: 'Jillien', gender: 'f' },
    { id: '1974', text: 'Jim', gender: 'm' },
    { id: '1975', text: 'Jim Luca', gender: 'm' },
    { id: '1976', text: 'Jimmy', gender: 'm' },
    { id: '1977', text: 'Jiri', gender: 'm' },
    { id: '1978', text: 'Jjeannne', gender: 'f' },
    { id: '1979', text: 'Jo', gender: 'f' },
    { id: '1980', text: 'Jo', gender: 'f' },
    { id: '1981', text: 'Jo', gender: 'm' },
    { id: '1982', text: 'Joachim', gender: 'm' },
    { id: '1983', text: 'Joah Levin', gender: 'm' },
    { id: '1984', text: 'Joan', gender: 'f' },
    { id: '1985', text: 'Joan', gender: 'm' },
    { id: '1986', text: 'Joan Alicia', gender: 'f' },
    { id: '1987', text: 'Joan Liv', gender: 'f' },
    { id: '1988', text: 'Joana', gender: 'f' },
    { id: '1989', text: 'Joana Julie', gender: 'f' },
    { id: '1990', text: 'Joana Maxime', gender: 'f' },
    { id: '1991', text: 'Joanna', gender: 'f' },
    { id: '1992', text: 'Joanna', gender: 'f' },
    { id: '1993', text: 'Jobst', gender: 'm' },
    { id: '1994', text: 'Jocelyn', gender: 'f' },
    { id: '1995', text: 'Jochem', gender: 'm' },
    { id: '1996', text: 'Jochen', gender: 'm' },
    { id: '1997', text: 'Jocy', gender: 'f' },
    { id: '1998', text: 'Joda', gender: 'm' },
    { id: '1999', text: 'Joe', gender: 'm' },
    { id: '2000', text: 'Joel', gender: 'm' },
    { id: '2001', text: 'Joel - christian', gender: 'm' },
    { id: '2002', text: 'Joel Benjamin', gender: 'm' },
    { id: '2003', text: 'Joel Dennis', gender: 'm' },
    { id: '2004', text: 'Joel-Daniel', gender: 'm' },
    { id: '2005', text: 'Joenna', gender: 'f' },
    { id: '2006', text: 'Joerg', gender: 'm' },
    { id: '2007', text: 'Joey', gender: 'm' },
    { id: '2008', text: 'Johan', gender: 'm' },
    { id: '2009', text: 'Johann', gender: 'm' },
    { id: '2010', text: 'Johanna', gender: 'f' },
    { id: '2011', text: 'Johanna', gender: 'f' },
    { id: '2012', text: 'Johanna Jane', gender: 'f' },
    { id: '2013', text: 'Johanne', gender: 'f' },
    { id: '2014', text: 'Johannes', gender: 'm' },
    { id: '2015', text: 'Johannes', gender: 'm' },
    { id: '2016', text: 'John', gender: 'm' },
    { id: '2017', text: 'John / Johnny', gender: 'm' },
    { id: '2018', text: 'John Leon', gender: 'm' },
    { id: '2019', text: 'John Luc', gender: 'f' },
    { id: '2020', text: 'John Paul', gender: 'm' },
    { id: '2021', text: 'John-pascal', gender: 'm' },
    { id: '2022', text: 'Johnas', gender: 'm' },
    { id: '2023', text: 'Johny', gender: 'm' },
    { id: '2024', text: 'Jolanda', gender: 'f' },
    { id: '2025', text: 'Jolander', gender: 'm' },
    { id: '2026', text: 'Jolanta', gender: 'f' },
    { id: '2027', text: 'Jolanthe', gender: 'f' },
    { id: '2028', text: 'Joleen', gender: 'f' },
    { id: '2029', text: 'Jolene', gender: 'f' },
    { id: '2030', text: 'Joli', gender: 'f' },
    { id: '2031', text: 'Jolie', gender: 'f' },
    { id: '2032', text: 'Jolienna', gender: 'f' },
    { id: '2033', text: 'Jolina', gender: 'f' },
    { id: '2034', text: 'Jolina Joise', gender: 'f' },
    { id: '2035', text: 'Jolina Noel', gender: 'f' },
    { id: '2036', text: 'Joline', gender: 'f' },
    { id: '2037', text: 'Joline-Maya', gender: 'f' },
    { id: '2038', text: 'Joly', gender: 'f' },
    { id: '2039', text: 'Jona-Maximillian', gender: 'm' },
    { id: '2040', text: 'Jonah', gender: 'm' },
    { id: '2041', text: 'Jonas', gender: 'm' },
    { id: '2042', text: 'Jonas', gender: 'm' },
    { id: '2043', text: 'Jonas', gender: 'm' },
    { id: '2044', text: 'Jonas Fabian', gender: 'm' },
    { id: '2045', text: 'Jonas Samuel', gender: 'm' },
    { id: '2046', text: 'Jonas-Maximilian', gender: 'm' },
    { id: '2047', text: 'Jonathan', gender: 'm' },
    { id: '2048', text: 'Jonathan', gender: 'm' },
    { id: '2049', text: 'Jonna', gender: 'f' },
    { id: '2050', text: 'Jonna', gender: 'f' },
    { id: '2051', text: 'Jonna marlena', gender: 'f' },
    { id: '2052', text: 'Jonny', gender: 'm' },
    { id: '2053', text: 'Joona', gender: 'm' },
    { id: '2054', text: 'Joonas', gender: 'f' },
    { id: '2055', text: 'Joost', gender: 'm' },
    { id: '2056', text: 'Jorcho', gender: 'm' },
    { id: '2057', text: 'Jordan Joell', gender: 'm' },
    { id: '2058', text: 'Jores', gender: 'm' },
    { id: '2059', text: 'Jörg', gender: 'm' },
    { id: '2060', text: 'Jörg-Peter', gender: 'm' },
    { id: '2061', text: 'Jorgana', gender: 'f' },
    { id: '2062', text: 'Jorge', gender: 'm' },
    { id: '2063', text: 'Jörgen', gender: 'm' },
    { id: '2064', text: 'Joris', gender: 'm' },
    { id: '2065', text: 'Jorma', gender: 'm' },
    { id: '2066', text: 'Jörn', gender: 'm' },
    { id: '2067', text: 'Joscha', gender: 'm' },
    { id: '2068', text: 'Joschka', gender: 'm' },
    { id: '2069', text: 'Joschua', gender: 'm' },
    { id: '2070', text: 'Jose', gender: 'm' },
    { id: '2071', text: 'José', gender: 'm' },
    { id: '2072', text: 'Josef', gender: 'm' },
    { id: '2073', text: 'Josefa', gender: 'f' },
    { id: '2074', text: 'Josefa', gender: 'f' },
    { id: '2075', text: 'Josefine', gender: 'f' },
    { id: '2076', text: 'Joseph', gender: 'm' },
    { id: '2077', text: 'Joseph', gender: 'm' },
    { id: '2078', text: 'Josephine', gender: 'f' },
    { id: '2079', text: 'Josephine / Josefine', gender: 'f' },
    { id: '2080', text: 'Josephine Joy', gender: 'f' },
    { id: '2081', text: 'Josephine Summer', gender: 'f' },
    { id: '2082', text: 'Josephine-Chiara', gender: 'f' },
    { id: '2083', text: 'Josh', gender: 'm' },
    { id: '2084', text: 'Joshua', gender: 'm' },
    { id: '2085', text: 'Joshua - Samuel', gender: 'm' },
    { id: '2086', text: 'Joshua Maximilien', gender: 'm' },
    { id: '2087', text: 'Josip', gender: 'm' },
    { id: '2088', text: 'Jost', gender: 'm' },
    { id: '2089', text: 'Jost', gender: 'm' },
    { id: '2090', text: 'Josue', gender: 'm' },
    { id: '2091', text: 'Joudia', gender: 'f' },
    { id: '2092', text: 'Jourel', gender: 'm' },
    { id: '2093', text: 'Jovan', gender: 'm' },
    { id: '2094', text: 'Joy', gender: 'f' },
    { id: '2095', text: 'Joy Lee', gender: 'f' },
    { id: '2096', text: 'Joy Rhianna', gender: 'f' },
    { id: '2097', text: 'Joy Sophia', gender: 'f' },
    { id: '2098', text: 'Joyce Dilara', gender: 'f' },
    { id: '2099', text: 'Joys', gender: 'f' },
    { id: '2100', text: 'Jozef', gender: 'm' },
    { id: '2101', text: 'Juan', gender: 'm' },
    { id: '2102', text: 'Juan', gender: 'm' },
    { id: '2103', text: 'Juan-Luca', gender: 'm' },
    { id: '2104', text: 'Juana Jasmin', gender: 'f' },
    { id: '2105', text: 'Judith', gender: 'f' },
    { id: '2106', text: 'Judith', gender: 'f' },
    { id: '2107', text: 'Juergen', gender: 'm' },
    { id: '2108', text: 'Julanda', gender: 'f' },
    { id: '2109', text: 'Jule', gender: 'f' },
    { id: '2110', text: 'Juli', gender: 'f' },
    { id: '2111', text: 'Juli-Maximillian', gender: 'm' },
    { id: '2112', text: 'Julia', gender: 'f' },
    { id: '2113', text: 'Julia', gender: 'f' },
    { id: '2114', text: 'Julia Josephien', gender: 'f' },
    { id: '2115', text: 'Julian', gender: 'm' },
    { id: '2116', text: 'Julian', gender: 'm' },
    { id: '2117', text: 'Julian Gabriel', gender: 'm' },
    { id: '2118', text: 'Julian Karl', gender: 'm' },
    { id: '2119', text: 'Julian Massimo', gender: 'm' },
    { id: '2120', text: 'Juliana', gender: 'f' },
    { id: '2121', text: 'Juliana', gender: 'f' },
    { id: '2122', text: 'Juliane', gender: 'f' },
    { id: '2123', text: 'Julie', gender: 'f' },
    { id: '2124', text: 'Julie', gender: 'f' },
    { id: '2125', text: 'Julie Maline', gender: 'f' },
    { id: '2126', text: 'Julie Sophie', gender: 'f' },
    { id: '2127', text: 'Julien', gender: 'm' },
    { id: '2128', text: 'Julien Alexander', gender: 'm' },
    { id: '2129', text: 'Julien christian', gender: 'm' },
    { id: '2130', text: 'Julien Elias', gender: 'm' },
    { id: '2131', text: 'Julien Laurin', gender: 'm' },
    {
      id: '2132',
      text: 'Julienne Katarina Linnea Michelle Noelle',
      gender: 'f'
    },
    { id: '2133', text: 'Julienne Laeticia', gender: 'f' },
    { id: '2134', text: 'Juliette', gender: 'f' },
    { id: '2135', text: 'Julika', gender: 'f' },
    { id: '2136', text: 'Julina', gender: 'f' },
    { id: '2137', text: 'Julius', gender: 'm' },
    { id: '2138', text: 'Julius', gender: 'm' },
    { id: '2139', text: 'July', gender: 'f' },
    { id: '2140', text: 'July-Noelle', gender: 'f' },
    { id: '2141', text: 'Junes', gender: 'm' },
    { id: '2142', text: 'Junis', gender: 'm' },
    { id: '2143', text: 'Jürgen', gender: 'm' },
    { id: '2144', text: 'Jürgen Lennard', gender: 'm' },
    { id: '2145', text: 'Jürgen Oliver', gender: 'm' },
    { id: '2146', text: 'Juri', gender: 'm' },
    { id: '2147', text: 'Jurij', gender: 'm' },
    { id: '2148', text: 'Jushua', gender: 'm' },
    { id: '2149', text: 'Justin', gender: 'm' },
    { id: '2150', text: 'Justin Joel', gender: 'm' },
    { id: '2151', text: 'Justin Jui', gender: 'm' },
    { id: '2152', text: 'Justin Marvin', gender: 'm' },
    { id: '2153', text: 'Justin Taylor', gender: 'm' },
    { id: '2154', text: 'Justin-Gerhard', gender: 'm' },
    { id: '2155', text: 'Justina', gender: 'f' },
    { id: '2156', text: 'Justine', gender: 'f' },
    { id: '2157', text: 'Justine', gender: 'f' },
    { id: '2158', text: 'Justis', gender: 'm' },
    { id: '2159', text: 'Justus', gender: 'm' },
    { id: '2160', text: 'Justus', gender: 'm' },
    { id: '2161', text: 'Justyna', gender: 'f' },
    { id: '2162', text: 'Jutta', gender: 'f' },
    { id: '2163', text: 'Kai', gender: 'f' },
    { id: '2164', text: 'Kai-Uwe', gender: 'm' },
    { id: '2165', text: 'Kaja', gender: 'f' },
    { id: '2166', text: 'Kamil', gender: 'm' },
    { id: '2167', text: 'Kandy', gender: 'f' },
    { id: '2168', text: 'Karen', gender: 'f' },
    { id: '2169', text: 'Karim', gender: 'm' },
    { id: '2170', text: 'Karin', gender: 'f' },
    { id: '2171', text: 'Karina', gender: 'f' },
    { id: '2172', text: 'Karina', gender: 'f' },
    { id: '2173', text: 'Karl', gender: 'm' },
    { id: '2174', text: 'Karl / Carl', gender: 'm' },
    { id: '2175', text: 'Karl Heinz', gender: 'm' },
    { id: '2176', text: 'Karl Louis', gender: 'm' },
    { id: '2177', text: 'Karl-August', gender: 'm' },
    { id: '2178', text: 'Karl-Dieter', gender: 'm' },
    { id: '2179', text: 'Karl-Ernst', gender: 'm' },
    { id: '2180', text: 'Karl-Friedrich', gender: 'm' },
    { id: '2181', text: 'Karl-Georg', gender: 'm' },
    { id: '2182', text: 'Karl-Hans', gender: 'm' },
    { id: '2183', text: 'Karl-Heinrich', gender: 'm' },
    { id: '2184', text: 'Karl-Heinz', gender: 'm' },
    { id: '2185', text: 'Karl-Hermann', gender: 'm' },
    { id: '2186', text: 'Karl-Josef', gender: 'm' },
    { id: '2187', text: 'Karl-Jürgen', gender: 'm' },
    { id: '2188', text: 'Karl-Ludwig', gender: 'm' },
    { id: '2189', text: 'Karl-Otto', gender: 'm' },
    { id: '2190', text: 'Karl-Peter', gender: 'm' },
    { id: '2191', text: 'Karl-Werner', gender: 'm' },
    { id: '2192', text: 'Karl-Wilhelm', gender: 'm' },
    { id: '2193', text: 'Karla', gender: 'f' },
    { id: '2194', text: 'Karla', gender: 'f' },
    { id: '2195', text: 'Karlfried', gender: 'm' },
    { id: '2196', text: 'Karlheinz', gender: 'm' },
    { id: '2197', text: 'Karlo', gender: 'm' },
    { id: '2198', text: 'Karola', gender: 'f' },
    { id: '2199', text: 'Karolin', gender: 'f' },
    { id: '2200', text: 'Karolina', gender: 'f' },
    { id: '2201', text: 'Karoline', gender: 'f' },
    { id: '2202', text: 'Karoline', gender: 'f' },
    { id: '2203', text: 'Karsta', gender: 'f' },
    { id: '2204', text: 'Karsten', gender: 'm' },
    { id: '2205', text: 'Kasimir', gender: 'm' },
    { id: '2206', text: 'Kaspar', gender: 'm' },
    { id: '2207', text: 'Kaspar', gender: 'm' },
    { id: '2208', text: 'Kassel', gender: 'm' },
    { id: '2209', text: 'Kata', gender: 'f' },
    { id: '2210', text: 'Katalin', gender: 'f' },
    { id: '2211', text: 'Katalin', gender: 'f' },
    { id: '2212', text: 'Katarina', gender: 'f' },
    { id: '2213', text: 'Katarzyna', gender: 'f' },
    { id: '2214', text: 'Käte', gender: 'f' },
    { id: '2215', text: 'Katerina', gender: 'f' },
    { id: '2216', text: 'Katharina', gender: 'f' },
    { id: '2217', text: 'Katharina', gender: 'f' },
    { id: '2218', text: 'Katharina Helena', gender: 'f' },
    { id: '2219', text: 'Katharine', gender: 'f' },
    { id: '2220', text: 'Käthe', gender: 'f' },
    { id: '2221', text: 'Katherina', gender: 'f' },
    { id: '2222', text: 'Kathi', gender: 'f' },
    { id: '2223', text: 'Käthi', gender: 'f' },
    { id: '2224', text: 'Kathleen', gender: 'f' },
    { id: '2225', text: 'Kathleen', gender: 'f' },
    { id: '2226', text: 'Kathleen-Sophie', gender: 'f' },
    { id: '2227', text: 'Kathrin', gender: 'f' },
    { id: '2228', text: 'Kathy', gender: 'f' },
    { id: '2229', text: 'Kati', gender: 'f' },
    { id: '2230', text: 'Katie', gender: 'f' },
    { id: '2231', text: 'Katja', gender: 'f' },
    { id: '2232', text: 'Katrin', gender: 'f' },
    { id: '2233', text: 'Katty', gender: 'f' },
    { id: '2234', text: 'Katy', gender: 'f' },
    { id: '2235', text: 'Katy', gender: 'f' },
    { id: '2236', text: 'Kay-Uwe', gender: 'm' },
    { id: '2237', text: 'Kayla', gender: 'f' },
    { id: '2238', text: 'Kaylee-Megan', gender: 'f' },
    { id: '2239', text: 'Kazim', gender: 'm' },
    { id: '2240', text: 'Kees', gender: 'm' },
    { id: '2241', text: 'Keisha', gender: 'f' },
    { id: '2242', text: 'Kelly', gender: 'f' },
    { id: '2243', text: 'Kemal', gender: 'm' },
    { id: '2244', text: 'Kenan', gender: 'm' },
    { id: '2245', text: 'Kendra', gender: 'f' },
    { id: '2246', text: 'Kenneth', gender: 'm' },
    { id: '2247', text: 'Kenneth Noah', gender: 'm' },
    { id: '2248', text: 'Kenny', gender: 'm' },
    { id: '2249', text: 'Kerstin', gender: 'f' },
    { id: '2250', text: 'Kevin', gender: 'm' },
    { id: '2251', text: 'Kevin', gender: 'm' },
    { id: '2252', text: 'Kian', gender: 'm' },
    { id: '2253', text: 'Kiana', gender: 'f' },
    { id: '2254', text: 'Kianush', gender: 'm' },
    { id: '2255', text: 'Kiara-Sophie', gender: 'f' },
    { id: '2256', text: 'Kilian', gender: 'm' },
    { id: '2257', text: 'Kilian', gender: 'm' },
    { id: '2258', text: 'Kilian-Maurice', gender: 'm' },
    { id: '2259', text: 'Kim', gender: 'f' },
    { id: '2260', text: 'Kim Marie', gender: 'f' },
    { id: '2261', text: 'Kimball', gender: 'm' },
    { id: '2262', text: 'Kimberley', gender: 'f' },
    { id: '2263', text: 'Kimberley Fabienne', gender: 'f' },
    { id: '2264', text: 'Kimberly', gender: 'f' },
    { id: '2265', text: 'Kimberly Delisha', gender: 'f' },
    { id: '2266', text: 'Kimberly-Soey', gender: 'f' },
    { id: '2267', text: 'Kimi', gender: 'm' },
    { id: '2268', text: 'Kingston-Madox', gender: 'm' },
    { id: '2269', text: 'Kira', gender: 'f' },
    { id: '2270', text: 'Kira', gender: 'f' },
    { id: '2271', text: 'Kira-Katharina', gender: 'f' },
    { id: '2272', text: 'Kira-Lee', gender: 'f' },
    { id: '2273', text: 'Kiria', gender: 'f' },
    { id: '2274', text: 'Kirsten', gender: 'f' },
    { id: '2275', text: 'Kirstin', gender: 'f' },
    { id: '2276', text: 'Kisha', gender: 'f' },
    { id: '2277', text: 'Kiv', gender: 'm' },
    { id: '2278', text: 'Kiv-Lewin', gender: 'm' },
    { id: '2279', text: 'Kjell', gender: 'm' },
    { id: '2280', text: 'Kjell Lennart', gender: 'm' },
    { id: '2281', text: 'Klaas', gender: 'm' },
    { id: '2282', text: 'Klaas', gender: 'm' },
    { id: '2283', text: 'Klara', gender: 'f' },
    { id: '2284', text: 'Klara', gender: 'f' },
    { id: '2285', text: 'Kläre', gender: 'f' },
    { id: '2286', text: 'Klaudia', gender: 'f' },
    { id: '2287', text: 'Klaus', gender: 'm' },
    { id: '2288', text: 'Klaus', gender: 'm' },
    { id: '2289', text: 'Klaus Dieter', gender: 'm' },
    { id: '2290', text: 'Klaus Peter', gender: 'm' },
    { id: '2291', text: 'Klaus Rüdiger', gender: 'm' },
    { id: '2292', text: 'Klaus-D', gender: 'm' },
    { id: '2293', text: 'Klaus-Dieter', gender: 'm' },
    { id: '2294', text: 'Klaus-Günter', gender: 'm' },
    { id: '2295', text: 'Klaus-Jürgen', gender: 'm' },
    { id: '2296', text: 'Klaus-Michael', gender: 'm' },
    { id: '2297', text: 'Klaus-Peter', gender: 'm' },
    { id: '2298', text: 'Klaus-Rüdiger', gender: 'm' },
    { id: '2299', text: 'Klaus-Ulrich', gender: 'm' },
    { id: '2300', text: 'Klaus-Werner', gender: 'm' },
    { id: '2301', text: 'Klemens', gender: 'm' },
    { id: '2302', text: 'Klothilde', gender: 'f' },
    { id: '2303', text: 'Knud', gender: 'm' },
    { id: '2304', text: 'Knut', gender: 'm' },
    { id: '2305', text: 'Kolja', gender: 'm' },
    { id: '2306', text: 'Konrad', gender: 'm' },
    { id: '2307', text: 'Konrad', gender: 'm' },
    { id: '2308', text: 'Konstantin', gender: 'm' },
    { id: '2309', text: 'Konstantin', gender: 'm' },
    { id: '2310', text: 'Konstantinos', gender: 'm' },
    { id: '2311', text: 'Konstanze', gender: 'f' },
    { id: '2312', text: 'Korbinian', gender: 'm' },
    { id: '2313', text: 'Kordula', gender: 'f' },
    { id: '2314', text: 'Korinna', gender: 'f' },
    { id: '2315', text: 'Kornelia', gender: 'f' },
    { id: '2316', text: 'Kornelius', gender: 'm' },
    { id: '2317', text: 'Kosma', gender: 'f' },
    { id: '2318', text: 'Kreszentia', gender: 'f' },
    { id: '2319', text: 'Kreszenz', gender: 'f' },
    { id: '2320', text: 'Kreszenz', gender: 'f' },
    { id: '2321', text: 'Kriemhild', gender: 'f' },
    { id: '2322', text: 'Krishan', gender: 'm' },
    { id: '2323', text: 'Krista', gender: 'f' },
    { id: '2324', text: 'Kristian', gender: 'm' },
    { id: '2325', text: 'Kristiane', gender: 'f' },
    { id: '2326', text: 'Kristin', gender: 'f' },
    { id: '2327', text: 'Kristina', gender: 'f' },
    { id: '2328', text: 'Kristina', gender: 'f' },
    { id: '2329', text: 'Kristine', gender: 'f' },
    { id: '2330', text: 'Krystyna', gender: 'f' },
    { id: '2331', text: 'Krzysztof', gender: 'm' },
    { id: '2332', text: 'Ksenija', gender: 'f' },
    { id: '2333', text: 'Kunibert', gender: 'm' },
    { id: '2334', text: 'Kunigunda', gender: 'f' },
    { id: '2335', text: 'Kunigunde', gender: 'f' },
    { id: '2336', text: 'Kunigunde', gender: 'f' },
    { id: '2337', text: 'Kuno', gender: 'm' },
    { id: '2338', text: 'Kurt', gender: 'm' },
    { id: '2339', text: 'Kurt', gender: 'm' },
    { id: '2340', text: 'Kyara', gender: 'f' },
    { id: '2341', text: 'Kyell- Luca', gender: 'm' },
    { id: '2342', text: 'Kyra', gender: 'f' },
    { id: '2343', text: 'Ladislaus', gender: 'm' },
    { id: '2344', text: 'Laetizia', gender: 'f' },
    { id: '2345', text: 'Laila', gender: 'f' },
    { id: '2346', text: 'Laila', gender: 'f' },
    { id: '2347', text: 'Lakisha', gender: 'f' },
    { id: '2348', text: 'Lakysha', gender: 'f' },
    { id: '2349', text: 'Lale', gender: 'f' },
    { id: '2350', text: 'Lambert', gender: 'm' },
    { id: '2351', text: 'Lana', gender: 'f' },
    { id: '2352', text: 'Lana Mae', gender: 'f' },
    { id: '2353', text: 'Lanah', gender: 'f' },
    { id: '2354', text: 'Lara', gender: 'f' },
    { id: '2355', text: 'Lara', gender: 'f' },
    { id: '2356', text: 'Lará', gender: 'f' },
    { id: '2357', text: 'Lara Antonia', gender: 'f' },
    { id: '2358', text: 'Lara Eilin', gender: 'f' },
    { id: '2359', text: 'Lara Isabel', gender: 'f' },
    { id: '2360', text: 'Lara Julina', gender: 'f' },
    { id: '2361', text: 'Lara Marie', gender: 'f' },
    { id: '2362', text: 'Lara Rose', gender: 'f' },
    { id: '2363', text: 'Lara Sofie', gender: 'f' },
    { id: '2364', text: 'Lara Sopfie', gender: 'f' },
    { id: '2365', text: 'Lara-Louisa', gender: 'f' },
    { id: '2366', text: 'lara-sophie', gender: 'f' },
    { id: '2367', text: 'Larissa', gender: 'f' },
    { id: '2368', text: 'Larissa', gender: 'f' },
    { id: '2369', text: 'Larry', gender: 'm' },
    { id: '2370', text: 'Lars', gender: 'm' },
    { id: '2371', text: 'Lars', gender: 'm' },
    { id: '2372', text: 'Lars Lean', gender: 'm' },
    { id: '2373', text: 'Lars-Janis', gender: 'm' },
    { id: '2374', text: 'Lasko', gender: 'm' },
    { id: '2375', text: 'Laslo', gender: 'm' },
    { id: '2376', text: 'Lasse', gender: 'm' },
    { id: '2377', text: 'Laszlo', gender: 'm' },
    { id: '2378', text: 'Laura', gender: 'f' },
    { id: '2379', text: 'Laura', gender: 'f' },
    { id: '2380', text: 'Laura Alexa', gender: 'f' },
    { id: '2381', text: 'Laura Desireè', gender: 'f' },
    { id: '2382', text: 'Laura Marie', gender: 'f' },
    { id: '2383', text: 'Laura Sophie', gender: 'f' },
    { id: '2384', text: 'Laurelle', gender: 'f' },
    { id: '2385', text: 'Lauren', gender: 'f' },
    { id: '2386', text: 'Lauren', gender: 'm' },
    { id: '2387', text: 'Laurence', gender: 'm' },
    { id: '2388', text: 'Laurens', gender: 'm' },
    { id: '2389', text: 'Laurentina', gender: 'f' },
    { id: '2390', text: 'Laurenz', gender: 'm' },
    { id: '2391', text: 'Laurenz', gender: 'm' },
    { id: '2392', text: 'Lauri', gender: 'm' },
    { id: '2393', text: 'Laurin', gender: 'm' },
    { id: '2394', text: 'Laurin', gender: 'm' },
    { id: '2395', text: 'Laurin Pascal', gender: 'm' },
    { id: '2396', text: 'Laurina', gender: 'f' },
    { id: '2397', text: 'Laury', gender: 'm' },
    { id: '2398', text: 'Lavinia', gender: 'f' },
    { id: '2399', text: 'Lavinia / Levinia', gender: 'f' },
    { id: '2400', text: 'Lawrence', gender: 'm' },
    { id: '2401', text: 'Layla-Josephine', gender: 'f' },
    { id: '2402', text: 'Lea', gender: 'f' },
    { id: '2403', text: 'Lea / Leah', gender: 'f' },
    { id: '2404', text: 'Lea Alexa', gender: 'f' },
    { id: '2405', text: 'Lea Carolin', gender: 'f' },
    { id: '2406', text: 'Lea Charlin', gender: 'f' },
    { id: '2407', text: 'Lea Christin', gender: 'f' },
    { id: '2408', text: 'Lea Elina', gender: 'f' },
    { id: '2409', text: 'Lea Katharina', gender: 'f' },
    { id: '2410', text: 'Lea Marie', gender: 'f' },
    { id: '2411', text: 'Lea Sophie', gender: 'f' },
    { id: '2412', text: 'Lea-Céline', gender: 'f' },
    { id: '2413', text: 'Lea-Marie', gender: 'f' },
    { id: '2414', text: 'Lea-Sopfie', gender: 'f' },
    { id: '2415', text: 'Lean', gender: 'm' },
    { id: '2416', text: 'Léan', gender: 'm' },
    { id: '2417', text: 'Leana', gender: 'f' },
    { id: '2418', text: 'Leana - Sophie', gender: 'f' },
    { id: '2419', text: 'Leander', gender: 'm' },
    { id: '2420', text: 'Leander', gender: 'm' },
    { id: '2421', text: 'Leander Noél', gender: 'm' },
    { id: '2422', text: 'Leandra', gender: 'f' },
    { id: '2423', text: 'Leandra Luise', gender: 'f' },
    { id: '2424', text: 'Leandro', gender: 'm' },
    { id: '2425', text: 'Leandro Luca', gender: 'm' },
    { id: '2426', text: 'Lee', gender: 'm' },
    { id: '2427', text: 'Lee Angel', gender: 'f' },
    { id: '2428', text: 'Leeann', gender: 'f' },
    { id: '2429', text: 'Leeanna', gender: 'f' },
    { id: '2430', text: 'Leia Fabienne', gender: 'f' },
    { id: '2431', text: 'Leia-Leanne', gender: 'f' },
    { id: '2432', text: 'Leif', gender: 'm' },
    { id: '2433', text: 'Leif', gender: 'm' },
    { id: '2434', text: 'Leila', gender: 'f' },
    { id: '2435', text: 'Leila Noelle', gender: 'f' },
    { id: '2436', text: 'Leisje', gender: 'f' },
    { id: '2437', text: 'Lele', gender: 'm' },
    { id: '2438', text: 'Len', gender: 'm' },
    { id: '2439', text: 'Lena', gender: 'f' },
    { id: '2440', text: 'Lena', gender: 'f' },
    { id: '2441', text: 'Lena Michelle', gender: 'f' },
    { id: '2442', text: 'Lena-Carlotta', gender: 'f' },
    { id: '2443', text: 'Lena-Marie', gender: 'f' },
    { id: '2444', text: 'Lena-Michelle', gender: 'f' },
    { id: '2445', text: 'Lene', gender: 'f' },
    { id: '2446', text: 'Lene', gender: 'f' },
    { id: '2447', text: 'Lene-Jane-Mareen', gender: 'f' },
    { id: '2448', text: 'Leni', gender: 'f' },
    { id: '2449', text: 'Leni', gender: 'f' },
    { id: '2450', text: 'Leni Carlotta', gender: 'f' },
    { id: '2451', text: 'Leni Jaz', gender: 'f' },
    { id: '2452', text: 'Leni Luis', gender: 'f' },
    { id: '2453', text: 'Leni Reneé', gender: 'f' },
    { id: '2454', text: 'Leni-Charleen', gender: 'f' },
    { id: '2455', text: 'Leni-Sue', gender: 'f' },
    { id: '2456', text: 'Lenis', gender: 'm' },
    { id: '2457', text: 'Lenja', gender: 'f' },
    { id: '2458', text: 'Lenn', gender: 'm' },
    { id: '2459', text: 'Lenn Louis', gender: 'm' },
    { id: '2460', text: 'Lennard', gender: 'm' },
    { id: '2461', text: 'Lennard Leven', gender: 'm' },
    { id: '2462', text: 'Lennard Tobias', gender: 'm' },
    { id: '2463', text: 'Lennart / Lennard', gender: 'm' },
    { id: '2464', text: 'Lennart Emil', gender: 'm' },
    { id: '2465', text: 'Lennart Henri', gender: 'm' },
    { id: '2466', text: 'Lennart Wilhelm', gender: 'm' },
    { id: '2467', text: 'Lennert', gender: 'm' },
    { id: '2468', text: 'Lennox', gender: 'm' },
    { id: '2469', text: 'Lennox', gender: 'm' },
    { id: '2470', text: 'Lennox Lugh', gender: 'm' },
    { id: '2471', text: 'Lennox Luis', gender: 'm' },
    { id: '2472', text: 'Lennox-Paul', gender: 'm' },
    { id: '2473', text: 'Lenny', gender: 'm' },
    { id: '2474', text: 'Lenny', gender: 'm' },
    { id: '2475', text: 'Lenny Tom', gender: 'm' },
    { id: '2476', text: 'Lennya', gender: 'f' },
    { id: '2477', text: 'Lenya Emily', gender: 'f' },
    { id: '2478', text: 'Lenya-Joli', gender: 'f' },
    { id: '2479', text: 'Leo', gender: 'm' },
    { id: '2480', text: 'Leo', gender: 'm' },
    { id: '2481', text: 'Leokadia', gender: 'f' },
    { id: '2482', text: 'Leon', gender: 'm' },
    { id: '2483', text: 'leon', gender: 'm' },
    { id: '2484', text: 'Leon', gender: 'm' },
    { id: '2485', text: 'Leon - Georg', gender: 'm' },
    { id: '2486', text: 'Leon Joel', gender: 'm' },
    { id: '2487', text: 'Leon Luca', gender: 'm' },
    { id: '2488', text: 'Leon Luca', gender: 'm' },
    { id: '2489', text: 'Leon Matthias Jan', gender: 'm' },
    { id: '2490', text: 'Leon Maurice', gender: 'm' },
    { id: '2491', text: 'Leon Niklas', gender: 'm' },
    { id: '2492', text: 'Leon Sebastian', gender: 'm' },
    { id: '2493', text: 'Leon-fabian', gender: 'm' },
    { id: '2494', text: 'Leon-Gabriel', gender: 'm' },
    { id: '2495', text: 'Leon-Maximilian', gender: 'm' },
    { id: '2496', text: 'Leon-Pascal', gender: 'm' },
    { id: '2497', text: 'Leon-Paul', gender: 'm' },
    { id: '2498', text: 'Leona', gender: 'f' },
    { id: '2499', text: 'Leonard', gender: 'm' },
    { id: '2500', text: 'Leonard', gender: 'm' },
    { id: '2501', text: 'Leonardo', gender: 'm' },
    { id: '2502', text: 'Leonardo', gender: 'm' },
    { id: '2503', text: 'Leonardo', gender: 'm' },
    { id: '2504', text: 'Leonhard', gender: 'm' },
    { id: '2505', text: 'Leonhard', gender: 'm' },
    { id: '2506', text: 'Leonice', gender: 'f' },
    { id: '2507', text: 'Leonid', gender: 'm' },
    { id: '2508', text: 'Leonidas', gender: 'm' },
    { id: '2509', text: 'Leonie', gender: 'f' },
    { id: '2510', text: 'Leonie', gender: 'f' },
    { id: '2511', text: 'Léonie', gender: 'f' },
    { id: '2512', text: 'Leonie / Leony', gender: 'f' },
    { id: '2513', text: 'Leonie Anna', gender: 'f' },
    { id: '2514', text: 'Leonie Carolina', gender: 'f' },
    { id: '2515', text: 'Leonie Cecile', gender: 'f' },
    { id: '2516', text: 'Leonie chandal', gender: 'f' },
    { id: '2517', text: 'Leonie Eyleen', gender: 'f' },
    { id: '2518', text: 'Leonie Joel', gender: 'f' },
    { id: '2519', text: 'Leonie Marie', gender: 'f' },
    { id: '2520', text: 'Leonie Sina', gender: 'f' },
    { id: '2521', text: 'Leonie-Jolie', gender: 'f' },
    { id: '2522', text: 'Leonie-Sophie', gender: 'f' },
    { id: '2523', text: 'Leonis', gender: 'm' },
    { id: '2524', text: 'Leonor', gender: 'f' },
    { id: '2525', text: 'Leonore', gender: 'f' },
    { id: '2526', text: 'Leopold', gender: 'm' },
    { id: '2527', text: 'Leopold', gender: 'm' },
    { id: '2528', text: 'Leopold- Andreas', gender: 'm' },
    { id: '2529', text: 'Leopoldine', gender: 'f' },
    { id: '2530', text: 'Leora Maria', gender: 'f' },
    { id: '2531', text: 'Lera', gender: 'f' },
    { id: '2532', text: 'Leron', gender: 'm' },
    { id: '2533', text: 'Lesley Rene', gender: 'm' },
    { id: '2534', text: 'Leszek', gender: 'm' },
    { id: '2535', text: 'Letizia', gender: 'f' },
    { id: '2536', text: 'Levi', gender: 'm' },
    { id: '2537', text: 'Levin', gender: 'm' },
    { id: '2538', text: 'Levin Percy', gender: 'm' },
    { id: '2539', text: 'Levinia', gender: 'f' },
    { id: '2540', text: 'Lewin', gender: 'm' },
    { id: '2541', text: 'Lewis', gender: 'm' },
    { id: '2542', text: 'Lewis Joel', gender: 'm' },
    { id: '2543', text: 'Lewis Tamino', gender: 'm' },
    { id: '2544', text: 'Lex Sky', gender: 'm' },
    { id: '2545', text: 'Leyla', gender: 'f' },
    { id: '2546', text: 'Leyla', gender: 'f' },
    { id: '2547', text: 'Leyla-Nayma', gender: 'f' },
    { id: '2548', text: 'Lia', gender: 'f' },
    { id: '2549', text: 'Lia', gender: 'f' },
    { id: '2550', text: 'Lia Marie', gender: 'f' },
    { id: '2551', text: 'Lia-Isabell', gender: 'f' },
    { id: '2552', text: 'Lia-Marie', gender: 'f' },
    { id: '2553', text: 'Lia-Sophie', gender: 'f' },
    { id: '2554', text: 'Liah / Lia', gender: 'f' },
    { id: '2555', text: 'Liam', gender: 'm' },
    { id: '2556', text: 'Lian', gender: 'm' },
    { id: '2557', text: 'Liane', gender: 'f' },
    { id: '2558', text: 'Liane', gender: 'f' },
    { id: '2559', text: 'Lianna', gender: 'f' },
    { id: '2560', text: 'Liara', gender: 'f' },
    { id: '2561', text: 'Lias', gender: 'm' },
    { id: '2562', text: 'Lidia', gender: 'f' },
    { id: '2563', text: 'Lidija', gender: 'f' },
    { id: '2564', text: 'Lidwina', gender: 'f' },
    { id: '2565', text: 'Liesa', gender: 'f' },
    { id: '2566', text: 'Liesbeth', gender: 'f' },
    { id: '2567', text: 'Lieschen', gender: 'f' },
    { id: '2568', text: 'Liesel', gender: 'f' },
    { id: '2569', text: 'Lieselotte', gender: 'f' },
    { id: '2570', text: 'Lieselotte', gender: 'f' },
    { id: '2571', text: 'Lila', gender: 'f' },
    { id: '2572', text: 'Lili', gender: 'f' },
    { id: '2573', text: 'Lili / Lilly /Lilli', gender: 'f' },
    { id: '2574', text: 'Lilian', gender: 'f' },
    { id: '2575', text: 'Lilian', gender: 'f' },
    { id: '2576', text: 'Liliana', gender: 'f' },
    { id: '2577', text: 'Liliana', gender: 'f' },
    { id: '2578', text: 'Liliane', gender: 'f' },
    { id: '2579', text: 'Lilija', gender: 'f' },
    { id: '2580', text: 'Liljana', gender: 'f' },
    { id: '2581', text: 'Lilli', gender: 'f' },
    { id: '2582', text: 'Lilli Louise', gender: 'f' },
    { id: '2583', text: 'Lilli Luise', gender: 'f' },
    { id: '2584', text: 'Lilly', gender: 'f' },
    { id: '2585', text: 'Lilly', gender: 'f' },
    { id: '2586', text: 'Lilly Joy', gender: 'f' },
    { id: '2587', text: 'Lilly Lourdes Greta', gender: 'f' },
    { id: '2588', text: 'Lilly Marie', gender: 'f' },
    { id: '2589', text: 'Lilly May', gender: 'f' },
    { id: '2590', text: 'Lilly Sophie', gender: 'f' },
    { id: '2591', text: 'Lilly-Carlotta', gender: 'f' },
    { id: '2592', text: 'Lilly-Marie', gender: 'f' },
    { id: '2593', text: 'Lilo', gender: 'f' },
    { id: '2594', text: 'Lilou', gender: 'f' },
    { id: '2595', text: 'Lina', gender: 'f' },
    { id: '2596', text: 'Lina', gender: 'f' },
    { id: '2597', text: 'Lina Joseline', gender: 'f' },
    { id: '2598', text: 'Lina Jouline', gender: 'f' },
    { id: '2599', text: 'Lina Marie', gender: 'f' },
    { id: '2600', text: 'Lina Tabea', gender: 'f' },
    { id: '2601', text: 'Linda', gender: 'f' },
    { id: '2602', text: 'Linda', gender: 'f' },
    { id: '2603', text: 'Linda Theresia', gender: 'f' },
    { id: '2604', text: 'Lindsay Lisanne', gender: 'f' },
    { id: '2605', text: 'Ling', gender: 'f' },
    { id: '2606', text: 'Link', gender: 'm' },
    { id: '2607', text: 'Linnea', gender: 'f' },
    { id: '2608', text: 'Linus', gender: 'm' },
    { id: '2609', text: 'Linus', gender: 'm' },
    { id: '2610', text: 'Linus-Emilian', gender: 'm' },
    { id: '2611', text: 'Linus-Luca', gender: 'm' },
    { id: '2612', text: 'Lioba', gender: 'f' },
    { id: '2613', text: 'Lionel', gender: 'm' },
    { id: '2614', text: 'Liosa', gender: 'f' },
    { id: '2615', text: 'Lisa', gender: 'f' },
    { id: '2616', text: 'Lisa', gender: 'f' },
    { id: '2617', text: 'Lisa Babette', gender: 'f' },
    { id: '2618', text: 'Lisa Christin', gender: 'f' },
    { id: '2619', text: 'Lisa Noemi', gender: 'f' },
    { id: '2620', text: 'Lisa Velena', gender: 'f' },
    { id: '2621', text: 'Lisa-Marie', gender: 'f' },
    { id: '2622', text: 'Lisa-Sophie', gender: 'f' },
    { id: '2623', text: 'Lisanne', gender: 'f' },
    { id: '2624', text: 'Lisbeth', gender: 'f' },
    { id: '2625', text: 'Liselotte', gender: 'f' },
    { id: '2626', text: 'Lisette', gender: 'f' },
    { id: '2627', text: 'Lissi', gender: 'f' },
    { id: '2628', text: 'Lissy', gender: 'f' },
    { id: '2629', text: 'Liv', gender: 'f' },
    { id: '2630', text: 'Liv Grete', gender: 'f' },
    { id: '2631', text: 'Liv Nike', gender: 'f' },
    { id: '2632', text: 'Livia', gender: 'f' },
    { id: '2633', text: 'Liz', gender: 'f' },
    { id: '2634', text: 'Ljilja', gender: 'f' },
    { id: '2635', text: 'Ljiljana', gender: 'f' },
    { id: '2636', text: 'Ljubica', gender: 'f' },
    { id: '2637', text: 'Ljudmila', gender: 'f' },
    { id: '2638', text: 'Lleila Jamila', gender: 'f' },
    { id: '2639', text: 'Llyon', gender: 'm' },
    { id: '2640', text: 'Loana', gender: 'f' },
    { id: '2641', text: 'Loel', gender: 'm' },
    { id: '2642', text: 'Logan', gender: 'm' },
    { id: '2643', text: 'Logan Memphis', gender: 'm' },
    { id: '2644', text: 'Loisl', gender: 'm' },
    { id: '2645', text: 'Loni', gender: 'f' },
    { id: '2646', text: 'Lonyo', gender: 'm' },
    { id: '2647', text: 'Lore', gender: 'f' },
    { id: '2648', text: 'Lore', gender: 'f' },
    { id: '2649', text: 'Loreen', gender: 'f' },
    { id: '2650', text: 'Loreenja-Sophie', gender: 'f' },
    { id: '2651', text: 'Lorelai', gender: 'f' },
    { id: '2652', text: 'Lorena', gender: 'f' },
    { id: '2653', text: 'Lorena Sophie', gender: 'f' },
    { id: '2654', text: 'Lorena Talin', gender: 'f' },
    { id: '2655', text: 'Lorenz', gender: 'm' },
    { id: '2656', text: 'Lorenz', gender: 'm' },
    { id: '2657', text: 'Lorenzo', gender: 'm' },
    { id: '2658', text: 'Loretta', gender: 'f' },
    { id: '2659', text: 'Loriana', gender: 'f' },
    { id: '2660', text: 'Loric', gender: 'm' },
    { id: '2661', text: 'Loris', gender: 'm' },
    { id: '2662', text: 'Lothar', gender: 'm' },
    { id: '2663', text: 'Lotta', gender: 'f' },
    { id: '2664', text: 'Lotte', gender: 'f' },
    { id: '2665', text: 'Lotte', gender: 'f' },
    { id: '2666', text: 'Lotti', gender: 'f' },
    { id: '2667', text: 'Lou', gender: 'm' },
    { id: '2668', text: 'Lou-Emma', gender: 'f' },
    { id: '2669', text: 'Louis', gender: 'm' },
    { id: '2670', text: 'Louis / Luis', gender: 'm' },
    { id: '2671', text: 'Louis Henry Michel', gender: 'm' },
    { id: '2672', text: 'Louis-Maximilian', gender: 'm' },
    { id: '2673', text: 'Louisa', gender: 'f' },
    { id: '2674', text: 'Louise', gender: 'f' },
    { id: '2675', text: 'Lova', gender: 'f' },
    { id: '2676', text: 'Lowis', gender: 'm' },
    { id: '2677', text: 'Lu Colin', gender: 'm' },
    { id: '2678', text: 'Luan', gender: 'm' },
    { id: '2679', text: 'Luan Joel', gender: 'm' },
    { id: '2680', text: 'Luana', gender: 'f' },
    { id: '2681', text: 'Luana Sue', gender: 'f' },
    { id: '2682', text: 'Luc', gender: 'm' },
    { id: '2683', text: 'Luca / Lucca / Luka', gender: 'm' },
    { id: '2684', text: 'Luca Colin', gender: 'm' },
    { id: '2685', text: 'Luca Elias', gender: 'm' },
    { id: '2686', text: 'Luca Fabien', gender: 'm' },
    { id: '2687', text: 'Luca Justin', gender: 'm' },
    { id: '2688', text: 'Luca Marie', gender: 'f' },
    { id: '2689', text: 'Luca Maxim', gender: 'm' },
    { id: '2690', text: 'Luca Toni', gender: 'm' },
    { id: '2691', text: 'Luca-Alexander', gender: 'm' },
    { id: '2692', text: 'Luca-Finn', gender: 'm' },
    { id: '2693', text: 'Luca-Joel', gender: 'm' },
    { id: '2694', text: 'Luca-Maximilian', gender: 'm' },
    { id: '2695', text: 'Luca-Paul', gender: 'm' },
    { id: '2696', text: 'Luca-Venezian', gender: 'm' },
    { id: '2697', text: 'Lucas / Lukas', gender: 'm' },
    { id: '2698', text: 'Lucas Valentin', gender: 'm' },
    { id: '2699', text: 'Lucas-Etienne', gender: 'm' },
    { id: '2700', text: 'Lucia', gender: 'f' },
    { id: '2701', text: 'Lucia', gender: 'f' },
    { id: '2702', text: 'Lucian', gender: 'm' },
    { id: '2703', text: 'Lucian Hennessy', gender: 'm' },
    { id: '2704', text: 'Luciano', gender: 'm' },
    { id: '2705', text: 'Luciano', gender: 'm' },
    { id: '2706', text: 'Lucie', gender: 'f' },
    { id: '2707', text: 'Lucie', gender: 'f' },
    { id: '2708', text: 'Lucien', gender: 'm' },
    { id: '2709', text: 'Lucienne', gender: 'f' },
    { id: '2710', text: 'Lucio', gender: 'm' },
    { id: '2711', text: 'Lucius', gender: 'm' },
    { id: '2712', text: 'LuColin', gender: 'm' },
    { id: '2713', text: 'Lucy', gender: 'f' },
    { id: '2714', text: 'Ludger', gender: 'm' },
    { id: '2715', text: 'Ludmila', gender: 'f' },
    { id: '2716', text: 'Ludmilla', gender: 'f' },
    { id: '2717', text: 'Ludwig', gender: 'm' },
    { id: '2718', text: 'Ludwig', gender: 'm' },
    { id: '2719', text: 'Ludwina', gender: 'f' },
    { id: '2720', text: 'Lugh', gender: 'm' },
    { id: '2721', text: 'Luigi', gender: 'm' },
    { id: '2722', text: 'Luis', gender: 'm' },
    { id: '2723', text: 'Luis Alexander', gender: 'm' },
    { id: '2724', text: 'Luis Eenrique', gender: 'm' },
    { id: '2725', text: 'Luis Vincent', gender: 'm' },
    { id: '2726', text: 'Luisa', gender: 'f' },
    { id: '2727', text: 'Luisa', gender: 'f' },
    { id: '2728', text: 'Luise', gender: 'f' },
    { id: '2729', text: 'Luise', gender: 'f' },
    { id: '2730', text: 'Luisel', gender: 'f' },
    { id: '2731', text: 'Luitgard', gender: 'f' },
    { id: '2732', text: 'Luiz Direk', gender: 'm' },
    { id: '2733', text: 'Luka', gender: 'f' },
    { id: '2734', text: 'Luka Joel', gender: 'm' },
    { id: '2735', text: 'Lukas', gender: 'm' },
    { id: '2736', text: 'Lukas Alexander', gender: 'm' },
    { id: '2737', text: 'Lukas Elias', gender: 'm' },
    { id: '2738', text: 'Lukas Marcel', gender: 'm' },
    { id: '2739', text: 'Lukas Pascal', gender: 'm' },
    { id: '2740', text: 'Lukas-Aron', gender: 'm' },
    { id: '2741', text: 'Lukas-Timothy', gender: 'm' },
    { id: '2742', text: 'Luke', gender: 'm' },
    { id: '2743', text: 'Luke Christopher', gender: 'm' },
    { id: '2744', text: 'Luna', gender: 'f' },
    { id: '2745', text: 'Luna Marie', gender: 'f' },
    { id: '2746', text: 'Lusia', gender: 'f' },
    { id: '2747', text: 'Lutz', gender: 'm' },
    { id: '2748', text: 'Luva', gender: 'm' },
    { id: '2749', text: 'Luzia', gender: 'f' },
    { id: '2750', text: 'Luzie', gender: 'f' },
    { id: '2751', text: 'Luzie', gender: 'f' },
    { id: '2752', text: 'Luzio', gender: 'm' },
    { id: '2753', text: 'Ly Ann', gender: 'f' },
    { id: '2754', text: 'Lyandra', gender: 'f' },
    { id: '2755', text: 'Lydell', gender: 'm' },
    { id: '2756', text: 'Lydia', gender: 'f' },
    { id: '2757', text: 'Lydia', gender: 'f' },
    { id: '2758', text: 'Lyn Zoe', gender: 'f' },
    { id: '2759', text: 'Lynesa', gender: 'f' },
    { id: '2760', text: 'Lynette', gender: 'f' },
    { id: '2761', text: 'Lynn / Linn', gender: 'f' },
    { id: '2762', text: 'Lynn Sophie', gender: 'f' },
    { id: '2763', text: 'Lyon Luca', gender: 'm' },
    { id: '2764', text: 'Lyonel', gender: 'm' },
    { id: '2765', text: 'Lysann', gender: 'f' },
    { id: '2766', text: 'Maarja', gender: 'f' },
    { id: '2767', text: 'Maarten', gender: 'm' },
    { id: '2768', text: 'Mabel', gender: 'f' },
    { id: '2769', text: 'Machito', gender: 'm' },
    { id: '2770', text: 'Maddox', gender: 'm' },
    { id: '2771', text: 'Madeleine', gender: 'f' },
    { id: '2772', text: 'Madita', gender: 'f' },
    { id: '2773', text: 'Madlen', gender: 'f' },
    { id: '2774', text: 'Madlin', gender: 'f' },
    { id: '2775', text: 'Madox', gender: 'm' },
    { id: '2776', text: 'Mads', gender: 'm' },
    { id: '2777', text: 'Mae', gender: 'f' },
    { id: '2778', text: 'Magarete', gender: 'f' },
    { id: '2779', text: 'Magda', gender: 'f' },
    { id: '2780', text: 'Magdalena', gender: 'f' },
    { id: '2781', text: 'Magdalena', gender: 'f' },
    { id: '2782', text: 'Magdalena-Sophie', gender: 'f' },
    { id: '2783', text: 'Magdalene', gender: 'f' },
    { id: '2784', text: 'Maggi Suellen', gender: 'f' },
    { id: '2785', text: 'Magnus', gender: 'm' },
    { id: '2786', text: 'Magnus', gender: 'm' },
    { id: '2787', text: 'Magret', gender: 'f' },
    { id: '2788', text: 'Magrit', gender: 'f' },
    { id: '2789', text: 'Mahmoud', gender: 'm' },
    { id: '2790', text: 'Mahmut', gender: 'm' },
    { id: '2791', text: 'Maia', gender: 'f' },
    { id: '2792', text: 'Maik', gender: 'm' },
    { id: '2793', text: 'Maik', gender: 'm' },
    { id: '2794', text: 'Maike', gender: 'f' },
    { id: '2795', text: 'Maike', gender: 'f' },
    { id: '2796', text: 'Maike Isabell', gender: 'f' },
    { id: '2797', text: 'Mailin', gender: 'f' },
    { id: '2798', text: 'Maja', gender: 'f' },
    { id: '2799', text: 'Maja', gender: 'f' },
    { id: '2800', text: 'Maja Sofie', gender: 'f' },
    { id: '2801', text: 'Maka Sofie', gender: 'f' },
    { id: '2802', text: 'Malaika', gender: 'f' },
    { id: '2803', text: 'Malena', gender: 'f' },
    { id: '2804', text: 'Malgorzata', gender: 'f' },
    { id: '2805', text: 'Malik', gender: 'm' },
    { id: '2806', text: 'Malin', gender: 'f' },
    { id: '2807', text: 'Malin Mathilda', gender: 'f' },
    { id: '2808', text: 'Malina', gender: 'f' },
    { id: '2809', text: 'Maline', gender: 'f' },
    { id: '2810', text: 'Malte', gender: 'm' },
    { id: '2811', text: 'Malte', gender: 'm' },
    { id: '2812', text: 'Malte Eric', gender: 'm' },
    { id: '2813', text: 'Malva', gender: 'f' },
    { id: '2814', text: 'Malve', gender: 'f' },
    { id: '2815', text: 'Mandy', gender: 'f' },
    { id: '2816', text: 'Mandy', gender: 'f' },
    { id: '2817', text: 'Manfred', gender: 'm' },
    { id: '2818', text: 'Manfred', gender: 'm' },
    { id: '2819', text: 'Manja', gender: 'f' },
    { id: '2820', text: 'Manolis', gender: 'm' },
    { id: '2821', text: 'Manuel', gender: 'm' },
    { id: '2822', text: 'Manuel', gender: 'm' },
    { id: '2823', text: 'Manuel Juan', gender: 'm' },
    { id: '2824', text: 'Manuela', gender: 'f' },
    { id: '2825', text: 'Manuele', gender: 'm' },
    { id: '2826', text: 'Maoritz', gender: 'm' },
    { id: '2827', text: 'Mara', gender: 'f' },
    { id: '2828', text: 'Mara', gender: 'f' },
    { id: '2829', text: 'Mara Elin', gender: 'f' },
    { id: '2830', text: 'Mara Michelle', gender: 'f' },
    { id: '2831', text: 'Mara-Aliya', gender: 'f' },
    { id: '2832', text: 'Marc', gender: 'm' },
    { id: '2833', text: 'Marc / Mark', gender: 'm' },
    { id: '2834', text: 'Marc Cedric', gender: 'm' },
    { id: '2835', text: 'Marc Fabian', gender: 'm' },
    { id: '2836', text: 'Marc Finley', gender: 'm' },
    { id: '2837', text: 'Marc-Jona', gender: 'm' },
    { id: '2838', text: 'Marc-Sebastian', gender: 'm' },
    { id: '2839', text: 'Marcel', gender: 'm' },
    { id: '2840', text: 'Marcel', gender: 'm' },
    { id: '2841', text: 'Marcel Benjamin', gender: 'm' },
    { id: '2842', text: 'Marcel Leon', gender: 'm' },
    { id: '2843', text: 'Marcell', gender: 'm' },
    { id: '2844', text: 'Marcella', gender: 'f' },
    { id: '2845', text: 'Marcello', gender: 'm' },
    { id: '2846', text: 'Marcia', gender: 'f' },
    { id: '2847', text: 'Marcio', gender: 'm' },
    { id: '2848', text: 'Marco', gender: 'm' },
    { id: '2849', text: 'Marco', gender: 'm' },
    { id: '2850', text: 'Marcus', gender: 'm' },
    { id: '2851', text: 'Mareen', gender: 'f' },
    { id: '2852', text: 'Mareike', gender: 'f' },
    { id: '2853', text: 'Mareike / Marijke', gender: 'f' },
    { id: '2854', text: 'Mareile', gender: 'f' },
    { id: '2855', text: 'Marek', gender: 'm' },
    { id: '2856', text: 'Marek', gender: 'm' },
    { id: '2857', text: 'Maren', gender: 'f' },
    { id: '2858', text: 'Maren', gender: 'f' },
    { id: '2859', text: 'Marga', gender: 'f' },
    { id: '2860', text: 'Margaret', gender: 'f' },
    { id: '2861', text: 'Margareta', gender: 'f' },
    { id: '2862', text: 'Margarete', gender: 'f' },
    { id: '2863', text: 'Margaretha', gender: 'f' },
    { id: '2864', text: 'Margarethe', gender: 'f' },
    { id: '2865', text: 'Margarita', gender: 'f' },
    { id: '2866', text: 'Margarita', gender: 'f' },
    { id: '2867', text: 'Margit', gender: 'f' },
    { id: '2868', text: 'Margita', gender: 'f' },
    { id: '2869', text: 'Margitta', gender: 'f' },
    { id: '2870', text: 'Margot', gender: 'f' },
    { id: '2871', text: 'Margret', gender: 'f' },
    { id: '2872', text: 'Margrit', gender: 'f' },
    { id: '2873', text: 'Maria', gender: 'f' },
    { id: '2874', text: 'Maria / Mariah', gender: 'f' },
    { id: '2875', text: 'Maria Helena', gender: 'f' },
    { id: '2876', text: 'Maria-Luise', gender: 'f' },
    { id: '2877', text: 'Maria-Theresia', gender: 'f' },
    { id: '2878', text: 'Marian', gender: 'm' },
    { id: '2879', text: 'Marian', gender: 'f' },
    { id: '2880', text: 'Marian', gender: 'm' },
    { id: '2881', text: 'Mariana', gender: 'f' },
    { id: '2882', text: 'Mariana', gender: 'f' },
    { id: '2883', text: 'Marianna', gender: 'f' },
    { id: '2884', text: 'Marianne', gender: 'f' },
    { id: '2885', text: 'Marianne', gender: 'f' },
    { id: '2886', text: 'Marica', gender: 'f' },
    { id: '2887', text: 'Marie', gender: 'f' },
    { id: '2888', text: 'Marie', gender: 'f' },
    { id: '2889', text: 'Marie Éléne', gender: 'f' },
    { id: '2890', text: 'Marie Jeanne', gender: 'f' },
    { id: '2891', text: 'Marie Jo Anna', gender: 'f' },
    { id: '2892', text: 'Marie Jocelyn', gender: 'f' },
    { id: '2893', text: 'Marie Jolie', gender: 'f' },
    { id: '2894', text: 'Marie Joline', gender: 'f' },
    { id: '2895', text: 'Marie Sophia', gender: 'f' },
    { id: '2896', text: 'Marie Therese', gender: 'f' },
    { id: '2897', text: 'Marie-Louise', gender: 'f' },
    { id: '2898', text: 'Marie-Luise', gender: 'f' },
    { id: '2899', text: 'Marie-Luise', gender: 'f' },
    { id: '2900', text: 'Marie-Theres', gender: 'f' },
    { id: '2901', text: 'Marie-Therese', gender: 'f' },
    { id: '2902', text: 'Mariechen', gender: 'f' },
    { id: '2903', text: 'Mariele', gender: 'f' },
    { id: '2904', text: 'MarieLee', gender: 'f' },
    { id: '2905', text: 'Mariella', gender: 'f' },
    { id: '2906', text: 'Mariella Sophia', gender: 'f' },
    { id: '2907', text: 'Marieluise', gender: 'f' },
    { id: '2908', text: 'Mariestella', gender: 'f' },
    { id: '2909', text: 'Marietta', gender: 'f' },
    { id: '2910', text: 'Marietta', gender: 'f' },
    { id: '2911', text: 'Marija', gender: 'f' },
    { id: '2912', text: 'Marijan', gender: 'm' },
    { id: '2913', text: 'Marijana', gender: 'f' },
    { id: '2914', text: 'Marik', gender: 'm' },
    { id: '2915', text: 'Marika', gender: 'f' },
    { id: '2916', text: 'Marika/Marikka', gender: 'f' },
    { id: '2917', text: 'Marilena', gender: 'f' },
    { id: '2918', text: 'Marina', gender: 'f' },
    { id: '2919', text: 'Marina', gender: 'f' },
    { id: '2920', text: 'Marino', gender: 'm' },
    { id: '2921', text: 'Mario', gender: 'm' },
    { id: '2922', text: 'Mario', gender: 'm' },
    { id: '2923', text: 'Mariola', gender: 'f' },
    { id: '2924', text: 'Marion', gender: 'f' },
    { id: '2925', text: 'Maris', gender: 'm' },
    { id: '2926', text: 'Marisa', gender: 'f' },
    { id: '2927', text: 'Marissa', gender: 'f' },
    { id: '2928', text: 'Marit', gender: 'f' },
    { id: '2929', text: 'Marita', gender: 'f' },
    { id: '2930', text: 'Maritta', gender: 'f' },
    { id: '2931', text: 'Marius', gender: 'm' },
    { id: '2932', text: 'Marius', gender: 'm' },
    { id: '2933', text: 'Mariusz', gender: 'm' },
    { id: '2934', text: 'Marizza', gender: 'f' },
    { id: '2935', text: 'Marizza Sofie', gender: 'f' },
    { id: '2936', text: 'Marja', gender: 'f' },
    { id: '2937', text: 'Marjan', gender: 'f' },
    { id: '2938', text: 'Mark', gender: 'm' },
    { id: '2939', text: 'Mark', gender: 'm' },
    { id: '2940', text: 'Mark - Leon', gender: 'm' },
    { id: '2941', text: 'Marko', gender: 'm' },
    { id: '2942', text: 'Markus', gender: 'm' },
    { id: '2943', text: 'Markus', gender: 'm' },
    { id: '2944', text: 'Marleen', gender: 'f' },
    { id: '2945', text: 'Marleen', gender: 'f' },
    { id: '2946', text: 'Marlen', gender: 'f' },
    { id: '2947', text: 'Marlene', gender: 'f' },
    { id: '2948', text: 'Marlene', gender: 'f' },
    { id: '2949', text: 'Marlies', gender: 'f' },
    { id: '2950', text: 'Marliese', gender: 'f' },
    { id: '2951', text: 'Marlis', gender: 'f' },
    { id: '2952', text: 'Marlo', gender: 'm' },
    { id: '2953', text: 'Marlon-Noel', gender: 'm' },
    { id: '2954', text: 'Marshal', gender: 'm' },
    { id: '2955', text: 'Marta', gender: 'f' },
    { id: '2956', text: 'Marten', gender: 'm' },
    { id: '2957', text: 'Marten', gender: 'm' },
    { id: '2958', text: 'Martha', gender: 'f' },
    { id: '2959', text: 'Martha / Marta', gender: 'f' },
    { id: '2960', text: 'Martin', gender: 'm' },
    { id: '2961', text: 'Martina', gender: 'f' },
    { id: '2962', text: 'Martine', gender: 'f' },
    { id: '2963', text: 'Marvin', gender: 'm' },
    { id: '2964', text: 'Marvin', gender: 'm' },
    { id: '2965', text: 'Mary', gender: 'f' },
    { id: '2966', text: 'Mary', gender: 'f' },
    { id: '2967', text: 'Mary Lou', gender: 'f' },
    { id: '2968', text: 'Mary Lu', gender: 'f' },
    { id: '2969', text: 'Marzena', gender: 'f' },
    { id: '2970', text: 'Massie', gender: 'f' },
    { id: '2971', text: 'Massimo', gender: 'm' },
    { id: '2972', text: 'Massimo', gender: 'm' },
    { id: '2973', text: 'Matai', gender: 'm' },
    { id: '2974', text: 'Mathew', gender: 'm' },
    { id: '2975', text: 'Mathias', gender: 'm' },
    { id: '2976', text: 'Mathias-Paul', gender: 'm' },
    { id: '2977', text: 'Mathilda', gender: 'f' },
    { id: '2978', text: 'Mathilde', gender: 'f' },
    { id: '2979', text: 'Mathis', gender: 'm' },
    { id: '2980', text: 'Matilda', gender: 'f' },
    { id: '2981', text: 'Mato', gender: 'm' },
    { id: '2982', text: 'Matrina', gender: 'f' },
    { id: '2983', text: 'Mats', gender: 'm' },
    { id: '2984', text: 'Mats Niclas', gender: 'm' },
    { id: '2985', text: 'Mats-Alexander', gender: 'm' },
    { id: '2986', text: 'Mats-Julian', gender: 'm' },
    { id: '2987', text: 'Matteo', gender: 'm' },
    { id: '2988', text: 'Matteo', gender: 'm' },
    { id: '2989', text: 'Matteo / Matheo', gender: 'm' },
    { id: '2990', text: 'Matthäus', gender: 'm' },
    { id: '2991', text: 'Matthias', gender: 'm' },
    { id: '2992', text: 'Matthias', gender: 'm' },
    { id: '2993', text: 'Matti', gender: 'm' },
    { id: '2994', text: 'Mattia', gender: 'm' },
    { id: '2995', text: 'Mattias', gender: 'm' },
    { id: '2996', text: 'Mattis', gender: 'm' },
    { id: '2997', text: 'Maureece', gender: 'm' },
    { id: '2998', text: 'Maurice', gender: 'm' },
    { id: '2999', text: 'Maurice', gender: 'm' },
    { id: '3000', text: 'Maurice Christian', gender: 'm' },
    { id: '3001', text: 'Mauricio', gender: 'm' },
    { id: '3002', text: 'Maurizio', gender: 'm' },
    { id: '3003', text: 'Maurizio', gender: 'm' },
    { id: '3004', text: 'Mavie', gender: 'f' },
    { id: '3005', text: 'Max', gender: 'm' },
    { id: '3006', text: 'Max', gender: 'm' },
    { id: '3007', text: 'Max Alexander', gender: 'm' },
    { id: '3008', text: 'Max Cedrik', gender: 'm' },
    { id: '3009', text: 'Max Louis', gender: 'm' },
    { id: '3010', text: 'Max Maddox', gender: 'm' },
    { id: '3011', text: 'Max-Aleyej', gender: 'm' },
    { id: '3012', text: 'Max-Leonhard', gender: 'm' },
    { id: '3013', text: 'Maxi', gender: 'f' },
    { id: '3014', text: 'Maxim', gender: 'm' },
    { id: '3015', text: 'Maxim', gender: 'm' },
    { id: '3016', text: 'Maxima', gender: 'f' },
    { id: '3017', text: 'Maximilian', gender: 'm' },
    { id: '3018', text: 'Maximilian', gender: 'm' },
    { id: '3019', text: 'MaximilianLuis-Florentino', gender: 'm' },
    { id: '3020', text: 'Maya', gender: 'f' },
    { id: '3021', text: 'Maya', gender: 'f' },
    { id: '3022', text: 'Maya Sophie', gender: 'f' },
    { id: '3023', text: 'Mayleen', gender: 'f' },
    { id: '3024', text: 'Mayra', gender: 'f' },
    { id: '3025', text: 'Mayson', gender: 'm' },
    { id: '3026', text: 'Me', gender: 'f' },
    { id: '3027', text: 'Mechthild', gender: 'f' },
    { id: '3028', text: 'Mechthilde', gender: 'f' },
    { id: '3029', text: 'Mechtild', gender: 'f' },
    { id: '3030', text: 'Megan', gender: 'f' },
    { id: '3031', text: 'Mehdi', gender: 'm' },
    { id: '3032', text: 'Mehmet', gender: 'm' },
    { id: '3033', text: 'Meik', gender: 'm' },
    { id: '3034', text: 'Meike', gender: 'f' },
    { id: '3035', text: 'Meinhard', gender: 'm' },
    { id: '3036', text: 'Meinolf', gender: 'm' },
    { id: '3037', text: 'Meinrad', gender: 'm' },
    { id: '3038', text: 'Melanie', gender: 'f' },
    { id: '3039', text: 'Melanie', gender: 'f' },
    { id: '3040', text: 'Melia', gender: 'f' },
    { id: '3041', text: 'Meliha', gender: 'f' },
    { id: '3042', text: 'Melina', gender: 'f' },
    { id: '3043', text: 'Melina Sophie', gender: 'f' },
    { id: '3044', text: 'Melinda', gender: 'f' },
    { id: '3045', text: 'Melisa', gender: 'f' },
    { id: '3046', text: 'Melissa', gender: 'f' },
    { id: '3047', text: 'Melissa', gender: 'f' },
    { id: '3048', text: 'Melissa Abigail', gender: 'f' },
    { id: '3049', text: 'Melita', gender: 'f' },
    { id: '3050', text: 'Melitta', gender: 'f' },
    { id: '3051', text: 'Melody', gender: 'f' },
    { id: '3052', text: 'Melvin', gender: 'm' },
    { id: '3053', text: 'Mena', gender: 'f' },
    { id: '3054', text: 'Meral', gender: 'f' },
    { id: '3055', text: 'Meranda', gender: 'f' },
    { id: '3056', text: 'Mercan', gender: 'f' },
    { id: '3057', text: 'Mercedes', gender: 'f' },
    { id: '3058', text: 'Mercedes', gender: 'f' },
    { id: '3059', text: 'Meret', gender: 'f' },
    { id: '3060', text: 'Merle', gender: 'f' },
    { id: '3061', text: 'Merlin', gender: 'm' },
    { id: '3062', text: 'Meryem', gender: 'f' },
    { id: '3063', text: 'Mesut', gender: 'm' },
    { id: '3064', text: 'Meta', gender: 'f' },
    { id: '3065', text: 'Meter', gender: 'f' },
    { id: '3066', text: 'Metin', gender: 'm' },
    { id: '3067', text: 'Mia', gender: 'f' },
    { id: '3068', text: 'Mia', gender: 'f' },
    { id: '3069', text: 'Mia Aur élie', gender: 'f' },
    { id: '3070', text: 'Mia Joline', gender: 'f' },
    { id: '3071', text: 'Mia Luisa', gender: 'f' },
    { id: '3072', text: 'Mia Luisa Audrey', gender: 'f' },
    { id: '3073', text: 'Mia Marcella', gender: 'f' },
    { id: '3074', text: 'Mia Mareike', gender: 'f' },
    { id: '3075', text: 'Mia Marisa', gender: 'f' },
    { id: '3076', text: 'Mia Mathilda', gender: 'f' },
    { id: '3077', text: 'Mia Melina', gender: 'f' },
    { id: '3078', text: 'Mia Penelope', gender: 'f' },
    { id: '3079', text: 'Mia Philine', gender: 'm' },
    { id: '3080', text: 'Mia Sofie', gender: 'f' },
    { id: '3081', text: 'Mia Sophie', gender: 'f' },
    { id: '3082', text: 'Mia-Antonia', gender: 'f' },
    { id: '3083', text: 'Mia-Felice', gender: 'f' },
    { id: '3084', text: 'Mia-Marie', gender: 'f' },
    { id: '3085', text: 'Mia-Marleen', gender: 'f' },
    { id: '3086', text: 'Mia-paiton', gender: 'f' },
    { id: '3087', text: 'Micha', gender: 'm' },
    { id: '3088', text: 'Michael', gender: 'm' },
    { id: '3089', text: 'Michael', gender: 'm' },
    { id: '3090', text: 'Michaela', gender: 'f' },
    { id: '3091', text: 'Michaele', gender: 'f' },
    { id: '3092', text: 'Michail', gender: 'm' },
    { id: '3093', text: 'Michel', gender: 'm' },
    { id: '3094', text: 'Michel', gender: 'm' },
    { id: '3095', text: 'Michelle', gender: 'f' },
    { id: '3096', text: 'Michelle', gender: 'f' },
    { id: '3097', text: 'Michelle Alina', gender: 'f' },
    { id: '3098', text: 'Michelle sophie', gender: 'f' },
    { id: '3099', text: 'Michelle-Marie', gender: 'f' },
    { id: '3100', text: 'Midori', gender: 'f' },
    { id: '3101', text: 'Miena', gender: 'f' },
    { id: '3102', text: 'Miguel', gender: 'm' },
    { id: '3103', text: 'Miguel', gender: 'm' },
    { id: '3104', text: 'Miina', gender: 'f' },
    { id: '3105', text: 'Mijo', gender: 'm' },
    { id: '3106', text: 'Mijo', gender: 'm' },
    { id: '3107', text: 'Mika', gender: 'm' },
    { id: '3108', text: 'Mike', gender: 'm' },
    { id: '3109', text: 'Mike', gender: 'm' },
    { id: '3110', text: 'Mike Oliver', gender: 'm' },
    { id: '3111', text: 'Mike-Simon', gender: 'm' },
    { id: '3112', text: 'Mikhail', gender: 'm' },
    { id: '3113', text: 'Mikko', gender: 'm' },
    { id: '3114', text: 'Mila', gender: 'f' },
    { id: '3115', text: 'Mila', gender: 'f' },
    { id: '3116', text: 'Milaim', gender: 'm' },
    { id: '3117', text: 'Milan', gender: 'm' },
    { id: '3118', text: 'Milan', gender: 'm' },
    { id: '3119', text: 'Milan Laurin', gender: 'm' },
    { id: '3120', text: 'Milano', gender: 'm' },
    { id: '3121', text: 'Milena', gender: 'f' },
    { id: '3122', text: 'Milena', gender: 'f' },
    { id: '3123', text: 'Milena-Evelyn', gender: 'f' },
    { id: '3124', text: 'Miley', gender: 'f' },
    { id: '3125', text: 'Milica', gender: 'f' },
    { id: '3126', text: 'Milka', gender: 'f' },
    { id: '3127', text: 'Milla', gender: 'f' },
    { id: '3128', text: 'Milo', gender: 'm' },
    { id: '3129', text: 'Milos', gender: 'm' },
    { id: '3130', text: 'Mina', gender: 'f' },
    { id: '3131', text: 'Mina', gender: 'f' },
    { id: '3132', text: 'Minja', gender: 'f' },
    { id: '3133', text: 'Minna', gender: 'f' },
    { id: '3134', text: 'Mino', gender: 'm' },
    { id: '3135', text: 'Minou', gender: 'f' },
    { id: '3136', text: 'Mio', gender: 'm' },
    { id: '3137', text: 'Miodrag', gender: 'm' },
    { id: '3138', text: 'Mira', gender: 'f' },
    { id: '3139', text: 'Mira', gender: 'f' },
    { id: '3140', text: 'Miraita', gender: 'f' },
    { id: '3141', text: 'Mirco', gender: 'm' },
    { id: '3142', text: 'Mirco Joshua', gender: 'm' },
    { id: '3143', text: 'Mirella', gender: 'f' },
    { id: '3144', text: 'Miriam', gender: 'f' },
    { id: '3145', text: 'Miriam-Patricia', gender: 'f' },
    { id: '3146', text: 'Miriana', gender: 'f' },
    { id: '3147', text: 'Mirja', gender: 'f' },
    { id: '3148', text: 'Mirjam', gender: 'f' },
    { id: '3149', text: 'Mirjam', gender: 'f' },
    { id: '3150', text: 'Mirjana', gender: 'f' },
    { id: '3151', text: 'Mirko', gender: 'm' },
    { id: '3152', text: 'Miroslav', gender: 'm' },
    { id: '3153', text: 'Miroslaw', gender: 'm' },
    { id: '3154', text: 'Miroslawa', gender: 'f' },
    { id: '3155', text: 'Mischa', gender: 'f' },
    { id: '3156', text: 'Mischa', gender: 'm' },
    { id: '3157', text: 'Misha', gender: 'f' },
    { id: '3158', text: 'Mitco', gender: 'f' },
    { id: '3159', text: 'Mohamed', gender: 'm' },
    { id: '3160', text: 'Mohammad', gender: 'm' },
    { id: '3161', text: 'Mohammed', gender: 'm' },
    { id: '3162', text: 'Mona', gender: 'f' },
    { id: '3163', text: 'Mona', gender: 'f' },
    { id: '3164', text: 'Monica', gender: 'f' },
    { id: '3165', text: 'Monico', gender: 'm' },
    { id: '3166', text: 'Monika', gender: 'f' },
    { id: '3167', text: 'Monique', gender: 'f' },
    { id: '3168', text: 'Monja', gender: 'f' },
    { id: '3169', text: 'Montry', gender: 'm' },
    { id: '3170', text: 'Morice', gender: 'm' },
    { id: '3171', text: 'Moritz', gender: 'm' },
    { id: '3172', text: 'Moritz', gender: 'm' },
    { id: '3173', text: 'Mourice', gender: 'm' },
    { id: '3174', text: 'Mousa', gender: 'm' },
    { id: '3175', text: 'Muharrem', gender: 'm' },
    { id: '3176', text: 'Murat', gender: 'm' },
    { id: '3177', text: 'Muriel', gender: 'f' },
    { id: '3178', text: 'Mustafa', gender: 'm' },
    { id: '3179', text: 'Muzaffer', gender: 'm' },
    { id: '3180', text: 'Myleen', gender: 'f' },
    { id: '3181', text: 'Myriam', gender: 'f' },
    { id: '3182', text: 'Myriam', gender: 'f' },
    { id: '3183', text: 'Nada', gender: 'f' },
    { id: '3184', text: 'Nadeschda', gender: 'f' },
    { id: '3185', text: 'Nadeshda', gender: 'f' },
    { id: '3186', text: 'Nadia', gender: 'f' },
    { id: '3187', text: 'Nadin', gender: 'f' },
    { id: '3188', text: 'Nadine', gender: 'f' },
    { id: '3189', text: 'Nadine', gender: 'f' },
    { id: '3190', text: 'Nadine Keira', gender: 'f' },
    { id: '3191', text: 'Nadja', gender: 'f' },
    { id: '3192', text: 'Nadja', gender: 'f' },
    { id: '3193', text: 'Nahla', gender: 'f' },
    { id: '3194', text: 'Naiobi', gender: 'f' },
    { id: '3195', text: 'Naliah', gender: 'f' },
    { id: '3196', text: 'Namika', gender: 'f' },
    { id: '3197', text: 'Nancy', gender: 'f' },
    { id: '3198', text: 'Natali', gender: 'f' },
    { id: '3199', text: 'Natalia', gender: 'f' },
    { id: '3200', text: 'Natalie', gender: 'f' },
    { id: '3201', text: 'Natalie', gender: 'f' },
    { id: '3202', text: 'Natalija', gender: 'f' },
    { id: '3203', text: 'Natalija', gender: 'f' },
    { id: '3204', text: 'Natalja', gender: 'f' },
    { id: '3205', text: 'Natascha', gender: 'f' },
    { id: '3206', text: 'Nathalie', gender: 'f' },
    { id: '3207', text: 'Nathalie', gender: 'f' },
    { id: '3208', text: 'Nathalie Sue', gender: 'f' },
    { id: '3209', text: 'Nathan', gender: 'm' },
    { id: '3210', text: 'Nathaniel', gender: 'm' },
    { id: '3211', text: 'Nathon', gender: 'm' },
    { id: '3212', text: 'Navina', gender: 'f' },
    { id: '3213', text: 'Nea', gender: 'f' },
    { id: '3214', text: 'Neas', gender: 'm' },
    { id: '3215', text: 'Necati', gender: 'm' },
    { id: '3216', text: 'Neela', gender: 'f' },
    { id: '3217', text: 'Neeltje', gender: 'f' },
    { id: '3218', text: 'Neide', gender: 'f' },
    { id: '3219', text: 'Nele', gender: 'f' },
    { id: '3220', text: 'Nele-Hermine', gender: 'f' },
    { id: '3221', text: 'Nell', gender: 'f' },
    { id: '3222', text: 'Nelli', gender: 'f' },
    { id: '3223', text: 'Nelly', gender: 'f' },
    { id: '3224', text: 'Nelly', gender: 'f' },
    { id: '3225', text: 'Nenad', gender: 'm' },
    { id: '3226', text: 'Neo', gender: 'm' },
    { id: '3227', text: 'Nermin', gender: 'f' },
    { id: '3228', text: 'Neven', gender: 'm' },
    { id: '3229', text: 'Nevenka', gender: 'f' },
    { id: '3230', text: 'Neves', gender: 'f' },
    { id: '3231', text: 'Neves-Leni', gender: 'f' },
    { id: '3232', text: 'Neviah', gender: 'f' },
    { id: '3233', text: 'Nevio', gender: 'm' },
    { id: '3234', text: 'Nia', gender: 'f' },
    { id: '3235', text: 'Niamh', gender: 'f' },
    { id: '3236', text: 'Nic-Sander', gender: 'm' },
    { id: '3237', text: 'Nicita', gender: 'f' },
    { id: '3238', text: 'Nick', gender: 'm' },
    { id: '3239', text: 'Nick', gender: 'm' },
    { id: '3240', text: 'Nick Sidney', gender: 'm' },
    { id: '3241', text: 'Nick-Kilian', gender: 'm' },
    { id: '3242', text: 'Nick-Maximilian', gender: 'm' },
    { id: '3243', text: 'Nico', gender: 'm' },
    { id: '3244', text: 'Nico', gender: 'm' },
    { id: '3245', text: 'Nico Emiliano', gender: 'm' },
    { id: '3246', text: 'Nico-Jan', gender: 'm' },
    { id: '3247', text: 'Nicol', gender: 'f' },
    { id: '3248', text: 'Nicola', gender: 'm' },
    { id: '3249', text: 'Nicolai', gender: 'm' },
    { id: '3250', text: 'Nicolas', gender: 'm' },
    { id: '3251', text: 'Nicolas', gender: 'm' },
    { id: '3252', text: 'Nicolaus', gender: 'm' },
    { id: '3253', text: 'Nicole', gender: 'f' },
    { id: '3254', text: 'Nicole', gender: 'f' },
    { id: '3255', text: 'Niels', gender: 'm' },
    { id: '3256', text: 'Niels Vincent', gender: 'm' },
    { id: '3257', text: 'Nik Luiz', gender: 'm' },
    { id: '3258', text: 'Nike', gender: 'f' },
    { id: '3259', text: 'Nike Naomi', gender: 'f' },
    { id: '3260', text: 'Nike Nathalie', gender: 'f' },
    { id: '3261', text: 'Nikita', gender: 'm' },
    { id: '3262', text: 'Niklas', gender: 'm' },
    { id: '3263', text: 'Niklas / Niclas', gender: 'm' },
    { id: '3264', text: 'Niklas-Samuel', gender: 'm' },
    { id: '3265', text: 'Niko', gender: 'm' },
    { id: '3266', text: 'Nikola', gender: 'm' },
    { id: '3267', text: 'Nikolai', gender: 'm' },
    { id: '3268', text: 'Nikolai', gender: 'm' },
    { id: '3269', text: 'Nikolaj', gender: 'm' },
    { id: '3270', text: 'Nikolaos', gender: 'm' },
    { id: '3271', text: 'Nikolas', gender: 'm' },
    { id: '3272', text: 'Nikolaus', gender: 'm' },
    { id: '3273', text: 'Nilay Loreen', gender: 'f' },
    { id: '3274', text: 'Nils', gender: 'm' },
    { id: '3275', text: 'Nils', gender: 'm' },
    { id: '3276', text: 'Nina', gender: 'f' },
    { id: '3277', text: 'Nina', gender: 'f' },
    { id: '3278', text: 'Nina Marie', gender: 'f' },
    { id: '3279', text: 'Nina-Jennifer', gender: 'f' },
    { id: '3280', text: 'Ninja', gender: 'f' },
    { id: '3281', text: 'Nino', gender: 'm' },
    { id: '3282', text: 'Noa', gender: 'f' },
    { id: '3283', text: 'Noah / Noa / Noá', gender: 'm' },
    { id: '3284', text: 'Noah Elias', gender: 'm' },
    { id: '3285', text: 'Noah Malte', gender: 'm' },
    { id: '3286', text: 'Noah Tamino', gender: 'm' },
    { id: '3287', text: 'Noah-Dave', gender: 'm' },
    { id: '3288', text: 'Noah-Elias', gender: 'm' },
    { id: '3289', text: 'Noah-Joel', gender: 'm' },
    { id: '3290', text: 'Noah-Levin', gender: 'm' },
    { id: '3291', text: 'Noam', gender: 'm' },
    { id: '3292', text: 'Noé', gender: 'm' },
    { id: '3293', text: 'Noel', gender: 'm' },
    { id: '3294', text: 'Noel', gender: 'm' },
    { id: '3295', text: 'Noel Yannis', gender: 'm' },
    { id: '3296', text: 'Noelia Michelle', gender: 'f' },
    { id: '3297', text: 'Noelle', gender: 'f' },
    { id: '3298', text: 'NoelMaximilian', gender: 'm' },
    { id: '3299', text: 'Noemi', gender: 'f' },
    { id: '3300', text: 'Noha', gender: 'm' },
    { id: '3301', text: 'Nohely', gender: 'f' },
    { id: '3302', text: 'Noko', gender: 'm' },
    { id: '3303', text: 'Noor', gender: 'm' },
    { id: '3304', text: 'Nora', gender: 'f' },
    { id: '3305', text: 'Nora', gender: 'f' },
    { id: '3306', text: 'Norbert', gender: 'm' },
    { id: '3307', text: 'Noreen', gender: 'f' },
    { id: '3308', text: 'Noren Oliver', gender: 'm' },
    { id: '3309', text: 'Norma', gender: 'f' },
    { id: '3310', text: 'Norman', gender: 'm' },
    { id: '3311', text: 'Normen', gender: 'm' },
    { id: '3312', text: 'Notburga', gender: 'f' },
    { id: '3313', text: 'Nova', gender: 'f' },
    { id: '3314', text: 'Nuno', gender: 'm' },
    { id: '3315', text: 'Nur', gender: 'f' },
    { id: '3316', text: 'Nuran', gender: 'f' },
    { id: '3317', text: 'Nuray', gender: 'f' },
    { id: '3318', text: 'Nurettin', gender: 'm' },
    { id: '3319', text: 'Nuri', gender: 'm' },
    { id: '3320', text: 'Nuria', gender: 'f' },
    { id: '3321', text: 'Nurten', gender: 'f' },
    { id: '3322', text: 'Oceane', gender: 'f' },
    { id: '3323', text: 'Oda', gender: 'f' },
    { id: '3324', text: 'Oda', gender: 'f' },
    { id: '3325', text: 'Odin', gender: 'm' },
    { id: '3326', text: 'Oke-Römer', gender: 'm' },
    { id: '3327', text: 'Olaf', gender: 'm' },
    { id: '3328', text: 'Olav', gender: 'f' },
    { id: '3329', text: 'Ole', gender: 'm' },
    { id: '3330', text: 'Ole', gender: 'm' },
    { id: '3331', text: 'Ole Oskar', gender: 'm' },
    { id: '3332', text: 'Ole-Einar', gender: 'm' },
    { id: '3333', text: 'Olena', gender: 'f' },
    { id: '3334', text: 'Olga', gender: 'f' },
    { id: '3335', text: 'Olinda', gender: 'f' },
    { id: '3336', text: 'Oliver', gender: 'm' },
    { id: '3337', text: 'Oliver', gender: 'f' },
    { id: '3338', text: 'Oliver', gender: 'm' },
    { id: '3339', text: 'Oliver Patrick', gender: 'm' },
    { id: '3340', text: 'Olivia', gender: 'f' },
    { id: '3341', text: 'Olivia', gender: 'f' },
    { id: '3342', text: 'Olivia Antonia ', gender: 'f' },
    { id: '3343', text: 'Olivia-Janina', gender: 'f' },
    { id: '3344', text: 'Olivier', gender: 'm' },
    { id: '3345', text: 'Ömer', gender: 'm' },
    { id: '3346', text: 'Onrie', gender: 'm' },
    { id: '3347', text: 'Orhan', gender: 'm' },
    { id: '3348', text: 'Orlando', gender: 'm' },
    { id: '3349', text: 'Ortrud', gender: 'f' },
    { id: '3350', text: 'Ortrun', gender: 'f' },
    { id: '3351', text: 'Ortwin', gender: 'm' },
    { id: '3352', text: 'Oscar', gender: 'm' },
    { id: '3353', text: 'Oskar', gender: 'm' },
    { id: '3354', text: 'Oskar', gender: 'm' },
    { id: '3355', text: 'Osman', gender: 'm' },
    { id: '3356', text: 'Oswald', gender: 'm' },
    { id: '3357', text: 'Oswin', gender: 'm' },
    { id: '3358', text: 'Otfried', gender: 'm' },
    { id: '3359', text: 'Othmar', gender: 'm' },
    { id: '3360', text: 'Otmar', gender: 'm' },
    { id: '3361', text: 'Ottfried', gender: 'm' },
    { id: '3362', text: 'Ottilie', gender: 'f' },
    { id: '3363', text: 'Ottmar', gender: 'm' },
    { id: '3364', text: 'Otto', gender: 'm' },
    { id: '3365', text: 'Otto', gender: 'm' },
    { id: '3366', text: 'Ottokar', gender: 'm' },
    { id: '3367', text: 'Ottomar', gender: 'm' },
    { id: '3368', text: 'Oxana', gender: 'f' },
    { id: '3369', text: 'Oxana', gender: 'f' },
    { id: '3370', text: 'Pablo', gender: 'm' },
    { id: '3371', text: 'Pamela', gender: 'f' },
    { id: '3372', text: 'Panja', gender: 'f' },
    { id: '3373', text: 'Paola', gender: 'f' },
    { id: '3374', text: 'Paolo', gender: 'm' },
    { id: '3375', text: 'Paris', gender: 'f' },
    { id: '3376', text: 'Pascal', gender: 'm' },
    { id: '3377', text: 'Pascal', gender: 'm' },
    { id: '3378', text: 'Pascal Joel', gender: 'm' },
    { id: '3379', text: 'Pascal Pau', gender: 'm' },
    { id: '3380', text: 'Pascale', gender: 'f' },
    { id: '3381', text: 'Pascale', gender: 'f' },
    { id: '3382', text: 'Pasquale', gender: 'm' },
    { id: '3383', text: 'Patric', gender: 'm' },
    { id: '3384', text: 'Patricia', gender: 'f' },
    { id: '3385', text: 'Patricia', gender: 'f' },
    { id: '3386', text: 'Patricia Marie', gender: 'f' },
    { id: '3387', text: 'Patrick', gender: 'm' },
    { id: '3388', text: 'Patrik', gender: 'm' },
    { id: '3389', text: 'Patrizia', gender: 'f' },
    { id: '3390', text: 'Pauel', gender: 'm' },
    { id: '3391', text: 'Paul', gender: 'm' },
    { id: '3392', text: 'Paul', gender: 'm' },
    { id: '3393', text: 'Paul Elija', gender: 'm' },
    { id: '3394', text: 'Paul Finley', gender: 'm' },
    { id: '3395', text: 'Paul Luca', gender: 'm' },
    { id: '3396', text: 'Paul Sebastian', gender: 'm' },
    { id: '3397', text: 'Paul Stanley', gender: 'm' },
    { id: '3398', text: 'Paul Vincent', gender: 'm' },
    { id: '3399', text: 'Paul-Gerhard', gender: 'm' },
    { id: '3400', text: 'Paul-Heinz', gender: 'm' },
    { id: '3401', text: 'Paul-Laurenz', gender: 'm' },
    { id: '3402', text: 'Paula', gender: 'f' },
    { id: '3403', text: 'Paula', gender: 'f' },
    { id: '3404', text: 'Paula Emilia Sophie', gender: 'f' },
    { id: '3405', text: 'Paulina', gender: 'f' },
    { id: '3406', text: 'Paulina', gender: 'f' },
    { id: '3407', text: 'Pauline', gender: 'f' },
    { id: '3408', text: 'Pauline', gender: 'f' },
    { id: '3409', text: 'Paulo', gender: 'm' },
    { id: '3410', text: 'Pavel', gender: 'm' },
    { id: '3411', text: 'Pawel', gender: 'm' },
    { id: '3412', text: 'Pax', gender: 'm' },
    { id: '3413', text: 'Pedro', gender: 'm' },
    { id: '3414', text: 'Peer', gender: 'm' },
    { id: '3415', text: 'Peer Alejandro', gender: 'm' },
    { id: '3416', text: 'Peer-Arne', gender: 'm' },
    { id: '3417', text: 'Peggy', gender: 'f' },
    { id: '3418', text: 'Penelope', gender: 'f' },
    { id: '3419', text: 'Pepè', gender: 'm' },
    { id: '3420', text: 'Pepe Uli', gender: 'm' },
    { id: '3421', text: 'Perla', gender: 'f' },
    { id: '3422', text: 'Pero', gender: 'm' },
    { id: '3423', text: 'Petar', gender: 'm' },
    { id: '3424', text: 'Peter', gender: 'm' },
    { id: '3425', text: 'Peter', gender: 'm' },
    { id: '3426', text: 'Peter-Michael', gender: 'm' },
    { id: '3427', text: 'Petra', gender: 'f' },
    { id: '3428', text: 'Petros', gender: 'm' },
    { id: '3429', text: 'Phiebie', gender: 'f' },
    { id: '3430', text: 'Phil', gender: 'm' },
    { id: '3431', text: 'Phil Cornelius', gender: 'm' },
    { id: '3432', text: 'Phil-Louis', gender: 'm' },
    { id: '3433', text: 'Philine', gender: 'f' },
    { id: '3434', text: 'Philip', gender: 'm' },
    { id: '3435', text: 'Philipp', gender: 'm' },
    { id: '3436', text: 'Philipp', gender: 'm' },
    { id: '3437', text: 'Philipp Danieel', gender: 'm' },
    { id: '3438', text: 'Philippe', gender: 'm' },
    { id: '3439', text: 'Philippe', gender: 'm' },
    { id: '3440', text: 'Phillip', gender: 'm' },
    { id: '3441', text: 'Phillip / Filip / Philipp', gender: 'm' },
    { id: '3442', text: 'Phillip-Maurice', gender: 'm' },
    { id: '3443', text: 'Philomena', gender: 'f' },
    { id: '3444', text: 'Phobe / Phoebe', gender: 'f' },
    { id: '3445', text: 'Phoenix', gender: 'm' },
    { id: '3446', text: 'Phyllis', gender: 'f' },
    { id: '3447', text: 'Pia', gender: 'f' },
    { id: '3448', text: 'Pia', gender: 'f' },
    { id: '3449', text: 'Pia - Sophia', gender: 'f' },
    { id: '3450', text: 'Pia Viktoria', gender: 'f' },
    { id: '3451', text: 'Pierre', gender: 'm' },
    { id: '3452', text: 'Pierre-Luca', gender: 'm' },
    { id: '3453', text: 'Piet-Ole', gender: 'm' },
    { id: '3454', text: 'Pietro', gender: 'm' },
    { id: '3455', text: 'Pina', gender: 'f' },
    { id: '3456', text: 'Piotr', gender: 'm' },
    { id: '3457', text: 'Pirmin', gender: 'm' },
    { id: '3458', text: 'Pius', gender: 'm' },
    { id: '3459', text: 'Pius', gender: 'm' },
    { id: '3460', text: 'Pjeer', gender: 'm' },
    { id: '3461', text: 'Polina', gender: 'f' },
    { id: '3462', text: 'Polina', gender: 'f' },
    { id: '3463', text: 'Priscilla', gender: 'f' },
    { id: '3464', text: 'Priska', gender: 'f' },
    { id: '3465', text: 'Quentin', gender: 'm' },
    { id: '3466', text: 'Rabea', gender: 'f' },
    { id: '3467', text: 'Rachel', gender: 'f' },
    { id: '3468', text: 'Radmila', gender: 'f' },
    { id: '3469', text: 'Rafael', gender: 'm' },
    { id: '3470', text: 'Rafael', gender: 'm' },
    { id: '3471', text: 'Raffael', gender: 'm' },
    { id: '3472', text: 'Raffaele', gender: 'm' },
    { id: '3473', text: 'Rahel', gender: 'f' },
    { id: '3474', text: 'Rahel', gender: 'f' },
    { id: '3475', text: 'Raik', gender: 'm' },
    { id: '3476', text: 'Raik', gender: 'm' },
    { id: '3477', text: 'Raimund', gender: 'm' },
    { id: '3478', text: 'Rainer', gender: 'm' },
    { id: '3479', text: 'Raisa', gender: 'f' },
    { id: '3480', text: 'Raissa', gender: 'f' },
    { id: '3481', text: 'Ralf', gender: 'm' },
    { id: '3482', text: 'Ralf', gender: 'm' },
    { id: '3483', text: 'Ralf-Dieter', gender: 'm' },
    { id: '3484', text: 'Ralf-Peter', gender: 'm' },
    { id: '3485', text: 'Ralph', gender: 'm' },
    { id: '3486', text: 'Ramazan', gender: 'm' },
    { id: '3487', text: 'Ramon', gender: 'm' },
    { id: '3488', text: 'Ramon', gender: 'm' },
    { id: '3489', text: 'Ramona', gender: 'f' },
    { id: '3490', text: 'Ramona', gender: 'f' },
    { id: '3491', text: 'Ramses', gender: 'm' },
    { id: '3492', text: 'Randolf', gender: 'm' },
    { id: '3493', text: 'Randy', gender: 'm' },
    { id: '3494', text: 'Raphael', gender: 'm' },
    { id: '3495', text: 'Raphael', gender: 'm' },
    { id: '3496', text: 'Raphaela', gender: 'f' },
    { id: '3497', text: 'Rasmus', gender: 'm' },
    { id: '3498', text: 'Raul', gender: 'm' },
    { id: '3499', text: 'Raven Luca', gender: 'm' },
    { id: '3500', text: 'Ray', gender: 'm' },
    { id: '3501', text: 'Rayan', gender: 'm' },
    { id: '3502', text: 'Raymond', gender: 'm' },
    { id: '3503', text: 'Raymund', gender: 'm' },
    { id: '3504', text: 'Rebecca', gender: 'f' },
    { id: '3505', text: 'Rebecca', gender: 'f' },
    { id: '3506', text: 'Rebekka', gender: 'f' },
    { id: '3507', text: 'Rebekka', gender: 'f' },
    { id: '3508', text: 'Recep', gender: 'm' },
    { id: '3509', text: 'Regina', gender: 'f' },
    { id: '3510', text: 'Reginald', gender: 'm' },
    { id: '3511', text: 'Regine', gender: 'f' },
    { id: '3512', text: 'Reimar', gender: 'm' },
    { id: '3513', text: 'Reimer', gender: 'm' },
    { id: '3514', text: 'Reimund', gender: 'm' },
    { id: '3515', text: 'Reinald', gender: 'm' },
    { id: '3516', text: 'Reiner', gender: 'm' },
    { id: '3517', text: 'Reingard', gender: 'f' },
    { id: '3518', text: 'Reinhard', gender: 'm' },
    { id: '3519', text: 'Reinhardt', gender: 'm' },
    { id: '3520', text: 'Reinhart', gender: 'm' },
    { id: '3521', text: 'Reinhild', gender: 'f' },
    { id: '3522', text: 'Reinhilde', gender: 'f' },
    { id: '3523', text: 'Reinhold', gender: 'm' },
    { id: '3524', text: 'Remo', gender: 'm' },
    { id: '3525', text: 'Rena', gender: 'f' },
    { id: '3526', text: 'Renata', gender: 'f' },
    { id: '3527', text: 'Renata', gender: 'f' },
    { id: '3528', text: 'Renate', gender: 'f' },
    { id: '3529', text: 'Renato', gender: 'm' },
    { id: '3530', text: 'Rene', gender: 'm' },
    { id: '3531', text: 'René', gender: 'm' },
    { id: '3532', text: 'René Marcel', gender: 'm' },
    { id: '3533', text: 'Renee', gender: 'f' },
    { id: '3534', text: 'Reneé', gender: 'm' },
    { id: '3535', text: 'Renee Tamara', gender: 'f' },
    { id: '3536', text: 'Reni', gender: 'f' },
    { id: '3537', text: 'Resi', gender: 'f' },
    { id: '3538', text: 'Rex', gender: 'm' },
    { id: '3539', text: 'Reza', gender: 'm' },
    { id: '3540', text: 'Rhijana', gender: 'f' },
    { id: '3541', text: 'Ria', gender: 'f' },
    { id: '3542', text: 'Ria Ella', gender: 'f' },
    { id: '3543', text: 'Ricarda', gender: 'f' },
    { id: '3544', text: 'Ricarda', gender: 'f' },
    { id: '3545', text: 'Ricardo', gender: 'm' },
    { id: '3546', text: 'Ricardo', gender: 'm' },
    { id: '3547', text: 'Richard', gender: 'm' },
    { id: '3548', text: 'Richard', gender: 'm' },
    { id: '3549', text: 'Richard Cedric', gender: 'm' },
    { id: '3550', text: 'Richard-Oliver', gender: 'm' },
    { id: '3551', text: 'Rico', gender: 'm' },
    { id: '3552', text: 'Rico', gender: 'm' },
    { id: '3553', text: 'Rigo', gender: 'm' },
    { id: '3554', text: 'Riley', gender: 'm' },
    { id: '3555', text: 'Rita', gender: 'f' },
    { id: '3556', text: 'Riza', gender: 'm' },
    { id: '3557', text: 'Robby', gender: 'm' },
    { id: '3558', text: 'Robert', gender: 'm' },
    { id: '3559', text: 'Robert', gender: 'm' },
    { id: '3560', text: 'Roberto', gender: 'm' },
    { id: '3561', text: 'Robin', gender: 'm' },
    { id: '3562', text: 'Robin', gender: 'm' },
    { id: '3563', text: 'Robin Elias', gender: 'm' },
    { id: '3564', text: 'Robin Lion', gender: 'm' },
    { id: '3565', text: 'Robin Luca', gender: 'm' },
    { id: '3566', text: 'Robin Matthis', gender: 'm' },
    { id: '3567', text: 'Robin Pascal', gender: 'm' },
    { id: '3568', text: 'Rocco', gender: 'm' },
    { id: '3569', text: 'Rochus', gender: 'm' },
    { id: '3570', text: 'Rock Lewis', gender: 'm' },
    { id: '3571', text: 'Rocky', gender: 'm' },
    { id: '3572', text: 'Roderich', gender: 'm' },
    { id: '3573', text: 'Roger', gender: 'm' },
    { id: '3574', text: 'Rojan', gender: 'm' },
    { id: '3575', text: 'Roland', gender: 'm' },
    { id: '3576', text: 'Rolf', gender: 'm' },
    { id: '3577', text: 'Rolf-Dieter', gender: 'm' },
    { id: '3578', text: 'Rolf-Peter', gender: 'm' },
    { id: '3579', text: 'Roma', gender: 'f' },
    { id: '3580', text: 'Roman', gender: 'm' },
    { id: '3581', text: 'Roman', gender: 'm' },
    { id: '3582', text: 'Romana', gender: 'f' },
    { id: '3583', text: 'Romeo', gender: 'm' },
    { id: '3584', text: 'Romina', gender: 'f' },
    { id: '3585', text: 'Romuald', gender: 'm' },
    { id: '3586', text: 'Romy', gender: 'f' },
    { id: '3587', text: 'Romy', gender: 'f' },
    { id: '3588', text: 'Ron', gender: 'm' },
    { id: '3589', text: 'Ron', gender: 'm' },
    { id: '3590', text: 'Ronald', gender: 'm' },
    { id: '3591', text: 'Ronja', gender: 'f' },
    { id: '3592', text: 'Ronja', gender: 'f' },
    { id: '3593', text: 'Ronja Joanna', gender: 'f' },
    { id: '3594', text: 'Ronja Lucia', gender: 'f' },
    { id: '3595', text: 'Ronny', gender: 'm' },
    { id: '3596', text: 'Ronny Joey', gender: 'm' },
    { id: '3597', text: 'Rosa', gender: 'f' },
    { id: '3598', text: 'Rosa', gender: 'f' },
    { id: '3599', text: 'Rosa Lynn', gender: 'f' },
    { id: '3600', text: 'Rosa-Maria', gender: 'f' },
    { id: '3601', text: 'Rosalia', gender: 'f' },
    { id: '3602', text: 'Rosalie', gender: 'f' },
    { id: '3603', text: 'Rosalie', gender: 'f' },
    { id: '3604', text: 'Rosalinde', gender: 'f' },
    { id: '3605', text: 'Rosanna', gender: 'f' },
    { id: '3606', text: 'Rose', gender: 'f' },
    { id: '3607', text: 'Rose-Marie', gender: 'f' },
    { id: '3608', text: 'Rosel', gender: 'f' },
    { id: '3609', text: 'Roselia', gender: 'f' },
    { id: '3610', text: 'Roselinde', gender: 'f' },
    { id: '3611', text: 'Rosemarie', gender: 'f' },
    { id: '3612', text: 'Rosi', gender: 'f' },
    { id: '3613', text: 'Rosina', gender: 'f' },
    { id: '3614', text: 'Rosita', gender: 'f' },
    { id: '3615', text: 'Rosl', gender: 'f' },
    { id: '3616', text: 'Rosmarie', gender: 'f' },
    { id: '3617', text: 'Roswita', gender: 'f' },
    { id: '3618', text: 'Roswitha', gender: 'f' },
    { id: '3619', text: 'Rotraud', gender: 'f' },
    { id: '3620', text: 'Rotraut', gender: 'f' },
    { id: '3621', text: 'Rouven', gender: 'm' },
    { id: '3622', text: 'Rouven', gender: 'm' },
    { id: '3623', text: 'Roux', gender: 'm' },
    { id: '3624', text: 'Rowen', gender: 'm' },
    { id: '3625', text: 'Roxane / Roxan', gender: 'f' },
    { id: '3626', text: 'Roxane Céline', gender: 'f' },
    { id: '3627', text: 'Roy', gender: 'm' },
    { id: '3628', text: 'Ruben', gender: 'm' },
    { id: '3629', text: 'Ruben', gender: 'm' },
    { id: '3630', text: 'Rudi', gender: 'm' },
    { id: '3631', text: 'Rüdiger', gender: 'm' },
    { id: '3632', text: 'Rudolf', gender: 'm' },
    { id: '3633', text: 'Rudolph', gender: 'm' },
    { id: '3634', text: 'Rulin', gender: 'm' },
    { id: '3635', text: 'Runa', gender: 'f' },
    { id: '3636', text: 'Rune', gender: 'm' },
    { id: '3637', text: 'Rupert', gender: 'm' },
    { id: '3638', text: 'Ruth', gender: 'f' },
    { id: '3639', text: 'Ruthild', gender: 'f' },
    { id: '3640', text: 'Ruven', gender: 'm' },
    { id: '3641', text: 'Ryan', gender: 'm' },
    { id: '3642', text: 'Ryan', gender: 'm' },
    { id: '3643', text: 'Ryan Aron', gender: 'm' },
    { id: '3644', text: 'Ryszard', gender: 'm' },
    { id: '3645', text: 'Saban', gender: 'm' },
    { id: '3646', text: 'Sabina', gender: 'f' },
    { id: '3647', text: 'Sabine', gender: 'f' },
    { id: '3648', text: 'Sabine', gender: 'f' },
    { id: '3649', text: 'Sabri', gender: 'm' },
    { id: '3650', text: 'Sabrina', gender: 'f' },
    { id: '3651', text: 'Sabrina', gender: 'f' },
    { id: '3652', text: 'Sahin', gender: 'm' },
    { id: '3653', text: 'Sahra Jane', gender: 'f' },
    { id: '3654', text: 'Sahra Michelle', gender: 'f' },
    { id: '3655', text: 'Salah', gender: 'm' },
    { id: '3656', text: 'Salih', gender: 'm' },
    { id: '3657', text: 'Salina', gender: 'f' },
    { id: '3658', text: 'Sally', gender: 'f' },
    { id: '3659', text: 'Salome', gender: 'f' },
    { id: '3660', text: 'Salvatore', gender: 'm' },
    { id: '3661', text: 'Sam', gender: 'm' },
    { id: '3662', text: 'Sam Louis', gender: 'm' },
    { id: '3663', text: 'Samantha', gender: 'f' },
    { id: '3664', text: 'Samantha lara', gender: 'f' },
    { id: '3665', text: 'Samara', gender: 'f' },
    { id: '3666', text: 'Sami', gender: 'm' },
    { id: '3667', text: 'Samir', gender: 'm' },
    { id: '3668', text: 'Samira', gender: 'f' },
    { id: '3669', text: 'Samira', gender: 'f' },
    { id: '3670', text: 'Samira Sophie', gender: 'f' },
    { id: '3671', text: 'Samuel', gender: 'm' },
    { id: '3672', text: 'Samuel', gender: 'm' },
    { id: '3673', text: 'Samy', gender: 'm' },
    { id: '3674', text: 'Samy Lukas', gender: 'm' },
    { id: '3675', text: 'Sander', gender: 'm' },
    { id: '3676', text: 'Sandor', gender: 'm' },
    { id: '3677', text: 'Sandra', gender: 'f' },
    { id: '3678', text: 'Sandra', gender: 'f' },
    { id: '3679', text: 'sandrine', gender: 'f' },
    { id: '3680', text: 'Sandro', gender: 'm' },
    { id: '3681', text: 'Sandro', gender: 'm' },
    { id: '3682', text: 'Sandy', gender: 'f' },
    { id: '3683', text: 'Sandy', gender: 'f' },
    { id: '3684', text: 'Sanjana', gender: 'f' },
    { id: '3685', text: 'Sapna', gender: 'f' },
    { id: '3686', text: 'Sara', gender: 'f' },
    { id: '3687', text: 'Sara', gender: 'f' },
    { id: '3688', text: 'Sarafia', gender: 'f' },
    { id: '3689', text: 'Sarafina', gender: 'f' },
    { id: '3690', text: 'Sarah', gender: 'f' },
    { id: '3691', text: 'Sarah / Sara / Sahra', gender: 'f' },
    { id: '3692', text: 'Sarah Jasmin', gender: 'f' },
    { id: '3693', text: 'Sarah- Loreen', gender: 'f' },
    { id: '3694', text: 'Sarah- Marie', gender: 'f' },
    { id: '3695', text: 'Sarah-Ann', gender: 'f' },
    { id: '3696', text: 'Sarina', gender: 'f' },
    { id: '3697', text: 'Sarina', gender: 'f' },
    { id: '3698', text: 'Sascha', gender: 'm' },
    { id: '3699', text: 'Sasina', gender: 'f' },
    { id: '3700', text: 'Saskia', gender: 'f' },
    { id: '3701', text: 'Saskia', gender: 'f' },
    { id: '3702', text: 'Saskia Tamara', gender: 'f' },
    { id: '3703', text: 'Savana', gender: 'f' },
    { id: '3704', text: 'Sayleen', gender: 'm' },
    { id: '3705', text: 'Scarlett', gender: 'f' },
    { id: '3706', text: 'Scarlett Lexa', gender: 'f' },
    { id: '3707', text: 'Scott', gender: 'm' },
    { id: '3708', text: 'Sean', gender: 'm' },
    { id: '3709', text: 'Sean Leon', gender: 'm' },
    { id: '3710', text: 'Sean Paul', gender: 'm' },
    { id: '3711', text: 'Sean-Antony', gender: 'm' },
    { id: '3712', text: 'Sean-Luca', gender: 'm' },
    { id: '3713', text: 'Sean-Paul-Luca', gender: 'm' },
    { id: '3714', text: 'Sean-Preston', gender: 'm' },
    { id: '3715', text: 'Sebastian', gender: 'm' },
    { id: '3716', text: 'Sebastian', gender: 'm' },
    { id: '3717', text: 'Sebastiano', gender: 'm' },
    { id: '3718', text: 'Sedat', gender: 'm' },
    { id: '3719', text: 'Sedrik', gender: 'm' },
    { id: '3720', text: 'Segory', gender: 'm' },
    { id: '3721', text: 'Selena', gender: 'f' },
    { id: '3722', text: 'Selim', gender: 'm' },
    { id: '3723', text: 'Selina', gender: 'f' },
    { id: '3724', text: 'Selina', gender: 'f' },
    { id: '3725', text: 'Selina - Jolie', gender: 'f' },
    { id: '3726', text: 'Selina Sophie', gender: 'f' },
    { id: '3727', text: 'Selma', gender: 'f' },
    { id: '3728', text: 'Semi', gender: 'm' },
    { id: '3729', text: 'Semra', gender: 'f' },
    { id: '3730', text: 'Semrana', gender: 'f' },
    { id: '3731', text: 'Senol', gender: 'm' },
    { id: '3732', text: 'Senta', gender: 'f' },
    { id: '3733', text: 'Sepp', gender: 'm' },
    { id: '3734', text: 'Serafina', gender: 'f' },
    { id: '3735', text: 'Serdar', gender: 'm' },
    { id: '3736', text: 'Serge', gender: 'm' },
    { id: '3737', text: 'Sergei', gender: 'm' },
    { id: '3738', text: 'Sergei', gender: 'm' },
    { id: '3739', text: 'Sergej', gender: 'm' },
    { id: '3740', text: 'Sergio', gender: 'm' },
    { id: '3741', text: 'Sergio', gender: 'm' },
    { id: '3742', text: 'Serpil', gender: 'f' },
    { id: '3743', text: 'Severin', gender: 'm' },
    { id: '3744', text: 'Severin', gender: 'm' },
    { id: '3745', text: 'Sevim', gender: 'f' },
    { id: '3746', text: 'Shaina', gender: 'f' },
    { id: '3747', text: 'Shaleena', gender: 'f' },
    { id: '3748', text: 'Shalik', gender: 'm' },
    { id: '3749', text: 'Shana', gender: 'f' },
    { id: '3750', text: 'Shandy', gender: 'f' },
    { id: '3751', text: 'Shane', gender: 'm' },
    { id: '3752', text: 'Shanice', gender: 'f' },
    { id: '3753', text: 'Shanice', gender: 'm' },
    { id: '3754', text: 'Shannaya', gender: 'f' },
    { id: '3755', text: 'Shannon', gender: 'f' },
    { id: '3756', text: 'Sharona', gender: 'f' },
    { id: '3757', text: 'Shawn', gender: 'm' },
    { id: '3758', text: 'Shawn Michael', gender: 'm' },
    { id: '3759', text: 'Shaya Dyn', gender: 'f' },
    { id: '3760', text: 'Shayenne', gender: 'f' },
    { id: '3761', text: 'Shayna', gender: 'f' },
    { id: '3762', text: 'Sheila', gender: 'f' },
    { id: '3763', text: 'Shirin', gender: 'f' },
    { id: '3764', text: 'Shirona Jane', gender: 'f' },
    { id: '3765', text: 'Shoseline', gender: 'f' },
    { id: '3766', text: 'Sibel', gender: 'f' },
    { id: '3767', text: 'Sibilla', gender: 'f' },
    { id: '3768', text: 'Sibille', gender: 'f' },
    { id: '3769', text: 'Sibylla', gender: 'f' },
    { id: '3770', text: 'Sibylle', gender: 'f' },
    { id: '3771', text: 'Sidney', gender: 'f' },
    { id: '3772', text: 'Siegbert', gender: 'm' },
    { id: '3773', text: 'Siegfried', gender: 'm' },
    { id: '3774', text: 'Sieghard', gender: 'm' },
    { id: '3775', text: 'Sieglinde', gender: 'f' },
    { id: '3776', text: 'Siegmar', gender: 'm' },
    { id: '3777', text: 'Siegmund', gender: 'm' },
    { id: '3778', text: 'Siegrid', gender: 'f' },
    { id: '3779', text: 'Siegried', gender: 'f' },
    { id: '3780', text: 'Siegrun', gender: 'f' },
    { id: '3781', text: 'Siegward', gender: 'm' },
    { id: '3782', text: 'Sienna', gender: 'f' },
    { id: '3783', text: 'Sienna Fee', gender: 'f' },
    { id: '3784', text: 'Sigfried', gender: 'm' },
    { id: '3785', text: 'Sigismund', gender: 'm' },
    { id: '3786', text: 'Siglinde', gender: 'f' },
    { id: '3787', text: 'Sigmar', gender: 'm' },
    { id: '3788', text: 'Sigmund', gender: 'm' },
    { id: '3789', text: 'Sigrid', gender: 'f' },
    { id: '3790', text: 'Sigrun', gender: 'f' },
    { id: '3791', text: 'Sigurd', gender: 'm' },
    { id: '3792', text: 'Silas', gender: 'm' },
    { id: '3793', text: 'Silas Romeo', gender: 'm' },
    { id: '3794', text: 'Silja', gender: 'f' },
    { id: '3795', text: 'Silja', gender: 'f' },
    { id: '3796', text: 'Silja-Malin', gender: 'f' },
    { id: '3797', text: 'Silke', gender: 'f' },
    { id: '3798', text: 'Silva', gender: 'f' },
    { id: '3799', text: 'Silvana', gender: 'f' },
    { id: '3800', text: 'Silvester', gender: 'm' },
    { id: '3801', text: 'Silvia', gender: 'f' },
    { id: '3802', text: 'Silvia', gender: 'f' },
    { id: '3803', text: 'Silvie', gender: 'f' },
    { id: '3804', text: 'Silvio', gender: 'm' },
    { id: '3805', text: 'Simon', gender: 'm' },
    { id: '3806', text: 'Simon', gender: 'm' },
    { id: '3807', text: 'Simon Florin', gender: 'm' },
    { id: '3808', text: 'Simon Liam', gender: 'm' },
    { id: '3809', text: 'Simon Wilhelm', gender: 'm' },
    { id: '3810', text: 'Simona', gender: 'f' },
    { id: '3811', text: 'Simone', gender: 'f' },
    { id: '3812', text: 'Simone', gender: 'f' },
    { id: '3813', text: 'Sina', gender: 'f' },
    { id: '3814', text: 'Sina', gender: 'f' },
    { id: '3815', text: 'Sinah', gender: 'f' },
    { id: '3816', text: 'Sinaida', gender: 'f' },
    { id: '3817', text: 'Sindbad', gender: 'm' },
    { id: '3818', text: 'Sineo', gender: 'm' },
    { id: '3819', text: 'Sinika', gender: 'f' },
    { id: '3820', text: 'Sinika', gender: 'f' },
    { id: '3821', text: 'Sisan', gender: 'm' },
    { id: '3822', text: 'Sissi', gender: 'f' },
    { id: '3823', text: 'Skadi', gender: 'f' },
    { id: '3824', text: 'Skrollan', gender: 'f' },
    { id: '3825', text: 'Sky', gender: 'm' },
    { id: '3826', text: 'Sky Joel', gender: 'm' },
    { id: '3827', text: 'Sky-Eric', gender: 'm' },
    { id: '3828', text: 'Slavica', gender: 'f' },
    { id: '3829', text: 'Slavko', gender: 'm' },
    { id: '3830', text: 'Slawomir', gender: 'm' },
    { id: '3831', text: 'Slobodan', gender: 'm' },
    { id: '3832', text: 'Snezhana', gender: 'f' },
    { id: '3833', text: 'soey charleen', gender: 'f' },
    { id: '3834', text: 'Soffa', gender: 'f' },
    { id: '3835', text: 'Sofia', gender: 'f' },
    { id: '3836', text: 'Sofie', gender: 'f' },
    { id: '3837', text: 'Sofie Marie', gender: 'f' },
    { id: '3838', text: 'Solveig', gender: 'f' },
    { id: '3839', text: 'Söncke', gender: 'm' },
    { id: '3840', text: 'Songül', gender: 'f' },
    { id: '3841', text: 'Sonia', gender: 'f' },
    { id: '3842', text: 'Sonja', gender: 'f' },
    { id: '3843', text: 'Sonja', gender: 'f' },
    { id: '3844', text: 'Sonja Melanie', gender: 'f' },
    { id: '3845', text: 'Sönke', gender: 'm' },
    { id: '3846', text: 'Sönne', gender: 'm' },
    { id: '3847', text: 'Sonni', gender: 'm' },
    { id: '3848', text: 'Sophia', gender: 'f' },
    { id: '3849', text: 'Sophia', gender: 'f' },
    { id: '3850', text: 'Sophia Linn', gender: 'f' },
    { id: '3851', text: 'Sophia Victoria', gender: 'f' },
    { id: '3852', text: 'Sophia-Celinemia', gender: 'f' },
    { id: '3853', text: 'Sophie', gender: 'f' },
    { id: '3854', text: 'Sophie / Sofie', gender: 'f' },
    { id: '3855', text: 'Sophie Anne-Marie', gender: 'f' },
    { id: '3856', text: 'Sophie Hannah Marie', gender: 'f' },
    { id: '3857', text: 'Sophie Luise', gender: 'f' },
    { id: '3858', text: 'Sophie Madlen', gender: 'f' },
    { id: '3859', text: 'Sophie Marie', gender: 'f' },
    { id: '3860', text: 'Sophie-Madlen', gender: 'f' },
    { id: '3861', text: 'Sophiea Lorena', gender: 'f' },
    { id: '3862', text: 'Soraya', gender: 'f' },
    { id: '3863', text: 'Soraya Diana', gender: 'f' },
    { id: '3864', text: 'Sören', gender: 'm' },
    { id: '3865', text: 'Sören', gender: 'm' },
    { id: '3866', text: 'Soufian', gender: 'm' },
    { id: '3867', text: 'Soumia', gender: 'f' },
    { id: '3868', text: 'Stacy', gender: 'f' },
    { id: '3869', text: 'Stan', gender: 'm' },
    { id: '3870', text: 'Stanislaus', gender: 'm' },
    { id: '3871', text: 'Stanislav', gender: 'm' },
    { id: '3872', text: 'Stanislaw', gender: 'm' },
    { id: '3873', text: 'Stavros', gender: 'm' },
    { id: '3874', text: 'Stefan', gender: 'm' },
    { id: '3875', text: 'Stefan', gender: 'm' },
    { id: '3876', text: 'Stefani', gender: 'f' },
    { id: '3877', text: 'Stefania', gender: 'f' },
    { id: '3878', text: 'Stefanie', gender: 'f' },
    { id: '3879', text: 'Stefano', gender: 'm' },
    { id: '3880', text: 'Steffen', gender: 'm' },
    { id: '3881', text: 'Steffen', gender: 'm' },
    { id: '3882', text: 'Steffi', gender: 'f' },
    { id: '3883', text: 'Stella', gender: 'f' },
    { id: '3884', text: 'Stella', gender: 'f' },
    { id: '3885', text: 'Stella', gender: 'f' },
    { id: '3886', text: 'Stella Celina', gender: 'f' },
    { id: '3887', text: 'Stella Isabell', gender: 'f' },
    { id: '3888', text: 'Stephan', gender: 'm' },
    { id: '3889', text: 'Stephanie', gender: 'f' },
    { id: '3890', text: 'Stephen', gender: 'm' },
    { id: '3891', text: 'Steve', gender: 'm' },
    { id: '3892', text: 'Steven', gender: 'm' },
    { id: '3893', text: 'Steven', gender: 'm' },
    { id: '3894', text: 'steven lennox', gender: 'm' },
    { id: '3895', text: 'steven lennox', gender: 'm' },
    { id: '3896', text: 'Stian', gender: 'm' },
    { id: '3897', text: 'Stilla', gender: 'f' },
    { id: '3898', text: 'Stine', gender: 'f' },
    { id: '3899', text: 'Stjepan', gender: 'm' },
    { id: '3900', text: 'Sue', gender: 'f' },
    { id: '3901', text: 'Sue', gender: 'f' },
    { id: '3902', text: 'Sükrü', gender: 'm' },
    { id: '3903', text: 'Sükür Deniz', gender: 'm' },
    { id: '3904', text: 'Süleyman', gender: 'm' },
    { id: '3905', text: 'Sullivan Luca', gender: 'm' },
    { id: '3906', text: 'Summer', gender: 'f' },
    { id: '3907', text: 'Summer Lia', gender: 'f' },
    { id: '3908', text: 'Sunny', gender: 'f' },
    { id: '3909', text: 'Susan', gender: 'f' },
    { id: '3910', text: 'Susana', gender: 'f' },
    { id: '3911', text: 'Susann', gender: 'f' },
    { id: '3912', text: 'Susanna', gender: 'f' },
    { id: '3913', text: 'Susanne', gender: 'f' },
    { id: '3914', text: 'Suse', gender: 'f' },
    { id: '3915', text: 'Susi', gender: 'f' },
    { id: '3916', text: 'Susi', gender: 'f' },
    { id: '3917', text: 'Suzanne', gender: 'f' },
    { id: '3918', text: 'Svea', gender: 'f' },
    { id: '3919', text: 'Svea', gender: 'f' },
    { id: '3920', text: 'Sven', gender: 'm' },
    { id: '3921', text: 'Sven', gender: 'm' },
    { id: '3922', text: 'Sven', gender: 'm' },
    { id: '3923', text: 'Svenja', gender: 'f' },
    { id: '3924', text: 'Svenja', gender: 'f' },
    { id: '3925', text: 'Sverre', gender: 'm' },
    { id: '3926', text: 'Svetlana', gender: 'f' },
    { id: '3927', text: 'Swantje', gender: 'f' },
    { id: '3928', text: 'Swen', gender: 'm' },
    { id: '3929', text: 'Swetlana', gender: 'f' },
    { id: '3930', text: 'Sybilla', gender: 'f' },
    { id: '3931', text: 'Sybille', gender: 'f' },
    { id: '3932', text: 'Sydney', gender: 'f' },
    { id: '3933', text: 'Sydney', gender: 'm' },
    { id: '3934', text: 'Sydney Sophia', gender: 'f' },
    { id: '3935', text: 'Sydney-Kady', gender: 'f' },
    { id: '3936', text: 'Sylke', gender: 'f' },
    { id: '3937', text: 'Sylvana', gender: 'f' },
    { id: '3938', text: 'Sylvester', gender: 'm' },
    { id: '3939', text: 'Sylvia', gender: 'f' },
    { id: '3940', text: 'Sylvie', gender: 'f' },
    { id: '3941', text: 'Sylvie', gender: 'f' },
    { id: '3942', text: 'Sylvio', gender: 'm' },
    { id: '3943', text: 'Sylwia', gender: 'f' },
    { id: '3944', text: 'Tabea', gender: 'f' },
    { id: '3945', text: 'Tabea', gender: 'f' },
    { id: '3946', text: 'Tadeusz', gender: 'm' },
    { id: '3947', text: 'Tajana', gender: 'f' },
    { id: '3948', text: 'Takashi', gender: 'm' },
    { id: '3949', text: 'Talea', gender: 'f' },
    { id: '3950', text: 'Talina-Marie', gender: 'f' },
    { id: '3951', text: 'Talula', gender: 'f' },
    { id: '3952', text: 'Tamara', gender: 'f' },
    { id: '3953', text: 'Tamara', gender: 'f' },
    { id: '3954', text: 'Tami', gender: 'f' },
    { id: '3955', text: 'Tamia Destiney', gender: 'f' },
    { id: '3956', text: 'Tamika Sunshine', gender: 'f' },
    { id: '3957', text: 'Tamina', gender: 'f' },
    { id: '3958', text: 'Taminka', gender: 'm' },
    { id: '3959', text: 'Tamino', gender: 'm' },
    { id: '3960', text: 'Tamino Joel', gender: 'm' },
    { id: '3961', text: 'Tamio Alexander', gender: 'm' },
    { id: '3962', text: 'Tammo-Leonardo', gender: 'm' },
    { id: '3963', text: 'Tania', gender: 'f' },
    { id: '3964', text: 'Tanja', gender: 'f' },
    { id: '3965', text: 'Tara', gender: 'f' },
    { id: '3966', text: 'Tara Charleen', gender: 'f' },
    { id: '3967', text: 'Tara-Sophie', gender: 'f' },
    { id: '3968', text: 'Tara-Thalia', gender: 'f' },
    { id: '3969', text: 'Tassilo', gender: 'm' },
    { id: '3970', text: 'Tassilo', gender: 'm' },
    { id: '3971', text: 'Tatiana', gender: 'f' },
    { id: '3972', text: 'Tatjana', gender: 'f' },
    { id: '3973', text: 'Tatjana', gender: 'f' },
    { id: '3974', text: 'Tatjana Marie', gender: 'f' },
    { id: '3975', text: 'Taylan', gender: 'm' },
    { id: '3976', text: 'Tayler', gender: 'm' },
    { id: '3977', text: 'Tehodor', gender: 'm' },
    { id: '3978', text: 'Telse', gender: 'f' },
    { id: '3979', text: 'Teo', gender: 'm' },
    { id: '3980', text: 'Teodor', gender: 'm' },
    { id: '3981', text: 'Terence Luc', gender: 'm' },
    { id: '3982', text: 'Teresa', gender: 'f' },
    { id: '3983', text: 'Teresa', gender: 'f' },
    { id: '3984', text: 'Terje', gender: 'm' },
    { id: '3985', text: 'Tess', gender: 'f' },
    { id: '3986', text: 'Tessa', gender: 'f' },
    { id: '3987', text: 'Tessa-Mareen', gender: 'f' },
    { id: '3988', text: 'Tessa-Marie', gender: 'f' },
    { id: '3989', text: 'Tessina', gender: 'f' },
    { id: '3990', text: 'Thabea', gender: 'f' },
    { id: '3991', text: 'Thaddäus', gender: 'm' },
    { id: '3992', text: 'Thalia Davina', gender: 'f' },
    { id: '3993', text: 'Thalita', gender: 'f' },
    { id: '3994', text: 'Thea', gender: 'f' },
    { id: '3995', text: 'Thea', gender: 'f' },
    { id: '3996', text: 'Thea Lilly', gender: 'f' },
    { id: '3997', text: 'Theda', gender: 'f' },
    { id: '3998', text: 'Thekla', gender: 'f' },
    { id: '3999', text: 'Theo', gender: 'm' },
    { id: '4000', text: 'Theo', gender: 'm' },
    { id: '4001', text: 'Theo Jürgen Richard', gender: 'm' },
    { id: '4002', text: 'Theobald', gender: 'm' },
    { id: '4003', text: 'Theodor', gender: 'm' },
    { id: '4004', text: 'Theodora', gender: 'f' },
    { id: '4005', text: 'Theodoros', gender: 'm' },
    { id: '4006', text: 'Theres', gender: 'f' },
    { id: '4007', text: 'Theresa', gender: 'f' },
    { id: '4008', text: 'Theresa', gender: 'f' },
    { id: '4009', text: 'Therese', gender: 'f' },
    { id: '4010', text: 'Theresia', gender: 'f' },
    { id: '4011', text: 'Therissa', gender: 'f' },
    { id: '4012', text: 'Thessa-Thalia', gender: 'f' },
    { id: '4013', text: 'Thiago', gender: 'm' },
    { id: '4014', text: 'Thies', gender: 'm' },
    { id: '4015', text: 'Thilo', gender: 'm' },
    { id: '4016', text: 'Thilo', gender: 'm' },
    { id: '4017', text: 'Thjelle', gender: 'm' },
    { id: '4018', text: 'Thomas', gender: 'm' },
    { id: '4019', text: 'Thomas', gender: 'm' },
    { id: '4020', text: 'Thommy', gender: 'm' },
    { id: '4021', text: 'Thora', gender: 'f' },
    { id: '4022', text: 'Thoralf', gender: 'm' },
    { id: '4023', text: 'Thorben', gender: 'm' },
    { id: '4024', text: 'Thorben', gender: 'm' },
    { id: '4025', text: 'Thorin', gender: 'm' },
    { id: '4026', text: 'Thorsten', gender: 'm' },
    { id: '4027', text: 'Thysson', gender: 'm' },
    { id: '4028', text: 'Tia', gender: 'f' },
    { id: '4029', text: 'Tia-Joline', gender: 'f' },
    { id: '4030', text: 'Tiago-Noel', gender: 'm' },
    { id: '4031', text: 'Tiana', gender: 'f' },
    { id: '4032', text: 'Tiara', gender: 'f' },
    { id: '4033', text: 'Tibor', gender: 'm' },
    { id: '4034', text: 'Tiffany Josefine', gender: 'f' },
    { id: '4035', text: 'Tiger', gender: 'm' },
    { id: '4036', text: 'Tijana', gender: 'f' },
    { id: '4037', text: 'Tikvah', gender: 'f' },
    { id: '4038', text: 'Till', gender: 'm' },
    { id: '4039', text: 'Till', gender: 'm' },
    { id: '4040', text: 'Till Richard', gender: 'm' },
    { id: '4041', text: 'Tillmann', gender: 'm' },
    { id: '4042', text: 'Tilly', gender: 'f' },
    { id: '4043', text: 'Tilman', gender: 'm' },
    { id: '4044', text: 'Tilman', gender: 'm' },
    { id: '4045', text: 'Tilmann', gender: 'm' },
    { id: '4046', text: 'Tilo', gender: 'm' },
    { id: '4047', text: 'Tim', gender: 'm' },
    { id: '4048', text: 'Tim', gender: 'm' },
    { id: '4049', text: 'Tim Elias', gender: 'm' },
    { id: '4050', text: 'Tim Leon', gender: 'm' },
    { id: '4051', text: 'Tim-Joel', gender: 'm' },
    { id: '4052', text: 'Tim-Karl', gender: 'm' },
    { id: '4053', text: 'Timea', gender: 'f' },
    { id: '4054', text: 'Timm', gender: 'm' },
    { id: '4055', text: 'Timo', gender: 'm' },
    { id: '4056', text: 'Timo', gender: 'm' },
    { id: '4057', text: 'Timo Leandro', gender: 'm' },
    { id: '4058', text: 'Timo Lukas', gender: 'm' },
    { id: '4059', text: 'Timon', gender: 'm' },
    { id: '4060', text: 'Tina', gender: 'f' },
    { id: '4061', text: 'Tinn', gender: 'm' },
    { id: '4062', text: 'Tino', gender: 'm' },
    { id: '4063', text: 'Tino', gender: 'm' },
    { id: '4064', text: 'Tippi', gender: 'f' },
    { id: '4065', text: 'Tizia', gender: 'f' },
    { id: '4066', text: 'Tizian', gender: 'm' },
    { id: '4067', text: 'Tiziano', gender: 'm' },
    { id: '4068', text: 'Tjark', gender: 'm' },
    { id: '4069', text: 'Tjark Joel', gender: 'm' },
    { id: '4070', text: 'Tobias', gender: 'm' },
    { id: '4071', text: 'Tobias', gender: 'm' },
    { id: '4072', text: 'Tom', gender: 'm' },
    { id: '4073', text: 'Tom', gender: 'm' },
    { id: '4074', text: 'Tom Bastian', gender: 'm' },
    { id: '4075', text: 'Tom Silas', gender: 'm' },
    { id: '4076', text: 'Tom-Lucas', gender: 'm' },
    { id: '4077', text: 'Tomas', gender: 'm' },
    { id: '4078', text: 'Tomasz', gender: 'm' },
    { id: '4079', text: 'Tomislav', gender: 'm' },
    { id: '4080', text: 'Tomke', gender: 'f' },
    { id: '4081', text: 'Tommy', gender: 'm' },
    { id: '4082', text: 'Toni', gender: 'm' },
    { id: '4083', text: 'Toni', gender: 'm' },
    { id: '4084', text: 'Toni Leonie', gender: 'f' },
    { id: '4085', text: 'Tony', gender: 'm' },
    { id: '4086', text: 'Toralf', gender: 'm' },
    { id: '4087', text: 'Torben', gender: 'm' },
    { id: '4088', text: 'Torben', gender: 'm' },
    { id: '4089', text: 'Torben Michel', gender: 'm' },
    { id: '4090', text: 'Torsten', gender: 'm' },
    { id: '4091', text: 'Toska Carina', gender: 'f' },
    { id: '4092', text: 'Tracy-Jolina', gender: 'f' },
    { id: '4093', text: 'Traude', gender: 'f' },
    { id: '4094', text: 'Traudel', gender: 'f' },
    { id: '4095', text: 'Traudl', gender: 'f' },
    { id: '4096', text: 'Traugott', gender: 'm' },
    { id: '4097', text: 'Traute', gender: 'f' },
    { id: '4098', text: 'Trevor', gender: 'm' },
    { id: '4099', text: 'Tristan', gender: 'm' },
    { id: '4100', text: 'Trude', gender: 'f' },
    { id: '4101', text: 'Trudel', gender: 'f' },
    { id: '4102', text: 'Trudi', gender: 'f' },
    { id: '4103', text: 'Trudi', gender: 'f' },
    { id: '4104', text: 'Tülay', gender: 'f' },
    { id: '4105', text: 'Türkan', gender: 'f' },
    { id: '4106', text: 'Tyler', gender: 'm' },
    { id: '4107', text: 'Tyler Jerome', gender: 'm' },
    { id: '4108', text: 'Tyler Joel', gender: 'm' },
    { id: '4109', text: 'Tyler-Jason', gender: 'm' },
    { id: '4110', text: 'Tyler-Jerome', gender: 'm' },
    { id: '4111', text: 'Tyler-Logan', gender: 'm' },
    { id: '4112', text: 'Tylor', gender: 'm' },
    { id: '4113', text: 'Tyrone / Tyron', gender: 'm' },
    { id: '4114', text: 'Udo', gender: 'm' },
    { id: '4115', text: 'Ulf', gender: 'm' },
    { id: '4116', text: 'Uli', gender: 'm' },
    { id: '4117', text: 'Ulla', gender: 'f' },
    { id: '4118', text: 'Ullrich', gender: 'm' },
    { id: '4119', text: 'Ulrich', gender: 'm' },
    { id: '4120', text: 'Ulrike', gender: 'f' },
    { id: '4121', text: 'Undine', gender: 'f' },
    { id: '4122', text: 'Urban', gender: 'm' },
    { id: '4123', text: 'Urs', gender: 'm' },
    { id: '4124', text: 'Ursel', gender: 'f' },
    { id: '4125', text: 'Ursula', gender: 'f' },
    { id: '4126', text: 'Urszula', gender: 'f' },
    { id: '4127', text: 'Urte', gender: 'f' },
    { id: '4128', text: 'Uschi', gender: 'f' },
    { id: '4129', text: 'Uschi', gender: 'f' },
    { id: '4130', text: 'Uta', gender: 'f' },
    { id: '4131', text: 'Ute', gender: 'f' },
    { id: '4132', text: 'Utz', gender: 'm' },
    { id: '4133', text: 'Uwe', gender: 'm' },
    { id: '4134', text: 'Vadim', gender: 'm' },
    { id: '4135', text: 'Valentin', gender: 'm' },
    { id: '4136', text: 'Valentin', gender: 'm' },
    { id: '4137', text: 'Valentin', gender: 'm' },
    { id: '4138', text: 'Valentina', gender: 'f' },
    { id: '4139', text: 'Valentina', gender: 'f' },
    { id: '4140', text: 'Valentine', gender: 'f' },
    { id: '4141', text: 'Valentino', gender: 'm' },
    { id: '4142', text: 'Valeri', gender: 'f' },
    { id: '4143', text: 'Valeria', gender: 'f' },
    { id: '4144', text: 'Valeria', gender: 'f' },
    { id: '4145', text: 'Valeria', gender: 'f' },
    { id: '4146', text: 'Valerie', gender: 'f' },
    { id: '4147', text: 'Valerie', gender: 'f' },
    { id: '4148', text: 'Valerij', gender: 'm' },
    { id: '4149', text: 'Valerija', gender: 'f' },
    { id: '4150', text: 'Valery Avana', gender: 'f' },
    { id: '4151', text: 'Valeska', gender: 'f' },
    { id: '4152', text: 'Vanessa', gender: 'f' },
    { id: '4153', text: 'Vanessa', gender: 'f' },
    { id: '4154', text: 'Vassilios', gender: 'm' },
    { id: '4155', text: 'Vaun', gender: 'm' },
    { id: '4156', text: 'Veena', gender: 'f' },
    { id: '4157', text: 'Veit', gender: 'm' },
    { id: '4158', text: 'Veit', gender: 'm' },
    { id: '4159', text: 'Veli', gender: 'm' },
    { id: '4160', text: 'Vena', gender: 'f' },
    { id: '4161', text: 'Vera', gender: 'f' },
    { id: '4162', text: 'Vera', gender: 'f' },
    { id: '4163', text: 'Verena', gender: 'f' },
    { id: '4164', text: 'Verenus', gender: 'm' },
    { id: '4165', text: 'Veronica', gender: 'f' },
    { id: '4166', text: 'Veronika', gender: 'f' },
    { id: '4167', text: 'Veronika', gender: 'f' },
    { id: '4168', text: 'Veronique', gender: 'f' },
    { id: '4169', text: 'Veronique', gender: 'f' },
    { id: '4170', text: 'Vesna', gender: 'f' },
    { id: '4171', text: 'Vico-Jouel', gender: 'm' },
    { id: '4172', text: 'Victor', gender: 'm' },
    { id: '4173', text: 'Victor', gender: 'm' },
    { id: '4174', text: 'Victoria', gender: 'f' },
    { id: '4175', text: 'Victoria Marie', gender: 'f' },
    { id: '4176', text: 'Viktor', gender: 'm' },
    { id: '4177', text: 'Viktor', gender: 'm' },
    { id: '4178', text: 'Viktor Silviu', gender: 'm' },
    { id: '4179', text: 'Viktoria', gender: 'f' },
    { id: '4180', text: 'Viktoria', gender: 'f' },
    { id: '4181', text: 'Vince', gender: 'm' },
    { id: '4182', text: 'Vincent', gender: 'm' },
    { id: '4183', text: 'Vincent', gender: 'm' },
    { id: '4184', text: 'Vincent Joel', gender: 'm' },
    { id: '4185', text: 'Vincent Maurice', gender: 'm' },
    { id: '4186', text: 'Vincent Noél', gender: 'm' },
    { id: '4187', text: 'Vincent Shane', gender: 'm' },
    { id: '4188', text: 'Vincenzo', gender: 'm' },
    { id: '4189', text: 'Vinko', gender: 'm' },
    { id: '4190', text: 'Vinzenz', gender: 'm' },
    { id: '4191', text: 'Viola', gender: 'f' },
    { id: '4192', text: 'Viola', gender: 'f' },
    { id: '4193', text: 'Violana', gender: 'f' },
    { id: '4194', text: 'Violetta', gender: 'f' },
    { id: '4195', text: 'Violetta', gender: 'f' },
    { id: '4196', text: 'Violetta-Elenora', gender: 'f' },
    { id: '4197', text: 'Virginia', gender: 'f' },
    { id: '4198', text: 'Virginia', gender: 'f' },
    { id: '4199', text: 'Vitali', gender: 'm' },
    { id: '4200', text: 'Vito', gender: 'm' },
    { id: '4201', text: 'Vittorio', gender: 'm' },
    { id: '4202', text: 'Vitus', gender: 'm' },
    { id: '4203', text: 'Viviane', gender: 'f' },
    { id: '4204', text: 'Vivien', gender: 'f' },
    { id: '4205', text: 'Vivienne-Alice', gender: 'f' },
    { id: '4206', text: 'Vladimir', gender: 'm' },
    { id: '4207', text: 'Vlado', gender: 'm' },
    { id: '4208', text: 'Volker', gender: 'm' },
    { id: '4209', text: 'Volkhard', gender: 'm' },
    { id: '4210', text: 'Volkmar', gender: 'm' },
    { id: '4211', text: 'Walburga', gender: 'f' },
    { id: '4212', text: 'Waldemar', gender: 'm' },
    { id: '4213', text: 'Waldtraut', gender: 'f' },
    { id: '4214', text: 'Walentina', gender: 'f' },
    { id: '4215', text: 'Wales', gender: 'm' },
    { id: '4216', text: 'Walfried', gender: 'm' },
    { id: '4217', text: 'Walli', gender: 'f' },
    { id: '4218', text: 'Wally', gender: 'f' },
    { id: '4219', text: 'Walter', gender: 'm' },
    { id: '4220', text: 'Walther', gender: 'm' },
    { id: '4221', text: 'Waltraud', gender: 'f' },
    { id: '4222', text: 'Waltraut', gender: 'f' },
    { id: '4223', text: 'Waltrud', gender: 'f' },
    { id: '4224', text: 'Wanda', gender: 'f' },
    { id: '4225', text: 'Wassilissa', gender: 'f' },
    { id: '4226', text: 'Wellori', gender: 'f' },
    { id: '4227', text: 'Wencke', gender: 'f' },
    { id: '4228', text: 'Wendelin', gender: 'f' },
    { id: '4229', text: 'Wenke', gender: 'f' },
    { id: '4230', text: 'Wenzel', gender: 'm' },
    { id: '4231', text: 'Wera', gender: 'f' },
    { id: '4232', text: 'Werner', gender: 'm' },
    { id: '4233', text: 'Wes Franjo', gender: 'm' },
    { id: '4234', text: 'Wibke', gender: 'f' },
    { id: '4235', text: 'Wiebke', gender: 'f' },
    { id: '4236', text: 'Wieland', gender: 'm' },
    { id: '4237', text: 'Wieslaw', gender: 'm' },
    { id: '4238', text: 'Wigbert', gender: 'm' },
    { id: '4239', text: 'Wilfried', gender: 'm' },
    { id: '4240', text: 'Wilfriede', gender: 'f' },
    { id: '4241', text: 'Wilhelm', gender: 'm' },
    { id: '4242', text: 'Wilhelmine', gender: 'f' },
    { id: '4243', text: 'Willfried', gender: 'm' },
    { id: '4244', text: 'Willi', gender: 'm' },
    { id: '4245', text: 'William', gender: 'm' },
    { id: '4246', text: 'William', gender: 'm' },
    { id: '4247', text: 'Willibald', gender: 'm' },
    { id: '4248', text: 'Willibert', gender: 'm' },
    { id: '4249', text: 'Willy', gender: 'm' },
    { id: '4250', text: 'Wilma', gender: 'f' },
    { id: '4251', text: 'Wiltrud', gender: 'f' },
    { id: '4252', text: 'Winfried', gender: 'm' },
    { id: '4253', text: 'Wissam', gender: 'm' },
    { id: '4254', text: 'Wissama', gender: 'f' },
    { id: '4255', text: 'Witold', gender: 'm' },
    { id: '4256', text: 'Wlad', gender: 'm' },
    { id: '4257', text: 'Wladimir', gender: 'm' },
    { id: '4258', text: 'Wojciech', gender: 'm' },
    { id: '4259', text: 'Woldemar', gender: 'm' },
    { id: '4260', text: 'Wolf', gender: 'm' },
    { id: '4261', text: 'Wolf-Dieter', gender: 'm' },
    { id: '4262', text: 'Wolf-Dietrich', gender: 'm' },
    { id: '4263', text: 'Wolf-Rüdiger', gender: 'm' },
    { id: '4264', text: 'Wolfgang', gender: 'm' },
    { id: '4265', text: 'Wolfhard', gender: 'm' },
    { id: '4266', text: 'Wolfram', gender: 'm' },
    { id: '4267', text: 'Wolke', gender: 'f' },
    { id: '4268', text: 'Wulf', gender: 'm' },
    { id: '4269', text: 'Wynona', gender: 'f' },
    { id: '4270', text: 'Xaver', gender: 'm' },
    { id: '4271', text: 'Xenia', gender: 'f' },
    { id: '4272', text: 'Xenia', gender: 'f' },
    { id: '4273', text: 'Xenja', gender: 'f' },
    { id: '4274', text: 'Yael', gender: 'f' },
    { id: '4275', text: 'Yanic / Janick / Yannick', gender: 'm' },
    { id: '4276', text: 'Yannik', gender: 'm' },
    { id: '4277', text: 'Yannique Fabrice', gender: 'm' },
    { id: '4278', text: 'Yara', gender: 'f' },
    { id: '4279', text: 'Yasemin', gender: 'f' },
    { id: '4280', text: 'Yasmin', gender: 'f' },
    { id: '4281', text: 'Yesko', gender: 'm' },
    { id: '4282', text: 'Yilmaz', gender: 'm' },
    { id: '4283', text: 'Ylenia', gender: 'f' },
    { id: '4284', text: 'Ylvie', gender: 'f' },
    { id: '4285', text: 'Yoan', gender: 'm' },
    { id: '4286', text: 'Younes', gender: 'm' },
    { id: '4287', text: 'Yuki', gender: 'f' },
    { id: '4288', text: 'Yuma', gender: 'm' },
    { id: '4289', text: 'Yusuf', gender: 'm' },
    { id: '4290', text: 'Yves', gender: 'm' },
    { id: '4291', text: 'Yvette', gender: 'f' },
    { id: '4292', text: 'Yvonne', gender: 'f' },
    { id: '4293', text: 'Zac', gender: 'm' },
    { id: '4294', text: 'Zaid', gender: 'm' },
    { id: '4295', text: 'Zarah', gender: 'f' },
    { id: '4296', text: 'Zarminah', gender: 'f' },
    { id: '4297', text: 'Zbigniew', gender: 'm' },
    { id: '4298', text: 'Zdenka', gender: 'f' },
    { id: '4299', text: 'Zdravko', gender: 'm' },
    { id: '4300', text: 'Zehra', gender: 'f' },
    { id: '4301', text: 'Zeki', gender: 'm' },
    { id: '4302', text: 'Zeljko', gender: 'm' },
    { id: '4303', text: 'Zena', gender: 'f' },
    { id: '4304', text: 'Zenon', gender: 'm' },
    { id: '4305', text: 'Zenta', gender: 'f' },
    { id: '4306', text: 'Zeynep', gender: 'f' },
    { id: '4307', text: 'Zita', gender: 'f' },
    { id: '4308', text: 'Zlatko', gender: 'm' },
    { id: '4309', text: 'Zoé / Zoe', gender: 'f' },
    { id: '4310', text: 'Zoe Anicia', gender: 'f' },
    { id: '4311', text: 'Zoe Aur élie', gender: 'f' },
    { id: '4312', text: 'Zoe Celine', gender: 'f' },
    { id: '4313', text: 'Zoey', gender: 'f' },
    { id: '4314', text: 'Zoey Cheyenne', gender: 'f' },
    { id: '4315', text: 'Zoey-Cahrleen', gender: 'f' },
    { id: '4316', text: 'Zofia', gender: 'f' },
    { id: '4317', text: 'Zoltan', gender: 'm' },
    { id: '4318', text: 'Zoran', gender: 'm' }
  ];

  return {
    firstnames: firstnames,
    getGender: getGender
  };

  /**
   *
   * @param name:string
   * @param strict:boolean
   * @returns {{valid: boolean, gender:string }}
   */
  function getGender(name) {
    var result = [],
      isValid = false,
      gender;

    if (name) {
      result = firstnames.filter(function(obj) {
        return obj.text === name.toString();
      });

      if (result.length >= 1) {
        isValid = true;
        gender = result.pop().gender;
      }
    }

    return { valid: isValid, gender: gender };
  }
}

angular.module('service.commonNames', []).service('CommonNames', CommonNames);

'use strict';

(function() {
  ////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.creditCardModalController', ['raisenow.payment'])
    .controller(
      'RaiseNowCreditCardModalController',
      RaiseNowCreditCardModalController
    );

  ////////////////////////////////////////////////////////////////////////////

  RaiseNowCreditCardModalController.$inject = [
    '$scope',
    '$sce',
    '$stateParams',
    'RaiseNowPayment',
    'RaiseNowIframe',
    'RaiseNowSettings'
  ];

  ////////////////////////////////////////////////////////////////////////////

  function RaiseNowCreditCardModalController(
    $scope,
    $sce,
    $stateParams,
    RaiseNowPayment,
    RaiseNowIframe,
    RaiseNowSettings
  ) {
    var currentPayment = RaiseNowPayment.getCurrentPayment();
    var paymentMethod = currentPayment.getPaymentMethod();
    var iFrameUrl = $sce.trustAsResourceUrl(
      RaiseNowSettings.getPaymentUrl(
        currentPayment.getMerchantIdentifier(),
        currentPayment.getPaymentMethod(),
        currentPayment.getPaymentObject().use_stripe,
        $stateParams.lang
      )
    );
    var iFrameWindow = angular.element($('#raisenow-payment-iframe'));

    var self = {
      currentPayment: currentPayment,
      paymentStatus: 'new',
      iFrameUrl: iFrameUrl,
      startPaymentFlow: startPaymentFlow,
      cancelPayment: cancelPayment,
      finishPayment: finishPayment,
      paymentDoneOfflineConfirm: paymentDoneOfflineConfirm,
      showStartPaymentFlowButton: showStartPaymentFlowButton,
      showWaitButton: showWaitButton,
      showDoneButton: showDoneButton,
      showRetryButton: showRetryButton,
      showCancelButton: showCancelButton
    };

    (function init() {
      if (!currentPayment) {
        console.error('[raisenow] there is no payment in progress');
      }

      $scope.$on('modal.closing', function(event, reason) {
        if (reason !== 'force') {
          event.preventDefault();
        }
      });

      setupRaiseNowCommunication();
      subscribeToEvents();
    })();

    return self;

    function subscribeToEvents() {
      currentPayment.subNoNetworkConnection(function() {
        self.paymentStatus = 'offline';
        self.iframeStyle = {};
      });

      currentPayment.subBeforeInitiation(function() {
        self.paymentStatus = 'initiating';
        self.iframeStyle = { display: 'none' };
      });

      currentPayment.subAfterInitiation(function() {
        self.paymentStatus = 'initiated';
      });

      currentPayment.subBeforeConfirmation(function() {
        self.paymentStatus = 'confirming';
      });

      currentPayment.subAfterConfirmation(function() {
        self.paymentStatus = 'confirmed';
      });

      currentPayment.subError(function(args) {
        self.paymentStatus = 'error';
        self.iframeStyle = {};
        self.errorMessage = args.error;
      });
    }

    function startPaymentFlow() {
      sendRaiseNowMessage('validate-form');
      self.paymentStatus = 'initiated';
    }

    function cancelPayment() {
      currentPayment.cancel();
    }

    function finishPayment() {
      currentPayment.finish();
    }

    function paymentDoneOfflineConfirm() {
      currentPayment.finish();
    }

    function setupRaiseNowCommunication() {
      window.addEventListener('message', handleRaiseNowMessage);
    }

    function handleRaiseNowMessage(event) {
      if (!event.data || typeof event.data != 'string') {
        return;
      }

      try {
        var eventData = JSON.parse(event.data);
        var topic = eventData.topic || null;
        var data = eventData.data || {};

        if (topic == null) {
          return;
        }

        switch (topic) {
          case 'rnw-creditcardform.token-received':
            currentPayment.setCreditCardPaymentData(
              data.paymentMethod,
              data.token
            );

            self.iFrameUrl = './iframe.view.html';

            // TODO: Make it better
            setTimeout(function() {
              currentPayment.initiate();
            }, 1000);

            break;
          case 'rnw-creditcardform.form-not-valid':
          case 'rnw-creditcardform.create-token-error':
            self.paymentStatus = 'error';

            break;
          case 'rnw-creditcardform.form-valid':
            sendRaiseNowMessage('create-token');
            break;
        }

        $scope.apply();
      } catch (e) {
        return;
      }
    }

    function sendRaiseNowMessage(event) {
      iFrameWindow = document.getElementById('raisenow-creditcard-iframe')
        .contentWindow;
      var eventData = JSON.stringify({
        topic: 'rnw-creditcardform.' + event,
        data: { apiKey: currentPayment.getMerchantIdentifier() }
      });
      iFrameWindow.postMessage(eventData, '*');
    }

    function showStartPaymentFlowButton() {
      return self.paymentStatus === 'new';
    }

    function showWaitButton() {
      return ['initiating', 'initiated', 'confirming'].includes(
        self.paymentStatus
      );
    }

    function showDoneButton() {
      return self.paymentStatus === 'confirmed';
    }

    function showRetryButton() {
      return self.paymentStatus === 'error';
    }

    function showCancelButton() {
      return self.paymentStatus !== 'confirmed';
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  angular
    .module('raisenow.mposModalController', ['raisenow.payment'])
    .controller('RaiseNowMposModalController', RaiseNowMposModalController);

  RaiseNowMposModalController.$inject = [
    '$scope',
    'RaiseNowPayment',
    'RaiseNowSettings',
    'FundraisersResource'
  ];

  function RaiseNowMposModalController(
    $scope,
    RaiseNowPayment,
    RaiseNowSettings
  ) {
    var currentPayment = RaiseNowPayment.getCurrentPayment();
    var paymentMethod = currentPayment.getPaymentMethod();

    var self = {
      currentPayment: currentPayment,
      paymentStatus: 'new',
      initiatePayment: initiatePayment,
      cancelPayment: cancelPayment,
      finishPayment: finishPayment,
      paymentDoneOfflineConfirm: paymentDoneOfflineConfirm,
      showWaitButton: showWaitButton,
      showRedirectToMposButton: showRedirectToMposButton,
      showDoneButton: showDoneButton,
      showRetryButton: showRetryButton,
      showCancelButton: showCancelButton
    };

    (function init() {
      if (!currentPayment) {
        console.error('[raisenow] there is no payment in progress');
      }

      $scope.$on('modal.closing', function(event, reason) {
        if (reason !== 'force') {
          event.preventDefault();
        }
      });

      subscribeToEvents();
      currentPayment.initiate();
    })();

    return self;

    function subscribeToEvents() {
      currentPayment.subNoNetworkConnection(function() {
        self.paymentStatus = 'offline';
      });

      currentPayment.subBeforeInitiation(function() {
        self.paymentStatus = 'initiating';
      });

      currentPayment.subAfterInitiation(function() {
        self.paymentStatus = 'initiated';
      });

      currentPayment.subBeforeRedirectToMpos(function() {
        self.paymentStatus = 'redirectToMpos';
      });

      currentPayment.subAfterRedirectToMpos(function() {
        self.paymentStatus = 'finishedMpos';
      });

      currentPayment.subBeforeConfirmation(function() {
        self.paymentStatus = 'confirming';
      });

      currentPayment.subAfterConfirmation(function() {
        self.paymentStatus = 'confirmed';
      });

      currentPayment.subError(function(args) {
        self.paymentStatus = 'error';
        self.errorMessage = args.error;
      });
    }

    function initiatePayment() {
      currentPayment.initiate();
    }

    function cancelPayment() {
      currentPayment.cancel();
    }

    function finishPayment() {
      currentPayment.finish();
    }

    function paymentDoneOfflineConfirm() {
      currentPayment.finish();
    }

    function showWaitButton() {
      return ['initiating', 'initiated', 'confirming'].includes(
        self.paymentStatus
      );
    }

    function showRedirectToMposButton() {
      return ['initiated', 'confirming', 'redirectToMpos'].includes(
        self.paymentStatus
      );
    }

    function showDoneButton() {
      return self.paymentStatus === 'confirmed';
    }

    function showRetryButton() {
      return self.paymentStatus === 'error';
    }

    function showCancelButton() {
      return [
        'initiating',
        'initiated',
        'redirectToMpos',
        'error',
        'offline'
      ].includes(self.paymentStatus);
    }
  }
})();

'use strict';

(function() {
  ////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.smsModalController', ['raisenow.payment'])
    .controller('RaiseNowSMSModalController', RaiseNowSMSModalController);

  ////////////////////////////////////////////////////////////////////////////

  RaiseNowSMSModalController.$inject = [
    '$scope',
    'RaiseNowPayment',
    'FundraisersResource'
  ];

  ////////////////////////////////////////////////////////////////////////////

  function RaiseNowSMSModalController($scope, RaiseNowPayment) {
    var currentPayment = RaiseNowPayment.getCurrentPayment();
    var paymentMethod = currentPayment.getPaymentMethod();

    var self = {
      currentPayment: currentPayment,
      paymentStatus: 'new',
      initiatePayment: initiatePayment,
      cancelPayment: cancelPayment,
      finishPayment: finishPayment,
      paymentDoneOfflineConfirm: paymentDoneOfflineConfirm,
      showInitButton: showInitButton,
      showDoneButton: showDoneButton,
      showRetryButton: showRetryButton,
      showCancelButton: showCancelButton,
      showOfflineDonationButton: showOfflineDonationButton
    };

    (function init() {
      if (!currentPayment) {
        console.error('[raisenow] there is no payment in progress');
      }

      $scope.$on('modal.closing', function(event, reason) {
        if (reason !== 'force') {
          event.preventDefault();
        }
      });

      subscribeToEvents();
    })();

    return self;

    function subscribeToEvents() {
      currentPayment.subNoNetworkConnection(function() {
        self.paymentStatus = 'offline';
      });

      currentPayment.subBeforeInitiation(function() {
        self.paymentStatus = 'initiating';
      });

      currentPayment.subAfterInitiation(function() {
        self.paymentStatus = 'initiated';
      });

      currentPayment.subBeforeConfirmation(function() {
        self.paymentStatus = 'confirming';
      });

      currentPayment.subAfterConfirmation(function() {
        self.paymentStatus = 'confirmed';
        currentPayment.finish();
      });

      currentPayment.subError(function(args) {
        self.paymentStatus = 'error';
        self.errorMessage = args.error;
      });
    }

    function initiatePayment() {
      currentPayment.initiate();
    }

    function cancelPayment() {
      currentPayment.cancel();
    }

    function finishPayment() {
      currentPayment.finish();
    }

    function paymentDoneOfflineConfirm() {
      currentPayment.finish();
    }

    function showInitButton() {
      return self.paymentStatus === 'new';
    }

    function showDoneButton() {
      return self.paymentStatus === 'confirmed';
    }

    function showRetryButton() {
      return self.paymentStatus === 'error';
    }

    function showCancelButton() {
      return self.paymentStatus !== 'confirmed';
    }

    function showOfflineDonationButton() {
      return self.paymentStatus === 'offline';
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.errorist', [])
    .service('RaiseNowErrorist', RaiseNowErrorist);

  //////////////////////////////////////////////////////////////////////////////

  // its like a terrorist, but for errors
  function RaiseNowErrorist() {
    var currentErrorLevel = 0;
    var maxErrorLevel = 100;
    var errorSeverities = {
      INVALID_PAYMENT_METHOD: 100,
      NOT_CONFIRMED: 1,
      INVALID_PAYMENT_STATUS: 100,
      OFFLINE: 40,
      UNKNOWN_ERROR: 50,
      PAYMENT_IFRAME_ERROR: 100
    };

    return {
      errors: errorSeverities,
      error: error,
      reset: reset,
      isOk: isOk
    };

    function error(errorSeverity) {
      console.error(
        '[raisenow] received an error with severity of ":severity"'.replace(
          ':severity',
          errorSeverity
        )
      );

      currentErrorLevel += errorSeverity;

      return isOk();
    }

    function reset() {
      currentErrorLevel = 0;
    }

    function isOk() {
      return currentErrorLevel < maxErrorLevel;
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.iframe', ['raisenow.settings', 'raisenow.urlParser'])
    .service('RaiseNowIframe', RaiseNowIframe);

  //////////////////////////////////////////////////////////////////////////////

  RaiseNowIframe.$inject = [
    'RaiseNowSettings',
    'UrlParser',
    'BaseChannel',
    '$timeout'
  ];

  //////////////////////////////////////////////////////////////////////////////

  function RaiseNowIframe(RaiseNowSettings, UrlParser, BaseChannel, $timeout) {
    var paymentIframe;
    var currentPayment;
    var paymentTimeout = null;

    var events = {
      paymentIframeLoaded: 'event:paymentIframeLoaded',
      paymentIframeInitiated: 'event:paymentIframeInitiated'
    };

    (function init() {
      subPaymentIframeLoaded(onPaymentIframeLoaded);
    })();

    return {
      submit: submit,
      subPaymentIframeLoaded: subPaymentIframeLoaded,
      pubPaymentIframeLoaded: pubPaymentIframeLoaded,
      subPaymentIframeInitiated: subPaymentIframeInitiated,
      pubPaymentIframeInitiated: pubPaymentIframeInitiated
    };

    function subPaymentIframeLoaded(scope, callback) {
      return BaseChannel.subRootEmit(
        events.paymentIframeLoaded,
        scope,
        callback
      );
    }

    function pubPaymentIframeLoaded(args) {
      BaseChannel.pubRootEmit(events.paymentIframeLoaded, args);
    }

    function subPaymentIframeInitiated(scope, callback) {
      return BaseChannel.subRootEmit(
        events.paymentIframeInitiated,
        scope,
        callback
      );
    }

    function pubPaymentIframeInitiated(args) {
      BaseChannel.pubRootEmit(events.paymentIframeInitiated, args);
    }

    function onPaymentIframeLoaded(data) {
      paymentIframe = data.window;

      if (!currentPayment) {
        return;
      }

      $timeout.cancel(paymentTimeout);

      var query = UrlParser.parseQuery(data.window.location.href);

      if (query.error_detail) {
        // todo: error tick hard error or offline

        if (currentPayment) {
          currentPayment.pubError({
            error: query.error_detail,
            query: query
          });
        }
      } else if (query.epp_transaction_id) {
        if (currentPayment) {
          currentPayment.pubAfterInitiation({
            epp_transaction_id: query.epp_transaction_id,
            query: query
          });
        }
      } else {
        currentPayment.pubError({
          error: 'Unknown error'
        });
      }

      currentPayment = null;
    }

    function fill(payment) {
      var paymentObject = payment.getPaymentObject();
      if (!paymentIframe) {
        console.error('[raisenow] payment iframe has not been loaded yet');
        return;
      }

      var paymentUrl = RaiseNowSettings.getPaymentUrl(
        paymentObject.merchant_identifier,
        paymentObject.payment_method,
        paymentObject.use_stripe
      );

      angular
        .element(paymentIframe.document.body)
        .find('form')
        .remove();

      var $form = angular.element('<form>').attr({
        method: 'post',
        action: paymentUrl
      });

      if (payment.isMposPaymentMethod()) {
        var submitFields = payment.getMposPaymentData();
      } else {
        var submitFields = paymentObject;
      }
      angular.forEach(submitFields, function(value, key) {
        var $input = angular.element('<input>').attr({
          type: 'text',
          name: key,
          value: value
        });
        $form.append($input);
      });

      angular.element(paymentIframe.document.body).append($form);
    }

    function submit(payment) {
      if (currentPayment) {
        return;
      }

      currentPayment = payment;
      // paymentTimeout = $timeout(function() {
      //   currentPayment.pubError({
      //     error: 'Payment is timed out'
      //   });
      // }, 30000);

      fill(payment);

      angular
        .element(paymentIframe.document.body)
        .find('form')[0]
        .submit();
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.modal', ['ui.bootstrap'])
    .service('RaiseNowModal', RaiseNowModal);

  //////////////////////////////////////////////////////////////////////////////

  RaiseNowModal.$inject = ['$uibModal'];

  //////////////////////////////////////////////////////////////////////////////

  function RaiseNowModal($uibModal) {
    var modal;
    var currentPayment;
    var controller;
    var modalTemplate;

    return {
      open: open,
      close: close,
      isOpen: isOpen
    };

    function open(payment) {
      if (isOpen()) {
        console.error('[raisenow] payment modal is already open');
        return;
      }

      currentPayment = payment;

      if (currentPayment.isSMSPaymentMethod()) {
        controller = 'RaiseNowSMSModalController';
        modalTemplate = 'raisenow.sms.modal.html';
      } else if (currentPayment.isCreditCardPaymentMethod()) {
        controller = 'RaiseNowCreditCardModalController';
        modalTemplate = 'raisenow.creditcard.modal.html';
      } else if (currentPayment.isMposPaymentMethod()) {
        controller = 'RaiseNowMposModalController';
        modalTemplate = 'raisenow.mpos.modal.html';
      }

      currentPayment.pubBeforeModal();

      modal = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/services/raisenow/views/' + modalTemplate,
        controller: controller + ' as modal',
        size: 6,
        backdrop: 'static',
        keyboard: false
      });

      modal.result.finally(function() {
        modal = null;
        currentPayment = null;
      });
    }

    function isOpen() {
      return !!modal;
    }

    function close() {
      if (isOpen()) {
        modal.close('force');

        if (currentPayment) {
          currentPayment.pubAfterModal();
        }
      }
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.payment', [
      'raisenow.service',
      'raisenow.modal',
      'raisenow.paymentObjectAdapter'
    ])
    .service('RaiseNowPayment', RaiseNowPayment);

  //////////////////////////////////////////////////////////////////////////////

  RaiseNowPayment.$inject = [
    'RaiseNowService',
    'RaiseNowModal',
    'RaiseNowPaymentObjectAdapter'
  ];

  //////////////////////////////////////////////////////////////////////////////

  function RaiseNowPayment(
    RaiseNowService,
    RaiseNowModal,
    RaiseNowPaymentObjectAdapter
  ) {
    var paymentStatuses = {
      ACTIVE: 1,
      INACTIVE: 2
    };
    var currentPayment = null;

    return {
      create: create,
      getCurrentPayment: getCurrentPayment
    };

    function create(donutFormData) {
      var paymentObject = RaiseNowPaymentObjectAdapter.createPaymentObject(
        donutFormData
      );
      currentPayment = new Payment(paymentObject);

      return currentPayment;
    }

    function getCurrentPayment() {
      return currentPayment;
    }

    function Payment(paymentObject) {
      var status = paymentStatuses.INACTIVE;
      var eventHandlers = [];
      var self = {
        start: start,
        initiate: initiate,
        redirectToMpos: redirectToMpos,
        finish: finish,
        cancel: cancel,
        isActive: isActive,
        getPaymentObject: getPaymentObject,
        getPaymentMethod: getPaymentMethod,
        getMerchantIdentifier: getMerchantIdentifier,
        isCreditCardPaymentMethod: isCreditCardPaymentMethod,
        isMposPaymentMethod: isMposPaymentMethod,
        isSMSPaymentMethod: isSMSPaymentMethod,
        getMposPaymentData: getMposPaymentData,
        setCreditCardPaymentData: setCreditCardPaymentData,

        // called before modal opens
        subBeforeModal: subBeforeModal,
        pubBeforeModal: pubBeforeModal,
        // called after modal closes
        subAfterModal: subAfterModal,
        pubAfterModal: pubAfterModal,
        // called when payment data has been built
        subDataReady: subDataReady,
        pubDataReady: pubDataReady,
        // called before payment has been initiated
        subBeforeInitiation: subBeforeInitiation,
        pubBeforeInitiation: pubBeforeInitiation,
        // called after payment has been initiated
        subAfterInitiation: subAfterInitiation,
        pubAfterInitiation: pubAfterInitiation,
        // called before we redirect to the RaiseNow app for the mPOS device
        subBeforeRedirectToMpos: subBeforeRedirectToMpos,
        pubBeforeRedirectToMpos: pubBeforeRedirectToMpos,
        // called before we redirect to the RaiseNow app for the mPOS device
        subAfterRedirectToMpos: subAfterRedirectToMpos,
        pubAfterRedirectToMpos: pubAfterRedirectToMpos,
        // called before payment confirmation
        subBeforeConfirmation: subBeforeConfirmation,
        pubBeforeConfirmation: pubBeforeConfirmation,
        // called multiple times during payment confirmation
        subDuringConfirmation: subDuringConfirmation,
        pubDuringConfirmation: pubDuringConfirmation,
        // called after payment payment confirmation
        subAfterConfirmation: subAfterConfirmation,
        pubAfterConfirmation: pubAfterConfirmation,
        // called on payment status poll
        subStatusPoll: subStatusPoll,
        pubStatusPoll: pubStatusPoll,
        // called after payment has been initiated and confirmed
        subSuccess: subSuccess,
        pubSuccess: pubSuccess,
        // called whenever an error occurs
        subError: subError,
        pubError: pubError,
        // called after a payment has been initiated, confirmed and modal has been closed
        subFinished: subFinished,
        pubFinished: pubFinished,
        // called after modal has been closed due to a payment cancellation
        subCancelled: subCancelled,
        pubCancelled: pubCancelled,
        // called if device is offline and payment can not be executed
        subNoNetworkConnection: subNoNetworkConnection,
        pubNoNetworkConnection: pubNoNetworkConnection
      };

      return self;

      function start() {
        status = paymentStatuses.ACTIVE;
        RaiseNowModal.open(self);
      }

      function initiate() {
        self.pubDataReady({
          paymentObject: getPaymentObject()
        });

        RaiseNowService.initiatePayment(self);
      }

      function redirectToMpos() {
        RaiseNowService.redirectToMpos(self.eppTransactionId);
      }

      function finish() {
        status = paymentStatuses.INACTIVE;
        RaiseNowModal.close();
        self.pubFinished();
      }

      function cancel() {
        status = paymentStatuses.INACTIVE;
        RaiseNowModal.close();
        self.pubCancelled();
      }

      function isActive() {
        return status === paymentStatuses.ACTIVE;
      }

      // XXX this is called with credit card payments.
      function getPaymentObject() {
        return paymentObject;
      }

      function getPaymentMethod() {
        return paymentObject.payment_method;
      }

      function getMerchantIdentifier() {
        return paymentObject.merchant_identifier;
      }

      function setCreditCardPaymentData(paymentMethod, cardToken) {
        paymentObject.payment_method = paymentMethod;
        paymentObject.card_token = cardToken;
        // hardcoded to satisfy RaiseNow
        paymentObject.reqtype = 'CAA';
      }

      function isCreditCardPaymentMethod() {
        return (
          paymentObject.payment_method === 'cc_raisenow' ||
          paymentObject.card_token !== undefined
        );
      }

      // XXX this is called with MPOS payments.
      function getMposPaymentData() {
        var mposData = {};
        mposData.amount = paymentObject.amount;
        mposData.currency = paymentObject.currency.toLowerCase();
        mposData.payment_method = 'mpos';
        mposData.success_url = paymentObject.success_url;
        mposData.error_url = paymentObject.error_url;
        mposData.cancel_url = paymentObject.cancel_url;
        mposData.test_mode = paymentObject.test_mode;
        mposData.mobile_mode = false;
        mposData.payer_line1 = paymentObject.card_holder_name;
        mposData.payer_line2 =
          paymentObject.stored_street + ' ' + paymentObject.stored_house_number;
        mposData.payer_line3 = paymentObject.stored_zip_code;
        mposData.language = paymentObject.language; // TODO: see if this needs to come from the form

        // Set data for MPOS new
        if (paymentObject.payment_method === 'cc_mpos_new') {
          mposData.stored_customer_email = paymentObject.stored_customer_email;
        }

        // Set recurring information
        if (paymentObject.recurring) {
          if (paymentObject.payment_method === 'cc_mpos_new') {
            mposData.recurring = true;
            mposData.recurring_interval = 'monthly';
          }
        }

        return mposData;
      }

      function isMposPaymentMethod() {
        return (
          paymentObject.payment_method === 'cc_mpos' ||
          paymentObject.payment_method === 'cc_mpos_new'
        );
      }

      function isSMSPaymentMethod() {
        return (
          paymentObject.payment_method === 'cym' ||
          paymentObject.payment_method === 'sms'
        );
      }

      // -------------------
      // The Payment Events
      // -------------------

      // modal
      function subBeforeModal(eventHandler) {
        return sub('beforeModal', eventHandler);
      }

      function pubBeforeModal(args) {
        return pub('beforeModal', args);
      }

      function subAfterModal(eventHandler) {
        return sub('afterModal', eventHandler);
      }

      function pubAfterModal(args) {
        return pub('afterModal', args);
      }
      // --

      // dataReady
      function subDataReady(eventHandler) {
        return sub('dataReady', eventHandler);
      }

      function pubDataReady(args) {
        return pub('dataReady', args);
      }
      // --

      // initiation
      function subBeforeInitiation(eventHandler) {
        return sub('beforeInitiation', eventHandler);
      }

      function pubBeforeInitiation(args) {
        return pub('beforeInitiation', args);
      }

      function subAfterInitiation(eventHandler) {
        return sub('afterInitiation', eventHandler);
      }

      function pubAfterInitiation(args) {
        return pub('afterInitiation', args);
      }
      // --

      // redirectToMpos
      function pubBeforeRedirectToMpos(args) {
        return pub('beforeRedirectToMpos', args);
      }

      function subBeforeRedirectToMpos(eventHandler) {
        return sub('beforeRedirectToMpos', eventHandler);
      }

      function pubAfterRedirectToMpos(args) {
        return pub('afterRedirectToMpos', args);
      }

      function subAfterRedirectToMpos(eventHandler) {
        return sub('afterRedirectToMpos', eventHandler);
      }
      // --

      // confirmation
      function subBeforeConfirmation(eventHandler) {
        return sub('beforeConfirmation', eventHandler);
      }

      function pubBeforeConfirmation(args) {
        return pub('beforeConfirmation', args);
      }

      function subDuringConfirmation(eventHandler) {
        return sub('duringConfirmation', eventHandler);
      }

      function pubDuringConfirmation(args) {
        return pub('duringConfirmation', args);
      }

      function subAfterConfirmation(eventHandler) {
        return sub('afterConfirmation', eventHandler);
      }

      function pubAfterConfirmation(args) {
        return pub('afterConfirmation', args);
      }
      // --

      // statusPoll
      function subStatusPoll(eventHandler) {
        return sub('statusPoll', eventHandler);
      }

      function pubStatusPoll(args) {
        return pub('statusPoll', args);
      }
      // --

      // success
      function subSuccess(eventHandler) {
        return sub('success', eventHandler);
      }

      function pubSuccess(args) {
        return pub('success', args);
      }
      // --

      // error
      function subError(eventHandler) {
        return sub('error', eventHandler);
      }

      function pubError(args) {
        return pub('error', args);
      }
      // --

      // finished
      function subFinished(eventHandler) {
        return sub('finished', eventHandler);
      }

      function pubFinished(args) {
        return pub('finished', args);
      }
      // --

      // cancelled
      function subCancelled(eventHandler) {
        return sub('cancelled', eventHandler);
      }

      function pubCancelled(args) {
        return pub('cancelled', args);
      }
      // --

      // pubNoNetworkConnection
      function subNoNetworkConnection(eventHandler) {
        return sub('offline', eventHandler);
      }

      function pubNoNetworkConnection(args) {
        return pub('offline', args);
      }
      // --

      function sub(eventName, eventHandler) {
        if (!eventHandlers[eventName]) {
          eventHandlers[eventName] = [];
        }

        eventHandlers[eventName].push(eventHandler);

        return self;
      }

      function pub(eventName, args) {
        var args = args || {};
        args.payment = self;

        var handlers = eventHandlers[eventName];

        if (handlers) {
          for (var index in handlers) {
            handlers[index](args);
          }
        }

        return self;
      }
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.paymentObjectAdapter', ['raisenow.settings'])
    .service('RaiseNowPaymentObjectAdapter', RaiseNowPaymentObjectAdapter);

  //////////////////////////////////////////////////////////////////////////////

  RaiseNowPaymentObjectAdapter.$inject = [
    'RaiseNowSettings',
    'AuthenticationService'
  ];

  //////////////////////////////////////////////////////////////////////////////

  function RaiseNowPaymentObjectAdapter(
    RaiseNowSettings,
    AuthenticationService
  ) {
    return {
      createPaymentObject: createPaymentObject
    };

    function createPaymentObject(donutFormData) {
      var paymentObject = {
        error_url: RaiseNowSettings.errorUrl,
        success_url: RaiseNowSettings.successUrl,
        cancel_url: RaiseNowSettings.cancelUrl,
        test_mode: RaiseNowSettings.testMode
      };
      var userData = AuthenticationService.getCurrentUser();

      // if the value is not set on the backend default to the old behaviour
      if (!('raisenow_use_salesforce' in donutFormData)) {
        donutFormData.raisenow_use_salesforce = false;
      }

      if ('language' in donutFormData) {
        paymentObject.language = donutFormData.language;
      }

      if ('currency' in donutFormData) {
        paymentObject.currency = donutFormData.currency;
      }

      if ('raisenow_payment_method' in donutFormData) {
        paymentObject.payment_method = donutFormData.raisenow_payment_method;

        switch (donutFormData.direct_debit_interval) {
          case '0':
            paymentObject.recurring = true;
            paymentObject.recurring_interval = 'monthly';
            break;
          case '1':
            paymentObject.recurring = true;
            paymentObject.recurring_interval = 'quarterly';
            break;
          case '2':
            paymentObject.recurring = true;
            paymentObject.recurring_interval = 'semestral';
            break;
          case '3':
            paymentObject.recurring = true;
            paymentObject.recurring_interval = 'yearly';
            break;
          default:
            paymentObject.recurring = false;
            paymentObject.recurring_interval = null;
            break;
        }

        if (paymentObject.payment_method == 'cc_raisenow') {
          paymentObject.stored_sxt_first_charge_date =
            donutFormData.contract_start_date;
          // a unique ID since we don't know the EPP transaction ID yet
          var userId = userData.id;
          paymentObject.stored_sxt_base_record_number =
            userId + '_donation__' + Date.now();
        }

        if (
          (paymentObject.payment_method === 'cc_raisenow' ||
            paymentObject.payment_method === 'cc_mpos' ||
            paymentObject.payment_method === 'cc_mpos_new') &&
          paymentObject.recurring
        ) {
          paymentObject.immediate_execution = false;
          var reference_date = donutFormData.contract_start_date;
          var day = new Date(reference_date).getDate();
          var month = new Date(reference_date).getMonth() + 1;
          switch (paymentObject.recurring_interval) {
            case 'monthly':
              paymentObject.recurring_interval = day + ' * *';
              break;
            case 'quarterly':
              var payments = [month, month + 3, month + 6, month + 9];
              for (var i in payments) {
                if (payments[i] > 12) payments[i] = payments[i] - 12;
              }
              paymentObject.recurring_interval =
                day + ' ' + payments.join(',') + ' *';
              break;
            case 'semestral':
              var payments = [month, month + 6];
              for (var i in payments) {
                if (payments[i] > 12) payments[i] = payments[i] - 12;
              }
              paymentObject.recurring_interval =
                day + ' ' + payments.join(',') + ' *';
              break;
            case 'yearly':
              paymentObject.recurring_interval = day + ' ' + month + ' *';
              break;
          }
        } else if (paymentObject.payment_method == 'cym') {
          paymentObject.recurring = true;
          paymentObject.recurring_interval = 'monthly';
        } else if (paymentObject.payment_method == 'sms') {
          paymentObject.recurring = false;
        }
      }

      if ('email' in donutFormData) {
        //if no email is set in campaign we use the fallbackEmail from the RaiseNow config obj
        paymentObject.stored_customer_email = donutFormData.email
          ? donutFormData.email
          : 'noemailprovided@formunauts.com';
      } else {
        paymentObject.stored_customer_email = 'noemailprovided@formunauts.com';
      }

      if ('stored_title' in donutFormData) {
        paymentObject.stored_customer_salutation = paymentObject.stored_title = getSextantSalutation(
          donutFormData.stored_title
        );
      }

      if ('stored_sxt_partner_keywords' in donutFormData) {
        paymentObject.stored_sxt_partner_keywords = JSON.stringify(
          donutFormData.stored_sxt_partner_keywords
        );
      }

      if (donutFormData.raisenow_use_salesforce) {
        if ('stored_marketing_location_identifier' in donutFormData) {
          paymentObject.stored_marketing_location_identifier =
            donutFormData.stored_marketing_location_identifier;
        }
      } else {
        if ('stored_sxt_marketing_location' in donutFormData) {
          paymentObject.stored_sxt_marketing_location =
            donutFormData.stored_sxt_marketing_location;
        }
      }

      if (donutFormData.raisenow_use_salesforce) {
        if ('stored_fundraising_team_type' in donutFormData) {
          paymentObject.stored_fundraising_team_type =
            donutFormData.stored_fundraising_team_type;
        }
        if ('stored_fundraising_team_type' in donutFormData) {
          paymentObject.stored_fundraising_team_type =
            donutFormData.stored_fundraising_team_type;
        }
      }

      if ('academic_title' in donutFormData) {
        if (donutFormData.raisenow_use_salesforce) {
          paymentObject.stored_customer_honorific_prefix =
            donutFormData.academic_title;
        } else {
          paymentObject.stored_academic_title = donutFormData.academic_title;
        }
      }

      if ('first_name' in donutFormData) {
        paymentObject.stored_customer_firstname = paymentObject.stored_first_name =
          donutFormData.first_name;
      }

      if ('last_name' in donutFormData) {
        paymentObject.stored_customer_lastname = paymentObject.stored_last_name =
          donutFormData.last_name;
      }

      if ('date_of_birth' in donutFormData) {
        paymentObject.stored_customer_birthdate = paymentObject.stored_date_of_birth =
          donutFormData.date_of_birth;
      }

      if ('occupation' in donutFormData) {
        paymentObject.stored_occupation = donutFormData.occupation;
      }

      if ('street' in donutFormData) {
        paymentObject.stored_customer_street = paymentObject.stored_street =
          donutFormData.street + ' ' + donutFormData.house_number;
      }

      if ('address_addition' in donutFormData) {
        paymentObject.stored_customer_address_addendum =
          donutFormData.address_addition;
      }

      if ('country' in donutFormData) {
        paymentObject.stored_customer_country = donutFormData.country;
      }

      if ('house_number' in donutFormData) {
        paymentObject.stored_house_number = donutFormData.house_number;
      }

      if ('city' in donutFormData) {
        paymentObject.stored_customer_city = paymentObject.stored_city =
          donutFormData.city;
      }

      if ('zip_code' in donutFormData) {
        paymentObject.stored_customer_zip_code = paymentObject.stored_zip_code =
          donutFormData.zip_code;
      }

      if ('fundraiser' in donutFormData) {
        paymentObject.stored_fundraiser = donutFormData.fundraiser;
      }

      if ('first_name' in userData) {
        paymentObject.stored_fundraiser_firstname = userData.first_name;
      }

      if ('last_name' in userData) {
        paymentObject.stored_fundraiser_lastname = userData.last_name;
      }

      if ('image_upload' in userData) {
        paymentObject.stored_fundraiser_image = userData.image_upload;
      }

      if (userData.is_coach) {
        paymentObject.stored_fundraiser_function = 'coach';
      } else if (userData.is_teamleader) {
        paymentObject.stored_fundraiser_function = 'teamleader';
      } else {
        paymentObject.stored_fundraiser_function = 'fundraiser';
      }

      if ('comments' in donutFormData) {
        paymentObject.stored_customer_message = paymentObject.stored_comments =
          donutFormData.comments;
      }

      if ('raisenow_sms_keyword' in donutFormData) {
        paymentObject.stored_sms_keyword = donutFormData.raisenow_sms_keyword;
      }

      if ('raisenow_sms_shortcode' in donutFormData) {
        paymentObject.stored_sms_shortcode =
          donutFormData.raisenow_sms_shortcode;
      }

      if ('raisenow_use_stripe' in donutFormData) {
        paymentObject.use_stripe = donutFormData.raisenow_use_stripe;
      }

      if ('donation_amount' in donutFormData) {
        paymentObject.amount = Math.floor(donutFormData.donation_amount * 100);
      }

      if ('raisenow_api_key' in donutFormData) {
        paymentObject.merchant_identifier = donutFormData.raisenow_api_key;
      }

      if ('stored_sxt_contract_template_id' in donutFormData) {
        paymentObject.stored_sxt_contract_template_id =
          donutFormData.stored_sxt_contract_template_id;
      }

      if ('stored_sxt_product_id' in donutFormData) {
        paymentObject.stored_sxt_product_id =
          donutFormData.stored_sxt_product_id;
      }

      if ('stored_sxt_address_source' in donutFormData) {
        paymentObject.stored_sxt_address_source =
          donutFormData.stored_sxt_address_source;
      }

      if ('mobile_number' in donutFormData) {
        paymentObject.stored_customer_phone = paymentObject.msisdn =
          donutFormData.mobile_number;
      }

      if ('correspondence_language' in donutFormData) {
        paymentObject.stored_customer_language = paymentObject.language =
          donutFormData.correspondence_language;
      } else {
        var fallbackLanguage = userData.language.split('-')[0];
        paymentObject.stored_customer_language = paymentObject.language = fallbackLanguage;
      }

      // XXX add the raisenow stored_campaign_id here
      if ('stored_campaign_id' in donutFormData) {
        paymentObject.stored_campaign_id = donutFormData.stored_campaign_id;
      }

      if ('sextant_vendor_id' in userData && userData.sextant_vendor_id) {
        if (donutFormData.raisenow_use_salesforce) {
          paymentObject.stored_crm_fundraiser_id = userData.sextant_vendor_id;
        } else {
          paymentObject.stored_sxt_vendor_id = userData.sextant_vendor_id;
        }
      } else {
        if (donutFormData.raisenow_use_salesforce) {
          paymentObject.stored_crm_fundraiser_id = userData.fundraiser_code;
        } else {
          paymentObject.stored_sxt_vendor_id = userData.fundraiser_code;
        }
      }

      if ('stored_sf_Contact_Occupation__c' in donutFormData) {
        paymentObject.stored_sf_Contact_Occupation__c =
          donutFormData.stored_sf_Contact_Occupation__c;
      }

      if ('stored_campaign_subid' in donutFormData) {
        paymentObject.stored_campaign_subid =
          donutFormData.stored_campaign_subid;
      }

      paymentObject.card_holder_name = [
        paymentObject.stored_first_name,
        paymentObject.stored_last_name
      ].join(' ');

      return paymentObject;
    }

    function getSextantSalutation(titleCode) {
      var codeLabels = {
        '0': 'SALUTATION_MALE',
        '1': 'SALUTATION_FEMALE',
        '2': 'SALUTATION_FAMILY',
        '3': 'SALUTATION_COMPANY',
        '4': 'SALUTATION_OTHER',
        '5': 'SALUTATION_FEMALE_UNKNOWN',
        '6': 'SALUTATION_FEMALE_UNMARRIED',
        '7': 'SALUTATION_NONE',
        '8': 'SALUTATION_DR'
      };
      var RAISENOW_SALUTATION_CHOICES = {
        SALUTATION_MALE: 'mr',
        SALUTATION_FEMALE: 'ms',
        SALUTATION_FEMALE_UNKNOWN: 'ms',
        SALUTATION_FEMALE_UNMARRIED: 'ms',
        SALUTATION_FAMILY: 'fam',
        SALUTATION_COMPANY: 'company',
        SALUTATION_OTHER: 'other'
      };
      var label = codeLabels[titleCode];
      return (
        RAISENOW_SALUTATION_CHOICES[label] ||
        RAISENOW_SALUTATION_CHOICES['SALUTATION_OTHER']
      );
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.service', [
      'raisenow.settings',
      'raisenow.errorist',
      'raisenow.iframe',
      'raisenow.urlParser'
    ])
    .service('RaiseNowService', RaiseNowService);

  //////////////////////////////////////////////////////////////////////////////

  RaiseNowService.$inject = [
    '$timeout',
    '$window',
    'RaiseNowSettings',
    'RaiseNowErrorist',
    'RaiseNowIframe',
    'FundraisersResource',
    'baseResource'
  ];

  //////////////////////////////////////////////////////////////////////////////
  /**
   *
   * @param {*} $timeout
   * @param {Window} $window
   * @param {*} RaiseNowSettings
   * @param {*} RaiseNowErrorist
   * @param {*} RaiseNowIframe
   * @param {*} FundraisersResource
   * @param {*} baseResource
   * @returns
   */
  function RaiseNowService(
    $timeout,
    $window,
    RaiseNowSettings,
    RaiseNowErrorist,
    RaiseNowIframe,
    FundraisersResource,
    baseResource
  ) {
    var currentPayment;
    /** @type {Window | null | undefined} */
    var currentMposWindow;

    return {
      initiatePayment: initiatePayment,
      redirectToMpos: redirectToMpos
    };

    function initiatePayment(payment) {
      reset();
      RaiseNowErrorist.reset();

      if (isCurrentPayment(payment)) {
        console.warn('Skip setting up event listeners for same payment');
      } else {
        currentPayment = payment;
        setupPaymentEventListeners(currentPayment);
      }

      FundraisersResource.onlineTest()
        .then(function() {
          currentPayment.pubBeforeInitiation();

          if (
            RaiseNowSettings.isPaymentMethodSupported(
              currentPayment.getPaymentMethod()
            )
          ) {
            // we submit the payment to the iFrame for SMS, credit card etc.
            RaiseNowIframe.submit(currentPayment);
          } else {
            onInvalidPaymentMethod(currentPayment.getPaymentMethod());
          }
        })
        .catch(function() {
          currentPayment.pubNoNetworkConnection();
        });
    }

    function onInvalidPaymentMethod(paymentMethod) {
      console.error(
        '[raisenow] could not initiate payment because payment method ":paymentMethod" is not supported'.replace(
          ':paymentMethod',
          paymentMethod
        )
      );

      currentPayment.pubError({
        error: 'Payment method ":id" is not supported.'.replace(
          ':id',
          paymentMethod
        )
      });

      triggerError(RaiseNowErrorist.errors.INVALID_PAYMENT_METHOD);
    }

    function onWindowFocused() {
      if (currentPayment) {
        currentPayment.pubAfterRedirectToMpos({
          epp_transaction_id: currentPayment.eppTransactionId
        });
      }
    }

    /**
     * Resets states before another payment is initiated
     */
    function reset() {
      // remove focus listener
      $window.removeEventListener('focus', onWindowFocused);

      // close MPOS tab, if one was opened
      if (currentMposWindow) {
        if (!currentMposWindow.closed) {
          // Close, if not already closed
          currentMposWindow.close();
        }
      }
      currentMposWindow = undefined;
    }

    /**
     * @param {*} payment The payment object
     *
     * @returns {boolean}
     * `true` if a payment is currently in progress and the given payment
     * has the same object reference has the current payment object.
     */
    function isCurrentPayment(payment) {
      return currentPayment && payment === currentPayment;
    }

    /**
     * Sets up event listeners for the given payment object upon
     * payment initiation.
     *
     * @param {*} payment
     */
    function setupPaymentEventListeners(payment) {
      console.log('Setting up listeners for payment events');

      payment.subAfterInitiation(function(args) {
        // Guard to make sure the event was fired by the same payment
        // we are currently processing
        if (!isCurrentPayment(payment)) {
          return;
        }

        if (payment.isMposPaymentMethod()) {
          payment.eppTransactionId = args.epp_transaction_id;
          // Register the event handler for focusing
          $window.addEventListener('focus', onWindowFocused);
          // Open/redirect to MPOS
          currentMposWindow = redirectToMpos(args.epp_transaction_id);
          if (currentMposWindow === null) {
            // TODO: Implement handling
            console.warn('could not open window due to popup blocker');
          } else if (currentMposWindow) {
            currentMposWindow.focus();
          }
        } else {
          confirmPayment(args.epp_transaction_id, args.query);
        }
      });

      payment.subAfterConfirmation(function() {
        // Guard to make sure the event was fired by the same payment
        // we are currently processing
        if (!isCurrentPayment(payment)) {
          return;
        }

        reset();
      });

      payment.subAfterRedirectToMpos(function(args) {
        // Guard to make sure the event was fired by the same payment
        // we are currently processing
        if (!isCurrentPayment(payment)) {
          return;
        }

        if (payment.isMposPaymentMethod() && payment.eppTransactionId) {
          confirmPayment(payment.eppTransactionId);
        }
      });
    }

    /**
     * @param {string} eppTransactionId EPP transaction ID
     *
     * @returns {Window | undefined | null}
     * If a window was opened, the window will be returned.
     * If a window was tried to be upon, but couldn't `null`
     * will be returned (e.g. popup blocker)
     * If redirected `undefined` will be returned.
     */
    function redirectToMpos(eppTransactionId) {
      currentPayment.pubBeforeRedirectToMpos();

      if (currentPayment.getPaymentMethod() === 'cc_mpos_new') {
        return $window.open(
          'https://terminal.raisenow.com/pay/' +
            eppTransactionId +
            // possible values for end: 'back' (redirect),  'close' (closes tab), 'none' (does nothing)
            '?end=close',
          '_blank'
        );
      } else {
        $window.location.href = 'raisenow://mpos?trx=' + eppTransactionId;
      }
    }

    function confirmPayment(eppTransactionId, query) {
      currentPayment.pubBeforeConfirmation({
        epp_transaction_id: eppTransactionId
      });

      if (currentPayment.isCreditCardPaymentMethod()) {
        if (query.epayment_status === 'success') {
          currentPayment.pubAfterConfirmation({
            epp_transaction_id: eppTransactionId
          });
        } else {
          triggerError(RaiseNowErrorist.errors.NOT_CONFIRMED);
        }
      } else {
        pollPaymentStatus(eppTransactionId);
      }
    }

    function pollPaymentStatusDelayed(eppTransactionId) {
      $timeout(function() {
        pollPaymentStatus(eppTransactionId);
      }, 3000);
    }

    function pollPaymentStatus(eppTransactionId) {
      if (!currentPayment.isActive()) {
        return;
      }

      var url = RaiseNowSettings.getStatusUrl(
        eppTransactionId,
        currentPayment.getPaymentMethod()
      );

      baseResource
        .request({
          url: url,
          method: 'GET',
          cache: false
        })
        .then(function(resp) {
          onPollPaymentStatusSuccess(resp.data, eppTransactionId);
        })
        .catch(function(resp) {
          onPollPaymentStatusError(resp, eppTransactionId);
        });
    }

    function onPollPaymentStatusSuccess(data, eppTransactionId) {
      currentPayment.pubStatusPoll({
        epp_transaction_id: eppTransactionId
      });

      if (data.status === 'final_success') {
        // Special error handling for new mpos + recurring payments
        if (
          currentPayment.getPaymentMethod() === 'cc_mpos_new' &&
          currentPayment.getPaymentObject().recurring &&
          data.subscription_status !== 'active'
        ) {
          if (triggerError(RaiseNowErrorist.errors.INVALID_PAYMENT_STATUS)) {
            pollPaymentStatusDelayed(eppTransactionId);
          }
        } else {
          currentPayment.pubAfterConfirmation({
            epp_transaction_id: eppTransactionId
          });
        }
      } else if (data.status === 'success') {
        if (triggerError(RaiseNowErrorist.errors.NOT_CONFIRMED)) {
          pollPaymentStatusDelayed(eppTransactionId);
        }
      } else {
        if (triggerError(RaiseNowErrorist.errors.INVALID_PAYMENT_STATUS)) {
          pollPaymentStatusDelayed(eppTransactionId);
        }
      }
    }

    function onPollPaymentStatusError(data, eppTransactionId) {
      if (data.status === -1) {
        if (triggerError(RaiseNowErrorist.errors.OFFLINE)) {
          pollPaymentStatusDelayed(eppTransactionId);
        }
      } else {
        if (triggerError(RaiseNowErrorist.errors.UNKNOWN_ERROR)) {
          pollPaymentStatusDelayed(eppTransactionId);
        }
      }
    }

    function triggerError(errorSeverity) {
      if (!RaiseNowErrorist.error(errorSeverity)) {
        currentPayment.cancel();
        reset();
        return false;
      }
      return true;
    }
  }
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular
    .module('raisenow.settings', [])
    .service('RaiseNowSettings', RaiseNowSettings);

  //////////////////////////////////////////////////////////////////////////////

  function RaiseNowSettings() {
    var self = {
      getStatusUrl: getStatusUrl,
      getPaymentUrl: getPaymentUrl,
      endpointUrl: baseconfig.raisenow.endpoint,
      errorUrl: baseconfig.raisenow.errorUrl,
      successUrl: baseconfig.raisenow.successUrl,
      cancelUrl: baseconfig.raisenow.cancelUrl,
      testMode: baseconfig.raisenow.testMode,
      useStripe: baseconfig.raisenow.useStripe,
      paymentMethods: baseconfig.raisenow.paymentMethods,
      isPaymentMethodSupported: isPaymentMethodSupported
    };

    return self;

    function getPaymentUrl(apiKey, paymentMethod, paymentUseStripe, language) {
      if (paymentMethod === 'cc_raisenow') {
        var url = ':endpoint/epayment/api/step/select-card/merchant/:apiKey?submit_button_visibility=false'
          .replace(':cssurl', 'http://localhost:4200/raisenow_creditcard.css')
          .replace(':endpoint', self.endpointUrl)
          .replace(':apiKey', apiKey);
        if (language) {
          url = url + '&language=' + language;
        }
        if (typeof paymentUseStripe !== 'undefined') {
          // the use_stripe variable is configured on the campaign level
          url = url + '&use_stripe=' + paymentUseStripe;
        } else {
          // we will use the global settings for use_stripe
          if (self.useStripe === 'true' || self.useStripe === true) {
            url = url + '&use_stripe=true';
          }
        }
        return url;
      } else if (
        paymentMethod === 'cc_mpos' ||
        paymentMethod === 'cc_mpos_new'
      ) {
        return ':endpoint/epayment/api/step/pay/merchant/:apiKey'
          .replace(':endpoint', self.endpointUrl)
          .replace(':apiKey', apiKey);
      } else {
        return ':endpoint/epayment/api/step/pay/merchant/:apiKey'
          .replace(':endpoint', self.endpointUrl)
          .replace(':apiKey', apiKey);
      }
    }

    function getStatusUrl(transactionId, paymentMethod) {
      if (paymentMethod === 'cc_mpos_new') {
        return 'https://api.raisenow.io/terminal-epp/transactions/:transactionId'.replace(
          ':transactionId',
          transactionId
        );
      }

      return ':endpoint/api/v1/transactions/:transactionId/status'
        .replace(':endpoint', self.endpointUrl)
        .replace(':transactionId', transactionId);
    }

    function isPaymentMethodSupported(paymentMethod) {
      return self.paymentMethods.indexOf(paymentMethod) !== -1;
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

'use strict';

(function() {
  //////////////////////////////////////////////////////////////////////////////

  angular.module('raisenow.urlParser', []).service('UrlParser', UrlParser);

  //////////////////////////////////////////////////////////////////////////////

  function UrlParser() {
    return {
      parseQuery: parseQuery
    };

    function parseQuery(keyValue) {
      keyValue = keyValue.replace(/^\?/, '');
      var obj = {},
        key_value,
        key;
      var iter = (keyValue || '').split('&');
      for (var i = 0; i < iter.length; i++) {
        var kValue = iter[i];
        if (kValue) {
          key_value = kValue.replace(/\+/g, '%20').split('=');
          key = tryDecodeURIComponent(key_value[0]);
          if (isDefined(key)) {
            var val = isDefined(key_value[1])
              ? tryDecodeURIComponent(key_value[1])
              : true;
            if (!hasOwnProperty.call(obj, key)) {
              obj[key] = val;
            } else if (isArray(obj[key])) {
              obj[key].push(val);
            } else {
              obj[key] = [obj[key], val];
            }
          }
        }
      }

      return obj;
    }

    function tryDecodeURIComponent(value) {
      try {
        return decodeURIComponent(value);
      } catch (e) {
        // Ignore any invalid uri component
      }
    }

    function isDefined(value) {
      return typeof value !== 'undefined';
    }
  }

  //////////////////////////////////////////////////////////////////////////////
})();

angular.module('service.raisenow', [
  'raisenow.settings',
  'raisenow.iframe',
  'raisenow.service',
  'raisenow.errorist',
  'raisenow.payment',
  'raisenow.paymentObjectAdapter',
  'raisenow.urlParser',
  'raisenow.modal',
  'raisenow.creditCardModalController',
  'raisenow.mposModalController',
  'raisenow.smsModalController'
]);

/**
 * Service for processing donations & petitions and generating objects for the
 * summary view
 */

SummaryService.$inject = [
  'AuthenticationService',
  'formHelperFactory',
  '$translate'
];

function SummaryService(AuthenticationService, formHelperFactory, $translate) {
  var service = {
    preparePersonDetails: preparePersonDetails,
    prepareGiftRecipientsData: prepareGiftRecipientsData,
    prepareData: prepareData,
    prepareFormWording: prepareFormWording
  };
  return service;

  /**
   * accept an unprocessed person object containing personal details
   * and a form_config to pull in relevant form information
   * (labels, select options etc.)
   *
   * it returns either a new preparedPerson object or updates an existing one
   * if it's passed in as a last parameter
   * @param  {object} person         input person object to be processed
   * @param  {object} form_config    the schemaForm form_config to use
   * @param  {object} preparedPerson output person object to update (optional)
   * @return {object}                processed person object
   */
  function preparePersonDetails(person, form_config, preparedPerson) {
    var preparedPerson =
      typeof preparedPerson !== 'undefined' ? preparedPerson : {};

    //personal data
    if (person.title) {
      preparedPerson.isCompany = person.title + '' === '3';
      preparedPerson.pers_title = formHelperFactory.getValueOfTitleMap(
        form_config.form,
        'title',
        person.title
      );
      preparedPerson.pers_company_name = person.company_name;
    }
    if ('academic_title' in person && person.academic_title !== '') {
      preparedPerson.pers_academic_title = formHelperFactory.getValueOfTitleMap(
        form_config.form,
        'academic_title',
        person.academic_title
      );
    }
    preparedPerson.pers_first_name = person.first_name;
    preparedPerson.pers_last_name = person.last_name;
    preparedPerson.pers_date_of_birth = person.date_of_birth;
    if ('occupation' in person && person.occupation !== '') {
      preparedPerson.pers_occupation = formHelperFactory.getValueOfTitleMap(
        form_config.form,
        'occupation',
        person.occupation
      );
    }

    //contact data
    preparedPerson.pers_contact_email = person.email;
    preparedPerson.pers_contact_phone_number = person.phone_number;
    preparedPerson.pers_contact_mobile_number = person.mobile_number;
    if (
      'correspondence_language' in person &&
      person.correspondence_language !== ''
    ) {
      preparedPerson.pers_contact_correspondence_language_title = formHelperFactory.getValueOfTitleMap(
        form_config.form,
        'correspondence_language',
        person.correspondence_language,
        'name'
      );
    }
    if ('contact_email_conf' in person) {
      preparedPerson.pers_contact_email_conf = person.contact_email_conf
        ? $translate.instant('Yes')
        : $translate.instant('No');
    }

    if ('contact_phone_conf' in person) {
      preparedPerson.pers_contact_phone_conf = person.contact_phone_conf
        ? $translate.instant('Yes')
        : $translate.instant('No');
    }

    if ('contact_data_conf' in person) {
      // to show the answer
      preparedPerson.show_contact_data_notice = true;
      // to selectivly show/hide the extra legal notice
      preparedPerson.contact_data_conf = person.contact_data_conf;
    }

    //address data
    preparedPerson.pers_street = person.street;
    preparedPerson.pers_house_number = person.house_number;
    preparedPerson.pers_zip_code = person.zip_code;
    preparedPerson.pers_city = person.city;
    if ('country' in person && person.country !== '') {
      preparedPerson.pers_country_name = formHelperFactory.getValueOfTitleMap(
        form_config.form,
        'country',
        person.country
      );
    }

    if ('address_addition' in person) {
      preparedPerson.pers_address_addition = person.address_addition;
    }

    return preparedPerson;
  }

  /**
   * prepare person details for every gift recipient and return it as an array
   */
  function prepareGiftRecipientsData(rawData, form_config) {
    if (!rawData.has_gift_recipients || !rawData.gift_recipients_map) {
      return null;
    }
    gift_recipients_map = [];
    for (var i = 0; i < rawData.gift_recipients_map.length; ++i) {
      var preparedGiftRecipient = preparePersonDetails(
        rawData.gift_recipients_map[i],
        form_config
      );
      gift_recipients_map.push(preparedGiftRecipient);
    }
    return gift_recipients_map;
  }

  function processFormGroup(form, rawData) {
    var processedFormGroup = [];
    angular.forEach(form, function(fieldset, key) {
      if (!angular.isObject(fieldset) || !('items' in fieldset)) {
        return false;
      }
      angular.forEach(fieldset.items, function(item, k) {
        if (!(item.key in rawData)) {
          return false;
        }
        // only show items green-lighted on the backend
        var itemKey = item.key instanceof Array ? item.key[0] : item.key;
        if (!('show_on_summary' in item) || !item.show_on_summary) {
          return false;
        }
        switch (item.type) {
          case 'checkboxesWithContent':
            var cbItem = { title: item.title, type: item.type, items: [] };
            angular.forEach(item.titleMap, function(titleMap, k) {
              if (
                angular.isArray(rawData[itemKey]) &&
                rawData[itemKey].length > 0
              ) {
                if (rawData[itemKey].indexOf(titleMap.value) !== -1) {
                  cbItem.items.push(titleMap.title);
                }
              }
            });
            processedFormGroup.push(cbItem);
            break;
          case 'radiosWithContent':
          case 'select':
            angular.forEach(item.titleMap, function(map, k) {
              if (map.value == rawData[itemKey]) {
                processedFormGroup.push({
                  label: item.title || item.name || '',
                  title: map.title || map.name,
                  type: item.type,
                  value: map.value,
                  description: map.description
                });
              }
            });
            break;
          case 'rangesWithContentSimple':
          case 'text':
          case 'date':
          default:
            processedFormGroup.push({
              title: item.title,
              value: rawData[itemKey],
              type: item.type
            });
            break;
        }
      });
    });
    return processedFormGroup;
  }

  /**
   * process all filled out form information to prepare it for being rendered on
   * the summary & signature page.
   *
   * Warning: this same function is used for both donations and petitions,
   * because of their similar architecture.
   *
   * @param  {[type]}  rawData     the values of all the input fields – comes from petitions.petitionModel or donations.donationModel
   * @param  {[type]}  rawDonation (or rawPetition) containing the form, form_config etc. attributes
   * @return {[type]}              processed filled-out form information
   */
  function prepareData(rawData, rawDonation) {
    var preparedData = {};
    var formConfig = rawDonation.form_config || rawDonation.formConfig;

    var fundrUser = AuthenticationService.getCurrentUser();

    //fundraiser data
    preparedData.fundraiser_first_name = fundrUser.first_name;
    preparedData.fundraiser_last_name = fundrUser.last_name;
    preparedData.fundraiser_code = fundrUser.fundraiser_code;
    preparedData.fundraiser_location = rawData.location;

    //sponsorship
    preparedData.campaign_name = rawData.campaign_name;
    if ('sponsorship' in rawData && rawData.sponsorship !== '') {
      preparedData.sponsorship_title = formHelperFactory.getValueOfTitleMap(
        formConfig.form,
        'sponsorship',
        rawData.sponsorship,
        'title'
      );
    }

    preparePersonDetails(rawData, formConfig, preparedData);

    // gift recipients
    if ('form_config_gift_recipient' in rawDonation) {
      preparedData.gift_recipients_map = prepareGiftRecipientsData(
        rawData,
        rawDonation.form_config_gift_recipient
      );
    }

    //donate data
    if (
      formConfig.schema &&
      'contract_start_date' in formConfig.schema.properties
    ) {
      preparedData.pers_donate_debit_contract_start_date =
        rawData.contract_start_date;
    }

    //donate data
    if (formConfig.form) {
      preparedData.pers_donate_debit_contract_start_date =
        rawData.contract_start_date;
      preparedData.pers_donate_calculation_base = formHelperFactory.getFieldOfFormObj(
        formConfig.form,
        'donation_amount'
      ).calculation_base;

      if (!preparedData.pers_donate_calculation_base) {
        preparedData.pers_donate_direct_debit_interval_amount =
          rawData.donation_amount;
        preparedData.pers_donate_direct_debit_interval_title = formHelperFactory.getValueOfTitleMap(
          formConfig.form,
          'direct_debit_interval',
          rawData.direct_debit_interval
        );
        preparedData.show_amount_by_base = false;
        preparedData.show_amount_per_interval = true;
      } else {
        preparedData.pers_donate_direct_debit_interval_title = formHelperFactory.getValueOfTitleMap(
          formConfig.form,
          'direct_debit_interval',
          rawData.direct_debit_interval
        );
        preparedData.pers_donate_direct_debit_interval_amount = formHelperFactory.calcIntervalDebitAmount(
          rawData.donation_amount,
          rawData.direct_debit_interval,
          preparedData.pers_donate_calculation_base
        );

        var pers_donate_direct_debit_amount_yearly = formHelperFactory.calcYearlyDebitAmount(
          rawData.donation_amount,
          preparedData.pers_donate_calculation_base
        );
        var pers_donate_direct_debit_amount_monthly = formHelperFactory.calcMonthlyDebitAmount(
          rawData.donation_amount,
          preparedData.pers_donate_calculation_base
        );
        preparedData.pers_donate_direct_debit_amount =
          preparedData.pers_donate_calculation_base == 'monthly'
            ? pers_donate_direct_debit_amount_monthly
            : pers_donate_direct_debit_amount_yearly;
        preparedData.show_amount_by_base =
          preparedData.pers_donate_direct_debit_amount &&
          preparedData.direct_debit_interval != '4';
        preparedData.show_amount_per_interval = preparedData.pers_donate_direct_debit_amount
          ? true
          : false;
      }
    }

    //account data

    preparedData.account_bank_name = rawData.account_bank_name;
    preparedData.account_iban_or_number = rawData.account_iban_or_number;
    preparedData.account_bic_or_bankcode = rawData.account_bic_or_bankcode;

    if ('payment_method' in rawData) {
      preparedData.payment_method = rawData.payment_method;
      preparedData.print_summary_disclaimer = formHelperFactory.getPaymentDisclaimer(
        rawData,
        rawDonation,
        'print_summary_disclaimer'
      );

      preparedData.print_summary_signature_text = formHelperFactory.getPaymentDisclaimer(
        rawData,
        rawDonation,
        'print_summary_signature_text'
      );
    }

    preparedData.direct_debit_interval = rawData.direct_debit_interval;

    // The code below is handling configurable input types
    // (custom radio buttons, checkboxes, etc.) – pairing their values with
    // the exact wording and preparing them for setting to the scope.

    //additional fields new
    preparedData.form_group = processFormGroup(formConfig.form, rawData);

    //additional fields QA
    if (rawDonation.form_config_qa) {
      preparedData.form_qa_group = processFormGroup(
        rawDonation.form_config_qa.form,
        rawData
      );
    }

    // additional fields signature
    if (rawDonation.form_config_signature) {
      preparedData.form_signature_group = processFormGroup(
        rawDonation.form_config_signature.form,
        rawData
      );
    }

    //comments
    preparedData.comments_comments = rawData.comments;

    //signature
    preparedData.sign_date = new Date();

    // logo
    preparedData.organization_logo = rawDonation.organization_logo;

    return preparedData;
  }

  function prepareFormWording(
    formWording,
    rawData,
    form_config_gift_recipient
  ) {
    preparedFormWording = angular.copy(formWording);

    switch (rawData.payment_method) {
      case 'donut-sepa':
      case 'postfinance_iban':
      case 'swiss_direct_debit':
        preparedFormWording.account_bic_or_bankcode =
          formWording.account_sepa_bic;
        preparedFormWording.account_iban_or_number =
          formWording.account_sepa_iban;
        break;
      case 'donut-post-finance':
        preparedFormWording.account_bic_or_bankcode =
          formWording.account_post_finance_clearing_number;
        preparedFormWording.account_iban_or_number =
          formWording.account_post_finance_post_account_number;
        break;
      case 'donut-uk-sort-codes':
        preparedFormWording.account_bic_or_bankcode =
          formWording.account_uk_sort_code;
        preparedFormWording.account_iban_or_number =
          formWording.account_uk_account_number;
        break;
      case 'donut-de-kontonummer':
        preparedFormWording.account_bic_or_bankcode =
          formWording.account_old_bank_code;
        preparedFormWording.account_iban_or_number =
          formWording.account_old_account_number;
        break;
    }
    preparedFormWording.title_gift_recipients = formHelperFactory.getFieldOfFormObj(
      form_config_gift_recipient,
      'title'
    ).title;

    return preparedFormWording;
  }
}

angular.module('service.summary', []).factory('SummaryService', SummaryService);

SignatureConverter.$inject = [];
function SignatureConverter() {
  var SignatureConverter = {
    validateSignatureData: validateSignatureData,
    toDataURL: toDataURL,
    toHtmlSvg: toHtmlSvg
  };

  return SignatureConverter;

  ////////////

  /**
   * toData
   *
   * converts a rawSignature into the given format

   * @param fromData
   * @param format
   * @returns {false | convertedSignature}
   */
  function toDataURL(fromData, format, wH) {
    wH = wH ? wH : [500, 300];
    format = format ? format : 'image/svg+xml';
    var validFormats = [
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/svg+xml'
    ];
    if (
      !format ||
      (validFormats.indexOf(format) !== -1 &&
        validateSignatureData(
          fromData,
          baseconfig.signatureValidation.minLines,
          baseconfig.signatureValidation.minPoints
        ))
    ) {
      var canvas = document.createElement('canvas');
      canvas.width = wH[0];
      canvas.height = wH[1];
      var s = new SignaturePad(canvas);
      s.fromData(fromData);
      return s.toDataURL(format);
    }
    return false;
  }

  function toHtmlSvg(signatureData, wH) {
    wH = wH ? wH : [500, 300];
    return window.atob(
      this.toDataURL(signatureData, 'image/svg+xml', wH).split(',')[1]
    );
  }

  /**
   *
   * @param signatureData
   * @param minLineCount
   * @param minPointCount
   * @returns {boolean}
   */
  function validateSignatureData(signatureData, minLineCount, minPointCount) {
    var valid = true;

    if (!signatureData) {
      valid = false;
      // console.info('no signatureData given')
    } else if (!angular.isArray(signatureData) || signatureData.length <= 0) {
      // has to be array with at least 1 item
      valid = false;
      // console.info('signatureData is not an array or have no items')
    } else if (consistOfArrays(signatureData)) {
      // items should be of type array
      valid = false;
      // console.info('Some items are not arrays')
    } else if (signatureData.filter(consistOfObjects).length) {
      // subitems should only be objects
      valid = false;
      // console.info('Some sub items are not objects')
    } else if (
      containsXLinesOFYPoints(signatureData, minLineCount, minPointCount)
    ) {
      // at least one item should have more than 10 points
      valid = false;
      // console.info('containsXLinesOFYPoints invalid')
    }

    return valid;
  }

  /**
   * containsXLinesOFYPoints
   *
   * checks structure of signature for min lines and points per line
   *
   * @param item
   * @param minLineCount
   * @param minPointCount
   * @returns {boolean}
   */
  function containsXLinesOFYPoints(item, minLineCount, minPointCount) {
    var lineCount = item.length;
    if (lineCount < minLineCount) {
      // console.log(lineCount , ' is smaller than minLineCount of ', minLineConut);
      return false;
    }

    var pointCount = item.filter(function(i) {
      return i.length > minPointCount;
    }).length;

    if (pointCount > 0) {
      // console.info(lineCount , ' is smaller than minLineCount of ', minLineConut);
      return false;
    }

    return true;
  }

  /**
   * consistOfArrays
   *
   * subi tems should be of type object
   *
   * @param item
   * @returns {boolean}
   */
  function consistOfArrays(item) {
    var countOfNonArrays = item.filter(function(i) {
      // filter non objects
      return !angular.isArray(i);
    }).length;

    // return false if a non object is contained
    return countOfNonArrays > 0;
  }

  /**
   * consistOfObjects
   *
   * sub items should be of type object
   *
   * @param item
   * @returns {boolean}
   */
  function consistOfObjects(item) {
    var countOfNonObjects = item.filter(function(i) {
      // filter non objects
      return !angular.isObject(i);
    }).length;

    // return false if a non object is contained
    return countOfNonObjects > 0;
  }
}

angular
  .module('service.signatureConverter', [])
  .factory('signatureConverter', SignatureConverter);

/**
 * @typedef {object} AnalyticsEventContext
 *
 * @property {string} [sourceCategory]
 * @property {string} [sourceId]
 * @property {string} [tagName]
 * @property {string} [targetId]
 */

/**
 * @typedef {object} AnalyticsEvent
 *
 * @property {AnalyticsEventType} eventType
 * The type of event
 *
 * @property {AnalyticsSlug} name
 * Name of the event
 *
 * @property {Date} [timestamp]
 * Timestamp of the event
 *
 * @property {number} [fundraiser]
 * Identifier for the user
 *
 * @property {AnalyticsEventContext} [eventContext]
 * Event specific context
 *
 * @property {ApiEventLocation} [eventLocation]
 * Location information
 */

/**
 * @typedef {object} AnalyticsEventFactory
 *
 * @property {(name: string, content: ApiEventContext) => AnalyticsEvent} click
 */

AnalyticsService.$inject = [
  '$q',
  'AuthenticationService',
  'AnalyticsResource',
  'AnalyticsIDB'
];
function AnalyticsService(
  $q,
  AuthenticationService,
  /**
   * @type {AnalyticsResource}
   */
  AnalyticsResource,
  AnalyticsIDB
) {
  var analyticsService = {
    trackEvent: trackEvent,
    trackEvents: trackEvents,
    eventFactory: eventFactory
  };

  return analyticsService;

  /////////

  /**
   * Provides global state values for the given event
   * for specific properties, if those aren't specified.
   *
   * @param {AnalyticsEvent} event The event to track
   *
   * @returns {AnalyticsEvent}
   */
  function withGlobalStateValues(event) {
    var currentUser = AuthenticationService.getCurrentUser();

    var eventLocation = event.eventLocation || {
      current: window.location.href,
      referrer: ''
    };

    return {
      name: event.name,
      eventType: event.eventType,
      timestamp: event.timestamp || new Date(),
      fundraiser: event.fundraiser || currentUser.id,
      eventLocation: eventLocation,
      eventContext: event.eventContext
    };
  }

  /**
   * @param {AnalyticsEvent} event The event to track
   *
   * @returns {Promise}
   * A promise that resolves when the event is stored either on the server or in IDB
   */
  function trackEvent(event) {
    return trackEvents([event]);
  }

  /**
   * @param {AnalyticsEvent[]} events The events to track
   *
   * @returns {Promise<{ store: 'server' | 'local' }>}
   * A promise that resolves when the events were stored either on the server or in IDB
   */
  function trackEvents(events) {
    var mappedEvents = events.map(withGlobalStateValues);

    return storeEventsOnServer(mappedEvents)
      .then(function() {
        return { store: 'server' };
      })
      .catch(function() {
        // In case the events couldn't be stored on the server, persist in IDB
        return storeEventsInIndexedDb(mappedEvents).then(function() {
          return { store: 'local' };
        });
      });
  }

  /**
   * Uploads the passed events and the stored events.
   *
   * @param {AnalyticsEvent[]} events The events to store on the server
   *
   * @returns {Promise}
   * A promise that resolves when the events were stored on the server.
   * If uploading to the server fails, the promise is rejected.
   */
  function storeEventsOnServer(events) {
    // If we know that we are offline, reject immediatly
    if (!navigator.onLine) {
      return $q.reject();
    }

    function mapEventsFromIdb(dbEvent) {
      var event = angular.copy(dbEvent);
      delete event.id;
      return event;
    }

    // First, try to get the events stored in IDB
    return AnalyticsIDB.list('events').then(function(dbEntries) {
      // Combine the events from IDB with the passed events
      var allEvents = sortEvents(
        dbEntries.map(mapEventsFromIdb).concat(events)
      );
      // and store them on the server
      return AnalyticsResource.createEvents(allEvents).then(function(response) {
        var keys = dbEntries.map(function(entry) {
          return entry.id;
        });

        return AnalyticsIDB.delete('events', keys)
          .then(function() {
            return response;
          })
          .catch(function(error) {
            return error; // Catch any error, to let the promise resolve
          });
      });
    });
  }

  /**
   * @param {AnalyticsEvent | AnalyticsEvent[]} events The events to store
   *
   * @returns {Promise}
   * A promise that is resolved, once all items are stored in IDB
   */
  function storeEventsInIndexedDb(events) {
    var promises = events.map(function(event) {
      return AnalyticsIDB.add('events', event).catch(function() {});
    });

    return $q.all(promises);
  }

  /**
   * @param {AnalyticsEvent[]} events The events to sort
   *
   * @returns {AnalyticsEvent[]}
   * The events sorted by datetime ascending
   */
  function sortEvents(events) {
    return events.sort(function(a, b) {
      return a.timestamp.getTime() - b.timestamp.getTime();
    });
  }

  /**
   * @param {ApiEventContext} configuredContext The event context
   *
   * @returns {AnalyticsEventFactory}
   * A factory for creating analytics events with a default context
   */
  function eventFactory(configuredContext) {
    function enhanceContext(overrides) {
      var resultContext = {};

      angular.forEach(
        configuredContext,
        function(value, key) {
          this[key] = value;
        },
        resultContext
      );

      if (overrides) {
        angular.forEach(
          overrides,
          function(value, key) {
            this[key] = value;
          },
          resultContext
        );
      }

      return resultContext;
    }

    /**
     *
     * @param {string} name The name of the event
     * @param {ApiEventContext} [context] The targetId
     *
     * @returns {AnalyticsEvent}
     * An analytics event
     */
    function click(name, context) {
      var event = {
        eventType: 'click',
        name: name,
        eventContext: enhanceContext(context)
      };

      return event;
    }

    return {
      click: click
    };
  }
}

angular
  .module('service.analytics', [])
  .value('analyticsIDBConfig', {
    name: 'analytics_events',
    version: 1,
    stores: { events: null }
  })
  .factory('AnalyticsIDB', [
    '$q',
    'analyticsIDBConfig',
    function($q, analyticsIDBConfig) {
      return IndexedDbService($q, analyticsIDBConfig);
    }
  ])
  .factory('AnalyticsService', AnalyticsService);

angular.module('services', [
  'service.analytics',
  'service.formHelper',
  'service.bankAccountCheck',
  'service.offlineStore',
  'service.indexeddb',
  'service.geoLocation',
  'service.commonNames',
  'service.incognitocheck',
  'service.cachingService',
  'service.raisenow',
  'service.commonHelpers',
  'service.imagePreloader',
  'service.notifications',
  'service.signatureConverter',
  'service.summary'
]);

GeneralModalController.$inject = [
  '$uibModalInstance',
  'title',
  'text',
  'cancelGiven',
  'isTextAsHtml'
];
function GeneralModalController(
  $uibModalInstance,
  title,
  text,
  cancelGiven,
  isTextAsHtml
) {
  var vm = this;

  vm.title = title;
  vm.text = text;

  vm.ok = ok;
  vm.isTextAsHtml = isTextAsHtml ? true : false;
  vm.cancelGiven = cancelGiven ? true : false;

  vm.cancel = cancel;

  ////////////////

  function ok() {
    $uibModalInstance.close('ok');
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }
}

angular
  .module('generalModal', [])
  .controller('GeneralModalController', GeneralModalController);

IncognitoModalController.$inject = ['title', 'text'];
function IncognitoModalController(title, text) {
  var vm = this;

  vm.title = title;
  vm.text = text;
}

angular
  .module('incognitoModal', [])
  .controller('IncognitoModalController', IncognitoModalController);

BrowserSupportModalController.$inject = ['$uibModalInstance', 'title', 'text'];
function BrowserSupportModalController($uibModalInstance, title, text) {
  var vm = this;

  vm.title = title;
  vm.text = text;
  vm.ok = ok;

  ////////////////

  function ok() {
    $uibModalInstance.close('ok');
  }
}

angular
  .module('browserSupportModal', [])
  .controller('BrowserSupportModalController', BrowserSupportModalController);

UploadSuccessController.$inject = [
  '$uibModalInstance',
  'title',
  'text',
  'image',
  'hint'
];
function UploadSuccessController($uibModalInstance, title, text, image, hint) {
  var vm = this;

  vm.title = title;
  vm.text = text;
  vm.image = image;
  vm.hint = hint;

  vm.ok = ok;
  ////////////////

  function ok() {
    $uibModalInstance.close('ok');
  }
}

angular
  .module('uploadSuccess', [])
  .controller('UploadSuccessController', UploadSuccessController);

angular.module('modals', [
  'generalModal',
  'incognitoModal',
  'uploadSuccess',
  'browserSupportModal'
]);

function formatForCurrency() {
  var currencyWithSymbolRight = ['€'],
    out = '';

  return function(amount, currency) {
    var symbolOnRightSide = false;

    if (currencyWithSymbolRight.indexOf(currency) !== -1) {
      symbolOnRightSide = true;
    }

    if (symbolOnRightSide) {
      out = amount + ' ' + currency;
    } else {
      out = currency + ' ' + amount;
    }

    return out;
  };
}

function ifEmpty() {
  return function(input, defaultValue) {
    if (angular.isUndefined(input) || input === null || input === '') {
      return defaultValue;
    }

    return input;
  };
}

function msToTime() {
  return function(milliseconds, withHour) {
    if (milliseconds < 0) {
      return withHour ? '00:00:00' : '00:00';
    }

    var seconds = parseInt((milliseconds / 1000) % 60);
    var minutes = parseInt((milliseconds / (1000 * 60)) % 60);
    var hours = parseInt((milliseconds / (1000 * 60 * 60)) % 24);
    var out = '';

    out = minutes + ':' + seconds;

    if (withHour) {
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      out = hours + ':' + minutes + ':' + seconds;
    } else {
      minutes = parseInt(minutes) + 60 * parseInt(hours);
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      out = minutes + ':' + seconds;
    }

    return out;
  };
}

function toCapitalized() {
  return function(value) {
    value = value ? value : '';

    return capitalize(value);

    //////////////

    function capitalize(str) {
      // first remove superfluous  white space
      str = str.replace(/\s\s+/g, ' ');

      // Find all (lowercased) letters at the beginning or before a
      // non-alphanumerical character - including some special symbols -
      // but only, if they are followed by another alphanumeric character.
      var re = /((^|[^a-zA-ZÀ-ƿ0-9'])[a-zÀ-ƿ](?=[a-zA-ZÀ-ƿ0-9']))/g;

      return str.replace(re, function(c) {
        return c.toUpperCase();
      });
    }
  };
}

//sumByKey.$inject = [];

/**
 *
 * provide a default value if original is not given
 *
 * example {{input | ifEmpty:0}}
 *
 */
/** @ngInject */
function sumByKey() {
  return function(data, key) {
    if (angular.isUndefined(data) && angular.isUndefined(key)) return 0;

    var sum = 0;
    angular.forEach(data, function(v, k) {
      sum = sum + parseInt(v[key]);
    });
    return sum;
  };
}

function formatE164Function() {
  return function(value, countryCode) {
    countryCode = countryCode ? countryCode : getLanguage();
    value = value ? value : '';
    return formatE164(countryCode, value);
    /////
    function getLanguage() {
      var lang = 'en';
      try {
        var browserLang = navigator.language.split('-')[0];
        if (browserLang) {
          var languages = ['de', 'en'];
          if (languages.indexOf(browserLang) !== -1) {
            lang = browserLang;
          }
        }
      } catch (e) {
        //don't bubble up
      }
      return lang;
    }
  };
}

function toTrimmedWhitespace() {
  return function(value, trimAll) {
    trimAll = !!trimAll;
    value = value ? value : '';

    return trimFunction(value, trimAll);

    //////////////

    function trimFunction(str, trimAll) {
      var result = str;

      if (trimAll) {
        result = result.split(' ').join('');
      } else {
        result = result.trim();
      }

      return result;
    }
  };
}

formatIban.$inject = [];
function formatIban() {
  return function(iban, bic) {
    return formatIban(iban, bic);
  };

  ////////////////////////
}

angular
  .module('filter', [])
  .filter('formatForCurrency', formatForCurrency)
  .filter('ifEmpty', ifEmpty)
  .filter('msToTime', msToTime)
  .filter('toCapitalized', toCapitalized)
  .filter('sumByKey', sumByKey)
  .filter('formatE164', formatE164Function)
  .filter('toTrimmedWhitespace', toTrimmedWhitespace)
  .filter('formatIban', formatIban);

signaturePadInputController.$inject = ['$scope', '$element'];
function signaturePadInputController($scope, $element) {
  var childrenReady = false;
  var defaultID = 'signaturePad' + parseInt(Math.random() * 1000);
  var canvas;

  var defaultConfig = {
    // (float or function) Radius of a single dot.
    // dotSize: 1,
    // (float) Minimum width of a line. Defaults to 0.5.
    minWidth: 1,
    // (float) Maximum width of a line. Defaults to 2.5.
    maxWidth: 3,
    // (integer) Draw the next point at most once per every x milliseconds. Set it to 0 to turn off throttling. Defaults to 16.
    throttle: 16,
    // (string) Color used to clear the background.
    // Can be any color format accepted by context.fillStyle.
    // Defaults to "rgba(0,0,0,0)" (transparent black).
    // Use a non-transparent color e.g. "rgb(255,255,255)" (opaque white) if you'd like to save signatures as JPEG images.
    backgroundColor: 'rgba(0,0,0,0)',
    // (string) Color used to draw the lines. Can be any color format accepted by context.fillStyle. Defaults to "black".
    penColor: 'black',
    // (float) Weight used to modify new velocity based on the previous velocity. Defaults to 0.7.
    velocityFilterWeight: 0.7
    //  (function) Callback when stroke begin.
    // onBegin: function() {},
    // (function) Callback when stroke end.
    // onEnd: function() {}
  };

  var ctrl = this;
  ctrl.signaturePad;

  // Lifecycle hooks ==========================================
  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('padId', changes) && changes.padId.currentValue) {
      ctrl.padId = changes.padId.currentValue
        ? changes.padId.currentValue
        : defaultID;
      initSignaturePad();
    }

    if (valueChanged('config', changes) && changes.config.currentValue) {
      ctrl.config = changes.config.currentValue;
      updateConfig(ctrl.config);
    }
  };

  ctrl.$onInit = function() {
    // Specify how UI should be updated
    ctrl.ngModel.$render = function() {
      renderModelToView(ctrl.ngModel.$modelValue);
    };

    $scope.$watch(
      function() {
        return ctrl.ngModel.$modelValue;
      },
      function(value) {
        ctrl.ngModel.$setViewValue(value);
      }
    );
  };

  ctrl.$onDestroy = function() {
    try {
      ctrl.signaturePad.off();
    } catch (e) {
      console.error('Failed unbind signature pad!');
    }
  };
  ctrl.$postLink = function() {
    childrenReady = true;
    initSignaturePad();
  };

  ctrl.clear = function() {
    ctrl.ngModel.$setViewValue(null);
    ctrl.ngModel.$render();
    ctrl.ngModel.$setUntouched();
    ctrl.ngModel.$setPristine();
  };

  // ngModel Hooks  ==========================================

  function renderModelToView(val) {
    if (!ctrl.signaturePad) {
      return;
    }

    if (canRenderSignatureData(val)) {
      ctrl.signaturePad.fromData(val);
    } else {
      ctrl.signaturePad.clear();
    }
  }

  function writeViewToModel() {
    /*
     * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
     * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
     * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
     * `$asyncValidators` are called and the value is applied to `$modelValue`.
     * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
     * all the registered change listeners, in the `$viewChangeListeners` list are called.
     */
    ctrl.ngModel.$setTouched();
    ctrl.ngModel.$setViewValue(angular.copy(ctrl.signaturePad.toData()));
  }

  // Signature Pad  ==========================================

  function canRenderSignatureData(data) {
    return angular.isArray(data);
  }

  function initSignaturePad() {
    if (childrenReady) {
      renderSignaturePad();
      updateConfig(defaultConfig);
    }
  }

  /**
   *   config: {
   *    dotSize:number | Function,
   *    minWidth: number,
   *    maxWidth: number,
   *    throttle: number,
   *    backgroundColor: string,
   *    penColor: string,
   *    velocityFilterWeight: number,
   *    onBegin: Function,
   *    onEnd: Function
   *  }
   *
   * @param config
   */
  function updateConfig(config) {
    if (angular.isObject(config) && childrenReady) {
      if ('dotSize' in config && config.dotSize) {
        if (typeof config.dotSize === 'function' || config.dotSize > 0) {
          ctrl.signaturePad.dotSize = config.dotSize;
        }
      }

      if ('minWidth' in config && config.minWidth >= 0) {
        ctrl.signaturePad.minWidth = config.minWidth;
      } else {
        ctrl.signaturePad.minWidth = defaultConfig.minWidth;
      }

      if ('maxWidth' in config && config.maxWidth >= 0) {
        ctrl.signaturePad.maxWidth = config.maxWidth;
      }

      if ('throttle' in config && config.throttle >= 0) {
        ctrl.signaturePad.throttle = config.throttle;
      }

      if ('backgroundColor' in config && config.backgroundColor) {
        ctrl.signaturePad.backgroundColor = config.backgroundColor;
      }

      if ('penColor' in config && config.penColor) {
        ctrl.signaturePad.penColor = config.penColor;
      }

      if (
        'velocityFilterWeight' in config &&
        config.velocityFilterWeight >= 0
      ) {
        ctrl.signaturePad.velocityFilterWeight = config.velocityFilterWeight;
      }

      if ('onBegin' in config && config.onBegin) {
        if (typeof config.onBegin === 'function') {
          ctrl.signaturePad.onBegin = config.onBegin;
        }
      }

      if ('onEnd' in config && config.onEnd) {
        if (typeof config.onEnd === 'function') {
          ctrl.signaturePad.onEnd = config.onEnd;
        }
      }
    }
  }

  function renderSignaturePad() {
    var parent = $element[0].querySelector('.signature-pad-body');
    //clear content and listener
    window.removeEventListener('resize', resizeCanvas);
    parent.innerHTML = '';
    //create elem
    canvas = document.createElement('canvas');
    canvas.id = ctrl.padId;
    canvas.className = 'signature-pad';
    canvas.width = '400';
    canvas.height = '200';
    // add element
    parent.appendChild(canvas);

    canvas = document.getElementById(ctrl.padId);
    // resize canvas
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    if (ctrl.signaturePad) {
      try {
        ctrl.signaturePad.off();
      } catch (e) {
        console.error('Failed unbind signature pad!');
      }
    }

    ctrl.signaturePad = new SignaturePad(canvas);
    updateConfig(defaultConfig);
    ctrl.signaturePad.onEnd = writeViewToModel;

    try {
      ctrl.signaturePad.on();
    } catch (e) {
      console.error('Failed rebind signature pad!');
    }
  }

  function resizeCanvas() {
    if (canvas) {
      // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      var parent = $element[0].querySelector('.signature-pad-body');

      // information needed to calculate the available width and height
      var canvasBorder = {};
      canvasBorder.top = parseInt(
        angular.element(canvas).css('borderTopWidth')
      );
      canvasBorder.bottom = parseInt(
        angular.element(canvas).css('borderBottomWidth')
      );
      canvasBorder.left = parseInt(
        angular.element(canvas).css('borderLeftWidth')
      );
      canvasBorder.right = parseInt(
        angular.element(canvas).css('borderRightWidth')
      );
      var parentPadding = {};
      parentPadding.top = parseInt(angular.element(parent).css('paddingTop'));
      parentPadding.bottom = parseInt(
        angular.element(parent).css('paddingBottom')
      );
      parentPadding.left = parseInt(angular.element(parent).css('paddingLeft'));
      parentPadding.right = parseInt(
        angular.element(parent).css('paddingRight')
      );

      canvas.width =
        (canvas.parentElement.clientWidth -
          parentPadding.left -
          parentPadding.right -
          canvasBorder.left -
          canvasBorder.right) *
        ratio;
      canvas.height =
        (canvas.parentElement.clientHeight -
          parentPadding.top -
          parentPadding.bottom -
          canvasBorder.top -
          canvasBorder.bottom -
          5) /*Don't know why 5px! Where are they coming from?*/ *
        ratio;
      canvas.getContext('2d').scale(ratio, ratio);

      // The signature pad deletes the canvas data on every resize.
      // The model value is still set. So we restore it here by rendering the model value to view again.
      if (typeof ctrl.ngModel.$render === 'function') {
        ctrl.ngModel.$render();
        // we currently have no fix for signatures signed in landscape and sent in portrait
        // We clear the signature form the model because the canvas is cleared.
        // But on some devices the signature gets cleared on scroll so we go with the render approach
        // ctrl.clear()
      }
    }
  }
}

var SignaturePadInputComp = {
  require: {
    form: '^form',
    ngModel: '^ngModel'
  },
  bindings: {
    padId: '<',
    config: '<',
    valueChange: '&'
  },
  templateUrl:
    'app/commons/components/signature-pad-input/signature-pad-input.html',
  controller: signaturePadInputController
};

angular
  .module('signaturePadInputModule', [])
  .component('signaturePadInputComp', SignaturePadInputComp);

LoadingSpinnerController.$inject = ['$element'];
function LoadingSpinnerController($element) {
  var ctrl = this;

  ctrl.animate = false;

  ////////////////////

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('animate', changes)) {
      ctrl.animate = changes.animate.currentValue;
    }
  };
}

var loadingSpinner = {
  bindings: {
    animate: '<'
  },
  templateUrl: 'app/commons/components/loading-spinner/loading-spinner.html',
  controller: LoadingSpinnerController
};

angular
  .module('loadingSpinnerModule', [])
  .component('loadingSpinner', loadingSpinner);

NetworkStatusBarController.$inject = ['$window', '$scope'];
function NetworkStatusBarController($window, $scope) {
  var networkStates = {
    unknown: 'unknown',
    on: 'online',
    off: 'offline'
  };

  var $ctrl = this;
  $ctrl.$onInit = $onInit;

  $ctrl.networkStateName = networkStates.unknown;
  $ctrl.networkStateClass = networkStates.unknown;

  //////

  function $onInit() {
    if (navigator.onLine) {
      $ctrl.networkStateName = networkStates.on;
      $ctrl.networkStateClass = networkStates.on;
    } else {
      $ctrl.networkStateName = networkStates.off;
      $ctrl.networkStateClass = networkStates.off;
    }

    $window.addEventListener(networkStates.on, function(e) {
      $ctrl.networkStateName = networkStates.on;
      $ctrl.networkStateClass = networkStates.on;
      $scope.$digest();
    });
    $window.addEventListener(networkStates.off, function(e) {
      $ctrl.networkStateName = networkStates.off;
      $ctrl.networkStateClass = networkStates.off;
      $scope.$digest();
    });
  }
}

var NetworkStatusBarComponent = {
  templateUrl:
    'app/commons/components/network-status-bar/network-status-bar.html',
  controller: NetworkStatusBarController
};

angular
  .module('networkStatusBar', [])
  .component('networkStatusBarComp', NetworkStatusBarComponent);

/**
 * Lib: https://github.com/davidshimjs/qrcodejs
 **/
DisclaimerController.$inject = ['$scope', '$element', '$attrs'];
function DisclaimerController($scope, $element, $attrs) {
  var ctrl = this;

  ctrl.text;
  ctrl.imageUrl;

  ctrl.$onChanges = function(changes) {
    if ('text' in changes) {
      ctrl.text = changes.text.currentValue;
    }

    if ('imageUrl' in changes) {
      ctrl.imageUrl = changes.imageUrl.currentValue;
    }
  };
}

var DisclaimerComponent = {
  bindings: {
    text: '<',
    imageUrl: '<'
  },
  templateUrl: 'app/commons/components/disclaimer/disclaimer.tpl.html',
  controller: DisclaimerController
};

angular
  .module('disclaimerComp', [])
  .component('disclaimer', DisclaimerComponent);

/**
 * Lib: https://github.com/davidshimjs/qrcodejs
 **/
qrCodeRendererController.$inject = ['$scope', '$element', '$attrs'];
function qrCodeRendererController($scope, $element, $attrs) {
  var ctrl = this;

  ctrl.defaultID = 'qrcode';

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('id', changes)) {
      ctrl.id = changes.id.currentValue
        ? changes.id.currentValue
        : ctrl.defaultID;
      ctrl.renderQrCode();
    }

    if (valueChanged('text', changes)) {
      ctrl.text = changes.text.currentValue;
      ctrl.renderQrCode();
    }
  };

  ctrl.renderQrCode = function() {
    //clear content
    $element[0].innerHTML = '';

    //create elem and add
    var qrCodeElem = document.createElement('div');
    qrCodeElem.id = ctrl.id;
    $element.append(qrCodeElem);

    // render qr-code
    var qrcode = new QRCode(document.getElementById(ctrl.id), {
      text: ctrl.text,
      width: 128,
      height: 128,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    });
  };
}

var QrCodeRendererComp = {
  bindings: {
    id: '<',
    text: '<'
  },
  templateUrl:
    'app/commons/components/qr-code-renderer/qr-code-renderer.tpl.html',
  controller: qrCodeRendererController
};

angular
  .module('qrCodeRenderer', [])
  .component('qrCodeRendererComp', QrCodeRendererComp);

ToastController.$inject = ['notificationsChannel', '$scope', '$interval'];
function ToastController(notificationsChannel, $scope, $interval) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.onButtonClicked = onButtonClicked;
  ctrl.durationTimeout = undefined;

  $scope.toast = undefined;
  $scope.timePassed = 0;
  $scope.durationStyle = {};

  $scope.$on('$destroy', function() {
    window.removeEventListener('click', onAnyClick);
  });

  function $onInit() {
    notificationsChannel.subToastsChanged(onToastChanged);
    window.addEventListener('click', onAnyClick);
  }

  function onToastChanged(toast) {
    $scope.toast = toast;

    if (toast) {
      setUpDurationListener(toast.duration);
    }
  }

  function onAnyClick(ev) {
    if (!$scope.toast || $scope.toast.dismissable !== true) {
      return;
    }

    var toastElement = ev.target;

    // Search the hierarchy upwards, to find an enclosing element we wanna capture
    // TODO: Can be replace with `anchorElement.closest(...)` once polyfill is available
    while (toastElement && !toastElement.classList.contains('toast')) {
      toastElement = toastElement.parentElement;
    }

    // Click not within a toast
    if (!toastElement) {
      close('dismiss');
    }
  }

  /**
   *
   * @param {object} button
   * @param {boolean} button.close
   * @param {string} button.action
   */
  function onButtonClicked(button) {
    if (button && button.close) {
      close('action');
    }
  }

  function setUpDurationListener(duration) {
    if (typeof duration !== 'number') {
      if (ctrl.durationIndicator) {
        $interval.cancel(ctrl.durationIndicator);
      }
      return; // No auto close
    }

    var durationMs = duration * 1000;
    var start = new Date().getTime();
    $scope.timePassed = 0;

    // Checks for the
    var instance = $scope.toast;
    ctrl.durationTimeout = setTimeout(function() {
      // Only call, when if the instance didn't change
      if (instance && instance === $scope.toast) {
        close('timeout');
      }
    }, durationMs);

    function tick() {
      // Only call, when if the instance didn't change
      if (instance && instance === $scope.toast) {
        var element = document.getElementsByClassName('toast__timeout').item(0);

        if (element) {
          $scope.timePassed = $scope.timePassed + new Date().getTime() - start;
          start = new Date().getTime();
          element.style.width = ($scope.timePassed / durationMs) * 100 + '%';
        }
      }
    }
    ctrl.durationIndicator = $interval(tick, 10);
    tick();
  }

  function close(action) {
    if (ctrl.durationTimeout) {
      window.clearTimeout(ctrl.durationTimeout);
    }

    if (ctrl.durationIndicator) {
      $interval.cancel(ctrl.durationIndicator);
      ctrl.durationIndicator = undefined;
    }

    var toastEvents = $scope.toast.events;
    if (toastEvents && toastEvents.close) {
      toastEvents.close(action);
    }

    $scope.toast = undefined;
  }
}

var Toast = {
  templateUrl: 'app/commons/components/toast/toast.html',
  controller: ToastController
};

angular.module('toast', []).component('toastComp', Toast);

dashboardWidgetValueController.$inject = ['$filter', '$translate'];
function dashboardWidgetValueController($filter, $translate) {
  var ctrl = this;

  //Type of the box. [dashboardBoxType]
  //define dashboardBoxType = "metric" | "money" | "text-list" | "key-value-list";
  ctrl.type;
  //The value to display in the box. [number | Array<string> | Array<Array><string>]
  ctrl.value;
  //An angular filter to apply on values. [Array<string>]
  ctrl.filters;
  //The widgets currency
  ctrl.currency;
  //A prefix for the value. [string]
  ctrl.prefix;
  //A suffix for the value. [string]
  ctrl.suffix;

  //Ctrl only properties
  //Valid types for value
  ctrl.types = {
    metric: 'metric',
    money: 'money',
    duration: 'duration',
    text_list: 'text-list',
    key_value_list: 'key-value-list',
    star_rating: 'star-rating'
  };

  ctrl.calcHalfStarVisible = calcHalfStarVisible;

  ctrl.$onChanges = function(changes) {
    // helper to detect a real change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('value', changes)) {
      ctrl.value = prepareValue(
        changes.value.currentValue,
        ctrl.type,
        ctrl.filters,
        ctrl.currency
      );
    }
  };

  /**
   * prepareValue
   *
   * @param value
   * @param type
   * @param filters Array<FilterConfig>
   * @param currency
   *
   * @returns newValue:string, prepared value
   */
  function prepareValue(value, type, filters, currency) {
    var newValue = value;

    //provide default values if empty
    if (
      (type === ctrl.types.metric || type === ctrl.types.money || !type) &&
      !newValue
    ) {
      newValue = 0;
    }

    // prepare duration value
    if (type === ctrl.types.duration) {
      // Passed value is in minutes
      newValue = !newValue ? '-' : $filter('number')(newValue, 2) + 'm';
      return newValue;
    }

    //prepare the star rating
    if (type === ctrl.types.star_rating) {
      var formattedRating = $filter('number')(newValue.average_rating, 2);
      newValue.text = $translate.instant('{{rating}} from {{count}} ratings', {
        rating: formattedRating,
        count: newValue.number_of_ratings
      });
      return newValue;
    }

    newValue = prepareValueWithFilter(newValue, type, filters, currency);

    return newValue;
  }

  /**
   * prepareValueWithFilter
   *
   * @param value
   * @param type
   * @param filters
   * @param currency
   *
   * @returns {*}
   */
  function prepareValueWithFilter(value, type, filters, currency) {
    filters = filters || [];
    var newValue = value;

    // apply currencyFilter to type money
    if (type === ctrl.types.money) {
      filters.push({ name: 'formatForCurrency', attributes: [currency] });
    }

    // apply filter to value
    if (filters) {
      var actualFilter;
      var actualFilterParams;

      for (var i = 0; i < filters.length; i++) {
        actualFilter = $filter(filters[i].name);
        actualFilterParams = angular.copy(filters[i].attributes);
        actualFilterParams.unshift(newValue);
        newValue = actualFilter.apply(undefined, actualFilterParams);
      }
    }

    return newValue;
  }

  function calcHalfStarVisible(rating) {
    return rating % 1 > 0.5;
  }
}

var DashboardWidgetValueComponent = {
  bindings: {
    type: '<',
    value: '<',
    lang: '<',
    filters: '<',
    currency: '<',
    prefix: '<',
    suffix: '<'
  },
  templateUrl:
    'app/commons/components/dashboard/dashboard-widget/dashboard-widget-value/dashboard-widget-value.tpl.html',
  controller: dashboardWidgetValueController
};

angular
  .module('dashboard-widget-value', [])
  .component('dashboardWidgetValueComp', DashboardWidgetValueComponent);

function dashboardWidgetController() {
  var ctrl = this;

  //Type of the box. [dashboardBoxType]
  //define dashboardBoxType = "metric" | "money" | "text-list" | "key-value-list";
  ctrl.type;
  //Title of the box. [string]
  ctrl.titleText;
  //Suggested language of the box content
  ctrl.lang;
  //The widgets currency
  ctrl.currency;
  //url of title as link
  ctrl.link;
  //Widget class placed on the box it self. [string]
  ctrl.widgetClass;
  //Icon Class. [string]
  ctrl.iconClass;
  //The value to display in the box. [number | Array<string> | Array<Array><string>]
  ctrl.value;
  //An angular filter to apply on values. [Array<string>]
  ctrl.filters;
  //A prefix for the value. [string]
  ctrl.prefix;
  //A suffix for the value. [string]
  ctrl.suffix;

  //ctrl only
  //Valid types for value
  ctrl.types = {
    metric: 'metric',
    money: 'money',
    text_list: 'text-list',
    key_value_list: 'key-value-list'
  };

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('titleText', changes)) {
      ctrl.titleText = getLangValueFromLangObj(
        changes.titleText.currentValue,
        ctrl.lang
      );
    }

    if (valueChanged('value', changes)) {
      ctrl.value = prepareWidgetValueForLanguage(
        changes.value.currentValue,
        ctrl.type,
        ctrl.lang
      );
    }
  };

  /**
   * prepareWidgetValue
   *
   * @param value
   * @param type
   * @param lang
   * @returns {*}
   */
  function prepareWidgetValueForLanguage(value, type, lang) {
    var newValue;
    var translatedValue;
    var newObj;

    if (type === ctrl.types.key_value_list) {
      newValue = value.map(function(entry) {
        translatedValue = getLangValueFromLangObj(entry.key, lang);

        newObj = {};
        newObj.key = translatedValue;
        newObj.value = entry.value;

        return newObj;
      });
    } else if (type === ctrl.types.text_list) {
      newValue = value.map(function(entry) {
        translatedValue = getLangValueFromLangObj(entry, lang);

        return translatedValue;
      });
    } else {
      //    type === ctrl.types.metric
      // || type === ctrl.types.money
      // || type === ctrl.types.star_rating
      // || !type
      newValue = value;
    }

    return newValue;
  }

  /**
   * getLangFromLangObj
   *
   * @param langObj:array, The title to display.
   * @param suggestedLang?:string, The language in which the title should be displayed.
   *
   * @returns translatedTitle:string,
   */
  function getLangValueFromLangObj(langObj, suggestedLang) {
    var supportedLanguages = Object.keys(langObj);
    var lang = getLanguage(supportedLanguages, suggestedLang);
    return langObj[lang];
  }

  /**
   * getLanguage
   *
   * @param supportedLanguages:Array<string>, The list of supported languages.
   * @param suggestedLang?:string, The language key that should be used.
   *
   * @return newLang:string, Available language key
   */
  function getLanguage(supportedLanguages, suggestedLang) {
    var newLang;

    if (supportedLanguages.indexOf(suggestedLang) !== -1) {
      newLang = suggestedLang;
    } else {
      newLang = supportedLanguages[0];
    }

    return newLang;
  }
}

var DashboardWidgetComponent = {
  bindings: {
    type: '<',
    titleText: '<',
    currency: '<',
    link: '<',
    lang: '<',
    widgetClass: '<',
    iconClass: '<',
    value: '<',
    filters: '<',
    prefix: '<',
    suffix: '<'
  },
  templateUrl:
    'app/commons/components/dashboard/dashboard-widget/dashboard-widget.tpl.html',
  controller: dashboardWidgetController
};

angular
  .module('dashboard-widget', ['dashboard-widget-value'])
  .component('dashboardWidgetComp', DashboardWidgetComponent);

dashboardHeaderController.$inject = ['$state'];
function dashboardHeaderController($state) {
  var ctrl = this;

  //Title of the box. [string]
  ctrl.titleText;
  //icons of the widget
  ctrl.icons;
  //Type of the dashboard to navigate to
  ctrl.dashboardType;
  //Id of the dashboard to navigate to
  ctrl.dashboardObjectId;

  //ctrl internal
  ctrl.goToDashboard = goToDashboard;

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('titleText', changes)) {
      ctrl.titleText = changes.titleText.currentValue;
    }

    if (valueChanged('icons', changes)) {
      ctrl.icons = changes.icons.currentValue || [];
    }

    if (valueChanged('dashboardType', changes)) {
      ctrl.dashboardType = changes.dashboardType.currentValue;
    }

    if (valueChanged('dashboardObjectId', changes)) {
      ctrl.dashboardObjectId = changes.dashboardObjectId.currentValue;
    }
  };

  function goToDashboard() {
    if (!!ctrl.dashboardType && !!ctrl.dashboardObjectId) {
      var routeParamIdName = getRouteParamIdName(ctrl.dashboardType);
      var routName = getRouteName(ctrl.dashboardType);

      if (!!routName && !!routeParamIdName) {
        var params = {};
        params[routeParamIdName] = ctrl.dashboardObjectId;
        $state.go(routName, params);
      }
    }
  }

  function getRouteParamIdName(dashboardType) {
    var paramIdNames = {
      fundraiser: 'fid',
      team: 'tid'
    };

    var newParamIdName = '';

    if (Object.keys(paramIdNames).indexOf(dashboardType) != -1) {
      newParamIdName = paramIdNames[dashboardType];
    }

    return newParamIdName;
  }

  function getRouteName(dashboardType) {
    var routeNames = {
      fundraiser: 'app.filter.fundraiser',
      teams: 'app.filter.teams',
      team: 'app.filter.team'
    };

    var newRouteName = '';

    if (Object.keys(routeNames).indexOf(dashboardType) != -1) {
      newRouteName = routeNames[dashboardType];
    }

    return newRouteName;
  }
}

var DashboardHeaderComp = {
  bindings: {
    titleText: '<',
    icons: '<',
    dashboardType: '<',
    dashboardObjectId: '<'
  },
  templateUrl:
    'app/commons/components/dashboard/dashboard-header/dashboard-header.tpl.html',
  controller: dashboardHeaderController
};

angular
  .module('dashboard-header', [])
  .component('dashboardHeaderComp', DashboardHeaderComp);

function dashboardController() {
  var ctrl = this;

  //Set of dashboards.
  ctrl.set;
  //Currency Symbol
  ctrl.currencySymbol;
  //language
  ctrl.lang;

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('set', changes)) {
      ctrl.set = changes.set.currentValue;
    }

    if (valueChanged('currencySymbol', changes)) {
      ctrl.currencySymbol = changes.currencySymbol.currentValue || [];
    }

    if (valueChanged('lang', changes)) {
      ctrl.lang = changes.lang.currentValue || [];
    }
  };
}

var DashboardComp = {
  bindings: {
    set: '<',
    currencySymbol: '<',
    lang: '<'
  },
  templateUrl: 'app/commons/components/dashboard/dashboard.tpl.html',
  controller: dashboardController
};

angular
  .module('dashboard', ['dashboard-header', 'dashboard-widget', 'breadcrumbs'])
  .component('dashboardComp', DashboardComp);

UserSettingsController.$inject = [
  '$scope',
  '$state',
  'AuthenticationService',
  'AuthenticationChannel',
  'FundraisersResource',
  'cachingService',
  'locationsService',
  '$rootScope',
  'AuthenticationSetConstant',
  '$window'
];
function UserSettingsController(
  $scope,
  $state,
  AuthenticationService,
  AuthenticationChannel,
  FundraisersResource,
  cachingService,
  locationsService,
  $rootScope,
  AuthenticationSetConstant,
  $window
) {
  var ctrl = this;
  ctrl.collapsed = true;

  ctrl.version = baseconfig.version;

  ctrl.state = {
    collapsed: true,
    user: {},
    mainUserId: 0,
    selectedLocation: ''
  };

  ctrl.$state = $state;

  ctrl.isRefreshing = false;
  ctrl.doRefresh = doRefresh;
  ctrl.doLogout = doLogout;
  ctrl.goTo = goTo;
  ctrl.allOptionsEnabled = allOptionsEnabled;
  ctrl.routeToNextTrainingcenter = routeToNextTrainingcenter;
  ctrl.routeToLocationSelect = routeToLocationSelect;
  ctrl.routeToLocationPermit = routeToLocationPermit;
  ctrl.canNavigateToLocationPermit = canNavigateToLocationPermit;
  ctrl.gamificationEnabled = gamificationEnabled;

  ctrl.authSets = AuthenticationSetConstant;

  ////////////

  init();

  ////////////////////

  function init() {
    ctrl.state.user = AuthenticationService.getCurrentUser();
    ctrl.state.location = locationsService.getSelectedLocation();
    ctrl.userToken = AuthenticationService.getTokenData('access_token');

    ctrl.hasGamification = false;
    if (
      'settings' in ctrl.state.user &&
      'has_gamification' in ctrl.state.user.settings
    ) {
      ctrl.hasGamification = ctrl.state.user.settings.has_gamification;
    }

    ctrl.hasNextTrainingCenter = false;
    if (
      'settings' in ctrl.state.user &&
      'has_fundraiser_quizzes' in ctrl.state.user.settings
    ) {
      ctrl.hasNextTrainingCenter =
        ctrl.state.user.settings.has_fundraiser_quizzes;
    }

    // Checks if the location tracking is enabled
    ctrl.hasLocationTracking = false;
    if (
      'settings' in ctrl.state.user &&
      'has_location_tracking' in ctrl.state.user.settings
    ) {
      ctrl.hasLocationTracking = ctrl.state.user.settings.has_location_tracking;
    }

    // Checks if the more sophisticated location module is enabled
    ctrl.hasLocationModule =
      'settings' in ctrl.state.user &&
      'has_location_module' in ctrl.state.user.settings
        ? ctrl.state.user.settings.has_location_module
        : false;

    AuthenticationChannel.pubAuthenticationConnectionStateUpdated(
      $scope,
      function() {
        ctrl.state.user = AuthenticationService.getCurrentUser();
        ctrl.userToken = AuthenticationService.getTokenData('access_token');
        ctrl.state.location = locationsService.getSelectedLocation();
      }
    );

    console.warn('user-settings $scope: ', $scope);
  }

  function goTo(link, params) {
    ctrl.$state.go(link, params);
    ctrl.state.collapsed = true;
  }

  function doLogout() {
    AuthenticationService.logout().finally(function() {
      // redirect to login either way
      AuthenticationService.redirectToLogin();
      ctrl.collapsed = true;
    });
  }

  function doRefresh() {
    ctrl.isRefreshing = true;
    FundraisersResource.self(true)
      .then(function(successData) {
        cachingService.clearAllCaches();
        location.reload(true);
      })
      .catch(function(error) {
        ctrl.debugRefresh = error;
      })
      .finally(function() {
        ctrl.isRefreshing = false;
        ctrl.collapsed = true;
      });
  }

  function allOptionsEnabled() {
    if (!locationsService.needsLocation()) {
      return true;
    }

    return $rootScope.selectedLocation || ctrl.state.location;
  }

  function gamificationEnabled() {
    var currentUser = ctrl.state.user;

    if (!allOptionsEnabled()) {
      return false;
    }

    return !('is_jobscout' in currentUser && currentUser.is_jobscout);
  }

  function routeToNextTrainingcenter() {
    $window.location.href = '/next/trainingcenter/';
  }

  function routeToLocationSelect() {
    if (locationsService.useNextLocationsCheckIn()) {
      var result = new URL('/next/locations/', location.href);
      result.searchParams.append('returnUrl', '/app/');
      navigateByUrl(result);
    } else {
      goTo('app.locationselect');
    }
  }

  function routeToLocationPermit() {
    if (locationsService.useNextLocationsCheckIn()) {
      routeToNextLocationPermit();
    } else {
      goTo('app.location-permit');
    }
  }

  function routeToNextLocationPermit() {
    // To open the location permit, there must be a selected location
    var selectedLocation = locationsService.getSelectedLocation();
    var id = (selectedLocation || {}).id;
    if (id === null || id === undefined) {
      return;
    }

    var result = new URL('/next/locations/' + id, location.href);
    result.searchParams.append('returnUrl', '/app/');
    navigateByUrl(result);
  }

  /**
   * @param {string|URL} newUrl Target to redirect to
   */
  function navigateByUrl(newUrl) {
    var result;
    if (typeof newUrl === 'string') {
      result = newUrl;
    } else if (newUrl instanceof URL) {
      result = _trimOriginFromUrl(newUrl);
    }

    window.location.href = result;
  }

  /**
   * @param {URL} url
   * @returns {string}
   */
  function _trimOriginFromUrl(url) {
    return url.href.substring(url.origin.length);
  }

  /**
   * Checks if the location permit can be opened.
   *
   * @returns {boolean} true if the location permit page can be opened.
   */
  function canNavigateToLocationPermit() {
    if (!allOptionsEnabled()) {
      return false;
    }

    var selectedLocation = locationsService.getSelectedLocation();
    var id = (selectedLocation || {}).id;
    return id !== null && id !== undefined;
  }
}

var userSettings = {
  bindings: {},
  templateUrl: 'app/commons/components/user-settings/user-settings.html',
  controller: UserSettingsController
};

angular.module('userSettings', []).component('userSettings', userSettings);

function BreadcrumbsController() {
  var ctrl = this;

  ctrl.breadcrumbs = [];

  ////////////////////

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('breadcrumbs', changes)) {
      ctrl.breadcrumbs = changes.breadcrumbs.currentValue;
    }
  };
}

var breadcrumbs = {
  bindings: {
    breadcrumbs: '<'
  },
  templateUrl: 'app/commons/components/breadcrumbs/breadcrumbs.html',
  controller: BreadcrumbsController
};

angular.module('breadcrumbs', []).component('breadcrumbs', breadcrumbs);

angular.module('common.components', [
  'qrCodeRenderer',
  'dashboard',
  'loadingSpinnerModule',
  'networkStatusBar',
  'disclaimerComp',
  'userSettings',
  'toast',
  'signaturePadInputModule',
  'summary'
]);

fontSizeToggle.$inject = ['FontSizeService', 'FontSizeChannel'];
function fontSizeToggle(FontSizeService, FontSizeChannel) {
  return {
    restrict: 'A',
    link: function($scope, element, attrs) {
      var bodyElem = document.getElementsByTagName('body')[0];
      var currentFontSize = FontSizeService.getCurrentFontSize();

      $scope.changeFontSize = changeFontSize;

      FontSizeChannel.subFontSizeChangedChanged($scope, fontSizeChangedHandler);

      /////////////////

      function fontSizeChangedHandler(newFontSize) {
        bodyElem.className = bodyElem.className
          .replace(currentFontSize, newFontSize)
          .trim();
        currentFontSize = newFontSize;
      }

      function changeFontSize(fontSize) {
        if (fontSize) {
          if (FontSizeService.fontSizes.indexOf(fontSize) != -1) {
            FontSizeService.setCurrentFontSize(fontSize);
          }
          return;
        }

        if (currentFontSize == FontSizeService.fontLarge) {
          FontSizeService.setCurrentFontSize(FontSizeService.fontSmall);
        } else if (currentFontSize == FontSizeService.fontMedium) {
          FontSizeService.setCurrentFontSize(FontSizeService.fontLarge);
        } else if (currentFontSize == FontSizeService.fontSmall) {
          FontSizeService.setCurrentFontSize(FontSizeService.fontMedium);
        }
      }
    }
  };
}

var FontSizeChannelConstant = {
  fontSizeChanged: 'fontSizeChanged'
};

FontSizeChannel.$inject = ['BaseChannel', 'FontSizeChannelConstant'];
function FontSizeChannel(BaseChannel, FontSizeChannelConstant) {
  //setup and return service
  var fontSizeChannel = {
    pubFontSizeChangedChanged: pubFontSizeChangedChanged,
    subFontSizeChangedChanged: subFontSizeChangedChanged
  };

  return fontSizeChannel;

  ////////////

  function pubFontSizeChangedChanged(fontSize) {
    BaseChannel.pubRootEmit(FontSizeChannelConstant.fontSizeChangedChanged, {
      fontSize: fontSize
    });
  }

  function subFontSizeChangedChanged($scope, scopeHandler) {
    BaseChannel.subRootEmit(
      FontSizeChannelConstant.fontSizeChangedChanged,
      $scope,
      scopeHandler,
      function(args) {
        return args.fontSize;
      }
    );
  }
}

FontSizeService.$inject = ['FontSizeChannel'];
function FontSizeService(FontSizeChannel) {
  var small = 'font-small',
    medium = 'font-medium',
    large = 'font-large';

  var currentFontSize = small;

  var fontSizeService = {
    fontSizes: [small, medium, large],
    fontSmall: small,
    fontMedium: medium,
    fontLarge: large,
    getCurrentFontSize: getCurrentFontSize,
    setCurrentFontSize: setCurrentFontSize
  };

  var bodyElem = document.getElementsByTagName('body')[0];
  init();

  return fontSizeService;

  ///////

  function init() {
    bodyElem.className = (bodyElem.className || '') + ' ' + currentFontSize;
  }

  function getCurrentFontSize() {
    return currentFontSize;
  }

  function setCurrentFontSize(newFontSize) {
    currentFontSize = newFontSize;
    FontSizeChannel.pubFontSizeChangedChanged(currentFontSize);
  }
}

angular
  .module('fontSize', [])
  .factory('FontSizeChannel', FontSizeChannel)
  .service('FontSizeService', FontSizeService)
  .directive('fontSizeToggle', fontSizeToggle)
  .constant('FontSizeChannelConstant', FontSizeChannelConstant);

angular.module('commons.fontSize.service', [
  'commons.fontSize.service',
  'commons.fontSize.channel'
]);

angular.module('fontSizeToggle.directive', []);

function gbPostCodeValidationDir() {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controller) {
      var that = this;
      //config section
      var dirName = 'gbPostCodeValidationDir';
      var countryFieldName = 'gbPostCodeValidationCountry';

      var form = controller[0];
      var ngModel = controller[1];

      var isActive = false;
      var dirActiveWatch;
      var watchers = [];

      addressCountry = '';

      dirActiveWatch = attrs.$observe(dirName, function(value) {
        value = !!parseInt(value);
        //check for change
        if (isActive !== value) {
          isActive = value;
          if (isActive) {
            activateDir();
          } else {
            deactivateDir();
          }
        }
      });

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      //For model -> DOM validation
      ngModel.$formatters.unshift(formatterFunction);

      //watch country attribute which changes dynamically

      ////////////////////////////////////////////

      function activateDir() {
        watchers.push(
          scope.$watch(
            function() {
              return getFormFieldValue(countryFieldName);
            },
            function(value) {
              addressCountry = value;
              validateInput(ngModel.$modelValue);
            }
          )
        );
      }

      function deactivateDir() {
        for (var i = 0; i < watchers.length; i++) {
          if (typeof watchers[i] === 'function') {
            watchers[i]();
          }
        }
      }

      ////////////////////////////////////////////////////

      function parseFunction(value) {
        validateInput(value);
        return value;
      }

      function formatterFunction(value) {
        validateInput(value);
        return value;
      }

      function validateInput(value) {
        var valid = true;

        ngModel.$setValidity('gbPostCode', true);

        if (isActive) {
          if (addressCountry === 'gb') {
            if (!isValidPostalCode(value)) {
              ngModel.$setValidity('gbPostCode', false);
              valid = false;
            }
          }
        }

        return valid;
      }

      /**
       *
       * Source: http://stackoverflow.com/questions/164979/uk-postcode-regex-comprehensive
       */
      function isValidPostalCode(value) {
        value = (value + '').replace(/ /g, '');

        //|----------------------------outward code------------------------------| |------inward code-----|
        //#special↓       α1        α2    AAN  AANA      AANN      AN    ANN    ANA (α3)        N         AA
        //^(GIR 0AA|[A-PR-UWYZ]([A-HK-Y]([0-9][A-Z]?|[1-9][0-9])|[1-9]([0-9]|[A-HJKPSTUW])?) [0-9][ABD-HJLNP-UW-Z]{2})$
        var pattern = /^(GIR0AA|[A-PR-UWYZ]([A-HK-Y]([0-9][A-Z]?|[1-9][0-9])|[1-9]([0-9]|[A-HJKPSTUW])?)[0-9][ABD-HJLNP-UW-Z]{2})$/;
        var isValid = false;

        isValid = pattern.test(value);

        return isValid;
      }

      function getFormFieldValue(fieldName) {
        var value = '';
        if (
          attrs[fieldName] &&
          form[attrs[fieldName]] &&
          '$modelValue' in form[attrs[fieldName]]
        ) {
          value = form[attrs[fieldName]].$modelValue;
        }

        return value;
      }
    }
  };
}

angular
  .module('gbPostCodeValidation-dir', [])
  .directive('gbPostCodeValidationDir', gbPostCodeValidationDir);

function gbPostCodeAreaValidationDir() {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controller) {
      //config section
      var dirName = 'gbPostCodeAreaValidationDir';
      var countryFieldName = 'gbPostCodeAreaValidationCountry';

      var form = controller[0];
      var ngModel = controller[1];

      var isActive = false;
      var dirActiveWatch;
      var watchers = [];

      var postalAreasArray = POSTAL_CODES_GB.data;
      var addressCountry = '';

      dirActiveWatch = attrs.$observe(dirName, function(value) {
        value = !!parseInt(value);

        //check for change
        if (isActive !== value) {
          isActive = value;
          if (isActive) {
            activateDir();
          } else {
            deactivateDir();
          }
        }
      });

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      //For model -> DOM validation
      ngModel.$formatters.unshift(formatterFunction);

      //watch country attribute which changes dynamically

      ////////////////////////////////////////////

      function activateDir() {
        //watch sourceCode attribute which changes dynamically
        watchers.push(
          scope.$watch(
            function() {
              return getFormFieldValue(countryFieldName);
            },
            function(value) {
              addressCountry = value;
              validateInput(ngModel.$modelValue);
            }
          )
        );
      }

      function deactivateDir() {
        for (var i = 0; i < watchers.length; i++) {
          if (typeof watchers[i] === 'function') {
            watchers[i]();
          }
        }
      }

      ////////////////////////////////////////////////////

      function parseFunction(value) {
        validateInput(value);
        return value;
      }

      function formatterFunction(value) {
        validateInput(value);
        return value;
      }

      function validateInput(value) {
        var valid = true;
        ngModel.$setValidity('gbPostArea', true);

        if (isActive) {
          if (addressCountry === 'gb') {
            value = (value + '').replace(/ /g, '');
            if (!isValidPostalArea(getLettersFromStart(value))) {
              ngModel.$setValidity('gbPostArea', false);
              valid = false;
            }
          }
        }

        return valid;
      }

      /**
       *
       * @param area
       * @returns {boolean}
       */
      function isValidPostalArea(area) {
        area = area.toUpperCase();
        var isValid = false;

        if (area) {
          var filteredArray = postalAreasArray.filter(function(item) {
            return item[0] === area;
          });

          isValid = filteredArray.length === 1;
        }

        return isValid;
      }

      function getLettersFromStart(str) {
        var onlyLettersFromStart = '';
        var isLetter = false;

        if (!str) {
          return '';
        }

        for (var i = 0; i < str.length; i++) {
          if (str[i].match(/[a-z,A-Z]/i)) {
            onlyLettersFromStart = onlyLettersFromStart + str[i];
          } else {
            return onlyLettersFromStart;
          }
        }
        return onlyLettersFromStart;
      }

      function getFormFieldValue(fieldName) {
        var value = '';
        if (
          attrs[fieldName] &&
          form[attrs[fieldName]] &&
          '$modelValue' in form[attrs[fieldName]]
        ) {
          value = form[attrs[fieldName]].$modelValue;
        }

        return value;
      }
    }
  };
}

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports'], factory);
  } else if (
    typeof exports === 'object' &&
    typeof exports.nodeName !== 'string'
  ) {
    // CommonJS
    factory(exports);
  } else {
    // Browser globals
    factory((root.POSTAL_CODES_GB = {}));
  }
})(this, function(exports) {
  /**
   * The array consists of Postcode area, Postcode area name, Code formation
   * Source: https://en.wikipedia.org/wiki/List_of_postcode_areas_in_the_United_Kingdom
   */
  const DATA = [
    //United Kingdom postcode areas
    ['AB', 'Aberdeen'],
    ['AL', 'St Albans'],
    ['B', 'Birmingham'],
    ['BA', 'Bath'],
    ['BB', 'Blackburn'],
    ['BD', 'Bradford'],
    ['BH', 'Bournemouth'],
    ['BL', 'Bolton'],
    ['BN', 'Brighton'],
    ['BR', 'Bromley'],
    ['BS', 'Bristol'],
    ['BT', 'Belfast'],
    ['CA', 'Carlisle'],
    ['CB', 'Cambridge'],
    ['CF', 'Cardiff'],
    ['CH', 'Chester'],
    ['CM', 'Chelmsford'],
    ['CO', 'Colchester'],
    ['CR', 'Croydon'],
    ['CT', 'Canterbury'],
    ['CV', 'Coventry'],
    ['CW', 'Crewe'],
    ['DA', 'Dartford'],
    ['DD', 'Dundee'],
    ['DE', 'Derby'],
    ['DG', 'Dumfries', 'Dumfries and Galloway'],
    ['DH', 'Durham'],
    ['DL', 'Darlington'],
    ['DN', 'Doncaster'],
    ['DT', 'Dorchester'],
    ['DY', 'Dudley'],
    ['E', 'East London'],
    ['EC', 'East Central London'],
    ['EH', 'Edinburgh'],
    ['EN', 'Enfield'],
    ['EX', 'Exeter'],
    ['FK', 'Falkirk'],
    ['FY', 'Blackpool', 'The Fylde'],
    ['G', 'Glasgow'],
    ['GL', 'Gloucester'],
    ['GU', 'Guildford'],
    ['HA', 'Harrow'],
    ['HD', 'Huddersfield'],
    ['HG', 'Harrogate'],
    ['HP', 'Hemel Hempstead'],
    ['HR', 'Hereford'],
    ['HS', 'Outer Hebrides', 'First and last letters of Hebrides'],
    ['HU', 'Hull'],
    ['HX', 'Halifax'],
    ['IG', 'Ilford', 'Possibly Ilford and Chigwell, or Ilford and Barking'],
    ['IP', 'Ipswich'],
    ['IV', 'Inverness'],
    ['KA', 'Kilmarnock'],
    ['KT', 'Kingston upon Thames'],
    ['KW', 'Kirkwall'],
    ['KY', 'Kirkcaldy'],
    ['L', 'Liverpool'],
    ['LA', 'Lancaster'],
    ['LD', 'Llandrindod Wells'],
    ['LE', 'Leicester'],
    ['LL', 'Llandudno'],
    ['LN', 'Lincoln'],
    ['LS', 'Leeds'],
    ['LU', 'Luton'],
    ['M ', 'Manchester'],
    ['ME', 'Rochester', 'Medway (now sometimes known as Maidstone)'],
    ['MK', 'Milton Keynes'],
    ['ML', 'Motherwell'],
    ['N', 'North London'],
    ['NE', 'Newcastle upon Tyne'],
    ['NG', 'Nottingham'],
    ['NN', 'Northampton'],
    ['NP', 'Newport'],
    ['NR', 'Norwich'],
    ['NW', 'North West London'],
    ['OL', 'Oldham'],
    ['OX', 'Oxford'],
    ['PA', 'Paisley'],
    ['PE', 'Peterborough'],
    ['PH', 'Perth'],
    ['PL', 'Plymouth'],
    ['PO', 'Portsmouth'],
    ['PR', 'Preston'],
    ['RG', 'Reading'],
    ['RH', 'Redhill'],
    ['RM', 'Romford'],
    ['S', 'Sheffield'],
    ['SA', 'Swansea'],
    ['SE', 'South East London'],
    ['SG', 'Stevenage'],
    ['SK', 'Stockport'],
    ['SL', 'Slough'],
    [
      'SM',
      'Sutton',
      'Possibly Sutton and Morden, the two post towns that are within the SM area'
    ],
    ['SN', 'Swindon'],
    ['SO', 'Southampton'],
    ['SP', 'Salisbury', 'Salisbury Plain'],
    ['SR', 'Sunderland'],
    ['SS', 'Southend-on-Sea'],
    ['ST', 'Stoke-on-Trent'],
    ['SW', 'South West London'],
    ['SY', 'Shrewsbury'],
    ['TA', 'Taunton'],
    ['TD', 'Galashiels', 'Tweeddale'],
    ['TF', 'Telford'],
    ['TN', 'Tunbridge Wells'],
    ['TQ', 'Torquay'],
    ['TR', 'Truro'],
    ['TS', 'Cleveland', 'Teesside'],
    ['TW', 'Twickenham'],
    ['UB', 'Southall', 'Uxbridge'],
    ['W', 'West London'],
    ['WA', 'Warrington'],
    ['WC', 'Western Central London'],
    ['WD', 'Watford'],
    ['WF', 'Wakefield'],
    ['WN', 'Wigan'],
    ['WR', 'Worcester'],
    ['WS', 'Walsall'],
    ['WV', 'Wolverhampton'],
    ['YO', 'York'],
    ['ZE', 'Lerwick', 'Zetland'],
    //Crown dependencies
    ['GY', 'Guernsey', ''],
    ['JE', 'Jersey', ''],
    ['IM', 'Isle of Man', ''],
    //Non-geographic postcodes
    ['GIR', '', ''],
    ['BF', '', ''],
    ['BX', '', '']
  ];

  /**
   * An object containing all the AT bank data.
   */
  exports.data = DATA;
});

angular
  .module('gbPostCodeAreaValidation-dir', [])
  .directive('gbPostCodeAreaValidationDir', gbPostCodeAreaValidationDir);

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports'], factory);
  } else if (
    typeof exports === 'object' &&
    typeof exports.nodeName !== 'string'
  ) {
    // CommonJS
    factory(exports);
  } else {
    // Browser globals
    factory((root.POSTAL_CODES_GB = {}));
  }
})(this, function(exports) {
  /**
   * The array consists of Postcode area, Postcode area name, Code formation
   * Source: https://en.wikipedia.org/wiki/List_of_postcode_areas_in_the_United_Kingdom
   */
  const DATA = [
    //United Kingdom postcode areas
    ['AB', 'Aberdeen'],
    ['AL', 'St Albans'],
    ['B', 'Birmingham'],
    ['BA', 'Bath'],
    ['BB', 'Blackburn'],
    ['BD', 'Bradford'],
    ['BH', 'Bournemouth'],
    ['BL', 'Bolton'],
    ['BN', 'Brighton'],
    ['BR', 'Bromley'],
    ['BS', 'Bristol'],
    ['BT', 'Belfast'],
    ['CA', 'Carlisle'],
    ['CB', 'Cambridge'],
    ['CF', 'Cardiff'],
    ['CH', 'Chester'],
    ['CM', 'Chelmsford'],
    ['CO', 'Colchester'],
    ['CR', 'Croydon'],
    ['CT', 'Canterbury'],
    ['CV', 'Coventry'],
    ['CW', 'Crewe'],
    ['DA', 'Dartford'],
    ['DD', 'Dundee'],
    ['DE', 'Derby'],
    ['DG', 'Dumfries', 'Dumfries and Galloway'],
    ['DH', 'Durham'],
    ['DL', 'Darlington'],
    ['DN', 'Doncaster'],
    ['DT', 'Dorchester'],
    ['DY', 'Dudley'],
    ['E', 'East London'],
    ['EC', 'East Central London'],
    ['EH', 'Edinburgh'],
    ['EN', 'Enfield'],
    ['EX', 'Exeter'],
    ['FK', 'Falkirk'],
    ['FY', 'Blackpool', 'The Fylde'],
    ['G', 'Glasgow'],
    ['GL', 'Gloucester'],
    ['GU', 'Guildford'],
    ['HA', 'Harrow'],
    ['HD', 'Huddersfield'],
    ['HG', 'Harrogate'],
    ['HP', 'Hemel Hempstead'],
    ['HR', 'Hereford'],
    ['HS', 'Outer Hebrides', 'First and last letters of Hebrides'],
    ['HU', 'Hull'],
    ['HX', 'Halifax'],
    ['IG', 'Ilford', 'Possibly Ilford and Chigwell, or Ilford and Barking'],
    ['IP', 'Ipswich'],
    ['IV', 'Inverness'],
    ['KA', 'Kilmarnock'],
    ['KT', 'Kingston upon Thames'],
    ['KW', 'Kirkwall'],
    ['KY', 'Kirkcaldy'],
    ['L', 'Liverpool'],
    ['LA', 'Lancaster'],
    ['LD', 'Llandrindod Wells'],
    ['LE', 'Leicester'],
    ['LL', 'Llandudno'],
    ['LN', 'Lincoln'],
    ['LS', 'Leeds'],
    ['LU', 'Luton'],
    ['M ', 'Manchester'],
    ['ME', 'Rochester', 'Medway (now sometimes known as Maidstone)'],
    ['MK', 'Milton Keynes'],
    ['ML', 'Motherwell'],
    ['N', 'North London'],
    ['NE', 'Newcastle upon Tyne'],
    ['NG', 'Nottingham'],
    ['NN', 'Northampton'],
    ['NP', 'Newport'],
    ['NR', 'Norwich'],
    ['NW', 'North West London'],
    ['OL', 'Oldham'],
    ['OX', 'Oxford'],
    ['PA', 'Paisley'],
    ['PE', 'Peterborough'],
    ['PH', 'Perth'],
    ['PL', 'Plymouth'],
    ['PO', 'Portsmouth'],
    ['PR', 'Preston'],
    ['RG', 'Reading'],
    ['RH', 'Redhill'],
    ['RM', 'Romford'],
    ['S', 'Sheffield'],
    ['SA', 'Swansea'],
    ['SE', 'South East London'],
    ['SG', 'Stevenage'],
    ['SK', 'Stockport'],
    ['SL', 'Slough'],
    [
      'SM',
      'Sutton',
      'Possibly Sutton and Morden, the two post towns that are within the SM area'
    ],
    ['SN', 'Swindon'],
    ['SO', 'Southampton'],
    ['SP', 'Salisbury', 'Salisbury Plain'],
    ['SR', 'Sunderland'],
    ['SS', 'Southend-on-Sea'],
    ['ST', 'Stoke-on-Trent'],
    ['SW', 'South West London'],
    ['SY', 'Shrewsbury'],
    ['TA', 'Taunton'],
    ['TD', 'Galashiels', 'Tweeddale'],
    ['TF', 'Telford'],
    ['TN', 'Tunbridge Wells'],
    ['TQ', 'Torquay'],
    ['TR', 'Truro'],
    ['TS', 'Cleveland', 'Teesside'],
    ['TW', 'Twickenham'],
    ['UB', 'Southall', 'Uxbridge'],
    ['W', 'West London'],
    ['WA', 'Warrington'],
    ['WC', 'Western Central London'],
    ['WD', 'Watford'],
    ['WF', 'Wakefield'],
    ['WN', 'Wigan'],
    ['WR', 'Worcester'],
    ['WS', 'Walsall'],
    ['WV', 'Wolverhampton'],
    ['YO', 'York'],
    ['ZE', 'Lerwick', 'Zetland'],
    //Crown dependencies
    ['GY', 'Guernsey', ''],
    ['JE', 'Jersey', ''],
    ['IM', 'Isle of Man', ''],
    //Non-geographic postcodes
    ['GIR', '', ''],
    ['BF', '', ''],
    ['BX', '', '']
  ];

  /**
   * An object containing all the AT bank data.
   */
  exports.data = DATA;
});

isValidFirstNameDir.$inject = ['CommonNames'];
function isValidFirstNameDir(CommonNames) {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controllers) {
      var isValidFirstName = parseInt(attrs.isValidFirstName);

      if (!isValidFirstName) {
        return;
      }

      var form = controllers[0];
      var ngModel = controllers[1];

      var warningMessage =
        attrs.validFirstNameWarningMessage ||
        'Salutation may not be correct for this name';

      scope.$watch(getTitleValue, function() {
        parseFunction(ngModel.$modelValue);
      });

      ngModel.$parsers.push(parseFunction);

      /////////////////////

      function parseFunction(first_name) {
        if (isValidFirstName) {
          var title = getTitleValue();
          var contentsOfFormGroupElem = angular
            .element(document.getElementById(ngModel.$name))
            .parent();
          var contentsOfFormGroupContents = contentsOfFormGroupElem.contents();
          var helpBlock = angular.element(
            contentsOfFormGroupContents[contentsOfFormGroupContents.length - 1]
          );

          var genderGuess = CommonNames.getGender(first_name).gender;
          var isValid = checkValidFirstName(genderGuess, title);

          if (!isValid && first_name) {
            contentsOfFormGroupElem.addClass('has-warning');
            helpBlock.text(warningMessage);
          } else {
            contentsOfFormGroupElem.removeClass('has-warning');
            helpBlock.text('');
          }
        }

        return first_name;
      }

      function getTitleValue() {
        var title = '';
        if (
          attrs.validFirstNameTitle &&
          attrs.validFirstNameTitle in form &&
          '$modelValue' in form[attrs.validFirstNameTitle]
        ) {
          title = form[attrs.validFirstNameTitle].$modelValue;
        }
        return title;
      }

      function checkValidFirstName(genderGuess, title) {
        if (genderGuess == undefined) {
          return true;
        }
        if (title == undefined) {
          return true;
        }

        title = title + '';

        var validTitlesFemale = [
          //Mrs
          '1',
          //Ms
          '5',
          //Miss
          '6'
        ];
        var validTitlesMale = [
          //Mr
          '0'
        ];
        var validTitlesForGenderValidation = validTitlesMale.concat(
          validTitlesFemale
        );

        var isValid = false;

        if (validTitlesForGenderValidation.indexOf(title) !== -1) {
          if (genderGuess == 'm' && validTitlesMale.indexOf(title) !== -1) {
            isValid = true;
          } else if (
            genderGuess == 'f' &&
            validTitlesFemale.indexOf(title) !== -1
          ) {
            isValid = true;
          }
        } else {
          // other ids ale always valid
          isValid = true;
        }

        return isValid;
      }
    }
  };
}

angular
  .module('is-valid-first-name-dir', [])
  .directive('isValidFirstNameDir', isValidFirstNameDir);

function formSettingsMenu() {
  return {
    restrict: 'E',
    scope: {
      state: '=',
      formId: '=',
      languages: '='
    },
    replace: true,
    templateUrl:
      'app/commons/directives/form-settings-menu/form-settings-menu.tpl.html',
    link: function($scope, element, attrs) {
      $scope.$ctrl = {};
      $scope.$ctrl.languages = $scope.languages;
      $scope.$ctrl.formId = $scope.formId;
      $scope.$ctrl.state = $scope.state;

      $scope.$ctrl.isOpen = false;

      $scope.$ctrl.toggleIsOpen = toggleIsOpen;

      /////////////////

      function toggleIsOpen() {
        $scope.$ctrl.isOpen = !$scope.$ctrl.isOpen;
      }
    }
  };
}

angular
  .module('formSettingsMenu', [])
  .directive('formSettingsMenu', formSettingsMenu);

/**
 * A directive for adding google places autocomplete to a text box
 * google places autocomplete info: https://developers.google.com/maps/documentation/javascript/places
 *
 * Usage:
 *
 * <input type="text"  ng-autocomplete ng-model="autocomplete" options="options" details="details/>
 *
 * + ng-model - autocomplete textbox value
 *
 * + details - more detailed autocomplete result, includes address parts, latlng, etc. (Optional)
 *
 * + options - configuration for the autocomplete (Optional)
 *
 *       + types: type,        String, values can be 'geocode', 'establishment', '(regions)', or '(cities)'
 *       + bounds: bounds,     Google maps LatLngBounds Object, biases results to bounds, but may return results outside these bounds
 *       + country: country    String, ISO 3166-1 Alpha-2 compatible country code. examples; 'ca', 'us', 'gb'
 *       + watchEnter:         Boolean, true; on Enter select top autocomplete result. false(default); enter ends autocomplete
 *
 * example:
 *
 *    options = {
 *        types: '(cities)',
 *        country: 'ca'
 *    }
 **/
ngAutocompleteDirective.$inject = ['geoLocationChannel'];
function ngAutocompleteDirective(geoLocationChannel) {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
      options: '=?',
      details: '=?',
      detailcb: '=',
      formIdToCopyIn: '=',
      formNameToCopyIn: '=',
      copyKeyToField: '='
    },

    link: function(scope, element, attrs, controller) {
      //options for autocomplete
      var opts;
      var watchEnter = false;
      var autocompleteService =
        typeof google !== 'undefined'
          ? new google.maps.places.AutocompleteService()
          : undefined;

      geoLocationChannel.subPositionUpdated(scope, function(pos) {
        var center = { lat: pos.coords.latitude, lng: pos.coords.latitude };
        var circle = new google.maps.Circle({
          center: center,
          radius: pos.coords.accuracy
        });
        scope.gPlace.setBounds(circle.getBounds());
      });

      //convert options provided to opts
      var initOpts = function() {
        opts = {};
        if (scope.options) {
          if (scope.options.watchEnter !== true) {
            watchEnter = false;
          } else {
            watchEnter = true;
          }

          if (scope.options.types) {
            opts.types = [];
            opts.types.push(scope.options.types);
            scope.gPlace.setTypes(opts.types);
          } else {
            scope.gPlace.setTypes([]);
          }

          if (scope.options.bounds) {
            opts.bounds = scope.options.bounds;
            scope.gPlace.setBounds(opts.bounds);
          } else {
            scope.gPlace.setBounds(null);
          }

          if (scope.options.country) {
            opts.componentRestrictions = {
              country: scope.options.country
            };
            scope.gPlace.setComponentRestrictions(opts.componentRestrictions);
          } else {
            scope.gPlace.setComponentRestrictions(null);
          }
        }

        if (scope.gPlace == undefined) {
          scope.gPlace = new google.maps.places.Autocomplete(element[0], {});
        }

        google.maps.event.addListener(
          scope.gPlace,
          'place_changed',
          function() {
            var result = scope.gPlace.getPlace();
            if (result !== undefined) {
              if (result.address_components !== undefined) {
                scope.$apply(function() {
                  scope.details = result;

                  scope.detailcb(
                    result,
                    scope.copyKeyToField,
                    scope.formIdToCopyIn,
                    scope.formNameToCopyIn
                  );
                  controller.$setViewValue(element.val());
                });
              } else {
                if (watchEnter) {
                  getPlace(result);
                }
              }
            }
          }
        );
      };

      //function to get retrieve the autocompletes first result using the AutocompleteService
      var getPlace = function(result) {
        if (result.name.length > 0) {
          autocompleteService.getPlacePredictions(
            {
              input: result.name,
              offset: result.name.length
            },
            function listentoresult(list, status) {
              if (list == null || list.length == 0) {
                scope.$apply(function() {
                  scope.details = null;
                });
              } else {
                var placesService = new google.maps.places.PlacesService(
                  element[0]
                );
                placesService.getDetails(
                  { reference: list[0].reference },
                  function detailsresult(detailsResult, placesServiceStatus) {
                    if (placesServiceStatus == google.maps.GeocoderStatus.OK) {
                      scope.$apply(function() {
                        controller.$setViewValue(
                          detailsResult.formatted_address
                        );
                        element.val(detailsResult.formatted_address);

                        scope.details = detailsResult;

                        //on focusout the value reverts, need to set it again.
                        var watchFocusOut = element.on('focusout', function(
                          event
                        ) {
                          element.val(detailsResult.formatted_address);
                          element.unbind('focusout');
                        });
                      });
                    }
                  }
                );
              }
            }
          );
        }
      };

      controller.$render = function() {
        var location = controller.$viewValue;
        element.val(location);
      };

      //watch options provided to directive
      scope.watchOptions = function() {
        return scope.options;
      };

      scope.$watch(
        scope.watchOptions,
        function() {
          if (typeof google !== 'undefined') {
            initOpts();
          }
        },
        true
      );
    }
  };
}

angular
  .module('ngAutocomplete', [])
  .directive('ngAutocompleteDirective', ngAutocompleteDirective);

toggleByProp.$inject = ['AuthenticationChannel', 'AuthenticationService'];
function toggleByProp(AuthenticationChannel, AuthenticationService) {
  return {
    restrict: 'A',

    link: function($scope, element, attrs) {
      $scope.user = AuthenticationService.getCurrentUser();

      var prevDisp = element.css('display'),
        //, userRoles = $scope.user.roles
        // , accessLevel
        toggleAction,
        prop = false;

      if (attrs.toggleAction !== 'hide' && attrs.toggleAction !== 'show') {
        toggleAction = 'hide';
      } else {
        toggleAction = attrs.toggleAction;
      }

      if (attrs.toggleByProp) {
        prop = attrs.toggleByProp;
      }

      currentUserUpdatedHandler($scope.user);
      AuthenticationChannel.subAuthenticationCurrentUserUpdated(
        $scope,
        currentUserUpdatedHandler
      );

      attrs.$observe('toggleByProp', function(al) {
        var parsed = [];
        if (al) {
          prop = $scope.$eval(al);
        }

        updateCSS();
      });

      ///////////////////////////////////////////////////

      //hide or shoe elem by toggleAction
      function updateCSS() {
        if (prop) {
          if (toggleAction == 'hide') {
            if (!AuthenticationService.isAuthorized(prop))
              element.css('display', 'none');
            else element.css('display', prevDisp);
          } else if (toggleAction == 'show') {
            if (!AuthenticationService.isAuthorized(prop))
              element.css('display', prevDisp);
            else element.css('display', 'none');
          }
        }
      }

      function currentUserUpdatedHandler(user) {
        $scope.user = user;
        updateCSS();
      }
    }
  };
}

angular
  .module('da.commons.directives.toggleByProp', [])
  .directive('toggleByProp', toggleByProp);

toggleBySet.$inject = ['AuthenticationChannel', 'AuthenticationService'];
function toggleBySet(AuthenticationChannel, AuthenticationService) {
  return {
    restrict: 'A',
    scope: {
      authSet: '='
    },

    link: function($scope, element, attrs) {
      $scope.user = AuthenticationService.getCurrentUser();

      var prevDisp = element.css('display'),
        //, userRoles = $scope.user.roles
        // , accessLevel
        toggleAction,
        propSet = false;

      if (attrs.toggleAction !== 'hide' && attrs.toggleAction !== 'show') {
        toggleAction = 'hide';
      } else {
        toggleAction = attrs.toggleAction;
      }

      if ($scope.authSet) {
        propSet = $scope.authSet;
      }

      currentUserUpdatedHandler($scope.user);
      AuthenticationChannel.subAuthenticationCurrentUserUpdated(
        $scope,
        currentUserUpdatedHandler
      );

      attrs.$observe('toggleBySet', function(al) {
        if (al) {
          propSet = $scope.$eval(al);
        }

        updateCSS();
      });

      //hide or shoe elem by toggleAction
      function updateCSS() {
        if (propSet) {
          if (toggleAction == 'hide') {
            if (!AuthenticationService.isAuthorized(propSet))
              element.css('display', 'none');
            else element.css('display', prevDisp);
          } else if (toggleAction == 'show') {
            if (!AuthenticationService.isAuthorized(propSet))
              element.css('display', prevDisp);
            else element.css('display', 'none');
          }
        }
      }

      function currentUserUpdatedHandler(user) {
        $scope.user = user;
        updateCSS();
      }
    }
  };
}

angular
  .module('da.commons.directives.toggleBySet', [])
  .directive('toggleBySet', toggleBySet);

userPanelDirective.$inject = [
  '$rootScope',
  'AuthenticationService',
  'AuthenticationChannel',
  '$state'
];
function userPanelDirective(
  $rootScope,
  AuthenticationService,
  AuthenticationChannel,
  $state
) {
  return {
    // restrict to an element type.
    restrict: 'E',
    replace: true,
    templateUrl: 'app/commons/directives/user-panel/user-panel.tpl.html',
    link: function(scope, element, attrs) {
      var fakeScope = $rootScope.$new();
      scope.statusInfo = {
        collapsed: true,
        user: false,
        mainUserId: 0
      };
      scope.statusInfo.mainUserId = AuthenticationService.getCurrentUser().id;

      scope.doLogout = doLogout;
      scope.setUserAsActive = setUserAsActive;

      init(attrs.noDropDown);

      function init(noDropDown) {
        if (noDropDown) {
          var activeUser =
            AuthenticationService.getCurrentUser() ||
            AuthenticationService.getActiveUser();
        } else {
          var activeUser = AuthenticationService.getActiveUser();
        }
        activeUserUpdatedHandler(activeUser);
        AuthenticationChannel.subAuthenticationActiveUserUpdated(
          fakeScope,
          activeUserUpdatedHandler
        );
      }

      function doLogout() {
        AuthenticationService.logout().finally(function(resp) {
          AuthenticationService.redirectToLogin();
        });
      }

      function setUserAsActive(userId) {
        AuthenticationService.setUserAsActive(userId);
        scope.statusInfo.collapsed = true;
      }

      function activeUserUpdatedHandler(user) {
        if (user) {
          scope.statusInfo.user = user;
        } else {
          scope.statusInfo.user =
            AuthenticationService.getActiveUser() ||
            AuthenticationService.getCurrentUser();
        }
        scope.statusInfo.team_members = AuthenticationService.getTeamMembers();
      }
    }
  };
}

angular
  .module('userPanel', [])
  .directive('userPanelDirective', userPanelDirective);

capitalizedDir.$inject = ['$filter'];
function capitalizedDir($filter) {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      //config section
      var dirName = 'capitalizedDir';
      var filterName = 'toCapitalized';
      var filterFunction = $filter(filterName);

      var isActive = false;

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      //For model -> DOM validation
      ngModel.$formatters.unshift(formatterFunction);

      var dirActiveWatch = scope.$watch(
        function() {
          return !!parseInt(attrs[dirName]);
        },
        function(value) {
          //check for change
          if (isActive !== value) {
            isActive = value;
          }
        }
      );

      ////////////////////////////////////////////

      function parseFunction(value) {
        var formatted = formatInput(value);
        return formatted;
      }

      function formatterFunction(value) {
        var formatted = formatInput(value);
        return formatted;
      }

      function formatInput(value) {
        if (isActive) {
          var transformedInput = angular.isString(value)
            ? filterFunction(value)
            : value;

          if (transformedInput !== value) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();
            value = transformedInput;
          }
        }
        return value;
      }
    }
  };
}

angular
  .module('capitalized-dir', [])
  .directive('capitalizedDir', capitalizedDir);

function uppercasedDir() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      //config section
      var dirName = 'uppercasedDir';

      var isActive = false;

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      //For model -> DOM validation
      ngModel.$formatters.unshift(formatterFunction);

      var dirActiveWatch = scope.$watch(
        function() {
          return !!parseInt(attrs[dirName]);
        },
        function(value) {
          //check for change
          if (isActive !== value) {
            isActive = value;
          }
        }
      );

      ////////////////////////////////////////////

      function parseFunction(value) {
        var formatted = formatInput(value);
        return formatted;
      }

      function formatterFunction(value) {
        var formatted = formatInput(value);
        return formatted;
      }

      function formatInput(value) {
        if (isActive) {
          var transformedInput = angular.isString(value)
            ? value.toUpperCase()
            : value;
          if (transformedInput !== value) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();
            value = transformedInput;
          }
        }

        return value;
      }
    }
  };
}

angular.module('uppercased-dir', []).directive('uppercasedDir', uppercasedDir);

trimWhitespaceDir.$inject = ['$filter'];
function trimWhitespaceDir($filter) {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      var activationAttributeName = 'trimmedWhitespace';
      var filterName = 'toTrimmedWhitespace';
      var isTrimmedWhitespaceAll = false;

      ///

      var isActive = false;
      var filterFunction = $filter(filterName);

      //watch isActive
      scope.$watch(attrs[activationAttributeName], function(value) {
        isActive = value !== undefined ? parseInt(value) === 1 : false;
        registerFunctions(isActive);
      });

      //watch isTrimmedWhitespaceAll
      scope.$watch(attrs['isTrimmedWhitespaceAll'], function(value) {
        isTrimmedWhitespaceAll =
          value !== undefined ? parseInt(value) === 1 : false;
      });

      /////////////////////////////////////7

      function registerFunctions(flag) {
        if (flag) {
          //For DOM -> model
          ngModel.$parsers.unshift(parseFunction);
          //For model -> DOM
          ngModel.$formatters.unshift(formatterFunction);
        }
      }

      function parseFunction(value) {
        return transform(value);
      }

      function formatterFunction(value) {
        return transform(value);
      }

      function transform(value) {
        if (isActive) {
          var transformedInput = angular.isString(value)
            ? filterFunction(value, isTrimmedWhitespaceAll)
            : value;
          if (transformedInput !== value) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();
          }
          return transformedInput;
        }
        return value;
      }
    }
  };
}

angular
  .module('trimWhitespace-dir', [])
  .directive('trimWhitespaceDir', trimWhitespaceDir);

formatE164Dir.$inject = ['$filter', 'formHelperFactory'];
function formatE164Dir($filter, formHelperFactory) {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controllers) {
      var form = controllers[0];
      var ngModel = controllers[1];

      var warningMessage = attrs.formatE164WarningMessage || 'Wrong number';
      var updateOnCountryChange = !!parseInt(attrs.updateOnCountryChange);
      var isFormatE164 = parseInt(attrs.isFormatE164);

      ngModel.$parsers.push(parseFunction);

      if (updateOnCountryChange) {
        scope.$watch(getCountryValue, reformatOnCountryChange);
      }

      ////////

      function getCountryValue() {
        var country = '';
        if (
          attrs.formatE164Country &&
          '$modelValue' in form[attrs.formatE164Country]
        ) {
          country = form[attrs.formatE164Country].$modelValue;
        }
        return country;
      }

      function reformatOnCountryChange(country) {
        ngModel.$setViewValue(formatE164(country, ngModel.$viewValue));
        ngModel.$render();
      }

      function parseFunction(value) {
        if (isFormatE164) {
          var lang;
          if (attrs.formatE164Country in form) {
            lang = form[attrs.formatE164Country].$modelValue;
          }

          var transformedInput = $filter('formatE164')(value, lang);
          if (transformedInput !== value) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();

            /*cursor jump bugfix*/
            formHelperFactory.focusEnd(attrs.id);
          }

          var contentsOfFormGroupElem = angular
            .element(document.getElementById(ngModel.$name))
            .parent();
          var contentsOfFormGroupContents = contentsOfFormGroupElem.contents();
          var helpBlock = angular.element(
            contentsOfFormGroupContents[contentsOfFormGroupContents.length - 1]
          );
          var isValid = isValidNumber(value);

          if (!isValid && value) {
            contentsOfFormGroupElem.addClass('has-warning');
            helpBlock.text(warningMessage);
          } else {
            contentsOfFormGroupElem.removeClass('has-warning');
            helpBlock.text('');
          }

          return transformedInput;
        }

        return value;
      }
    }
  };
}

angular.module('formatE164-dir', []).directive('formatE164Dir', formatE164Dir);

postrenderAction.$inject = ['$timeout'];
function postrenderAction($timeout) {
  // ### Directive Interface
  // Defines base properties for the directive.
  var directive = {
    restrict: 'A',
    priority: 101,
    link: link
  };
  return directive;

  // ### Link Function
  // Provides functionality for the directive during the DOM building/data binding stage.
  function link(scope, element, attrs) {
    $timeout(function() {
      scope.$evalAsync(attrs.postrenderAction);
    }, 0);
  }
}

angular
  .module('postrenderAction', [])
  .directive('postrenderAction', postrenderAction);

validSignatureDir.$inject = ['signatureConverter'];
function validSignatureDir(signatureConverter) {
  return {
    require: ['ngModel'],
    link: function(scope, element, attrs, controllers) {
      var ngModel = controllers[0];

      //config section
      var dirName = 'validSignatureDir';
      var isActive = false;

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      //For model -> DOM validation
      ngModel.$formatters.unshift(formatterFunction);

      var dirActiveWatch = scope.$watch(
        function() {
          return !!parseInt(attrs[dirName]);
        },
        function(value) {
          //check for change
          if (isActive !== value) {
            isActive = value;
          }
        }
      );

      function parseFunction(signatureData) {
        return validateSignatureData(signatureData) ? signatureData : null;
      }

      function formatterFunction(signatureData) {
        validateSignatureData(signatureData);
        return signatureData;
      }

      function validateSignatureData(signatureData) {
        var valid = true;
        var errorName = 'signatureDataValid';
        ngModel.$setValidity(errorName, valid);

        if (isActive && signatureData) {
          valid = signatureConverter.validateSignatureData(
            signatureData,
            baseconfig.signatureValidation.minLines,
            baseconfig.signatureValidation.minPoints
          );
          // invalidate
          if (!valid) {
            ngModel.$setValidity(errorName, valid);
          }
        }

        return valid;
      }
    }
  };
}

angular
  .module('valid-signature-dir', [])
  .directive('validSignatureDir', validSignatureDir);

function someOfValidDir() {
  return {
    require: ['^form', 'ngModel'],
    link: function(scope, element, attrs, controllers) {
      var errorName = 'someOfValid';
      //config section
      var dirName = 'someOfValidDir';
      var relatedFieldsNameAttr = 'someOfValidFields';
      var numOfMatchesAttr = 'someOfValidNumOfMatches';

      //
      var form = controllers[0];
      var ngModel = controllers[1];

      var watchers = [];

      var isActive = false;

      //For DOM -> model validation
      ngModel.$parsers.unshift(parseFunction);

      ngModel.$formatters.unshift(parseFunction);

      var dirActiveWatch = attrs.$observe(dirName, function(value) {
        value = !!parseInt(value);

        //check for change
        if (isActive !== value) {
          isActive = value;
          if (isActive) {
            activateDir();
          } else {
            deactivateDir();
          }
        }
      });

      ////////////////////////////////////////////

      function activateDir() {
        // perform initial validation on activation
        validateInput();

        //watch country attribute which changes dynamically
        var relatedFieldNames = attrs[relatedFieldsNameAttr].split(';');

        // all fields related to this validation
        relatedFieldNames
          // filter out actual field
          .filter(function(fieldName) {
            return fieldName !== ngModel.$name;
          })
          .forEach(function(fieldName) {
            // watch every other field for changes
            watchers.push(
              scope.$watch(
                // get value
                function() {
                  return getFormFieldValue(fieldName);
                },
                // check value
                function(newVal, oldVal) {
                  if (newVal !== oldVal) {
                    validateInput();
                  }
                }
              )
            );
          });
      }

      function deactivateDir() {
        for (var i = 0; i < watchers.length; i++) {
          if (typeof watchers[i] === 'function') {
            watchers[i]();
          }
        }
      }

      function parseFunction(value) {
        validateInput(value);
        return value;
      }

      function validateInput(value) {
        if (!isActive) {
          return;
        }

        // Get related field names and exclude this control
        var relatedFieldNames = attrs[relatedFieldsNameAttr]
          .split(';')
          .filter(function(key) {
            return key !== ngModel.$name;
          });

        var minRequiredFields = Math.min(
          parseInt(attrs[numOfMatchesAttr]) || 0,
          relatedFieldNames.length + 1 // add 1 bc current control is excluded
        );

        // Get all non-empty values
        var values = getRelatedValues(relatedFieldNames);
        if (!!ngModel.$viewValue) {
          values.push(ngModel.$viewValue);
        }

        // if not enough fields are filled and the actual field is not filled
        var isValid = values.length >= minRequiredFields;
        ngModel.$setValidity(errorName, isValid);

        if (isValid) {
          _cleanupSchemaFormError();
        }
      }

      /**
       * @param {string[]} relatedFieldsName
       * @returns {any[]}
       */
      function getRelatedValues(relatedFieldsName) {
        if (!angular.isArray(relatedFieldsName)) {
          return [];
        }

        return relatedFieldsName
          .map(function(fieldName) {
            return getFormFieldValue(fieldName);
          })
          .filter(function(v) {
            return !!v;
          });
      }

      function getFormFieldValue(fieldName) {
        var value = '';
        if (form[fieldName] && '$viewValue' in form[fieldName]) {
          value = form[fieldName].$viewValue;
        }
        return value;
      }

      /**
       * SchemaForm adds a validator that adds an error called
       * "schemaForm" in case that the control has any error.
       * Since we manually update the validity these validator
       * isn't called which leaves the "schemaForm" error pending
       * in the control errors.
       */
      function _cleanupSchemaFormError() {
        var SCHEMA_FORM_ERROR = 'schemaForm';
        var otherErrors = Object.keys(ngModel.$error);
        // Remove the "schemaForm" error in case that it is the
        // only remaining error for this control.
        if (
          otherErrors.length === 1 &&
          otherErrors.includes(SCHEMA_FORM_ERROR)
        ) {
          ngModel.$setValidity(SCHEMA_FORM_ERROR, true);
        }
      }
    }
  };
}

angular
  .module('someOfValid-dir', [])
  .directive('someOfValidDir', someOfValidDir);

angular.module('directives', [
  'fontSize',
  'formSettingsMenu',
  'ngAutocomplete',
  'userPanel',
  'da.commons.directives.toggleByProp',
  'da.commons.directives.toggleBySet',
  'capitalized-dir',
  'formatE164-dir',
  'is-valid-first-name-dir',
  'gbPostCodeValidation-dir',
  'gbPostCodeAreaValidation-dir',
  'uppercased-dir',
  'trimWhitespace-dir',
  'postrenderAction',
  'valid-signature-dir',
  'someOfValid-dir'
]);

AuthenticationChannel.$inject = [
  'BaseChannel',
  'AuthenticationChannelConstant'
];
function AuthenticationChannel(BaseChannel, AuthenticationChannelConstant) {
  //setup and return service
  var authenticationChannelService = {
    // login request
    pubAuthenticationLoginConfirmed: pubAuthenticationLoginConfirmed,
    subAuthenticationLoginConfirmed: subAuthenticationLoginConfirmed,
    pubAuthenticationLoginFailed: pubAuthenticationLoginFailed,
    subAuthenticationLoginFailed: subAuthenticationLoginFailed,

    // logout request
    pubAuthenticationLogoutConfirmed: pubAuthenticationLogoutConfirmed,
    subAuthenticationLogoutConfirmed: subAuthenticationLogoutConfirmed,
    pubAuthenticationLogoutFailed: pubAuthenticationLogoutFailed,
    subAuthenticationLogoutFailed: subAuthenticationLogoutFailed,

    // refreshConnection request
    pubAuthenticationRefreshConnectionConfirmed: pubAuthenticationRefreshConnectionConfirmed,
    subAuthenticationRefreshConnectionConfirmed: subAuthenticationRefreshConnectionConfirmed,
    pubAuthenticationRefreshConnectionFailed: pubAuthenticationRefreshConnectionFailed,
    subAuthenticationRefreshConnectionFailed: subAuthenticationRefreshConnectionFailed,

    // Connection state updated
    pubAuthenticationConnectionStateUpdated: pubAuthenticationConnectionStateUpdated,
    subAuthenticationConnectionStateUpdated: subAuthenticationConnectionStateUpdated,

    // Current user updated
    pubAuthenticationCurrentUserUpdated: pubAuthenticationCurrentUserUpdated,
    subAuthenticationCurrentUserUpdated: subAuthenticationCurrentUserUpdated,
    // Current user updated
    pubAuthenticationActiveUserUpdated: pubAuthenticationActiveUserUpdated,
    subAuthenticationActiveUserUpdated: subAuthenticationActiveUserUpdated
  };

  return authenticationChannelService;

  ////////////

  //Authentication login request functions

  /**
   * pubAuthenticationLoginConfirmed
   *
   * Publish the AuthenticationLoginConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationLoginConfirmed(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_loginConfirmed,
      args
    );
  }

  /**
   * subAuthenticationLoginConfirmed
   *
   * subscribe for the AuthenticationLoginConfirmed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationLoginConfirmed function
   * @param    {function} scopeHandler The callback handler for AuthenticationLoginConfirmed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationLoginConfirmed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_loginConfirmed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //###############

  /**
   * pubAuthenticationLoginFailed
   *
   * Publish the AuthenticationLoginConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationLoginFailed(args) {
    var args = { errors: args };

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_loginFailed,
      args
    );
  }

  /**
   * subAuthenticationLoginFailed
   *
   * subscribe for the AuthenticationLoginFailed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationLoginFailed function
   * @param    {function} scopeHandler The callback handler for AuthenticationLoginFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationLoginFailed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_loginFailed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //________________________________________________________________________________________________________________________________________

  //Authentication logout request functions

  /**
   * pubAuthenticationLogoutConfirmed
   *
   * Publish the AuthenticationLogoutConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationLogoutConfirmed(args) {
    var args = args;
    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_logoutConfirmed,
      args
    );
  }

  /**
   * subAuthenticationLogoutConfirmed
   *
   * subscribe for the AuthenticationLogoutConfirmed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationLogoutConfirmed function
   * @param    {function} scopeHandler The callback handler for AuthenticationLogoutConfirmed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationLogoutConfirmed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_logoutConfirmed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //###############

  /**
   * pubAuthenticationLogoutFailed
   *
   * Publish the AuthenticationLogoutConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationLogoutFailed(args) {
    var args = { errors: args };
    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_logoutFailed,
      args
    );
  }

  /**
   * subAuthenticationLogoutFailed
   *
   * subscribe for the AuthenticationLogoutFailed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationLogoutFailed function
   * @param    {function} scopeHandler The callback handler for AuthenticationLogoutFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationLogoutFailed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_logoutFailed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //__________________________________________________________________________________________________________________________________________

  //Authentication refresh connection request functions

  /**
   * pubAuthenticationRefreshConnectionConfirmed
   *
   * Publish the AuthenticationRefreshConnectionConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationRefreshConnectionConfirmed(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_refreshConnectionConfirmed,
      args
    );
  }

  /**
   * subAuthenticationRefreshConnectionConfirmed
   *
   * subscribe for the AuthenticationRefreshConnectionConfirmed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationRefreshConnectionConfirmed function
   * @param    {function} scopeHandler The callback handler for AuthenticationRefreshConnectionConfirmed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationRefreshConnectionConfirmed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_refreshConnectionConfirmed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //###############

  /**
   * pubAuthenticationRefreshConnectionFailed
   *
   * Publish the AuthenticationRefreshConnectionConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationRefreshConnectionFailed(args) {
    var args = { errors: args };

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_refreshConnectionFailed,
      args
    );
  }

  /**
   * subAuthenticationRefreshConnectionFailed
   *
   * subscribe for the AuthenticationRefreshConnectionFailed event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationRefreshConnectionFailed function
   * @param    {function} scopeHandler The callback handler for AuthenticationRefreshConnectionFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationRefreshConnectionFailed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_refreshConnectionFailed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //________________________________________________________________________________________________________________________________________

  /**
   * pubAuthenticationConnectionStateUpdated
   *
   * Publish the ConnectionStateUpdated updated event with given args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationConnectionStateUpdated(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_connectionStateUpdated,
      args
    );
  }

  /**
   * subAuthenticationConnectionStateUpdated
   *
   * subscribe for the ConnectionStateUpdated event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationConnectConfirmed function
   * @param    {function} scopeHandler The callback handler for AuthenticationConnectConfirmed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationConnectionStateUpdated(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_connectionStateUpdated,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //###############

  /**
   * pubAuthenticationCurrentUserUpdated
   *
   * Publish the CurrentUserUpdated event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationCurrentUserUpdated(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_currentUserUpdated,
      args
    );
  }

  /**
   * subAuthenticationCurrentUserUpdated
   *
   * subscribe for the CurrentUserUpdated event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationConnectFailed function
   * @param    {function} scopeHandler The callback handler for AuthenticationConnectFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationCurrentUserUpdated(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_currentUserUpdated,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //________________________________________________________________________________________________________________________________________

  //###############

  /**
   * pubAuthenticationActiveUserUpdated
   *
   * Publish the ActiveUserUpdated event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubAuthenticationActiveUserUpdated(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      AuthenticationChannelConstant.authentication_activeUserUpdated,
      args
    );
  }

  /**
   * subAuthenticationActiveUserUpdated
   *
   * subscribe for the ActiveUserUpdated event
   *
   * @param    {Object} _Scope The scope that calls the channels subAuthenticationConnectFailed function
   * @param    {function} scopeHandler The callback handler for AuthenticationConnectFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subAuthenticationActiveUserUpdated(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      AuthenticationChannelConstant.authentication_activeUserUpdated,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }
}

AuthenticationHttpInterceptor.$inject = ['$injector', '$q'];
function AuthenticationHttpInterceptor($injector, $q) {
  //setup and return service
  var intercepter = {
    request: doRequestConfiguration,
    responseError: doResponseError
  };

  return intercepter;

  ////////////

  /**
   * doRequestConfiguration
   *
   * Intercepts a request and sets the Accept attribute
   *
   * @param    {Object} config The requests config object
   *
   * @return  {Object} The edited config object
   *
   **/
  function doRequestConfiguration(config) {
    $injector.invoke([
      'ApiConstant',
      function(ApiConstant) {
        // "raisenow" is a bit more generic and will work
        // for live, staging and local environments
        if (
          !(typeof config.url === 'string') ||
          !config.url.startsWith(ApiConstant.system_instance)
        ) {
          return;
        }

        var token = false;

        $injector.invoke([
          'AuthenticationService',
          function(AuthenticationService) {
            token = AuthenticationService.getTokenData('access_token');
          }
        ]);

        if (token) {
          angular.extend(config.headers, {
            Authorization: 'Bearer ' + token
          });
        }
      }
    ]);
    return config;
  }

  function doResponseError(error) {
    var UserResourceConstant = $injector.get('UserResourceConstant');
    var ApiConstant = $injector.get('ApiConstant');
    var AuthenticationService = $injector.get('AuthenticationService');
    var $q = $injector.get('$q');
    var $state = $injector.get('$state');

    var tokenUrl =
      ApiConstant.system_instance + UserResourceConstant.actions.login;

    var refresh_token = AuthenticationService.getTokenData('refresh_token');

    if (error.status == 401 && error.config.url !== tokenUrl && refresh_token) {
      return AuthenticationService.refreshToken(refresh_token)
        .then(function() {
          return retryRequest(error.config);
        })
        .catch(function() {
          return $q.reject(error);
        });
    } else if (
      (error.status == 401 || error.status == 400) &&
      (error.config.url == tokenUrl || !refresh_token)
    ) {
      AuthenticationService.redirectToLogin({ enforce: true });
      return $q.reject(error);
    } else {
      return $q.reject(error);
    }
  }

  function retryRequest(httpConfig) {
    var $http = $injector.get('$http');
    return $http(httpConfig);
  }
}

AuthenticationService.$inject = [
  '$http',
  '$translate',
  'ApiConstant',
  'AuthenticationChannel',
  'UserResource',
  'FundraisersResource',
  '$localStorage',
  '$rootScope',
  '$q',
  '$state',
  '$window'
];
function AuthenticationService(
  $http,
  $translate,
  ApiConstant,
  AuthenticationChannel,
  UserResource,
  FundraisersResource,
  $localStorage,
  $rootScope,
  $q,
  $state,
  $window
) {
  var userIsConected = false,
    currentUser,
    activeUser,
    team_members = [],
    // time of last successful connection in ms
    lastConnectTime = 0,
    //auth token
    defaultUser = {
      id: 0,
      language: getLanguage(),
      is_active: false,
      is_coach: false,
      is_teamleader: false
    },
    currentUser = $localStorage.currentUser || defaultUser;

  //setup and return service
  var authenticationService = {
    isAuthorized: isAuthorized,

    refreshConnection: refreshConnection,

    login: login,
    refreshToken: refreshToken,
    logout: logout,

    getLastConnectTime: getLastConnectTime,
    getConnectionState: getConnectionState,

    getTokenData: getTokenData,
    persistTokenData: persistTokenData,
    deleteTokenData: deleteTokenData,

    getCurrentUser: getCurrentUser,
    setCurrentUser: setCurrentUser,
    setUserAsActive: setUserAsActive,
    getActiveUser: getActiveUser,
    getTeamMembers: getTeamMembers,
    redirectToLogin: redirectToLogin
  };

  return authenticationService;

  ////////////

  /**
   * isAuthorized
   *
   * @returns {Boolean} true if authorized false if not
   *
   */
  function isAuthorized(propOrSet) {
    var user = getCurrentUser();
    var isAuthorized = false;

    if (angular.isObject(propOrSet)) {
      //@TODO implement operation mode. For now everything is one of logic
      for (var propKey in propOrSet) {
        if (propOrSet.hasOwnProperty(propKey)) {
          if (propKey in user && user[propKey] == propOrSet[propKey].value) {
            isAuthorized = true;
          }
        }
      }
      return isAuthorized;
    } else {
      if (propOrSet == '*') {
        return true;
      }

      if (propOrSet) {
        if (propOrSet in user) {
          isAuthorized = user[propOrSet] ? true : false;
        }
        return isAuthorized;
      }
      return isAuthorized;
    }
  }

  /**
   * login
   *
   * Uses the login request of the user resource and saves session data on success
   *
   **/
  function login(loginData) {
    return UserResource.login(loginData)
      .then(
        //success
        function(responseData) {
          persistTokenData(responseData.data);
          setLastConnectTime(Date.now());
          setConnectionState(true);

          delete $localStorage.lastLocation;
          AuthenticationChannel.pubAuthenticationLoginConfirmed();
          return fetchCurrentUser();
          //return $q.resolve(responseData.data);
        }
      )
      .catch(function(responseError) {
        setConnectionState(false);
        if ('data' in responseError) {
          AuthenticationChannel.pubAuthenticationLoginFailed(
            responseError.data
          );
          return $q.reject(responseError.data);
        } else {
          AuthenticationChannel.pubAuthenticationLoginFailed();
          return $q.reject(responseError);
        }
      })
      .then(function(data) {
        AuthenticationChannel.pubAuthenticationLoginConfirmed(data);
        AuthenticationChannel.pubAuthenticationConnectionStateUpdated(true);
        return $q.resolve(true);
      })
      .catch(function(error) {
        return $q.reject(error);
      });
  }

  function refreshToken(refresh_token) {
    return UserResource.refreshToken(refresh_token).then(function(
      responseData
    ) {
      persistTokenData(responseData.data);
    });
  }

  /**
   * logout
   *
   * Uses the logout request of the user resource and deletes session data
   *
   **/
  function logout() {
    return UserResource.logout({
      token: getTokenData('access_token')
    })
      .then(
        //success
        function(responseData) {
          return $q.resolve({ success: true, response: responseData });
        }
      )
      .catch(
        // error
        function(responseError) {
          return $q.resolve({
            success: false,
            error:
              'status' in responseError && 'data' in responseError
                ? responseError.data
                : responseError
          });
        }
      )
      .then(function(result) {
        // Now do every additional cleanup that is needed on logout.
        var promises = [
          logoutFromAdmin(),
          deleteTokenData(),
          clearCacheStorage()
        ];

        // Either way, delete user data
        persistCurrentUser(defaultUser);
        setConnectionState(false);

        return $q.all(promises).then(function() {
          return $q.resolve(result);
        });
      })
      .then(function(result) {
        // Notify via channel
        if (result.success) {
          AuthenticationChannel.pubAuthenticationLogoutConfirmed();
          return $q.resolve(true);
        }

        AuthenticationChannel.pubAuthenticationLogoutFailed(result.error);
        return $q.reject(result.error);
      });
  }

  /**
   * Helper to logout from admin
   * @returns {Promise<boolean>}
   */
  function logoutFromAdmin() {
    var pathToList = ApiConstant.system_instance + 'admin/logout/',
      requestConfig = {
        url: pathToList,
        method: 'GET'
      };
    return $http(requestConfig)
      .then(function() {
        return true;
      })
      .catch(function() {
        return false;
      });
  }

  function refreshConnection() {
    var defer = $q.defer();

    setLastConnectTime(Date.now());
    setConnectionState(false);

    if (!getTokenData('access_token')) {
      defer.reject(false);
      return defer.promise;
    }

    fetchCurrentUser()
      .then(function(s) {
        setConnectionState(true);
        defer.resolve(true);
      })
      .catch(function() {
        defer.reject(false);
      });

    return defer.promise;
  }

  function getCurrentUser() {
    return currentUser;
  }

  function getTeamMembers() {
    return team_members;
  }

  function setCurrentUser(user) {
    currentUser = user;
    AuthenticationChannel.pubAuthenticationCurrentUserUpdated(currentUser);
  }

  function setUserAsActive(id) {
    setActiveUser(
      team_members.filter(function(user) {
        return user.id == id;
      })[0]
    );
  }

  function setActiveUser(user) {
    activeUser = user;
    AuthenticationChannel.pubAuthenticationActiveUserUpdated(activeUser);
  }

  function getActiveUser() {
    return activeUser;
  }

  /**
   * fetchCurrentUser
   *
   * Returns the current authenticated user
   *
   * @return {Object} user as JSON
   *
   **/
  function fetchCurrentUser() {
    var defer = $q.defer();

    FundraisersResource.self()
      .then(function(result) {
        if (result.data.is_superuser) {
          deleteTokenData();
          window.location = ApiConstant.system_instance + 'big_admin';
        } else if (result.data.is_admin) {
          deleteTokenData();
          window.location = ApiConstant.system_instance + 'admin';
        }
        persistCurrentUser(result.data);

        defer.resolve(result.data);
      })
      .catch(function(errorRequest) {
        //inactive user
        if ('status' in errorRequest && errorRequest.status == 404) {
          errorRequest.data = {};
          errorRequest.data.error = 'inactive_user';
          errorRequest.data.error_description = $translate.instant(
            'Your account has been deactivated.'
          );
        }

        if ('status' in errorRequest && errorRequest.status == 403) {
          errorRequest.data = {};
          errorRequest.data.error = 'forbidden';
          errorRequest.data.error_description = $translate.instant(
            'You are not allowed to perform this action.'
          );
        }

        defer.reject('data' in errorRequest ? errorRequest.data : errorRequest);
      });

    return defer.promise;
  }

  /**
   * persistCurrentUser
   *
   * Sets the current loggend in user
   *
   **/
  function persistCurrentUser(newUser) {
    setCurrentUser(newUser);
    $localStorage.currentUser = newUser;
    if (angular.isObject(newUser) && 'team_members' in newUser) {
      team_members = newUser.team_members;
    }

    if (newUser) {
      var lang = newUser.language ? newUser.language : getLanguage();
      lang = lang ? lang : '';
      $translate.use(lang);
    }
    AuthenticationChannel.pubAuthenticationCurrentUserUpdated(newUser);
  }

  function getLanguage() {
    var lang = 'en';
    try {
      var browserLang = navigator.language.split('-')[0];
      if (browserLang) {
        var languages = ['de', 'en'];
        if (languages.indexOf(browserLang) !== -1) {
          lang = browserLang;
        }
      }
    } catch (e) {
      //don't bubble up
    }

    return lang;
  }

  /**
   * getPersistedTokenData
   *
   * Returns the saved cookie data
   *
   * @return  {String} cookie data
   *
   **/
  function getTokenData(key) {
    if (!key) {
      if (angular.isObject($localStorage.tokenData)) {
        return $localStorage.tokenData;
      } else {
        return {};
      }
    } else if (
      angular.isObject($localStorage.tokenData) &&
      key in $localStorage.tokenData
    ) {
      return $localStorage.tokenData[key];
    }
  }

  /**
   * persistTokenData
   *
   * Saves the session id and name in service and cookies
   *
   *
   **/
  function persistTokenData(data, key) {
    if (key) {
      $localStorage.tokenData[key] = data;
    } else {
      //save data in service
      $localStorage.tokenData = data;
    }
  }

  /**
   * deleteTokenData
   *
   * Deletes the cookie from service and cookies
   *
   * @returns {Promise<boolean>}
   *
   **/
  function deleteTokenData() {
    var deferred = $q.defer();
    delete $localStorage.tokenData;
    // on next log in, the user should select the location again
    delete $localStorage.selectedLocation;
    delete $rootScope.selectedLocation;

    // Make sure that the token data is cleaned up, because
    // $localStorage seems to keep the data just a tiny bit longer.
    setTimeout(function() {
      deferred.resolve(true);
    }, 100);

    return deferred.promise;
  }

  /**
   * Deletes Cache Storages when user session ends.
   *
   * These caches are configured in Repo app `ngsw-config.json` and save APIs
   * using the Cache API.
   *
   * @returns {Promise<boolean[]>}
   */
  function clearCacheStorage() {
    var ngswCachesToClear = [
      /(session_cache)/,
      /(stale_while_revalidate)/,
      /(fallback_api)/
    ];

    return caches
      .keys()
      .then(function(keyList) {
        $q.all(
          keyList
            .filter(function(key) {
              return ngswCachesToClear.some(function(rx) {
                return rx.test(key);
              });
            })
            .map(function(key) {
              return caches.delete(key);
            })
        );
      })
      .catch(function() {
        return $q.resolve([]);
      });
  }

  /**
   * getConnectionState
   *
   * Returns the current authentication state as boolean
   *
   * @return {Boolean} state as boolesan
   *
   **/
  function getConnectionState() {
    return userIsConected;
  }

  /**
   * setConnectionState
   *
   * Sets the current state of connection as boolean
   *
   **/
  function setConnectionState(newState) {
    if (newState != userIsConected) {
      userIsConected = newState ? true : false;
      AuthenticationChannel.pubAuthenticationConnectionStateUpdated(
        userIsConected
      );
    }
  }

  /**
   * getLastConnectTime
   *
   * Returns the time of last successful connection in ms
   *
   * @return time in ms
   *
   **/
  function getLastConnectTime() {
    return lastConnectTime;
  }

  /**
   * setLastConnectTime
   *
   * Sets the time of last successful connection in ms
   *
   **/
  function setLastConnectTime(newTimeInMs) {
    var newTimeInMs = parseInt(newTimeInMs);
    if (newTimeInMs === NaN || newTimeInMs < 0) return;
    lastConnectTime = newTimeInMs;
  }

  /**
   * @param {object} [options] Redirect options
   * @param {boolean} [options.enforce=false] If `true`, connection state is hard reseted. Default is `false`
   */
  function redirectToLogin(options) {
    var opts = options || {};

    if (opts.enforce === true) {
      // Hard reset connection state to allow navigation
      setConnectionState(false);
    }

    // Make sure to clean up token data
    deleteTokenData().finally(function() {
      _redirectToLogin();
    });
  }

  function _redirectToLogin() {
    if (
      baseconfig.next.nextLogin === 'true' ||
      baseconfig.next.nextLogin === true
    ) {
      // let the new frontend figure out the redirect
      $window.location.href = '/';
    } else {
      $state.go('app.login');
    }
  }
}

angular
  .module('api.commons.authentication', [])
  .constant('AuthenticationSetConstant', {
    coach_or_shift: {
      is_coach: { value: true },
      has_workshift: { value: true }
    },
    jobscout_or_shift: {
      is_jobscout: { value: true },
      has_workshift: { value: true }
    },
    coach_or_teamleader: {
      is_coach: { value: true },
      is_teamleader: { value: true }
    },
    coach_or_teamleader_or_recruiter: {
      is_coach: { value: true },
      is_teamleader: { value: true },
      is_recruiter: { value: true }
    }
  })
  .constant('AuthenticationChannelConstant', {
    authentication_loginConfirmed: 'event:authService-loginConfirmed',
    authentication_loginFailed: 'event:authService-loginFailed',

    authentication_logoutConfirmed: 'event:authService-logoutConfirmed',
    authentication_logoutFailed: 'event:authService-logoutFailed',

    authentication_refreshConnectionConfirmed:
      'event:authService-refreshConnectionConfirmed',
    authentication_refreshConnectionFailed:
      'event:authService-refreshConnectionFailed',

    authentication_connectionStateUpdated:
      'event:authService-connectionStateUpdated',

    authentication_currentUserUpdated: 'event:authService-currentUserUpdated',
    authentication_activeUserUpdated: 'event:authService-activeUserUpdated'
  })
  .factory('AuthenticationService', AuthenticationService)
  .factory('AuthenticationHttpInterceptor', AuthenticationHttpInterceptor)
  .factory('AuthenticationChannel', AuthenticationChannel);

ApiRequestIntercepter.$inject = ['$injector', '$q'];
function ApiRequestIntercepter($injector, $q) {
  //setup and return service
  var intercepter = {
    request: request
  };

  return intercepter;

  ////////////

  //request function

  /**
   * request
   *
   * Intercepts a request and sets the request attribute
   * If the request url is o/token add Accept and Content-Type headers
   *
   * @param    {Object} config The requests config object
   *
   * @return  {Object} The edited config object
   *
   **/
  function request(config) {
    $injector.invoke([
      'ApiConstant',
      function(ApiConstant) {
        if (!config.url == ApiConstant.system_instance + 'o/token/') {
          config.headers['Accept'] = ApiConstant.responseFormat;
          config.headers['Content-Type'] = ApiConstant.responseFormat;
        }

        if (
          typeof config.url === 'string' &&
          config.url.startsWith(ApiConstant.system_instance)
        ) {
          config.headers['X-Requested-With'] = baseconfig.version;
        }
      }
    ]);

    return config;
  }
}

BaseChannel.$inject = ['$rootScope'];
function BaseChannel($rootScope) {
  var baseChannelService = {
    pubRootEmit: pubRootEmit,
    subRootEmit: subRootEmit
  };

  return baseChannelService;

  ////////////

  /**
   * subRootEmit
   *
   * subscribe for an event published over $rootScope.$emit(event, args)
   *
   * @param    {String} eventName The events name
   * @param    {Object} _Scope The scope that calls the channels subscribe function
   * @param    {function} scopeHandler The callback handler normally defined in the $scopes controller or directive or service
   * @param    {function} $mapArgs A mapper function to customize the given event arguments
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subRootEmit(eventName, _Scope, scopeHandler, mapArgs) {
    if (!scopeHandler && _Scope) {
      scopeHandler = _Scope;
      _Scope = $rootScope;
    }

    if (!mapArgs) {
      mapArgs = function(args) {
        return args;
      };
    }

    //subscribe with rootScope to event and cache unsubscribe function
    var unsubsSopeHandler = $rootScope.$on(eventName, function(event, args) {
      scopeHandler(mapArgs(args));
      safeApply();
    });

    //unsubscribe rootScope listener after scope destruction
    _Scope.$on('$destroy', function() {
      unsubsSopeHandler();
    });

    //return the unsubscribe function from the $rootScope.on() call
    return unsubsSopeHandler;
  }

  /**
   * pubRootEmit
   *
   * publish an event only to $rootScope
   *
   * @param    {String} eventName The events name
   * @param    {object} args The events arguments
   *
   **/
  function pubRootEmit(eventName, args) {
    $rootScope.$emit(eventName, args);
    safeApply();
  }

  function safeApply(fn) {
    var phase = $rootScope.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
      if (fn && typeof fn === 'function') {
        fn();
      }
    } else {
      $rootScope.$apply(fn);
    }
  }

  function safeApply(fn) {
    var phase = $rootScope.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
      if (fn && typeof fn === 'function') {
        fn();
      }
    } else {
      $rootScope.$apply(fn);
    }
  }
}

baseResource.$inject = ['$http', '$q'];
function baseResource($http, $q) {
  var baseResourceService = {
    request: request
  };

  return baseResourceService;

  ////////////

  /**
   * request
   *
   * generic function for a request
   *
   * @param {Object} data The requests data
   * @param {Object} requestConfig The requests url
   * @param {Function} pubError The requests error publish function
   * @param {Function} pubSuccess The requests success publish function
   *
   * @return {Promise} Promise of the retrieve request
   *
   */
  function request(requestConfig, pubError, pubSuccess) {
    var errors = [];

    if (errors.length != 0) {
      pubError(errors);
      return $q.reject(errors);
    }

    return $http(requestConfig)
      .then(function(responseData, status, headers, config) {
        if (pubSuccess && responseData.data) {
          pubSuccess(responseData);
        } else if (pubError) {
          responseData.data = {};
          responseData.data.error = 'offline';
          responseData.data.error_description = $translate.instant(
            'You are offline'
          );
          pubError(responseData);
        }
        return responseData;
      })
      .catch(function(responseError, status, headers, config) {
        if (pubError) {
          pubError(responseError);
        }
        // @TODO not sure if really needed to throw!!!
        throw responseError;
      });
  }
}

angular
  .module('api.commons', ['api.commons.authentication'])
  .constant('ApiConstant', {
    // Sites domain
    system_instance: baseconfig.system_instance,
    // Service endpoint (version)
    api_endpoint: 'api/',
    api_section: 'internal/',
    api_section_next: 'next/',
    base_url: this.system_instance + this.api_endpoint + this.api_section,
    //
    pca_predict: 'https://services.postcodeanywhere.co.uk/',
    pca_key: 'PA99-TB96-PC59-TH55',
    //response format of a request. possible values are
    responseFormat: 'application/json'
  })
  .factory('ApiRequestIntercepter', ApiRequestIntercepter)
  .factory('baseResource', baseResource)
  .factory('BaseChannel', BaseChannel);

AppConfigResource.$inject = [
  'baseResource',
  'ApiConstant',
  'AppConfigResourceConstant'
];
function AppConfigResource(
  baseResource,
  ApiConstant,
  AppConfigResourceConstant
) {
  //setup and return service
  var appConfigResourceService = {
    //Actions
    getAppConfig: getAppConfig
  };

  return appConfigResourceService;

  ////////////

  /**
   * getAppConfig
   *
   * get the appConfig
   *
   * Method: GER
   * Url: http://system_instance/api_endpoint/api_section/app-config/
   *
   * @return    {Promise}
   *
   **/
  function getAppConfig() {
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        AppConfigResourceConstant.resourcePath,
      requestConfig = {
        url: pathToCreate,
        method: 'GET'
      };

    return baseResource.request(requestConfig, null);
  }
}

angular
  .module('appConfig.resource', [])
  .constant('AppConfigResourceConstant', {
    //resource path
    resourcePath: 'app-config/',

    //actions of appConfig resource
    actions: {
      //create 			: ''
    }
  })
  .factory('AppConfigResource', AppConfigResource);

DonationsResource.$inject = [
  'baseResource',
  'ApiConstant',
  'DonationsResourceConstant',
  'DonationsRawResourceConstant'
];
function DonationsResource(
  baseResource,
  ApiConstant,
  DonationsResourceConstant,
  DonationsRawResourceConstant
) {
  //setup and return service
  var donationsResourceService = {
    //Actions
    create: create,
    createRaw: createRaw
  };

  return donationsResourceService;

  ////////////

  /**
   * Create a donation on the server (or in case of Next any type of form)
   * or patch an already existing Unfinished Donation.
   *
   * @param  {Object}   data the donation / form object
   * @param  {Boolean}  next if the form was filled out in next
   * @return {Promie}        for the network request
   */
  function create(data, next) {
    var apiSection = next
      ? ApiConstant.api_section_next
      : ApiConstant.api_section;

    var requestConfig;

    // When an Unfinished Donation is stored in localStorage,
    // the data on the server needs to be updated, by using
    // a `PUT` request.
    // An Unfinished Donation differs in that it already has
    // an `id`, generated when the first upload happened.
    if (next && data.id) {
      var pathToUpdate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        apiSection +
        DonationsResourceConstant.unfinishedDonationUpdate +
        data.id;

      requestConfig = {
        url: pathToUpdate,
        method: 'PUT',
        data: data,
        cache: false
      };
    } else {
      var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        apiSection +
        DonationsResourceConstant.resourcePath;

      requestConfig = {
        url: pathToCreate,
        method: 'POST',
        data: data,
        cache: false
      };
    }

    return baseResource.request(requestConfig);
  }

  /**
   * upload form data to a raw API endpoint without any validation
   * @param  {Object}   data the donation / form object
   * @return {Promie}        for the network request
   */
  function createRaw(data) {
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        DonationsRawResourceConstant.resourcePath,
      requestConfig = {
        url: pathToCreate,
        method: 'POST',
        data: data,
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('donations.resource', [])
  .constant('DonationsResourceConstant', {
    resourcePath: 'donations/',
    unfinishedDonationUpdate: 'unfinished_donations/',
    actions: {}
  })
  .constant('DonationsRawResourceConstant', {
    resourcePath: 'raw/',
    actions: {}
  })
  .factory('DonationsResource', DonationsResource);

FundraisersChannel.$inject = ['BaseChannel'];
function FundraisersChannel(BaseChannel) {
  var FundraisersChannelConstant = {
    fundraisersSelfConfirmed: 'fundraisersSelfConfirmed',
    fundraisersSelfFailed: 'fundraisersSelfFailed'
  };

  //setup and return service
  var fundraiserChannelService = {
    // self request
    pubFundraisersSelfConfirmed: pubFundraisersSelfConfirmed,
    subFundraisersSelfConfirmed: subFundraisersSelfConfirmed,
    pubFundraisersSelfFailed: pubFundraisersSelfFailed,
    subFundraisersSelfFailed: subFundraisersSelfFailed
  };

  return fundraiserChannelService;

  ////////////////////////

  //Authentication login request functions

  /**
   * pubFundraisersSelfConfirmed
   *
   * Publish the FundraisersSelfConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubFundraisersSelfConfirmed(args) {
    var args = args;

    BaseChannel.pubRootEmit(
      FundraisersChannelConstant.fundraisersSelfConfirmed,
      args
    );
  }

  /**
   * subFundraisersSelfConfirmed
   *
   * subscribe for the FundraisersSelfConfirmed event
   *
   * @param    {Object} _Scope The scope that calls the channels subFundraisersSelfConfirmed function
   * @param    {function} scopeHandler The callback handler for FundraisersSelfConfirmed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subFundraisersSelfConfirmed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      FundraisersChannelConstant.fundraisersSelfConfirmed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //###############

  /**
   * pubFundraisersSelfFailed
   *
   * Publish the FundraisersSelfConfirmed event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubFundraisersSelfFailed(args) {
    var args = { errors: args };

    BaseChannel.pubRootEmit(
      FundraisersChannelConstant.fundraisersSelfFailed,
      args
    );
  }

  /**
   * subFundraisersSelfFailed
   *
   * subscribe for the FundraisersSelfFailed event
   *
   * @param    {Object} _Scope The scope that calls the channels subFundraisersSelfFailed function
   * @param    {function} scopeHandler The callback handler for FundraisersSelfFailed event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subFundraisersSelfFailed(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      FundraisersChannelConstant.fundraisersSelfFailed,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }
}

FundraisersResource.$inject = [
  '$q',
  'baseResource',
  'ApiConstant',
  'FundraisersResourceConstant',
  'fundraisersChannel'
];
function FundraisersResource(
  $q,
  baseResource,
  ApiConstant,
  FundraisersResourceConstant,
  fundraisersChannel
) {
  //setup and return service
  var fundraisersResourceService = {
    //Actions
    onlineTest: onlineTest,
    list: list,
    retrieve: retrieve,
    retrieveStats: retrieveStats,
    self: self,
    selfStats: selfStats
  };

  return fundraisersResourceService;

  ////////////

  function onlineTest() {
    var deferred = $q.defer();

    var pathToList =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section,
      requestConfig = {
        url: pathToList,
        method: 'OPTIONS'
      };

    baseResource
      .request(requestConfig)
      .then(function(result) {
        deferred.resolve(true);
      })
      .catch(function(error) {
        if ('status' in error && error.status == -1) {
          deferred.reject(false);
        } else {
          deferred.resolve(true);
        }
      });
    return deferred.promise;
  }

  /**
   * list
   *
   * Returns a list of fundraisers
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/fundraisers/
   *
   * @return    {Promise}
   *
   **/
  function list() {
    var pathToList =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        FundraisersResourceConstant.resourcePath,
      requestConfig = {
        url: pathToList,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  /**
   * retrieve
   *
   * Returns the main data of the current logged in user
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/fundraisers/{ID}
   *
   * @param {Integer} id The id of the fundraiser to retrieve
   *
   * @return    {Promise}
   *
   **/
  function retrieve(data) {
    //undefined check
    data = data ? data : {};

    var pathToRetrieve =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        FundraisersResourceConstant.resourcePath +
        data.id,
      requestConfig = {
        url: pathToRetrieve,
        method: 'GET'
      },
      errors = [];

    if (!angular.isObject(data) || !angular.isDefined(data.id)) {
      errors.push('id is not defined');
    } else if (data.id <= 0) {
      errors.push('id have to be a positive integer');
    }

    if (errors.length > 0) {
      return $q.reject(errors);
    }

    return baseResource.request(requestConfig);
  }

  /**
   * retrieveStats
   *
   * Returns the main data of the current logged in user
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/fundraisers/{ID}/stats
   *
   * @param {Integer} id The id of the fundraiser to retrieveStats
   *
   * @return    {Promise}
   *
   **/
  function retrieveStats(data) {
    //undefined check
    data = data ? data : {};

    var pathToRetrieve =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        FundraisersResourceConstant.resourcePath +
        data.id +
        '/' +
        FundraisersResourceConstant.actions.retrieveStats,
      requestConfig = {
        url: pathToRetrieve,
        method: 'GET'
      },
      errors = [];

    if (!angular.isObject(data) || !angular.isDefined(data.id)) {
      errors.push('id is not defined');
    } else if (data.id <= 0) {
      errors.push('id have to be a positive integer');
    }

    if (errors.length > 0) {
      return $q.reject(errors);
    }

    return baseResource.request(requestConfig);
  }

  /**
   * self
   *
   * Returns the main data of the current logged in user
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/fundraisers/self
   *
   * @return    {Promise}
   *
   **/
  function self(noCache) {
    var deferred = $q.defer();

    var pathToSelf =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        FundraisersResourceConstant.resourcePath +
        FundraisersResourceConstant.actions.self,
      requestConfig = {
        url: pathToSelf,
        method: 'GET'
      };
    if (noCache) {
      requestConfig.cache = false;
    }

    baseResource
      .request(requestConfig)
      .then(function(response) {
        fundraisersChannel.pubFundraisersSelfConfirmed(response);
        deferred.resolve(response);
      })
      .catch(function(error) {
        fundraisersChannel.pubFundraisersSelfFailed(error);
        deferred.reject(error);
      });

    return deferred.promise;
  }

  //___________________________________________________________________________________________________

  /**
   * selfStats
   *
   * Returns the statistics for the user-dashboard of the current logged in user
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/fundraisers/self/stats
   *
   * @param  {Object} filter The filtervalue to apply.
   *                    - key date, value {String} date as [yyyy-MM-dd]
   *                    - key week, value {String} week as [yyyy-ww]
   *
   * @return    {Promise}
   *
   **/
  function selfStats(filter) {
    filter = filter ? filter : {};

    var params = false;

    if (filter.date) {
      params = 'date=' + filter.date;
    }

    if (filter.week) {
      params = 'year_weeknumber=' + filter.week;
    }

    var pathToSelfStats =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        FundraisersResourceConstant.resourcePath +
        FundraisersResourceConstant.actions.selfStats +
        (params ? '?' + params : ''),
      requestConfig = {
        url: pathToSelfStats,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('fundraisers.resource', [])
  .constant('FundraisersResourceConstant', {
    //resource path
    resourcePath: 'fundraisers/',
    //actions of fundraisers resource
    actions: {
      //list 			: ''
      //retrieve      : '{ID}',
      retrieveStats: /*{ID}/*/ 'stats/',
      self: 'self/',
      selfStats: 'self/stats/'
    }
  })
  .factory('fundraisersChannel', FundraisersChannel)
  .factory('FundraisersResource', FundraisersResource);

JobapplicationsResource.$inject = [
  'baseResource',
  'ApiConstant',
  'JobapplicationsResourceConstant'
];
function JobapplicationsResource(
  baseResource,
  ApiConstant,
  JobapplicationsResourceConstant
) {
  //setup and return service
  var jobapplicationsResourceService = {
    //Actions
    create: create
  };

  return jobapplicationsResourceService;

  ////////////

  function create(data) {
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        JobapplicationsResourceConstant.resourcePath,
      requestConfig = {
        url: pathToCreate,
        method: 'POST',
        data: data,
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('jobapplications.resource', [])
  .constant('JobapplicationsResourceConstant', {
    //resource path
    resourcePath: 'jobapplications/',

    //actions of jobapplications resource
    actions: {
      //create 			: ''
    }
  })
  .factory('JobapplicationsResource', JobapplicationsResource);

JobscoutsResource.$inject = [
  '$q',
  'baseResource',
  'ApiConstant',
  'JobscoutsResourceConstant'
];
function JobscoutsResource(
  $q,
  baseResource,
  ApiConstant,
  JobscoutsResourceConstant
) {
  //setup and return service
  var jobscoutsResourceService = {
    //Actions
    list: list,
    selfStats: selfStats
  };

  return jobscoutsResourceService;

  ////////////

  /**
   * list
   *
   * Returns a list of jobscouts
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/jobscouts/
   *
   * @return    {Promise}
   *
   **/
  function list() {
    var pathToList =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        JobscoutsResourceConstant.resourcePath,
      requestConfig = {
        url: pathToList,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  //___________________________________________________________________________________________________

  /**
   * selfStats
   *
   * Returns the statistics for the user-dashboard of the current logged in user
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/jobscouts/self/stats
   *
   * @param  {Object} filter The filtervalue to apply.
   *                    - key date, value {String} date as [yyyy-MM-dd]
   *                    - key week, value {String} week as [yyyy-ww]
   *
   * @return    {Promise}
   *
   **/
  function selfStats(filter) {
    filter = filter ? filter : {};

    var params = false;

    if (filter.date) {
      params = 'date=' + filter.date;
    }

    if (filter.week) {
      params = 'year_weeknumber=' + filter.week;
    }

    var pathToSelfStats =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        JobscoutsResourceConstant.resourcePath +
        JobscoutsResourceConstant.actions.selfStats +
        (params ? '?' + params : ''),
      requestConfig = {
        url: pathToSelfStats,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('jobscouts.resource', [])
  .constant('JobscoutsResourceConstant', {
    //resource path
    resourcePath: 'jobscouts/',
    //actions of jobscouts resource
    actions: {
      //list 			: ''
      selfStats: 'self/stats/'
    }
  })
  .factory('JobscoutsResource', JobscoutsResource);

PetitionsResource.$inject = [
  '$http',
  '$q',
  'baseResource',
  'ApiConstant',
  'PetitionsResourceConstant'
];
function PetitionsResource(
  $http,
  $q,
  baseResource,
  ApiConstant,
  PetitionsResourceConstant
) {
  //setup and return service
  var petitionsResourceService = {
    //Actions
    create: create
  };

  return petitionsResourceService;

  ////////////

  /**
   * create
   *
   * Creates a new petition
   *
   * @param data {Object} the data to post
   *              - id                    {String} offline_[Wed Dec 09 2015 14:29:35 GMT+0100 (CET)]
   *              - id_offline            {String} offline_[Wed Dec 09 2015 14:29:35 GMT+0100 (CET)]
   *              - campaign            {Number} The id of the actual campaign
   *              - id_fundraiser        {Number} The id of the actual logged in fundraiser !!!!NEW!!!!
   *              -    form_data            {Object} The formdata
   *              - form_data_sendmail    {Object}
   *                    - send_email:    {Boolean} To send email to ??? or not
   *              - form_data_qualityassessment {Object} qualityassesment data
   *              - form_data_signature {Object}
   *                    - signature {String} stringencoded html-svg Element
   *                     - form_data_sendmail    {Object} XXXduplicate dataXXXXXXX
   *                            - send_email:    {Boolean} To send email to ??? or not
   *
   * Method: POST
   * Url: http://system_instance/api_endpoint/api_section/petitions/
   *
   * @return    {Promise}
   *
   **/
  function create(data) {
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        PetitionsResourceConstant.resourcePath,
      requestConfig = {
        url: pathToCreate,
        method: 'POST',
        data: data,
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('petitions.resource', [])
  .constant('PetitionsResourceConstant', {
    //resource path
    resourcePath: 'petitions/',
    //actions of petitions resource
    actions: {
      //create 			: ''
    }
  })
  .factory('PetitionsResource', PetitionsResource);

SmsResource.$inject = ['baseResource', 'ApiConstant'];
function SmsResource(baseResource, ApiConstant) {
  //setup and return service
  var smsResourceService = {
    //Actions
    sms: sms
  };

  return smsResourceService;

  ////////////

  /**
   * create
   *
   * Creates a new donation
   *
   * @param data {Object} the data to post
   * - to {String}
   * - campaign_id {String}
   * - petition_campaign_id {String}
   * - recruiting_id {String}
   *
   * Method: POST
   * Url: http://system_instance/api_endpoint/api_section/sms/
   *
   * @return    {Promise}
   *
   **/
  function sms(data) {
    if (
      !data.campaign_id &&
      !data.petition_campaign_id &&
      !data.recruiting_id
    ) {
      throw new Error('No identifier given');
    }

    var pathToCreate =
      ApiConstant.system_instance +
      ApiConstant.api_endpoint +
      ApiConstant.api_section +
      'sms/';
    var requestConfig = {
      url: pathToCreate,
      method: 'POST',
      data: data,
      cache: false
    };

    return baseResource.request(requestConfig);
  }
}

angular.module('sms.resource', []).factory('SmsResource', SmsResource);

TimecaptureResource.$inject = [
  'baseResource',
  'ApiConstant',
  'TimecaptureResourceConstant'
];
function TimecaptureResource(
  baseResource,
  ApiConstant,
  TimecaptureResourceConstant
) {
  //setup and return service
  var timecaptureResourceService = {
    //Actions
    create: create
  };

  return timecaptureResourceService;

  ////////////

  function create(data) {
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        TimecaptureResourceConstant.resourcePath,
      requestConfig = {
        url: pathToCreate,
        method: 'POST',
        data: data,
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('timecapture.resource', [])
  .constant('TimecaptureResourceConstant', {
    //resource path
    resourcePath: 'timeentries/',
    //actions of timecapture resource
    actions: {
      //create 			: ''
    }
  })
  .factory('TimecaptureResource', TimecaptureResource);

UserResource.$inject = [
  '$q',
  'baseResource',
  'ApiConstant',
  'UserResourceConstant'
];
function UserResource($q, baseResource, ApiConstant, UserResourceConstant) {
  var client_id = 'Cb0lSfbm0xFvhmnHroexPr1SAZAyuy5HkPEra2qv';

  //setup and return service
  var userResourceService = {
    //Actions
    token: token,
    login: login,
    refreshToken: refreshToken,
    logout: logout,
    userStatus: userStatus
  };

  return userResourceService;

  ////////////

  /**
   * userStatus
   *
   * receives the a user ststus
   *
   * Method: POST
   * Url: http://system_instance/api_endpoint/user_status/
   *
   * @params  {Object} data The requests data
   *            @key @TODO write docs
   *
   * @return    {Promise}
   *
   **/
  function userStatus(data) {
    //undefined check
    data = data ? data : {};

    var pathToUserStatus =
        ApiConstant.system_instance /*+ ApiConstant.api_endpoint*/ +
        UserResourceConstant.actions.user_status,
      requestConfig = {
        url: pathToUserStatus,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  /**
   * login
   *
   * Login a user for a new session
   *
   * Method: POST
   * Url: http://system_instance/api_endpoint/user/login
   *
   * @params  {Object} data The requests data
   *            @key    {String} username A valid username, required:true, source:post body
   *            @key    {String} password A valid password, required:true, source:post body
   *
   * @return    {Promise}
   *
   **/
  function login(data) {
    //undefined check
    data = data ? data : {};

    data.username = data.username || '';
    data.password = data.password || '';
    data.client_id = client_id;
    data.grant_type = 'password';

    data = formatData(data);

    var pathToLogin =
        ApiConstant.system_instance + UserResourceConstant.actions.login,
      requestConfig = {
        url: pathToLogin,
        method: 'POST',
        data: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      };

    return baseResource.request(requestConfig).catch(function(errorRequest) {
      //connection refused
      if (errorRequest.status == -1 || errorRequest.status == 500) {
        errorRequest.data = {};
        errorRequest.data.error = 'invalid_grant';
        errorRequest.data.error_description = 'Service is not available.';
      }
      //invalid credentials
      if (errorRequest.status == 401 || errorRequest.status == 400) {
        errorRequest.data = {};
        errorRequest.data.error = 'invalid_grant';
        errorRequest.data.error_description =
          'Invalid credentials given. Check your username and password.';
      }
      //no server || wrong server url
      if (errorRequest.status == 404) {
        errorRequest.data = {};
        errorRequest.data.error = 'not_available';
        errorRequest.data.error_description =
          'Cannot establish internet connection. Please check your internet connection and try again.';
      } else if (errorRequest.status == 0) {
        //no internet
        errorRequest.data = {};
        errorRequest.data.error = 'not_available';
        errorRequest.data.error_description =
          'Cannot establish internet connection. Please check your internet connection and try again.';
      }

      return $q.reject(errorRequest);
    });
  }

  function refreshToken(refresh_token) {
    //undefined check
    var data = {};

    data.client_id = client_id;
    data.grant_type = 'refresh_token';
    data.refresh_token = refresh_token;

    data = formatData(data);

    var pathToLogin =
        ApiConstant.system_instance + UserResourceConstant.actions.login,
      requestConfig = {
        url: pathToLogin,
        method: 'POST',
        data: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      };

    return baseResource.request(requestConfig);
  }

  /**
   * logout
   *
   * Logout a user session
   *
   * Method: POST
   * Url: http://system_instance/o/revoke_token
   * @params  {Object} data The requests data
   *            @key    {String} token the token of the user to revoke
   * @return    {Promise}
   *
   **/
  function logout(data) {
    data = data || {};
    data.client_id = client_id;

    var pathToLogout =
        ApiConstant.system_instance + UserResourceConstant.actions.logout,
      requestConfig = {
        url: pathToLogout,
        method: 'POST',
        data: formatData(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      };

    return baseResource.request(requestConfig);
  }

  /**
   * token
   *
   * Returns the CSRF token of the current session.
   *
   * Method: POST
   * Url: http://system_instance/api_endpoint/user/token
   *
   * @return    {Promise}
   *
   **/
  function token() {
    var pathToToken =
        ApiConstant.system_instance + UserResourceConstant.actions.token,
      requestConfig = {
        url: pathToToken,
        method: 'POST'
      };

    return baseResource.request(requestConfig);
  }

  function formatData(jData) {
    var arrayOfKeyValueEqualGlued = [];
    angular.forEach(jData, function(v, k) {
      if (typeof v === 'string' || v instanceof String) {
        arrayOfKeyValueEqualGlued.push(
          k.toString() + '=' + encodeURIComponent(v.toString())
        );
      }
    });
    return arrayOfKeyValueEqualGlued.join('&');
  }
}

angular
  .module('user.resource', [])
  .constant('UserResourceConstant', {
    actions: {
      token: 'o/token/',
      login: 'o/token/',
      logout: 'o/revoke_token/',
      user_status: 'user_status/'
    }
  })
  .factory('UserResource', UserResource);

DashboardsResource.$inject = ['baseResource', 'ApiConstant'];
function DashboardsResource(baseResource, ApiConstant) {
  var resourcePath = 'dashboards';

  var resourceActions = {
    user: 'user',
    teams: 'teams'
  };

  //setup and return service
  var dashboardsResourceService = {
    getUser: getUser,
    getTeams: getTeams
  };

  return dashboardsResourceService;

  ////////////

  function getUser(filter) {
    var params = prepareFilter(filter);

    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        resourcePath +
        '/' +
        resourceActions.user +
        '/' +
        (params ? '?' + params : ''),
      requestConfig = {
        url: pathToCreate,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  function getTeams(filter) {
    var params = prepareFilter(filter);

    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        resourcePath +
        '/' +
        resourceActions.teams +
        ('team_id' in filter ? '/' + filter.team_id : '') +
        '/' +
        (params ? '?' + params : ''),
      requestConfig = {
        url: pathToCreate,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  ////////////////////////////////////////////////////////////

  function prepareFilter(filter) {
    filter = filter ? filter : {};
    var renderedParams = [];

    if (filter.timespan) {
      renderedParams.push(
        'date_from=' + filter.timespan.from,
        'date_to=' + filter.timespan.to
      );
    }

    if (filter.week) {
      renderedParams.push('year_weeknumber=' + filter.week);
    }

    return renderedParams ? renderedParams.join('&') : false;
  }
}

angular
  .module('dashboards.resource', [])
  .factory('dashboardsResource', DashboardsResource);

AchievementsResource.$inject = ['baseResource', 'ApiConstant'];
function AchievementsResource(baseResource, ApiConstant) {
  var resourcePath = 'achievements';

  var resourceActions = {
    check: 'check'
  };

  //setup and return service
  var achievementsResourceService = {
    getAll: getAll,
    checkNew: checkNew
  };

  return achievementsResourceService;

  ////////////

  function getAll() {
    // when working with local npm json server use
    // "http://localhost:3000/achievements";
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        resourcePath +
        '/',
      requestConfig = {
        url: pathToCreate,
        method: 'GET',
        cache: false
      };

    return baseResource.request(requestConfig);
  }

  function checkNew() {
    // when working with local npm json server use
    //"http://localhost:3000/check";
    var pathToCreate =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        resourcePath +
        '/' +
        resourceActions.check +
        '/',
      requestConfig = {
        url: pathToCreate,
        method: 'GET',
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('achievements.resource', [])
  .factory('achievementsResource', AchievementsResource);

VersionResource.$inject = ['baseResource', 'ApiConstant'];
function VersionResource(baseResource, ApiConstant) {
  //setup and return service
  var achievementsResourceService = {
    getVersion: getVersion
  };

  return achievementsResourceService;

  ////////////

  function getVersion() {
    // when working with local npm json server use
    // "http://localhost:3000/version.json";
    var pathToCreate = ApiConstant.system_instance + 'app/version.json',
      requestConfig = {
        url: pathToCreate,
        method: 'GET',
        cache: false,
        headers: {
          'Content-Type': 'application/json'
        }
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('version.resource', [])
  .factory('versionResource', VersionResource);

LeaderboardResource.$inject = [
  'baseResource',
  'ApiConstant',
  'LeaderboardResourceConstant'
];
function LeaderboardResource(
  baseResource,
  ApiConstant,
  LeaderboardResourceConstant
) {
  //setup and return service
  var leaderboardResourceService = {
    //Actions
    getJobReferrals: getJobReferrals,
    getSelf: getSelf
  };

  var url =
    ApiConstant.system_instance +
    ApiConstant.api_endpoint +
    ApiConstant.api_section +
    LeaderboardResourceConstant.resourcePath;

  return leaderboardResourceService;

  ////////////

  /**
   * get
   *
   * Get referrals leaderboard
   *
   * @param data {Object} the data to get
   *              - page = number of the actual page
   *              - date_from = Date as "1970-01-01"
   *              - date_to = Date as "2017-07-24"
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/leaderboard/job-referral
   *
   * @return    {Promise}
   *
   **/
  function getJobReferrals(data) {
    var params = [];
    if (data) {
      if (data.date_from) {
        params.push('date_from=' + moment(data.date_from).format('YYYY-MM-DD'));
      }
      if (data.date_to) {
        params.push('date_to=' + moment(data.date_to).format('YYYY-MM-DD'));
      }
      if (data.page) {
        params.push('page=' + data.page);
      }
    }
    var pathToCreate = url + '?' + params.join('&');
    requestConfig = {
      url: pathToCreate,
      method: 'GET',
      cache: false
    };

    return baseResource.request(requestConfig);
  }

  /**
   * get
   *
   * Get loged in user in referrals list
   *
   * @param data {Object} the data to get
   *              - date_from = Date as "1970-01-01"
   *              - date_to = Date as "2017-07-24"
   *
   * Method: GET
   * Url: http://system_instance/api_endpoint/api_section/leaderboard/job-referral/self
   *
   * @return    {Promise}
   *
   **/
  function getSelf(data) {
    var params = [];
    if (data) {
      if (data.date_from) {
        params.push('date_from=' + moment(data.date_from).format('YYYY-MM-DD'));
      }
      if (data.date_to) {
        params.push('date_to=' + moment(data.date_to).format('YYYY-MM-DD'));
      }
    }
    var pathToCreate =
        url + LeaderboardResourceConstant.actions.self + '?' + params.join('&'),
      requestConfig = {
        url: pathToCreate,
        method: 'GET',
        cache: false
      };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('leaderboard.resource', [])
  .constant('LeaderboardResourceConstant', {
    // resource path
    resourcePath: 'leaderboards/job-referrals/',
    actions: {
      //get
      self: 'self/'
    }
  })
  .factory('LeaderboardResource', LeaderboardResource);

PcaPredictResource.$inject = ['baseResource', 'ApiConstant'];
function PcaPredictResource(baseResource, ApiConstant) {
  var resourcePath =
    ApiConstant.pca_predict + 'BankAccountValidation/Interactive/';
  var resourceActions = {
    retrieve_by_sortcode: 'RetrieveBySortcode/v1.00/json3.ws%params',
    validation: 'Validate/v2.00/json3.ws%params'
  };

  //setup and return service
  var dashboardsResourceService = {
    validateSortCode: validateSortCode,
    validateAccountAndSortCode: validateAccountAndSortCode
  };

  return dashboardsResourceService;

  ////////////

  /**
   * validateSortCode
   *
   * Test it in browser console:
   * (function() {
   *   var $injector = angular.element(document.body).injector();
   *   var pcaPredictResource = $injector.get('pcaPredictResource');
   *   // works
   *   pcaPredictResource.validateSortCode({sortCode:'40-47-84'})
   *   // fails
   *   pcaPredictResource.validateSortCode({sortCode:'11-22-33'})
   * })()
   *
   *
   * @param params: {sortCode:string|number}
   */
  function validateSortCode(sortcodeParams) {
    var localToServerParamsMap = {
      sortCode: 'SortCode'
    };
    var preparedParams = mapPcaParams(sortcodeParams, localToServerParamsMap);
    var pathToCreate = (
        resourcePath +
        resourceActions.retrieve_by_sortcode +
        '/'
      ).replace('%params', '?' + preparedParams),
      requestConfig = {
        url: pathToCreate,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  /**
   * validateAccountAndSortCode
   *
   * (function() {
   *   var $injector = angular.element(document.body).injector();
   *   var pcaPredictResource = $injector.get('pcaPredictResource');
   *   // works
   *   pcaPredictResource.validateAccountAndSortCode({sortCode:'40-47-84', accountNumber:'70872490'})
   *   // fails
   *   pcaPredictResource.validateAccountAndSortCode({sortCode:'11-22-33', accountNumber:'11223344'})
   * })()
   * @param accountSortcodeParams: {sortCode:string|number, accountNumber:string|number}
   */
  function validateAccountAndSortCode(accountSortcodeParams) {
    var localToServerParamsMap = {
      accountNumber: 'AccountNumber',
      sortCode: 'SortCode'
    };
    var preparedParams = mapPcaParams(
      accountSortcodeParams,
      localToServerParamsMap
    );
    var pathToCreate = (
        resourcePath +
        '/' +
        resourceActions.validation +
        '/'
      ).replace('%params', '?' + preparedParams),
      requestConfig = {
        url: pathToCreate,
        method: 'GET'
      };

    return baseResource.request(requestConfig);
  }

  function mapPcaParams(paramsObj, paramsMap) {
    var params = [];
    params.push('Key=' + encodeURIComponent(ApiConstant.pca_key));

    for (var key in paramsMap) {
      if (key in paramsObj && paramsObj[key]) {
        params.push(paramsMap[key] + '=' + encodeURIComponent(paramsObj[key]));
      }
    }
    return params.join('&');
  }
}

angular
  .module('pca-predict.resource', [])
  .factory('pcaPredictResource', PcaPredictResource);

LocationsResource.$inject = [
  'baseResource',
  'ApiConstant',
  'LocationsResourceConstant'
];
function LocationsResource(
  baseResource,
  ApiConstant,
  LocationsResourceConstant
) {
  //setup and return service
  var locationsResourceService = {
    //Actions
    get: get,
    create: create,
    // Permit
    getPermitData: getPermitData,
    getPermitFile: getPermitFile
  };

  return locationsResourceService;

  ////////////

  function get(data) {
    var pathToGet =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        LocationsResourceConstant.resourcePath,
      requestConfig = {
        url: pathToGet,
        method: 'GET',
        cache: false
      };

    return baseResource.request(requestConfig);
  }

  function create(data) {
    var path =
        ApiConstant.system_instance +
        ApiConstant.api_endpoint +
        ApiConstant.api_section +
        LocationsResourceConstant.resourcePath,
      requestConfig = {
        url: path,
        method: 'POST',
        data: data,
        cache: false
      };

    return baseResource.request(requestConfig);
  }

  /**
   * @typedef {object} PermitResponse
   *
   * @property {string} url
   * The URL to the permit file
   */

  /**
   * @param {number} id The ID of the location
   *
   * @returns {Promise<PermitResponse>}
   * A promise that resolves with the permit information for the
   * location with the given `id`.
   */
  function getPermitData(id) {
    var path =
      ApiConstant.system_instance +
      ApiConstant.api_endpoint +
      ApiConstant.api_section +
      LocationsResourceConstant.resourcePath +
      LocationsResourceConstant.actions.permit;
    path = path.replace('{location_id}', id);

    var requestConfig = {
      url: path,
      method: 'GET',
      cache: false
    };

    return baseResource.request(requestConfig);
  }

  /**
   * @param {string} url URL to the permit file
   * @param {boolean} cached If the resource should be accessed cached or not
   */
  function getPermitFile(url, cached) {
    var requestConfig = {
      url: url,
      method: 'GET',
      cache: cached || false
    };

    return baseResource.request(requestConfig);
  }
}

/**
 * @typedef {object} LocationResource
 *
 * @property {number} id
 * The location id
 */

/**
 * @typedef {object} LocationPermit
 *
 * @property {string} url
 */

LocationsService.$inject = [
  '$q',
  '$localStorage',
  '$filter',
  'AuthenticationService',
  'offlineStore',
  'LocationsResource'
];
function LocationsService(
  $q,
  $localStorage,
  $filter,
  AuthenticationService,
  offlineStore,
  LocationsResource
) {
  //setup and return service
  var locationsService = {
    // List
    getList: getList,
    getListOffline: getListOffline,
    // Location
    getSelectedLocation: getSelectedLocation,
    setLocation: setLocation,
    // Permit
    getLocationPermitOffline: getLocationPermitOffline,
    getCurrentLocationPermitData: getCurrentLocationPermitData,
    // Others
    needsLocation: needsLocation,
    useNextLocationsCheckIn: useNextLocationsCheckIn
  };

  return locationsService;

  function getList() {
    return LocationsResource.get().then(function(res) {
      updateOfflineLocationList(res.data);
      return res;
    });
  }

  /**
   * @returns {LocationResource[]}
   */
  function getListOffline() {
    var locations = [];
    if (
      $localStorage.locationsList &&
      'locations' in $localStorage.locationsList
    )
      locations = $localStorage.locationsList.locations;

    return locations;
  }

  /**
   * @param {LocationResource[]} locations
   */
  function updateOfflineLocationList(locations) {
    $localStorage.locationsList = {
      locations: locations
    };
  }

  /**
   *
   * @param {LocationPermit} permitData
   */
  function updateOfflineLocationPermit(permitData) {
    $localStorage.locationPermit = permitData;
  }

  /**
   * @returns {LocationPermit | undefined}
   */
  function getLocationPermitOffline() {
    return $localStorage.locationPermit;
  }

  /**
   * @param {LocationResource} location
   */
  function setLocation(location) {
    // Update in location storage
    $localStorage.selectedLocation = location;

    var data = {
      location: location.id,
      createtime: $filter('date')(Date.now(), 'yyyy-MM-dd HH:mm:ss.sss')
    };

    var SetLocationPromise = offlineStore.savePersistFormData(
      data,
      offlineStore.getTypes()[4]
    );

    updateLocationPermit(location.id);

    return SetLocationPromise;
  }

  /**
   * @returns {LocationResource | undefined}
   */
  function getSelectedLocationOffline() {
    var selectedLocation = $localStorage.selectedLocation;
    return selectedLocation && selectedLocation.id !== undefined
      ? selectedLocation
      : undefined;
  }

  /**
   * @returns {LocationResource | undefined}
   */
  function getSelectedLocation() {
    if (needsLocation()) {
      return undefined;
    } else {
      return getSelectedLocationOffline();
    }
  }

  /**
   * @returns {Promise<LocationPermit>}
   */
  function getCurrentLocationPermitData() {
    if (!navigator.onLine) {
      return $q.resolve(getLocationPermitOffline());
    }

    var selectedLocation = getSelectedLocationOffline();
    if (!selectedLocation) {
      return $q.reject('no location selected');
    }

    return getPermitData(selectedLocation.id).catch(function(error) {
      var offlineData = getLocationPermitOffline();
      return offlineData ? $q.resolve(offlineData) : $q.reject(error);
    });
  }

  /**
   * @param {number} id The id of the location
   *
   * @returns {Promise<LocationPermit>}
   */
  function getPermitData(id) {
    return LocationsResource.getPermitData(id)
      .then(function(response) {
        /**
         * @type {LocationPermit}
         */
        var data = response.data;

        updateOfflineLocationPermit(data);
        return data;
      })
      .catch(function(error) {
        return $q.reject(error);
      });
  }

  /**
   * @param {string} id ID of the location for which the permit should be acquired
   *
   * @returns {Promise<LocationPermit>}
   */
  function updateLocationPermit(id) {
    // First, delete the current location permit
    delete $localStorage.locationPermit;

    // And try fetching updated data
    return (
      getPermitData(id)
        .then(function(data) {
          var permitUrl = data.url;

          return getPermitFile(permitUrl).then(function(permitResponse) {
            return data;
          });
        })
        // Not every location has permit data
        .catch(angular.noop)
    );
  }

  /**
   * @param {string} url URL to the permit file
   * @param {boolean} cached If the resource should be accessed cached or not
   */
  function getPermitFile(url, cached) {
    return LocationsResource.getPermitFile(url, cached);
  }

  /**
   * @returns {boolean | undefined}
   */
  function needsLocation() {
    var currentUser = AuthenticationService.getCurrentUser();

    if (!currentUser || !currentUser.settings) {
      return undefined;
    }
    if ('is_jobscout' in currentUser && currentUser.is_jobscout) {
      return false;
    }
    if (!currentUser.settings.has_location_tracking) {
      return false;
    }

    if (useNextLocationsCheckIn()) {
      return false;
    }

    return getSelectedLocationOffline() === undefined;
  }

  function useNextLocationsCheckIn() {
    var currentUser = AuthenticationService.getCurrentUser();

    if (!currentUser || !currentUser.settings) {
      return undefined;
    }

    // In order for the location check-in on next to be used
    // every campaign must be on next.
    return (currentUser.campaigns || []).every(function(c) {
      return c.use_next_form === true;
    });
  }
}

angular
  .module('locations.resource', [])
  .constant('LocationsResourceConstant', {
    // resource path
    resourcePath: 'locations/',
    // actions of locations resource
    actions: {
      // Replace location_id
      permit: '{location_id}/permit/'
    }
  })
  .factory('LocationsResource', LocationsResource)
  .factory('locationsService', LocationsService);

/**
 * @typedef {string} AnalyticsSlug
 * String, containing only lowercase letters, numbers, underscores or hyphens
 * Regex: /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/
 */
/**
 * @typedef {string} Timestamp
 * Datetime expressed using ISO-8601 (e.g. 2020-03-30T07:28:06+00:00)
 */
/**
 * @typedef {'click'} AnalyticsEventType
 * Type of the event
 */
/**
 * @typedef {object} ApiEventContext
 * Contextual information to the event
 *
 * @property {string | null} tag_name
 * The tag name which corresponds to the event
 *
 * @property {string | null} target_id
 * Optional id related to the event target
 *
 * @property {string | null} source_id
 * Optional id related to the event source
 *
 * @property {string | null} source_category
 * Category related to the event source
 */

/**
 * @typedef {object} ApiEventLocation
 * The location where an event occured
 *
 * @property {string} current
 * The current URL
 *
 * @property {string} referrer
 * Where the user came from within our app. Related to HTTP referer (sic!)
 */

/**
 * @typedef {object} ApiAnalyticsEvent
 *
 * @property {AnalyticsEventType} event_type
 * The type of event
 *
 * @property {AnalyticsSlug} name
 * Name of the event. Maximum length: 50
 *
 * @property {Timestamp} timestamp
 * Timestamp of the event
 *
 * @property {number} fundraiser
 * Identifier for the user (fundraiser id)
 *
 * @property {ApiEventContext} event_context
 * Event specific context
 *
 * @property {ApiEventLocation} event_location
 * Location information
 */

AnalyticsResource.$inject = [
  'baseResource',
  'ApiConstant',
  'AnalyticsResourceConstant'
];
function AnalyticsResource(
  baseResource,
  ApiConstant,
  AnalyticsResourceConstant
) {
  //setup and return service
  var analyticsResourceService = {
    createEvents: createEvents
  };

  return analyticsResourceService;

  ////////////

  /**
   * Ensures that the given value is a string or null
   *
   * @param {*} value The value
   *
   * @returns {string | null}
   */
  function ensureValue(value) {
    return value ? value.toString() : null;
  }

  /**
   * @param {AnalyticsEventContext} eventContext The context to adapt
   *
   * @returns {ApiEventContext}
   * An event context that can be interpreted by the API
   */
  function toApiEventContext(eventContext) {
    return {
      source_category: ensureValue(eventContext.sourceCategory),
      source_id: ensureValue(eventContext.sourceId),
      tag_name: ensureValue(eventContext.tagName),
      target_id: ensureValue(eventContext.targetId)
    };
  }

  /**
   * @param {AnalyticsEvent} event The event to adapt
   *
   * @returns {ApiAnalyticsEvent}
   * An event that can be interpreted by the API
   */
  function toApiEvent(event) {
    // IMPORTANT: Please be aware that the event mapping is tightly coupled
    // with the new frontend as both of them write in the same IDB.
    // So whenever you need to change something here, you are most likely
    // need to change it in the new frontend as well.
    return {
      name: event.name,
      event_type: event.eventType,
      timestamp: event.timestamp.toISOString(),
      fundraiser: event.fundraiser,
      event_location: event.eventLocation,
      event_context: toApiEventContext(event.eventContext)
    };
  }

  /**
   * @param {AnalyticsEvent | AnalyticsEvent[]} events The events to create
   *
   * @returns {Promise}
   */
  function createEvents(events) {
    var data = Array.isArray(events)
      ? events.map(toApiEvent)
      : toApiEvent(events);

    var apiSection = ApiConstant.api_section_next;
    var pathToCreate =
      ApiConstant.system_instance +
      ApiConstant.api_endpoint +
      apiSection +
      AnalyticsResourceConstant.resourcePath +
      AnalyticsResourceConstant.actions.trackEvent;
    var requestConfig = {
      url: pathToCreate,
      method: 'POST',
      data: data,
      cache: false
    };

    return baseResource.request(requestConfig);
  }
}

angular
  .module('analytics.resource', [])
  .constant('AnalyticsResourceConstant', {
    //resource path
    resourcePath: 'tracking/',
    //actions of analytics resource
    actions: {
      trackEvent: 'events/'
    }
  })
  .factory('AnalyticsResource', AnalyticsResource);

angular.module('api.resources', [
  'analytics.resource',
  'appConfig.resource',
  'donations.resource',
  'fundraisers.resource',
  'jobapplications.resource',
  'jobscouts.resource',
  'petitions.resource',
  'sms.resource',
  'timecapture.resource',
  'user.resource',
  'dashboards.resource',
  'achievements.resource',
  'version.resource',
  'leaderboard.resource',
  'pca-predict.resource',
  'locations.resource'
]);

angular.module('api', ['api.commons', 'api.resources']);

angular.module('common', [
  'api',
  'common.components',
  'directives',
  'filter',
  'modals',
  'form',
  'services'
]);

SummaryController.$inject = [
  'SummaryService',
  'AuthenticationService',
  'formHelperFactory',
  '$translate',
  '$filter'
];
function SummaryController(
  SummaryService,
  AuthenticationService,
  formHelperFactory,
  $translate,
  $filter
) {
  var ctrl = this;

  /**
   * rawData bound to donations.donationModel in donations.signature.view.html
   * rawDonation bound to donationsSignatureStep.actualDonation in donations.signature.view.html
   */
  ctrl.rawData;
  ctrl.rawDonation;
  ctrl.formWording;
  ctrl.currencySymbol;

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes) {
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      }
      return false;
    };

    if (valueChanged('rawData', changes)) {
      ctrl.rawData = changes.rawData.currentValue;
      if (ctrl.rawData && ctrl.rawDonation) {
        ctrl.summaryData = SummaryService.prepareData(
          ctrl.rawData,
          ctrl.rawDonation
        );
      }
    }

    if (valueChanged('rawDonation', changes)) {
      ctrl.rawDonation = changes.rawDonation.currentValue;
      if (ctrl.rawData && ctrl.rawDonation) {
        ctrl.summaryData = SummaryService.prepareData(
          ctrl.rawData,
          ctrl.rawDonation
        );
      }
    }

    if (valueChanged('formWording', changes)) {
      ctrl.formWording = SummaryService.prepareFormWording(
        changes.formWording.currentValue || {},
        ctrl.rawData,
        ctrl.rawDonation.form_config_gift_recipient &&
          ctrl.rawDonation.form_config_gift_recipient.form
      );
    }

    if (valueChanged('currencySymbol', changes)) {
      if (changes.rawData.currentValue.currencies)
        ctrl.currencySymbol = changes.rawData.currentValue.currencies;
      else ctrl.currencySymbol = changes.currencySymbol.currentValue || {};
    }
  };
}

/**
 * rawData bound to donations.donationModel in donations.signature.view.html
 * rawDonation bound to donationsSignatureStep.actualDonation in donations.signature.view.html
 */

var Summary = {
  bindings: {
    rawData: '<',
    rawDonation: '<',
    formWording: '<',
    currencySymbol: '<'
  },
  templateUrl: 'app/commons/components/summary/summary.html',
  controller: SummaryController
};

angular.module('summary', ['filter']).component('summary', Summary);

printSummaryController.$inject = [
  'SummaryService',
  'AuthenticationService',
  'formHelperFactory',
  '$translate'
];
function printSummaryController(
  SummaryService,
  AuthenticationService,
  formHelperFactory,
  $translate
) {
  var ctrl = this;

  ctrl.rawData;
  ctrl.rawDonation;
  ctrl.formWording;
  ctrl.currencySymbol;

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes) {
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      }
      return false;
    };

    if (valueChanged('rawData', changes)) {
      ctrl.rawData = changes.rawData.currentValue;
      if (ctrl.rawData && ctrl.rawDonation) {
        ctrl.summaryData = SummaryService.prepareData(
          ctrl.rawData,
          ctrl.rawDonation
        );
      }
    }

    if (valueChanged('rawDonation', changes)) {
      ctrl.rawDonation = changes.rawDonation.currentValue;
      if (ctrl.rawData && ctrl.rawDonation) {
        ctrl.summaryData = SummaryService.prepareData(
          ctrl.rawData,
          ctrl.rawDonation
        );
      }
    }

    if (valueChanged('formWording', changes)) {
      ctrl.formWording = SummaryService.prepareFormWording(
        changes.formWording.currentValue || {},
        ctrl.rawData,
        ctrl.rawDonation.form_config_gift_recipient &&
          ctrl.rawDonation.form_config_gift_recipient.form
      );
    }

    if (valueChanged('currencySymbol', changes)) {
      if (changes.rawData.currentValue.currencies)
        ctrl.currencySymbol = changes.rawData.currentValue.currencies;
      else ctrl.currencySymbol = changes.currencySymbol.currentValue || {};
    }
  };
}

// TODO: since this is very similar to the Summary component,
// consider combining both

var PrintSummary = {
  bindings: {
    rawData: '<',
    rawDonation: '<',
    formWording: '<',
    currencySymbol: '<'
  },
  templateUrl:
    'app/pages/donations/signature-step/print-summary/print-summary.html',
  controller: printSummaryController
};

angular
  .module('donations.print-summary', ['filter'])
  .component('printSummary', PrintSummary);

DonationsController.$inject = [
  '$localStorage',
  'AuthenticationService',
  '$translate',
  '$scope',
  '$stateParams',
  '$uibModal',
  '$filter',
  '$state',
  'offlineStore',
  'formHelperFactory',
  'actualDonation',
  'AnalyticsService',
  'analyticsEventFactory'
];
function DonationsController(
  $localStorage,
  AuthenticationService,
  $translate,
  $scope,
  $stateParams,
  $uibModal,
  $filter,
  $state,
  offlineStore,
  formHelperFactory,
  actualDonation,
  AnalyticsService,
  /**
   * @type {AnalyticsEventFactory}
   */
  analyticsEventFactory
) {
  var dateFilter = $filter('date');

  //viewmodel setup
  var vm = this;

  vm.configurableStyles = {};
  vm.configurableStyles.all = {};

  vm.stamp_image = '';
  //all data are collected in tis obj and filled in each step
  vm.donationModel = {};

  vm.donationForm;
  //form-settings-menu
  vm.custom_css = actualDonation.custom_css;
  vm.formId = actualDonation.id;
  //@TODO safely remove this
  vm.id = actualDonation.id;
  vm.baseState = 'app.donations.';
  vm.supported_languages = actualDonation.supported_languages;

  vm.donationForm_options = {};

  vm.resetForm = resetForm;

  init();

  ////////////////////////

  function init() {
    if (actualDonation !== false) {
      vm.configurableStyles.all = prepareStyles(actualDonation);
      vm.stamp_image = actualDonation.stamp_image;

      getFormOptions($stateParams)
        .then(function(options) {
          vm.donationForm_options = options;
        })
        .catch(angular.noop);
    } else {
      //@TODO create handling for this
      alert('form  not exist');
    }

    initSubscriptions();
  }

  function initSubscriptions() {
    $scope.$on('$stateChangeStart', function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (toState.name.indexOf('app.donations') === -1) {
        $translate.use(AuthenticationService.getCurrentUser().language);
      }
    });

    $scope.$on('$stateChangeStart', function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (toState.name.indexOf('app.donations') === -1) {
        $translate.use(AuthenticationService.getCurrentUser().language);
      }
    });
  }

  function getFormOptions(stateParams) {
    if ('lang' in stateParams && stateParams.lang) {
      return $translate
        .use(stateParams.lang)
        .then(function() {
          return {
            validationMessage: {
              302: $translate.instant('Required'),
              'autocomplete-required': $translate.instant('Required')
              //105 : $translate.instant("wrong number")
            }
          };
        })
        .catch(function() {
          return {};
        });
    }
  }

  function prepareStyles(donationObj) {
    var styles = {};

    if (donationObj.background_image) {
      styles['background-position'] = 'top';
      styles['background-image'] =
        "url('" + donationObj.background_image + "')";
    }

    if (donationObj.background_color !== '#000000') {
      styles['background-color'] = donationObj.background_color;
    }

    return styles;
  }

  function resetForm() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Reset form');
        },
        text: function() {
          return $translate.instant('Do you really want to reset the form?');
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result
      .then(function() {
        var promiseTrackEvent = AnalyticsService.trackEvent(
          analyticsEventFactory.click('campaign-form-clear')
        );

        //reset form model start
        offlineStore.deletePendingFormData();

        //reset form model start
        vm.donationModel = formHelperFactory.getDonationModel(
          actualDonation.form_config.model || {},
          {},
          actualDonation.form_config.schema.properties,
          actualDonation.form_config.form,
          $localStorage.lastLocation
        );

        var dateField = formHelperFactory.getFieldOfFormObj(
          actualDonation.form_config.form,
          'date_of_birth',
          true
        );
        dateField.date_day = '';
        dateField.date_month = '';
        dateField.date_year = '';

        //reset form
        vm.donationForm.$setPristine();
        $scope.$emit('resetForm', actualDonation);
        $state.go('app.donations.form');

        return promiseTrackEvent;
      })
      .catch(angular.noop);
  }
}

DonationsService.$inject = ['AuthenticationService', 'formHelperFactory'];

function DonationsService(AuthenticationService, formHelperFactory) {
  var service = {
    getDonation: getDonation
  };
  return service;

  ////////////

  function getDonation(donationId, language) {
    var donation = false,
      userData = AuthenticationService.getCurrentUser();

    if ('campaigns' in userData) {
      angular.forEach(userData.campaigns, function(v, k) {
        if (v.id == donationId) {
          donation = angular.copy(v);

          // When the campaign uses next forms we can stop here
          if (donation.use_next_form) {
            return;
          }

          /* START TRANSLATE CAMPAIGN */
          if (!(language in donation.supported_languages)) {
            language = Object.keys(donation.supported_languages)[0];
          }

          if ('form_wording' in donation && language in donation.form_wording) {
            donation.form_wording = donation.form_wording[language];
          }

          if ('form_config' in donation) {
            if ('form' in donation.form_config) {
              donation.form_config.form = donation.form_config.form[language];
            } else {
              donation.form_config.form = [];
            }
          }

          if ('form_config_qa' in donation) {
            if ('form' in donation.form_config_qa) {
              donation.form_config_qa.form =
                donation.form_config_qa.form[language];
            } else {
              donation.form_config_qa.form = [];
            }
          }

          if ('form_config_signature' in donation) {
            if ('form' in donation.form_config_signature) {
              donation.form_config_signature.form =
                donation.form_config_signature.form[language];
            } else {
              donation.form_config_signature.form = [];
            }
          }

          if ('form_config_gift_recipient' in donation) {
            if ('form' in donation.form_config_gift_recipient) {
              donation.form_config_gift_recipient.form =
                donation.form_config_gift_recipient.form[language];
            } else {
              donation.form_config_gift_recipient.form = [];
            }
          }

          if (
            'upload_modal_config' in donation &&
            language in donation.upload_modal_config
          ) {
            donation.upload_modal_config =
              donation.upload_modal_config[language];
          }

          /*START PREPARE CAMPAIGN */

          // add payment disclaimer
          var paymentDisclaimers = getPaymentDisclaimers(donation.form_config);
          donation.form_config = addPaymentDisclaimerToStep1(
            donation.form_config,
            paymentDisclaimers
          );
          donation.form_config_signature = addPaymentDisclaimerToStepSignature(
            donation.form_config_signature,
            paymentDisclaimers
          );
        }
      });
      return donation !== false ? donation : false;
    } else {
      return false;
    }
  }

  function getPaymentDisclaimers(step1Config) {
    var paymentMethods = formHelperFactory.getFieldOfFormObj(
      step1Config.form,
      'payment_method'
    );
    return paymentMethods.titleMap.filter(function(titleMap) {
      return angular.isObject(titleMap.disclaimer);
    });
  }

  function addPaymentDisclaimerToStep1(step1Config, paymentDisclaimers) {
    step1Config = angular.copy(step1Config);

    var disclaimerGroupIndex = -1;
    step1Config.form.find(function(item) {
      disclaimerGroupIndex++;
      return item.key === 'disclaimerStep1Keys';
    });

    paymentDisclaimers.forEach(function(titleMap) {
      var key = 'account_disclaimer_' + titleMap.value;
      var accountDisclaimerSchema = {
        required: false,
        type: 'string'
      };

      var accountDisclaimerFrom = {
        condition: function(xtc) {
          return (
            xtc.$parent.donations.donationModel.payment_method ===
            titleMap.value
          );
        },
        description: '',
        htmlClass: 'col-sm-12 disclaimer-box',
        imageUrl: titleMap.disclaimer.imageUrl,
        key: key,
        text: titleMap.disclaimer.text,
        type: 'disclaimer'
      };

      step1Config.schema.properties[key] = accountDisclaimerSchema;
      step1Config.form[disclaimerGroupIndex].items.push(accountDisclaimerFrom);
    });
    return step1Config;
  }

  function addPaymentDisclaimerToStepSignature(
    stepSignatureConfig,
    paymentDisclaimers
  ) {
    stepSignatureConfig = angular.copy(stepSignatureConfig);

    paymentDisclaimers.forEach(function(titleMap) {
      var key = 'sig_account_disclaimer_' + titleMap.value;
      var accountDisclaimerSchema = {
        required: false,
        type: 'string'
      };

      var accountDisclaimerForm = {
        condition: function(xtc) {
          return (
            xtc.$parent.donations.donationModel.payment_method ===
            titleMap.value
          );
        },
        description: '',
        htmlClass: 'col-sm-12 disclaimer-box',
        imageUrl: titleMap.disclaimer.imageUrl,
        key: key,
        text: titleMap.disclaimer.text,
        type: 'disclaimer'
      };
      stepSignatureConfig.schema.properties[key] = accountDisclaimerSchema;
      if (
        'form' in stepSignatureConfig &&
        angular.isArray(stepSignatureConfig.form) &&
        stepSignatureConfig.form[0] &&
        'items' in stepSignatureConfig.form[0]
      ) {
        stepSignatureConfig.form[0].items.push(accountDisclaimerForm);
      }
    });

    return stepSignatureConfig;
  }
}

DonationsFormController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$stateParams',
  '$filter',
  '$translate',
  '$uibModal',
  '$window',
  'formHelperFactory',
  'actualDonation',
  'offlineStore',
  '$localStorage',
  'AuthenticationService',
  'DonationsService',
  'AnalyticsService',
  'analyticsEventFactory',
  'NotificationsService'
];
function DonationsFormController(
  $scope,
  $timeout,
  $state,
  $stateParams,
  $filter,
  $translate,
  $uibModal,
  $window,
  formHelperFactory,
  actualDonation,
  offlineStore,
  $localStorage,
  AuthenticationService,
  DonationsService,
  AnalyticsService,
  /**
   * @type {AnalyticsEventFactory}
   */
  analyticsEventFactory,
  NotificationsService
) {
  var vm = this;

  vm.stepState = 'form';
  vm.header_image = '';
  vm.form_config = {};
  vm.has_amount_choices_per_age_group = false;
  vm.amount_choices_per_interval = undefined;
  vm.matchingAmountChoices = undefined;
  vm.currencyRate = 1; // the default currency conversion rate (EUR to EUR)
  vm.presentation = undefined;

  vm.goBack = goBack;
  vm.goToStart = goToStart;
  vm.goToNext = goToNext;
  vm.goToPresentation = goToPresentation;

  vm.registered;
  var cleanupFunctions = [];

  init(actualDonation);

  $scope.$on('$destroy', function() {
    // Call all registered cleanup functions
    cleanupFunctions.forEach(function(fn) {
      fn();
    });
  });

  $scope.$parent.$on('resetForm', function(event, actualDonation) {
    // this handler is called from the donations.controller.js
    // to hopefully mimic the effects of completely reset the form
    init(actualDonation);
  });

  //////////////////////////////////////////////////////////////////////////////////

  function init(donationObj) {
    if (donationObj.form_config) {
      vm.form_config = donationObj.form_config;

      var formConfigSchema =
        'schema' in donationObj.form_config &&
        'properties' in donationObj.form_config.schema &&
        angular.isObject(donationObj.form_config.schema.properties)
          ? donationObj.form_config.schema.properties
          : {};
      $scope.donations.donationModel = formHelperFactory.getDonationModel(
        donationObj.form_config.model || {},
        offlineStore.getPendingFormData() || {},
        formConfigSchema,
        vm.form_config.form,
        $localStorage.lastLocation
      );

      vm.has_amount_choices_per_age_group =
        donationObj.has_amount_choices_per_age_group;
      vm.amount_choices_per_interval = donationObj.amount_choices_per_interval;
      updateAmountChoicesForAge($scope.donations.donationModel);
      vm.user = AuthenticationService.getCurrentUser();

      // keep a copy of the original payment methods, because we're later deleting them when currencies don't support them
      if (!donationObj.allPaymentMethods) {
        donationObj.allPaymentMethods = formHelperFactory.getFieldOfFormObj(
          vm.form_config.form,
          'payment_method',
          false
        );
      }
      vm.allPaymentMethods = donationObj.allPaymentMethods;
      vm.paymentMethodsForCurrency = donationObj.paymentMethodsForCurrency;
      vm.paymentMethodsForInterval = donationObj.paymentMethodsForInterval;
      if (vm.form_config.model.currencies) {
        updateAmountChoicesCurrency(vm.form_config.model.currencies);
      }
      updatePaymentMethods($scope.donations.donationModel);
      vm.form_config.form = prepareForm(vm.form_config.form);

      if ('only_use_amount_selection' in donationObj) {
        vm.onlyUseAmountSelection = donationObj.only_use_amount_selection;
      }
      if ('currencyRate' in $scope.donations.donationModel) {
        vm.currencyRate = $scope.donations.donationModel.currencyRate;
      }
      // for now there can be only one presentation per campaign
      if ('presentation' in donationObj && donationObj.presentation) {
        vm.presentation = donationObj.presentation;
        initInactivityCheck(vm.presentation.inactive_threshold * 1000);
      }

      updateDonationAmountLabel();

      var sponsorship = updateSponsorship();
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Go back to dashboard');
        },
        text: function() {
          return $translate.instant(
            'If you go back, the form will lose data. Do you really want to do this?'
          );
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      //delete all pending formdata in local storage
      offlineStore.deletePendingFormData();
      $state.go('app.filter.home');
    });
  }

  function goToStart() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Go to start');
        },
        text: function() {
          return $translate.instant(
            'If you go back, the form will lose data. Do you really want to do this?'
          );
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      var events = [
        analyticsEventFactory.click('campaign-start-open'),
        analyticsEventFactory.click('conversation-end', { reason: 'abort' })
      ];

      return AnalyticsService.trackEvents(events).then(function() {
        //delete all pending formdata in local storage
        offlineStore.deletePendingFormData();
        $window.location.href = '/next/forms/' + actualDonation.id + '/start';
      });
    });
  }

  function goToNext(form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');
    form.$submitted = true;

    if (form.$valid) {
      // Then we check if the form is valid
      if ($scope.donations.donationModel.title != 3) {
        delete $scope.donations.donationModel.company_name;
      }
      // also persist the currency rate, otherwise validation will be wrong if someone goes back a page
      $scope.donations.donationModel.currencyRate = vm.currencyRate;

      setPaymentData();

      offlineStore.savePendingFormData($scope.donations.donationModel);

      if ($scope.donations.donationModel.gift_recipients_number) {
        // we first have to get the info of all the recipients
        $state.go('app.donations.gift', { recipientPage: 1 });
      } else {
        // no gift recipients, so proceed normally
        if (
          'skip' in actualDonation.form_config_qa &&
          actualDonation.form_config_qa.skip == true
        ) {
          $state.go('app.donations.signature');
        } else {
          $state.go('app.donations.qa');
        }
      }
    } else {
      $timeout(function() {
        var firstInvalidField = $('#donation form')
          .find('.ng-invalid:visible')
          .first();
        if (
          'offset' in firstInvalidField &&
          firstInvalidField.offset() &&
          'top' in firstInvalidField.offset()
        ) {
          $('html, body').animate(
            {
              scrollTop: firstInvalidField.offset().top - 30
            },
            100,
            function() {
              firstInvalidField.focus();
            }
          );
        }
      }, 100);
    }
  }

  function goToPresentation() {
    var campaignId = actualDonation.id;
    var presentationId = $scope.donationsFormStep.presentation.refid;

    offlineStore.savePendingFormData($scope.donations.donationModel);

    var event = analyticsEventFactory.click('presentation-open', {
      targetId: presentationId
    });
    AnalyticsService.trackEvent(event).then(function() {
      // route to the presentation in Next
      $window.location.href = '/next/forms/' + campaignId + '/presentation';
    });
  }

  //////HELPER

  function prepareForm(formObj) {
    formObj = angular.copy(formObj);
    // call this as early as possible to clean up the keys as arrays situation
    formHelperFactory.keysToString(formObj);

    //iterate fieldsets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate fieldset items
      angular.forEach(fieldset.items, function(item, k) {
        //prepare selects with default option
        if (item.type == 'select') {
          var field = actualDonation.form_config.schema.properties[item.key];
          // when select field is required
          // -> show validationMessage when empty option is selected
          if (item.key in actualDonation.form_config.schema.properties) {
            item.onChange = function(value) {
              formHelperFactory.validateRequired(field, item, vm);
            };
          }

          // when select field is not required
          // -> change type of select field to any, so the value can be set to `undefined` again.
          if (!('required' in field) || field.required == false) {
            field.type = 'any';
          }
        }

        switch (item.key) {
          //PERSON DATA SECTION
          case 'company_name':
            item.condition = 'donations.donationModel.title == 3';
            break;

          case 'first_name':
            item.capitalizedDir = 1;

            item.isValidFirstName = 1;
            item.validFirstNameTitle = 'title';
            item.validFirstNameWarningMessage = $translate.instant(
              'Salutation may not be correct for this name'
            );

            item.onChange = function(value) {
              if (
                isPaymentMethodWithBankData(
                  $scope.donations.donationModel.payment_method
                )
              ) {
                $scope.donations.donationModel.account_holder = saveConcatStrings(
                  $scope.donations.donationModel.first_name,
                  $scope.donations.donationModel.last_name
                );
              }
            };
            break;

          case 'last_name':
            item.capitalizedDir = 1;

            item.onChange = function() {
              if (
                isPaymentMethodWithBankData(
                  $scope.donations.donationModel.payment_method
                )
              ) {
                $scope.donations.donationModel.account_holder = saveConcatStrings(
                  $scope.donations.donationModel.first_name,
                  $scope.donations.donationModel.last_name
                );
              }
            };
            break;

          case 'email':
            item.$validators = {
              isemail: function(value) {
                return formHelperFactory.isValidEmail(value);
              }
            };

            item.validationMessage = {
              isemail: function(ctx) {
                return $translate.instant('This is no valid email');
              }
            };
            break;

          case 'contract_start_date':
            var field = actualDonation.form_config.schema.properties[item.key];
            item.$validators = {};
            item.validationMessage = {};
            if ('minimum' in field) {
              item.$validators['min'] = function(value) {
                return formHelperFactory.validateMinDate(
                  vm.form_config,
                  'contract_start_date',
                  value
                );
              };
              item.validationMessage['min'] = function(ctx) {
                return $translate.instant(
                  'The contract can not start before {{minimum}}.',
                  {
                    minimum: vm.form_config.schema.properties[item.key].minimum
                  }
                );
              };
            }
            break;
          case 'date_of_birth':
            item.onChange = function(value) {
              if (
                vm.has_amount_choices_per_age_group &&
                vm.amount_choices_per_interval
              ) {
                vm.age = moment.duration(Date.now() - value).years(); // age in years
                updateAmountChoicesForAge($scope.donations.donationModel);
              }
            };
            var field = actualDonation.form_config.schema.properties[item.key];
            formHelperFactory.configureDateOfBirthValidation(field, item, vm);
            break;

          //ADDRESS DATA SECTION
          case 'address_search':
            item.detailcb = formHelperFactory.copyValues;
            //@TODO fint better way with less params to get form model
            item.formIdToCopyIn = '#donation form';
            item.formNameToCopyIn = 'donationForm';
            break;

          case 'street':
            item.capitalizedDir = 1;
            break;

          case 'city':
            item.capitalizedDir = 1;
            break;

          case 'zip_code':
            item.uppercasedDir = 1;

            item.trimmedWhitespaceDir = 1;
            item.trimAllWhitespace = 1;

            item.gbPostCodeAreaValidationDir = 1;
            item.gbPostCodeAreaValidationCountry = 'country';

            item.gbPostCodeValidationDir = 1;
            item.gbPostCodeValidationCountry = 'country';

            item.validationMessage = {
              gbPostCode: function(ctx) {
                return $translate.instant('Wrong Post Code for UK');
              },
              gbPostArea: function(ctx) {
                return $translate.instant('Wrong Post Area for UK');
              }
            };

            break;

          case 'country':
            item.onChange = function(country) {
              $scope.donations.donationModel.account_country = formHelperFactory.getValueOfTitleMap(
                vm.form_config.form,
                'account_country',
                country,
                'value'
              );
              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);
            };
            break;

          //CONTACT DATA SECTION
          case 'phone_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;

            if (
              'contact_required_config' in vm.form_config &&
              vm.form_config.contact_required_config
            ) {
              item.someOfValidDir = 1;
              item.someOfValidFields = vm.form_config.contact_required_config.required.join(
                ';'
              );
              item.someOfValidNumOfMatches =
                vm.form_config.contact_required_config.min_count;

              item.validationMessage = {
                someOfValid: function(value) {
                  return $translate.instant('Phone number is required');
                }
              };
            }
            break;

          case 'mobile_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;

            if (
              'contact_required_config' in vm.form_config &&
              vm.form_config.contact_required_config
            ) {
              item.someOfValidDir = 1;
              item.someOfValidFields = vm.form_config.contact_required_config.required.join(
                ';'
              );
              item.someOfValidNumOfMatches =
                vm.form_config.contact_required_config.min_count;

              item.validationMessage = {
                someOfValid: function(value) {
                  return $translate.instant('Mobile number is required');
                }
              };
            }
            break;

          case 'contact_data_conf':
            // RadiosWithCustomDelete
            // value (bool) - do we collect contact information?
            item.onChange = function(value) {
              var updateKeys = ['email', 'phone_number', 'mobile_number'];
              for (var i = 0; i < updateKeys.length; ++i) {
                var key = updateKeys[i];
                // flip the input to disabled if no consent
                $('input#' + key).prop('disabled', !value);
                if (value === false && $scope.donations.donationModel[key]) {
                  // "No" was selected in the consent form, so make sure the contact data is cleared from the model
                  $scope.donations.donationModel[key] = '';
                }
              }
            };
            item.required = true;
            break;

          case 'send_sms':
            // Set the action for the sms button
            item.isSmsButton =
              actualDonation.form_config.model.enable_hlr_lookup === true
                ? 'hlr'
                : 'sms';

            //@TODO add smsButton prefix to all smsButton depending attributes
            item.targetFieldName = 'mobile_number';
            item.campaignId = actualDonation.id;
            item.campaignType = 'campaign';
            item.campaignLang = '';
            if (
              $stateParams &&
              angular.isObject($stateParams) &&
              'lang' in $stateParams
            ) {
              item.campaignLang = $stateParams.lang;
            }
            break;

          //SPONSORSHIP DATA SECTION
          case 'sponsorship':
            item.onChange = function(value) {
              updateSponsorship();
              $scope.donations.donationForm.donation_amount.$$parseAndValidate();
              $scope.donations.donationForm.donation_amount_alternative.$$parseAndValidate();
              $scope.donations.donationForm.direct_debit_interval.$$parseAndValidate();
            };
            break;

          case 'gift_recipients':
            item.condition = 'donations.donationModel.has_gift_recipients';
            item.onChange = function(value) {
              updateSponsorship(value);
              $scope.donations.donationForm.donation_amount.$$parseAndValidate();
              $scope.donations.donationForm.donation_amount_alternative.$$parseAndValidate();
              $scope.donations.donationForm.direct_debit_interval.$$parseAndValidate();
            };
            break;

          case 'currencies':
            item.onChange = function(value) {
              updateCurrency($scope.donations.donationModel);
              $scope.donations.donationForm.donation_amount.$$parseAndValidate();
              $scope.donations.donationForm.donation_amount_alternative.$$parseAndValidate();
              $scope.donations.donationForm.direct_debit_interval.$$parseAndValidate();
              $scope.donations.donationForm.payment_method.$$parseAndValidate();

              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);
            };
            break;
          case 'amount_choices':
            item.condition = function() {
              return (
                // hide the amount choices if no amount choices matching age was found
                !vm.has_amount_choices_per_age_group ||
                !!vm.matchingAmountChoices
              );
            };
            item.onChange = function(value) {
              var donationAmount = +value;
              $scope.donations.donationModel.donation_amount = donationAmount;
              $scope.donations.donationForm.donation_amount.$setViewValue(
                donationAmount
              );
              calcMonthlyYearly(
                'donation_amount',
                'donation_amount_alternative',
                donationAmount
              );
              $scope.donations.donationForm.donation_amount.$render();
              $scope.donations.donationForm.direct_debit_interval.$$parseAndValidate();
            };
            break;

          case 'donation_amount_alternative':
            if (vm.onlyUseAmountSelection) {
              item.readonly = true;
            }
            item.onChange = function(value) {
              calcMonthlyYearly(
                'donation_amount_alternative',
                'donation_amount',
                value
              );
              if ('payment_method' in $scope.donations.donationForm) {
                $scope.donations.donationForm.payment_method.$$parseAndValidate();
              }
            };

            item.$formatters = [];
            item.$formatters.push(toFixedComma);

            item.$validators = {
              min: function(value) {
                var isValid = false,
                  min_amount = false;
                //if sponsorship is selected min value is min_amount of selected sponsorship
                //get the titleMap of sponsorships
                var calculation_base = formHelperFactory.getFieldOfFormObj(
                  actualDonation.form_config.form,
                  'donation_amount_alternative'
                ).calculation_base;

                if ('sponsorship' in $scope.donations.donationModel) {
                  //validate against the selected sonsorship's min_amount value
                  min_amount = formHelperFactory.getValueOfTitleMap(
                    vm.form_config.form,
                    'sponsorship',
                    $scope.donations.donationModel.sponsorship,
                    'min_amount'
                  );
                } else {
                  min_amount = item.min_amount;
                }

                if (calculation_base == 'monthly') {
                  min_amount = getRealMinAmount(min_amount) / 12;
                } else {
                  min_amount = getRealMinAmount(min_amount, calculation_base);
                }

                if (angular.isNumber(value) && value >= min_amount) {
                  isValid = true;
                }

                return isValid;
              }
            };

            item.validationMessage = {
              min: function(ctx) {
                var validationMessageValue = 0,
                  message = '';

                var calculation_base = formHelperFactory.getFieldOfFormObj(
                  actualDonation.form_config.form,
                  'donation_amount_alternative'
                ).calculation_base;

                //if sponsorship is selected set min value of selected sponsorship
                if ('sponsorship' in $scope.donations.donationModel) {
                  //validate against the selected sonsorship's min_amount value
                  min_amount = formHelperFactory.getValueOfTitleMap(
                    vm.form_config.form,
                    'sponsorship',
                    $scope.donations.donationModel.sponsorship,
                    'min_amount'
                  );
                } else {
                  min_amount = item.min_amount;
                }

                if (calculation_base == 'monthly') {
                  var validationMessageValue =
                    getRealMinAmount(min_amount) / 12;
                } else {
                  var validationMessageValue = getRealMinAmount(
                    min_amount,
                    calculation_base
                  );
                }

                if ('sponsorship' in $scope.donations.donationModel) {
                  message = $translate.instant(
                    'Give at least {{amount}} for the selected sponsorship',
                    {
                      amount: $filter('formatForCurrency')(
                        validationMessageValue,
                        getDonationCurrencySymbol()
                      )
                    }
                  );
                } else {
                  message = $translate.instant('Give at least {{amount}}', {
                    amount: $filter('formatForCurrency')(
                      validationMessageValue,
                      getDonationCurrencySymbol()
                    )
                  });
                }

                return message;
              }
            };

            break;

          case 'donation_amount':
            if (vm.onlyUseAmountSelection) {
              item.readonly = true;
            }
            var chosen_interval = formHelperFactory.getValueOfTitleMap(
              vm.form_config.form,
              'direct_debit_interval',
              $scope.donations.donationModel.direct_debit_interval,
              'name'
            );
            item.title = item.title.replace('{{interval}}', chosen_interval);
            item.onChange = function(value) {
              calcMonthlyYearly(
                'donation_amount',
                'donation_amount_alternative',
                value
              );
              if ('direct_debit_interval' in $scope.donations.donationForm) {
                $scope.donations.donationForm.direct_debit_interval.$$parseAndValidate();
              }
              if ('payment_method' in $scope.donations.donationForm) {
                $scope.donations.donationForm.payment_method.$$parseAndValidate();
              }
            };

            item.$formatters = [];
            item.$formatters.push(toFixedComma);

            item.$validators = {
              min: function(value) {
                var isValid = false,
                  min_amount = false;
                //if sponsorship is selected min value is min_amount of selected sponsorship
                if ('sponsorship' in $scope.donations.donationModel) {
                  min_amount = formHelperFactory.getValueOfTitleMap(
                    vm.form_config.form,
                    'sponsorship',
                    $scope.donations.donationModel.sponsorship,
                    'min_amount'
                  );
                } else {
                  min_amount = item.min_amount;
                }

                min_amount = getRealMinAmount(min_amount);

                if (angular.isNumber(value) && value >= min_amount) {
                  isValid = true;
                }
                return isValid;
              }
            };

            item.validationMessage = {
              min: function(ctx) {
                var validationMessageValue = 0,
                  message = '';

                //if sponsorship is selected set min value of selected sponsorship
                if ('sponsorship' in $scope.donations.donationModel) {
                  var validationMessageValue = getRealMinAmount(
                    formHelperFactory.getValueOfTitleMap(
                      vm.form_config.form,
                      'sponsorship',
                      $scope.donations.donationModel.sponsorship,
                      'min_amount'
                    )
                  );
                  message = $translate.instant(
                    'Give at least {{amount}} for the selected sponsorship',
                    {
                      amount: $filter('formatForCurrency')(
                        validationMessageValue,
                        getDonationCurrencySymbol()
                      )
                    }
                  );
                } else {
                  //if non of above is selected set min value of donation_amount.min_amount
                  validationMessageValue = getRealMinAmount(item.min_amount);

                  message = $translate.instant('Give at least {{amount}}', {
                    amount: $filter('formatForCurrency')(
                      validationMessageValue,
                      getDonationCurrencySymbol()
                    )
                  });
                }

                return message;
              }
            };
            break;

          case 'direct_debit_interval':
            item.onChange = function(value) {
              updateAmountChoicesForAge($scope.donations.donationModel);
              if (
                value &&
                formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'direct_debit_interval',
                  value,
                  'value'
                )
              ) {
                updateDonationAmountLabel();
                if ($scope.donations.donationForm.donation_amount_alternative) {
                  calcMonthlyYearly(
                    'donation_amount_alternative',
                    'donation_amount',
                    parseFloat(
                      $scope.donations.donationForm.donation_amount_alternative
                        .$viewValue
                    )
                  );
                }
                clearDonationAmountIfHidden();
              }

              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);

              // update the available payment methods
              updatePaymentMethods($scope.donations.donationModel);
              if ('payment_method' in $scope.donations.donationForm) {
                $scope.donations.donationForm.payment_method.$$parseAndValidate();
              }

              // hide amount alternative for one off donations
              if (value && value == '4') {
                $('#form-group-donation_amount_alternative').hide();
              } else {
                $('#form-group-donation_amount_alternative').show();
              }
            };

            item.$validators = {
              paymentIntervalValid: function(value) {
                var min_amount = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'direct_debit_interval',
                  value,
                  'min_amount'
                );
                var donation_amount =
                  $scope.donations.donationModel.donation_amount;

                if (donation_amount < min_amount) return false;
                return true;
              }
            };

            item.validationMessage = {
              paymentIntervalValid: function(ctx) {
                var validationMessageValue = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'direct_debit_interval',
                  ctx.viewValue + '',
                  'min_amount'
                );

                return $translate.instant(
                  'Give at least {{amount}} for the selected debit interval',
                  {
                    amount: $filter('formatForCurrency')(
                      validationMessageValue,
                      getDonationCurrencySymbol()
                    )
                  }
                );
              }
            };
            break;

          //BANK DATA SECTION
          case 'payment_method':
            item.onChange = function(value) {
              formHelperFactory.rerenderInput(
                $scope.donations.donationForm,
                'account_country'
              );
              if ($scope.donations.donationForm.account_sepa_iban) {
                $scope.donations.donationForm.account_sepa_iban.$$parseAndValidate();
              }

              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);
            };

            item.$validators = {
              maxLimit: function(value) {
                var isValid = true;
                currentPaymentMethodMaxLimit = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'payment_method',
                  value,
                  'max_limit'
                );

                if (currentPaymentMethodMaxLimit !== null) {
                  if (
                    $scope.donations.donationModel.donation_amount >
                    currentPaymentMethodMaxLimit
                  ) {
                    isValid = false;
                  }
                }

                return isValid;
              }
            };

            item.validationMessage = {
              maxLimit: function(ctx) {
                var maxLimit = formHelperFactory.getValueOfTitleMap(
                  $scope.donationsFormStep.form_config.form,
                  'payment_method',
                  ctx.viewValue,
                  'max_limit'
                );

                var errorMsg =
                  'The chosen donation amount is higher than the allowed Maximum of {{maxLimit}}. Please choose a lower donation amount';

                return $translate.instant(errorMsg, {
                  maxLimit: maxLimit
                });
              },
              0: function(ctx) {
                var errorMsg;
                var amount_choices_field = formHelperFactory.getFieldOfFormObj(
                  $scope.donationsFormStep.form_config.form,
                  'payment_method',
                  true
                );
                if (
                  amount_choices_field &&
                  amount_choices_field.titleMap.length
                ) {
                  errorMsg = 'Please choose another payment method.';
                } else {
                  errorMsg =
                    'No payment method available for the chosen combination of payment interval and currency.';
                }
                return $translate.instant(errorMsg);
              }
            };
            break;

          case 'account_country':
            item.condition = function() {
              return isPaymentMethodWithBankData(
                $scope.donations.donationModel.payment_method
              );
            };

            item.onChange = function(value) {
              if ($scope.donations.donationForm.account_sepa_iban) {
                $scope.donations.donationForm.account_sepa_iban.$$parseAndValidate();
              }
              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);
            };

            item.isPostfinanceCountryValidDir = 1;
            item.isPostfinanceCountryValidPaymentMethod = 'payment_method';

            item.isSortCodeCountryValidDir = 1;
            item.isSortCodeCountryValidPaymentMethod = 'payment_method';

            item.validationMessage = {
              postfinanceCountryPaymentMethod: function(ctx) {
                return $translate.instant(
                  'PostFinance payments are only available for Swiss accounts.'
                );
              },
              sortCodeCountryPaymentMethod: function(ctx) {
                return $translate.instant(
                  'Sort code payments are only available for British and Irish accounts.'
                );
              }
            };
            break;

          case 'account_holder':
            item.condition = function() {
              return isPaymentMethodWithBankData(
                $scope.donations.donationModel.payment_method
              );
            };

            item.capitalizedDir = 1;
            break;

          case 'account_sepa_iban':
            item.condition = function() {
              var payment_method =
                $scope.donations.donationModel.payment_method;
              return (
                payment_method == 'donut-sepa' ||
                payment_method == 'postfinance_iban' ||
                payment_method == 'swiss_direct_debit'
              );
            };
            item.required = true;

            item.uppercasedDir = 1;

            item.formatIbanDir = 1;

            item.isCountryOfIbanValidDir = 1;
            item.isCountryOfIbanValidCountry = 'account_country';

            item.isIbanValidDir = 1;

            item.$validators = {
              isIbanCountryAllowed: function(value) {
                var paymentMethod = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'payment_method',
                  $scope.donations.donationModel.payment_method,
                  'value',
                  true
                );
                if (paymentMethod && value && value.length >= 2) {
                  // TODO: insert disallowed countries from the backend if necessary
                  return formHelperFactory.isAllowedIbanCountry(
                    value.substring(0, 2).toLowerCase(),
                    paymentMethod.countries,
                    []
                  );
                } else {
                  return true;
                }
              },
              isBankCodeAllowed: function(value) {
                var paymentMethod = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'payment_method',
                  $scope.donations.donationModel.payment_method,
                  'value',
                  true
                );
                if (paymentMethod) {
                  return formHelperFactory.isAllowedBankCode(
                    value,
                    paymentMethod.allowed_bank_codes,
                    paymentMethod.disallowed_bank_codes
                  );
                } else {
                  return true;
                }
              }
            };

            item.validationMessage = {
              ibanCountry: function(ctx) {
                return $translate.instant(
                  'SEPA payments are not available for this country.'
                );
              },
              ibanValid: function(ctx) {
                return $translate.instant('Please enter a valid IBAN.');
              },
              isIbanCountryAllowed: function(ctx) {
                return $translate.instant(
                  'Please enter an IBAN with an allowed country.'
                );
              },
              isBankCodeAllowed: function(ctx) {
                return $translate.instant(
                  'Please enter an IBAN with an allowed bank code.'
                );
              }
            };

            item.onChange = function() {
              //formHelperFactory.rerenderInput($scope.donations.donationForm, 'account_sepa_iban');
              formHelperFactory.rerenderInput(
                $scope.donations.donationForm,
                'account_sepa_bic'
              );
            };
            break;

          case 'account_sepa_bic':
            item.condition = function() {
              var payment_method =
                $scope.donations.donationModel.payment_method;
              return (
                payment_method == 'donut-sepa' ||
                payment_method == 'postfinance_iban' ||
                payment_method == 'swiss_direct_debit'
              );
            };

            item.uppercasedDir = 1;

            item.trimmedWhitespaceDir = 1;
            item.trimAllWhitespace = 1;

            item.isRequiredIfCountryDifferentDir = 1;
            item.isRequiredIfCountryDifferentCountry = 'account_country';
            item.isRequiredIfCountryDifferentInitialCountry = getInitialCountry();

            item.isBicExistingValidDir = '1';
            item.isBicExistingValidCountry = 'account_sepa_iban';

            item.validationMessage = {
              requiredCountryDiffInitial: function(ctx) {
                return $translate.instant('Please enter a valid BIC.');
              },
              bicExisting: function(ctx) {
                return $translate.instant('Please enter a valid BIC.');
              }
            };
            break;

          case 'account_post_finance_post_account_number':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-post-finance'
              );
            };
            item.required = true;
            item.formatChPostAccountNumberDir = 1;
            item.isPostAccountNumberValidDir = 1;

            item.validationMessage = {
              postAccountNumberValid: function(ctx) {
                return $translate.instant(
                  'Please enter a valid PostFinance account number.'
                );
              }
            };
            break;

          case 'account_post_finance_clearing_number':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-post-finance'
              );
            };

            item.required = false;
            item.readonly = true;
            break;

          case 'account_uk_sort_code':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-uk-sort-codes'
              );
            };
            item.required = true;

            item.formatUkSortCodeDir = 1;
            item.isUkSortCodeExistingValidDir = 1;

            item.validationMessage = {
              ukSortCodeExisting: function(ctx) {
                return $translate.instant('Please enter a valid Sort code.');
              }
            };
            break;

          case 'account_uk_account_number':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-uk-sort-codes'
              );
            };
            item.required = true;

            item.isUkAccountNumberValidDir = 1;
            item.isUkAccountNumberValidSortCode = 'account_uk_sort_code';

            item.validationMessage = {
              ukAccountNumberValid: function(ctx) {
                return $translate.instant(
                  'The account number is not valid for the give Sort code.'
                );
              }
            };

            break;

          case 'account_old_bank_code':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-de-kontonummer'
              );
            };
            item.required = true;
            break;

          case 'account_old_account_number':
            item.condition = function() {
              return (
                $scope.donations.donationModel.payment_method ==
                'donut-de-kontonummer'
              );
            };
            item.required = true;
            break;

          case 'account_bank_name':
            item.condition = function() {
              return isPaymentMethodWithBankData(
                $scope.donations.donationModel.payment_method
              );
            };

            item.getBankNameDir = 1;

            item.getBankNameCountry = 'account_country';
            item.getBankNamePaymentMethod = 'payment_method';

            item.getBankNameBic = 'account_sepa_bic';
            item.getBankNameIban = 'account_sepa_iban';
            item.getBankNameBankCode = 'account_old_bank_code';
            item.getBankNameUkSortCode = 'account_uk_sort_code';
            item.getBankNamePostfinanceClearingNumber =
              'account_post_finance_clearing_number';

            break;

          //OTHER DATA SECTION
          case 'location':
            if (vm.user.settings.has_location_tracking) {
              // disable location field and set it to the global selectedLocation
              $scope.donations.donationModel.location = $localStorage.selectedLocation.id.toString();
              item.readonly = true;
              // set lastLocation for 'cancel' to work
              $localStorage.lastLocation = {
                id: $scope.donations.id,
                value: $localStorage.selectedLocation.id.toString()
              };
            }
            item.onChange = function(value) {
              $localStorage.lastLocation = {
                id: $scope.donations.id,
                value: value
              };

              var field =
                actualDonation.form_config.schema.properties[item.key];
              formHelperFactory.validateRequired(field, item, vm);
            };
            break;

          //DEFAULT
          default:
            if (
              item.key.length > 0 &&
              item.key[0].indexOf('form_additional_text_field_') == 0
            ) {
              if ('pattern' in vm.form_config.schema.properties[item.key]) {
                //alphabetical
                if (
                  vm.form_config.schema.properties[item.key].pattern ==
                  '^[a-zA-Z]+$'
                ) {
                  item.validationMessage = {
                    202: $translate.instant('Can only contain characters')
                  };
                }
                //alphanumeric
                if (
                  vm.form_config.schema.properties[item.key].pattern ==
                  '^[a-zA-Z0-9]+$'
                ) {
                  item.validationMessage = {
                    202: $translate.instant(
                      'Can only contain characters and numbers'
                    )
                  };
                }
              }

              //numeric
              if (vm.form_config.schema.properties[item.key].type == 'number') {
                item.validationMessage = {
                  105: $translate.instant('Must be a number')
                };
              }
            }
            break;
        }
      });
    });

    return formObj;
  }

  function isPaymentMethodWithBankData(paymentMethod) {
    if (!paymentMethod) {
      return false;
    }

    var needs_bank_data = formHelperFactory.getValueOfTitleMap(
      vm.form_config.form,
      'payment_method',
      paymentMethod,
      'needs_bank_data'
    );

    return needs_bank_data;
  }

  function setPaymentData() {
    var pM = $scope.donations.donationModel.payment_method;

    if (
      pM === 'donut-sepa' ||
      pM === 'postfinance_iban' ||
      pM === 'swiss_direct_debit'
    ) {
      $scope.donations.donationModel.account_iban_or_number =
        $scope.donations.donationModel.account_sepa_iban;
      $scope.donations.donationModel.account_bic_or_bankcode =
        $scope.donations.donationModel.account_sepa_bic;
    } else if (pM === 'donut-post-finance') {
      $scope.donations.donationModel.account_iban_or_number =
        $scope.donations.donationModel.account_post_finance_post_account_number;
      $scope.donations.donationModel.account_bic_or_bankcode =
        $scope.donations.donationModel.account_post_finance_clearing_number;
    } else if (pM === 'donut-uk-sort-codes') {
      $scope.donations.donationModel.account_iban_or_number =
        $scope.donations.donationModel.account_uk_account_number;
      $scope.donations.donationModel.account_bic_or_bankcode =
        $scope.donations.donationModel.account_uk_sort_code;
    } else if (pM === 'donut-de-kontonummer') {
      $scope.donations.donationModel.account_iban_or_number =
        $scope.donations.donationModel.account_old_account_number;
      $scope.donations.donationModel.account_bic_or_bankcode =
        $scope.donations.donationModel.account_old_bank_code;
    }
  }

  // TODO generalize and put into formhelper
  function calcMonthlyYearly(fieldname, otherFieldname, value) {
    // reset the otherField if the value of the fieldname is resetted
    // this allows to delete the value as it does not overwrite
    // the value again from the otherField
    if (value == undefined) {
      $scope.donations.donationModel[otherFieldname] = undefined;
      $scope.donations.donationForm[otherFieldname].$setViewValue(undefined);
      $scope.donations.donationForm[otherFieldname].$render();
      return;
    }
    //do only if donation_amount_alternative exists
    if (
      value == undefined ||
      $scope.donations.donationForm.donation_amount_alternative == undefined
    ) {
      return;
    }

    var fieldname =
      otherFieldname == 'donation_amount'
        ? 'donation_amount_alternative'
        : 'donation_amount';
    var calculationBase = formHelperFactory.getFieldOfFormObj(
      vm.form_config.form,
      'donation_amount'
    ).calculation_base;
    var newVal = 0;

    var factor = 1;
    if (calculationBase == 'monthly') {
      if (fieldname == 'donation_amount') {
        newVal = value * 12;
      } else {
        newVal = value / 12;
      }
    } else if (calculationBase == 'yearly') {
      if (fieldname == 'donation_amount') {
        newVal = value / 12;
      } else {
        newVal = value * 12;
      }
    } else {
      // calc from direct debit interval field
      var chosen_invterval =
        $scope.donations.donationForm.direct_debit_interval.$viewValue;
      switch (chosen_invterval) {
        case '0':
        case '4':
          factor = 12;
          break;
        case '1':
          factor = 4;
          break;
        case '2':
          factor = 2;
          break;
      }

      if (fieldname == 'donation_amount') {
        newVal = value * factor;
      } else {
        newVal = value / factor;
      }
    }

    $scope.donations.donationModel[otherFieldname] = newVal;
    $scope.donations.donationForm[otherFieldname].$setViewValue(newVal);
    $scope.donations.donationForm[otherFieldname].$render();
  }

  function saveConcatStrings(strA, strB) {
    var result = '';

    if (angular.isString(strA)) {
      result = result + strA.toString();
    }

    if (angular.isString(strB)) {
      result = result + (strA ? ' ' : '') + strB.toString();
    }

    return result;
  }

  function toFixedComma(value) {
    var formattedVal = value;

    if (value) {
      if (parseFloat(value)) {
        formattedVal = parseFloat(parseFloat(value).toFixed(2));
      }
    }
    return formattedVal;
  }

  function getInitialDonationConfig() {
    var dId = actualDonation.id;
    var lang =
      $stateParams && angular.isObject($stateParams) && 'lang' in $stateParams
        ? $stateParams.lang
        : 'en';
    return DonationsService.getDonation(dId, lang);
  }

  function getInitialCountry() {
    var comp = getInitialDonationConfig();

    if (
      comp &&
      'form_config' in comp &&
      'model' in comp.form_config &&
      'country' in comp.form_config.model
    ) {
      return comp.form_config.model.country || '';
    }
    return '';
  }

  /**
   * replace the last word of the donation amount label with the
   * new chosen interval or reset it (in case it was changed)
   */
  function updateDonationAmountLabel() {
    // only update the field title if the campaign is configured to display
    // amounts per interval
    var calculation_base = formHelperFactory.getFieldOfFormObj(
      vm.form_config.form,
      'donation_amount'
    ).calculation_base;
    if (!calculation_base) {
      var donation_amount_field = formHelperFactory.getFieldOfFormObj(
        vm.form_config.form,
        'donation_amount',
        true
      );
      var chosen_interval = formHelperFactory.getValueOfTitleMap(
        vm.form_config.form,
        'direct_debit_interval',
        $scope.donations.donationModel.direct_debit_interval,
        'name'
      );
      var title = donation_amount_field.title.split(' ');
      title.pop();
      title.push(chosen_interval);
      donation_amount_field.title = title.join(' ');
    }
  }

  function updateSponsorship(gift_recipients_number) {
    updateGiftRecipientsNumber(null, gift_recipients_number);
    var set_min_amount = formHelperFactory.getValueOfTitleMap(
      vm.form_config.form,
      'sponsorship',
      $scope.donations.donationModel.sponsorship,
      'set_min_amount'
    );

    var donation_amount = $scope.donations.donationModel.donation_amount;
    var min_amount = getRealMinAmount(
      formHelperFactory.getValueOfTitleMap(
        vm.form_config.form,
        'sponsorship',
        $scope.donations.donationModel.sponsorship,
        'min_amount'
      )
    );
    if (set_min_amount && $scope.donations.donationForm.donation_amount) {
      $scope.donations.donationForm.donation_amount.$setViewValue(min_amount);
      $scope.donations.donationForm.donation_amount.$render();
      calcMonthlyYearly(
        'donation_amount',
        'donation_amount_alternative',
        min_amount
      );
    }
  }

  function updateGiftRecipientsNumber(
    has_gift_recipients,
    gift_recipients_number
  ) {
    if (has_gift_recipients == null) {
      // we need to find the selected sponsorship
      has_gift_recipients = formHelperFactory.getValueOfTitleMap(
        vm.form_config.form,
        'sponsorship',
        $scope.donations.donationModel.sponsorship,
        'has_gift_recipients'
      );
    }
    $scope.donations.donationModel.has_gift_recipients = has_gift_recipients;
    if (!has_gift_recipients) {
      $scope.donations.donationModel.gift_recipients_number = 0;
    } else {
      // there are gift recipients and the number might have changed
      if (gift_recipients_number == null) {
        // it was not passed, so fetch it from the form
        gift_recipients_number = +$scope.donations.donationModel
          .gift_recipients;
      }
      $scope.donations.donationModel.gift_recipients_number = +gift_recipients_number;
      if (!$scope.donations.donationModel.gift_recipients_map) {
        $scope.donations.donationModel.gift_recipients_map = [];
        for (var i = 0; i < +gift_recipients_number; i++) {
          $scope.donations.donationModel.gift_recipients_map.push({
            recipientId: i
          });
        }
      } else {
        // there is alread ya gift recipients map, so update it
        if (
          +gift_recipients_number ===
          $scope.donations.donationModel.gift_recipients_map.length
        ) {
          return;
        }
        if (
          +gift_recipients_number >
          $scope.donations.donationModel.gift_recipients_map.length
        ) {
          // add new empty recipients
          for (
            var i = $scope.donations.donationModel.gift_recipients_map.length;
            i < +gift_recipients_number;
            i++
          ) {
            $scope.donations.donationModel.gift_recipients_map.push({
              recipientId: i
            });
          }
        }
        if (
          +gift_recipients_number <
          $scope.donations.donationModel.gift_recipients_map.length
        ) {
          // delete only the extra few recipients
          for (
            var i = $scope.donations.donationModel.gift_recipients_map.length;
            i > +gift_recipients_number;
            i--
          ) {
            $scope.donations.donationModel.gift_recipients_map.pop();
          }
        }
      }
    }
  }

  function updateCurrency(donationModel) {
    currencyCode = donationModel.currencies;
    updateAmountChoicesCurrency(currencyCode);
    updatePaymentMethods(donationModel);
    vm.currencyRate = 1;
    for (var i = 0; i < actualDonation.exchange_rates.length; ++i) {
      if (actualDonation.exchange_rates[i].target === currencyCode) {
        vm.currencyRate = actualDonation.exchange_rates[i].rate;
        break;
      }
    }
  }

  function getDonationCurrencySymbol() {
    // if another currency is selected, we need to this in the form, instead of the global app currency symbol
    return (
      $scope.donations.donationModel.currencies || $scope.app.currencySymbol
    );
  }

  function getRealMinAmount(
    min_amount,
    calculation_base,
    direct_debit_interval
  ) {
    var calculation_base =
        calculation_base == undefined
          ? formHelperFactory.getFieldOfFormObj(
              actualDonation.form_config.form,
              'donation_amount'
            ).calculation_base
          : calculation_base,
      direct_debit_interval =
        direct_debit_interval == undefined
          ? parseInt($scope.donations.donationModel.direct_debit_interval)
          : direct_debit_interval;

    if (
      !calculation_base &&
      direct_debit_interval > 0 &&
      direct_debit_interval < 4
    ) {
      switch (direct_debit_interval) {
        case 1:
          min_amount = min_amount * 3;
          break;
        case 2:
          min_amount = min_amount * 6;
          break;
        case 3:
          min_amount = min_amount * 12;
      }
    }

    if ($scope.donations.donationModel.gift_recipients_number) {
      recipients = parseInt(
        $scope.donations.donationModel.gift_recipients_number
      );
      if (recipients > 0) {
        min_amount = min_amount * recipients;
      }
    }

    // e.g. if USD, the min amount will be slightly higher than in EUR, because 1 EUR ~= 1.16 USD
    var min_amount_in_currency =
      Math.round((min_amount * vm.currencyRate + 0.00001) * 100) / 100;

    return min_amount_in_currency;
  }

  /*
   * The new amount choices solution:
   * - by default amount choices empty
   * - when age entered, show amount choices based on age for default interval
   * - when age & interval entered, show amount choices based on age and interval
   */
  function updateAmountChoicesForAge(donationModel) {
    if (
      // don't affect campaigns that don't have this complex configuration
      !vm.has_amount_choices_per_age_group ||
      !vm.amount_choices_per_interval
    ) {
      return;
    }
    var interval = formHelperFactory.getValueOfTitleMap(
      vm.form_config.form,
      'direct_debit_interval',
      donationModel.direct_debit_interval,
      'value' // for 0, 1, 2, ... or 'name' for monthly, quarterly, ...
    );
    var amount_choices_field = formHelperFactory.getFieldOfFormObj(
      vm.form_config.form,
      'amount_choices',
      true
    );
    vm.matchingAmountChoices = undefined;
    if (interval) {
      if (vm.age) {
        angular.forEach(vm.amount_choices_per_interval[interval], function(
          age_group
        ) {
          if (
            'min_age' in age_group &&
            'max_age' in age_group &&
            age_group.min_age <= vm.age &&
            vm.age <= age_group.max_age
          ) {
            vm.matchingAmountChoices = age_group;
          }
          if ('min_age' in age_group && age_group.min_age <= vm.age) {
            vm.matchingAmountChoices = age_group;
          }
        });
      } else {
        // no date of birth is set
        if (
          vm.amount_choices_per_interval[interval] &&
          vm.amount_choices_per_interval[interval].length === 1
        ) {
          // special case - when there is only one age group, apply it no matter the age
          vm.matchingAmountChoices =
            vm.amount_choices_per_interval[interval][0];
        }
      }
    }
    if (vm.matchingAmountChoices) {
      amount_choices_field.titleMap = angular.copy(
        vm.matchingAmountChoices.amount_choices
      );
    }
    var existing_choice = $filter('filter')(amount_choices_field.titleMap, {
      value: $scope.donations.donationModel.amount_choices
    });
    if (existing_choice.length == 0) {
      // we're clearing out the model here so that no amount choice is selected any more
      $scope.donations.donationModel.amount_choices = '';
      $scope.donations.donationModel.donation_amount = '';
      $scope.donations.donationModel.donation_amount_alternative = '';
    }
  }

  function clearDonationAmountIfHidden() {
    // if only the amount choices are visible (i.e. donation amount hidden) and an amount choice isn't selected
    if (
      vm.onlyUseAmountSelection &&
      !$scope.donations.donationModel.amount_choices
    ) {
      // then clear the donation amount entered
      $scope.donations.donationModel.donation_amount = '';
    }
  }

  function updateAmountChoicesCurrency(currencyCode) {
    var amount_choices_field = formHelperFactory.getFieldOfFormObj(
      vm.form_config.form,
      'amount_choices',
      true
    );
    if (!amount_choices_field.originalTitle)
      amount_choices_field.originalTitle = amount_choices_field.title;
    amount_choices_field.title =
      amount_choices_field.originalTitle + ' (' + currencyCode + ')';
  }

  function updatePaymentMethods(donationModel) {
    var payment_method_field = formHelperFactory.getFieldOfFormObj(
      vm.form_config.form,
      'payment_method',
      true
    );
    var interval = formHelperFactory.getValueOfTitleMap(
      vm.form_config.form,
      'direct_debit_interval',
      donationModel.direct_debit_interval,
      'value' // for 0, 1, 2, ... or 'name' for monthly, quarterly, ...
    );
    var currencyCode = donationModel.currencies;
    var newPaymentMethodsTitleMap = [];
    for (var i = 0; i < vm.allPaymentMethods.titleMap.length; ++i) {
      var paymentMethod = vm.allPaymentMethods.titleMap[i];
      // currency check
      var passesCurrencyCheck = false;
      if (currencyCode) {
        if (paymentMethod.currencies.indexOf(currencyCode) > -1) {
          passesCurrencyCheck = true;
        }
      } else {
        passesCurrencyCheck = true;
      }
      // interval check
      var passesIntervalCheck = false;
      if (interval) {
        if (paymentMethod.direct_debit_intervals.indexOf(interval) > -1) {
          passesIntervalCheck = true;
        }
      } else {
        passesIntervalCheck = true;
      }
      // only if all checks pass allow this payment method
      if (passesCurrencyCheck && passesIntervalCheck) {
        newPaymentMethodsTitleMap.push(paymentMethod);
      }
    }
    payment_method_field.titleMap = newPaymentMethodsTitleMap;
  }

  /**
   * Starts the inactivity check with the given treshold.
   *
   * @param {number} inactivityThreshold Threshold in milliseconds
   */
  function initInactivityCheck(inactivityThreshold) {
    if (!inactivityThreshold) {
      return; // Nothing to set up
    }

    var timeoutId;
    var toastShown = false;

    document.addEventListener('mousemove', startTimer, false);
    document.addEventListener('mousedown', startTimer, false);
    document.addEventListener('keypress', startTimer, false);
    document.addEventListener('scroll', startTimer);
    document.addEventListener('touchmove', startTimer, false);

    cleanupFunctions.push(function() {
      cleanup();
      document.removeEventListener('mousemove', startTimer);
      document.removeEventListener('mousedown', startTimer);
      document.removeEventListener('keypress', startTimer);
      document.removeEventListener('scroll', startTimer);
      document.removeEventListener('touchmove', startTimer);
    });

    /**
     * @returns {boolean}
     * `true`, if data was entered in the form
     */
    function wasDataEntered() {
      var anyTouched = false;
      $scope.donations.donationForm.$$controls.forEach(function(control) {
        // Closest approximation
        if (control.$dirty && control.$name.indexOf('date_of_birth_') !== 0) {
          anyTouched = true;
        }
      });
      return anyTouched;
    }

    function doInactive() {
      if (wasDataEntered()) {
        return;
      }

      toastShown = true;
      NotificationsService.showToast({
        text:
          'A redirect will be activated in a few seconds. If you are still talking, please tap on the screen',
        title: 'You have been inactive for a while',
        duration: 10,
        dismissable: true,
        button: {
          action: 'dismiss',
          label: 'Dismiss',
          close: true
        },
        events: {
          close: function(reason) {
            if (reason === 'timeout') {
              autoRedirectToStart();
            } else {
              startTimer();
            }
          }
        }
      });
    }

    function cleanup() {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
        NotificationsService.hideToast();
      }
    }

    function startTimer() {
      cleanup();
      timeoutId = window.setTimeout(doInactive, inactivityThreshold);
    }

    startTimer();
  }

  function autoRedirectToStart() {
    var events = [
      analyticsEventFactory.click('conversation-end', { reason: 'abort' })
    ];

    return AnalyticsService.trackEvents(events).then(function() {
      // delete all pending formdata in local storage
      offlineStore.deletePendingFormData();
      $window.location.href = '/next/forms/' + actualDonation.id + '/start';
    });
  }
}

DonationsGiftController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$stateParams',
  '$translate',
  '$localStorage',
  'offlineStore',
  'formHelperFactory',
  'actualDonation'
];
function DonationsGiftController(
  $scope,
  $timeout,
  $state,
  $stateParams,
  $translate,
  $localStorage,
  offlineStore,
  formHelperFactory,
  actualDonation
) {
  var vm = this;
  vm.stepState = 'gift';
  vm.header_image = '';
  vm.form_config_gift_recipient = {};
  vm.formWording = actualDonation.form_wording;

  vm.copyAddress = copyAddress;
  vm.copyContact = copyContact;
  vm.goBack = goBack;
  vm.goToNext = goToNext;

  init(actualDonation);

  if ($stateParams.recipientPage) {
    vm.recipientPage = $stateParams.recipientPage;
    if (
      vm.recipientPage > $scope.donations.donationModel.gift_recipients_number
    ) {
      // This recipient page does not exist
      $state.go('app.donations.form');
    }
    vm.recipientId = $scope.donations.donationModel.recipientId =
      vm.recipientPage - 1;
  } else {
    // You need to pass the recipientPage url parameter
    $state.go('app.donations.form');
  }

  function init(donationObj) {
    if (donationObj.form_config_gift_recipient) {
      vm.form_config = donationObj.form_config;
      // TODO: I'm calling the "unfinished" prepareForm on form_config.form here – maybe not good
      vm.form_config.form = prepareForm(vm.form_config.form, vm.form_config);
      vm.form_config_gift_recipient = donationObj.form_config_gift_recipient;
      // TODO: extract prepare from donations.form.controller into another module
      vm.form_config_gift_recipient.form = prepareForm(
        vm.form_config_gift_recipient.form,
        vm.form_config_gift_recipient
      );
      var formConfigGiftRecipientSchema =
        'schema' in donationObj.form_config_gift_recipient &&
        'properties' in donationObj.form_config_gift_recipient.schema &&
        angular.isObject(
          donationObj.form_config_gift_recipient.schema.properties
        )
          ? donationObj.form_config_gift_recipient.schema.properties
          : {};
      var formConfigSchema =
        'schema' in donationObj.form_config &&
        'properties' in donationObj.form_config.schema &&
        angular.isObject(donationObj.form_config.schema.properties)
          ? donationObj.form_config.schema.properties
          : {};
      // load the donation model from local storage every time
      $scope.donations.donationModel = formHelperFactory.getDonationModel(
        donationObj.form_config.model || {},
        offlineStore.getPendingFormData() || {},
        formConfigSchema,
        vm.form_config.form,
        $localStorage.lastLocation
      );
    } else {
      $state.go('app.donations.form');
    }
  }

  function copyAddress() {
    var donationModel = $scope.donations.donationModel;
    var giftRecipient =
      donationModel.gift_recipients_map[
        $scope.donations.donationModel.recipientId
      ];
    giftRecipient.street = donationModel.street;
    giftRecipient.house_number = donationModel.house_number;
    giftRecipient.zip_code = donationModel.zip_code;
    giftRecipient.city = donationModel.city;
    giftRecipient.country = donationModel.country;
    giftRecipient.address_addition = donationModel.address_addition;
  }

  function copyContact() {
    var donationModel = $scope.donations.donationModel;
    var giftRecipient =
      donationModel.gift_recipients_map[
        $scope.donations.donationModel.recipientId
      ];
    giftRecipient.email = donationModel.email;
    giftRecipient.mobile_number = donationModel.mobile_number;
  }

  function goToNext(form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');
    form.$submitted = true;

    if (form.$valid) {
      //save current data to local storage as pending donation
      offlineStore.savePendingFormData($scope.donations.donationModel);
      if (
        +vm.recipientPage ==
        +$scope.donations.donationModel.gift_recipients_number
      ) {
        // last page, proceed to QA or signature step
        if (
          'skip' in actualDonation.form_config_qa &&
          actualDonation.form_config_qa.skip == true
        ) {
          $state.go('app.donations.signature');
        } else {
          $state.go('app.donations.qa');
        }
      } else {
        // go to the next gift recipient's page
        $state.go('app.donations.gift', {
          recipientPage: +vm.recipientPage + 1
        });
      }
    } else {
      $timeout(function() {
        var firstInvalidField = $('#donation form')
          .find('.ng-invalid:visible')
          .first();

        $('html, body').animate(
          {
            scrollTop: firstInvalidField.offset().top - 30
          },
          100,
          function() {
            firstInvalidField.focus();
          }
        );
      }, 100);
    }
  }

  function goBack() {
    //save current data to local storage as pending donation
    offlineStore.savePendingFormData($scope.donations.donationModel);
    if (+vm.recipientPage == 1) {
      $state.go('app.donations.form');
    } else {
      $state.go('app.donations.gift', { recipientPage: +vm.recipientPage - 1 });
    }
  }

  // TODO: everything below here should go into a separate module, cause it's
  // common both to this controller and the form controller.
  //
  // This version of the function has been made more general-purpose, BUT
  // right now it doesn't contain everything from the first one, so needs more work!
  //
  function prepareForm(formObj, formConfigObj) {
    formObj = angular.copy(formObj);
    // call this as early as possible to clean up the keys as arrays situation
    formHelperFactory.keysToString(formObj);
    //iterate fieldsets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate fieldset items
      angular.forEach(fieldset.items, function(item, k) {
        switch (item.key) {
          case 'address_search':
            item.detailcb = formHelperFactory.copyValues;
            //@TODO fint better way with less params to get form model
            item.formIdToCopyIn = '#donation form';
            item.formNameToCopyIn = 'donationForm';
            break;
          case 'first_name':
            item.capitalizedDir = 1;
            item.isValidFirstName = 1;
            item.validFirstNameTitle = 'title';
            item.validFirstNameWarningMessage = $translate.instant(
              'Salutation may not be correct for this name'
            );
            break;

          case 'last_name':
            item.capitalizedDir = 1;
            break;

          case 'email':
            item.$validators = {
              isemail: function(value) {
                return formHelperFactory.isValidEmail(value);
              }
            };
            item.validationMessage = {
              isemail: function(ctx) {
                return $translate.instant('This is no valid email');
              }
            };
            break;

          case 'date_of_birth':
            var field =
              actualDonation.form_config_gift_recipient.schema.properties[
                item.key
              ];
            item.$validators = {};
            item.validationMessage = {};
            if ('maximum' in field) {
              item.$validators['max'] = function(value) {
                return formHelperFactory.validateMaxDate(
                  vm.form_config_gift_recipient,
                  'date_of_birth',
                  value
                );
              };
              item.validationMessage['max'] = function(ctx) {
                var max_date = new Date(
                    vm.form_config_gift_recipient.schema.properties[
                      item.key
                    ].maximum.replace(/-/g, '/')
                  ),
                  maximumAgeInYears =
                    new Date(new Date() - new Date(max_date)).getFullYear() -
                    1970;
                return $translate.instant(
                  'The minimum age is {{minimum}} years.',
                  { minimum: maximumAgeInYears }
                );
              };
            }
            if ('minimum' in field) {
              item.$validators['min'] = function(value) {
                return formHelperFactory.validateMinDate(
                  vm.form_config_gift_recipient,
                  'date_of_birth',
                  value
                );
              };
              item.validationMessage['min'] = function(ctx) {
                var min_date = new Date(
                    vm.form_config_gift_recipient.schema.properties[
                      item.key
                    ].minimum.replace(/-/g, '/')
                  ),
                  minimumAgeInYears =
                    new Date(new Date() - new Date(min_date)).getFullYear() -
                    1970 -
                    1;
                return $translate.instant(
                  'The maximum age is {{maximum}} years.',
                  { maximum: minimumAgeInYears }
                );
              };
            }
            if ('required' in field && field.required) {
              item.$validators['required'] = function(value) {
                return formHelperFactory.validateFilledOut(
                  vm.form_config_gift_recipient,
                  'date_of_birth',
                  value
                );
              };
              item.validationMessage['required'] = function(ctx) {
                return $translate.instant('Required.');
              };
            }
            break;

          case 'mobile_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;
        }
      });
    });

    return formObj;
  }
}

DonationsQaController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$filter',
  '$uibModal',
  '$translate',
  'offlineStore',
  'actualDonation'
];
function DonationsQaController(
  $scope,
  $timeout,
  $state,
  $filter,
  $uibModal,
  $translate,
  offlineStore,
  actualDonation
) {
  var vm = this;

  vm.stepState = 'qa';
  vm.form_config = {};
  vm.goToNext = goToNext;
  vm.goBack = goBack;

  init(actualDonation);

  //////////////////

  function init(donationObj) {
    if (!offlineStore.pendingFormDataPresent()) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant('Invalid state');
          },
          text: function() {
            return $translate.instant(
              'No pending Formdata given! Return to start.'
            );
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return false;
          }
        }
      });

      modalInstance.result.then(function() {
        $state.go('app.donations.form');
      });
    } else {
      $scope.donations.donationModel = offlineStore.getPendingFormData();
    }

    if (donationObj.form_config_qa) {
      vm.form_config = donationObj.form_config_qa;
      vm.form_config.form = prepareForm(vm.form_config.form);
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    //save current data to local storage as pending donation
    offlineStore.savePendingFormData($scope.donations.donationModel);
    if ($scope.donations.donationModel.gift_recipients_number) {
      $state.go('app.donations.gift', {
        recipientPage: +$scope.donations.donationModel.gift_recipients_number
      });
    } else {
      $state.go('app.donations.form');
    }
  }

  function goToNext(form) {
    vm.wasSubmitted = true;
    if (form.$valid) {
      //save current data to local storage as pending donation
      offlineStore.savePendingFormData($scope.donations.donationModel);
      $state.go('app.donations.signature');
    } else {
      $timeout(function() {
        var firstInvalidField = $('#donation form')
          .find('.ng-invalid:visible')
          .first();

        $('html, body').animate(
          {
            scrollTop: firstInvalidField.offset().top - 30
          },
          100,
          function() {
            firstInvalidField.focus();
          }
        );
      }, 100);
    }
  }

  function prepareForm(formObj) {
    formObj = angular.copy(formObj);
    //iterate fieldsets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate fieldset items
      angular.forEach(fieldset.items, function(item, k) {
        // make sure required fields are filled out
        var field = vm.form_config.schema.properties[item.key];
        if ('required' in field && field.required) {
          if (!item.$validators) {
            item.$validators = {};
          }
          item.$validators['required'] = function(value) {
            if (value === 0 || value === false) {
              return true;
            }
            // make sure that value is truthy, i.e. not null, undefined, 0, false or empty string
            return !!value;
          };
          if (!item.validationMessage) {
            item.validationMessage = {};
          }
          item.validationMessage['required'] = function(ctx) {
            return $translate.instant('Required.');
          };
        }
      });
    });
    return formObj;
  }
}

DonationsSignatureController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  '$q',
  'formHelperFactory',
  'offlineStore',
  'RaiseNowPayment',
  'RaiseNowSettings',
  '$uibModal',
  '$window',
  'actualDonation',
  'signatureConverter',
  'AuthenticationService',
  'IndexedDbService',
  'AnalyticsService',
  'analyticsEventFactory'
];
function DonationsSignatureController(
  $scope,
  $state,
  $stateParams,
  $translate,
  $q,
  formHelperFactory,
  offlineStore,
  RaiseNowPayment,
  RaiseNowSettings,
  $uibModal,
  $window,
  actualDonation,
  signatureConverter,
  AuthenticationService,
  IndexedDbService,
  AnalyticsService,
  /**
   * @type {AnalyticsEventFactory}
   */
  analyticsEventFactory
) {
  var vm = this;

  vm.stepState = 'signature';
  vm.form_config = {};
  vm.formWording = actualDonation.form_wording;
  vm.uploadFormdata = uploadFormdata;
  vm.goBack = goBack;
  vm.signatureError = '';
  vm.is_printable = 0;
  vm.isPrinted = 0;
  vm.actualDonation = actualDonation;
  vm.isUploading = false;

  vm.printSummary = function() {
    window.print();
  };

  init(actualDonation);
  //////////////////

  /**
   * First check whether there is pending form data in the
   * offline storage and store it in the current scope
   *
   * If no data is stored, return back to the start of the form
   */
  function init(donationObj) {
    if (!offlineStore.pendingFormDataPresent()) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 7,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant('Invalid state');
          },
          text: function() {
            return $translate.instant(
              'No pending Formdata given! Return to start.'
            );
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return false;
          }
        }
      });

      modalInstance.result.then(function() {
        $state.go('app.donations.form');
      });
    } else {
      $scope.donations.donationModel = offlineStore.getPendingFormData();
    }

    if (angular.isObject(donationObj)) {
      var isPrintable = formHelperFactory.getValueOfTitleMap(
        donationObj.form_config.form,
        'payment_method',
        $scope.donations.donationModel.payment_method,
        'is_printable'
      );

      vm.is_printable = isPrintable ? 1 : 0;
    }

    if (donationObj.form_config_signature) {
      vm.form_config = donationObj.form_config_signature;
      vm.form_config.form = prepareForm(donationObj.form_config_signature.form);
      // we need the first two page configs for some Sextant variables
      vm.qa_form_config = donationObj.form_config_qa;
      vm.donation_form_config = donationObj.form_config;
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    if (actualDonation.form_config_qa.skip == true) {
      if ($scope.donations.donationModel.gift_recipients_number) {
        $state.go('app.donations.gift', {
          recipientPage: $scope.donations.donationModel.gift_recipients_number
        });
      } else {
        $state.go('app.donations.form');
      }
    } else {
      $state.go('app.donations.qa');
    }
  }

  function uploadFormdata(form) {
    // Abort if uploading is already in progress
    if (vm.isUploading) {
      return;
    }

    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');
    form.$setSubmitted(true);

    if (form.$valid && isSignatureValid()) {
      vm.isUploading = true;
      var preparedData = prepareFormDataForUpload(
        $scope.donations.donationModel,
        true
      );
      if (
        preparedData.gift_recipients_map &&
        preparedData.gift_recipients_map.length > 0 &&
        +preparedData.gift_recipients_number > 0
      ) {
        var prepared_gift_recipients_map = [];
        for (
          i = 0;
          i < +$scope.donations.donationModel.gift_recipients_number;
          i++
        ) {
          var prepared_gift_recipient = prepareFormDataForUpload(
            $scope.donations.donationModel.gift_recipients_map[i],
            false
          );
          prepared_gift_recipients_map.push(prepared_gift_recipient);
        }
        preparedData.gift_recipients_map = prepared_gift_recipients_map;
      }

      if (
        RaiseNowSettings.isPaymentMethodSupported(preparedData.payment_method)
      ) {
        var payment = RaiseNowPayment.create(preparedData)
          .subSuccess(function(data) {
            if ('message' in data) {
              //@TODO do something with data.message
            } else {
              //@TODO do something with data.epp_transaction_id
            }
          })
          .subFinished(function(data) {
            finalizeDonation(preparedData).finally(function() {
              vm.isUploading = false;
            });
          })
          .subAfterConfirmation(function(data) {
            preparedData.epp_transaction_id = data.epp_transaction_id;
          });

        payment.start();
      } else {
        finalizeDonation(preparedData).finally(function() {
          vm.isUploading = false;
        });
      }
    } else {
      form.signature.$setValidity('signatureDataValid', false);
    }
  }

  /**
   * @param {*} preparedData The prepared data
   *
   * @returns {Promise}
   * A promise that is resolved once the donation was finalized
   */
  function finalizeDonation(preparedData) {
    return persistFormData(preparedData).then(function(result) {
      $scope.donations.donationModel = {};
      var modal = result.modal;
      return modal.closed.then(function() {
        if ('presentation' in actualDonation && actualDonation.presentation) {
          // there is a presentation for this campaign, so we go back to the start page
          $window.location.href = '/next/forms/' + actualDonation.id + '/start';
        } else {
          // we go back to the first page of the donation form
          $state.go('app.donations.form');
        }
      });
    });
  }

  /**
   * @param {object} preparedData The prepared form data
   *
   * @returns {Promise<{ result: any, modal: { closed: Promise, response: Promise } }>}
   * A promise that resolves with the result from the upload request and the modal
   */
  function persistFormData(preparedData) {
    function storeInIndexedDb(preparedData) {
      var userData = AuthenticationService.getCurrentUser();
      var userId = userData.id;
      var type = offlineStore.getTypes()[0] || 'unknown';
      var key = userId + '_' + type + '__' + Date.now();

      var promises = [
        IndexedDbService.add('logs', {
          key: key,
          fuid: preparedData.fuid || '',
          type: 'submitted_donation',
          timestamp: Date.now()
        }),
        IndexedDbService.add(
          'donations',
          Object.assign({ key: key }, preparedData)
        )
      ];

      // Resolve once all operations completed, even if an error occured for any of the operations
      return $q.all(
        promises.map(function(promise) {
          return promise.catch(function(r) {
            return r;
          });
        })
      );
    }

    function storeEvents() {
      return AnalyticsService.trackEvents([
        analyticsEventFactory.click('campaign-form-success'),
        analyticsEventFactory.click('conversation-end', { reason: 'donation' })
      ]);
    }

    // First, store the data in IDB
    /**
     * @type {Promise[]}
     */
    var promises = [storeInIndexedDb(preparedData), storeEvents()];

    // Then, try persisting the data on the server.
    offlineStore.deletePendingFormData();
    promises.push(
      offlineStore
        .savePersistFormData(preparedData, offlineStore.getTypes()[0])
        .catch(function(r) {
          return r; // Catch any error that might occure
        })
    );

    return $q.all(promises).then(function(results) {
      // Resolve with the result from savePersistFormData
      return results[results.length - 1];
    });
  }

  function prepareFormDataForUpload(formData, includeRootData) {
    var preparedData = angular.copy(formData);
    if (!angular.isObject(preparedData)) {
      return preparedData;
    }

    if (includeRootData) {
      preparedData.languageWhileCollection = $stateParams.lang;
      preparedData.campaign = actualDonation.id;
    }

    if (
      angular.isObject(preparedData.location) &&
      'title' in preparedData.location
    ) {
      preparedData.location = preparedData.location.title;
    }

    if ('contract_start_date' in preparedData) {
      if (
        preparedData.contract_start_date &&
        moment(preparedData.contract_start_date).isValid()
      ) {
        preparedData.contract_start_date = moment(
          preparedData.contract_start_date
        ).format('YYYY-MM-DD');
      } else {
        preparedData.contract_start_date = null;
      }
    }

    if ('date_of_birth' in preparedData) {
      if (
        preparedData.date_of_birth &&
        moment(preparedData.date_of_birth).isValid()
      ) {
        preparedData.date_of_birth = moment(preparedData.date_of_birth).format(
          'YYYY-MM-DD'
        );
      } else {
        preparedData.date_of_birth = null;
      }
    }

    var roundAdd = 0.0000005;
    if ('donation_amount' in preparedData) {
      if (preparedData.donation_amount % 1 != 0) {
        preparedData.donation_amount = (
          parseFloat(preparedData.donation_amount) + roundAdd
        ).toFixed(6);
      }
    }

    if ('donation_amount_alternative' in preparedData) {
      if (preparedData.donation_amount_alternative % 1 != 0) {
        preparedData.donation_amount_alternative = (
          parseFloat(preparedData.donation_amount_alternative) + roundAdd
        ).toFixed(6);
      }
    }

    if (
      'raisenow_config' in actualDonation &&
      RaiseNowSettings.isPaymentMethodSupported(preparedData.payment_method)
    ) {
      preparedData.currency =
        preparedData.currencies ||
        actualDonation.raisenow_config.raisenow_currency_code;
      preparedData.raisenow_payment_method = preparedData.payment_method;
      preparedData.raisenow_sms_keyword =
        actualDonation.raisenow_config.raisenow_sms_keyword;
      preparedData.raisenow_sms_shortcode =
        actualDonation.raisenow_config.raisenow_sms_shortcode;
      preparedData.raisenow_api_key =
        actualDonation.raisenow_config.raisenow_api_key;
      preparedData.raisenow_use_stripe =
        actualDonation.raisenow_config.raisenow_use_stripe;
      if ('stored_campaign_subid' in actualDonation.raisenow_config) {
        preparedData.stored_campaign_subid =
          actualDonation.raisenow_config.stored_campaign_subid;
      }
      if ('stored_sxt_contract_template_id' in actualDonation.raisenow_config) {
        preparedData.stored_sxt_contract_template_id =
          actualDonation.raisenow_config.stored_sxt_contract_template_id;
      }

      if ('raisenow_use_salesforce' in actualDonation.raisenow_config) {
        preparedData.raisenow_use_salesforce =
          actualDonation.raisenow_config.raisenow_use_salesforce;
      }
      if ('stored_fundraising_team_type' in actualDonation.raisenow_config) {
        preparedData.stored_fundraising_team_type =
          actualDonation.raisenow_config.stored_fundraising_team_type;
      }
      if ('stored_crm_fundraising_team' in actualDonation.raisenow_config) {
        preparedData.stored_crm_fundraising_team =
          actualDonation.raisenow_config.stored_crm_fundraising_team;
      }

      if (
        'sponsorship' in preparedData &&
        'raisenow_sponsorships' in actualDonation.raisenow_config &&
        preparedData.sponsorship in
          actualDonation.raisenow_config.raisenow_sponsorships
      ) {
        preparedData.stored_sxt_product_id =
          actualDonation.raisenow_config.raisenow_sponsorships[
            preparedData.sponsorship
          ].stored_sxt_product_id;
      } else if ('stored_sxt_product_id' in actualDonation.raisenow_config) {
        preparedData.stored_sxt_product_id =
          actualDonation.raisenow_config.stored_sxt_product_id;
      }

      if ('stored_sxt_address_source' in actualDonation.raisenow_config) {
        preparedData.stored_sxt_address_source =
          actualDonation.raisenow_config.stored_sxt_address_source;
      }
      // for Sextant we need a special mapping for both title and salutation
      // that is added in raisenow.paymentObjectAdapter.js
      preparedData.stored_title = $scope.donations.donationModel.title;
      preparedData.stored_customer_salutation =
        $scope.donations.donationModel.title;

      if (
        'raisenow_use_salesforce' in actualDonation.raisenow_config &&
        preparedData.raisenow_use_salesforce
      ) {
        // Salesforce needs just the location code as a string e.g. bahnhofzoo
        preparedData.stored_marketing_location_identifier = formHelperFactory.getValueOfTitleMap(
          vm.donation_form_config.form,
          'location',
          $scope.donations.donationModel.location,
          'code'
        );
        // stored_sf_Contact_Occupation__c
        preparedData.stored_sf_Contact_Occupation__c = formHelperFactory.getValueOfTitleMap(
          vm.donation_form_config.form,
          'occupation',
          $scope.donations.donationModel.occupation
        );
      } else {
        // default to old behaviour (for Sextant)
        // stored_sxt_marketing_location  = Fields(Werbeort=%s), %s replaced by location.code
        // eg. "Fields(Werberort=bahnhofzoo)"
        preparedData.stored_sxt_marketing_location =
          'Fields(Werbeort=' +
          formHelperFactory.getValueOfTitleMap(
            vm.donation_form_config.form,
            'location',
            $scope.donations.donationModel.location,
            'code'
          ) +
          ')';
      }

      // additional radio buttons key-value – stored_sxt_partner_keywords: ["value", "value2"]
      preparedData.stored_sxt_partner_keywords = filterAllSextantKeywords(
        vm.donation_form_config,
        vm.qa_form_config,
        vm.form_config,
        formData
      );
      preparedData.fallbackEmail =
        actualDonation.raisenow_config.email_fallback_address;
      // XXX added here the stored_campaign_id
      preparedData.stored_campaign_id =
        actualDonation.raisenow_config.stored_campaign_id;
    }

    // prepare additional text-fields
    for (var key in preparedData) {
      // if the field is an additional field and exists in form config
      if (
        key.indexOf('form_additional_text_field_') === 0 &&
        angular.isObject(actualDonation) &&
        'form_config' in actualDonation &&
        angular.isObject(actualDonation.form_config) &&
        'schema' in actualDonation.form_config &&
        angular.isObject(actualDonation.form_config.schema) &&
        'properties' in actualDonation.form_config.schema &&
        key in actualDonation.form_config.schema.properties &&
        'type' in actualDonation.form_config.schema.properties[key]
      ) {
        // if it is a date field
        if (actualDonation.form_config.schema.properties[key].type === 'date') {
          // reformat if date given else set no date
          if (preparedData[key] && moment(preparedData[key]).isValid()) {
            preparedData[key] = moment(preparedData[key]).format('YYYY-MM-DD');
          } else {
            preparedData[key] = null;
          }
        }
      }
    }
    if ('signature' in preparedData) {
      preparedData.signature = prepareSignature(
        preparedData.signature,
        'signature'
      );
    }
    return preparedData;
  }

  function prepareSignature(signatureData, key) {
    if (!signatureData) {
      return null;
    }
    var wH = [];
    wH.push(parseInt(document.getElementById(key).getAttribute('width')));
    wH.push(parseInt(document.getElementById(key).getAttribute('height')));
    return signatureConverter.toHtmlSvg(signatureData, wH);
  }

  function prepareForm(formObj) {
    formObj = angular.copy(formObj);
    //iterate field sets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate field set items
      angular.forEach(fieldset.items, function(item, k) {
        switch (item.key) {
          case 'signature':
            item.validSignatureDir = 1;
            break;
        }
      });
    });
    return formObj;
  }

  function isSignatureValid() {
    var schemaProperties =
      actualDonation.form_config_signature.schema.properties;
    var signatureRequired = true; // by default we require the signature
    // if the required property is present in the schemaForm schema,
    // infer if the signature should be validated or not
    if (
      'signature' in schemaProperties &&
      'required' in schemaProperties.signature
    ) {
      signatureRequired = schemaProperties.signature.required;
    }
    if (signatureRequired) {
      return (
        signatureConverter.toDataURL(
          $scope.donations.donationModel.signature,
          'image/svg+xml'
        ) !== false
      );
    } else {
      // if signature not required consider the signature valid
      return true;
    }
  }

  function filterAllSextantKeywords(
    donationFormConfig,
    qaFormConfig,
    signatureFormConfig,
    formData
  ) {
    var keywords = [];
    keywords = keywords.concat(
      filterSextantKeywords(donationFormConfig, formData)
    );
    keywords = keywords.concat(filterSextantKeywords(qaFormConfig, formData));
    keywords = keywords.concat(
      filterSextantKeywords(signatureFormConfig, formData)
    );
    return keywords;
  }

  function filterSextantKeywords(formConfig, formData) {
    resultsArray = [];
    for (var i = 0; i < formConfig.form.length; ++i) {
      var fieldset = formConfig.form[i];
      for (var j = 0; j < fieldset.items.length; ++j) {
        var field = fieldset.items[j];
        if (field.type === 'radiosWithContent') {
          var fieldData = formHelperFactory.getValueOfTitleMap(
            formConfig.form,
            field.key,
            formData[field.key],
            null,
            true
          );
          if (
            fieldData &&
            'sextant_keyword' in fieldData &&
            fieldData.sextant_keyword
          ) {
            resultsArray.push(fieldData.sextant_keyword_value);
          }
        }
      }
    }
    return resultsArray;
  }
}

angular
  .module('donations', [
    'donations.print-summary',
    'summary',
    'filter',
    'generalModal'
  ])
  .factory('DonationsService', DonationsService)
  .controller('DonationsController', DonationsController)
  .controller('DonationsFormController', DonationsFormController)
  .controller('DonationsGiftController', DonationsGiftController)
  .controller('DonationsQaController', DonationsQaController)
  .controller('DonationsSignatureController', DonationsSignatureController)
  .config([
    '$stateProvider',
    'AuthenticationSetConstant',
    function($stateProvider, AuthenticationSetConstant) {
      $stateProvider
        .state('app.donations', {
          abstract: true,
          url: '/donations/:cid/:lang',
          templateUrl: 'app/pages/donations/donations.view.html',
          controller: 'DonationsController as donations',
          resolve: {
            //@TODO minification save resolver function => move to bottom and use $inject. then just reference here
            actualDonation: [
              '$stateParams',
              'DonationsService',
              function($stateParams, DonationsService) {
                return DonationsService.getDonation(
                  $stateParams.cid,
                  $stateParams.lang
                );
              }
            ],
            analyticsEventFactory: [
              '$stateParams',
              'AnalyticsService',
              function($stateParams, AnalyticsService) {
                return AnalyticsService.eventFactory({
                  sourceCategory: 'campaign-form',
                  sourceId: $stateParams.cid
                });
              }
            ]
          },
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.donations.form', {
          url: '/form',
          templateUrl: 'app/pages/donations/form-step/donations.form.view.html',
          controller: 'DonationsFormController as donationsFormStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.donations.gift', {
          url: '/gift/:recipientPage',
          templateUrl: 'app/pages/donations/gift-step/donations.gift.view.html',
          controller: 'DonationsGiftController as donationsGiftStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.donations.qa', {
          url: '/qa',
          templateUrl: 'app/pages/donations/qa-step/donations.qa.view.html',
          controller: 'DonationsQaController as donationsQaStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.donations.signature', {
          url: '/signature',
          templateUrl:
            'app/pages/donations/signature-step/donations.signature.view.html',
          controller: 'DonationsSignatureController as donationsSignatureStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        });
    }
  ]);

FilterpanelChannel.$inject = ['BaseChannel', 'FilterpanelChannelConstant'];
function FilterpanelChannel(BaseChannel, FilterpanelChannelConstant) {
  //setup and return service
  var fundraisersChannelService = {
    //fundraisers list request
    pubFilterUpdated: pubFilterUpdated,
    subFilterUpdated: subFilterUpdated
  };

  return fundraisersChannelService;

  ////////////

  //Filterpanel list request functions

  /**
   * pubFilterUpdated
   *
   * Publish the FilterpanelFilterUpdated event with giver args
   *
   * @param    {Object} args The events arguments
   *
   *
   **/
  function pubFilterUpdated(args) {
    BaseChannel.pubRootEmit(FilterpanelChannelConstant.filterUpdated, args);
  }

  /**
   * subFilterUpdated
   *
   * subscribe for the FilterpanelFilterUpdated event
   *
   * @param    {Object} _Scope The scope that calls the channels subFilterUpdated function
   * @param    {function} scopeHandler The callback handler for FilterUpdated event
   *
   * @return    {function} The unsubscribe function from the $rootScope.on() call
   *
   **/
  function subFilterUpdated(_Scope, scopeHandler) {
    var prepArgs = function(args) {
      return args;
    };

    var unsubsSopeHandler = BaseChannel.subRootEmit(
      FilterpanelChannelConstant.filterUpdated,
      _Scope,
      scopeHandler,
      prepArgs
    );

    return unsubsSopeHandler;
  }

  //________________________________________________________________________________________________________________________________________
}

FilterpanelController.$inject = [
  'achievementsService',
  '$state',
  '$translate',
  '$filter',
  '$window',
  'cachingService',
  'FilterpanelChannel',
  'AuthenticationService',
  'ApiConstant',
  'FundraisersResource'
];
function FilterpanelController(
  achievementsService,
  $state,
  $translate,
  $filter,
  $window,
  cachingService,
  FilterpanelChannel,
  AuthenticationService,
  ApiConstant,
  FundraisersResource
) {
  /* jshint validthis: true */
  var vm = this;
  vm.serverUrl = ApiConstant.system_instance;
  vm.debugUser = {};
  vm.debugRefresh = {};
  vm.noCampaignMessage = '';

  vm.currentUserData = {};
  vm.userToken = '';

  vm.filters = {
    total: 'total',
    today: 'today',
    date: 'date',
    week: 'week',
    month: 'month'
  };
  vm.weeks = calcWeeks(52);
  vm.months = calcMonths(24);

  vm.formData = {};
  vm.formData.startDate = null;
  vm.formData.endDate = null;
  vm.formData.selectedWeek = vm.weeks[0];
  vm.formData.selectedMonth = vm.months[0];

  vm.selectedFilter = vm.filters.today;
  vm.changeSelectedFilter = changeSelectedFilter;
  vm.updateDateRange = updateDateRange;
  vm.getFilterRequestParams = getFilterRequestParams;

  vm.goToCampaignForm = goToCampaignForm;
  vm.goToPetitionForm = goToPetitionForm;
  vm.goToRecruitingForm = goToRecruitingForm;

  _updateFilterValues(vm.selectedFilter);
  init();

  ///////////////////

  function init() {
    vm.currentUserData = AuthenticationService.getCurrentUser();
    vm.lang = vm.currentUserData.language;
    vm.userToken = AuthenticationService.getTokenData('access_token');

    if (
      'settings' in vm.currentUserData &&
      'has_gamification' in vm.currentUserData.settings &&
      vm.currentUserData.settings.has_gamification
    ) {
      achievementsService.refreshNewAchievements();
    }

    if (
      'campaigns' in vm.currentUserData &&
      angular.isArray(vm.currentUserData.campaigns) &&
      'petition_campaigns' in vm.currentUserData &&
      angular.isArray(vm.currentUserData.petition_campaigns)
    ) {
      if (
        vm.currentUserData.campaigns.length == 0 &&
        vm.currentUserData.petition_campaigns.length == 0
      ) {
        vm.noCampaignMessage = $translate.instant(
          'You have no campaigns or petitions applied'
        );
      }
    } else {
      vm.noCampaignMessage = '';
    }
  }

  function goToCampaignForm(id, useNextForm, presentation) {
    // if there is a presentation defined, we go to next's info materials
    if (presentation) {
      $window.location.href = '/next/forms/' + id + '/start';
    } else {
      if (useNextForm) {
        $window.location.href = '/next/forms/' + id;
      } else {
        $state.go('app.donations.form', { cid: id, lang: vm.lang });
      }
    }
  }

  function goToPetitionForm(id) {
    $state.go('app.petitions.form', { pid: id, lang: vm.lang });
  }

  function goToRecruitingForm(id) {
    $state.go('app.recruitings.form', { rid: id, lang: vm.lang });
  }

  function changeSelectedFilter(newFilter) {
    vm.selectedFilter = vm.filters[_coerceFilter(newFilter)];
    _updateFilterValues(vm.selectedFilter);
    FilterpanelChannel.pubFilterUpdated(vm.selectedFilter);
  }

  function _updateFilterValues(filter) {
    switch (filter) {
      case vm.filters.today:
        _setStartEndFromTimespan({ from: new Date(), to: new Date() });
        vm.formData.selectedWeek = vm.weeks[0];
        vm.formData.selectedMonth = vm.months[0];
        return;

      case vm.filters.week:
        vm.formData.startDate = '';
        vm.formData.endDate = '';
        vm.formData.selectedMonth = vm.months[0];
        return;

      case vm.filters.month:
        _setStartEndFromTimespan(vm.formData.selectedMonth.timespan);
        vm.formData.selectedWeek = vm.weeks[0];
        return;

      case vm.filters.date:
        vm.formData.selectedWeek = vm.weeks[0];
        vm.formData.selectedMonth = vm.months[0];
        return;

      case vm.filters.total:
        vm.formData.startDate = '';
        vm.formData.endDate = '';
        vm.formData.selectedWeek = vm.weeks[0];
        vm.formData.selectedMonth = vm.months[0];
        return;
    }
  }

  function updateDateRange(startOrEnd) {
    var start = vm.formData.startDate;
    var end = vm.formData.endDate;

    // start or end was explicitly unset
    if (!(startOrEnd === 'start' ? start : end)) {
      return;
    }

    // Make sure that the "other" date is correctly set
    switch (startOrEnd) {
      case 'start':
        if (moment(start).isAfter(moment(end))) {
          end = start;
        }
        break;
      case 'end':
        if (moment(end).isBefore(moment(start))) {
          start = end;
        }
        break;
    }

    _setStartEndFromTimespan({
      from: start,
      to: end
    });
  }

  /**
   * Coerces the `selectedFilter` so that it fallsback to a different
   * filter when no data is avaiable for the given `selectedFilter`.
   *
   * @param {*} selectedFilter Filter that was selected by the user.
   * @returns
   * The coerced filter that should be selected.
   */
  function _coerceFilter(selectedFilter) {
    switch (selectedFilter) {
      case vm.filters.week:
        return vm.formData.selectedWeek.value === vm.weeks[0].value
          ? vm.filters.today
          : selectedFilter;
      case vm.filters.month:
        return vm.formData.selectedMonth.value === vm.months[0].value
          ? vm.filters.today
          : selectedFilter;
      case vm.filters.date:
        // Both dates must be set to use the date filter
        if (!vm.formData.startDate && !vm.formData.endDate) {
          return vm.filters.today;
        }

        var startDate = moment(vm.formData.startDate);
        var endDate = moment(vm.formData.endDate);

        // If both dates are set to "today", use today filter
        if (
          startDate.isSame(endDate, 'day') &&
          startDate.isSame(moment(), 'day')
        ) {
          return vm.filters.today;
        }

        // If both dates are set to the selected month, use month filter
        var selectedMonth = vm.formData.selectedMonth;
        if (
          'timespan' in selectedMonth &&
          startDate.isSame(moment(selectedMonth.timespan.from), 'day') &&
          endDate.isSame(moment(selectedMonth.timespan.to), 'day')
        ) {
          return vm.filters.month;
        }

        // Otherwise use date filter
        return selectedFilter;
    }

    return selectedFilter;
  }

  /**
   * Updates the start / end date form data based on the given timespan.
   *
   * @param {{from: Date, to: Date}} timespan Timespan
   */
  function _setStartEndFromTimespan(timespan) {
    vm.formData.startDate = timespan.from;
    vm.formData.endDate = timespan.to;
  }

  function getFilterRequestParams() {
    function _makeTimespanFilter(filters) {
      return {
        timespan: {
          from: $filter('date')(filters.from, 'yyyy-MM-dd'),
          to: $filter('date')(filters.to, 'yyyy-MM-dd')
        }
      };
    }

    switch (vm.selectedFilter) {
      case vm.filters.total:
        return {};
      // Filters for "Today", "Month" and "Date" should all synchronize
      // via start / end date
      case vm.filters.today:
      case vm.filters.date:
      case vm.filters.month:
        return _makeTimespanFilter({
          from: vm.formData.startDate,
          to: vm.formData.endDate
        });
      case vm.filters.week:
        var week =
          angular.isObject(vm.formData) &&
          angular.isObject(vm.formData.selectedWeek) &&
          'value' in vm.formData.selectedWeek &&
          vm.formData.selectedWeek.value
            ? vm.formData.selectedWeek.value
            : null;
        return { week: week };
      default:
        return '';
    }
  }

  function calcWeeks(numOfWeeks) {
    var now = new Date(),
      currentWeekNum = getWeekOfYear(now),
      // In case the week already belongs to the next year, take the next year
      currentYear =
        now.getFullYear() +
        (now.getMonth() === 11 && currentWeekNum === 1 ? 1 : 0),
      lastYear = currentYear - 1,
      weeksLeftInPastYear = Math.max(numOfWeeks - currentWeekNum, 0),
      weeksInCurrentYear = Math.min(numOfWeeks, currentWeekNum),
      totalWeeksInPastYear = getWeeksOfYear(lastYear),
      weeks = [{ value: '', name: $translate.instant('Week') }];

    //create weeks till start of this year
    var weekNum = currentWeekNum;

    for (var i = 0; i < weeksInCurrentYear; i++) {
      weekNum = currentWeekNum - i;
      pushWeek(currentYear, weekNum);
    }

    //create weeks in past year
    if (weeksLeftInPastYear) {
      weekNum = totalWeeksInPastYear;
      weekNum = weekNum < 10 ? '0' + weekNum : weekNum;

      for (var j = 0; j < weeksLeftInPastYear; j++) {
        weekNum = totalWeeksInPastYear - j;
        pushWeek(lastYear, weekNum);
      }
    }

    return weeks;

    //////////////////////

    function pushWeek(y, w) {
      w = w < 10 ? '0' + w : w;
      weeks.push({ value: y + '-' + w, name: y + '-' + w });
    }

    function getWeekOfYear(year, month, day) {
      function serial(days) {
        return 86400000 * days;
      }

      function dateserial(year, month, day) {
        return new Date(year, month - 1, day).valueOf();
      }

      function weekday(date) {
        return new Date(date).getDay() + 1;
      }

      function yearserial(date) {
        return new Date(date).getFullYear();
      }

      var date =
          year instanceof Date
            ? year.valueOf()
            : typeof year === 'string'
            ? new Date(year).valueOf()
            : dateserial(year, month, day),
        date2 = dateserial(
          yearserial(date - serial(weekday(date - serial(1))) + serial(4)),
          1,
          3
        );

      return ~~((date - date2 + serial(weekday(date2) + 5)) / serial(7));
    }

    function getWeeksOfYear(year) {
      var firstDayOfYear = new Date(year, 0, 1);
      var days = firstDayOfYear.getDay() + (isLeapYear(year) ? 366 : 365);

      return Math.ceil(days / 7);
    }

    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }
  }

  function calcMonths(numOfMonths) {
    /** @type {import('moment').Moment} */
    var currentDate = moment(new Date()).startOf('month');
    var months = [{ value: '', name: $translate.instant('Month') }];

    for (var i = 0; i < numOfMonths; ++i) {
      var startOfMonth = currentDate.clone();
      months.push({
        value: startOfMonth.format('YYYY-MM'),
        name: startOfMonth.format('YYYY MMM'),
        timespan: {
          from: startOfMonth.toDate(),
          to: moment(startOfMonth)
            .endOf('month')
            .toDate()
        }
      });

      currentDate.subtract(1, 'month');
    }

    return months;
  }
}

angular
  .module('filterpanel', [
    ,
    'da.commons.directives.toggleByProp',
    'da.commons.directives.toggleBySet'
  ])

  .constant('FilterpanelChannelConstant', {
    filterUpdated: 'event:filterpanel-updated'
  })
  .controller('FilterpanelController', FilterpanelController)
  .factory('FilterpanelChannel', FilterpanelChannel)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.filter', {
        url: '/filter',
        abstract: true,
        templateUrl: 'app/pages/filterpanel/filterpanel.view.html',
        controller: 'FilterpanelController as filterpanel',
        data: {
          access: 'is_active'
        }
      });
    }
  ]);

HomeController.$inject = [
  '$scope',
  '$q',
  '$translate',
  '$uibModal',
  'FilterpanelChannel',
  'AuthenticationService',
  'dashboardsResource',
  'spinnerService',
  'IndexedDbService',
  'DonationsResource',
  'offlineStore'
];
function HomeController(
  $scope,
  $q,
  $translate,
  $uibModal,
  FilterpanelChannel,
  AuthenticationService,
  dashboardsResource,
  spinnerService,
  IndexedDbService,
  DonationsResource,
  offlineStore
) {
  $scope.app.headline = 'Home';

  /* jshint validthis: true */
  var vm = this;
  vm.fundraiserSelfStats = {};
  vm.jobscoutSelfStats = {};
  vm.ageLimit = AuthenticationService.getCurrentUser().age_limit;
  vm.dashboard;

  vm.filterChangedHandler = filterChangedHandler;

  FilterpanelChannel.subFilterUpdated($scope, filterChangedHandler);

  var promises = [];
  if (navigator.onLine) {
    // If online, get donations and logs from IndexedDb and upload them
    promises.push(uploadAndDeleteIndexedDbData('logs'));
    promises.push(uploadAndDeleteIndexedDbData('donations', 'key'));
  }

  $q.all(promises).then(function() {
    checkForOfflineData();
  });

  /**
   * @param {string} store The name of the store
   * @param {string} [key=id] The name of the key property for this store
   *
   * @returns {Promise<string>}
   * A promise that resolves with a string describing the final state.
   */
  function uploadAndDeleteIndexedDbData(store, key) {
    key = key || 'id';

    return IndexedDbService.list(store).then(
      function(objects) {
        // Don't upload anything, if we don't have any data
        if (objects.length === 0) {
          return 'nothing to delete';
        }

        return DonationsResource.createRaw(objects, false).then(
          function(s) {
            var keys = objects.map(function(object) {
              return object[key];
            });

            return IndexedDbService.delete(store, keys).then(
              function() {
                return 'success';
              },
              function() {
                return 'deleting entries from IDB failed';
              }
            );
          },
          function() {
            return 'storing to raw failed';
          }
        );
      },
      function() {
        return 'listing entries from IDB failed';
      }
    );
  }

  /**
   * Checks if there are any pending datasets stored offline for more than 1 day
   * and shows a warning modal, if this applies.
   */
  function checkForOfflineData() {
    var oneDayInMiliseconds = 24 * 60 * 60 * 1000;

    /**
     * @param {Date} timestamp The timestamp to check
     *
     * @returns {boolean}
     * True, if the timestamp is older than 1 day
     */
    function isOlderThanOneDay(timestamp) {
      return Date.now() - timestamp.getTime() > oneDayInMiliseconds;
    }

    /**
     * @returns {Promise<object[]>}
     * A promise that resolves with an array of pending entries.
     * If data couldn't be read, the promise resolves with an empty array.
     */
    function getPendingFromIndexedDB() {
      return IndexedDbService.query('donations', function(entry) {
        // Since the indexedDB entries do not have a createtime
        // property, we need to extract the timestamp from the key.
        var key = entry.key;
        if (typeof key !== 'string') {
          return false;
        }

        // Keys look like this: '<campaignID>_<type>__<timestamp>'
        var splitResult = key.split('__');
        if (splitResult.length !== 2) {
          return false;
        }

        var timestampAsNumber = Number.parseInt(splitResult[1]);
        if (Number.isNaN(timestampAsNumber)) {
          return false;
        }

        return isOlderThanOneDay(new Date(timestampAsNumber));
      }).catch(function() {
        return []; // In case of an error, we provide an empty array
      });
    }

    /**
     * @returns {object[]}
     * An array of pending entries
     */
    function getPendingFromOfflineStore() {
      var entries = offlineStore.queryOfflineData(function(entry) {
        var timestamp =
          // versionNumber isn't set for certain entries (e.g. time tracking)
          typeof entry.versionNumber === 'string' &&
          entry.versionNumber.startsWith('next')
            ? new Date(entry.timestamp)
            : new Date(entry.createtime);

        return isOlderThanOneDay(timestamp);
      });

      return entries;
    }

    var entriesOfflineStorage = getPendingFromOfflineStore();

    getPendingFromIndexedDB().then(function(entriesIndexedDb) {
      if (entriesOfflineStorage.length === 0 && entriesIndexedDb.length === 0) {
        // No data is offline stored
        return;
      }

      // Show modal
      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return '';
          },
          text: function() {
            var texts = [
              $translate.instant(
                'Please upload all your offline stored datasets now, by clicking the red button at the bottom of the dashboard.'
              ),
              $translate.instant(
                'Offline datasets will be deleted after being stored locally (on your device) longer than 7 days.'
              ),
              $translate.instant(
                'We are showing this warning to you because we have noticed that one or more datasets are stored locally since more than 24 hours.'
              )
            ];

            return '<p>' + texts.join('</p><p>') + '</p>';
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return true;
          }
        }
      });
    });
  }

  ///////////////////

  function filterChangedHandler() {
    getDashboard($scope.filterpanel.getFilterRequestParams());
  }

  function getDashboard(filters) {
    spinnerService.show('homeSelfStats');

    dashboardsResource
      .getUser(filters)
      .then(function(response) {
        vm.dashboard = response.data;
      })
      .catch(angular.noop)
      .finally(function() {
        spinnerService.hide('homeSelfStats');
      });
  }
}

angular
  .module('home', [])
  .controller('HomeController', HomeController)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.filter.home', {
        url: '/home',
        views: {
          home: {
            templateUrl: 'app/pages/home/home.view.html',
            controller: 'HomeController as home'
          }
        },
        data: {
          access: 'is_active'
        }
      });
    }
  ]);

LoginController.$inject = [
  '$state',
  'AuthenticationService',
  'locationsService',
  '$localStorage',
  'offlineStore',
  'cachingService'
];
function LoginController(
  $state,
  AuthenticationService,
  locationsService,
  $localStorage,
  offlineStore,
  cachingService
) {
  // jshint validthis: true
  var vm = this;

  // store requests
  vm.loginServerErrors = false;
  vm.loginData = {
    username: $localStorage.lastLoginName
  };

  // test request
  vm.doLogin = doLogin;
  vm.isLoginPending = false;

  //__________________________________________________________________________________________________

  /////////////////////

  // login request

  // do request
  function doLogin(loginForm) {
    if (loginForm.$valid) {
      vm.isLoginPending = true;
      cachingService.clearHttpCaches();

      AuthenticationService.login(vm.loginData)
        .then(
          //login success
          function(data) {
            offlineStore.persistAllFromOfflineCacheToServer();

            $localStorage.lastLoginName = vm.loginData.username;
            vm.loginServerErrors = false;
            //@TODO implement image cache
            if (locationsService.needsLocation()) {
              $state.go('app.locationselect');
            } else {
              $state.go('app.filter.home');
            }
          }
        )
        .catch(
          //login error
          function(error) {
            vm.loginErrorFeedback = error;
            vm.loginServerErrors = error.error_description
              ? error.error_description
              : error.error;
          }
        )
        .finally(function() {
          vm.isLoginPending = false;
        });
    }
  }
}

angular
  .module('login', [])
  .controller('LoginController', LoginController)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.view.html',
        controller: 'LoginController as login'
      });
    }
  ]);

PetitionsSignatureController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$filter',
  '$translate',
  'offlineStore',
  '$uibModal',
  'formHelperFactory',
  'actualPetition',
  'signatureConverter'
];
function PetitionsSignatureController(
  $scope,
  $state,
  $stateParams,
  $filter,
  $translate,
  offlineStore,
  $uibModal,
  formHelperFactory,
  actualPetition,
  signatureConverter
) {
  var vm = this;

  vm.stepState = 'signature';

  vm.form_config = actualPetition.form_config.form
    ? actualPetition.form_config.form
    : {};
  vm.form_config_signature = actualPetition.form_config_signature.form
    ? actualPetition.form_config_signature.form
    : {};
  vm.formWording = actualPetition.form_wording;
  vm.disclaimer_step2 = formHelperFactory.getFieldOfFormObj(
    vm.form_config_signature,
    'disclaimer_step2'
  );

  vm.uploadFormdata = uploadFormdata;
  vm.goBack = goBack;
  vm.actualPetition = actualPetition;

  init(actualPetition);

  //////////////////

  function init(petitionObj) {
    if (!offlineStore.pendingFormDataPresent()) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant('Invalid state');
          },
          text: function() {
            return $translate.instant(
              'No pending Formdata given! Return to start.'
            );
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return false;
          }
        }
      });

      modalInstance.result.then(function() {
        $state.go('app.petitions.form');
      });
    } else {
      $scope.petitions.petitionModel = offlineStore.getPendingFormData();
      vm.signature = undefined;
    }

    if (petitionObj.form_config_signature) {
      vm.form_config_signature = petitionObj.form_config_signature;
      vm.form_config_signature.form = prepareForm(
        petitionObj.form_config_signature.form
      );
      vm.summaryData = $scope.petitions.petitionModel;
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    $state.go('app.petitions.form');
  }

  /**
   * uploadFormdata
   *
   * check siganture and upload form
   *
   */
  function uploadFormdata(form) {
    $scope.$broadcast('schemaFormValidate');
    form.$setSubmitted(true);

    if (
      form.$valid &&
      signatureConverter.toDataURL(
        $scope.petitions.petitionModel.signature,
        'image/svg+xml'
      ) !== false
    ) {
      var preparedData = prepareFormDataForUpload(
        $scope.petitions.petitionModel
      );

      //delete data in local storage
      offlineStore.deletePendingFormData();

      offlineStore.savePersistFormData(
        preparedData,
        offlineStore.getTypes()[1]
      );

      $scope.petitions.petitionModel = {};
      $state.go('app.petitions.form');
    } else {
      form.signature.$setValidity('signatureDataValid', false);
    }
  }

  /**
   *
   * prepareFormDataForUpload
   *
   * adds campaignid and other formatting to the formdata
   * It is used in the onSubmit function
   *
   *
   **/
  function prepareFormDataForUpload(formData) {
    var preparedData = angular.copy(formData);
    if (!angular.isObject(preparedData)) {
      return preparedData;
    }

    preparedData.languageWhileCollection = $stateParams.lang;

    if (
      angular.isObject(preparedData.location) &&
      'title' in preparedData.location
    ) {
      preparedData.location = preparedData.location.title;
    }

    if ('date_of_birth' in preparedData) {
      if (
        preparedData.date_of_birth &&
        moment(preparedData.date_of_birth).isValid()
      ) {
        preparedData.date_of_birth = moment(preparedData.date_of_birth).format(
          'YYYY-MM-DD'
        );
      } else {
        preparedData.date_of_birth = null;
      }
    }

    preparedData.campaign = actualPetition.id;
    preparedData.signature = prepareSignature(
      preparedData.signature,
      'signature'
    );

    return preparedData;
  }

  function prepareSignature(signatureData, key) {
    var wH = [];
    wH.push(parseInt(document.getElementById(key).getAttribute('width')));
    wH.push(parseInt(document.getElementById(key).getAttribute('height')));
    return signatureConverter.toHtmlSvg(signatureData, wH);
  }

  function prepareForm(formObj) {
    formObj = angular.copy(formObj);
    //iterate field sets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate field set items
      angular.forEach(fieldset.items, function(item, k) {
        switch (item.key) {
          case 'signature':
            item.validSignatureDir = 1;
            break;
        }
      });
    });
    return formObj;
  }
}

PetitionsController.$inject = [
  '$scope',
  'AuthenticationService',
  '$translate',
  '$stateParams',
  'offlineStore',
  '$uibModal',
  '$state',
  '$localStorage',
  'formHelperFactory',
  'actualPetition'
];
function PetitionsController(
  $scope,
  AuthenticationService,
  $translate,
  $stateParams,
  offlineStore,
  $uibModal,
  $state,
  $localStorage,
  formHelperFactory,
  actualPetition
) {
  //viewmodel setup
  var vm = this;

  if ('lang' in $stateParams && $stateParams.lang) {
    $translate.use($stateParams.lang).then(function() {
      vm.petitionsForm_options = {
        validationMessage: {
          302: $translate.instant('Required'),
          'autocomplete-required': $translate.instant('Required')
          //105 : $translate.instant("wrong number")
        }
      };
      init();
    });
  }

  $scope.$on('$stateChangeStart', function(
    event,
    toState,
    toParams,
    fromState,
    fromParams
  ) {
    if (toState.name.indexOf('app.petitions') === -1) {
      $translate.use(AuthenticationService.getCurrentUser().language);
    }
  });

  vm.configurableStyles = {};
  vm.stamp_image = '';

  //form-settings-menu
  vm.formId = actualPetition.id;
  vm.baseState = 'app.petitions.';
  vm.supported_languages = actualPetition.supported_languages;

  //all data are collected in tis obj and filled in each step
  vm.petitionModel = {};
  vm.petitionsForm_options = {};
  vm.resetForm = resetForm;

  init();

  ////////////////////////

  /**
   *
   */
  function init() {
    if (actualPetition !== false) {
      prepareStyles(actualPetition);
      vm.stamp_image = actualPetition.stamp_image;
    } else {
      $state.go('app.filter.home');
    }
  }

  /**
   *
   */
  function resetForm() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Reset form');
        },
        text: function() {
          return $translate.instant('Do you really want to reset the form?');
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      vm.petitionModel = {};
      offlineStore.deletePendingFormData();
      //reset location select
      $('.petitions-view select[name=location]')
        .parent()
        .find('.select2-chosen')
        .html('');
      if ('lastLocationPetition' in $localStorage) {
        vm.petitionModel.location = formHelperFactory.getLocationAutofill(
          $localStorage.lastLocationPetition,
          $scope.petitions.petitionModel['location']
        );
      }
      //reset form
      vm.petitionForm.$setPristine();
      $state.go('app.petitions.form');
    });
  }

  /**
   * prepareStyles
   *
   * creates a style obj that holds all configurable styles from server in separate sections
   *
   * @param petintionObj
   */
  function prepareStyles(petintionObj) {
    vm.configurableStyles.all = {
      'background-image': "url('" + petintionObj.background_image + "')"
    };

    if (petintionObj.background_color !== '#000000') {
      vm.configurableStyles.all['background-color'] =
        petintionObj.background_color;
    }
  }
}

PetitionsFormController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$stateParams',
  '$filter',
  '$translate',
  '$uibModal',
  'formHelperFactory',
  'offlineStore',
  '$localStorage',
  'actualPetition',
  'AuthenticationService',
  '$window'
];
function PetitionsFormController(
  $scope,
  $timeout,
  $state,
  $stateParams,
  $filter,
  $translate,
  $uibModal,
  formHelperFactory,
  offlineStore,
  $localStorage,
  actualPetition,
  AuthenticationService,
  $window
) {
  var dateFilter = $filter('date'),
    numberFilter = $filter('number'),
    requestPending = false;

  var vm = this;

  vm.stepState = 'form';

  vm.header_image = '';
  vm.form_config = {};

  vm.goBack = goBack;
  vm.goToNext = goToNext;

  init(actualPetition);

  ////////////////

  /**
   * init
   *
   * Al initial stuff here
   *
   */
  function init(petitionObj) {
    if (offlineStore.pendingFormDataPresent()) {
      var store = offlineStore.getPendingFormData();
      $scope.petitions.petitionModel = store;
      if (store['date_of_birth'] && moment(store['date_of_birth']).isValid()) {
        $scope.petitions.petitionModel.date_of_birth = new Date(
          store['date_of_birth']
        );
      }
    }

    if (angular.isObject(petitionObj)) {
      /*START Location value*/
      if (
        'form_config' in petitionObj &&
        'schema' in petitionObj.form_config &&
        'properties' in petitionObj.form_config.schema &&
        petitionObj.form_config.schema.properties &&
        'location' in petitionObj.form_config.schema.properties
      ) {
        var modelLocValue = $scope.petitions.petitionModel['location'];
        var locValue = false;
        if (
          'lastLocationPetition' in $localStorage &&
          $localStorage.lastLocationPetition &&
          'value' in $localStorage.lastLocationPetition
        ) {
          locValue = $localStorage.lastLocationPetition;
        }
        $scope.petitions.petitionModel[
          'location'
        ] = formHelperFactory.getLocationAutofill(locValue, modelLocValue);
      }
      /*END Location value*/

      if (petitionObj.form_config) {
        vm.form_config = petitionObj.form_config;

        prepareForm(vm.form_config.form);

        $scope.petitions.petitionModel = angular.merge(
          {}, // Extend empty object
          // ...with the values from the config
          petitionObj.form_config.model,
          // ...and make sure that we don't override the already available values
          $scope.petitions.petitionModel
        );
      }
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Go back to dashboard');
        },
        text: function() {
          return $translate.instant(
            'If you go back, the form will lose data. Do you really want to do this?'
          );
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      //delete all pending formdata in local storage
      offlineStore.deletePendingFormData();

      var currentUser = AuthenticationService.getCurrentUser();
      if (currentUser.settings['has_launcher'] == true) {
        // let the new frontend figure out the redirect
        $window.location.href = '/';
      } else {
        $state.go('app.filter.home');
      }
    });
  }

  function goToNext(form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');

    // Then we check if the form is valid
    if (form.$valid) {
      if ($scope.petitions.petitionModel.title != 3) {
        delete $scope.petitions.petitionModel.company_name;
      }

      //save to local storage as pending petition
      offlineStore.savePendingFormData($scope.petitions.petitionModel);
      $state.go('app.petitions.signature');
    } else {
      $timeout(function() {
        var firstInvalidField = $('#petition form')
          .find('.ng-invalid:visible')
          .first();
        $('html, body').animate(
          {
            scrollTop: firstInvalidField.offset().top - 30
          },
          100,
          function() {
            firstInvalidField.focus();
          }
        );
      }, 100);
    }
  }

  /**
   * prepareForm
   *
   * prepares our data form server for rendering
   *
   * @param formObj
   */
  function prepareForm(formObj) {
    /**
     * Holds the configuration for contact information requirement.
     *
     * @type {{min_count: number; required: string[]; }}
     */
    var contactRequiredConfig =
      'contact_required_config' in vm.form_config &&
      vm.form_config.contact_required_config;

    //iterate fieldsets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate fieldset items
      angular.forEach(fieldset.items, function(item, k) {
        // Add validation for any contact info required
        if (
          contactRequiredConfig &&
          contactRequiredConfig.required.includes(item.key)
        ) {
          item.someOfValidDir = 1;
          item.someOfValidFields = contactRequiredConfig.required.join(';');
          item.someOfValidNumOfMatches = contactRequiredConfig.min_count;
          item.validationMessage = {
            someOfValid: function(value) {
              return contactRequiredConfig.required.includes('email')
                ? $translate.instant('Email or phone number required')
                : $translate.instant('Phone or mobile number is required');
            }
          };
        }

        // Setup field
        switch (item.key) {
          case 'title':
            break;
          case 'company_name':
            item.condition = 'petitions.petitionModel.title == 3';
            break;
          case 'first_name':
            item.capitalizedDir = 1;
            item.isValidFirstName = 1;
            item.validFirstNameTitle = 'title';
            item.validFirstNameWarningMessage = $translate.instant(
              'Salutation may not be correct for this name'
            );
            break;
          case 'last_name':
            item.capitalizedDir = 1;
            break;
          case 'email':
            item.$validators = {
              isemail: function(value) {
                return formHelperFactory.isValidEmail(value);
              }
            };

            if (!item.validationMessage) {
              item.validationMessage = {};
            }
            item.validationMessage.isemail = function(ctx) {
              return $translate.instant('This is no valid email');
            };
            break;

          case 'date_of_birth':
            var field = actualPetition.form_config.schema.properties[item.key];
            formHelperFactory.configureDateOfBirthValidation(field, item, vm);
            break;

          case 'street':
            item.capitalizedDir = 1;
            break;

          case 'zip_code':
            item.uppercasedDir = 1;

            item.trimmedWhitespaceDir = 1;
            item.trimAllWhitespace = 1;

            item.gbPostCodeValidationDir = 1;
            item.gbPostCodeValidationCountry = 'country';

            item.gbPostCodeAreaValidationDir = 1;
            item.gbPostCodeAreaValidationCountry = 'country';

            item.validationMessage = {
              gbPostCode: function(ctx) {
                return $translate.instant('Wrong Post Code for GB');
              },
              gbPostArea: function(ctx) {
                return $translate.instant('Wrong Post Area for GB');
              }
            };

            break;

          case 'city':
            item.isCapitalized = 1;
            break;

          case 'country':
            break;

          case 'phone_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;
            break;

          case 'mobile_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;
            break;

          case 'send_sms':
            // Set the action for the sms button
            item.isSmsButton =
              actualPetition.form_config.model.enable_hlr_lookup === true
                ? 'hlr'
                : 'sms';

            item.targetFieldName = 'mobile_number';
            item.campaignId = actualPetition.id;
            item.campaignType = 'petition';
            item.campaignLang = '';
            if (
              $stateParams &&
              angular.isObject($stateParams) &&
              'lang' in $stateParams
            ) {
              item.campaignLang = $stateParams.lang;
            }
            break;

          case 'address_search':
            item.detailcb = formHelperFactory.copyValues;
            //@TODO fint better way with less params to get form model
            item.formIdToCopyIn = '#petition form';
            item.formNameToCopyIn = 'petitionForm';
            break;

          case 'location':
            item.onChange = function(value) {
              $localStorage.lastLocationPetition = {
                id: actualPetition.id,
                value: value
              };
            };
            break;

          default:
            if (item.key.indexOf('form_additional_text_field') == 0) {
              if ('pattern' in vm.form_config.schema.properties[item.key]) {
                //alphabetical
                if (
                  vm.form_config.schema.properties[item.key].pattern ==
                  '^[a-zA-Z]+$'
                ) {
                  item.validationMessage = {
                    202: $translate.instant('Can only contain characters')
                  };
                }
                //alphanumeric
                if (
                  vm.form_config.schema.properties[item.key].pattern ==
                  '^[a-zA-Z0-9]+$'
                ) {
                  item.validationMessage = {
                    202: $translate.instant(
                      'Can only contain characters and numbers'
                    )
                  };
                }
              }

              //numeric
              if (vm.form_config.schema.properties[item.key].type == 'number') {
                item.validationMessage = {
                  105: $translate.instant('Must be a number')
                };
              }
            }
            break;
        }
      });
    });
  }
}

PetitionsService.$inject = ['$q', 'AuthenticationService'];
function PetitionsService($q, AuthenticationService) {
  var service = {
    getPetition: getPetition
  };
  return service;

  ////////////

  /**
   *
   * getFormData
   *
   * fetches the formdata from the server and formats the data for the petition
   *
   *
   * @param petitionId
   */
  function getPetition(petitionId, language) {
    var petition = false,
      userData = AuthenticationService.getCurrentUser();

    if ('petition_campaigns' in userData) {
      angular.forEach(userData.petition_campaigns, function(v, k) {
        if (v.id == petitionId) {
          petition = angular.copy(v);

          if (!(language in petition.supported_languages)) {
            language = Object.keys(petition.supported_languages)[0];
          }

          if ('form_wording' in petition && language in petition.form_wording) {
            petition.form_wording = petition.form_wording[language];
          }

          if ('form_config' in petition) {
            if ('form' in petition.form_config) {
              petition.form_config.form = petition.form_config.form[language];
            }
          }

          if ('form_config_signature' in petition) {
            if ('form' in petition.form_config_signature) {
              petition.form_config_signature.form =
                petition.form_config_signature.form[language];
            }
          }

          if (
            'upload_modal_config' in petition &&
            language in petition.upload_modal_config
          ) {
            petition.upload_modal_config =
              petition.upload_modal_config[language];
          }
        }
      });
      return petition != false ? petition : false;
    } else {
      return false;
    }
  }
}

angular
  .module('petitions', ['summary', 'generalModal'])
  .controller('PetitionsController', PetitionsController)
  .controller('PetitionsFormController', PetitionsFormController)
  .controller('PetitionsSignatureController', PetitionsSignatureController)
  .factory('PetitionsService', PetitionsService)
  .config([
    '$stateProvider',
    'AuthenticationSetConstant',
    function($stateProvider, AuthenticationSetConstant) {
      $stateProvider
        .state('app.petitions', {
          abstract: true,
          url: '/petitions/:pid/:lang',
          templateUrl: 'app/pages/petitions/petitions.view.html',
          controller: 'PetitionsController as petitions',
          resolve: {
            //@TODO minification save resolver function => move to bottom and use $inject. then just reference here
            actualPetition: [
              '$stateParams',
              'PetitionsService',
              function($stateParams, PetitionsService) {
                return PetitionsService.getPetition(
                  $stateParams.pid,
                  $stateParams.lang
                );
              }
            ]
          },
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.petitions.form', {
          url: '/form',
          templateUrl: 'app/pages/petitions/form-step/petitions.form.view.html',
          controller: 'PetitionsFormController as petitionsFormStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        })
        .state('app.petitions.signature', {
          url: '/signature',
          templateUrl:
            'app/pages/petitions/signature-step/petitions.signature.view.html',
          controller: 'PetitionsSignatureController as petitionsSignatureStep',
          data: {
            access: AuthenticationSetConstant.coach_or_shift
          }
        });
    }
  ]);

RecruitingsController.$inject = [
  '$scope',
  'AuthenticationService',
  '$translate',
  '$stateParams',
  '$uibModal',
  '$filter',
  '$state',
  'actualRecruiting'
];
function RecruitingsController(
  $scope,
  AuthenticationService,
  $translate,
  $stateParams,
  $uibModal,
  $filter,
  $state,
  actualRecruiting
) {
  var dateFilter = $filter('date');

  //viewmodel setup
  var vm = this;

  $scope.$on('$stateChangeSuccess', function(
    event,
    toState,
    toParams,
    fromState,
    fromParams
  ) {
    if (toState.name.indexOf('app.recruitings') == 0) {
      if ('lang' in $stateParams && $stateParams.lang) {
        $translate.use($stateParams.lang).then(function() {
          vm.recruitingForm_options = {
            validationMessage: {
              302: $translate.instant('Required'),
              'autocomplete-required': $translate.instant('Required'),
              0: $translate('IInvalid type: {type} (expected {expected})')
              //105 : $translate.instant("wrong number")
            }
          };
        });
      }
    }
  });

  $scope.$on('$stateChangeStart', function(
    event,
    toState,
    toParams,
    fromState,
    fromParams
  ) {
    if (toState.name.indexOf('app.petitions') === -1) {
      $translate.use(AuthenticationService.getCurrentUser().language);
    }
  });

  vm.configurableStyles = {};
  vm.stamp_image = '';

  //form-settings-menu
  vm.formId = actualRecruiting.id;
  vm.baseState = 'app.recruitings.';
  vm.supported_languages = actualRecruiting.supported_languages;

  //all data are collected in tis obj and filled in each step
  vm.recruitingModel = {};
  vm.recruitingForm_options = {};

  vm.resetForm = resetForm;

  init();

  ////////////////////////

  /**
   *
   */
  function init() {
    if (actualRecruiting !== false) {
      vm.stamp_image = actualRecruiting.stamp_image;
      prepareStyles(actualRecruiting);
    } else {
      $state.go('app.filter.home');
    }
  }

  /**
   *
   */
  function resetForm() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Reset form');
        },
        text: function() {
          return $translate.instant('Do you really want to reset the form?');
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      vm.recruitingModel = {};
      //reset form
      vm.recruitingForm.$setPristine();
      $state.go('app.recruitings.form');
    });
  }

  /**
   * prepareStyles
   *
   * creates a style obj that holds all configurable styles from server in separate sections
   *
   * @param recruitingObj
   */
  function prepareStyles(recruitingObj) {
    vm.configurableStyles.all = {
      'background-image': "url('" + recruitingObj.background_image + "')"
    };

    if (recruitingObj.background_color !== '#000000') {
      vm.configurableStyles.all['background-color'] =
        recruitingObj.background_color;
    }
  }
}

RecruitingsFormController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$timeout',
  '$filter',
  '$translate',
  '$uibModal',
  'formHelperFactory',
  'offlineStore',
  'actualRecruiting',
  'signatureConverter',
  'AuthenticationService',
  '$window'
];
function RecruitingsFormController(
  $scope,
  $state,
  $stateParams,
  $timeout,
  $filter,
  $translate,
  $uibModal,
  formHelperFactory,
  offlineStore,
  actualRecruiting,
  signatureConverter,
  AuthenticationService,
  $window
) {
  var dateFilter = $filter('date'),
    numberFilter = $filter('number');

  var vm = this;

  vm.stepState = 'form';

  vm.header_image = '';
  vm.form_config = {};

  vm.goBack = goBack;
  vm.doUpload = doUpload;
  vm.signatureError = '';

  init(actualRecruiting);

  ////////////////

  /**
   * init
   *
   * Al initial stuff here
   *
   */
  function init(recruitingObj) {
    if (recruitingObj.form_config) {
      vm.form_config = recruitingObj.form_config;
      prepareForm(vm.form_config.form);

      $scope.recruitings.recruitingModel = angular.merge(
        $scope.recruitings.recruitingModel,
        recruitingObj.form_config.model
      );
    } else {
      $state.go('app.filter.home');
    }
  }

  function goBack() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
      controller: 'GeneralModalController as modal',
      size: 6,
      resolve: {
        title: function() {
          return $translate.instant('Go back to dashboard');
        },
        text: function() {
          return $translate.instant(
            'If you go back, the form will lose data. Do you really want to do this?'
          );
        },
        cancelGiven: function() {
          return true;
        },
        isTextAsHtml: function() {
          return false;
        }
      }
    });

    modalInstance.result.then(function() {
      var currentUser = AuthenticationService.getCurrentUser();
      if (currentUser.settings['has_launcher'] == true) {
        // let the new frontend figure out the redirect
        $window.location.href = '/';
      } else {
        $state.go('app.filter.home');
      }
    });
  }

  function doUpload(form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');
    form.$setSubmitted(true);

    //We wrap this in a timeout to let the form render all fields

    // Then we check if the form is valid
    if (
      // there's a signature pad, but the signature's not valid
      form.signature &&
      !signatureConverter.toDataURL(
        $scope.recruitings.recruitingModel.signature,
        'image/svg+xml'
      )
    ) {
      form.signature.$setValidity('signatureDataValid', false);
    }

    if (form.$valid) {
      var preparedData = prepareFormDataForUpload(
        $scope.recruitings.recruitingModel
      );

      offlineStore.savePersistFormData(
        preparedData,
        offlineStore.getTypes()[2]
      );

      $scope.recruitings.recruitingModel = {};
      $scope.recruitings.recruitingForm.$setPristine();

      $state.go('app.recruitings.form');
    } else {
      $timeout(function() {
        var firstInvalidField = $('#recruitingForm')
          .find('.ng-invalid:visible')
          .first();

        if (firstInvalidField) {
          $('html, body').animate(
            {
              scrollTop: firstInvalidField.offset().top - 30
            },
            100,
            function() {
              firstInvalidField.focus();
            }
          );
        }
      }, 100);
    }
  }

  /**
   *
   * prepareFormDataForUpload
   *
   * adds recruiting_campaignid and other formatting to the formdata
   * It is used in the onSubmit function
   *
   *
   **/
  function prepareFormDataForUpload(formData) {
    var preparedData = angular.copy(formData);

    preparedData.languageWhileCollection = $stateParams.lang;

    if (angular.isObject(preparedData) && 'date_of_birth' in preparedData) {
      preparedData.date_of_birth = $filter('date')(
        new Date(preparedData.date_of_birth),
        'yyyy-MM-dd'
      );
    }

    if (angular.isObject(preparedData) && 'start_of_work' in preparedData) {
      preparedData.start_of_work = $filter('date')(
        new Date(preparedData.start_of_work),
        'yyyy-MM-dd'
      );
    }

    preparedData.signature = prepareSignature(
      preparedData.signature,
      'signature'
    );

    function prepareSignature(signatureData, key) {
      if (!signatureData) {
        return null;
      }
      var wH = [];
      wH.push(parseInt(document.getElementById(key).getAttribute('width')));
      wH.push(parseInt(document.getElementById(key).getAttribute('height')));
      return signatureConverter.toHtmlSvg(signatureData, wH);
    }

    // preparedData.jobscout = ;
    return preparedData;
  }

  /**
   * prepareForm
   *
   * prepares our data form server for rendering
   *
   * @param formObj
   */
  function prepareForm(formObj) {
    //@TODO check if needed in recruitings
    //prepare phone_required_config
    if (angular.isObject(vm.form_config.phone_required_config)) {
      if (!('require_one' in vm.form_config.phone_required_config)) {
        vm.form_config.phone_required_config.require_one = false;
      }
    }

    //iterate fieldsets
    angular.forEach(formObj, function(fieldset, k) {
      //iterate fieldset items
      angular.forEach(fieldset.items, function(item, k) {
        switch (item.key) {
          case 'first_name':
            item.capitalizedDir = 1;
            break;

          case 'last_name':
            item.capitalizedDir = 1;
            break;

          case 'email':
            item.$validators = {
              isemail: function(value) {
                return formHelperFactory.isValidEmail(value);
              }
            };

            item.validationMessage = {
              isemail: function(ctx) {
                return $translate.instant('This is no valid email');
              }
            };
            break;

          case 'recruiting_campaign':
            item.onChange = function(campaign) {
              formHelperFactory.rerenderInput(
                $scope.recruitings.recruitingForm,
                'workload',
                '100',
                true
              );

              var max_date = formHelperFactory.getValueOfTitleMap(
                vm.form_config.form,
                'recruiting_campaign',
                campaign,
                'max_date_of_birth'
              );
              vm.form_config.schema.properties[
                'date_of_birth'
              ].maximum = max_date;

              $scope.recruitings.recruitingForm.date_of_birth.$$parseAndValidate();
              if ($scope.recruitings.recruitingForm.workload) {
                $scope.recruitings.recruitingForm.workload.$$parseAndValidate;
              }
            };
            break;

          case 'workload':
            item.$validators = {
              min: function(value) {
                if (
                  !value ||
                  !$scope.recruitings.recruitingModel.recruiting_campaign
                ) {
                  return true;
                }

                var min_work_time = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'recruiting_campaign',
                  $scope.recruitings.recruitingModel.recruiting_campaign,
                  'min_work_time'
                );

                if (value >= min_work_time) {
                  return true;
                }
                return false;
              }
            };
            item.validationMessage = {
              min: function(ctx) {
                var min_work_time = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'recruiting_campaign',
                  $scope.recruitings.recruitingModel.recruiting_campaign,
                  'min_work_time'
                );
                var job_type = formHelperFactory.getValueOfTitleMap(
                  vm.form_config.form,
                  'recruiting_campaign',
                  $scope.recruitings.recruitingModel.recruiting_campaign,
                  'job_type'
                );

                var msg = min_work_time
                  ? $translate.instant(
                      'The minimum workload is {{minimum}} {{unit}}',
                      {
                        minimum: min_work_time,
                        unit:
                          job_type == 'side_job'
                            ? $translate.instant('days per week')
                            : $translate.instant('weeks')
                      }
                    )
                  : $translate.instant('Workload is not correct');
                return msg;
              }
            };
            break;

          case 'date_of_birth':
            var field =
              actualRecruiting.form_config.schema.properties[item.key];
            formHelperFactory.configureDateOfBirthValidation(field, item, vm);
            break;

          case 'start_of_work':
            item.$validators = {
              min: function(value) {
                if (!value) {
                  return false;
                }
                if (value < new Date()) {
                  return false;
                }
                return true;
              }
            };

            item.validationMessage = {
              min: function(ctx) {
                return $translate.instant(
                  'Start of work has to be in the future!'
                );
              }
            };
            break;

          case 'street':
            item.capitalizedDir = 1;
            break;

          case 'city':
            item.capitalizedDir = 1;
            break;

          case 'country':
            break;

          case 'phone_number':
            item.isFormatE164 = 1;
            item.formatE164Country = 'country';
            item.formatE164WarningMessage = $translate.instant(
              'Number is not correct for this country choice'
            );
            item.updateOnCountryChange = 0;
            break;

          case 'send_sms':
            // Set the action for the sms button
            item.isSmsButton = 'sms';
            //@TODO add smsButton prefix to all smsButton depending attributes
            item.targetFieldName = 'phone_number';
            item.campaignType = 'recruiting';
            item.campaignId = actualRecruiting.id;
            item.campaignLang = '';
            if (
              $stateParams &&
              angular.isObject($stateParams) &&
              'lang' in $stateParams
            ) {
              item.campaignLang = $stateParams.lang;
            }
            break;

          case 'signature':
            item.validSignatureDir = 1;
            break;
        }
      });
    });
  }
}

RecruitingsService.$inject = ['$q', 'AuthenticationService'];
function RecruitingsService($q, AuthenticationService) {
  var service = {
    getRecruiting: getRecruiting
  };
  return service;

  ////////////

  /**
   *
   * getFormData
   *
   * fetches the formdata from the server and formats the data for the recruiting
   *
   *
   * @param recruitingId
   */
  function getRecruiting(recruitingId, language) {
    var recruiting_campaign = false,
      userData = AuthenticationService.getCurrentUser();

    if ('recruiting_campaigns' in userData) {
      angular.forEach(userData.recruiting_campaigns, function(v, k) {
        if (v.id == recruitingId) {
          recruiting_campaign = angular.copy(v);

          if (!(language in recruiting_campaign.supported_languages)) {
            language = Object.keys(recruiting_campaign.supported_languages)[0];
          }

          if (
            'form_wording' in recruiting_campaign &&
            language in recruiting_campaign.form_wording
          ) {
            recruiting_campaign.form_wording =
              recruiting_campaign.form_wording[language];
          }

          if ('form_config' in recruiting_campaign) {
            if ('form' in recruiting_campaign.form_config) {
              recruiting_campaign.form_config.form =
                recruiting_campaign.form_config.form[language];
            }
          }

          if (
            'upload_modal_config' in recruiting_campaign &&
            language in recruiting_campaign.upload_modal_config
          ) {
            recruiting_campaign.upload_modal_config =
              recruiting_campaign.upload_modal_config[language];
          }
        }
      });
      return recruiting_campaign != false
        ? $q.resolve(recruiting_campaign)
        : $q.reject(false);
    } else {
      return $q.reject(false);
    }
  }
}

angular
  .module('recruiting', [])
  .controller('RecruitingsController', RecruitingsController)
  .controller('RecruitingsFormController', RecruitingsFormController)
  .factory('RecruitingsService', RecruitingsService)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('app.recruitings', {
          abstract: true,
          url: '/recruitings/:rid/:lang',
          templateUrl: 'app/pages/recruitings/recruitings.view.html',
          controller: 'RecruitingsController as recruitings',
          resolve: {
            actualRecruiting: [
              '$stateParams',
              'RecruitingsService',
              function($stateParams, RecruitingsService) {
                return RecruitingsService.getRecruiting(
                  $stateParams.rid,
                  $stateParams.lang
                );
              }
            ]
          }
        })
        .state('app.recruitings.form', {
          url: '/form',
          templateUrl:
            'app/pages/recruitings/form-step/recruitings.form.view.html',
          controller: 'RecruitingsFormController as recruitingsFormStep'
        });
    }
  ]);

TeamController.$inject = [
  '$scope',
  'dashboardsResource',
  'FilterpanelChannel',
  'spinnerService',
  '$stateParams'
];
function TeamController(
  $scope,
  dashboardsResource,
  FilterpanelChannel,
  spinnerService,
  $stateParams
) {
  $scope.app.headline = 'Team Detail';

  var currentID = $stateParams.tid;

  var vm = this;

  vm.detail = {};
  vm.getDetails = getDetails;

  FilterpanelChannel.subFilterUpdated($scope, function(data) {
    //@TODO move getFilterRequestParams into filter service and create filterpanel directive
    var f = $scope.filterpanel.getFilterRequestParams();
    getDetails(f);
  });

  //init

  //!!!NOTICE!!!
  // our loading spinner fires the initial getTotals and getStats in it's on-loaded attribute defined in the view

  ///////////////////

  function getDetails(filters) {
    spinnerService.show('teamDetailsSpinner');

    if (currentID) {
      filters.team_id = currentID;
    }

    dashboardsResource
      .getTeams(filters)
      .then(function(resp) {
        vm.detail = resp.data;
      })
      .catch(angular.noop)
      .finally(function() {
        spinnerService.hide('teamDetailsSpinner');
      });
  }
}

TeamsController.$inject = [
  '$scope',
  'dashboardsResource',
  'FilterpanelChannel',
  'spinnerService'
];
function TeamsController(
  $scope,
  dashboardsResource,
  FilterpanelChannel,
  spinnerService
) {
  $scope.app.headline = 'Teams';

  var vm = this;

  vm.totals = {};
  vm.allCampaigns = {};

  vm.totals = {};
  vm.allCampaigns = {};
  vm.getTeamsStats = getTeamsStats;

  FilterpanelChannel.subFilterUpdated($scope, function(data) {
    //@TODO move getFilterRequestParams into filter service and create folterpanel directive
    var f = $scope.filterpanel.getFilterRequestParams();
    getTeamsStats(f);
  });
  FilterpanelChannel.subFilterUpdated($scope, function(data) {
    //@TODO move getFilterRequestParams into filter service and create folterpanel directive
    var f = $scope.filterpanel.getFilterRequestParams();
    getTeamsStats(f);
  });

  //init

  ///////////////////

  function getTeamsStats(filters) {
    spinnerService.show('teamsTotalsSpinner');

    dashboardsResource
      .getTeams(filters)
      .then(function(resp) {
        vm.dashboardTotals = resp.data;
      })
      .catch(angular.noop)
      .finally(function() {
        spinnerService.hide('teamsTotalsSpinner');
      });
  }
}

angular
  .module('teams', [
    'da.commons.directives.toggleByProp',
    'da.commons.directives.toggleBySet'
  ])
  .controller('TeamController', TeamController)
  .controller('TeamsController', TeamsController)
  .config([
    '$stateProvider',
    'AuthenticationSetConstant',
    function($stateProvider, AuthenticationSetConstant) {
      $stateProvider
        .state('app.filter.teams', {
          url: '/teams',
          views: {
            teams: {
              templateUrl: 'app/pages/teams/teams.view.html',
              controller: 'TeamsController as teams'
            }
          },
          data: {
            access: AuthenticationSetConstant.coach_or_teamleader_or_recruiter
          }
        })
        .state('app.filter.team', {
          url: '/team/:tid',
          views: {
            team: {
              templateUrl: 'app/pages/teams/team.view.html',
              controller: 'TeamController as team'
            }
          },
          data: {
            access: AuthenticationSetConstant.coach_or_teamleader_or_recruiter
          }
        });
    }
  ]);

TimecaptureController.$inject = [
  '$scope',
  '$filter',
  '$translate',
  '$interval',
  '$uibModal',
  'offlineStore'
];
function TimecaptureController(
  $scope,
  $filter,
  $translate,
  $interval,
  $uibModal,
  offlineStore
) {
  $scope.app.headline = $translate.instant('Timecapture');

  var tickInterval = 1000, //ms
    dateFilter = $filter('date');

  /* jshint validthis: true */
  var vm = this;
  vm.clockIntervalPromise = false;

  vm.offlineStoreKey = false;
  vm.timeData = [];

  vm.start = start;
  vm.isStarted = false;

  vm.end = end;

  vm.startBreak = startBreak;
  vm.endBreak = endBreak;
  vm.isPaused = false;

  vm.isFinished = false;

  /* edit a row in the table*/

  //index of row to edit or false
  vm.editing = false;
  //entry obj to edit
  vm.deleteEntry = deleteEntry;
  vm.editingRow = false;
  vm.setEditingRow = setEditingRow;

  vm.getMinStartTime = getMinStartTime;
  vm.getMinEndTime = getMinEndTime;
  vm.getMaxStartTime = getMaxStartTime;
  vm.getMaxEndTime = getMaxEndTime;

  vm.saveEditedRow = saveEditedRow;

  /*create new row in table*/
  vm.newRow = {};
  resetTimeEntry(vm.newRow);

  vm.resetTimeEntry = resetTimeEntry;
  vm.saveNewRow = saveNewRow;
  vm.toggleNewRowType = toggleNewRowType;

  vm.editStandardTimes = editStandardTimes;

  /*send data to server*/
  vm.saveData = saveData;

  init();

  ///////////////////

  function init() {
    $scope.$on('$destroy', function() {
      if (vm.clockIntervalPromise) {
        $interval.cancel(vm.clockIntervalPromise);
      }
    });

    vm.offlineStoreKey = offlineStore.getLastKeyOfUserByType(
      offlineStore.getTypes()[3]
    );

    if (vm.offlineStoreKey != false) {
      var offlineData = offlineStore.getEntryByKey(vm.offlineStoreKey);

      if (angular.isObject(offlineData)) {
        vm.editing = offlineData.editing;
        vm.editingRow = offlineData.editingRow;

        vm.isStarted = offlineData.isStarted;
        vm.isPaused = offlineData.isPaused;
        vm.isFinished = offlineData.isFinished;

        vm.timeData = angular.isArray(offlineData.timeData)
          ? offlineData.timeData
          : [];

        if (vm.isFinished === false) {
          startActualDuration();
        } else if (vm.timeData.length > 0) {
          prepareNewRow();
        }
      }
    }
  }

  //start stop tick and work state

  /**
   * startTick
   *
   * starts the time tracking
   **/
  function start() {
    if (!vm.isStarted) {
      vm.isStarted = true;
      vm.now = Date.now();

      addNewRow('work');

      updateOfflineData();

      startActualDuration();
    }
  }

  function startBreak() {
    if (vm.isStarted && !vm.isFinished) {
      $interval.cancel(vm.clockIntervalPromise);

      var index = vm.timeData.length - 1;

      vm.isPaused = true;

      finishRow();
      addNewRow('break');

      updateOfflineData();
      startActualDuration();
    }
  }

  function endBreak() {
    if (vm.isStarted && vm.isPaused && !vm.isFinished) {
      $interval.cancel(vm.clockIntervalPromise);

      var index = vm.timeData.length - 1;

      vm.isPaused = false;
      finishRow();
      addNewRow('work');

      updateOfflineData();
      startActualDuration();
    }
  }

  /**
   * endTick
   *
   * stops the tick
   */
  function end() {
    if (vm.isStarted && !vm.isFinished) {
      var index = vm.timeData.length - 1;

      vm.isPaused = false;
      finishRow();

      vm.isFinished = true;

      $interval.cancel(vm.clockIntervalPromise);

      prepareNewRow();

      updateOfflineData();
    }
  }

  function addNewRow(type) {
    vm.timeData.push({
      type: type,
      start: Date.now(),
      end: Date.now(),
      duration: 0,
      done: false
    });
  }

  function startActualDuration() {
    tick();

    vm.clockIntervalPromise = $interval(tick, tickInterval);

    function tick() {
      var index = vm.timeData.length - 1;

      vm.now = Date.now();
      vm.timeData[index].end = vm.now;
      vm.timeData[index].duration =
        vm.timeData[index].end - vm.timeData[index].start;

      updateOfflineData();
    }
  }

  function updateOfflineData() {
    if (vm.offlineStoreKey === false) {
      var persistResult = offlineStore.persistFromDataToOfflineCache(
        {},
        offlineStore.getTypes()[3]
      );
      vm.offlineStoreKey = persistResult.key;
    }

    var keyArray = vm.offlineStoreKey.split('_'),
      fundraiserKey = keyArray[0],
      data = {
        editing: vm.editing,
        editingRow: vm.editingRow,
        fundraiser: fundraiserKey,
        isStarted: vm.isStarted,
        isPaused: vm.isPaused,
        isFinished: vm.isFinished,
        timeData: vm.timeData
      };

    offlineStore.updateDataInOfflineCache(vm.offlineStoreKey, data);
  }

  function finishRow() {
    var index = vm.timeData.length - 1;

    vm.timeData[index].end = Date.now();
    vm.timeData[index].duration =
      vm.timeData[index].end - vm.timeData[index].start;
    vm.timeData[index].done = true;

    updateOfflineData();
  }

  function setEditingRow(index) {
    if (vm.editing === false) {
      vm.editing = index;

      vm.editStartMin = getMinStartTime(index);
      vm.editStartMax = getMaxStartTime(index);
      vm.editEndMin = getMinEndTime(index);
      vm.editEndMax = getMaxEndTime(index);

      vm.editingRow = angular.extend({}, vm.timeData[index]);

      var start = new Date(vm.editingRow.start),
        end = new Date(vm.editingRow.end);

      vm.editingRow.start = new Date(
        1970,
        0,
        1,
        start.getHours(),
        start.getMinutes(),
        start.getSeconds()
      );
      vm.editingRow.end = new Date(
        1970,
        0,
        1,
        end.getHours(),
        end.getMinutes(),
        end.getSeconds()
      );
    }
  }

  function saveEditedRow(index, timeEntry) {
    if (
      vm.editing !== false &&
      vm.editingForm['start_' + index].$valid &&
      vm.editingForm['end_' + index].$valid
    ) {
      vm.editing = false;

      var startDate = new Date();
      startDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        timeEntry.start.getHours(),
        timeEntry.start.getMinutes(),
        timeEntry.start.getSeconds()
      ).getTime();

      var endDate = new Date(vm.timeData[index].end);
      endDate = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        timeEntry.end.getHours(),
        timeEntry.end.getMinutes(),
        timeEntry.end.getSeconds()
      ).getTime();

      //save actual row
      vm.timeData[index].end = endDate;
      vm.timeData[index].start = startDate;
      vm.timeData[index].duration =
        vm.timeData[index].end - vm.timeData[index].start;

      //adopt other rows

      // first row
      if (index === 0) {
        //if next row exists
        if (vm.timeData.length > 1) {
          vm.timeData[index + 1].start = endDate;
          vm.timeData[index + 1].duration =
            vm.timeData[index + 1].end - vm.timeData[index + 1].start;
        }
      } else if (index > 0 && index < vm.timeData.length - 1) {
        //middle row
        //prev row
        vm.timeData[index - 1].end = startDate;
        vm.timeData[index - 1].duration =
          vm.timeData[index - 1].end - vm.timeData[index - 1].start;

        //next row
        vm.timeData[index + 1].start = endDate;
        vm.timeData[index + 1].duration =
          vm.timeData[index + 1].end - vm.timeData[index + 1].start;
      } else {
        //last row
        //prev row
        vm.timeData[index - 1].end = startDate;
        vm.timeData[index - 1].duration =
          vm.timeData[index - 1].end - vm.timeData[index - 1].start;
      }

      vm.editingRow = false;
    }
  }

  function deleteEntry(index) {
    vm.timeData.splice(index, 1);
  }

  function toggleNewRowType() {
    vm.newRow.type = vm.newRow.type == 'work' ? 'break' : 'work';
  }

  function editStandardTimes(index) {
    if (vm.editingRow.end < vm.editingRow.start) {
      vm.editingRow.end = vm.editingRow.start;
    }
  }

  function saveNewRow(timeEntry) {
    if (vm.editingForm.start_new.$valid && vm.editingForm.end_new.$valid) {
      var actualDate = new Date(),
        startDate = new Date(timeEntry.start),
        startDate = new Date(
          actualDate.getFullYear(),
          actualDate.getMonth(),
          actualDate.getDate(),
          timeEntry.start.getHours(),
          timeEntry.start.getMinutes(),
          timeEntry.start.getSeconds()
        ),
        endDate = new Date(timeEntry.end),
        endDate = new Date(
          actualDate.getFullYear(),
          actualDate.getMonth(),
          actualDate.getDate(),
          timeEntry.end.getHours(),
          timeEntry.end.getMinutes(),
          timeEntry.end.getSeconds()
        );

      //save actual row
      timeEntry.end = endDate.getTime();
      timeEntry.start = startDate.getTime();
      timeEntry.duration = timeEntry.end - timeEntry.start;
      timeEntry.done = true;

      vm.timeData.push(angular.extend({}, timeEntry));
      prepareNewRow();

      updateOfflineData();
    }
  }

  function saveData() {
    if (vm.editing === false) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        resolve: {
          title: function() {
            return $translate.instant('Upload time entries?');
          },
          text: function() {
            return $translate.instant(
              'Once you have uploaded your time entries, you can not edit them anymore! Are you sure you want to upload your time entries?'
            );
          },
          cancelGiven: function() {
            return true;
          },
          isTextAsHtml: function() {
            return false;
          }
        }
      });

      modalInstance.result.then(function() {
        offlineStore
          .persistOneFromOfflineCacheToServer(vm.offlineStoreKey)
          .finally(function(s) {
            reset();
          });
      });
    }
  }

  function prepareNewRow() {
    var endDateOfLastRow = new Date(vm.timeData[vm.timeData.length - 1].end);

    //prepare new Row
    endDateOfLastRow.setFullYear(1970);
    endDateOfLastRow.setDate(1);
    endDateOfLastRow.setMonth(0);
    endDateOfLastRow.setMilliseconds(0);

    vm.newRow.start = endDateOfLastRow;
    vm.newRow.end = endDateOfLastRow;
  }

  function reset() {
    vm.isStarted = false;
    vm.isPaused = false;
    vm.isFinished = false;

    vm.editing = false;
    vm.editingRow = false;

    vm.offlineStoreKey = false;

    vm.timeData = [];
  }

  /**
   * resets timeentry in form row.
   * @param entry
   */
  function resetTimeEntry(entry) {
    entry.type = 'break';
    entry.start = new Date(1970, 0, 1, 0, 0, 0);
    entry.end = new Date(1970, 0, 1, 0, 0, 0);
    entry.duration = 0;
  }

  function getMinStartTime(index) {
    //first row
    if (index === 0) {
      return '00:00:00';
    } else if (index > 0 && index < vm.timeData.length - 1) {
      //middle rows
      return dateFilter(vm.timeData[index - 1].start, 'HH:mm:ss');
    }
    //last row
    return dateFilter(vm.timeData[index - 1].start, 'HH:mm:ss');
  }

  function getMinEndTime(index) {
    //first row
    if (index === 0) {
      return dateFilter(vm.timeData[index].start, 'HH:mm:ss');
    } else if (index > 0 && index < vm.timeData.length - 1) {
      //middle rows
      return dateFilter(vm.timeData[index - 1].start, 'HH:mm:ss');
    }
    //last row
    return dateFilter(vm.timeData[index - 1].start, 'HH:mm:ss');
  }

  function getMaxStartTime(index) {
    //first row
    if (index === 0) {
      return dateFilter(vm.timeData[index].end, 'HH:mm:ss');
    } else if (index > 0 && index < vm.timeData.length - 1) {
      //middle rows
      return dateFilter(vm.timeData[index + 1].end, 'HH:mm:ss');
    } else {
      //last rows
      return '23:59:58';
    }
  }

  function getMaxEndTime(index) {
    //first row
    if (index === 0) {
      //if there is a next row to validate with
      if (vm.timeData.length > 1) {
        return dateFilter(vm.timeData[index + 1].end, 'HH:mm:ss');
      }
      //if it is the first and only row
      return '23:59:59';
    } else if (index > 0 && index < vm.timeData.length - 1) {
      return dateFilter(vm.timeData[index + 1].end, 'HH:mm:ss');
    }

    //last row
    return '23:59:59';
  }
}

angular
  .module('timecapture', [])
  .controller('TimecaptureController', TimecaptureController)

  .directive('ngModel', [
    '$filter',
    function($filter) {
      return {
        require: '?ngModel',
        link: function(scope, elem, attr, ngModel) {
          if (!ngModel) return;
          if (attr.type !== 'time') return;

          ngModel.$formatters.unshift(function(value) {
            return value.replace(/[.,]\d{3}$/, '');
          });
        }
      };
    }
  ])
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.timecapture', {
        url: '/timecapture',
        templateUrl: 'app/pages/timecapture/timecapture.view.html',
        controller: 'TimecaptureController as timecapture',
        data: {
          access: 'has_workshift'
        }
      });
    }
  ]);

AchievementsService.$inject = [
  'achievementsResource',
  '$uibModal',
  '$translate'
];
function AchievementsService(achievementsResource, $uibModal, $translate) {
  return {
    getCategories: getCategories,
    refreshNewAchievements: refreshNewAchievements
  };

  function displayNewAchievements(newAchievements) {
    if (angular.isArray(newAchievements)) {
      newAchievements.forEach(function(achievement) {
        //set it to 1 because we will display it probably many times
        achievement.count = 1;

        var modal = $uibModal.open({
          animation: true,
          templateUrl:
            'app/pages/achievements/achievements-modal/achievementsModal.view.html',
          controller: 'achievementsModalController as achievementModal',
          size: 6,
          openedClass: 'modal-open modal-invalid-state-message',
          resolve: {
            title: function() {
              return $translate.instant('Achievement unlocked!');
            },
            achievement: achievement
          }
        });
      });
    }
  }

  function refreshNewAchievements() {
    var that = this;
    achievementsResource
      .checkNew()
      .then(function(result) {
        displayNewAchievements(result.data);
      })
      .catch(angular.noop);
  }

  function getCategories() {
    return {
      easy: 'easy',
      medium: 'medium',
      hard: 'hard',
      epic: 'epic',
      specials: 'specials'
    };
  }
}

AchievementsController.$inject = [
  'achievementsResource',
  'spinnerService',
  '$translate'
];
function AchievementsController(
  achievementsResource,
  spinnerService,
  $translate
) {
  var vm = this;

  vm.achievements = [];

  vm.breadcrumbs = [
    {
      title: $translate.instant('Home'),
      link: 'app.filter.home'
    },
    {
      title: $translate.instant('My achievements'),
      link: ''
    }
  ];

  vm.init = init;

  //__________________________________________________________________________________________________

  function init() {
    loadAchievements();
  }

  /////////////////////

  function loadAchievements() {
    spinnerService.show('achievements');

    return achievementsResource
      .getAll()
      .then(function(responseData) {
        vm.achievements = responseData.data;
      })
      .catch(angular.noop)
      .finally(function() {
        spinnerService.hide('achievements');
      });
  }
}

angular
  .module('achievements', ['achievements-view', 'achievementsModal'])
  .controller('AchievementsController', AchievementsController)
  .factory('achievementsService', AchievementsService)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.achievements', {
        url: '/achievements',
        templateUrl: 'app/pages/achievements/achievements.view.html',
        controller: 'AchievementsController as achievements'
      });
    }
  ]);

function AttributeFilters(options) {
  var that = {};

  //the filters to filter items for separated by " "
  that.filterAttribute = 'data-target';

  //the categories of the item separated by " "
  that.categoryAttribute = 'data-category';

  that.defaultFilter = 'all';

  that.itemClass = undefined;
  that.filterItemClass = undefined;
  that.viewContainerClass = undefined;

  that.filters = undefined;
  that.currentFilter = that.defaultFilter;
  that.filterItems = [];
  that.items = [];

  that.viewContainer = undefined;
  that.initialPositions = [];

  that.setItemClass = setItemClass;
  that.setFilterItemClass = setFilterItemClass;
  that.setViewContainerClass = setViewContainerClass;

  that.filterByCategory = filterByCategory;
  that.rebindFilterMenu = rebindFilterMenu;
  that.renderView = renderView;

  construct(options);

  return that;

  /////////////////////////////

  function setItemClass(value) {
    that.itemClass = value;
  }

  function setFilterItemClass(value) {
    that.filterItemClass = value;
  }

  function setViewContainerClass(value) {
    that.viewContainerClass = value;
  }

  function rebindFilterMenu() {
    that.filters = document.getElementsByClassName(that.filterItemClass);

    for (var i = 0; i < that.filters.length; i++) {
      that.filters[i].onclick = onFilterClick;
    }
  }

  function renderView() {
    that.initialPositions = getPositions(that.items);
    filterByCategory(that.currentFilter);
    resizeContainer(that.viewContainer, that.items[0], that.filterItems.length);
  }

  function filterByCategory(category) {
    category = category || that.currentFilter;

    that.filterItems = [];

    for (var i = 0; i < that.items.length; i++) {
      var item = that.items[i];
      var categories = item.getAttribute(that.categoryAttribute).split(' ');

      if (
        categories.indexOf(category) != -1 ||
        category === that.defaultFilter
      ) {
        that.filterItems.push(item);

        // get new position
        // new position of the [n]'th filtered item is the position of the [n]'th item.
        // If we filter out the last item, it will be positioned as the first item
        var pos = getRelativePositionTo(
          item,
          that.initialPositions[that.filterItems.length - 1]
        );

        // animation fadein
        setStylesForPos(item, pos);
      } else {
        // animation fadeout
        setStylesForPos(item);
      }
    }
  }

  /////////////////////////////

  function construct(options) {
    that.itemClass = options.itemClass;
    that.filterItemClass = options.filterItemClass;
    that.viewContainerClass = options.viewContainerClass;

    that.items = document.getElementsByClassName(that.itemClass);
    that.viewContainer = document.getElementsByClassName(
      that.viewContainerClass
    )[0];

    rebindFilterMenu();
    renderView();

    window.onresize = function() {
      renderView();
    };

    return that;
  }

  function onFilterClick(event) {
    var currentItem = event.target;

    //remove active classes from all filters
    for (var i = 0; i < that.filters.length; i++) {
      that.filters[i].classList.remove('active');
    }
    //add active to clicked filter
    currentItem.classList.add('active');

    that.currentFilter = currentItem.getAttribute(that.filterAttribute);

    renderView();
  }

  function resizeContainer(container, itemsSample, filterCount) {
    var viewContainerWidth = container.clientWidth;

    var itemMargin = parseInt(
      (itemsSample && itemsSample.style.marginTop) || 0
    );
    itemMargin =
      itemMargin +
      parseInt((itemsSample && itemsSample.style.marginBottom) || 0);
    var itemHeight = itemsSample
      ? parseInt(itemsSample.clientHeight) + itemMargin
      : 0;

    var itemWidth = itemsSample ? parseInt(itemsSample.clientWidth) : 0;
    var itemsPerRow = Math.floor(viewContainerWidth / itemWidth);

    var rows = Math.ceil(filterCount / itemsPerRow);

    container.style.height = rows * itemHeight + 'px';
  }

  function setStylesForPos(item, pos) {
    if (pos && pos.length == 2) {
      item.style.transform =
        'translate3d(' +
        pos[1] +
        'px,' +
        pos[0] +
        'px,0) scale3d(1,1,1) rotate3d(0,1,0,0)';
      item.style.opacity = 1;
    } else {
      item.style.transform =
        'translateZ(0) scale3d(0,0,1) rotate3d(0,1,0,70deg)';
      item.style.opacity = '0';
    }
  }

  function getRelativePositionTo(item, toPosition) {
    var pos = [];

    pos[0] = toPosition[0] - item.offsetTop;
    pos[1] = toPosition[1] - item.offsetLeft;

    return pos;
  }

  function getPositions(items) {
    var positions = [];
    for (var i = 0; i < items.length; i++) {
      items[i].style.transform = 'inherit';
      positions[i] = [items[i].offsetTop, items[i].offsetLeft];
    }
    return positions;
  }
}

achievementsViewController.$inject = ['achievementsService'];
function achievementsViewController(achievementsService) {
  var ctrl = this;

  var animatedFilter;

  ctrl.achievements;
  ctrl.categories = achievementsService.getCategories();

  ctrl.initFilter = initFilter;

  ////////////////////////////////////////////

  ctrl.$onInit = function() {};

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('achievements', changes)) {
      ctrl.achievements = changes.achievements.currentValue;
    }
  };

  function initFilter() {
    //@TODO destruct af if exists

    /**/
    var options = {
      itemClass: 'achievement',
      filterItemClass: 'achievement-category',
      viewContainerClass: 'achievements-view-content'
    };
    animatedFilter = AttributeFilters(options);
  }
}

var achievementsView = {
  bindings: {
    achievements: '<'
  },
  templateUrl:
    'app/pages/achievements/achievements-view/achievements-view.html',
  controller: achievementsViewController
};

angular
  .module('achievements-view', ['achievements-categories', 'achievement'])
  .component('achievementsView', achievementsView);

AchievementsModalController.$inject = [
  '$uibModalInstance',
  'title',
  'achievement'
];
function AchievementsModalController($uibModalInstance, title, achievement) {
  var vm = this;

  vm.title = title;

  vm.achievement = achievement;

  vm.ok = ok;
  ////////////////

  function ok() {
    $uibModalInstance.close('ok');
  }
}

angular
  .module('achievementsModal', [])
  .controller('achievementsModalController', AchievementsModalController);

function achievementCategoriesController() {
  var ctrl = this;

  ctrl.categories = [];

  ////////////////////////

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('categories', changes)) {
      ctrl.categories = changes.categories.currentValue;
    }
  };
}

var achievementsCategories = {
  bindings: {
    categories: '<'
  },
  templateUrl:
    'app/pages/achievements/achievements-view/achievements-categories/achievements-categories.html',
  controller: achievementCategoriesController
};

angular
  .module('achievements-categories', [])
  .component('achievementsCategories', achievementsCategories);

achievementController.$inject = ['achievementsService'];
function achievementController(achievementsService) {
  var ctrl = this;

  ctrl.achievement = {
    className: '',
    count: 0
  };

  ctrl.getPresentationModeClass = getPresentationModeClass;
  ctrl.getUnlockedClass = getUnlockedClass;
  ctrl.isUnlocked = isUnlocked;
  ctrl.countVisible = countVisible;
  ctrl.getCategory = getCategory;

  //////////////////////////////////////////////

  ctrl.$onChanges = function(changes) {
    // helper to detect a change
    var valueChanged = function(key, changes) {
      if (key in changes)
        if (changes[key].currentValue != changes[key].previousValue) {
          return true;
        }
      return false;
    };

    if (valueChanged('achievement', changes)) {
      ctrl.achievement = changes.achievement.currentValue;

      if (angular.isObject(ctrl.achievement)) {
        ctrl.achievement.className = 'fa fa-star';
      }
    }
  };

  //////////////////////////////////////////////

  function getUnlockedClass() {
    return isUnlocked() ? 'unlocked' : 'locked';
  }

  function isUnlocked() {
    return 'count' in ctrl.achievement && ctrl.achievement.count > 0;
  }

  function getPresentationModeClass() {
    var isPresentationMode = 'presentationMode' in ctrl.achievement;
    return isPresentationMode ? 'presentation-mode' : '';
  }

  //////////////////////////////////////////

  function countVisible() {
    return 'count' in ctrl.achievement && ctrl.achievement.count > 1;
  }

  //////////////////////////////////////////

  function getCategory() {
    var categoryId =
      'category' in ctrl.achievement ? ctrl.achievement.category : 'easy';

    var categories = achievementsService.getCategories();

    return categoryId in categories ? categories[categoryId] : categories[0];
  }
}

var achievement = {
  bindings: {
    achievement: '<'
  },
  templateUrl:
    'app/pages/achievements/achievements-view/achievement/achievement.html',
  controller: achievementController
};

angular.module('achievement', []).component('achievement', achievement);

leaderboardFilterPaginateService.$inject = ['LeaderboardResource'];
function leaderboardFilterPaginateService(LeaderboardResource) {
  var queryParams = {
    date_from: null,
    date_to: null,
    page: 1
  };
  var firstPage = queryParams.page;
  var lastPage = false;
  var result = [];
  var totalCount = 0;

  var filterOptions = {
    none: 'none',
    custom: 'custom',
    overall: 'overall',
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    semester: 'semester',
    year: 'year'
  };
  var selectedFilter = false;
  var currentUser = false;

  var getService = function() {
    var that = this;
    return {
      init: init,
      reset: reset,
      getFilterOptions: function() {
        return filterOptions;
      },
      getQueryParams: function() {
        return queryParams;
      },
      setQueryParams: function(params) {
        queryParams = angular.merge({}, queryParams, {
          date_from: params.date_from,
          date_to: params.date_to
        });
      },
      getSelectedFilter: function() {
        return selectedFilter;
      },
      setSelectedFilter: function(type) {
        if (type in filterOptions) {
          selectedFilter = filterOptions[type];
        }
      },
      getFirstPage: function() {
        return firstPage;
      },
      getLastPage: function() {
        return lastPage;
      },
      getCurrentUser: function() {
        return currentUser;
      },
      getResult: function() {
        return result;
      },
      getTotalCount: function() {
        return totalCount;
      },
      loadFilter: loadFilter,
      loadNextPage: loadNextPage,
      loadPrevPage: loadPrevPage
    };
  };

  return getService();

  ////////////

  function init() {
    return this.loadFilter(filterOptions.overall);
  }

  function reset() {
    queryParams = {
      date_from: null,
      date_to: null,
      page: 1
    };
    firstPage = queryParams.page;
    lastPage = false;
    result = [];
  }

  ////////////

  function loadCurrentUser(params) {
    return LeaderboardResource.getSelf(params)
      .then(function(res) {
        currentUser = angular.merge({}, res.data);
        return currentUser;
      })
      .catch(function(err) {
        currentUser = false;
        return currentUser;
      });
  }

  function loadFilter(type, params) {
    if (selectedFilter === type && selectedFilter !== filterOptions.none) {
      return;
    }

    setFilterByType(type, params);

    // for none filter options there is no other action needed
    if (type === filterOptions.none) {
      return;
    }

    var promises = [];
    promises.push(loadLeaderboard(queryParams));
    promises.push(loadCurrentUser(queryParams));
    return Promise.all(promises);
  }

  function loadLeaderboard(params) {
    return LeaderboardResource.getJobReferrals(params)
      .then(function(res) {
        firstPage = res.data.previous === null ? params.page : 1;
        lastPage = res.data.next === null ? params.page : false;
        result = res.data.results;
        totalCount = res.data.total_count;
        return res;
      })
      .catch(function(error) {
        firstPage = 1;
        lastPage = false;
        result = [];
      });
  }

  function loadPrevPage() {
    if (firstPage === queryParams.page) {
      return;
    }

    var prevPage =
      firstPage <= queryParams.page - 1
        ? queryParams.page - 1
        : queryParams.page;
    queryParams = angular.merge({}, queryParams, { page: prevPage });

    firstPage = queryParams.page - 1;
    loadLeaderboard(queryParams)
      .then(function(res) {})
      .catch(function(error) {
        firstPage = queryParams.page + 1;
      });
  }

  function loadNextPage() {
    if (lastPage === queryParams.page) {
      return;
    }
    var nextPage =
      lastPage >= queryParams.page + 1 || lastPage === false
        ? queryParams.page + 1
        : queryParams.page;
    queryParams = angular.merge({}, queryParams, { page: nextPage });

    lastPage = queryParams.page + 1;
    loadLeaderboard(queryParams)
      .then(function(res) {})
      .catch(function(error) {
        lastPage = queryParams.page - 1;
      });
  }

  function resetPageSize() {
    queryParams = angular.merge({}, queryParams, { page: 1 });
    lastPage = false;
  }

  function setFilterByType(type, params) {
    if (!(type in filterOptions)) {
      return;
    }

    selectedFilter = filterOptions[type];
    resetPageSize();

    var newParams = {};
    switch (type) {
      case filterOptions.none:
        newParams = {
          date_from: params.date_from,
          date_to: params.date_to
        };
        break;
      case filterOptions.overall:
        newParams = {
          date_from: '',
          date_to: ''
        };
        break;
      case filterOptions.day:
        newParams = {
          date_from: moment()
            .utc()
            .toDate(),
          date_to: null
        };
        break;
      case filterOptions.week:
        newParams = {
          date_from: moment()
            .isoWeekday(1)
            .toDate(),
          date_to: moment()
            .isoWeekday(7)
            .toDate()
        };
        break;
      case filterOptions.month:
        newParams = {
          date_from: moment(moment().format('YYYY-MM-01')).toDate(),
          date_to: moment(
            moment().format('YYYY-MM-') + moment().daysInMonth()
          ).toDate()
        };
        break;
      case filterOptions.quarter:
        var quarterAdjustment = moment().month() % 3;
        var thisQuarterStartDate = moment()
          .subtract({ months: quarterAdjustment })
          .startOf('month');
        var thisQuarterEndtDate = thisQuarterStartDate
          .clone()
          .add({ months: 3 })
          .endOf('month');
        newParams = {
          date_from: thisQuarterStartDate.toDate(),
          date_to: thisQuarterEndtDate.toDate()
        };
        break;
      case filterOptions.semester:
        var quarterAdjustment = moment().month() % 6;
        var thisSemesterStartDate = moment()
          .subtract({ months: quarterAdjustment })
          .startOf('month');
        var thisSemesterEndtDate = thisSemesterStartDate
          .clone()
          .add({ months: 5 })
          .endOf('month');
        newParams = {
          date_from: thisSemesterStartDate.toDate(),
          date_to: thisSemesterEndtDate.toDate()
        };
        break;
      case filterOptions.year:
        newParams = {
          date_from: moment()
            .startOf('year')
            .toDate(),
          date_to: moment()
            .endOf('year')
            .toDate()
        };
        break;
      case filterOptions.custom:
        newParams = {
          date_from: params.date_from,
          date_to: params.date_to
        };
        break;
    }
    queryParams = angular.merge({}, queryParams, newParams);
  }
}

function leaderboardFiltersController() {
  var ctrl = this;
  //bindings
  ctrl.selectedFilter;
  ctrl.filterOptions;
  ctrl.queryParams;
  ctrl.onFiltersChange;
  ctrl.totalCount;

  // ctrl only
  ctrl.date_from;
  ctrl.date_to;

  ctrl.tryChangeFilters = tryChangeFilters;

  //////////////////////////////////////////////

  ctrl.$onChanges = function(changes) {
    if ('queryParams' in changes) {
      ctrl.date_from = changes.queryParams.currentValue.date_from;
      ctrl.date_to = changes.queryParams.currentValue.date_to;
    }
  };

  //////////////////////////////////////////////

  function tryChangeFilters(type) {
    if (type in ctrl.filterOptions) {
      var $event = {
        type: type
      };

      if (
        type === ctrl.filterOptions.custom ||
        type === ctrl.filterOptions.none
      ) {
        $event = angular.merge({}, $event, {
          params: {
            date_from: ctrl.date_from,
            date_to: ctrl.date_to
          }
        });
      }

      ctrl.onFiltersChange({ $event: $event });
    }
  }
}

var leaderboardFilters = {
  bindings: {
    selectedFilter: '<',
    filterOptions: '<',
    queryParams: '<',
    totalCount: '<',
    onFiltersChange: '&'
  },
  templateUrl:
    'app/pages/leaderboard/leaderboard-filters/leaderboard-filters.html',
  controller: leaderboardFiltersController
};

angular
  .module('leaderboard-filter', [])
  .component('leaderboardFilter', leaderboardFilters);

function leaderboardListController() {
  var ctrl = this;
  ctrl.list = [];
  ctrl.currentUser = false;
  ctrl.isCurrentUserPresent = false;

  //////////////////////////////////////////////

  ctrl.$onChanges = function(changes) {
    if ('list' in changes || 'currentUser' in changes) {
      if ('list' in changes) {
        ctrl.list = 'list' in changes ? changes.list.currentValue : false;
        if (ctrl.list && angular.isArray(ctrl.list) && ctrl.list.length > 0) {
          checkCurrentUser();
        }
      }

      if ('currentUser' in changes) {
        ctrl.currentUser =
          'currentUser' in changes ? changes.currentUser.currentValue : false;
      }
    }
  };

  //////////////////////////////////////////////

  function checkCurrentUser() {
    ctrl.isCurrentUserPresent = false;

    for (var i = 0; i < ctrl.list.length; i++) {
      if (ctrl.list[i].current_user === true) {
        ctrl.isCurrentUserPresent = true;
      }
    }
  }
}

var leaderboardList = {
  bindings: {
    list: '<',
    currentUser: '<'
  },
  templateUrl: 'app/pages/leaderboard/leaderboard-list/leaderboard-list.html',
  controller: leaderboardListController
};

angular
  .module('leaderboard-list', [])
  .component('leaderboardList', leaderboardList);

function leaderboardPaginationController() {
  var ctrl = this;
  //bindings
  ctrl.firstPage;
  ctrl.lastPage;
  ctrl.queryParams;

  // ctrl only
  ctrl.prevPage = prevPage;
  ctrl.nextPage = nextPage;

  //////////////////////////////////////////////

  function prevPage() {
    ctrl.onPrev();
  }

  function nextPage() {
    ctrl.onNext();
  }
}

var leaderboardPagination = {
  bindings: {
    queryParams: '<',
    firstPage: '<',
    lastPage: '<',
    onPrev: '&',
    onNext: '&'
  },
  templateUrl:
    'app/pages/leaderboard/leaderboard-pagination/leaderboard-pagination.html',
  controller: leaderboardPaginationController
};

angular
  .module('leaderboard-pagination', [])
  .component('leaderboardPagination', leaderboardPagination);

LeaderboardController.$inject = [
  '$scope',
  'LeaderboardFilterPaginateService',
  'AuthenticationService'
];
function LeaderboardController(
  $scope,
  LeaderboardFilterPaginateService,
  AuthenticationService
) {
  var vm = this;

  vm.currentUserData = AuthenticationService.getCurrentUser();
  vm.has_job_referral_leaderboard = false;

  if (
    vm.currentUserData &&
    angular.isObject(vm.currentUserData) &&
    'settings' in vm.currentUserData &&
    'has_job_referral_leaderboard' in vm.currentUserData.settings
  ) {
    vm.has_job_referral_leaderboard =
      vm.currentUserData.settings.has_job_referral_leaderboard;
  }

  vm.lFPService = LeaderboardFilterPaginateService;
  vm.onFiltersChange = onFiltersChange;
  vm.onPrev = onPrev;
  vm.onNext = onNext;

  vm.lFPService.init();
  initSubscriptions();

  //////////////////////////////////////////////

  function initSubscriptions() {
    $scope.$on('$stateChangeStart', function(
      event,
      toState,
      toParams,
      fromState
    ) {
      if (fromState.name.indexOf('app.leaderboard') !== -1) {
        vm.lFPService.reset();
      }
    });
  }

  //////////////////////////////////////////////

  function onFiltersChange($event) {
    LeaderboardFilterPaginateService.loadFilter($event.type, $event.params);
  }

  function onNext() {
    vm.lFPService.loadNextPage();
  }

  function onPrev() {
    vm.lFPService.loadPrevPage();
  }
}

angular
  .module('leaderboard', [
    'leaderboard-filter',
    'leaderboard-list',
    'leaderboard-pagination'
  ])
  .controller('LeaderboardController', LeaderboardController)
  .factory('LeaderboardFilterPaginateService', leaderboardFilterPaginateService)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.leaderboard', {
        url: '/leaderboard',
        templateUrl: 'app/pages/leaderboard/leaderboard.view.html',
        controller: 'LeaderboardController as leaderboard'
      });
    }
  ]);

LocationSelectController.$inject = [
  'locationsService',
  '$state',
  '$scope',
  '$rootScope'
];
function LocationSelectController(
  locationsService,
  $state,
  $scope,
  $rootScope
) {
  $scope.isLoading = true;
  $scope.locations = [];
  $scope.config = {
    selectedLocation: locationsService.getSelectedLocation()
  };
  var vm = this;

  init();

  function init() {
    if (locationsService.useNextLocationsCheckIn()) {
      window.location.href = '/next/locations';
    }

    vm.locations = locationsService.getListOffline();

    // download the latest list of locations
    locationsService
      .getList()
      .then(function(res) {
        vm.locations = res.data;
        $scope.locations = vm.locations;
        $scope.isLoading = false;
      })
      .catch(function(error) {
        // error fetching the new list, so we'll just keep using the one from the offlineStore
        $scope.locations = vm.locations;
        $scope.isLoading = false;
      });

    // function to upload the selected location to the server
    $scope.submitLocation = function() {
      $rootScope.selectedLocation = $scope.config.selectedLocation;

      locationsService.setLocation($scope.config.selectedLocation);
      $state.go('app.filter.home');
    };
  }
}

angular
  .module('locationselect', [])
  .controller('LocationSelectController', LocationSelectController)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.locationselect', {
        url: '/locationselect',
        templateUrl: 'app/pages/locationselect/locationselect.view.html',
        controller: 'LocationSelectController as locationselect'
      });
    }
  ]);

LocationPermitContorller.$inject = [
  'locationsService',
  '$window',
  '$scope',
  '$sce'
];
function LocationPermitContorller(locationsService, $window, $scope, $sce) {
  var vm = this;

  $scope.hasPermit = false;
  $scope.isLoading = false;
  $scope.isOnline = navigator.onLine;
  $scope.doRefresh = doRefresh;
  $scope.$on('$destroy', $onDestroyScope);

  if (locationsService.useNextLocationsCheckIn()) {
    routeToNextLocationPermit();
    return;
  }

  vm.$onInit = function() {
    updateLocationPermit(locationsService.getLocationPermitOffline());

    $scope.isOnline = navigator.onLine;
    $window.addEventListener('online', updateIsOnline);
    $window.addEventListener('offline', updateIsOnline);
  };

  function $onDestroyScope() {
    $window.removeEventListener('online', updateIsOnline);
    $window.removeEventListener('offline', updateIsOnline);
  }

  function updateIsOnline() {
    $scope.isOnline = navigator.onLine;
    $scope.$digest();
  }

  function doRefresh() {
    $scope.isLoading = true;

    locationsService
      .getCurrentLocationPermitData()
      .then(function(permitData) {
        updateLocationPermit(permitData);
      })
      .catch(function(error) {
        updateLocationPermit(undefined);
      })
      .finally(function() {
        $scope.isLoading = false;
      });
  }

  function updateLocationPermit(locationPermitData) {
    vm.locationPermitData = locationPermitData;
    vm.permitUrl = locationPermitData
      ? $sce.trustAsResourceUrl(locationPermitData.url)
      : null;

    $scope.locationPermitData = vm.locationPermitData;
    $scope.permitUrl = vm.permitUrl;
    $scope.hasPermit = !!vm.permitUrl;
  }

  function routeToNextLocationPermit() {
    id = (locationsService.getSelectedLocationOffline || {}).id;
    if (id) {
      window.location.href = '/next/locations' + id;
    }
  }
}

angular
  .module('location-permit', [])
  .controller('LocationPermitContorller', LocationPermitContorller)
  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('app.location-permit', {
        url: '/location/permit',
        templateUrl: 'app/pages/location-permit/location-permit.view.html',
        controller: 'LocationPermitContorller as locationPermit'
      });
    }
  ]);

angular.module('pages', [
  'donations',
  'filterpanel',
  'home',
  'login',
  'petitions',
  'recruiting',
  'teams',
  'timecapture',
  'achievements',
  'leaderboard',
  'locationselect',
  'location-permit'
]);

AppHttpIntercepters.$inject = ['$httpProvider'];
function AppHttpIntercepters($httpProvider) {
  $httpProvider.interceptors.push('ApiRequestIntercepter');
  $httpProvider.interceptors.push('AuthenticationHttpInterceptor');
}

AppRoutingRunFunction.$inject = [
  '$transitions',
  '$rootScope',
  '$urlRouter',
  'AuthenticationService',
  'locationsService',
  '$state',
  '$window'
];
function AppRoutingRunFunction(
  $transitions,
  $rootScope,
  $urlRouter,
  AuthenticationService,
  locationsService,
  $state,
  $window
) {
  //http://angular-ui.github.io/ui-router/site/#/api/ui.router.router.$urlRouterProvider#methods_deferintercept
  $rootScope.$on('$locationChangeStart', function(e) {
    if (AuthenticationService.getLastConnectTime() > 0) {
      //sync the current URL to the router
      $urlRouter.sync();
      return;
    }

    // Prevent $urlRouter's default handler from firing
    e.preventDefault();

    // init or refresh Authentication service connection
    // after this out routing knows what to do
    AuthenticationService.refreshConnection()
      .then(function() {
        $urlRouter.sync();
      })
      .catch(function() {
        $urlRouter.sync();
      });

    // Configures $urlRouter's listener *after* your custom listener
    $urlRouter.listen();
  });

  //restrict access redirects
  $transitions.onStart({}, function($transition) {
    var toState = $transition.$to();
    //redirects for logged in user
    if (toState.name == 'app.login') {
      if (AuthenticationService.getConnectionState()) {
        if (locationsService.needsLocation()) {
          $state.go('app.locationselect');
        } else {
          $state.go('app.filter.home');
        }
        return;
      }
    }

    //redirect if user in unauthorized
    if (
      'data' in toState &&
      toState.data &&
      'access' in toState.data &&
      !AuthenticationService.isAuthorized(toState.data.access)
    ) {
      AuthenticationService.redirectToLogin();
      return;
    }

    //redirect if has_location_tracking and location not selected
    if (locationsService.needsLocation()) {
      $state.go('app.locationselect');
      return;
    }
  });

  $transitions.onSuccess({}, function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });
}

AppRun.$inject = [
  '$http',
  'CacheFactory',
  'fundraisersChannel',
  'commonHelpers',
  'imagePreloader',
  '$rootScope'
];
function AppRun(
  $http,
  CacheFactory,
  fundraisersChannel,
  commonHelpers,
  imagePreloader,
  $rootScope
) {
  $http.defaults.cache = CacheFactory('httpCache', {
    maxAge: 1000 * 60 * 5, // Items added to this cache expire after 5 minutes
    cacheFlushInterval: 1000 * 60 * 10, // This cache will clear itself every hour
    deleteOnExpire: 'passive' // Items will be deleted from this cache when they expire
  });

  init();

  function init() {
    handleImageCaching();
  }

  function handleImageCaching() {
    var newScope = $rootScope.$new();
    fundraisersChannel.subFundraisersSelfConfirmed(
      newScope,
      preloadCampaignImages
    );

    ////////////

    function preloadCampaignImages(response) {
      // find all images inside the response body
      var images = commonHelpers.filterValuesRecursive(response.data, function(
        val
      ) {
        return /\.(png|jpg|jpeg|gif)$/.test(val);
      });

      // preload all images
      imagePreloader.load(images);

      // preload leaderboard preview image
      imagePreloader.load('assets/images/Leaderboard_neu_2.png');
    }
  }
}

AppController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  'incognitoCheckService',
  'AuthenticationService',
  'versionResource',
  'AuthenticationSetConstant',
  'AuthenticationChannel',
  '$translate',
  '$localStorage',
  '$interval'
];
function AppController(
  $scope,
  $state,
  $uibModal,
  incognitoCheckService,
  AuthenticationService,
  versionResource,
  AuthenticationSetConstant,
  AuthenticationChannel,
  $translate,
  $localStorage,
  $interval
) {
  /* jshint validthis: true */
  var vm = this;
  vm.appVersion = baseconfig.version;

  vm.navCollapsed = true;
  vm.$state = $state;

  vm.currencySymbol = '';
  vm.lang = AuthenticationService.getCurrentUser().language;
  vm.age_limit = '';

  vm.authSets = AuthenticationSetConstant;

  init();

  function cleanupInitialLoader() {
    var loadingSpinnerElement = document.querySelector(
      '#initial-page-load-spinner'
    );
    if (loadingSpinnerElement) {
      loadingSpinnerElement.remove();
    }
  }

  function init() {
    cleanupInitialLoader();

    // init lastRefresh
    if (
      !('lastRefresh' in $localStorage) ||
      !moment.isDate(moment($localStorage.lastRefresh).toDate())
    ) {
      $localStorage.lastRefresh = moment().toDate();
    }

    checkBrowserVersion();

    checkServerVersion();

    checkIncognitoMode();

    checkLastRefresh();

    connectionStateUpdatedHandler();
    AuthenticationChannel.subAuthenticationCurrentUserUpdated(
      $scope,
      connectionStateUpdatedHandler
    );
  }

  function connectionStateUpdatedHandler() {
    vm.currentUser = AuthenticationService.getCurrentUser();
    vm.currencySymbol = AuthenticationService.getCurrentUser().currency_symbol;
    vm.lang = AuthenticationService.getCurrentUser().language;
  }

  function checkIncognitoMode() {
    incognitoCheckService.detectPrivateMode(function(is_private) {
      if (is_private) {
        getIncognitoModal();
      }

      function getIncognitoModal() {
        var modal = $uibModal.open({
          animation: true,
          templateUrl:
            'app/commons/modals/incognitoModal/incognitoModal.view.html',
          controller: 'IncognitoModalController as modal',
          size: 6,
          openedClass: 'modal-open modal-invalid-state-message',
          resolve: {
            title: function() {
              return $translate.instant('Close incognito/private mode!');
            },
            text: function() {
              return $translate.instant(
                'Close the incognito/private mode and use Donut from the default browsing mode, otherwise your donations CAN NOT BE SAVED OFFLINE! Working in incognito/private mode is not supported!'
              );
            },
            cancelGiven: function() {
              return false;
            }
          }
        });

        modal.result.finally(function() {
          getIncognitoModal();
        });
      }
    });
  }

  // Return 1 if a > b
  // Return -1 if a < b
  // Return 0 if a == b
  function compare(a, b) {
    if (a === b) {
      return 0;
    }
    var a_components = a.split('.');
    var b_components = b.split('.');
    var len = Math.min(a_components.length, b_components.length);
    // loop while the components are equal
    for (var i = 0; i < len; i++) {
      // A bigger than B
      if (parseInt(a_components[i]) > parseInt(b_components[i])) {
        return 1;
      }
      // B bigger than A
      if (parseInt(a_components[i]) < parseInt(b_components[i])) {
        return -1;
      }
    }
    // If one's a prefix of the other, the longer one is greater.
    if (a_components.length > b_components.length) {
      return 1;
    }
    if (a_components.length < b_components.length) {
      return -1;
    }
    // Otherwise they are the same.
    return 0;
  }

  function checkServerVersion() {
    var clientVersion = baseconfig.version;
    var serverVersion = 'server-version-not-given';

    versionResource
      .getVersion()
      .then(function(res) {
        if (res.data && res.data.version) {
          serverVersion = res.data.version;
        }

        if (
          serverVersion != 'server-version-not-given' &&
          compare(clientVersion, serverVersion) === -1
        ) {
          getServerVersionModal(clientVersion, serverVersion);
        }
      })
      .catch(function() {
        // prevent unhandled promise rejection
      });

    function getServerVersionModal(clientVersion, serverVersion) {
      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant('Please update Donut!');
          },
          text: function() {
            var wrongVersionData = {
              clientVersion: clientVersion,
              serverVersion: serverVersion
            };
            var wrongVersionMessage = $translate.instant(
              'We have detected that you are using an old version of our app! You are using version {{clientVersion}} - the current version is {{serverVersion}} - Please go back to your dashboard, hit refresh and have a little patience until you see the update dialogue.',
              wrongVersionData
            );
            var wrongVersionAdvise = $translate.instant(
              'If you keep seeing this message please make sure all offline donations have been uploaded and clear your browser cache.'
            );

            return (
              '<p>' +
              wrongVersionMessage +
              '<br/><br/>' +
              wrongVersionAdvise +
              '</p>'
            );
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return true;
          }
        }
      });
    }
  }

  function checkBrowserVersion() {
    var browserSupportService = BrowserSupportService();
    var browserInfos = browserSupportService.detectBrowser();

    var isSupported = browserSupportService.isBrowserSupported(
      browserInfos,
      baseconfig.browserSupportWhitelist
    );

    if (!isSupported) {
      getBrowserSupportModal();
    }

    function getBrowserSupportModal() {
      var feedback = browserSupportService.getBrowserSupportFeedback(
        browserInfos,
        baseconfig.browserSupportWhitelist
      );

      var modal = $uibModal.open({
        animation: true,
        templateUrl:
          'app/commons/modals/browserSupportModal/browserSupportModal.view.html',
        controller: 'BrowserSupportModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant(feedback.title);
          },
          text: function() {
            return $translate.instant(feedback.text);
          },
          cancelGiven: function() {
            return true;
          }
        }
      });
    }
  }

  /* auto logout - on the next day the user should be logged out automatically */
  function checkLastRefresh() {
    /*
     * Starts an interval and checks if we should refresh every [intervalDelay] ms
     *
     */
    var intervalDelay = 10000;
    var refreshCheckInterval = $interval(function() {
      if (getTimeDiff() > 0 && navigator.onLine) {
        getBrowserRefreshModal();
        $interval.cancel(refreshCheckInterval);
      }
    }, intervalDelay);

    /*
     * Calculates the time diff from the very last moment of the last refresh date to now
     */
    function getTimeDiff() {
      var endOfDayOfLastRefresh = moment($localStorage.lastRefresh).endOf(
        'day'
      );

      if (
        $localStorage.lastRefresh === undefined ||
        !endOfDayOfLastRefresh.isValid()
      ) {
        // In case that the value was cleared from the local storage
        // we return 1 to trigger the refresh
        return 1;
      }

      return moment().diff(endOfDayOfLastRefresh);
    }

    /*
     * Show modal and refresh after closing it.
     * Also update time of last refresh
     */
    function getBrowserRefreshModal() {
      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'app/commons/modals/generalModal/generalModal.view.html',
        controller: 'GeneralModalController as modal',
        size: 6,
        openedClass: 'modal-open modal-invalid-state-message',
        resolve: {
          title: function() {
            return $translate.instant('Please refresh your browser!');
          },
          text: function() {
            var refreshMessage = $translate.instant(
              'Everyday is a fresh start! You were logged in for quite a while so your browser might need some refreshing too.'
            );

            return '<p>' + refreshMessage + '</p>';
          },
          cancelGiven: function() {
            return false;
          },
          isTextAsHtml: function() {
            return true;
          }
        }
      });

      modal.result.finally(function() {
        // update last refresh
        $localStorage.lastRefresh = moment().toDate();

        // Redirect to login and reload to restart the interval in any case
        AuthenticationService.logout().finally(function(resp) {
          AuthenticationService.redirectToLogin();
          location.reload();
        });
      });
    }
  }
}

(function() {
  'use strict';

  angular.module('commons.raven.settings', []).run(RavenConfigorations);

  RavenConfigorations.$inject = [
    'AuthenticationChannel',
    'AuthenticationService',
    '$timeout',
    '$rootScope'
  ];
  function RavenConfigorations(
    AuthenticationChannel,
    AuthenticationService,
    $timeout,
    $rootScope
  ) {
    initSubscriptions();

    function initSubscriptions() {
      //@TODO fix this without timeout!!!
      $timeout(function() {
        setUserContext(AuthenticationService.getCurrentUser().userId);
        AuthenticationChannel.subAuthenticationConnectionStateUpdated(
          $rootScope.$new(),
          function() {
            setUserContext(AuthenticationService.getCurrentUser().id);
          }
        );
      }, 0);
    }

    function setUserContext(userId) {
      var userContext = {};
      if (userId) {
        userContext.id = userId;
      }
      window.Raven.setUserContext(userContext);
    }
  }
})();

//https://github.com/getsentry/raven-js/blob/master/docs/integrations/angular.rst
Raven.config(baseconfig.raven.public_dsn, {
  environment: baseconfig.raven.environment,
  release: baseconfig.version
})
  .addPlugin(Raven.Plugins.Angular, angular)
  .install();

/*This is the module definition for the autogenerated template cache*/
angular.module('da.commons.caching.templates', []);

angular
  .module('donutApp', [
    'ngRaven',
    'ui.router',
    'ngStorage',
    'ngSanitize',
    'angular-cache',
    'pascalprecht.translate',
    'ngMessages',
    'schemaForm',
    'ui.bootstrap',
    'star-rating',
    'ui.select2',
    'angularSpinners',

    'da.commons.caching.templates',

    'common',
    'pages'
  ])
  .value('indexedDBConfig', {
    name: 'formunauts',
    version: 1,
    stores: { donations: 'key', logs: null }
  })
  .config(AppHttpIntercepters)
  .controller('AppController', AppController)
  .factory('cachingService', CachingService)
  .run(AppRoutingRunFunction)
  .run(AppRun)
  .config([
    '$compileProvider',
    function($compileProvider) {
      $compileProvider.debugInfoEnabled(baseconfig.debugInfoEnabled);
    }
  ])
  .config([
    '$stateProvider',
    '$translateProvider',
    '$urlRouterProvider',
    function($stateProvider, $translateProvider, $urlRouterProvider) {
      $translateProvider.preferredLanguage('en');
      $translateProvider.useSanitizeValueStrategy('escape');

      //We use this in the in the modules .run function
      $urlRouterProvider.deferIntercept();

      //routing
      $urlRouterProvider.otherwise('/app/filter/home');

      $stateProvider.state('app', {
        url: '/app',
        abstract: true,
        templateUrl: 'app/app.view.html',
        controller: 'AppController as app',
        resolve: {
          //@TODO minification save resolver function => move to bottom and use $inject. then just reference here
          translationData: [
            'AppConfigResource',
            function(AppConfigResource) {
              AppConfigResource.getAppConfig()
                .then(function(configData) {
                  configData = configData.data;
                  if ('i18n' in configData) {
                    angular.forEach(configData.i18n, function(val, key) {
                      $translateProvider.translations(key, val);
                    });
                  }
                })
                .catch(angular.noop);
              return true;
            }
          ]
        }
      });
    }
  ]);

angular.module("da.commons.caching.templates").run(["$templateCache",function(n){n.put("app/app.view.html",'<div id="header-wrapper" ng-if="!app.$state.includes(\'app.donations\') && !app.$state.includes(\'app.petitions\') && !app.$state.includes(\'app.recruitings\') && !app.$state.includes(\'app.login\')">\n    <div class="container header">\n        <div id="logo-section" class="col-sm-5">\n            <img ui-sref="app.filter.home" id="logo" class="center-block" title="formunauts.com" alt="formunauts.com" src="assets/images/formunauts-regular-blue.svg">\n        </div>\n\n        <div id="user-section" class="col-sm-7">\n            <user-settings></user-settings>\n        </div>\n    </div>\n</div>\n\n<ui-view></ui-view>\n\n<toast-comp></toast-comp>\n\n<network-status-bar-comp></network-status-bar-comp>\n'),n.put("app/pages/achievements/achievements.view.html",'<div id="achievements">\n    <div class="container">\n        <breadcrumbs breadcrumbs="achievements.breadcrumbs"></breadcrumbs>\n\n        <h2>{{\'Achievements\' | translate}}</h2>\n\n        <div class="loading-wrapper">\n            <spinner id="achievements-loadingspinner" class="loadingspinner" name="achievements" ng-cloak on-loaded="achievements.init()">\n                <loading-spinner animate="true" class="size--xl spinner center"></loading-spinner>\n            </spinner>\n\n            <achievements-view class="" achievements="achievements.achievements">\n            </achievements-view>\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/filterpanel/filterpanel.view.html",'<div id="main-contant-wrapper">\n  <div class="container">\n    <div class="filter-section">\n      <div class="row">\n        <div class="col-xs-6 col-lg-2 filter-total">\n          <a class="btn btn-block btn-warning" ng-class="{today:\'active\'}[filterpanel.selectedFilter]" ng-click="filterpanel.changeSelectedFilter(filterpanel.filters.today)">\n              {{\'Today\' | translate}}\n          </a>\n        </div>\n\n        <div class="col-xs-6 col-lg-2 filter-today">\n          <a class="btn btn-block btn-warning" ng-class="{total:\'active\'}[filterpanel.selectedFilter]" ng-click="filterpanel.changeSelectedFilter(filterpanel.filters.total)">\n              {{\'Total\' | translate}}\n          </a>\n        </div>\n\n        <div class="col-xs-6 col-md-3 col-lg-2 filter-date">\n          <div class="form-group">\n            <input type="date" class="form-control input-lg" ng-class="{date:\'active\'}[filterpanel.selectedFilter]" name="startDate" ng-model="filterpanel.formData.startDate" ng-change="filterpanel.updateDateRange(\'start\')" placeholder="dd/mm/yyyy" ng-blur="filterpanel.changeSelectedFilter(filterpanel.filters.date)">\n          </div>\n        </div>\n        <div class="col-xs-6 col-md-3 col-lg-2 filter-date">\n            <div class="form-group">\n              <input type="date" class="form-control input-lg" ng-class="{date:\'active\'}[filterpanel.selectedFilter]" name="endDate" ng-model="filterpanel.formData.endDate" ng-change="filterpanel.updateDateRange(\'end\')" placeholder="dd/mm/yyyy" ng-blur="filterpanel.changeSelectedFilter(filterpanel.filters.date)">\n            </div>\n          </div>\n\n        <div class="col-xs-6 col-md-3 col-lg-2 filter-weekYear">\n          <div class="form-group">\n            <select class="form-control input-lg" ng-class="{week:\'active\'}[filterpanel.selectedFilter]" name="weekYear" ng-model="filterpanel.formData.selectedWeek" ng-change="filterpanel.changeSelectedFilter(filterpanel.filters.week)" ng-options="week.name for week in filterpanel.weeks track by week.value">\n            </select>\n          </div>\n        </div>\n\n        <div class="col-xs-6 col-md-3 col-lg-2 filter-monthYear">\n          <div class="form-group">\n            <select class="form-control input-lg" ng-class="{month:\'active\'}[filterpanel.selectedFilter]" name="monthYear" ng-model="filterpanel.formData.selectedMonth" ng-change="filterpanel.changeSelectedFilter(filterpanel.filters.month)" ng-options="month.name for month in filterpanel.months track by month.value">\n            </select>\n          </div>\n        </div>\n\n        <div class="col-xs-6 col-sm-12 col-lg-2 nav-button pull-right">\n          <a ng-show="app.$state.includes(\'app.filter.teams\')" class="btn btn-block btn-md btn-success" ui-sref="app.filter.home">\n              &leftarrow; {{\'Home\' | translate}}\n          </a>\n          <a ng-show="app.$state.includes(\'app.filter.team\')" class="btn btn-block btn-md btn-success" ui-sref="app.filter.teams" toggle-by-set auth-set="app.authSets.coach_or_teamleader_or_recruiter">\n              &leftarrow; {{\'Teams\' | translate}}\n          </a>\n          <a ng-show="app.$state.includes(\'app.filter.home\')" toggle-by-set auth-set="app.authSets.coach_or_teamleader_or_recruiter" class="btn btn-block btn-md btn-success" ui-sref="app.filter.teams">\n              {{\'Teams\' | translate}} &rightarrow;\n          </a>\n        </div>\n      </div>\n    </div>\n\n    <ui-view name="home" ng-show="app.$state.includes(\'app.filter.home\')"></ui-view>\n    <ui-view name="teams" ng-show="app.$state.includes(\'app.filter.teams\')"></ui-view>\n    <ui-view name="team" ng-show="app.$state.includes(\'app.filter.team\')"></ui-view>\n\n    <div id="footer-menu">\n      <div class="row">\n\n        <div class="col-sm-12" id="offlinestore-section">\n          <offline-store-button class="btn-block btn-lg btn-danger"></offline-store-button>\n        </div>\n\n        <div id="campaign-section" class="col-sm-12" toggle-by-set auth-set="app.authSets.coach_or_shift">\n            <div class="bs-callout bs-callout-warning" ng-show="filterpanel.noCampaignMessage">\n              {{filterpanel.noCampaignMessage}}\n            </div>\n\n            <button class="btn btn-lg btn-block btn-warning icon-left campaign-button" type="submit" ng-click="filterpanel.goToCampaignForm(campaign.id, campaign.use_next_form, campaign.presentation)" ng-repeat="campaign in filterpanel.currentUserData.campaigns track by $index">\n                <i class="icon-gotoform"></i>{{campaign.name}}\n                <span class="workshift-warning" ng-if="!filterpanel.currentUserData.has_workshift">\n                  {{\'(No Workshift! Donations stored in unfinished donations)\' | translate}}\n                </span>\n            </button>\n\n            <button class="btn btn-lg btn-block btn-warning icon-left petition-button" type="submit" ng-click="filterpanel.goToPetitionForm(petition.id)" ng-repeat="petition in filterpanel.currentUserData.petition_campaigns track by $index">\n                <i class="icon-gotoform"></i>{{petition.name}}\n            </button>\n        </div>\n\n        <div id="recruiting-section" class="col-sm-12">\n          <button class="btn btn-lg btn-block btn-info icon-left recruiting-button" type="submit" ng-click="filterpanel.goToRecruitingForm(recruiting.id)" ng-repeat="recruiting in filterpanel.currentUserData.recruiting_campaigns track by $index">\n              <i class="icon-gotoform"></i>{{recruiting.name}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n'),n.put("app/pages/donations/donations.view.html",'<div class="donations-view">\n\n  <style ng-if="donations.custom_css" ng-bind-html="donations.custom_css">\n  </style>\n\n  <div ng-style="donations.configurableStyles.all" class="dynamic-form-wrapper">\n    <div id="donation">\n      <form id="donation-{{donations.formId}}" class="dynamic-form" name="donations.donationForm">\n        <ui-view></ui-view>\n      </form>\n    </div>\n  </div>\n</div>\n'),n.put("app/pages/home/home.view.html",'<div id="home">\n    <div class="loading-wrapper">\n        <spinner id="home-loadingspinner" class="loadingspinner" name="homeSelfStats" ng-cloak on-loaded="home.filterChangedHandler()">\n            <loading-spinner animate="true" class="size--xl spinner center"></loading-spinner>\n        </spinner>\n\n        <div class="row">\n            <div class="dynamic-dashboard primary" ng-repeat="set in home.dashboard.sets">\n                <dashboard-comp set="set" currency-symbol="app.currencySymbol" lang="app.lang">\n                </dashboard-comp>\n            </div>\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/leaderboard/leaderboard.view.html",'<div id="referral-leaderboard" class="container">\n  <div ng-if="!leaderboard.has_job_referral_leaderboard">\n    <h1>{{\'Referrals Leaderboard - Preview\' | translate}}</h1>\n\n    <h5>\n      {{\'The Referrals Leaderboard is one of our Professional-Features and can be activated complimentary for our Professional-Customers.\' | translate}}\n    </h5>\n\n    <h5><a href="{{\'https://support.formunauts.com/hc/en-us/articles/115001604213-The-Referrals-Leaderboard\' | translate}}" target="_blank">{{\'Help article for the Referrals Leaderboard\' | translate}}</a></h5>\n\n    <img src="assets/images/Leaderboard_neu_2.png" alt="Leaderboard Preview" style="box-shadow: 0px 5px 50px #aaa; display: block; filter: grayscale(100); margin: auto; margin-top: 40px; width: 60%">\n  </div>\n\n  <div ng-if="leaderboard.has_job_referral_leaderboard">\n    <h1>{{\'Referrals Leaderboard\' | translate}}</h1>\n\n    <div class="row">\n      <leaderboard-filter selected-filter="leaderboard.lFPService.getSelectedFilter()" filter-options="leaderboard.lFPService.getFilterOptions()" query-params="leaderboard.lFPService.getQueryParams()" on-filters-change="leaderboard.onFiltersChange($event)" total-count="leaderboard.lFPService.getTotalCount()">\n      </leaderboard-filter>\n    </div>\n\n    <leaderboard-list list="leaderboard.lFPService.getResult()" current-user="leaderboard.lFPService.getCurrentUser()"></leaderboard-list>\n\n    <leaderboard-pagination query-params="leaderboard.lFPService.getQueryParams()" last-page="leaderboard.lFPService.getLastPage()" first-page="leaderboard.lFPService.getFirstPage()" on-prev="leaderboard.onPrev($event)" on-next="leaderboard.onNext($event)"></leaderboard-pagination>\n\n  </div>\n\n</div>\n'),n.put("app/pages/location-permit/location-permit.view.html",'<div id="location-permit" class="container">\n    <div>\n        <header class="row">\n            <div class="col-xs-6">\n                <h3>{{\'Location permit\' | translate}}</h3>\n            </div>\n            <div class="col-xs-6 header-button-col">\n                <button ng-disabled="!isOnline || isLoading" ng-click="doRefresh()" class="btn btn-primary">\n                    {{\'Refresh\' | translate}}\n                </button>\n            </div>\n        </header>\n        <section class="row">\n            <div class="col-md-12">\n                <loading-spinner ng-if="isLoading" animate="true" class="inline"></loading-spinner>\n                <div ng-if="!isLoading">\n                    <iframe ng-if="hasPermit" ng-src="{{ permitUrl }}"></iframe>\n                    <div ng-if="!hasPermit">\n                        <div>\n                            {{\'There is no permit available for this location.\'\n                            | translate}}\n                        </div>\n                        <div ng-if="!isOnline">\n                            {{\'Go online and check again.\' | translate}}\n                        </div>\n                        \x3c!--\n                        <div ng-if="isOnline">\n                            {{\'Click Refresh to check again.\' | translate}}\n                        </div>\n                        --\x3e\n                    </div>\n                </div>\n            </div>\n        </section>\n    </div>\n</div>\n'),n.put("app/pages/locationselect/locationselect.view.html",'<div class="container locationselect">\n    <div>\n        <header class="row">\n            <div class="col-md-12">\n                <h3>{{\'Choose your location\' | translate}}</h3>\n            </div>\n        </header>\n        <section class="row locations">\n            <div class="col-md-12">\n                <loading-spinner ng-if="isLoading" animate="true" class="inline"></loading-spinner>\n                <div ng-if="!isLoading && (!locations || locations.length == 0)">\n                    <p>{{\'You have no location assigned.\' | translate}}</p>\n                    <p>{{\'Please contact your manager.\' | translate}}</p>\n                </div>\n                <div ng-if="!isLoading && locations && locations.length > 0">\n                    <p>\n                        </p><form name="locationsSelect" ng-submit="submitLocation()">\n                            <div class="form-group form-check">\n                                <div ng-repeat="location in locations" class="radio">\n                                    <label class="form-check-label">\n                                        <input type="radio" name="locationselect" class="form-check-input" ng-model="config.selectedLocation" ng-value="location" required>\n                                        {{ location.name }}\n                                    </label>\n                                </div>\n                            </div>\n                            <button type="submit" class="btn btn-primary">Continue</button>\n                        </form>\n                    <p></p>\n                    <p>{{\'Your location is missing? Please contact your manager.\' | translate}}</p>\n                </div>\n            </div>\n        </section>\n    </div>\n</div>\n'),n.put("app/pages/login/login.view.html",'<div id="main-contant-wrapper">\n    <div class="container">\n        <div id="login" class="">\n            <loading-spinner ui-sref="app.filter.home" animate="login.isLoginPending" class="center-block size--lg"></loading-spinner>\n\n            <h3>{{\'Ready to start? Log in....\' | translate}}</h3>\n\n            <form name="loginForm" novalidate ng-submit="login.doLogin(loginForm)">\n                <div ng-if="login.loginServerErrors" class="alert alert-danger">\n                    <p id="login-error">\n                        {{login.loginServerErrors | translate}}\n                    </p>\n                </div>\n                <div class="form-group" ng-class="{ \'has-error has-feedback\': loginForm.username.$touched && loginForm.username.$invalid || loginForm.username.$invalid && loginForm.$submitted}">\n                    <label for="login__username">{{ \'Username\' | translate }}</label>\n                    <input type="text" tabindex="1" autofocus class="form-control" name="username" id="login__username" placeholder="Name" ng-model="login.loginData.username" autocapitalize="off" autocorrect="off" required>\n\n                    <div class="help-block">\n                        <p ng-if="!loginForm.username.$touched && !loginForm.$submitted || loginForm.username.$valid">\n                            {{\'The user name\' | translate }}\n                        </p>\n\n                        <ng-messages ng-if="loginForm.username.$invalid && loginForm.username.$touched || loginForm.$submitted" for="loginForm.username.$error">\n                            <div ng-message="required">\n                                {{ \'This field is required\' | translate}}\n                            </div>\n                        </ng-messages>\n                    </div>\n                </div>\n\n                <div class="form-group" ng-class="{ \'has-error has-feedback\': loginForm.password.$touched && loginForm.password.$invalid || loginForm.password.$invalid && loginForm.$submitted}">\n                    <label for="login__password">{{ \'Password\' | translate }}</label>\n                    <input type="password" tabindex="2" class="form-control" name="password" id="login__password" placeholder="Password" ng-model="login.loginData.password" autocapitalize="off" autocorrect="off" required>\n\n                    <div class="help-block">\n                        <p class="description" ng-if="!loginForm.password.$touched && !loginForm.$submitted || loginForm.password.$valid">\n                            {{\'Your password\' | translate }}\n                        </p>\n                        <ng-messages class="error" ng-if="loginForm.password.$invalid && loginForm.password.$touched || loginForm.$submitted" for="loginForm.password.$error">\n                            <div ng-message="required">\n                                {{ \'This field is required\' | translate}}\n                            </div>\n                        </ng-messages>\n                    </div>\n                </div>\n\n                <button id="login-button" tabindex="3" class="btn btn-block btn-primary">\n                    {{ \'Login\' | translate }}\n                </button>\n            </form>\n        </div>\n\n        <br>\n        <br>\n        <br>\n        <br>\n        <button style="display:none" ng-click="login.testError()">\n            RANDOM BUG JS\n        </button>\n        <div>\n            Donut {{app.appVersion}} , by\n            <a target="_blank" href="http://www.formunauts.at">Formunauts GmbH.</a>\n            &bull; <a href="https://status.formunauts.com/">Status</a> &bull;\n            <a href="/reset_password/request">Forgot Password?</a>\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/petitions/petitions.view.html",'<div class="petitions-view">\n\n  <div ng-style="petitions.configurableStyles.all" class="dynamic-form-wrapper">\n\n    <div id="petition">\n      <form id="petition-{{petitions.formId}}" class="dynamic-form" name="petitions.petitionForm">\n        <ui-view></ui-view>\n      </form>\n\n    </div>\n  </div>\n</div>\n'),n.put("app/pages/teams/team.view.html",'<div id="team">\n    <div class="loading-wrapper">\n        <spinner class="loadingspinner" name="teamDetailsSpinner" ng-cloak="" on-loaded="team.getDetails(filterpanel.getFilterRequestParams())">\n            <loading-spinner animate="true" class="size--xl spinner center"></loading-spinner>\n        </spinner>\n\n        <div class="row">\n            <div class="dynamic-dashboard success" ng-repeat="set in team.detail.sets">\n                <dashboard-comp set="set" currency-symbol="app.currencySymbol" lang="app.lang">\n                </dashboard-comp>\n            </div>\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/teams/teams.view.html",'<div id="teams">\n    <div class="loading-wrapper">\n        <spinner class="loadingspinner" name="teamsTotalsSpinner" ng-cloak="" on-loaded="teams.getTeamsStats(filterpanel.getFilterRequestParams())">\n            <loading-spinner animate="true" class="size--xl spinner center"></loading-spinner>\n        </spinner>\n\n        <div class="row">\n            <div class="dynamic-dashboard success" ng-repeat="set in teams.dashboardTotals.sets">\n                <dashboard-comp set="set" currency-symbol="app.currencySymbol" lang="app.lang">\n                </dashboard-comp>\n            </div>\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/recruitings/recruitings.view.html",'<div class="recruitings-view">\n\n  <div ng-style="recruitings.configurableStyles.all" class="dynamic-form-wrapper">\n\n    <div id="recruitings">\n      <form id="recruitingForm" class="dynamic-form" name="recruitings.recruitingForm">\n        <ui-view></ui-view>\n      </form>\n\n    </div>\n  </div>\n</div>\n'),n.put("app/pages/timecapture/timecapture.view.html",'<div id="timecapture">\n    <div class="col-sm-12">\n        <button ng-class="{\'disabled\':timecapture.isStarted}" class="btn btn-lg btn-primary" ng-click="timecapture.start()">\n            {{"Start" | translate}}\n        </button>\n        <button ng-class="{\'disabled\':!timecapture.isStarted||timecapture.isFinished}" class="btn btn-lg btn-warning" ng-show="!timecapture.isPaused" ng-click="timecapture.startBreak()">\n            {{"Start Pause" | translate}}\n        </button>\n        <button ng-class="{ \'disabled\':timecapture.isFinished}" class="btn btn-lg btn-success" ng-show="timecapture.isPaused" ng-click="timecapture.endBreak()">\n            {{"Stop Pause" | translate}}\n        </button>\n        <button ng-class="{\'disabled\':!timecapture.isStarted||timecapture.isFinished}" class="btn btn-lg btn-danger" ng-click="timecapture.end()">\n            {{"End" | translate}}\n        </button>\n        <button ng-show="timecapture.isFinished" ng-class="{\'disabled\':timecapture.editing!==false}" ng-click="timecapture.saveData()" class="btn btn-lg btn-success">\n            {{"Save" | translate}}\n        </button>\n        <button class="pull-right btn btn-lg btn-default" ui-sref="app.filter.home">\n            {{"Back to dashboard" | translate}}\n        </button>\n        <br><br>\n        <br><br>\n    </div>\n\n    <div class="col-sm-12">\n        <form name="timecapture.editingForm" novalidate>\n            <table class="table table-striped">\n                <thead>\n                    <tr>\n                        <td class="col-sm-3 time-type">\n                            {{\'Type\' | translate}}\n                        </td>\n                        <td class="col-sm-3">{{\'Start time\' | translate}}</td>\n                        <td class="col-sm-3">{{\'End time\' | translate}}</td>\n                        <td class="col-sm-3">{{\'Duration\' | translate}}</td>\n                        <td class="col-sm-3">{{\'Actions\' | translate}}</td>\n                    </tr>\n                </thead>\n\n                <tbody>\n                    <tr ng-class="{ \'warning\':entry.type==\'break\', \'success\':entry.type==\'work\'}" ng-repeat="entry in timecapture.timeData track by $index">\n                        <td class="time-type">\n                            <i class="fa" ng-class="{\'fa-coffee\': entry.type==\'break\', \'fa-bullhorn\': entry.type==\'work\'}"></i>\n                        </td>\n                        <td>\n                            <span ng-show="timecapture.editing !== $index">{{entry.start | date:\'HH:mm:ss\'}}</span>\n\n                            <div class="form-group" ng-class="{ \'has-error\': timecapture.editingForm[\'start_\'+$index].$invalid}">\n                                <input class="form-control" type="time" ng-if="timecapture.editingRow && timecapture.editing === $index" name="start_{{$index}}" ng-model="timecapture.editingRow.start" ng-change="timecapture.editStandardTimes($index)" step="1" min="{{timecapture.editStartMin}}" max="{{timecapture.editStartMax}}">\n                            </div>\n                        </td>\n                        <td>\n                            <span ng-show="entry.end && timecapture.editing !== $index">{{entry.end | date:\'HH:mm:ss\'}}</span>\n\n                            <div class="form-group" ng-class="{ \'has-error\': timecapture.editingForm[\'end_\'+$index].$invalid}">\n                                <input class="form-control" type="time" ng-if="timecapture.editingRow && timecapture.editing === $index" name="end_{{$index}}" ng-model="timecapture.editingRow.end" ng-change="timecapture.editStandardTimes($index)" step="1" min="{{timecapture.editEndMin}}" max="{{timecapture.editEndMax}}">\n                            </div>\n                        </td>\n                        <td>\n                            <span ng-show="timecapture.editingRow === false || timecapture.editing !== $index ">{{entry.duration | msToTime:true }}</span>\n                            <span ng-show="timecapture.editingRow !== false && timecapture.editing === $index">{{timecapture.editingRow.end -\n                                timecapture.editingRow.start | msToTime:true\n                                }}</span>\n                        </td>\n                        <td>\n                            <div ng-show="entry.done">\n                                <button ng-class="{\'disabled\': timecapture.editing !== false}" class="btn btn-sm btn-primary" ng-show="timecapture.editing !== $index" ng-click="timecapture.setEditingRow($index)">\n                                    <i class="fa fa-pencil"></i>\n                                </button>\n                                <div ng-show="timecapture.editing === $index">\n                                    <button class="btn btn-sm btn-primary" ng-class="{ \'disabled\':(timecapture.editingForm[\'start_\'+$index].$invalid || timecapture.editingForm[\'end_\'+$index].$invalid)}" ng-click="timecapture.saveEditedRow($index, timecapture.editingRow)">\n                                        <i class="fa fa-check"></i>\n                                    </button>\n                                    <button class="btn btn-sm btn-primary" ng-click="timecapture.editing = false">\n                                        <i class="fa fa-remove"></i>\n                                    </button>\n                                </div>\n                                <button ng-show="timecapture.editing !== $index" class="btn btn-sm btn-primary" ng-click="timecapture.deleteEntry($index)">\n                                    <i class="fa fa-trash"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n\n                    <tr ng-show="timecapture.isFinished">\n                        <td class="add-row" colspan="5">\n                            <p>{{"Add additional time entries" | translate}}</p>\n                        </td>\n                    </tr>\n                    <tr ng-show="timecapture.isFinished" ng-class="{ \'warning\':timecapture.newRow.type==\'break\', \'success\':timecapture.newRow.type==\'work\'}">\n                        <td class="time-type">\n                            <i class="fa" ng-class="{\'fa-coffee\': timecapture.newRow.type==\'break\', \'fa-bullhorn\': timecapture.newRow.type==\'work\'}"></i>\n                        </td>\n                        <td>\n                            <div class="form-group" ng-class="{ \'has-error\': timecapture.editingForm.start_new.$invalid}">\n                                <input class="form-control" type="time" name="start_new" ng-model="timecapture.newRow.start" step="1" min="{{timecapture.timeData[timecapture.timeData.length-1].end | date:\'HH:mm:ss\'}}" max="23:59:58">\n                            </div>\n                        </td>\n                        <td>\n                            <div class="form-group" ng-class="{ \'has-error\': timecapture.editingForm.end_new.$invalid}">\n                                <input class="form-control" type="time" name="end_new" ng-model="timecapture.newRow.end" step="1" min="{{timecapture.newRow.start | date:\'HH:mm:ss\'}}" max="23:59:59">\n                            </div>\n                        </td>\n                        <td>\n                            <span>{{timecapture.newRow.end-\n                                timecapture.newRow.start | msToTime:true}}</span>\n                        </td>\n                        <td>\n                            <button class="btn btn-sm btn-primary" ng-class="{ \'disabled\':(timecapture.editingForm.start_new.$invalid || timecapture.editingForm.end_new.$invalid)}" ng-click="timecapture.saveNewRow(timecapture.newRow)">\n                                <i class="fa fa-check"></i>\n                            </button>\n                            <button class="btn btn-sm btn-primary" ng-click="timecapture.resetTimeEntry(timecapture.newRow)">\n                                <i class="fa fa-remove"></i>\n                            </button>\n                            <button class="btn btn-sm" ng-class="{ \'btn-warning\':timecapture.newRow.type == \'work\', \'btn-success\':timecapture.newRow.type == \'break\'}" ng-click="timecapture.toggleNewRowType()">\n                                <i class="fa" ng-class="{\'fa-coffee\': timecapture.newRow.type!=\'break\', \'fa-bullhorn\': timecapture.newRow.type!=\'work\'}"></i>\n                            </button>\n                        </td>\n                    </tr>\n                </tbody>\n\n                <tfoot>\n                    <tr>\n                        <td colspan="2">\n                            <h3>\n                                {{"Work" | translate}}: {{timecapture.timeData |\n                                filter:{ type: \'work\'} | sumByKey:\'duration\' |\n                                msToTime:true }}\n                            </h3>\n                        </td>\n                        <td colspan="3">\n                            <h3>\n                                {{"Break" | translate}}: {{timecapture.timeData\n                                | filter:{ type: \'break\'} | sumByKey:\'duration\'\n                                | msToTime:true }}\n                            </h3>\n                        </td>\n                    </tr>\n                </tfoot>\n            </table>\n        </form>\n    </div>\n</div>\n'),n.put("app/commons/components/breadcrumbs/breadcrumbs.html",'<ul class="breadcrumb">\n    <li class="{\'active\':breadcrumb.link}" ng-repeat="breadcrumb in $ctrl.breadcrumbs">\n        <a ng-if="breadcrumb.link" ui-sref="{{breadcrumb.link}}">{{breadcrumb.title | translate}}</a>\n        <span ng-if="!breadcrumb.link" ng-href="{{breadcrumb.link}}">{{breadcrumb.title | translate}}</span>\n    </li>\n</ul>'),n.put("app/commons/components/dashboard/dashboard.tpl.html",'<div class="dashboard-set">\n\n    <dashboard-header-comp ng-if="$ctrl.set.header.title" title-text="$ctrl.set.header.title" icons="$ctrl.set.header.icons" dashboard-type="$ctrl.set.header.dashboard_type" dashboard-object-id="$ctrl.set.header.dashboard_object_id">\n    </dashboard-header-comp>\n\n    <dashboard-widget-comp ng-repeat="widget in $ctrl.set.widgets track by $index" class="{{widget.widgetClass}}" type="widget.type" title-text="widget.title" link="widget.link" lang="$ctrl.lang" currency="$ctrl.currencySymbol" icon-class="widget.iconClass" value="widget.value" filters="widget.filters" postfix="widget.postfix" suffix="widget.suffix">\n    </dashboard-widget-comp>\n\n</div>'),n.put("app/commons/components/disclaimer/disclaimer.tpl.html",'<div class="disclaimer-box">\n    <div class="media disclaimer-block">\n        <div class="media-body disclaimer-text" ng-bind-html="$ctrl.text">\n        </div>\n        <div ng-show="$ctrl.imageUrl" class="media-right media-top">\n            <div class="media-object">\n                <img class="disclaimer-stamp" ng-src="{{$ctrl.imageUrl}}">\n            </div>\n        </div>\n    </div>\n</div>\n'),n.put("app/commons/components/loading-spinner/loading-spinner.html",'<svg width="100%" height="100%" viewBox="0 0 1500 1505" version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">\n    <g class="rocket__thrusts">\n        <rect class="rocket__thrust" ng-class="{\'rocket__thrust--stopped\':!$ctrl.animate}" x="-486" y="808" width="0" height="148"/>\n        <rect class="rocket__thrust" ng-class="{\'rocket__thrust--stopped\':!$ctrl.animate}" x="-592" y="988" width="0" height="152"/>\n        <rect class="rocket__thrust" ng-class="{\'rocket__thrust--stopped\':!$ctrl.animate}" x="-370" y="1170" width="0" height="148"/>\n    </g>\n    <g style="fill-rule: nonzero">\n        <path d="M668.771,1487.96c-5.5,3.417 -11,6.709 -16.584,9.875c6.751,0.834 13.542,1.667 20.292,2.334c-1.333,-4.042 -2.583,-8.125 -3.708,-12.209Z"/>\n        <path d="M806.775,527.383l-3.421,-0.179c0.992,-2.025 2.025,-4.008 3.108,-5.987c0.046,2.071 0.134,4.095 0.313,6.166Z"/>\n        <path d="M982.888,697.683c-1.984,1.125 -3.967,2.117 -5.946,3.109l-0.179,-3.425c2.024,0.137 4.095,0.27 6.125,0.316Z"/>\n        <path d="M1301.83,331.337c-8.646,8.642 -18.592,15.217 -29.212,19.625c-33.134,13.867 -72.796,7.338 -99.804,-19.625c-26.967,-27.008 -33.492,-66.67 -19.63,-99.804c4.413,-10.625 10.984,-20.575 19.63,-29.216c15.441,-15.442 34.974,-24.175 55.095,-26.246c26.379,-2.746 53.709,6.033 73.921,26.246c20.213,20.212 28.95,47.491 26.204,73.875c-2.029,20.12 -10.762,39.704 -26.204,55.145Zm130.729,-280.816l-164.175,40.2c-29.754,7.292 -57.891,19.941 -83.054,37.271c-3.65,2.479 -7.208,5.091 -10.716,7.787l-0.046,0c-8.913,6.8 -17.421,14.229 -25.388,22.196l-40.292,42.046l-189.612,197.941l-67.167,-3.87l-15.304,-0.9c-12.383,-0.721 -24.446,3.871 -33.225,12.65l-114.75,114.745l114.525,6.617c0.992,-2.025 2.025,-4.008 3.108,-5.987c0.046,2.071 0.134,4.095 0.313,6.166l-3.421,-0.179c-2.162,4.413 -4.096,8.871 -5.762,13.463c-18.275,49.875 -14.042,101.241 25.3,140.587c39.345,39.3 90.712,43.575 140.587,25.254c4.546,-1.666 9.05,-3.558 13.463,-5.716l-0.179,-3.425c2.024,0.137 4.095,0.27 6.125,0.316c-1.984,1.125 -3.967,2.117 -5.946,3.109l6.616,114.521l114.75,-114.751c8.775,-8.774 13.371,-20.841 12.65,-33.22l-0.9,-15.35l-3.875,-67.254l197.896,-189.521l42.046,-40.246c8.013,-8.013 15.442,-16.521 22.242,-25.438l-0,-0.041c2.7,-3.467 5.312,-7.025 7.787,-10.671c17.288,-25.163 29.983,-53.3 37.229,-83.1l40.2,-164.179c3.105,-12.65 -8.329,-24.084 -21.025,-21.021Z"/>\n        <path d="M806.775,527.383l-3.421,-0.179c0.992,-2.025 2.025,-4.008 3.108,-5.987c0.046,2.071 0.134,4.095 0.313,6.166Z"/>\n        <path d="M982.888,697.683c-1.984,1.125 -3.967,2.117 -5.946,3.109l-0.179,-3.425c2.024,0.137 4.095,0.27 6.125,0.316Z"/>\n        <path d="M1280.31,1284.5c-55.625,55.667 -117.916,100.792 -184.25,135.25c-108.129,56.292 -227.125,84.417 -346.041,84.417c-25.875,-0 -51.792,-1.334 -77.542,-4c-1.333,-4.042 -2.583,-8.125 -3.708,-12.209c-5.5,3.417 -11,6.709 -16.584,9.875c-158.166,-20.708 -311.041,-91.833 -432.545,-213.333c-267.409,-267.458 -290.659,-686.667 -69.663,-980.5c21,-27.958 44.25,-54.792 69.663,-80.208c146.462,-146.459 338.42,-219.625 530.379,-219.625c133.5,-0 267.042,35.416 385.25,106.25l-65.875,65.875c-96.625,-53.625 -205.792,-82.125 -319.375,-82.125c-176.292,-0 -342.042,68.666 -466.708,193.333c-11.959,11.958 -23.417,24.292 -34.338,37.004c47.171,17.038 91.421,44.496 129.296,82.371c52.625,52.625 85.125,117.667 97.625,185.75c25.5,3.375 50.791,8.708 75.542,16.167l-310.755,310.708l89.417,89.375l343.921,-343.917c14.792,9.459 29.25,19.834 43.166,31.167l-422.416,422.417l89.375,89.416l420.375,-420.375c11.125,15.125 21.208,30.75 30.333,46.834l-255.833,255.833l89.417,89.375l216.833,-216.833c19.375,82.083 17.125,168.208 -6.713,249.375c55.755,-0 111.459,21.25 153.963,63.791c16.458,16.459 29.667,34.834 39.75,54.459c52.291,-29.334 100.875,-66 144.375,-109.584c124.667,-124.662 193.333,-290.416 193.333,-466.708c0,-113.583 -28.5,-222.792 -82.167,-319.417l65.834,-65.875c172.792,288.167 135.042,667.334 -113.334,915.667Z"/>\n    </g>\n</svg>\n'),n.put("app/commons/components/network-status-bar/network-status-bar.html",'<div class="network-status-bar {{$ctrl.networkStateClass}}">\n    {{$ctrl.networkStateName}}\n</div>\n'),n.put("app/commons/components/qr-code-renderer/qr-code-renderer.tpl.html",'<div class="qr-code">\n</div>\n'),n.put("app/commons/components/summary/summary.html",'<div class="form-summary container-fluid">\n  <div class="row"><hr></div>\n  <div class="person-details row">\n    <div class="col-sm-6">\n      <div class="row name" ng-show="$ctrl.summaryData.isCompany">\n        <div class="col-sm-6 label" ng-if="$ctrl.summaryData.pers_title">\n          {{$ctrl.summaryData.pers_title}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_company_name}}\n        </div>\n      </div>\n      <div class="row name" ng-show="$ctrl.summaryData.pers_title || $ctrl.summaryData.pers_academic_title || $ctrl.summaryData.pers_first_name || $ctrl.summaryData.pers_last_name">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.name">{{$ctrl.formWording.name}}:</div>\n        <div ng-if="!$ctrl.summaryData.isCompany" class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_title}}\n          {{$ctrl.summaryData.pers_academic_title}}\n          {{$ctrl.summaryData.pers_first_name}}\n          {{$ctrl.summaryData.pers_last_name}}\n        </div>\n\n        <div ng-if="$ctrl.summaryData.isCompany" class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_academic_title}}\n          {{$ctrl.summaryData.pers_first_name}}\n          {{$ctrl.summaryData.pers_last_name}}\n        </div>\n\n        <div ng-if="$ctrl.summaryData.pers_address_addition" class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_address_addition}}\n        </div>\n      </div>\n\n      <div class="row birth" ng-show="$ctrl.summaryData.pers_date_of_birth">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.date_of_birth">\n          {{$ctrl.formWording.date_of_birth}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_date_of_birth | date:\'dd.MM.yyyy\'}}\n        </div>\n      </div>\n\n      <div class="row contact" ng-show="$ctrl.summaryData.pers_contact_email">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.email">{{$ctrl.formWording.email}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_contact_email}}\n        </div>\n      </div>\n      <div class="row" ng-show="$ctrl.summaryData.pers_contact_mobile_number">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.mobile_number">\n          {{$ctrl.formWording.mobile_number}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_contact_mobile_number}}\n        </div>\n      </div>\n      <div class="row" ng-show="$ctrl.summaryData.pers_contact_phone_number">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.phone_number">\n          {{$ctrl.formWording.phone_number}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_contact_phone_number}}\n        </div>\n      </div>\n\n      <div class="row address" ng-show="$ctrl.summaryData.pers_street || $ctrl.summaryData.pers_house_number || $ctrl.summaryData.pers_zip_code || $ctrl.summaryData.pers_city">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.address">{{$ctrl.formWording.address}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_street}}\n          {{$ctrl.summaryData.pers_house_number}}<br>\n          {{$ctrl.summaryData.pers_zip_code}} {{$ctrl.summaryData.pers_city}}\n        </div>\n      </div>\n    </div>\n\n    <div class="col-sm-6">\n      <div class="row" ng-show="$ctrl.summaryData.show_amount_by_base && $ctrl.summaryData.pers_donate_direct_debit_amount">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.amount">{{$ctrl.formWording.amount}}:</div>\n        <div class="col-sm-6 summary-content">\n            <span class="amount">\n                {{$ctrl.summaryData.pers_donate_direct_debit_amount | number:2 | formatForCurrency:$ctrl.currencySymbol}}\n            </span>\n        </div>\n      </div>\n\n      <div class="row" ng-show="$ctrl.summaryData.show_amount_per_interval && $ctrl.summaryData.pers_donate_direct_debit_interval_amount">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.debit_amount">{{$ctrl.formWording.debit_amount}}:</div>\n        <div class="col-sm-6 summary-content">\n            <span class="amount">\n                {{$ctrl.summaryData.pers_donate_direct_debit_interval_amount | number:2 | formatForCurrency:$ctrl.currencySymbol}}\n            </span>\n            <span class="interval-text">\n                {{$ctrl.summaryData.pers_donate_direct_debit_interval_title}}\n            </span>\n        </div>\n      </div>\n\n      <div class="row" ng-show="$ctrl.summaryData.account_holder">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.account_holder">{{$ctrl.formWording.account_holder}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.account_holder}}\n        </div>\n      </div>\n      <div class="row" ng-show="$ctrl.summaryData.account_bic_or_bankcode">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.account_bic_or_bankcode">\n          {{$ctrl.formWording.account_bic_or_bankcode}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.account_bic_or_bankcode}}\n        </div>\n      </div>\n      <div class="row" ng-show="$ctrl.summaryData.account_iban_or_number">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.account_iban_or_number">\n          {{$ctrl.formWording.account_iban_or_number}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.account_iban_or_number}}\n        </div>\n      </div>\n      <div class="row" ng-show="$ctrl.summaryData.pers_donate_debit_contract_start_date">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.contract_start_date">{{$ctrl.formWording.contract_start_date}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.pers_donate_debit_contract_start_date |\n          date:"dd.MM.yyyy"}}\n        </div>\n      </div>\n\n      <div class="row" ng-show="$ctrl.summaryData.comments_comments">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.comments">{{$ctrl.formWording.comments}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{$ctrl.summaryData.comments_comments}}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  \x3c!-- contact conf --\x3e\n\n  <div class="row">\n\n    <div class="col-sm-12" ng-show="$ctrl.summaryData.pers_contact_email_conf">\n      <div class="row contact_allowed_1">\n        <div class="col-sm-12 label" ng-if="$ctrl.formWording.contact_email_conf">{{$ctrl.formWording.contact_email_conf}}:\n          <b>{{$ctrl.summaryData.pers_contact_email_conf}}</b></div>\n      </div>\n    </div>\n\n    <div class="col-sm-12" ng-show="$ctrl.summaryData.pers_contact_phone_conf">\n      <div class="row contact_allowed">\n        <div class="col-sm-12 label" ng-if="$ctrl.formWording.contact_phone_conf">{{$ctrl.formWording.contact_phone_conf}}:\n          <b>{{$ctrl.summaryData.pers_contact_phone_conf}}</b></div>\n      </div>\n    </div>\n\n    <div class="col-sm-12" ng-show="$ctrl.summaryData.show_contact_data_notice && $ctrl.summaryData.contact_data_conf">\n        <div class="row contact_allowed_1">\n            <div class="col-sm-12">{{$ctrl.formWording.contact_data_conf_summary}}</div>\n        </div>\n    </div>\n\n  </div>\n\n\t\x3c!-- additional answers summary --\x3e\n  <div class="row">\n    <hr ng-show="$ctrl.summaryData.form_group.length > 0">\n  </div>\n\n  <div class="row">\n    <div class="col-sm-12" ng-repeat="item in $ctrl.summaryData.form_group">\n      <div ng-switch="item.type">\n        <div ng-switch-when="radiosWithContent">\n          <p>{{item.label}} {{item.title}}</p>\n        </div>\n        <div ng-switch-when="select">\n          <p>{{item.label}} {{item.title}}</p>\n        </div>\n        <div ng-switch-when="text">\n          <p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n        </div>\n        <div ng-switch-when="checkboxesWithContent">\n          <p>\n            {{item.title}}\n            <ul class="summary-content">\n              <li ng-repeat="option in item.items track by $index">\n                {{option}}\n              </li>\n            </ul>\n          </p>\n        </div>\n        <div ng-switch-when="rangesWithContentSimple">\n          <p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n        </div>\n        <div ng-switch-when="date">\n          <p>{{item.title}} {{item.value | date:\'yyyy-MM-dd\'}}</p>\n        </div>\n        <div ng-switch-default>\n          <p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  \x3c!-- gift recipients information --\x3e\n  <div class="row">\n    <hr ng-show="$ctrl.summaryData.gift_recipients_map.length > 0">\n  </div>\n\n  <div class="row" ng-show="$ctrl.summaryData.gift_recipients_map">\n    <div class="person-details col-sm-6" ng-repeat="person in $ctrl.summaryData.gift_recipients_map track by $index">\n\n      <div class="row">\n        <div class="col-sm-12">\n          <h4>{{$ctrl.formWording.recipient}} {{$index+1}}</h4>\n        </div>\n      </div>\n      <div class="row title" ng-show="person.pers_title">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.title_gift_recipients">{{$ctrl.formWording.title_gift_recipients}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_title}}\n        </div>\n      </div>\n      <div class="row name" ng-show="person.pers_first_name || person.pers_last_name">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.name">{{$ctrl.formWording.name}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_first_name}}\n          {{person.pers_last_name}}\n        </div>\n      </div>\n\n      <div class="row birth" ng-show="person.pers_date_of_birth">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.date_of_birth">\n          {{$ctrl.formWording.date_of_birth}}:\n        </div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_date_of_birth | date:\'dd.MM.yyyy\'}}\n        </div>\n      </div>\n\n      <div class="row contact" ng-show="person.pers_contact_email">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.email">{{$ctrl.formWording.email}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_contact_email}}\n        </div>\n      </div>\n      <div class="row" ng-show="person.pers_contact_mobile_number">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.mobile_number">{{$ctrl.formWording.mobile_number}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_contact_mobile_number}}\n        </div>\n      </div>\n      <div class="row address" ng-show="person.pers_street || person.pers_house_number || person.pers_zip_code || person.pers_city">\n        <div class="col-sm-6 label" ng-if="$ctrl.formWording.address">{{$ctrl.formWording.address}}:</div>\n        <div class="col-sm-6 summary-content">\n          {{person.pers_street}}\n          {{person.pers_house_number}}<br>\n          {{person.pers_zip_code}} {{person.pers_city}}\n          <div ng-if="person.pers_address_addition">\n            {{person.pers_address_addition}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  \x3c!-- end gift recipients information --\x3e\n\n\t\x3c!-- additional QA answers --\x3e\n  <div class="row">\n  \t<hr ng-show="$ctrl.summaryData.form_qa_group.length > 0">\n  </div>\n\n\t<div class="row">\n\t\t<div class="col-sm-12" ng-repeat="item in $ctrl.summaryData.form_qa_group">\n\t\t\t<div ng-switch="item.type">\n\t\t\t\t<div ng-switch-when="radiosWithContent">\n\t\t\t\t\t<p>{{item.label}} {{item.title}}</p>\n\t\t\t\t</div>\n        <div ng-switch-when="select">\n          <p>{{item.label}} {{item.title}}</p>\n        </div>\n\t\t\t\t<div ng-switch-when="text">\n\t\t\t\t\t<p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div ng-switch-when="checkboxesWithContent">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t{{item.title}}\n\t\t\t\t\t\t<ul class="summary-content">\n\t\t\t\t\t\t\t<li ng-repeat="option in item.items track by $index">\n\t\t\t\t\t\t\t  {{option}}\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div ng-switch-when="rangesWithContentSimple">\n\t\t\t\t\t<p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div ng-switch-when="date">\n\t\t\t\t\t<p>{{item.title}} {{item.value | date:\'yyyy-MM-dd\'}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div ng-switch-default>\n\t\t\t\t\t<p>{{item.title}}<span ng-if="item.title">:</span> {{item.value}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n  <div class="row"><hr></div>\n</div>\n'),n.put("app/commons/components/signature-pad-input/signature-pad-input.html",'<div class="signature-pad-box" ng-class="{\'has-feedback has-error\':($ctrl.ngModel.$invalid && $ctrl.ngModel.$touched) || ($ctrl.ngModel.$invalid && $ctrl.form.$submitted) }">\n\n  <div class="signature-pad-body">\n    \x3c!-- dynamic canvas here --\x3e\n  </div>\n\n  <div class="signature-pad-footer">\n    <a class="btn btn-default clear" ng-click="$ctrl.clear()">\n      {{\'Clear signature\' | translate}}\n    </a>\n    <div class="description">\n      <span ng-if="($ctrl.ngModel.$untouched && $ctrl.ngModel.$valid) || ($ctrl.ngModel.$valid && $ctrl.ngModel.$submitted)">\n        {{\'Sign above\' | translate}}\n      </span>\n      <span ng-if="$ctrl.ngModel.$touched && $ctrl.ngModel.$valid">\n        {{\'Thank you!\' | translate}}\n      </span>\n\n      <div ng-messages="$ctrl.ngModel.$error" ng-if="($ctrl.ngModel.$invalid && $ctrl.ngModel.$touched) || ($ctrl.ngModel.$invalid && $ctrl.form.$submitted)">\n        <div ng-message-exp="[\'required\',\'tv4-302\']">\n          {{\'Signature required\' | translate}}\n        </div>\n        <div ng-message="signatureDataValid">\n          {{\'This is no valid signature. Please try again!\' | translate}}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>'),n.put("app/commons/components/toast/toast.html",'<div class="toast" ng-if="toast">\n    <div class="toast__container">\n        <h3 class="toast__title">\n            \x3c!--\n            <fa-icon *ngIf="this.icon" [icon]="this.icon" size="lg"></fa-icon>\n        --\x3e\n            {{ toast.title | translate }}\n        </h3>\n\n        <div class="toast__content">\n            <p>{{ toast.text | translate }}</p>\n\n            <div class="toast__buttons">\n                <button ng-if="toast.button" type="button" class="toast__button text-primary {{ toast.button.style }}" ng-click="$ctrl.onButtonClicked(toast.button)">\n                    {{ toast.button.label | translate }}\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if="toast.duration" class="toast__timeout"></div>\n</div>\n'),n.put("app/commons/components/user-settings/user-settings.html",'<div ng-if="$ctrl.state.user" class="user-settings">\n    <div class="user-settings-user" ng-click="$ctrl.state.collapsed = !$ctrl.state.collapsed">\n        <div class="status-infos">\n            <div class="user-code" class="ellipsis">\n                {{$ctrl.state.user.fundraiser_code}}\n            </div>\n            <div class="user-name" class="ellipsis">\n                {{$ctrl.state.user.first_name}} {{$ctrl.state.user.last_name}}\n            </div>\n            <div class="user-location" class="ellipsis" ng-if="$ctrl.hasLocationTracking && ($root.selectedLocation || $ctrl.state.location)">\n                {{$root.selectedLocation.name || $ctrl.state.location.name}}\n            </div>\n        </div>\n\n        <img class="avatar" title="avatar" alt="user avatar" ng-src="{{ $ctrl.state.user.image_upload || \'/app/assets/images/default-avatar.jpg\' }}">\n\n        <div class="dropdown-button">\n            <div class="icon fa fa-2x fa-arrow-circle-down"></div>\n        </div>\n    </div>\n\n    <ul class="user-settings-dropdown dropdown-menu" ng-class="{\'collapsed\':$ctrl.state.collapsed}">\n        <li class="dropdown-header">\n            <i class="fa fa-line-chart"></i>{{\'Dashboards\' | translate}}\n        </li>\n        <li ng-class="{\'active\':$ctrl.$state.includes(\'app.filter.home\')}">\n            <a ng-click="$ctrl.goTo(\'app.filter.home\')" ng-class="{disabled: !$ctrl.allOptionsEnabled()}">\n                {{\'My Dashboard\' | translate}}\n            </a>\n        </li>\n        <li ng-class="{\'active\':$ctrl.$state.includes(\'app.teams\')}" toggle-by-set auth-set="$ctrl.authSets.coach_or_teamleader_or_recruiter">\n            <a ng-click="$ctrl.goTo(\'app.filter.teams\')" ng-class="{disabled: !$ctrl.allOptionsEnabled()}">\n                {{\'Teams Dashboard\' | translate}}\n            </a>\n        </li>\n        <li ng-class="{\'active\':$ctrl.$state.includes(\'app.leaderboard\')}">\n            <a ng-click="$ctrl.goTo(\'app.leaderboard\')" ng-class="{disabled: !$ctrl.allOptionsEnabled()}">\n                {{\'Referrals Leaderboard\' | translate}}\n            </a>\n        </li>\n\n        <li ng-if="$ctrl.hasNextTrainingCenter" ng-class="{\'active\':$ctrl.$state.includes(\'app.trainingcenter\')}">\n            <a ng-click="$ctrl.routeToNextTrainingcenter()" ng-class="{disabled: !$ctrl.allOptionsEnabled()}">\n                {{\'Training center\' | translate}}\n            </a>\n        </li>\n\n        <li ng-if="$ctrl.hasLocationTracking" class="dropdown-header">\n            <i class="fa fa-map-marker"></i>{{\'Locations\' | translate}}\n        </li>\n        <li ng-if="$ctrl.hasLocationTracking" ng-class="{\'active\':$ctrl.$state.includes(\'app.locationselect\')}">\n            <a ng-click="$ctrl.routeToLocationSelect()">\n                {{\'Change location\' | translate}}\n            </a>\n        </li>\n\n        <li ng-if="$ctrl.hasLocationModule" ng-class="{\'active\':$ctrl.$state.includes(\'app.location-permit\')}">\n            <a ng-click="$ctrl.routeToLocationPermit()" ng-class="{disabled: !$ctrl.canNavigateToLocationPermit()}">\n                {{\'Location permit\' | translate}}\n            </a>\n        </li>\n\n        <li ng-if="$ctrl.hasGamification" class="dropdown-header">\n            <i class="fa fa-star"></i>{{\'Achievements\' | translate}}\n        </li>\n        <li ng-if="$ctrl.hasGamification" ng-class="{\'active\':$ctrl.$state.includes(\'app.achievements\')}">\n            <a ng-click="$ctrl.goTo(\'app.achievements\')" ng-class="{disabled: !$ctrl.gamificationEnabled()}">\n                {{\'My achievements\' | translate}}\n            </a>\n        </li>\n\n        <li class="dropdown-header">\n            <i class="fa fa-gear"></i>{{\'General\' | translate}}\n        </li>\n        <li toggle-by-prop="has_workshift" ng-class="{\'active\':$ctrl.$state.includes(\'app.timecapture\')}">\n            <a class="icon icon-left" ng-click="$ctrl.goTo(\'app.timecapture\')" ng-class="{disabled: !$ctrl.allOptionsEnabled()}">\n                {{\'Time tracking\' | translate }}\n            </a>\n        </li>\n        <li>\n            <a class="icon icon-left" href="/support/" target="_blank">{{\'Help\' | translate}}\n            </a>\n        </li>\n        <li>\n            <a class="icon icon-left" target="_self" href="/admin/">{{\'Admin\' | translate}}</a>\n        </li>\n\n        <li class="divider"></li>\n\n        <li class="btn-list-item">\n            <button class="btn btn-primary btn-sm" ng-click="$ctrl.doLogout()">\n                <i class="fa fa-sign-out"></i> {{\'Logout\' | translate}}\n            </button>\n            <button class="btn btn-primary btn-sm" ng-click="$ctrl.doRefresh()">\n                <i class="fa fa-refresh" ng-class="{\'fa-spin\':$ctrl.isRefreshing}"></i>\n                {{\'Refresh\' | translate}}\n            </button>\n        </li>\n        <li class="version-number">\n            <small>Version: {{$ctrl.version}}</small>\n        </li>\n    </ul>\n</div>\n'),n.put("app/commons/directives/form-settings-menu/form-settings-menu.tpl.html",'<div class="btn-group form-settings-menu" uib-dropdown>\n    <button id="single-button" type="button" class="btn btn-primary" ng-click="$ctrl.toggleIsOpen()">\n        <i class="fa fa-gear"></i> <span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu dropdown-menu-right" ng-class="{\'open\':$ctrl.isOpen}" role="menu" aria-labelledby="single-button">\n        <li role="menuitem">\n            <span class="font-size-button" ng-click="changeFontSize(\'font-small\')" font-size-toggle>{{ \'small font\' | translate }}<b class="small pull-right">A</b></span>\n        </li>\n        <li role="menuitem">\n            <span class="font-size-button" ng-click="changeFontSize(\'font-medium\')" font-size-toggle>{{ \'medium font\' | translate }}<b class="medium pull-right">A</b></span>\n        </li>\n        <li role="menuitem">\n            <span class="font-size-button" ng-click="changeFontSize(\'font-large\')" font-size-toggle>{{ \'large font\' | translate }}<b class="large pull-right">A</b></span>\n        </li>\n        <li class="divider"></li>\n        <li role="menuitem" ng-repeat="(lang, name) in $ctrl.languages">\n            <span ui-sref="{{$ctrl.state}}({cid:\'{{$ctrl.formId}}\', lang:\'{{lang}}\' })">\n                {{name}}\n                <i class="fa fa-language pull-right"></i>\n            </span>\n        </li>\n    </ul>\n</div>\n'),n.put("app/commons/directives/user-panel/user-panel.tpl.html",'<div ng-if="statusInfo.user" class="user-panel">\n    <div class="team-member" ng-click="statusInfo.collapsed = !statusInfo.collapsed">\n        <div class="user-avatar-wrapper">\n            <img class="avatar user-avatar" title="user avatar" alt="user avatar" ng-src="{{ statusInfo.user.image_upload || \'/app/assets/images/default-avatar.jpg\' }}">\n        </div>\n\n        <div class="status-infos">\n            <div id="code" class="ellipsis">\n                {{statusInfo.user.fundraiser_code}}\n            </div>\n            <div id="name" class="ellipsis">\n                {{statusInfo.user.first_name}} {{statusInfo.user.last_name}}\n            </div>\n            <a style="margin-top:10px" id="logout-button" class="logout btn btn-primary" ng-click="doLogout()">Logout</a>\n        </div>\n    </div>\n\n    <div class="team-members-dropdown" ng-class="{\'collapsed\':statusInfo.collapsed}" ng-if="statusInfo.team_members.length > 0">\n        <div class="team-member" ng-class="{\'main-user\':(statusInfo.mainUserId == member.id)}" ng-repeat="member in statusInfo.team_members" ng-click="setUserAsActive(member.id)">\n            <div class="user-avatar-wrapper">\n                <img class="avatar user-avatar" title="user avatar" alt="user avatar" ng-src="{{ member.image_upload || \'/app/assets/images/default-avatar.jpg\' }}">\n            </div>\n            <div class="status-infos">\n                <div id="code" class="ellipsis">{{member.fundraiser_code}}</div>\n                <div id="name" class="ellipsis">\n                    {{member.first_name}} {{member.last_name}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'),n.put("app/commons/form/custom-date-field/custom-date-field.html",'<div id="{{\'form-group-\'+form.key.slice(-1)[0]}}" class="form-group schema-form-custom-date-field {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }">\n\n    <label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.slice(-1)[0]}}">\n        {{form.title}}\n    </label>\n\n    <input style="visibility: hidden; height:0px" ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" ng-show="form.key" type="date" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$" custom-date-field-exploder-dir="1" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">\n\n    <div class="row">\n        <div class="col-xs-3">\n            <input id="{{form.key.slice(-1)[0]+\'_date_day\'}}" class="form-control custom-date_day" style="padding-right:12px" placeholder="DD" type="number" custom-date-field-component-dir="1" custom-date-field-component-name="day" custom-date-field-name="{{form.key.slice(-1)[0]}}" ng-model="form.date_day" name="{{form.key.slice(-1)[0]+\'_date_day\'}}">\n\n        </div>\n        <div class="col-xs-3">\n            <input id="{{form.key.slice(-1)[0]+\'_date_month\'}}" class="form-control custom-date_month" style="padding-right:12px" placeholder="MM" type="number" custom-date-field-component-dir="1" custom-date-field-component-name="month" custom-date-field-name="{{form.key.slice(-1)[0]}}" ng-model="form.date_month" name="{{form.key.slice(-1)[0]+\'_date_month\'}}">\n\n        </div>\n        <div class="col-xs-6">\n            <input id="{{form.key.slice(-1)[0]+\'_date_year\'}}" class="form-control custom-date_year" style="padding-right:12px" placeholder="YYYY" type="number" custom-date-field-component-dir="1" custom-date-field-component-name="year" custom-date-field-name="{{form.key.slice(-1)[0]}}" ng-model="form.date_year" name="{{form.key.slice(-1)[0]+\'_date_year\'}}">\n\n        </div>\n    </div>\n    <span ng-if="form.feedback !== false" class="form-control-feedback" ng-class="evalInScope(form.feedback) || {\'fa\': true, \'fa-check\': hasSuccess(), \'fa-remove\': hasError() }" aria-hidden="true">\n    </span>\n    <span ng-if="hasError() || hasSuccess()" id="{{form.key.slice(-1)[0] + \'Status\'}}" class="sr-only">\n    {{ hasSuccess() ? \'(success)\' : \'(error)\' }}\n    </span>\n    <div class="help-block" sf-message="form.description"></div>\n</div>\n'),n.put("app/commons/form/checkboxes-with-content/checkboxes-with-content.html",'<div sf-array="form" ng-model="$$value$$" class="form-group has-feedback schema-form-checkboxes-with-content {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true &&  hasError(), \'has-success\': form.disableSuccessState !== true &&  hasSuccess()}">\n\n  <label class="col-sm-12 control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.join(\'.\')}}">\n    {{form.title}}\n  </label>\n\n  <div class="checkbox-with-content" ng-class="form.htmlItemClass" ng-repeat="val in titleMapValues track by $index">\n    <div class="form-group">\n      \x3c!-- @TODO Try to refactor the next div away!--\x3e\n      <div class="checkbox">\n        <label for="{{form.key.join(\'.\')}}_{{$index}}">\n          <input type="checkbox" id="{{form.key.join(\'.\')}}_{{$index}}" ng-disabled="form.readonly" sf-changed="form" class="{{form.fieldHtmlClass}}" ng-model="titleMapValues[$index]" name="{{form.key.slice(-1)[0]}}">\n          <img ng-if="item.imageUrl" class="image" ng-src="{{form.titleMap[$index].imageUrl}}">\n          <div class="info">\n            <div class="control-label title" ng-bind-html="form.titleMap[$index].title"></div>\n            <div class="description" ng-bind-html="form.titleMap[$index].description"></div>\n          </div>\n        </label>\n      </div>\n      \n\n    </div>\n    <div class="help-block" sf-message="form.description"></div>\n  </div>\n</div>\n'),n.put("app/commons/form/disclaimer/disclaimer.html",'<div class="form-group schema-form-disclaimer {{form.htmlClass}}">\n    <div class="media disclaimer-block">\n        <div class="media-body disclaimer-text" ng-bind-html="form.text">\n        </div>\n        <div class="media-right media-top" ng-if="form.imageUrl">\n            <div class="media-object">\n                <img class="disclaimer-stamp" ng-src="{{form.imageUrl}}">\n            </div>\n        </div>\n    </div>\n</div>'),n.put("app/commons/form/google-address-search/google-address-search.html",'<div class="form-group form-group--{{form.key.join(\'.\')}} has-feedback {{form.htmlClass}} schema-form-google-search" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true &&  hasSuccess()}">\n  <label class="{{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.join(\'.\')}}">{{form.title}}</label>\n\n\n  <input type="text" ng-autocomplete-directive options="" details="form.details" detailcb="form.detailcb" form-id-to-copy-in="form.formIdToCopyIn" form-name-to-copy-in="form.formNameToCopyIn" copy-key-to-field="form.copyKeyToField" id="{{form.key.join(\'.\')}}" class="form-control {{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}">\n\n  <span class="help-block" sf-message="form.description"></span>\n</div>'),n.put("app/commons/form/radios-with-custom-delete/radios-with-custom-delete.html",'<div id="{{\'form-group-\'+form.key.join(\'.\')}}" class="form-group has-feedback schema-form-radios-with-custom-delete schema-form-radios-with-content {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true &&  hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form">\n\n  <label class="col-sm-12 control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.join(\'.\')}}">\n    {{form.title}}\n  </label>\n\n  <div class="radio-with-custom-delete radios-with-content" ng-class="form.htmlItemClass" ng-repeat="item in form.titleMap">\n    <div class="form-group">\n        <div class="radio">\n            <label for="{{form.key.join(\'.\')}}_{{item.value}}">\n\n                <input type="radio" id="{{form.key.join(\'.\')}}_{{item.value}}" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}">\n                <div class="info">\n                    <div class="control-label title" ng-bind-html="item.name"></div>\n                    <div class="description" ng-bind-html="item.description"></div>\n                </div>\n            </label>\n        </div>\n    </div>\n\n  </div>\n\n  <div class="col-sm-12 help-block" sf-message="form.description"></div>\n</div>\n'),n.put("app/commons/form/radios-with-content/radios-with-content.html",'<div id="{{\'form-group-\'+form.key.join(\'.\')}}" class="form-group has-feedback schema-form-radios-with-content {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true &&  hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form">\n\n  <label class="col-sm-12 control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.join(\'.\')}}">\n    {{form.title}}\n  </label>\n\n  <div class="radio-with-content" ng-class="form.htmlItemClass" ng-repeat="item in form.titleMap">\n    <div class="form-group">\n      \x3c!-- @TODO Try to refactor the next div away!--\x3e\n      <div class="radio">\n        <label for="{{form.key.join(\'.\')}}_{{item.value}}">\n\n          <input type="radio" id="{{form.key.join(\'.\')}}_{{item.value}}" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}">\n\n          <img ng-if="item.imageUrl" class="image" ng-src="{{item.imageUrl}}">\n          <div class="info">\n            <div class="control-label title" ng-bind-html="item.title"></div>\n            <div class="description" ng-bind-html="item.description"></div>\n          </div>\n        </label>\n      </div>\n    </div>\n\n  </div>\n\n  <div class="col-sm-12 help-block" sf-message="form.description"></div>\n</div>\n'),n.put("app/commons/form/radios-with-sentence/radios-with-sentence.html",'<div id="{{\'form-group-\'+form.key.join(\'.\')}}" class="form-group has-feedback {{form.htmlClass}} schema-form-radios-with-sentence" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true &&  hasSuccess()}">\n\n  <div class="group-title col-sm-9">\n    <p>{{form.title}}</p>\n  </div>\n\n  <div class="col-sm-3">\n    <div class="form-group">\n\n      <div>\n        <label class="radio-inline" ng-repeat="item in form.titleMap">\n          <input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-value="item.value" name="{{form.key.join(\'.\')}}">\n          <span ng-bind-html="item.name"></span>\n        </label>\n      </div>\n\n    </div>\n  </div>\n  <div class="help-block" sf-message="form.description"></div>\n</div>'),n.put("app/commons/form/schema-form-range-with-content-simple/schema-form-range-with-content-simple.html",' <div id="{{form.key.join(\'\')}}" class="form-group schema-form-ranges-with-content {{form.htmlClass}}">\n\n\t<div class="range col-sm-12">\n\t\t<div class="image-wrapper image-left-wrapper">\n\t\t\t<img class="image image-left" ng-src="{{form.imageUrl1}}" ng-if="form.imageUrl1" style="filter: grayscale({{100*($$value$$-form.minValue)/(form.maxValue-form.minValue)}}%)">\n\t\t</div>\n\t\t<div class="image-wrapper image-right-wrapper">\n\t\t\t<img class="image image-right" ng-src="{{form.imageUrl2}}" ng-if="form.imageUrl2" style="filter: grayscale({{100*(1-(($$value$$-form.minValue)/(form.maxValue-form.minValue)))}}%)">\n\t\t</div>\n\t\t<div class="range-content">\n\t\t\t<label for="{{form.key.join(\'\')}}">\n\t\t\t\t<h4 class="info">\n\t\t\t\t\t<span class="control-label title" ng-bind-html="form.title" ng-class="{\'sr-only\': !showTitle()}"></span>\n\t\t\t\t</h4>\n\t\t\t\t<div class="description" ng-bind-html="form.description"></div>\n\t\t\t</label>\n\t\t\t\x3c!-- ratio_percent - ratio * (L * 10 px + 12px) +/- 6px/2 --\x3e\n\t\t\t\x3c!--                          lenght 1em  padding circle diff--\x3e\n\t\t\t<div class="output-wrapper" style="padding-left: calc({{100*($$value$$-form.minValue)/(form.maxValue-form.minValue)}}% - {{($$value$$-form.minValue)/(form.maxValue-form.minValue) * ($$value$$.toString().length * 10 + 12)}}px + {{(1 - ($$value$$-form.minValue)/(form.maxValue-form.minValue)) * 3}}px - {{($$value$$-form.minValue)/(form.maxValue-form.minValue) * 3}}px)">\n\t\t\t\t<output for="{{form.key.join(\'\')}}">\n  \t\t\t\t<div class="range-tooltip" ng-hide="form.stepImages.length">{{$$value$$}}</div>\n  \t\t\t\t<div class="range-tooltip" ng-show="form.stepImages.length"><img ng-src="{{form.stepImages[$$value$$-form.minValue]}}"></div>\n  \t\t\t  </output>\n  \t\t\t</div>\n\t\t\t\x3c!-- .... --\x3e\n\t\t\t<input type="range" ng-input-range min="{{form.minValue}}" max="{{form.maxValue}}" class="{{form.htmlClass}}" sf-changed="form" ng-disabled="form.readonly" ng-model-options="form.ngModelOptions" ng-model="$$value$$" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.join(\'\')}}" id="{{form.key.join(\'\')}}">\n\t\t\t<div class="ticks">\n\t\t\t\t<div class="tick">{{form.sliderLabelLeft}}</div><div class="tick">{{form.sliderLabelCenter}}</div><div class="tick">{{form.sliderLabelRight}}</div>\n\t\t\t</div>\n\t   </div>\n</div>\n</div>'),n.put("app/commons/form/signature-pad/signature-pad.html",'<div class="{{form.htmlClass}} schema-form-signature-pad">\n  <label class="{{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}">{{form.title}}</label>\n\n  <signature-pad-input-comp class="{{form.fieldHtmlClass}}" pad-id="form.key.slice(-1)[0]" ng-show="form.key" ng-model-options="form.ngModelOptions" ng-model="$$value$$" ng-disabled="form.readonly" schema-validate="form" valid-signature-dir="{{form.validSignatureDir}}" name="{{form.key.slice(-1)[0]}}">\n  </signature-pad-input-comp>\n</div>\n'),n.put("app/commons/form/typeahead/typeahead.html",'<div id="{{\'form-group\'+form.key.slice(-1)[0]}}" class="form-group {{form.htmlClass}} schema-form-typeahead" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false}">\n  <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">\n    {{form.title}}\n  </label>\n  <select ui-select2 id="{{form.key.slice(-1)[0]}}" data-placeholder="form.placeholder" ng-model="$$value$$" ng-model-options="form.ngModelOptions" ng-disabled="form.readonly" sf-changed="form" class="form-control {{form.fieldHtmlClass}}" schema-validate="form" ng-options="item.value as item.name group by item.group for item in form.titleMap" name="{{form.key.slice(-1)[0]}}">\n  </select>\n\n  <div class="help-block" sf-message="form.description"></div>\n</div>\n\n'),n.put("app/commons/modals/browserSupportModal/browserSupportModal.view.html",'<div class="modal-wrapper">\n    <div class="modal-header">\n        <h3 class="modal-title">{{modal.title}}</h3>\n    </div>\n    <div class="modal-body">\n       <p>{{modal.text}}</p>\n    </div>\n    <div class="modal-footer">\n        <button ng-if="modal.cancelGiven" class="btn btn-warning" type="button" ng-click="modal.cancel()">Cancel</button>\n        <button class="btn btn-primary" type="button" ng-click="modal.ok()">OK</button>\n    </div>\n</div>\n'),n.put("app/commons/modals/generalModal/generalModal.view.html",'<div class="modal-wrapper">\n  <div class="modal-header">\n    <h3 class="modal-title">{{modal.title}}</h3>\n  </div>\n\n  <div ng-if="!modal.isTextAsHtml" class="modal-body">\n    <p>{{modal.text}}</p>\n  </div>\n  <div ng-if="modal.isTextAsHtml" ng-bind-html="modal.text" class="modal-body">\n  </div>\n  <div class="modal-footer">\n    <button ng-if="modal.cancelGiven" class="btn btn-warning" type="button" ng-click="modal.cancel()">Cancel</button>\n    <button class="btn btn-primary" type="button" ng-click="modal.ok()">OK</button>\n  </div>\n</div>\n'),n.put("app/commons/modals/incognitoModal/incognitoModal.view.html",'<div class="modal-wrapper">\n    <div class="modal-header">\n        <h3 class="modal-title">{{modal.title}}</h3>\n    </div>\n    <div class="modal-body">\n       <p>{{modal.text}}</p>\n    </div>\n</div>\n'),n.put("app/commons/modals/uploadSuccess/uploadSuccess.view.html",'<div class="modal-bg-img">\n  <img class="img-responsive" ng-src="{{uploadModal.image  || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n</div>\n<div class="modal-header">\n  <h3 class="modal-title">{{uploadModal.title}}</h3>\n</div>\n<div class="modal-body">\n  <p>{{uploadModal.text}}</p>\n  <p class="hint" ng-if="uploadModal.hint">{{uploadModal.hint}}</p>\n</div>\n<div class="modal-footer">\n  <button class="btn btn-primary btn-lg" type="button" ng-click="uploadModal.ok()">OK</button>\n</div>\n\n'),n.put("app/pages/achievements/achievements-modal/achievementsModal.view.html",'<div class="modal-wrapper achievements-modal">\n    <div class="modal-header">\n        <h3 class="modal-title">{{achievementModal.title}}</h3>\n    </div>\n    <div class="modal-body">\n\n        <achievement achievement="achievementModal.achievement"></achievement>\n\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-warning btn-lg pull-left" type="button" ng-click="achievementModal.ok()">{{"Thank you!" | translate}}</button>\n        <button class="btn btn-primary btn-lg pull-right" type="button" ui-sref="app.achievements" ng-click="achievementModal.ok()">{{"View" | translate}} <i class="fa fa-arrow-right"></i></button>\n    </div>\n</div>\n\n'),n.put("app/pages/achievements/achievements-view/achievements-view.html",'<div class="achievements-view">\n\n    <achievements-categories class="achievements-categories row" categories="$ctrl.categories"></achievements-categories>\n\n    <div class="achievements-view-content">\n\n        <achievement id="{{$index}}" class="achievement col-xs-6 col-sm-4 col-md-3" data-category="{{achievement.category}} {{(achievement.count>0)?\'unlocked\':\'locked\'}} {{(achievement.secret)?\'secret\':\'\'}}" postrender-action="$ctrl.initFilter()" ng-repeat="achievement in $ctrl.achievements track by $index" achievement="achievement">\n        </achievement>\n\n    </div>\n\n</div>'),n.put("app/pages/donations/form-step/donations.form.view.html",'<div class="form-step form-step--form">\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img ng-if="donationsFormStep.form_config.header_image" class="img-responsive" ng-src="{{donationsFormStep.form_config.header_image || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <div class="info-material-link" ng-if="donationsFormStep.presentation" ng-click="donationsFormStep.goToPresentation()">\n          \x3c!-- TODO: make conditional & get values from API --\x3e\n          <div class="info-material-link__content">\n            <span class="info-material-link__title">{{ donationsFormStep.presentation.title }}</span>\n            <span class="info-material-link__subtitle">{{ donationsFormStep.presentation.subtitle }}</span>\n            <a class="info-material-link__link-button">{{ \'open\' | translate }}</a>\n          </div>\n          <img class="info-material-link__image" ng-src="{{donationsFormStep.presentation.title_image}}">\n        </div>\n\n        <user-panel-directive class="user-panel" user-panel-sm></user-panel-directive>\n        <form-settings-menu class="form-settings-menu" form-id="donations.formId" state="donations.baseState+donationsFormStep.stepState" languages="donations.supported_languages">\n        </form-settings-menu>\n      </div>\n    </div>\n  </div>\n\n  <div class="form-section" sf-schema="donationsFormStep.form_config.schema" sf-form="donationsFormStep.form_config.form" sf-model="donations.donationModel" sf-options="donations.donationForm_options"></div>\n\n  <disclaimer class="disclaimer-section" ng-if="donationsFormStep.form_config.disclaimer_text" disclaimer-text="donationsFormStep.form_config.disclaimer_text" disclaimer-stamp-image="donations.stamp_image">\n  </disclaimer>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-if="!donationsFormStep.presentation" ng-click="donationsFormStep.goBack()">\n        {{"Back to dashboard" | translate}}\n      </a>\n      <a class="btn btn-default back-btn" ng-if="donationsFormStep.presentation" ng-click="donationsFormStep.goToStart()">\n        {{"Go to start" | translate}}\n      </a>\n      <a id="donations-form-step-next" class="btn btn-primary next-btn" ng-click="donationsFormStep.goToNext(donations.donationForm)">\n        {{"Next" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="donations.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n</div>\n'),n.put("app/pages/donations/gift-step/donations.gift.view.html",'<div class="form-step form-step--form">\n\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img ng-if="donationsGiftStep.form_config_gift_recipient.header_image" class="img-responsive" ng-src="{{donationsGiftStep.form_config_gift_recipient.header_image || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <user-panel-directive class="user-panel" user-panel-sm></user-panel-directive>\n        <form-settings-menu class="form-settings-menu" form-id="donations.formId" state="donations.baseState+donationsGiftStep.stepState" languages="donations.supported_languages">\n        </form-settings-menu>\n      </div>\n    </div>\n    <h2>{{donationsGiftStep.formWording.recipient}} {{donations.donationModel.recipientId + 1}}</h2>\n\n    <div class="button-section">\n      <div class="btn-group btn-group-lg btn-group-justified">\n        <a class="btn btn-default back-btn" ng-click="donationsGiftStep.copyAddress()">\n          {{"Copy address" | translate}}\n        </a>\n        <a class="btn btn-default back-btn" ng-click="donationsGiftStep.copyContact()">\n          {{"Copy contact data" | translate}}\n        </a>\n      </div>\n    </div>\n  </div>\n\n  <div class="form-section" sf-schema="donationsGiftStep.form_config_gift_recipient.schema" sf-form="donationsGiftStep.form_config_gift_recipient.form" sf-model="donations.donationModel.gift_recipients_map[donations.donationModel.recipientId]" sf-options="donations.donationForm_options">\n  </div>\n\n  <disclaimer class="disclaimer-section" ng-if="donationsGiftStep.form_config_gift_recipient.disclaimer_text" disclaimer-text="donationsGiftStep.form_config_gift_recipient.disclaimer_text" disclaimer-stamp-image="donations.stamp_image">\n  </disclaimer>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-click="donationsGiftStep.goBack()">\n        {{"Back" | translate}}\n      </a>\n      <a id="donations-form-step-next" class="btn btn-primary next-btn" ng-click="donationsGiftStep.goToNext(donations.donationForm)">\n        {{"Next" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="donations.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n\n</div>\n'),n.put("app/pages/donations/qa-step/donations.qa.view.html",'<div class="form-step form-step--qa">\n\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img class="img-responsive" ng-src="{{donationsQaStep.form_config.header_image  || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <user-panel-directive user-panel-sm></user-panel-directive>\n        <form-settings-menu form-id="donations.formId" state="donations.baseState+donationsQaStep.stepState" languages="donations.supported_languages"></form-settings-menu>\n      </div>\n    </div>\n  </div>\n\n  <div class="disclaimer-section" ng-if="donationsQaStep.form_config.disclaimer_text" class="col-sm-12" style="float:none" ng-bind-html="donationsQaStep.form_config.disclaimer_text">\n  </div>\n\n  <div class="form-section" ng-class="{\'was-submitted\': donationsQaStep.wasSubmitted}" sf-schema="donationsQaStep.form_config.schema" sf-form="donationsQaStep.form_config.form" sf-model="donations.donationModel">\n  </div>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-click="donationsQaStep.goBack()">\n        {{"Back" | translate}}\n      </a>\n      <a id="donations-qa-step-next" class="btn btn-primary next-btn" ng-click="donationsQaStep.goToNext(donations.donationForm)">\n        {{"Next" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="donations.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n</div>\n'),n.put("app/pages/donations/signature-step/donations.signature.view.html",'<div class="form-step form-step--signature">\n\n  <div class="hidden-print">\n\n    <div class="header-section">\n      <div class="header-inner-wrap">\n        <img class="img-responsive" id="formHeaderImg" ng-src="{{donationsSignatureStep.form_config.header_image  || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n        <div class="overlay-section">\n          <user-panel-directive user-panel-sm></user-panel-directive>\n\n          <form-settings-menu form-id="donations.formId" state="donations.baseState+donationsSignatureStep.stepState" languages="donations.supported_languages">\n          </form-settings-menu>\n        </div>\n      </div>\n    </div>\n\n    <summary currency-symbol="app.currencySymbol" raw-data="donations.donationModel" raw-donation="donationsSignatureStep.actualDonation" form-wording="donationsSignatureStep.formWording">\n    </summary>\n\n    <div class="form-section" sf-schema="donationsSignatureStep.form_config.schema" sf-form="donationsSignatureStep.form_config.form" sf-model="donations.donationModel">\n    </div>\n\n    <div class="col-sm-12 col-xs-12" ng-if="donationsSignatureStep.is_printable">\n      <div class="checkbox">\n        <label>\n          <input id="signature-print-checkbox" type="checkbox" ng-model="donationsSignatureStep.isPrinted">\n          {{donationsSignatureStep.formWording.confirmation_was_printed |\n          translate}} <i class="fa fa-print"></i>\n        </label>\n      </div>\n    </div>\n\n    <div class="button-section">\n      <div class="btn-group btn-group-lg btn-group-justified">\n        <a class="btn btn-default back-btn" ng-click="donationsSignatureStep.goBack()">\n          {{"Back" | translate}}\n        </a>\n        <a ng-if="donationsSignatureStep.is_printable && !donationsSignatureStep.isPrinted" ng-click="donationsSignatureStep.printSummary()" class="btn btn-primary btn-block print-btn">\n          <span>{{"Print" | translate}}</span>\n          <i class="fa fa-print"></i>\n        </a>\n        <a id="donations-signature-step-send" class="btn btn-primary btn-block next-btn" ng-if="!donationsSignatureStep.is_printable || donationsSignatureStep.isPrinted" ng-click="donationsSignatureStep.uploadFormdata(donations.donationForm)">\n          {{donationsSignatureStep.formWording.donate}}\n        </a>\n      </div>\n      <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="donations.resetForm()">\n        {{"Cancel" | translate}}\n      </a>\n    </div>\n\n  </div>\n\n  <print-summary raw-data="donations.donationModel" raw-donation="donationsSignatureStep.actualDonation" form-wording="donationsSignatureStep.formWording" currency-symbol="app.currencySymbol"></print-summary>\n\n</div>\n'),n.put("app/pages/leaderboard/leaderboard-list/leaderboard-list.html",'<table class="table leaderboard-table">\n  <thead>\n  <tr>\n    <th>{{\'Position\' | translate}}</th>\n    <th>{{\'Image\' | translate}}</th>\n    <th>{{\'Name\' | translate}}</th>\n    <th>{{\'Fundraiser Code\' | translate}}</th>\n    <th>{{\'Referrals\' | translate}}</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr ng-repeat="item in $ctrl.list" class="{{item.current_user?\'success\':\'\'}}">\n    <td>{{item.position}}</td>\n    <td><img class="avatar" ng-src="{{item.image}}"></td>\n    <td>{{item.name}}</td>\n    <td>{{item.fundraiser_code}}</td>\n    <td>{{item.score}}</td>\n  </tr>\n  </tbody>\n  <tbody ng-if="!$ctrl.isCurrentUserPresent && $ctrl.currentUser" class="current-user">\n  <tr class="success">\n    <td>{{$ctrl.currentUser.position}}</td>\n    <td><img class="avatar" ng-src="{{$ctrl.currentUser.image}}"></td>\n    <td>{{$ctrl.currentUser.name}}</td>\n    <td>{{$ctrl.currentUser.fundraiser_code}}</td>\n    <td>{{$ctrl.currentUser.score}}</td>\n  </tr>\n  </tbody>\n</table>\n'),n.put("app/pages/leaderboard/leaderboard-filters/leaderboard-filters.html",'<form class="navbar-form navbar-left leaderboard-filters" role="search">\n  <div class="col-sm-12 custom-filters">\n    <button class="btn btn-lg btn-default {{$ctrl.selectedFilter === $ctrl.filterOptions.overall?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.overall)">{{\'Overall\'\n      | translate}}\n    </button>\n    <div class="form-group">\n      <input type="date" class="form-control input-lg" name="from" ng-model="$ctrl.date_from" ng-change="$ctrl.tryChangeFilters($ctrl.filterOptions.none)" placeholder="dd/mm/yyyy">\n    </div>\n    <div class="form-group">\n      <input type="date" class="form-control input-lg" name="to" ng-model="$ctrl.date_to" ng-change="$ctrl.tryChangeFilters($ctrl.filterOptions.none)" placeholder="dd/mm/yyyy">\n    </div>\n    <button type="submit" class="btn btn-lg btn-warning {{$ctrl.selectedFilter !== $ctrl.filterOptions.none ?\'disabled\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.custom)">{{\'Filter\' |\n      translate}}\n    </button>\n  </div>\n  <div class="col-sm-12">\n    <div class="date-btn-group col-sm-9">\n      <button class="btn btn-lg btn-warning {{$ctrl.selectedFilter === $ctrl.filterOptions.day?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.day)">{{\'Day\' |\n        translate}}\n      </button>\n      <button class="btn btn-lg btn-warning {{$ctrl.selectedFilter === $ctrl.filterOptions.week?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.week)">{{\'Week\' |\n        translate}}\n      </button>\n      <button class="btn btn-lg btn-warning {{$ctrl.selectedFilter === $ctrl.filterOptions.month?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.month)">{{\'Month\' |\n        translate}}\n      </button>\n      <button class="btn btn-lg btn-warning {{$ctrl.selectedFilter === $ctrl.filterOptions.quarter?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.quarter)">\n        {{\'Quarter\' | translate}}\n      </button>\n      <button class="btn btn-lg btn-warning {{$ctrl.selectedFilter === $ctrl.filterOptions.year?\'active\':\'\'}}" ng-click="$ctrl.tryChangeFilters($ctrl.filterOptions.year)">{{\'Year\'\n        | translate}}\n      </button>\n    </div>\n    <div class="date-btn-group col-sm-3">\n      <h2>{{\'Total\' | translate}} {{$ctrl.totalCount}}</h2>\n    </div>\n  </div>\n</form>\n'),n.put("app/pages/leaderboard/leaderboard-pagination/leaderboard-pagination.html",'<nav aria-label="text-center" class="text-center leaderboard-pagination">\n  <div class="btn-group btn-group-lg">\n    <button aria-label="Previous" class="btn btn-warning previous {{$ctrl.firstPage === $ctrl.queryParams.page?\'disabled\':\'\'}}" ng-click="$ctrl.prevPage()">\n      <span aria-hidden="true">&laquo; {{\'Previous\' | translate}}</span>\n    </button>\n    <button class="btn btn-default disabled">\n      {{\'Page\' | translate}}: {{$ctrl.queryParams.page}}\n    </button>\n    <button aria-label="Next" class="btn btn-warning next {{$ctrl.lastPage === $ctrl.queryParams.page?\'disabled\':\'\'}}" ng-click="$ctrl.nextPage()">\n      <span aria-hidden="true">&raquo; {{\'Next\' | translate}}</span>\n    </button>\n  </div>\n</nav>\n'),n.put("app/pages/petitions/form-step/petitions.form.view.html",'<div class="form-step form-step--form">\n\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img ng-show="petitionsFormStep.form_config.header_image" class="img-responsive" id="formHeaderImg" ng-src="{{petitionsFormStep.form_config.header_image || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <user-panel-directive user-panel-sm></user-panel-directive>\n        <form-settings-menu form-id="petitions.formId" state="petitions.baseState+petitionsFormStep.stepState" languages="petitions.supported_languages">\n        </form-settings-menu>\n      </div>\n    </div>\n  </div>\n\n  <div class="form-section" sf-schema="petitionsFormStep.form_config.schema" sf-form="petitionsFormStep.form_config.form" sf-model="petitions.petitionModel" sf-options="petitions.petitionsForm_options">\n  </div>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-click="petitionsFormStep.goBack()">\n        {{"Back to dashboard" | translate}}\n      </a>\n      <a class="btn btn-primary next-btn" ng-click="petitionsFormStep.goToNext(petitions.petitionForm)">\n        {{"Next" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="petitions.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n</div>'),n.put("app/pages/petitions/signature-step/petitions.signature.view.html",'<div class="form-step form-step--signature">\n\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img class="img-responsive" id="formHeaderImg" ng-src="{{petitionsSignatureStep.form_config_signature.header_image  || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <user-panel-directive user-panel-sm></user-panel-directive>\n        <form-settings-menu form-id="petitions.formId" state="petitions.baseState+petitionsSignatureStep.stepState" languages="petitions.supported_languages">\n        </form-settings-menu>\n      </div>\n    </div>\n  </div>\n\n  <hr>\n\n  <summary currency-symbol="app.currencySymbol" raw-data="petitions.petitionModel" raw-donation="petitionsSignatureStep.actualPetition" form-wording="petitionsSignatureStep.formWording">\n  </summary>\n\n  <hr>\n\n  <div class="form-section" sf-schema="petitionsSignatureStep.form_config_signature.schema" sf-form="petitionsSignatureStep.form_config_signature.form" sf-model="petitions.petitionModel">\n  </div>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-click="petitionsSignatureStep.goBack()">\n        {{"Back" | translate}}\n      </a>\n      <a class="btn btn-primary btn-block next-btn" ng-click="petitionsSignatureStep.uploadFormdata(petitions.petitionForm)">\n        {{"Submit" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="petitions.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n</div>\n'),n.put("app/pages/recruitings/form-step/recruitings.form.view.html",'<div class="form-step form-step--form">\n\n  <div class="header-section">\n    <div class="header-inner-wrap">\n      <img ng-show="recruitingsFormStep.form_config.header_image" class="img-responsive" id="formHeaderImg" ng-src="{{recruitingsFormStep.form_config.header_image || \'assets/images/transparent_bg.png\' }}" alt="" title="">\n      <div class="overlay-section">\n        <user-panel-directive class="user-panel" user-panel-sm></user-panel-directive>\n        <form-settings-menu form-id="recruitings.formId" state="recruitings.baseState+recruitingsFormStep.stepState" languages="recruitings.supported_languages">\n        </form-settings-menu>\n      </div>\n    </div>\n  </div>\n\n  <div class="form-section" sf-schema="recruitingsFormStep.form_config.schema" sf-form="recruitingsFormStep.form_config.form" sf-model="recruitings.recruitingModel" sf-options="recruitings.recruitingForm_options">\n  </div>\n\n  <disclaimer ng-if="recruitingsFormStep.form_config.disclaimer_text" disclaimer-text="recruitingsFormStep.form_config.disclaimer_text" disclaimer-stamp-image="recruitings.stamp_image"></disclaimer>\n\n  <div class="button-section">\n    <div class="btn-group btn-group-lg btn-group-justified">\n      <a class="btn btn-default back-btn" ng-click="recruitingsFormStep.goBack()">\n        {{"Back to dashboard" | translate}}\n      </a>\n      <a class="btn btn-primary next-btn" ng-click="recruitingsFormStep.doUpload(recruitings.recruitingForm)">\n        {{"Submit" | translate}}\n      </a>\n    </div>\n    <a class="btn btn-danger btn-lg btn-block reset-btn" ng-click="recruitings.resetForm()">\n      {{"Cancel" | translate}}\n    </a>\n  </div>\n</div>\n'),n.put("app/commons/components/dashboard/dashboard-header/dashboard-header.tpl.html",'<div class="heading-bar-wrapper" ng-click="$ctrl.goToDashboard()">\n    <div class="image-section">\n        <img class="campaign-image" title="campaign image" alt="campaign image" ng-src="{{icon}}" ng-repeat="icon in $ctrl.icons track by $index">\n    </div>\n    <div class="heading-bar">\n        <div class="heading-bar-content" ng-bind-html="$ctrl.titleText"></div>\n    </div>\n</div>\n'),n.put("app/commons/components/dashboard/dashboard-widget/dashboard-widget.tpl.html",'<div class="dashboard-widget {{\'widget-type-\'+$ctrl.type}} {{$ctrl.widgetClass}}">\n    <div class="panel">\n        <div class="panel-heading">\n            <i class="icon {{$ctrl.iconClass}}"></i>\n\n            \x3c!-- display title as link or span depending on link binding--\x3e\n            <a ng-if="$ctrl.link" ng-href="{{$ctrl.link}}">\n                {{$ctrl.titleText}}\n            </a>\n            <span ng-if="!$ctrl.link">{{$ctrl.titleText}}</span>\n\n        </div>\n\n        <div class="panel-body">\n            <dashboard-widget-value-comp class="widget-value" type="$ctrl.type" value="$ctrl.value" filters="$ctrl.filters" currency="$ctrl.currency" prefix="$ctrl.prefix" suffix="$ctrl.suffix">\n            </dashboard-widget-value-comp>\n\n        </div>\n    </div>\n</div>\n'),n.put("app/pages/achievements/achievements-view/achievement/achievement.html",'<div class="achievement-inner {{\'category-\'+$ctrl.getCategory()}} {{$ctrl.getUnlockedClass()}} {{$ctrl.getPresentationModeClass()}}">\n\n    <div ng-if="$ctrl.countVisible()" class="count badge">{{$ctrl.achievement.count}}</div>\n\n    <h3 class="header">{{$ctrl.achievement.name}}</h3>\n\n    <div class="symbol-container">\n\n        <div ng-if="!$ctrl.achievement.image && $ctrl.isUnlocked()" class="symbol {{$ctrl.achievement.className}}"></div>\n\n        <img ng-if="$ctrl.achievement.image  && $ctrl.isUnlocked()" class="symbol" ng-src="{{$ctrl.achievement.image}}">\n\n        <div ng-if="!$ctrl.isUnlocked()" class="symbol fa fa-question"></div>\n\n    </div>\n\n    <p class="description">{{$ctrl.achievement.description}}</p>\n\n</div>'),n.put("app/pages/achievements/achievements-view/achievements-categories/achievements-categories.html",'<ul class="categories navbar navbar-nav">\n    <li class="filter btn btn-lg achievement-category category-all" data-target="all">{{\'All\' | translate}}</li>\n</ul>\n\n<ul class="categories navbar navbar-nav">\n    <li class="filter btn btn-lg achievement-category category-unlocked" data-target="unlocked">{{\'Unlocked\' | translate}}</li>\n    <li class="filter btn btn-lg achievement-category category-locked" data-target="locked">{{\'Locked\' | translate}}</li>\n</ul>\n\n<ul class="categories navbar navbar-nav">\n    <li class="filter btn btn-lg achievement-category category-{{name}}" data-target="{{id}}" ng-repeat="(id, name) in $ctrl.categories">{{name | translate}}\n    </li>\n</ul>\n\n'),n.put("app/commons/services/raisenow/views/raisenow.creditcard.modal.html",'<div id="raisenow-modal">\n  <div class="modal-header">\n    <h3 class="modal-title">{{"Payment" | translate}}</h3>\n  </div>\n\n  <div class="modal-body">\n\n    <p>\n      </p><div>\n        <div class="step step-initiating" ng-show="modal.paymentStatus === \'new\'">\n          {{"Enter credit card information to continue" | translate}}<br>\n        </div>\n\n        <div class="step step-initiating" ng-show="modal.paymentStatus === \'initiating\' ">\n          {{"Initiating credit card payment" | translate}}<br>\n\n          <br><center><i class="fa fa-spinner fa-spin fa-5x"></i></center> <br><br>\n\n          {{"Please be patient" | translate}}\n        </div>\n\n        <div class="step step-sms-sent" ng-show="modal.paymentStatus === \'initiated\' || modal.paymentStatus === \'confirming\' ">\n          {{"Payment request registered." | translate}} <br>\n        </div>\n\n        <div class="step step-payment-confirmed" ng-show="modal.paymentStatus === \'confirmed\'">\n          {{"Confirmed payment with credit card" | translate}} <br>\n\n          <b>{{"Thank you!" | translate}}</b>\n        </div>\n\n        <div class="step step-offline" ng-show="modal.paymentStatus === \'offline\'">\n          <b>{{"You are offline, please check your network settings and try again" | translate}}</b> <br>\n        </div>\n\n        <div class="step step-error" ng-show="modal.paymentStatus === \'error\'">\n          <b>{{"An error occurred" | translate}}</b> <br>\n\n          <small>\n            {{"The original error message was: " | translate}}<br>\n            {{modal.errorMessage}}\n          </small>\n        </div>\n      </div>\n    <p></p>\n\n    <iframe id="raisenow-creditcard-iframe" style="width:100%; height: 236px; border: none" ng-src="{{modal.iFrameUrl}}" ng-style="modal.iframeStyle"></iframe>\n\n    <p>\n        <svg height="20px" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" style="position: relative; top: 4px">\n            <path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"></path>\n        </svg>\n        <span style="display: inline; margin-right: 4px">Secure payment platform provided by</span>\n        <img height="20px" style="display: inline-block; height: 18px; position: relative; top: -4px" class="center-block" alt="RaiseNow" src="assets/images/raisenow-logo.svg">\n    </p>\n\n  </div>\n\n  <div class="modal-footer">\n    <button type="button" class="btn btn-warning" ng-click="modal.cancelPayment()" ng-if="modal.showCancelButton()">{{"Cancel" | translate }}</button>\n\n    <button type="button" class="btn btn-primary" ng-click="modal.startPaymentFlow()" ng-if="modal.showStartPaymentFlowButton()">{{"Start Payment" | translate }}</button>\n\n    \x3c!-- startPaymentFlow doesn\'t fully reinitiate the RaiseNow transaction --\x3e\n    \x3c!-- <button\n      type="button"\n      class="btn btn-primary"\n      ng-click="modal.startPaymentFlow()"\n      ng-if="modal.showRetryButton()"\n    >{{"Try again" | translate }}</button> --\x3e\n\n    <button type="button" class="btn btn-primary" ng-if="modal.showWaitButton()" disabled="disabled">\n      <i class="fa fa-spinner fa-spin"></i>\n      {{"Wait" | translate }}\n    </button>\n\n    <button type="button" class="btn btn-primary" ng-click="modal.finishPayment()" ng-if="modal.showDoneButton()">{{"Done" | translate }}</button>\n  </div>\n</div>\n'),n.put("app/commons/services/raisenow/views/raisenow.mpos.modal.html",'<div id="raisenow-modal">\n  <div class="modal-header">\n    <h3 class="modal-title">{{"mPOS Payment" | translate}}</h3>\n  </div>\n\n  <div class="modal-body">\n    \x3c!-- the invisible iframe, because RaiseNow doesn\'t have a normal REST API, but returns 302 redirects instead --\x3e\n    <iframe id="raisenow-payment-iframe" style="display: none" src="./iframe.view.html"></iframe>\n\n    <div>\n      <div class="step step-initiating" ng-show="modal.paymentStatus === \'new\' || modal.paymentStatus === \'initiating\' ">\n        {{"Initiating mPOS payment" | translate}}<br>\n\n        <br>\n        <center><i class="fa fa-spinner fa-spin fa-5x"></i></center>\n        <br><br>\n\n        {{"Please be patient" | translate}}\n      </div>\n\n      <div class="step step-sms-sent" ng-show="modal.paymentStatus === \'initiated\' || modal.paymentStatus === \'confirming\' ">\n        {{"Payment request registered. Redirecting to the mPOS app…" |\n        translate}} <br>\n\n        <br>\n        <center><i class="fa fa-spinner fa-spin fa-5x"></i></center>\n        <br><br>\n\n        {{"Please confirm your payment" | translate}}\n      </div>\n\n      <div class="step step-payment-confirmed" ng-show="modal.paymentStatus === \'confirmed\'">\n        {{"Confirmed payment with mPOS" | translate}} <br>\n\n        <b>{{"Thank you!" | translate}}</b>\n      </div>\n\n      <div class="step step-offline" ng-show="modal.paymentStatus === \'offline\'">\n        <b>{{"You are offline, please check your network settings and try again"\n          | translate}}</b>\n        <br>\n      </div>\n\n      <div class="step step-error" ng-show="modal.paymentStatus === \'error\'">\n        <b>{{"An error occurred" | translate}}</b> <br>\n\n        <small>\n          {{"The original error message was: " | translate}}<br>\n          {{modal.errorMessage}}\n        </small>\n      </div>\n    </div>\n  </div>\n\n  <div class="modal-footer">\n    <button type="button" class="btn btn-warning" ng-click="modal.cancelPayment()" ng-if="modal.showCancelButton()">\n      {{"Cancel" | translate }}\n    </button>\n\n    <button class="btn btn-primary" type="button" ng-click="modal.initiatePayment()" ng-if="modal.showRetryButton()">\n      {{"Try again" | translate }}\n    </button>\n\n    <button type="button" class="btn btn-primary" ng-if="modal.showWaitButton()" disabled="disabled">\n      <i class="fa fa-spinner fa-spin"></i>\n      {{"Wait" | translate }}\n    </button>\n\n    \x3c!-- <a ng-href="modal.eppTransactionId" ng-if="modal.showRedirectToMposButton()">\n        <button\n          type="button"\n          class="btn btn-primary"\n        >{{"Redirect to mPOS" | translate }}</button>\n    </a> --\x3e\n\n    <button type="button" class="btn btn-primary" ng-click="modal.finishPayment()" ng-if="modal.showDoneButton()">\n      {{"Done" | translate }}\n    </button>\n  </div>\n</div>\n'),n.put("app/commons/services/raisenow/views/raisenow.sms.modal.html",'<div id="raisenow-modal">\n    \x3c!-- do not modify this first line without updating the commons.http.requestInterceptor.js ! --\x3e\n    <div class="modal-header">\n      <h3 class="modal-title" ng-show="modal.paymentStatus == \'new\'">\n        {{"Start SMS payment" | translate}}\n      </h3>\n      <h3 class="modal-title" ng-show="modal.paymentStatus === \'initiating\' || modal.paymentStatus === \'initiated\' || modal.paymentStatus === \'confirming\'">\n        {{"Confirm SMS payment" | translate}}\n      </h3>\n      <h3 class="modal-title" ng-show="modal.paymentStatus === \'offline\'">\n        {{"You are offline" | translate}}\n      </h3>\n      <h3 class="modal-title" ng-show="modal.paymentStatus === \'error\'">\n        {{"SMS payment failed" | translate}}\n      </h3>\n    </div>\n\n    <div class="modal-body">\n      <iframe id="raisenow-payment-iframe" style="display: none" src="./iframe.view.html"></iframe>\n        \n      <div class="raisenow-cymba-modal">\n        <div>\n          <div class="step step-confirm-sms" ng-show="modal.paymentStatus === \'new\'">\n            <p>{{"Press \'Send SMS\' to start the payment" | translate }}</p>\n            <p>{{"Have you entered a mobile number on the form?" | translate }}</p>\n          </div>\n\n          <div class="step step-sms-sent" ng-show="modal.paymentStatus === \'initiating\' || modal.paymentStatus === \'initiated\' || modal.paymentStatus === \'confirming\'">\n            <p>{{"A SMS was sent to the following phone number:" | translate}}</p>\n            <p><strong>{{modal.currentPayment.getPaymentObject().msisdn}}</strong></p>\n            <p>{{"Please follow the instructions in this SMS." | translate}}</p>\n            <p>{{"If the SMS was not sent within the next 10 minutes, please try again or choose another payment method." | translate}}</p>\n          </div>\n\n          <div class="step step-offline" ng-show="modal.paymentStatus === \'offline\'">\n            <p>{{"Please send a SMS with the keyword & donation amount:" | translate}}</p>\n            <p>{{modal.currentPayment.getPaymentObject().stored_sms_keyword}} {{modal.currentPayment.getPaymentObject().amount / 100}}</p>\n            <p>{{"to the following number: " | translate}}</p>\n            <p>{{modal.currentPayment.getPaymentObject().stored_sms_shortcode}}</p>\n          </div>\n\n          <div class="step step-error" ng-show="modal.paymentStatus === \'error\'">\n            <p>{"The payment was not confirmed." | translate}</p>\n            <p>{"Please try again or choose another payment method." | translate}</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="modal-footer">\n      <button class="btn btn-warning" type="button" ng-click="modal.cancelPayment()" ng-show="modal.showCancelButton()">{{"Cancel" | translate }}</button>\n      <button class="btn btn-primary" type="button" ng-click="modal.initiatePayment()" ng-show="modal.showInitButton()">{{"Send SMS" | translate }}</button>\n      <button class="btn btn-primary" type="button" ng-click="modal.finishPayment()" ng-show="modal.showDoneButton()">{{"Done" | translate }}</button>\n      <button class="btn btn-primary" type="button" ng-click="modal.paymentDoneOfflineConfirm()" ng-show="modal.showOfflineDonationButton()">{{"Donated from clients phone" | translate }}</button>\n      </div>\n    </div>\n\n'),n.put("app/pages/donations/signature-step/print-summary/_additional_answers_group.html",'<div ng-switch="item.type">\n    <div ng-switch-when="radiosWithContent|select" ng-switch-when-separator="|">\n        <p>{{item.label}}: {{item.title}}</p>\n    </div>\n    <div ng-switch-when="text">\n        <p>{{item.title}}: {{item.value}}</p>\n    </div>\n    <div ng-switch-when="checkboxesWithContent">\n        <p>\n            {{item.title}}\n            <ul class="summary-content">\n                <li ng-repeat="option in item.items track by $index">\n                  {{option}}\n                </li>\n            </ul>\n        </p>\n    </div>\n    <div ng-switch-when="rangesWithContentSimple">\n        <p>{{item.title}}: {{item.value}}</p>\n    </div>\n    <div ng-switch-when="date">\n        <p>{{item.title}}: {{item.value | date:\'yyyy-MM-dd\'}}</p>\n    </div>\n    <div ng-switch-default>\n        <p>{{item.title}}: {{item.value}}</p>\n    </div>\n</div>\n'),n.put("app/pages/donations/signature-step/print-summary/print-summary.html",'<div class="visible-print print-summary">\n\n    \x3c!-- Fundraiser Infos --\x3e\n    <div class="summary-section">\n        <img class="image-responsive" ng-src="{{$ctrl.summaryData.organization_logo}}" alt="customer logo">\n        <h2>{{$ctrl.formWording.print_summary_headline | translate}}</h2>\n        <h3 class="subheadline">{{$ctrl.formWording.print_summary_subheadline | translate}}</h3>\n        <p>{{$ctrl.formWording.fundraiser}}: {{$ctrl.summaryData.fundraiser_first_name}} {{$ctrl.summaryData.fundraiser_last_name}}/{{$ctrl.summaryData.fundraiser_code}}</p>\n        <p>{{$ctrl.formWording.location}}: {{$ctrl.summaryData.fundraiser_location}}</p>\n    </div>\n\n    \x3c!-- Personal data --\x3e\n    <div class="summary-section">\n        <h3>\n            <span>\n                {{$ctrl.summaryData.sponsorship_title}}\n            </span>\n        </h3>\n        <p><b>{{$ctrl.formWording.personal_data | translate}}</b></p>\n        <p>\n            </p><div ng-if="$ctrl.summaryData.pers_title == 3">\n                {{$ctrl.summaryData.company_name}}<br>\n                {{$ctrl.summaryData.pers_academic_title}}\n                {{$ctrl.summaryData.pers_first_name}}\n                {{$ctrl.summaryData.pers_last_name}}\n            </div>\n            <div ng-if="$ctrl.summaryData.pers_title != 3">\n                    {{$ctrl.summaryData.titleName}}\n                    {{$ctrl.summaryData.pers_academic_title}}\n                    {{$ctrl.summaryData.pers_first_name}}\n                    {{$ctrl.summaryData.pers_last_name}}\n            </div>\n            <div>\n                {{$ctrl.summaryData.pers_street}}\n                {{$ctrl.summaryData.pers_house_number}}\n                <span ng-if="$ctrl.summaryData.pers_address_addition">{{$ctrl.summaryData.pers_address_addition}}<br></span>\n                {{$ctrl.summaryData.pers_zip_code}}\n                {{$ctrl.summaryData.pers_city}}\n                {{$ctrl.summaryData.pers_country_name}}\n            </div>\n            <br>\n            <div ng-if="$ctrl.summaryData.pers_contact_email">\n                <span>{{$ctrl.formWording.email | translate }}:</span>\n                {{$ctrl.summaryData.pers_contact_email}}\n            </div>\n            <div ng-if="$ctrl.summaryData.pers_contact_mobile_number">\n                <span>{{$ctrl.formWording.mobile_number | translate }}:</span>\n                {{$ctrl.summaryData.pers_contact_mobile_number}}\n            </div>\n            <div ng-if="$ctrl.summaryData.pers_contact_phone_number">\n                <span>{{$ctrl.formWording.phone_number | translate }}:</span>\n                {{$ctrl.summaryData.pers_contact_phone_number}}\n            </div>\n                \n            \n        <p></p>\n        <p>\n            </p><div>{{$ctrl.formWording.date_of_birth}}: {{$ctrl.summaryData.pers_date_of_birth | date:"dd.MM.yyyy"}}</div>\n            <div>\n                {{$ctrl.formWording.correspondence_language}}: {{$ctrl.summaryData.pers_contact_correspondence_language_title}}\n            </div>\n        <p></p>\n    </div>\n\n    \x3c!-- Donation Data --\x3e\n    <div class="summary-section">\n        <p>\n            {{$ctrl.formWording.contract_start_date}}: {{$ctrl.summaryData.pers_donate_debit_contract_start_date | date:"dd.MM.yyyy"}}<br>\n            {{$ctrl.formWording.debit_amount}}: {{$ctrl.summaryData.pers_donate_direct_debit_interval_amount | number:2 | formatForCurrency:$ctrl.currencySymbol}}<br>\n            {{\'Interval\' | translate}}: {{$ctrl.summaryData.pers_donate_direct_debit_interval_title}}\n        </p>\n    </div>\n\n    \x3c!-- Account data --\x3e\n    <div class="summary-section">\n        <p>\n            </p><div ng-show="$ctrl.summaryData.account_holder">\n                {{$ctrl.formWording.account_holder}}: {{$ctrl.summaryData.account_holder}}\n            </div>\n            <div ng-show="$ctrl.summaryData.account_bank_name">\n                {{$ctrl.formWording.account_bank_name}}: {{$ctrl.summaryData.account_bank_name}}\n            </div>\n            <div ng-show="$ctrl.summaryData.account_bic_or_bankcode">\n                {{$ctrl.formWording.account_bic_or_bankcode}}: {{$ctrl.summaryData.account_bic_or_bankcode}}\n            </div>\n            <div ng-show="$ctrl.summaryData.account_iban_or_number">\n                {{$ctrl.formWording.account_iban_or_number}}: {{$ctrl.summaryData.account_iban_or_number}}\n            </div>\n        <p></p>\n    </div>\n\n    \x3c!-- Payment notice --\x3e\n    <div class="summary-section" ng-if="$ctrl.summaryData.print_summary_disclaimer && $ctrl.summaryData.print_summary_disclaimer.text">\n        <p ng-bind-html="$ctrl.summaryData.print_summary_disclaimer.text"></p>\n    </div>\n\n    \x3c!-- Comments --\x3e\n    <div class="summary-section">\n        <p>\n            {{$ctrl.formWording.comments}}: {{$ctrl.summaryData.comments_comments}}\n        </p>\n    </div>\n\n    \x3c!-- additional answers summary --\x3e\n\n\t<div class="summary-section" ng-if="$ctrl.summaryData.form_group.length > 0">\n\t\t<div ng-repeat="item in $ctrl.summaryData.form_group">\n\t\t\t<ng-include src="\'app/pages/donations/signature-step/print-summary/_additional_answers_group.html\'"></ng-include>\n\t\t</div>\n\t</div>\n\n    \x3c!-- gift recipients information --\x3e\n    <div ng-if="$ctrl.summaryData.gift_recipients_map">\n        <hr>\n        <div class="person-details" ng-repeat="person in $ctrl.summaryData.gift_recipients_map track by $index">\n            <p>\n                </p><h4>{{$ctrl.formWording.recipient}} {{$index+1}}</h4>\n                <div class="title" ng-show="person.pers_title">\n                    <div class="summary-content">\n                        {{person.pers_title}}\n                    </div>\n                </div>\n                <div class="name" ng-show="person.pers_first_name || person.pers_last_name">\n                    <div class="summary-content">\n                        {{person.pers_first_name}} {{person.pers_last_name}}\n                    </div>\n                </div>\n\n                <div class="birth" ng-show="person.pers_date_of_birth">\n                    <div class="summary-content">\n                        {{person.pers_date_of_birth | date:\'dd.MM.yyyy\'}}\n                    </div>\n                </div>\n\n                <div class="contact" ng-show="person.pers_contact_email">\n                  <div class="summary-content">\n                    {{person.pers_contact_email}}\n                  </div>\n                </div>\n                <div ng-show="person.pers_contact_mobile_number">\n                  <div class="summary-content">\n                    {{person.pers_contact_mobile_number}}\n                  </div>\n                </div>\n                <div class="address" ng-show="person.pers_street || person.pers_house_number || person.pers_zip_code || person.pers_city">\n                  <div class="summary-content">\n                    {{person.pers_street}}\n                    {{person.pers_house_number}}<br>\n                    {{person.pers_zip_code}} {{person.pers_city}}\n\n                    <div ng-if="person.pers_address_addition" class="col-sm-6 summary-content">\n                      {{person.pers_address_addition}}\n                    </div>\n                  </div>\n                </div>\n            <p></p>\n        </div>\n        <hr>\n    </div>\n    \x3c!-- end gift recipients information --\x3e\n\n    \x3c!-- additional QA answers --\x3e\n    <div class="summary-section" ng-if="$ctrl.summaryData.form_qa_group.length > 0">\n\t\t<div ng-repeat="item in $ctrl.summaryData.form_qa_group">\n\t\t\t<ng-include src="\'app/pages/donations/signature-step/print-summary/_additional_answers_group.html\'"></ng-include>\n\t\t</div>\n\t</div>\n\n    \x3c!-- additional signature answers summary --\x3e\n\n\t<div class="summary-section" ng-if="$ctrl.summaryData.form_signature_group.length > 0">\n\t\t<div ng-repeat="item in $ctrl.summaryData.form_signature_group">\n\t\t\t<ng-include src="\'app/pages/donations/signature-step/print-summary/_additional_answers_group.html\'"></ng-include>\n\t\t</div>\n\t</div>\n\n    \x3c!-- Signature Section --\x3e\n    <div class="print-signature-section">\n        <p>\n            <b>{{ \'Place\' | translate}}:</b>\n        </p>\n        <p><b>{{ \'Date\' | translate}}:</b> {{$ctrl.summaryData.sign_date | date:"dd.MM.yyyy"}}</p>\n        <p ng-if="$ctrl.formWording.signature"><b>{{$ctrl.formWording.signature}}<span ng-if="$ctrl.summaryData.print_summary_signature_text.text"></span>:</b></p>\n        <div ng-if="$ctrl.summaryData.print_summary_signature_text && $ctrl.summaryData.print_summary_signature_text.text">\n            <hr>\n        </div>\n        <p ng-if="$ctrl.summaryData.print_summary_signature_text.text">\n            <span ng-bind-html="$ctrl.summaryData.print_summary_signature_text.text"></span>\n        </p>\n        <div ng-if="$ctrl.formWording.print_summary_footer">\n            <p>{{$ctrl.formWording.print_summary_footer | translate}}</p>\n        </div>\n    </div>\n</div>\n'),n.put("app/commons/components/dashboard/dashboard-widget/dashboard-widget-value/dashboard-widget-value.tpl.html",'<div class="{{\'value-type-\'+$ctrl.type}}">\n    \x3c!-- Metric Values --\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.metric">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        {{$ctrl.value}}\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n\n    \x3c!-- Duration Values --\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.duration">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        {{$ctrl.value}}\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n\n    \x3c!-- Money Values--\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.money">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        {{$ctrl.value}}\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n\n    \x3c!-- Text-List Values --\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.text_list">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        <div class="empty-value" ng-if="!$ctrl.value.length">\n            -\n        </div>\n        <div ng-repeat="value in $ctrl.value track by $index" class="value-col">\n            {{value}}\n        </div>\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n\n    \x3c!-- Key-Value-List Values --\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.key_value_list">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        <div class="empty-value" ng-if="!$ctrl.value.length">\n            -\n        </div>\n        <div class="value-col" ng-repeat="val in $ctrl.value track by $index">\n            <div class="label">{{val.key}}</div>\n            <div class="value">{{val.value}}</div>\n        </div>\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n\n    \x3c!-- Star-Rating Values --\x3e\n    <div class="value-wrapper" ng-if="$ctrl.type === $ctrl.types.star_rating">\n        <div class="widget-prefix" ng-if="$ctrl.prefix">{{$ctrl.prefix}}</div>\n        <div class="empty-value" ng-if="!$ctrl.value.average_rating">\n            -\n        </div>\n        <star-rating-comp ng-if="$ctrl.value.average_rating" num-of-stars="$ctrl.value.maximum_rating" rating="$ctrl.value.average_rating" show-half-stars="true" get-half-star-visible="$ctrl.calcHalfStarVisible" color="\'default\'" size="\'large\'" label-text="$ctrl.value.text" label-position="\'bottom\'" read-only="true">\n        </star-rating-comp>\n        <div class="widget-suffix" ng-if="$ctrl.suffix">{{$ctrl.suffix}}</div>\n    </div>\n</div>\n')}]);